import { jsxs as S, jsx as p, Fragment as $t } from "react/jsx-runtime";
import { useTranslation as Ae } from "react-i18next";
import { Link as Ea } from "react-router";
import { buttonVariants as us, Button as mt, cn as fe, Tooltip as Kd, TooltipTrigger as qd, TooltipContent as Yd, AlertDialog as Zd, AlertDialogContent as Xd, AlertDialogHeader as Jd, AlertDialogTitle as Qd, AlertDialogDescription as eu, AlertDialogFooter as tu, AlertDialogCancel as t4, AlertDialogAction as n4, Skeleton as me, Label as wa, Input as $a, Collapsible as r4, CollapsibleTrigger as a4, CollapsibleContent as i4, Command as nu, Badge as o4, CommandList as ru, CommandGroup as au, CommandItem as iu, Popover as l4, PopoverTrigger as s4, PopoverContent as c4, CommandInput as d4, ScrollArea as u4, CommandEmpty as f4, Card as ki, CardContent as Oi, Separator as ou, Checkbox as p4, CardHeader as m4, CardTitle as h4, TableRow as v4, TableHead as g4, TooltipProvider as y4 } from "@cold-ambulance/shadcn";
import * as $ from "react";
import i, { forwardRef as _n, createElement as ll, useState as ve, useEffect as xe, useId as Li, useCallback as de, useRef as $e, useMemo as Fe, useContext as St, createContext as it, useLayoutEffect as b4, useReducer as E4, useImperativeHandle as w4, Fragment as $4 } from "react";
import { toast as lr } from "sonner";
import { useQuery as x4, useQueryClient as C4, useMutation as M4, useMutationState as S4 } from "@tanstack/react-query";
import { ColdAmbulance as F4, APIError as fs, ParseError as P4, Unauthorized as N4 } from "@cold-ambulance/client";
import * as _4 from "react-dom";
import T4, { flushSync as A4 } from "react-dom";
import z4 from "i18next";
const jk = {
  shared: {
    terms: {
      title: "الموافقة على الاتفاقيات والشروط",
      description: "لمتابعة استخدام المنصة، يرجى الاطلاع على المستندات التالية والموافقة عليها:",
      acknowledgement: "أقر بأنني قرأت {{documents}} وأوافق على جميع بنودهما",
      documentSeparator: " و",
      accept: "أوافق وأتابع",
      accepting: "جارٍ الحفظ...",
      logout: "تسجيل الخروج"
    },
    reviewRequest: {
      governmentSector: "قطاع حكومي",
      privateSector: "قطاع خاص",
      projectType: "نوع المشروع",
      projectLocation: "موقع المشروع",
      requestDate: "تاريخ الطلب",
      dailyWorkHours: "ساعات العمل اليومية",
      requiredServices: "الخدمات المطلوبة",
      siteConditions: "حالة الموقع",
      isolatedArea: "منطقة معزولة/منطقة نائية",
      housingTransport: "مسكن و مواصلات",
      mealsForStaff: "طعام لطاقم العمل",
      offerAndPayment: "العرض والدفع",
      proposalDeadline: "الموعد النهائي للعرض",
      bankGuarantee: "ضمان بنكي",
      paymentSystem: "نظام الدفع",
      installment: "الدفعة",
      kpis: "مؤشرات الأداء (KPIs)",
      notes: "ملاحظات"
    },
    services: {
      ambulanceWithDriver: "سيارة إسعاف مع سائق",
      ambulanceWithoutDriver: "سيارة إسعاف بدون سائق",
      ambulance4x4WithDriver: "سيارة إسعاف 4x4 مع سائق",
      ambulance4x4WithoutDriver: "سيارة إسعاف 4x4 بدون سائق",
      mobileClinicBasic: "عيادة متنقلة أساسية",
      mobileClinicAdvanced: "عيادة متنقلة متقدمة",
      paramedics: "المسعفين",
      nurses: "الممرضين",
      doctors: "الأطباء",
      medicalEquipment: "المعدات الطبية",
      specialist: "أخصائي",
      technician: "فني"
    },
    offerStatus: {
      open: "متاح لاستقبال العروض",
      awaitingDocuments: "في انتظار مستندات المورد",
      awaitingReview: "في انتظار مراجعة الإدارة",
      documentsRejected: "تم رفض المستندات",
      awaitingSigning: "في انتظار توقيع العقد",
      contractReady: "تم إتمام العقد",
      awaitingTT: "في انتظار رفع إثبات الدفع",
      awaitingTTReview: "في انتظار مراجعة إثبات الدفع",
      ttRejected: "تم رفض إثبات الدفع",
      inProgress: "جاري تنفيذ الخدمة"
    },
    offerAction: {
      allDocsUploadedAwaitingReview: "تم رفع جميع المستندات - في انتظار مراجعة الإدارة",
      docsRequired: "مطلوب رفع مستندات",
      docsUploaded: "{{uploaded}} من {{total}} مستندات مرفوعة",
      uploadDocs: "رفع المستندات",
      viewDocs: "عرض المستندات",
      someDocsRejected: "تم رفض بعض المستندات",
      reviewAndReupload: "يرجى مراجعة المستندات وإعادة رفعها",
      updateDocs: "تحديث المستندات",
      awaitingSigning: "في انتظار توقيع العقد",
      project: "مشروع: {{name}}",
      signContract: "توقيع العقد",
      awaitingCustomerTT: "في انتظار رفع إثبات الدفع من العميل",
      willNotifyOnTT: "سيتم إشعارك عند رفع العميل لإثبات الدفع",
      awaitingTTReview: "في انتظار مراجعة إثبات الدفع",
      ttUnderReview: "جاري مراجعة إثبات الدفع من قبل الإدارة",
      ttRejected: "تم رفض إثبات الدفع",
      awaitingCustomerReupload: "في انتظار إعادة رفع إثبات الدفع من العميل",
      serviceInProgress: "جاري تنفيذ الخدمة",
      rejectionReason: "سبب الرفض: {{reason}}"
    },
    contract: {
      signatureStatus: "حالة التوقيع",
      signed: "تم التوقيع",
      awaitingSignature: "في انتظار التوقيع",
      signingEmailSent: "تم إرسال العقد للتوقيع إلكترونياً",
      signingEmailInstruction: "يرجى التحقق من بريدك الإلكتروني والتوقيع على العقد من خلال الرابط المرسل."
    },
    banners: {
      congratsDocsApproved: "تهانينا! تمت الموافقة على جميع المستندات المطلوبة.",
      proceedToSign: "الآن يمكنك الانتقال لتوقيع العقد.",
      project: "مشروع: {{name}}",
      signContract: "توقيع العقد",
      completeVerification: "لإكمال التحقق من حسابك، يرجى تزويدنا بمزيد من مستندات",
      submitAdditionalDocs: "تقديم مستندات إضافية",
      completeProfile: "أكمل بيانات ملفك الشخصي (المفوض بالتوقيع والمعلومات النظامية) لتفعيل العقود",
      completeProfileCta: "إكمال الملف",
      accountUnderReview: "حسابك قيد التدقيق لضمان أعلى مستوى من الخدمة، وسننجز ذلك خلال 24 ساعة فقط.",
      accountRejectedTitle: "طلب حسابك يحتاج إلى تعديلات",
      accountRejectedReason: "السبب: {{reason}}"
    },
    validation: {
      fieldValidationError: "خطأ في التحقق من صحة البيانات",
      formValidationError: "خطأ في التحقق من صحة النموذج",
      unexpectedError: "حدث خطأ غير متوقع",
      valueAlreadyInUse: "القيمة المدخلة مستخدمة بالفعل"
    },
    errors: {
      recordNotFound: "البيانات المطلوبة غير موجودة",
      validationFailed: "البيانات المدخلة غير صحيحة",
      forbidden: "غير مصرح لك بالوصول",
      unexpectedErrorRetry: "حدث خطأ غير متوقع، يرجى المحاولة لاحقًا",
      offerAlreadyAccepted: "تم قبول عرض آخر بالفعل لهذا الطلب"
    },
    payment: {
      monthly: "دفعات شهرية",
      deliverables: "دفعات المخرجات"
    },
    common: {
      notSpecified: "لم يتم التحديد",
      back: "رجوع",
      view: "عرض",
      download: "تحميل",
      loading: "جاري التحميل...",
      unavailable: "غير متاح",
      searchCountry: "ابحث عن دولة...",
      fileViewFailed: "فشل عرض الملف",
      fileDownloadFailed: "فشل تحميل الملف",
      dragFile: "ادرج الملف",
      cancel: "إلغاء",
      confirm: "تأكيد",
      mandatory: "إلزامي"
    },
    fileErrors: {
      invalidType: "نوع الملف غير مدعوم",
      tooLarge: "حجم الملف كبير جداً. الحد الأقصى المسموح 10 ميجابايت",
      tooSmall: "حجم الملف صغير جداً",
      tooMany: "عدد كبير من الملفات. يُسمح بملف واحد فقط"
    },
    equipment: {
      placeholder: "اسم المعدة أو اللوازم الطبية",
      quantity: "الكمية",
      addEquipment: "إضافة معدة"
    },
    actions: {
      profile: {
        accountUpdated: "تم تحديث بيانات الحساب",
        contactUpdated: "تم تحديث بيانات التواصل",
        signatoryUpdated: "تم تحديث بيانات المفوض بالتوقيع",
        documentsUpdated: "تم تحديث المستندات",
        additionalDocsSubmitted: "تم إرسال المستندات الإضافية"
      },
      offer: {
        documentUploaded: "تم رفع المستند",
        documentDeleted: "تم حذف المستند",
        customerTtUploaded: "تم رفع إثبات الدفع لميد هاب",
        customerTtDeleted: "تم حذف إثبات الدفع لميد هاب",
        vendorTtUploaded: "تم رفع إثبات الدفع للمورد",
        vendorTtDeleted: "تم حذف إثبات الدفع للمورد",
        vendorTtApproved: "تم اعتماد إثبات الدفع",
        vendorTtRejected: "تم رفض إثبات الدفع"
      },
      draft: {
        deleted: "تم حذف المسودة"
      }
    },
    firebase: {
      invalidCredentials: "البريد الإلكتروني أو كلمة المرور غير صحيحة",
      tooManyAttempts: "تم حظر تسجيل الدخول بسبب محاولات متكررة، يرجى المحاولة لاحقاً",
      accountDisabled: "تم تعطيل الحساب، يرجى التواصل مع الدعم الفني",
      networkFailed: "فشل الاتصال بالشبكة، يرجى التحقق من اتصالك بالإنترنت",
      loginNotSupported: "تسجيل الدخول بالبريد الإلكتروني وكلمة المرور غير مدعوم حالياً",
      invalidEmail: "البريد الإلكتروني غير صحيح، يرجى المحاولة مرة أخرى",
      invalidPassword: "كلمة المرور غير صحيحة، يرجى المحاولة مرة أخرى",
      loginError: "حدث خطأ أثناء تسجيل الدخول",
      logoutError: "حدث خطأ أثناء تسجيل الخروج",
      emailNotRegistered: "البريد الإلكتروني غير مسجل",
      resetEmailError: "حدث خطأ أثناء إرسال رابط إعادة التعيين",
      emailAlreadyInUse: "البريد الإلكتروني مسجل بالفعل",
      weakPassword: "كلمة المرور ضعيفة. الرجاء اختيار كلمة مرور أقوى",
      signupError: "حدث خطأ أثناء إنشاء الحساب"
    }
  }
}, Vk = {
  shared: {
    terms: {
      title: "Agreement and policy acceptance",
      description: "To continue using the platform, please review and accept the following documents:",
      acknowledgement: "I acknowledge that I have read the {{documents}} and agree to all their terms.",
      documentSeparator: " and ",
      accept: "Agree and continue",
      accepting: "Saving...",
      logout: "Log out"
    },
    reviewRequest: {
      governmentSector: "Government Sector",
      privateSector: "Private Sector",
      projectType: "Project Type",
      projectLocation: "Project Location",
      requestDate: "Request Date",
      dailyWorkHours: "Daily Working Hours",
      requiredServices: "Required Services",
      siteConditions: "Site Conditions",
      isolatedArea: "Isolated/Remote Area",
      housingTransport: "Housing & Transportation",
      mealsForStaff: "Meals for Staff",
      offerAndPayment: "Offer & Payment",
      proposalDeadline: "Proposal Deadline",
      bankGuarantee: "Bank Guarantee",
      paymentSystem: "Payment System",
      installment: "Installment",
      kpis: "Performance Indicators (KPIs)",
      notes: "Notes"
    },
    services: {
      ambulanceWithDriver: "Ambulance with Driver",
      ambulanceWithoutDriver: "Ambulance without Driver",
      ambulance4x4WithDriver: "4x4 Ambulance with Driver",
      ambulance4x4WithoutDriver: "4x4 Ambulance without Driver",
      mobileClinicBasic: "Basic Mobile Clinic",
      mobileClinicAdvanced: "Advanced Mobile Clinic",
      paramedics: "Paramedics",
      nurses: "Nurses",
      doctors: "Doctors",
      medicalEquipment: "Medical Equipment",
      specialist: "Specialist",
      technician: "Technician"
    },
    offerStatus: {
      open: "Open for Offers",
      awaitingDocuments: "Awaiting Vendor Documents",
      awaitingReview: "Awaiting Admin Review",
      documentsRejected: "Documents Rejected",
      awaitingSigning: "Awaiting Contract Signature",
      contractReady: "Contract Completed",
      awaitingTT: "Awaiting Payment Proof Upload",
      awaitingTTReview: "Awaiting Payment Proof Review",
      ttRejected: "Payment Proof Rejected",
      inProgress: "Service In Progress"
    },
    offerAction: {
      allDocsUploadedAwaitingReview: "All documents uploaded - Awaiting admin review",
      docsRequired: "Document upload required",
      docsUploaded: "{{uploaded}} of {{total}} documents uploaded",
      uploadDocs: "Upload Documents",
      viewDocs: "View Documents",
      someDocsRejected: "Some documents were rejected",
      reviewAndReupload: "Please review and re-upload the documents",
      updateDocs: "Update Documents",
      awaitingSigning: "Awaiting contract signature",
      project: "Project: {{name}}",
      signContract: "Sign Contract",
      awaitingCustomerTT: "Awaiting payment proof upload from customer",
      willNotifyOnTT: "You will be notified when the customer uploads payment proof",
      awaitingTTReview: "Awaiting payment proof review",
      ttUnderReview: "Payment proof is being reviewed by admin",
      ttRejected: "Payment proof rejected",
      awaitingCustomerReupload: "Awaiting payment proof re-upload from customer",
      serviceInProgress: "Service in progress",
      rejectionReason: "Rejection reason: {{reason}}"
    },
    contract: {
      signatureStatus: "Signature Status",
      signed: "Signed",
      awaitingSignature: "Awaiting Signature",
      signingEmailSent: "The contract has been sent for electronic signature",
      signingEmailInstruction: "Please check your email to complete the signing process"
    },
    banners: {
      congratsDocsApproved: "Congratulations! All required documents have been approved.",
      proceedToSign: "You can now proceed to sign the contract.",
      project: "Project: {{name}}",
      signContract: "Sign Contract",
      completeVerification: "To complete your account verification, please provide us with more documents",
      submitAdditionalDocs: "Submit Additional Documents",
      completeProfile: "Complete your profile (signatory and legal details) to enable contracts",
      completeProfileCta: "Complete profile",
      accountUnderReview: "Your account is under review to ensure the highest level of service. This will be completed within 24 hours.",
      accountRejectedTitle: "Your application needs changes",
      accountRejectedReason: "Reason: {{reason}}"
    },
    validation: {
      fieldValidationError: "Field validation error",
      formValidationError: "Form validation error",
      unexpectedError: "An unexpected error occurred",
      valueAlreadyInUse: "This value is already in use"
    },
    errors: {
      recordNotFound: "The requested data was not found",
      validationFailed: "The entered data is invalid",
      forbidden: "You are not authorized to access this",
      unexpectedErrorRetry: "An unexpected error occurred, please try again later",
      offerAlreadyAccepted: "Another offer has already been accepted for this request"
    },
    payment: {
      monthly: "Monthly Payments",
      deliverables: "Deliverables Payments"
    },
    common: {
      notSpecified: "Not specified",
      back: "Back",
      view: "View",
      download: "Download",
      loading: "Loading...",
      unavailable: "Unavailable",
      searchCountry: "Search for a country...",
      fileViewFailed: "File view failed",
      fileDownloadFailed: "File download failed",
      dragFile: "Drag file here",
      cancel: "Cancel",
      confirm: "Confirm",
      mandatory: "Mandatory"
    },
    fileErrors: {
      invalidType: "File type not supported",
      tooLarge: "File size is too large. Maximum allowed is 10 MB",
      tooSmall: "File size is too small",
      tooMany: "Too many files. Only one file is allowed"
    },
    equipment: {
      placeholder: "Equipment or medical supplies name",
      quantity: "Quantity",
      addEquipment: "Add Equipment"
    },
    actions: {
      profile: {
        accountUpdated: "Account info updated",
        contactUpdated: "Contact info updated",
        signatoryUpdated: "Signatory info updated",
        documentsUpdated: "Documents updated",
        additionalDocsSubmitted: "Additional documents submitted"
      },
      offer: {
        documentUploaded: "Document uploaded",
        documentDeleted: "Document deleted",
        customerTtUploaded: "MedHub payment proof uploaded",
        customerTtDeleted: "MedHub payment proof deleted",
        vendorTtUploaded: "Vendor payment proof uploaded",
        vendorTtDeleted: "Vendor payment proof deleted",
        vendorTtApproved: "Payment proof approved",
        vendorTtRejected: "Payment proof rejected"
      },
      draft: {
        deleted: "Draft deleted"
      }
    },
    firebase: {
      invalidCredentials: "Invalid email or password",
      tooManyAttempts: "Login blocked due to repeated attempts, please try again later",
      accountDisabled: "Account has been disabled, please contact support",
      networkFailed: "Network connection failed, please check your internet connection",
      loginNotSupported: "Email and password login is not currently supported",
      invalidEmail: "Invalid email, please try again",
      invalidPassword: "Invalid password, please try again",
      loginError: "An error occurred during login",
      logoutError: "An error occurred during logout",
      emailNotRegistered: "Email is not registered",
      resetEmailError: "An error occurred while sending the reset link",
      emailAlreadyInUse: "Email is already registered",
      weakPassword: "Weak password. Please choose a stronger password",
      signupError: "An error occurred while creating the account"
    }
  }
};
const D4 = (t) => t.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase(), I4 = (t) => t.replace(
  /^([A-Z])|[\s-_]+(\w)/g,
  (e, n, r) => r ? r.toUpperCase() : n.toLowerCase()
), Zs = (t) => {
  const e = I4(t);
  return e.charAt(0).toUpperCase() + e.slice(1);
}, lu = (...t) => t.filter((e, n, r) => !!e && e.trim() !== "" && r.indexOf(e) === n).join(" ").trim(), k4 = (t) => {
  for (const e in t)
    if (e.startsWith("aria-") || e === "role" || e === "title")
      return !0;
};
var O4 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
};
const L4 = _n(
  ({
    color: t = "currentColor",
    size: e = 24,
    strokeWidth: n = 2,
    absoluteStrokeWidth: r,
    className: a = "",
    children: o,
    iconNode: l,
    ...s
  }, c) => ll(
    "svg",
    {
      ref: c,
      ...O4,
      width: e,
      height: e,
      stroke: t,
      strokeWidth: r ? Number(n) * 24 / Number(e) : n,
      className: lu("lucide", a),
      ...!o && !k4(s) && { "aria-hidden": "true" },
      ...s
    },
    [
      ...l.map(([d, u]) => ll(d, u)),
      ...Array.isArray(o) ? o : [o]
    ]
  )
);
const be = (t, e) => {
  const n = _n(
    ({ className: r, ...a }, o) => ll(L4, {
      ref: o,
      iconNode: e,
      className: lu(
        `lucide-${D4(Zs(t))}`,
        `lucide-${t}`,
        r
      ),
      ...a
    })
  );
  return n.displayName = Zs(t), n;
};
const R4 = [
  ["path", { d: "m12 19-7-7 7-7", key: "1l729n" }],
  ["path", { d: "M19 12H5", key: "x3x0zl" }]
], H4 = be("arrow-left", R4);
const B4 = [
  ["path", { d: "m21 16-4 4-4-4", key: "f6ql7i" }],
  ["path", { d: "M17 20V4", key: "1ejh1v" }],
  ["path", { d: "m3 8 4-4 4 4", key: "11wl7u" }],
  ["path", { d: "M7 4v16", key: "1glfcx" }]
], j4 = be("arrow-up-down", B4);
const V4 = [
  ["rect", { width: "20", height: "12", x: "2", y: "6", rx: "2", key: "9lu3g6" }],
  ["circle", { cx: "12", cy: "12", r: "2", key: "1c9p78" }],
  ["path", { d: "M6 12h.01M18 12h.01", key: "113zkx" }]
], U4 = be("banknote", V4);
const W4 = [
  ["rect", { width: "18", height: "18", x: "3", y: "4", rx: "2", key: "1hopcy" }],
  ["path", { d: "M16 2v4", key: "4m81vk" }],
  ["path", { d: "M3 10h18", key: "8toen8" }],
  ["path", { d: "M8 2v4", key: "1cmpym" }],
  ["path", { d: "M17 14h-6", key: "bkmgh3" }],
  ["path", { d: "M13 18H7", key: "bb0bb7" }],
  ["path", { d: "M7 14h.01", key: "1qa3f1" }],
  ["path", { d: "M17 18h.01", key: "1bdyru" }]
], G4 = be("calendar-range", W4);
const K4 = [["path", { d: "M20 6 9 17l-5-5", key: "1gmf2c" }]], zr = be("check", K4);
const q4 = [["path", { d: "m6 9 6 6 6-6", key: "qrunsl" }]], Y4 = be("chevron-down", q4);
const Z4 = [["path", { d: "m18 15-6-6-6 6", key: "153udz" }]], X4 = be("chevron-up", Z4);
const J4 = [
  ["path", { d: "m7 15 5 5 5-5", key: "1hf1tw" }],
  ["path", { d: "m7 9 5-5 5 5", key: "sgt6xg" }]
], Q4 = be("chevrons-up-down", J4);
const ep = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["line", { x1: "12", x2: "12", y1: "8", y2: "12", key: "1pkeuh" }],
  ["line", { x1: "12", x2: "12.01", y1: "16", y2: "16", key: "4dfq90" }]
], Dr = be("circle-alert", ep);
const tp = [
  ["path", { d: "M21.801 10A10 10 0 1 1 17 3.335", key: "yps3ct" }],
  ["path", { d: "m9 11 3 3L22 4", key: "1pflzl" }]
], su = be("circle-check-big", tp);
const np = [
  ["path", { d: "M12 6v6l4 2", key: "mmk7yg" }],
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }]
], Ir = be("clock", np);
const rp = [
  ["path", { d: "M12 13v8", key: "1l5pq0" }],
  ["path", { d: "M4 14.899A7 7 0 1 1 15.71 8h1.79a4.5 4.5 0 0 1 2.5 8.242", key: "1pljnt" }],
  ["path", { d: "m8 17 4-4 4 4", key: "1quai1" }]
], ap = be("cloud-upload", rp);
const ip = [
  ["rect", { width: "20", height: "14", x: "2", y: "5", rx: "2", key: "ynyp8z" }],
  ["line", { x1: "2", x2: "22", y1: "10", y2: "10", key: "1b3vmo" }]
], cu = be("credit-card", ip);
const op = [
  ["path", { d: "M15 3h6v6", key: "1q9fwt" }],
  ["path", { d: "M10 14 21 3", key: "gplh6r" }],
  ["path", { d: "M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6", key: "a6xqqp" }]
], du = be("external-link", op);
const lp = [
  [
    "path",
    {
      d: "M10.733 5.076a10.744 10.744 0 0 1 11.205 6.575 1 1 0 0 1 0 .696 10.747 10.747 0 0 1-1.444 2.49",
      key: "ct8e1f"
    }
  ],
  ["path", { d: "M14.084 14.158a3 3 0 0 1-4.242-4.242", key: "151rxh" }],
  [
    "path",
    {
      d: "M17.479 17.499a10.75 10.75 0 0 1-15.417-5.151 1 1 0 0 1 0-.696 10.75 10.75 0 0 1 4.446-5.143",
      key: "13bj9a"
    }
  ],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }]
], sp = be("eye-off", lp);
const cp = [
  [
    "path",
    {
      d: "M2.062 12.348a1 1 0 0 1 0-.696 10.75 10.75 0 0 1 19.876 0 1 1 0 0 1 0 .696 10.75 10.75 0 0 1-19.876 0",
      key: "1nclc0"
    }
  ],
  ["circle", { cx: "12", cy: "12", r: "3", key: "1v7zrd" }]
], dp = be("eye", cp);
const up = [
  ["path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z", key: "1rqfz7" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "m9 15 2 2 4-4", key: "1grp1n" }]
], sl = be("file-check", up);
const fp = [
  ["path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z", key: "1rqfz7" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "M10 9H8", key: "b1mrlr" }],
  ["path", { d: "M16 13H8", key: "t4e002" }],
  ["path", { d: "M16 17H8", key: "z1uh3a" }]
], uu = be("file-text", fp);
const pp = [
  ["path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z", key: "1rqfz7" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "M12 12v6", key: "3ahymv" }],
  ["path", { d: "m15 15-3-3-3 3", key: "15xj92" }]
], mp = be("file-up", pp);
const hp = [
  ["path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z", key: "1rqfz7" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "m14.5 12.5-5 5", key: "b62r18" }],
  ["path", { d: "m9.5 12.5 5 5", key: "1rk7el" }]
], ri = be("file-x", hp);
const vp = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M16 16s-1.5-2-4-2-4 2-4 2", key: "epbg0q" }],
  ["line", { x1: "9", x2: "9.01", y1: "9", y2: "9", key: "yxxnd0" }],
  ["line", { x1: "15", x2: "15.01", y1: "9", y2: "9", key: "1p4y9e" }]
], gp = be("frown", vp);
const yp = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M12 16v-4", key: "1dtifu" }],
  ["path", { d: "M12 8h.01", key: "e9boi3" }]
], kr = be("info", yp);
const bp = [
  ["path", { d: "M10 18v-7", key: "wt116b" }],
  [
    "path",
    {
      d: "M11.12 2.198a2 2 0 0 1 1.76.006l7.866 3.847c.476.233.31.949-.22.949H3.474c-.53 0-.695-.716-.22-.949z",
      key: "1m329m"
    }
  ],
  ["path", { d: "M14 18v-7", key: "vav6t3" }],
  ["path", { d: "M18 18v-7", key: "aexdmj" }],
  ["path", { d: "M3 22h18", key: "8prr45" }],
  ["path", { d: "M6 18v-7", key: "1ivflk" }]
], Ep = be("landmark", bp);
const wp = [["path", { d: "M21 12a9 9 0 1 1-6.219-8.56", key: "13zald" }]], fu = be("loader-circle", wp);
const $p = [
  ["path", { d: "m22 7-8.991 5.727a2 2 0 0 1-2.009 0L2 7", key: "132q7q" }],
  ["rect", { x: "2", y: "4", width: "20", height: "16", rx: "2", key: "izxlao" }]
], xp = be("mail", $p);
const Cp = [
  [
    "path",
    {
      d: "M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0",
      key: "1r0f0z"
    }
  ],
  ["circle", { cx: "12", cy: "10", r: "3", key: "ilqhr7" }]
], Xs = be("map-pin", Cp);
const Mp = [["path", { d: "M5 12h14", key: "1ays0h" }]], Sp = be("minus", Mp);
const Fp = [
  ["path", { d: "M13 21h8", key: "1jsn5i" }],
  [
    "path",
    {
      d: "M21.174 6.812a1 1 0 0 0-3.986-3.987L3.842 16.174a2 2 0 0 0-.5.83l-1.321 4.352a.5.5 0 0 0 .623.622l4.353-1.32a2 2 0 0 0 .83-.497z",
      key: "1a8usu"
    }
  ]
], ai = be("pen-line", Fp);
const Pp = [
  ["path", { d: "M5 12h14", key: "1ays0h" }],
  ["path", { d: "M12 5v14", key: "s699le" }]
], pu = be("plus", Pp);
const Np = [
  ["path", { d: "m21 21-4.34-4.34", key: "14j7rj" }],
  ["circle", { cx: "11", cy: "11", r: "8", key: "4ej97u" }]
], _p = be("search", Np);
const Tp = [
  [
    "path",
    {
      d: "M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z",
      key: "oel41y"
    }
  ],
  ["path", { d: "m9 12 2 2 4-4", key: "dzmm74" }]
], Ap = be("shield-check", Tp);
const zp = [
  ["path", { d: "M10 11v6", key: "nco0om" }],
  ["path", { d: "M14 11v6", key: "outv1u" }],
  ["path", { d: "M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6", key: "miytrc" }],
  ["path", { d: "M3 6h18", key: "d0wm0j" }],
  ["path", { d: "M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2", key: "e791ji" }]
], mu = be("trash-2", zp);
const Dp = [
  ["path", { d: "m16 11 2 2 4-4", key: "9rsbq5" }],
  ["path", { d: "M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2", key: "1yyitq" }],
  ["circle", { cx: "9", cy: "7", r: "4", key: "nufk8" }]
], Ip = be("user-check", Dp);
const kp = [
  ["path", { d: "M18 6 6 18", key: "1bl5f8" }],
  ["path", { d: "m6 6 12 12", key: "d8bk6v" }]
], hu = be("x", kp);
function Uk({
  projectName: t,
  linkUrl: e,
  subtitle: n
}) {
  const { t: r } = Ae();
  return /* @__PURE__ */ S("div", { className: "flex items-center justify-between rounded-xl border border-blue-200 bg-blue-50 py-3 ps-7 pe-4", children: [
    /* @__PURE__ */ S("div", { className: "flex-1", children: [
      /* @__PURE__ */ S("div", { className: "flex items-center gap-2", children: [
        /* @__PURE__ */ p(ai, { size: 20, className: "text-blue-600" }),
        /* @__PURE__ */ p("p", { className: "text-sm font-medium text-blue-800", children: r("shared.banners.congratsDocsApproved") })
      ] }),
      /* @__PURE__ */ S("div", { className: "mt-1 ms-7 text-sm text-blue-700", children: [
        /* @__PURE__ */ p("span", { children: r("shared.banners.proceedToSign") }),
        /* @__PURE__ */ S("span", { className: "ms-2", children: [
          "• ",
          r("shared.banners.project", { name: t })
        ] }),
        n && /* @__PURE__ */ S("span", { className: "ms-2", children: [
          "• ",
          n
        ] })
      ] })
    ] }),
    /* @__PURE__ */ S(
      Ea,
      {
        to: e,
        className: us({
          variant: "link",
          className: "bg-blue-600 text-sm text-white hover:bg-blue-700"
        }),
        children: [
          /* @__PURE__ */ p(ai, { size: 16, className: "me-1" }),
          r("shared.banners.signContract")
        ]
      }
    )
  ] });
}
function po({
  value: t,
  label: e
}) {
  return /* @__PURE__ */ S("div", { className: "flex items-center gap-2", children: [
    t ? /* @__PURE__ */ p(zr, { className: "text-primary shrink-0", strokeWidth: 4 }) : /* @__PURE__ */ p(hu, { size: 20, className: "shrink-0 text-red-500", strokeWidth: 4 }),
    /* @__PURE__ */ p("span", { children: e })
  ] });
}
function Op(t, e) {
  const n = !!t, [r, a] = ve(!1);
  return xe(() => {
    if (!n)
      return;
    const o = setTimeout(() => {
      a(!0);
    }, e);
    return () => {
      clearTimeout(o), queueMicrotask(() => a(!1));
    };
  }, [n, e]), n && r;
}
function Lp(t) {
  return typeof t == "function" ? !0 : typeof t == "object" && t !== null && "$$typeof" in t && typeof t.render == "function";
}
function vu({ icon: t }) {
  return Lp(t) ? /* @__PURE__ */ p(t, { className: "size-4" }) : /* @__PURE__ */ p($t, { children: t });
}
function gu() {
  return /* @__PURE__ */ p(fu, { className: "size-4 animate-spin" });
}
function Rp({
  icon: t,
  showSpinner: e
}) {
  return /* @__PURE__ */ S("div", { className: "relative size-4 overflow-hidden", children: [
    t && /* @__PURE__ */ p(
      "div",
      {
        className: fe(
          "absolute inset-0 flex items-center justify-center transition-all duration-300 ease-in-out",
          e ? "-translate-x-full opacity-0" : "translate-x-0 opacity-100"
        ),
        children: /* @__PURE__ */ p(vu, { icon: t })
      }
    ),
    /* @__PURE__ */ p(
      "div",
      {
        className: fe(
          "absolute inset-0 transition-all duration-300 ease-in-out",
          e ? "translate-x-0 opacity-100" : "translate-x-full opacity-0"
        ),
        children: /* @__PURE__ */ p(gu, {})
      }
    )
  ] });
}
function Hp({
  icon: t,
  showSpinner: e,
  children: n
}) {
  return /* @__PURE__ */ S($t, { children: [
    t && /* @__PURE__ */ p(
      "div",
      {
        className: fe(
          "overflow-hidden transition-all duration-300 ease-in-out",
          e ? "w-0 opacity-0" : "w-4 opacity-100"
        ),
        children: /* @__PURE__ */ p(vu, { icon: t })
      }
    ),
    /* @__PURE__ */ p(
      "div",
      {
        className: fe(
          "overflow-hidden transition-all duration-300 ease-in-out",
          e ? "w-4 opacity-100" : "-ms-2 w-0 opacity-0",
          t ? "-ms-2" : ""
        ),
        children: /* @__PURE__ */ p(gu, {})
      }
    ),
    n
  ] });
}
function Bp({
  tooltip: t,
  children: e
}) {
  return t ? /* @__PURE__ */ S(Kd, { children: [
    /* @__PURE__ */ p(qd, { asChild: !0, children: e }),
    /* @__PURE__ */ p(Yd, { children: t })
  ] }) : /* @__PURE__ */ p($t, { children: e });
}
function Ri({
  loading: t,
  disabled: e,
  children: n,
  delay: r = 300,
  icon: a,
  tooltip: o,
  size: l,
  ...s
}) {
  const c = Op(t, r), d = l?.startsWith("icon");
  return /* @__PURE__ */ p(Bp, { tooltip: o, children: /* @__PURE__ */ p(
    mt,
    {
      disabled: e || t,
      size: l,
      ...s,
      className: fe("cursor-pointer gap-2", s.className),
      children: d ? /* @__PURE__ */ p(Rp, { icon: a, showSpinner: c }) : /* @__PURE__ */ p(Hp, { icon: a, showSpinner: c, children: n })
    }
  ) });
}
function Wk({
  open: t,
  onOpenChange: e,
  mutation: n,
  title: r,
  description: a,
  actionLabel: o,
  pendingLabel: l,
  variant: s = "destructive"
}) {
  const { t: c } = Ae(), d = o ?? c("shared.common.confirm"), u = l ?? `${d}...`, f = (m) => {
    m.preventDefault(), n.mutate();
  };
  return /* @__PURE__ */ p(
    Zd,
    {
      open: t,
      onOpenChange: (m) => {
        n.isPending || e(m);
      },
      children: /* @__PURE__ */ S(Xd, { children: [
        /* @__PURE__ */ S(Jd, { children: [
          /* @__PURE__ */ p(Qd, { children: r }),
          /* @__PURE__ */ p(eu, { children: a })
        ] }),
        /* @__PURE__ */ S(tu, { children: [
          /* @__PURE__ */ p(t4, { disabled: n.isPending, children: c("shared.common.cancel") }),
          /* @__PURE__ */ p(n4, { asChild: !0, children: /* @__PURE__ */ p(
            Ri,
            {
              type: "button",
              onClick: f,
              className: s === "destructive" ? "bg-destructive text-destructive-foreground hover:bg-destructive/90" : void 0,
              loading: n.isPending,
              children: n.isPending ? u : d
            }
          ) })
        ] })
      ] })
    }
  );
}
function Gk() {
  return /* @__PURE__ */ S("div", { className: "space-y-6", children: [
    /* @__PURE__ */ p(me, { className: "h-8 w-32" }),
    /* @__PURE__ */ p(me, { className: "h-10 w-64" }),
    /* @__PURE__ */ p(me, { className: "h-5 w-48" }),
    /* @__PURE__ */ S("div", { className: "space-y-4 rounded-lg border p-4", children: [
      /* @__PURE__ */ p(me, { className: "h-6 w-32" }),
      /* @__PURE__ */ p(me, { className: "h-10 w-full" })
    ] }),
    /* @__PURE__ */ S("div", { className: "space-y-4 rounded-lg border p-4", children: [
      /* @__PURE__ */ p(me, { className: "h-6 w-32" }),
      /* @__PURE__ */ p(me, { className: "h-16 w-full" }),
      /* @__PURE__ */ p(me, { className: "h-16 w-full" })
    ] }),
    /* @__PURE__ */ S("div", { className: "space-y-4 rounded-lg border p-4", children: [
      /* @__PURE__ */ p(me, { className: "h-6 w-32" }),
      /* @__PURE__ */ p(me, { className: "h-10 w-full" }),
      /* @__PURE__ */ p(me, { className: "h-10 w-full" }),
      /* @__PURE__ */ p(me, { className: "h-10 w-full" }),
      /* @__PURE__ */ p(me, { className: "h-12 w-full" })
    ] })
  ] });
}
function jp({
  label: t,
  className: e,
  value: n,
  onChange: r,
  min: a = 0
}) {
  const o = Li();
  return /* @__PURE__ */ S(
    "div",
    {
      className: fe(
        "bg-background flex h-11 justify-between rounded-lg px-4",
        e
      ),
      children: [
        /* @__PURE__ */ p(wa, { htmlFor: o, children: t }),
        /* @__PURE__ */ S("div", { className: "flex items-center gap-2", children: [
          /* @__PURE__ */ p(
            mt,
            {
              onClick: () => r?.(n + 1),
              type: "button",
              variant: "outline",
              className: "h-8 min-w-8 rounded-full px-0",
              children: /* @__PURE__ */ p(pu, { className: "h-4 w-4" })
            }
          ),
          /* @__PURE__ */ p("p", { className: "mx-4 w-4 border-none bg-transparent text-center", children: n }),
          /* @__PURE__ */ p(
            mt,
            {
              onClick: () => r(Math.max(a, n - 1)),
              type: "button",
              variant: "outline",
              className: "h-8 min-w-8 rounded-full px-0",
              disabled: n <= a,
              children: /* @__PURE__ */ p(Sp, { className: "h-4 w-4" })
            }
          )
        ] })
      ]
    }
  );
}
const ps = "https://cold-ambulance-api-kbiylpokwq-wx.a.run.app", $n = new F4({
  baseUrl: ps
});
function Kk(t, e, n) {
  return x4({
    queryKey: [t, JSON.stringify(e)],
    ...n,
    meta: { endpoint: t, input: e },
    queryFn: () => $n.request(t, e ?? {})
  });
}
function qk(t, e) {
  const n = C4();
  return M4({
    ...e,
    mutationKey: [t],
    mutationFn: async (r, a) => e && "mutationFn" in e && e.mutationFn ? e.mutationFn(
      (o) => $n.request(t, o),
      a
    ) : await $n.request(t, r),
    onSuccess: async (r, a, o, l) => {
      for (const s of e?.invalidate ?? [])
        await n.invalidateQueries({
          predicate(c) {
            return c.meta?.endpoint === s;
          }
        });
      return e?.onSuccess?.(r, a, r, l);
    }
  });
}
function Yk(t) {
  return S4({
    filters: {
      predicate(e) {
        return e.meta?.endpoint === t;
      }
    }
  });
}
async function Vp(t, e, n) {
  const r = await yu(t, e), a = URL.createObjectURL(r), o = document.createElement("a");
  o.href = a, o.download = n, document.body.appendChild(o), o.click(), document.body.removeChild(o), URL.revokeObjectURL(a);
}
async function Up(t, e) {
  const n = bu();
  if (!n)
    throw new Error("Failed to open generated file");
  try {
    const r = await yu(t, e), a = URL.createObjectURL(r);
    n.location.href = a, window.setTimeout(() => URL.revokeObjectURL(a), 6e4);
  } catch (r) {
    throw n.close(), r;
  }
}
async function yu(t, e) {
  const n = await $n.defaultHeaders();
  let r = t.replace("GET ", "");
  for (const [o, l] of Object.entries(e))
    r = r.replace(`{${o}}`, String(l));
  const a = await fetch(`${$n.options.baseUrl}${r}`, {
    headers: n
  });
  if (!a.ok)
    throw new Error(`Failed to download file: ${a.statusText}`);
  return a.blob();
}
function bu() {
  const t = window.open("about:blank", "_blank");
  return t && (t.opener = null), t;
}
function Zk({
  endpoint: t,
  input: e,
  icon: n,
  label: r,
  variant: a = "outline",
  className: o = "text-foreground",
  ...l
}) {
  const [s, c] = ve(!1), { t: d } = Ae();
  return /* @__PURE__ */ p(
    Ri,
    {
      ...l,
      variant: a,
      className: o,
      loading: s,
      icon: n,
      onClick: async () => {
        c(!0);
        try {
          await Up(t, e);
        } catch {
          lr.error(d("shared.common.fileViewFailed"));
        } finally {
          c(!1);
        }
      },
      children: r ?? d("shared.common.view")
    }
  );
}
function Xk({
  endpoint: t,
  input: e,
  filename: n,
  icon: r,
  label: a,
  variant: o = "outline",
  className: l = "text-foreground",
  ...s
}) {
  const [c, d] = ve(!1), { t: u } = Ae();
  return /* @__PURE__ */ p(
    Ri,
    {
      ...s,
      variant: o,
      className: l,
      loading: c,
      icon: r,
      onClick: async () => {
        d(!0);
        try {
          await Vp(t, e, n);
        } catch {
          lr.error(u("shared.common.fileDownloadFailed"));
        } finally {
          d(!1);
        }
      },
      children: a ?? u("shared.common.download")
    }
  );
}
function Jk(t) {
  return /* @__PURE__ */ p(Eu, { ...t, purpose: "view" });
}
function Qk(t) {
  return /* @__PURE__ */ p(Eu, { ...t, purpose: "download" });
}
function Eu({
  fileId: t,
  unavailableLabel: e,
  label: n,
  purpose: r,
  variant: a = "outline",
  size: o = "sm",
  ...l
}) {
  const [s, c] = ve(!1), { t: d } = Ae();
  if (!t)
    return /* @__PURE__ */ p("span", { className: "text-muted-foreground text-sm", "aria-disabled": !0, children: e ?? d("shared.common.unavailable") });
  const u = r === "view";
  return /* @__PURE__ */ p(
    Ri,
    {
      ...l,
      variant: a,
      size: o,
      loading: s,
      onClick: async () => {
        c(!0);
        const f = bu();
        if (!f) {
          lr.error(
            d(
              u ? "shared.common.fileViewFailed" : "shared.common.fileDownloadFailed"
            )
          ), c(!1);
          return;
        }
        try {
          const { signedUrl: m } = await $n.request("GET /files/{id}/access", {
            id: t,
            purpose: r
          });
          f.location.href = m;
        } catch {
          f.close(), lr.error(
            d(
              u ? "shared.common.fileViewFailed" : "shared.common.fileDownloadFailed"
            )
          );
        } finally {
          c(!1);
        }
      },
      children: n ?? d(u ? "shared.common.view" : "shared.common.download")
    }
  );
}
function eO({
  className: t,
  type: e,
  ...n
}) {
  return /* @__PURE__ */ p(
    $a,
    {
      id: "email",
      type: "email",
      dir: "ltr",
      placeholder: "me@example.com",
      ...n
    }
  );
}
function tO(t) {
  return /* @__PURE__ */ S($t, { children: [
    /* @__PURE__ */ p("p", { className: "mt-8 mb-7 font-medium", children: t.title }),
    /* @__PURE__ */ S("div", { className: "flex h-80 flex-col items-center justify-center space-y-4 rounded-lg border text-center", children: [
      /* @__PURE__ */ p(gp, { size: 32 }),
      /* @__PURE__ */ S("div", { children: [
        /* @__PURE__ */ p("p", { className: "text-xl font-bold", children: t.subtitle }),
        /* @__PURE__ */ p("p", { className: "", children: t.description })
      ] })
    ] })
  ] });
}
function nO(t) {
  return Array.isArray(t) ? t.reduce(
    (e, n) => e + (n.quantity || 0),
    0
  ) : 0;
}
function rO({
  label: t,
  value: e,
  onChange: n
}) {
  const { t: r } = Ae();
  return /* @__PURE__ */ S($t, { children: [
    t && /* @__PURE__ */ p(wa, { className: "text-muted-foreground text-sm", children: t }),
    e.map((a, o) => /* @__PURE__ */ S(
      "div",
      {
        className: "flex items-start gap-2 rounded-lg border p-3",
        children: [
          /* @__PURE__ */ S("div", { className: "flex-1 space-y-3", children: [
            /* @__PURE__ */ p(
              $a,
              {
                placeholder: r("shared.equipment.placeholder"),
                value: a.name,
                onChange: (l) => {
                  const s = [...e];
                  s[o] = { ...a, name: l.target.value }, n(s);
                }
              }
            ),
            /* @__PURE__ */ p(
              jp,
              {
                label: r("shared.equipment.quantity"),
                value: a.quantity,
                min: 1,
                onChange: (l) => {
                  const s = [...e];
                  s[o] = { ...a, quantity: l }, n(s);
                }
              }
            )
          ] }),
          /* @__PURE__ */ p(
            mt,
            {
              type: "button",
              variant: "ghost",
              size: "icon",
              className: "text-destructive hover:text-destructive/80 shrink-0",
              onClick: () => n(e.filter((l, s) => s !== o)),
              children: /* @__PURE__ */ p(mu, { className: "h-4 w-4" })
            }
          )
        ]
      },
      o
    )),
    /* @__PURE__ */ S(
      mt,
      {
        type: "button",
        variant: "outline",
        size: "sm",
        className: "w-full",
        onClick: () => n([...e, { name: "", quantity: 1 }]),
        children: [
          /* @__PURE__ */ p(pu, { className: "h-4 w-4" }),
          r("shared.equipment.addEquipment")
        ]
      }
    )
  ] });
}
function aO({
  title: t,
  subtitle: e,
  children: n,
  className: r,
  open: a,
  onOpenChange: o
}) {
  return /* @__PURE__ */ S(
    r4,
    {
      onOpenChange: o,
      open: a,
      className: fe(
        "dark:bg-input/30 border-input w-full min-w-0 rounded-md border bg-transparent px-3 text-base transition-[color] outline-none disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
        "focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px]",
        "aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive",
        e ? "data-[state=closed]:h-15" : "data-[state=closed]:h-11",
        r,
        a ? "" : "flex items-center"
      ),
      children: [
        /* @__PURE__ */ p(a4, { className: "!h-auto min-h-full w-full", children: /* @__PURE__ */ S(
          "div",
          {
            className: fe(
              "my-3 flex h-full items-center gap-2 [[data-state=open]]:my-3"
            ),
            children: [
              /* @__PURE__ */ p(
                "div",
                {
                  className: fe(
                    "size-4 rounded-full py-px text-white",
                    a ? "bg-primary" : "border"
                  ),
                  children: a ? /* @__PURE__ */ p(zr, { size: 15 }) : /* @__PURE__ */ p($t, {})
                }
              ),
              /* @__PURE__ */ S("div", { children: [
                /* @__PURE__ */ p(wa, { htmlFor: t, children: t }),
                e && /* @__PURE__ */ p("p", { className: "text-muted-foreground text-xs", children: e })
              ] })
            ]
          }
        ) }),
        /* @__PURE__ */ p(i4, { children: n })
      ]
    }
  );
}
function iO(t) {
  const e = Li(), { t: n } = Ae(), r = t.errors.filter((a) => !!a).map((a) => n(a.message));
  return r.length === 0 ? null : /* @__PURE__ */ p(
    "p",
    {
      "data-slot": "form-message",
      id: e,
      className: fe("text-destructive text-sm", t.className),
      children: r.join(",")
    }
  );
}
function oO(t) {
  const e = Li(), { t: n } = Ae(), r = Array.from(
    new Set(
      t.errors.filter((a) => !!a).flatMap((a) => a.form?.map((o) => n(o.message)) ?? [])
    )
  );
  return r.length === 0 ? null : /* @__PURE__ */ p(
    "ul",
    {
      "data-slot": "form-message",
      id: e,
      className: "text-destructive list-disc ps-5 text-sm",
      children: r.map((a) => /* @__PURE__ */ p("li", { children: a }, a))
    }
  );
}
const cl = {
  "api/record-not-found": "shared.errors.recordNotFound",
  "api/validation-failed": "shared.errors.validationFailed",
  "api/forbidden": "shared.errors.forbidden",
  "offers/request-already-accepted": "shared.errors.offerAlreadyAccepted"
};
function $r(t) {
  return { form: [{ message: t }] };
}
function Wp(t) {
  if (t instanceof fs) {
    const e = t.data;
    if (e.cause.code === "api/validation-failed")
      return {
        form: Object.entries(e.cause.errors).map(([n, r]) => ({
          message: r.map((a) => a.message).join(",")
        }))
      };
    if (e.cause.code === "api/unique-constraint-failed") {
      const n = e.cause.fields || [], r = {};
      for (const a of n)
        r[a] = [
          { message: "shared.validation.valueAlreadyInUse" }
        ];
      return n.length === 0 ? $r("shared.validation.valueAlreadyInUse") : r;
    }
    return $r(cl[e.cause.code] || e.cause.detail);
  }
  if (t instanceof P4) {
    const e = {};
    return t.data.fieldErrors && (Array.isArray(t.data.fieldErrors) ? e.form = t.data.fieldErrors.map((n) => ({
      message: n.message || "shared.validation.fieldValidationError"
    })) : Object.entries(t.data.fieldErrors).forEach(([n, r]) => {
      r && r.length > 0 && (e[n] = r.map((a) => ({
        message: a.message || "shared.validation.fieldValidationError"
      })));
    })), t.data.formErrors && Array.isArray(t.data.formErrors) && t.data.formErrors.length > 0 && (e.form = t.data.formErrors.map((n) => ({
      message: n.message || "shared.validation.formValidationError"
    }))), Object.keys(e).length === 0 ? $r("shared.validation.fieldValidationError") : e;
  }
  return t instanceof Error ? $r(t.message) : $r("shared.validation.unexpectedError");
}
function lO(t) {
  const e = "shared.errors.unexpectedErrorRetry";
  if (t instanceof fs) {
    const n = t.data, r = n.cause?.code;
    if (r && cl[r]) return cl[r];
    if (n.cause?.detail) return n.cause.detail;
    if (n.error) return n.error;
  }
  return t instanceof Error && t.message ? t.message : e;
}
const Gp = () => {
};
const wu = function(t) {
  const e = [];
  let n = 0;
  for (let r = 0; r < t.length; r++) {
    let a = t.charCodeAt(r);
    a < 128 ? e[n++] = a : a < 2048 ? (e[n++] = a >> 6 | 192, e[n++] = a & 63 | 128) : (a & 64512) === 55296 && r + 1 < t.length && (t.charCodeAt(r + 1) & 64512) === 56320 ? (a = 65536 + ((a & 1023) << 10) + (t.charCodeAt(++r) & 1023), e[n++] = a >> 18 | 240, e[n++] = a >> 12 & 63 | 128, e[n++] = a >> 6 & 63 | 128, e[n++] = a & 63 | 128) : (e[n++] = a >> 12 | 224, e[n++] = a >> 6 & 63 | 128, e[n++] = a & 63 | 128);
  }
  return e;
}, Kp = function(t) {
  const e = [];
  let n = 0, r = 0;
  for (; n < t.length; ) {
    const a = t[n++];
    if (a < 128)
      e[r++] = String.fromCharCode(a);
    else if (a > 191 && a < 224) {
      const o = t[n++];
      e[r++] = String.fromCharCode((a & 31) << 6 | o & 63);
    } else if (a > 239 && a < 365) {
      const o = t[n++], l = t[n++], s = t[n++], c = ((a & 7) << 18 | (o & 63) << 12 | (l & 63) << 6 | s & 63) - 65536;
      e[r++] = String.fromCharCode(55296 + (c >> 10)), e[r++] = String.fromCharCode(56320 + (c & 1023));
    } else {
      const o = t[n++], l = t[n++];
      e[r++] = String.fromCharCode((a & 15) << 12 | (o & 63) << 6 | l & 63);
    }
  }
  return e.join("");
}, $u = {
  /**
   * Maps bytes to characters.
   */
  byteToCharMap_: null,
  /**
   * Maps characters to bytes.
   */
  charToByteMap_: null,
  /**
   * Maps bytes to websafe characters.
   * @private
   */
  byteToCharMapWebSafe_: null,
  /**
   * Maps websafe characters to bytes.
   * @private
   */
  charToByteMapWebSafe_: null,
  /**
   * Our default alphabet, shared between
   * ENCODED_VALS and ENCODED_VALS_WEBSAFE
   */
  ENCODED_VALS_BASE: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789",
  /**
   * Our default alphabet. Value 64 (=) is special; it means "nothing."
   */
  get ENCODED_VALS() {
    return this.ENCODED_VALS_BASE + "+/=";
  },
  /**
   * Our websafe alphabet.
   */
  get ENCODED_VALS_WEBSAFE() {
    return this.ENCODED_VALS_BASE + "-_.";
  },
  /**
   * Whether this browser supports the atob and btoa functions. This extension
   * started at Mozilla but is now implemented by many browsers. We use the
   * ASSUME_* variables to avoid pulling in the full useragent detection library
   * but still allowing the standard per-browser compilations.
   *
   */
  HAS_NATIVE_SUPPORT: typeof atob == "function",
  /**
   * Base64-encode an array of bytes.
   *
   * @param input An array of bytes (numbers with
   *     value in [0, 255]) to encode.
   * @param webSafe Boolean indicating we should use the
   *     alternative alphabet.
   * @return The base64 encoded string.
   */
  encodeByteArray(t, e) {
    if (!Array.isArray(t))
      throw Error("encodeByteArray takes an array as a parameter");
    this.init_();
    const n = e ? this.byteToCharMapWebSafe_ : this.byteToCharMap_, r = [];
    for (let a = 0; a < t.length; a += 3) {
      const o = t[a], l = a + 1 < t.length, s = l ? t[a + 1] : 0, c = a + 2 < t.length, d = c ? t[a + 2] : 0, u = o >> 2, f = (o & 3) << 4 | s >> 4;
      let m = (s & 15) << 2 | d >> 6, g = d & 63;
      c || (g = 64, l || (m = 64)), r.push(n[u], n[f], n[m], n[g]);
    }
    return r.join("");
  },
  /**
   * Base64-encode a string.
   *
   * @param input A string to encode.
   * @param webSafe If true, we should use the
   *     alternative alphabet.
   * @return The base64 encoded string.
   */
  encodeString(t, e) {
    return this.HAS_NATIVE_SUPPORT && !e ? btoa(t) : this.encodeByteArray(wu(t), e);
  },
  /**
   * Base64-decode a string.
   *
   * @param input to decode.
   * @param webSafe True if we should use the
   *     alternative alphabet.
   * @return string representing the decoded value.
   */
  decodeString(t, e) {
    return this.HAS_NATIVE_SUPPORT && !e ? atob(t) : Kp(this.decodeStringToByteArray(t, e));
  },
  /**
   * Base64-decode a string.
   *
   * In base-64 decoding, groups of four characters are converted into three
   * bytes.  If the encoder did not apply padding, the input length may not
   * be a multiple of 4.
   *
   * In this case, the last group will have fewer than 4 characters, and
   * padding will be inferred.  If the group has one or two characters, it decodes
   * to one byte.  If the group has three characters, it decodes to two bytes.
   *
   * @param input Input to decode.
   * @param webSafe True if we should use the web-safe alphabet.
   * @return bytes representing the decoded value.
   */
  decodeStringToByteArray(t, e) {
    this.init_();
    const n = e ? this.charToByteMapWebSafe_ : this.charToByteMap_, r = [];
    for (let a = 0; a < t.length; ) {
      const o = n[t.charAt(a++)], s = a < t.length ? n[t.charAt(a)] : 0;
      ++a;
      const d = a < t.length ? n[t.charAt(a)] : 64;
      ++a;
      const f = a < t.length ? n[t.charAt(a)] : 64;
      if (++a, o == null || s == null || d == null || f == null)
        throw new qp();
      const m = o << 2 | s >> 4;
      if (r.push(m), d !== 64) {
        const g = s << 4 & 240 | d >> 2;
        if (r.push(g), f !== 64) {
          const C = d << 6 & 192 | f;
          r.push(C);
        }
      }
    }
    return r;
  },
  /**
   * Lazy static initialization function. Called before
   * accessing any of the static map variables.
   * @private
   */
  init_() {
    if (!this.byteToCharMap_) {
      this.byteToCharMap_ = {}, this.charToByteMap_ = {}, this.byteToCharMapWebSafe_ = {}, this.charToByteMapWebSafe_ = {};
      for (let t = 0; t < this.ENCODED_VALS.length; t++)
        this.byteToCharMap_[t] = this.ENCODED_VALS.charAt(t), this.charToByteMap_[this.byteToCharMap_[t]] = t, this.byteToCharMapWebSafe_[t] = this.ENCODED_VALS_WEBSAFE.charAt(t), this.charToByteMapWebSafe_[this.byteToCharMapWebSafe_[t]] = t, t >= this.ENCODED_VALS_BASE.length && (this.charToByteMap_[this.ENCODED_VALS_WEBSAFE.charAt(t)] = t, this.charToByteMapWebSafe_[this.ENCODED_VALS.charAt(t)] = t);
    }
  }
};
class qp extends Error {
  constructor() {
    super(...arguments), this.name = "DecodeBase64StringError";
  }
}
const Yp = function(t) {
  const e = wu(t);
  return $u.encodeByteArray(e, !0);
}, xu = function(t) {
  return Yp(t).replace(/\./g, "");
}, Cu = function(t) {
  try {
    return $u.decodeString(t, !0);
  } catch (e) {
    console.error("base64Decode failed: ", e);
  }
  return null;
};
function Zp() {
  if (typeof self < "u")
    return self;
  if (typeof window < "u")
    return window;
  if (typeof global < "u")
    return global;
  throw new Error("Unable to locate global object.");
}
const Xp = () => Zp().__FIREBASE_DEFAULTS__, Jp = () => {
  if (typeof process > "u" || typeof process.env > "u")
    return;
  const t = process.env.__FIREBASE_DEFAULTS__;
  if (t)
    return JSON.parse(t);
}, Qp = () => {
  if (typeof document > "u")
    return;
  let t;
  try {
    t = document.cookie.match(/__FIREBASE_DEFAULTS__=([^;]+)/);
  } catch {
    return;
  }
  const e = t && Cu(t[1]);
  return e && JSON.parse(e);
}, Mu = () => {
  try {
    return Gp() || Xp() || Jp() || Qp();
  } catch (t) {
    console.info(`Unable to get __FIREBASE_DEFAULTS__ due to: ${t}`);
    return;
  }
}, em = () => Mu()?.config, tm = (t) => Mu()?.[`_${t}`];
class nm {
  constructor() {
    this.reject = () => {
    }, this.resolve = () => {
    }, this.promise = new Promise((e, n) => {
      this.resolve = e, this.reject = n;
    });
  }
  /**
   * Our API internals are not promisified and cannot because our callback APIs have subtle expectations around
   * invoking promises inline, which Promises are forbidden to do. This method accepts an optional node-style callback
   * and returns a node-style callback which will resolve or reject the Deferred's promise.
   */
  wrapCallback(e) {
    return (n, r) => {
      n ? this.reject(n) : this.resolve(r), typeof e == "function" && (this.promise.catch(() => {
      }), e.length === 1 ? e(n) : e(n, r));
    };
  }
}
function Su(t) {
  try {
    return (t.startsWith("http://") || t.startsWith("https://") ? new URL(t).hostname : t).endsWith(".cloudworkstations.dev");
  } catch {
    return !1;
  }
}
function xt() {
  return typeof navigator < "u" && typeof navigator.userAgent == "string" ? navigator.userAgent : "";
}
function rm() {
  return typeof window < "u" && // @ts-ignore Setting up an broadly applicable index signature for Window
  // just to deal with this case would probably be a bad idea.
  !!(window.cordova || window.phonegap || window.PhoneGap) && /ios|iphone|ipod|ipad|android|blackberry|iemobile/i.test(xt());
}
function am() {
  return typeof navigator < "u" && navigator.userAgent === "Cloudflare-Workers";
}
function im() {
  const t = typeof chrome == "object" ? chrome.runtime : typeof browser == "object" ? browser.runtime : void 0;
  return typeof t == "object" && t.id !== void 0;
}
function om() {
  return typeof navigator == "object" && navigator.product === "ReactNative";
}
function lm() {
  try {
    return typeof indexedDB == "object";
  } catch {
    return !1;
  }
}
function sm() {
  return new Promise((t, e) => {
    try {
      let n = !0;
      const r = "validate-browser-context-for-indexeddb-analytics-module", a = self.indexedDB.open(r);
      a.onsuccess = () => {
        a.result.close(), n || self.indexedDB.deleteDatabase(r), t(!0);
      }, a.onupgradeneeded = () => {
        n = !1;
      }, a.onerror = () => {
        e(a.error?.message || "");
      };
    } catch (n) {
      e(n);
    }
  });
}
const cm = "FirebaseError";
class Ft extends Error {
  constructor(e, n, r) {
    super(n), this.code = e, this.customData = r, this.name = cm, Object.setPrototypeOf(this, Ft.prototype), Error.captureStackTrace && Error.captureStackTrace(this, xa.prototype.create);
  }
}
class xa {
  constructor(e, n, r) {
    this.service = e, this.serviceName = n, this.errors = r;
  }
  create(e, ...n) {
    const r = n[0] || {}, a = `${this.service}/${e}`, o = this.errors[e], l = o ? dm(o, r) : "Error", s = `${this.serviceName}: ${l} (${a}).`;
    return new Ft(a, s, r);
  }
}
function dm(t, e) {
  return t.replace(um, (n, r) => {
    const a = e[r];
    return a != null ? String(a) : `<${r}?>`;
  });
}
const um = /\{\$([^}]+)}/g;
function dl(t, e) {
  if (t === e)
    return !0;
  const n = Object.keys(t), r = Object.keys(e);
  for (const a of n) {
    if (!r.includes(a))
      return !1;
    const o = t[a], l = e[a];
    if (Js(o) && Js(l)) {
      if (!dl(o, l))
        return !1;
    } else if (o !== l)
      return !1;
  }
  for (const a of r)
    if (!n.includes(a))
      return !1;
  return !0;
}
function Js(t) {
  return t !== null && typeof t == "object";
}
function Fu(t) {
  const e = [];
  for (const [n, r] of Object.entries(t))
    Array.isArray(r) ? r.forEach((a) => {
      e.push(encodeURIComponent(n) + "=" + encodeURIComponent(a));
    }) : e.push(encodeURIComponent(n) + "=" + encodeURIComponent(r));
  return e.length ? "&" + e.join("&") : "";
}
function Fr(t) {
  const e = {};
  return t.replace(/^\?/, "").split("&").forEach((r) => {
    if (r) {
      const [a, o] = r.split("=");
      e[decodeURIComponent(a)] = decodeURIComponent(o);
    }
  }), e;
}
function Pr(t) {
  const e = t.indexOf("?");
  if (!e)
    return "";
  const n = t.indexOf("#", e);
  return t.substring(e, n > 0 ? n : void 0);
}
function fm(t, e) {
  const n = new pm(t, e);
  return n.subscribe.bind(n);
}
class pm {
  /**
   * @param executor Function which can make calls to a single Observer
   *     as a proxy.
   * @param onNoObservers Callback when count of Observers goes to zero.
   */
  constructor(e, n) {
    this.observers = [], this.unsubscribes = [], this.observerCount = 0, this.task = Promise.resolve(), this.finalized = !1, this.onNoObservers = n, this.task.then(() => {
      e(this);
    }).catch((r) => {
      this.error(r);
    });
  }
  next(e) {
    this.forEachObserver((n) => {
      n.next(e);
    });
  }
  error(e) {
    this.forEachObserver((n) => {
      n.error(e);
    }), this.close(e);
  }
  complete() {
    this.forEachObserver((e) => {
      e.complete();
    }), this.close();
  }
  /**
   * Subscribe function that can be used to add an Observer to the fan-out list.
   *
   * - We require that no event is sent to a subscriber synchronously to their
   *   call to subscribe().
   */
  subscribe(e, n, r) {
    let a;
    if (e === void 0 && n === void 0 && r === void 0)
      throw new Error("Missing Observer.");
    mm(e, [
      "next",
      "error",
      "complete"
    ]) ? a = e : a = {
      next: e,
      error: n,
      complete: r
    }, a.next === void 0 && (a.next = mo), a.error === void 0 && (a.error = mo), a.complete === void 0 && (a.complete = mo);
    const o = this.unsubscribeOne.bind(this, this.observers.length);
    return this.finalized && this.task.then(() => {
      try {
        this.finalError ? a.error(this.finalError) : a.complete();
      } catch {
      }
    }), this.observers.push(a), o;
  }
  // Unsubscribe is synchronous - we guarantee that no events are sent to
  // any unsubscribed Observer.
  unsubscribeOne(e) {
    this.observers === void 0 || this.observers[e] === void 0 || (delete this.observers[e], this.observerCount -= 1, this.observerCount === 0 && this.onNoObservers !== void 0 && this.onNoObservers(this));
  }
  forEachObserver(e) {
    if (!this.finalized)
      for (let n = 0; n < this.observers.length; n++)
        this.sendOne(n, e);
  }
  // Call the Observer via one of it's callback function. We are careful to
  // confirm that the observe has not been unsubscribed since this asynchronous
  // function had been queued.
  sendOne(e, n) {
    this.task.then(() => {
      if (this.observers !== void 0 && this.observers[e] !== void 0)
        try {
          n(this.observers[e]);
        } catch (r) {
          typeof console < "u" && console.error && console.error(r);
        }
    });
  }
  close(e) {
    this.finalized || (this.finalized = !0, e !== void 0 && (this.finalError = e), this.task.then(() => {
      this.observers = void 0, this.onNoObservers = void 0;
    }));
  }
}
function mm(t, e) {
  if (typeof t != "object" || t === null)
    return !1;
  for (const n of e)
    if (n in t && typeof t[n] == "function")
      return !0;
  return !1;
}
function mo() {
}
function Ut(t) {
  return t && t._delegate ? t._delegate : t;
}
class sr {
  /**
   *
   * @param name The public service name, e.g. app, auth, firestore, database
   * @param instanceFactory Service factory responsible for creating the public interface
   * @param type whether the service provided by the component is public or private
   */
  constructor(e, n, r) {
    this.name = e, this.instanceFactory = n, this.type = r, this.multipleInstances = !1, this.serviceProps = {}, this.instantiationMode = "LAZY", this.onInstanceCreated = null;
  }
  setInstantiationMode(e) {
    return this.instantiationMode = e, this;
  }
  setMultipleInstances(e) {
    return this.multipleInstances = e, this;
  }
  setServiceProps(e) {
    return this.serviceProps = e, this;
  }
  setInstanceCreatedCallback(e) {
    return this.onInstanceCreated = e, this;
  }
}
const mn = "[DEFAULT]";
class hm {
  constructor(e, n) {
    this.name = e, this.container = n, this.component = null, this.instances = /* @__PURE__ */ new Map(), this.instancesDeferred = /* @__PURE__ */ new Map(), this.instancesOptions = /* @__PURE__ */ new Map(), this.onInitCallbacks = /* @__PURE__ */ new Map();
  }
  /**
   * @param identifier A provider can provide multiple instances of a service
   * if this.component.multipleInstances is true.
   */
  get(e) {
    const n = this.normalizeInstanceIdentifier(e);
    if (!this.instancesDeferred.has(n)) {
      const r = new nm();
      if (this.instancesDeferred.set(n, r), this.isInitialized(n) || this.shouldAutoInitialize())
        try {
          const a = this.getOrInitializeService({
            instanceIdentifier: n
          });
          a && r.resolve(a);
        } catch {
        }
    }
    return this.instancesDeferred.get(n).promise;
  }
  getImmediate(e) {
    const n = this.normalizeInstanceIdentifier(e?.identifier), r = e?.optional ?? !1;
    if (this.isInitialized(n) || this.shouldAutoInitialize())
      try {
        return this.getOrInitializeService({
          instanceIdentifier: n
        });
      } catch (a) {
        if (r)
          return null;
        throw a;
      }
    else {
      if (r)
        return null;
      throw Error(`Service ${this.name} is not available`);
    }
  }
  getComponent() {
    return this.component;
  }
  setComponent(e) {
    if (e.name !== this.name)
      throw Error(`Mismatching Component ${e.name} for Provider ${this.name}.`);
    if (this.component)
      throw Error(`Component for ${this.name} has already been provided`);
    if (this.component = e, !!this.shouldAutoInitialize()) {
      if (gm(e))
        try {
          this.getOrInitializeService({ instanceIdentifier: mn });
        } catch {
        }
      for (const [n, r] of this.instancesDeferred.entries()) {
        const a = this.normalizeInstanceIdentifier(n);
        try {
          const o = this.getOrInitializeService({
            instanceIdentifier: a
          });
          r.resolve(o);
        } catch {
        }
      }
    }
  }
  clearInstance(e = mn) {
    this.instancesDeferred.delete(e), this.instancesOptions.delete(e), this.instances.delete(e);
  }
  // app.delete() will call this method on every provider to delete the services
  // TODO: should we mark the provider as deleted?
  async delete() {
    const e = Array.from(this.instances.values());
    await Promise.all([
      ...e.filter((n) => "INTERNAL" in n).map((n) => n.INTERNAL.delete()),
      ...e.filter((n) => "_delete" in n).map((n) => n._delete())
    ]);
  }
  isComponentSet() {
    return this.component != null;
  }
  isInitialized(e = mn) {
    return this.instances.has(e);
  }
  getOptions(e = mn) {
    return this.instancesOptions.get(e) || {};
  }
  initialize(e = {}) {
    const { options: n = {} } = e, r = this.normalizeInstanceIdentifier(e.instanceIdentifier);
    if (this.isInitialized(r))
      throw Error(`${this.name}(${r}) has already been initialized`);
    if (!this.isComponentSet())
      throw Error(`Component ${this.name} has not been registered yet`);
    const a = this.getOrInitializeService({
      instanceIdentifier: r,
      options: n
    });
    for (const [o, l] of this.instancesDeferred.entries()) {
      const s = this.normalizeInstanceIdentifier(o);
      r === s && l.resolve(a);
    }
    return a;
  }
  /**
   *
   * @param callback - a function that will be invoked  after the provider has been initialized by calling provider.initialize().
   * The function is invoked SYNCHRONOUSLY, so it should not execute any longrunning tasks in order to not block the program.
   *
   * @param identifier An optional instance identifier
   * @returns a function to unregister the callback
   */
  onInit(e, n) {
    const r = this.normalizeInstanceIdentifier(n), a = this.onInitCallbacks.get(r) ?? /* @__PURE__ */ new Set();
    a.add(e), this.onInitCallbacks.set(r, a);
    const o = this.instances.get(r);
    return o && e(o, r), () => {
      a.delete(e);
    };
  }
  /**
   * Invoke onInit callbacks synchronously
   * @param instance the service instance`
   */
  invokeOnInitCallbacks(e, n) {
    const r = this.onInitCallbacks.get(n);
    if (r)
      for (const a of r)
        try {
          a(e, n);
        } catch {
        }
  }
  getOrInitializeService({ instanceIdentifier: e, options: n = {} }) {
    let r = this.instances.get(e);
    if (!r && this.component && (r = this.component.instanceFactory(this.container, {
      instanceIdentifier: vm(e),
      options: n
    }), this.instances.set(e, r), this.instancesOptions.set(e, n), this.invokeOnInitCallbacks(r, e), this.component.onInstanceCreated))
      try {
        this.component.onInstanceCreated(this.container, e, r);
      } catch {
      }
    return r || null;
  }
  normalizeInstanceIdentifier(e = mn) {
    return this.component ? this.component.multipleInstances ? e : mn : e;
  }
  shouldAutoInitialize() {
    return !!this.component && this.component.instantiationMode !== "EXPLICIT";
  }
}
function vm(t) {
  return t === mn ? void 0 : t;
}
function gm(t) {
  return t.instantiationMode === "EAGER";
}
class ym {
  constructor(e) {
    this.name = e, this.providers = /* @__PURE__ */ new Map();
  }
  /**
   *
   * @param component Component being added
   * @param overwrite When a component with the same name has already been registered,
   * if overwrite is true: overwrite the existing component with the new component and create a new
   * provider with the new component. It can be useful in tests where you want to use different mocks
   * for different tests.
   * if overwrite is false: throw an exception
   */
  addComponent(e) {
    const n = this.getProvider(e.name);
    if (n.isComponentSet())
      throw new Error(`Component ${e.name} has already been registered with ${this.name}`);
    n.setComponent(e);
  }
  addOrOverwriteComponent(e) {
    this.getProvider(e.name).isComponentSet() && this.providers.delete(e.name), this.addComponent(e);
  }
  /**
   * getProvider provides a type safe interface where it can only be called with a field name
   * present in NameServiceMapping interface.
   *
   * Firebase SDKs providing services should extend NameServiceMapping interface to register
   * themselves.
   */
  getProvider(e) {
    if (this.providers.has(e))
      return this.providers.get(e);
    const n = new hm(e, this);
    return this.providers.set(e, n), n;
  }
  getProviders() {
    return Array.from(this.providers.values());
  }
}
var Ne;
(function(t) {
  t[t.DEBUG = 0] = "DEBUG", t[t.VERBOSE = 1] = "VERBOSE", t[t.INFO = 2] = "INFO", t[t.WARN = 3] = "WARN", t[t.ERROR = 4] = "ERROR", t[t.SILENT = 5] = "SILENT";
})(Ne || (Ne = {}));
const bm = {
  debug: Ne.DEBUG,
  verbose: Ne.VERBOSE,
  info: Ne.INFO,
  warn: Ne.WARN,
  error: Ne.ERROR,
  silent: Ne.SILENT
}, Em = Ne.INFO, wm = {
  [Ne.DEBUG]: "log",
  [Ne.VERBOSE]: "log",
  [Ne.INFO]: "info",
  [Ne.WARN]: "warn",
  [Ne.ERROR]: "error"
}, $m = (t, e, ...n) => {
  if (e < t.logLevel)
    return;
  const r = (/* @__PURE__ */ new Date()).toISOString(), a = wm[e];
  if (a)
    console[a](`[${r}]  ${t.name}:`, ...n);
  else
    throw new Error(`Attempted to log a message with an invalid logType (value: ${e})`);
};
class Pu {
  /**
   * Gives you an instance of a Logger to capture messages according to
   * Firebase's logging scheme.
   *
   * @param name The name that the logs will be associated with
   */
  constructor(e) {
    this.name = e, this._logLevel = Em, this._logHandler = $m, this._userLogHandler = null;
  }
  get logLevel() {
    return this._logLevel;
  }
  set logLevel(e) {
    if (!(e in Ne))
      throw new TypeError(`Invalid value "${e}" assigned to \`logLevel\``);
    this._logLevel = e;
  }
  // Workaround for setter/getter having to be the same type.
  setLogLevel(e) {
    this._logLevel = typeof e == "string" ? bm[e] : e;
  }
  get logHandler() {
    return this._logHandler;
  }
  set logHandler(e) {
    if (typeof e != "function")
      throw new TypeError("Value assigned to `logHandler` must be a function");
    this._logHandler = e;
  }
  get userLogHandler() {
    return this._userLogHandler;
  }
  set userLogHandler(e) {
    this._userLogHandler = e;
  }
  /**
   * The functions below are all based on the `console` interface
   */
  debug(...e) {
    this._userLogHandler && this._userLogHandler(this, Ne.DEBUG, ...e), this._logHandler(this, Ne.DEBUG, ...e);
  }
  log(...e) {
    this._userLogHandler && this._userLogHandler(this, Ne.VERBOSE, ...e), this._logHandler(this, Ne.VERBOSE, ...e);
  }
  info(...e) {
    this._userLogHandler && this._userLogHandler(this, Ne.INFO, ...e), this._logHandler(this, Ne.INFO, ...e);
  }
  warn(...e) {
    this._userLogHandler && this._userLogHandler(this, Ne.WARN, ...e), this._logHandler(this, Ne.WARN, ...e);
  }
  error(...e) {
    this._userLogHandler && this._userLogHandler(this, Ne.ERROR, ...e), this._logHandler(this, Ne.ERROR, ...e);
  }
}
const xm = (t, e) => e.some((n) => t instanceof n);
let Qs, ec;
function Cm() {
  return Qs || (Qs = [
    IDBDatabase,
    IDBObjectStore,
    IDBIndex,
    IDBCursor,
    IDBTransaction
  ]);
}
function Mm() {
  return ec || (ec = [
    IDBCursor.prototype.advance,
    IDBCursor.prototype.continue,
    IDBCursor.prototype.continuePrimaryKey
  ]);
}
const Nu = /* @__PURE__ */ new WeakMap(), ul = /* @__PURE__ */ new WeakMap(), _u = /* @__PURE__ */ new WeakMap(), ho = /* @__PURE__ */ new WeakMap(), ms = /* @__PURE__ */ new WeakMap();
function Sm(t) {
  const e = new Promise((n, r) => {
    const a = () => {
      t.removeEventListener("success", o), t.removeEventListener("error", l);
    }, o = () => {
      n(en(t.result)), a();
    }, l = () => {
      r(t.error), a();
    };
    t.addEventListener("success", o), t.addEventListener("error", l);
  });
  return e.then((n) => {
    n instanceof IDBCursor && Nu.set(n, t);
  }).catch(() => {
  }), ms.set(e, t), e;
}
function Fm(t) {
  if (ul.has(t))
    return;
  const e = new Promise((n, r) => {
    const a = () => {
      t.removeEventListener("complete", o), t.removeEventListener("error", l), t.removeEventListener("abort", l);
    }, o = () => {
      n(), a();
    }, l = () => {
      r(t.error || new DOMException("AbortError", "AbortError")), a();
    };
    t.addEventListener("complete", o), t.addEventListener("error", l), t.addEventListener("abort", l);
  });
  ul.set(t, e);
}
let fl = {
  get(t, e, n) {
    if (t instanceof IDBTransaction) {
      if (e === "done")
        return ul.get(t);
      if (e === "objectStoreNames")
        return t.objectStoreNames || _u.get(t);
      if (e === "store")
        return n.objectStoreNames[1] ? void 0 : n.objectStore(n.objectStoreNames[0]);
    }
    return en(t[e]);
  },
  set(t, e, n) {
    return t[e] = n, !0;
  },
  has(t, e) {
    return t instanceof IDBTransaction && (e === "done" || e === "store") ? !0 : e in t;
  }
};
function Pm(t) {
  fl = t(fl);
}
function Nm(t) {
  return t === IDBDatabase.prototype.transaction && !("objectStoreNames" in IDBTransaction.prototype) ? function(e, ...n) {
    const r = t.call(vo(this), e, ...n);
    return _u.set(r, e.sort ? e.sort() : [e]), en(r);
  } : Mm().includes(t) ? function(...e) {
    return t.apply(vo(this), e), en(Nu.get(this));
  } : function(...e) {
    return en(t.apply(vo(this), e));
  };
}
function _m(t) {
  return typeof t == "function" ? Nm(t) : (t instanceof IDBTransaction && Fm(t), xm(t, Cm()) ? new Proxy(t, fl) : t);
}
function en(t) {
  if (t instanceof IDBRequest)
    return Sm(t);
  if (ho.has(t))
    return ho.get(t);
  const e = _m(t);
  return e !== t && (ho.set(t, e), ms.set(e, t)), e;
}
const vo = (t) => ms.get(t);
function Tm(t, e, { blocked: n, upgrade: r, blocking: a, terminated: o } = {}) {
  const l = indexedDB.open(t, e), s = en(l);
  return r && l.addEventListener("upgradeneeded", (c) => {
    r(en(l.result), c.oldVersion, c.newVersion, en(l.transaction), c);
  }), n && l.addEventListener("blocked", (c) => n(
    // Casting due to https://github.com/microsoft/TypeScript-DOM-lib-generator/pull/1405
    c.oldVersion,
    c.newVersion,
    c
  )), s.then((c) => {
    o && c.addEventListener("close", () => o()), a && c.addEventListener("versionchange", (d) => a(d.oldVersion, d.newVersion, d));
  }).catch(() => {
  }), s;
}
const Am = ["get", "getKey", "getAll", "getAllKeys", "count"], zm = ["put", "add", "delete", "clear"], go = /* @__PURE__ */ new Map();
function tc(t, e) {
  if (!(t instanceof IDBDatabase && !(e in t) && typeof e == "string"))
    return;
  if (go.get(e))
    return go.get(e);
  const n = e.replace(/FromIndex$/, ""), r = e !== n, a = zm.includes(n);
  if (
    // Bail if the target doesn't exist on the target. Eg, getAll isn't in Edge.
    !(n in (r ? IDBIndex : IDBObjectStore).prototype) || !(a || Am.includes(n))
  )
    return;
  const o = async function(l, ...s) {
    const c = this.transaction(l, a ? "readwrite" : "readonly");
    let d = c.store;
    return r && (d = d.index(s.shift())), (await Promise.all([
      d[n](...s),
      a && c.done
    ]))[0];
  };
  return go.set(e, o), o;
}
Pm((t) => ({
  ...t,
  get: (e, n, r) => tc(e, n) || t.get(e, n, r),
  has: (e, n) => !!tc(e, n) || t.has(e, n)
}));
class Dm {
  constructor(e) {
    this.container = e;
  }
  // In initial implementation, this will be called by installations on
  // auth token refresh, and installations will send this string.
  getPlatformInfoString() {
    return this.container.getProviders().map((n) => {
      if (Im(n)) {
        const r = n.getImmediate();
        return `${r.library}/${r.version}`;
      } else
        return null;
    }).filter((n) => n).join(" ");
  }
}
function Im(t) {
  return t.getComponent()?.type === "VERSION";
}
const pl = "@firebase/app", nc = "0.14.2";
const Ht = new Pu("@firebase/app"), km = "@firebase/app-compat", Om = "@firebase/analytics-compat", Lm = "@firebase/analytics", Rm = "@firebase/app-check-compat", Hm = "@firebase/app-check", Bm = "@firebase/auth", jm = "@firebase/auth-compat", Vm = "@firebase/database", Um = "@firebase/data-connect", Wm = "@firebase/database-compat", Gm = "@firebase/functions", Km = "@firebase/functions-compat", qm = "@firebase/installations", Ym = "@firebase/installations-compat", Zm = "@firebase/messaging", Xm = "@firebase/messaging-compat", Jm = "@firebase/performance", Qm = "@firebase/performance-compat", eh = "@firebase/remote-config", th = "@firebase/remote-config-compat", nh = "@firebase/storage", rh = "@firebase/storage-compat", ah = "@firebase/firestore", ih = "@firebase/ai", oh = "@firebase/firestore-compat", lh = "firebase", sh = "12.2.0";
const ch = "[DEFAULT]", dh = {
  [pl]: "fire-core",
  [km]: "fire-core-compat",
  [Lm]: "fire-analytics",
  [Om]: "fire-analytics-compat",
  [Hm]: "fire-app-check",
  [Rm]: "fire-app-check-compat",
  [Bm]: "fire-auth",
  [jm]: "fire-auth-compat",
  [Vm]: "fire-rtdb",
  [Um]: "fire-data-connect",
  [Wm]: "fire-rtdb-compat",
  [Gm]: "fire-fn",
  [Km]: "fire-fn-compat",
  [qm]: "fire-iid",
  [Ym]: "fire-iid-compat",
  [Zm]: "fire-fcm",
  [Xm]: "fire-fcm-compat",
  [Jm]: "fire-perf",
  [Qm]: "fire-perf-compat",
  [eh]: "fire-rc",
  [th]: "fire-rc-compat",
  [nh]: "fire-gcs",
  [rh]: "fire-gcs-compat",
  [ah]: "fire-fst",
  [oh]: "fire-fst-compat",
  [ih]: "fire-vertex",
  "fire-js": "fire-js",
  // Platform identifier for JS SDK.
  [lh]: "fire-js-all"
};
const ml = /* @__PURE__ */ new Map(), uh = /* @__PURE__ */ new Map(), hl = /* @__PURE__ */ new Map();
function rc(t, e) {
  try {
    t.container.addComponent(e);
  } catch (n) {
    Ht.debug(`Component ${e.name} failed to register with FirebaseApp ${t.name}`, n);
  }
}
function Or(t) {
  const e = t.name;
  if (hl.has(e))
    return Ht.debug(`There were multiple attempts to register component ${e}.`), !1;
  hl.set(e, t);
  for (const n of ml.values())
    rc(n, t);
  for (const n of uh.values())
    rc(n, t);
  return !0;
}
function It(t) {
  return t == null ? !1 : t.settings !== void 0;
}
const fh = {
  "no-app": "No Firebase App '{$appName}' has been created - call initializeApp() first",
  "bad-app-name": "Illegal App name: '{$appName}'",
  "duplicate-app": "Firebase App named '{$appName}' already exists with different options or config",
  "app-deleted": "Firebase App named '{$appName}' already deleted",
  "server-app-deleted": "Firebase Server App has been deleted",
  "no-options": "Need to provide options, when not being deployed to hosting via source.",
  "invalid-app-argument": "firebase.{$appName}() takes either no argument or a Firebase App instance.",
  "invalid-log-argument": "First argument to `onLog` must be null or a function.",
  "idb-open": "Error thrown when opening IndexedDB. Original error: {$originalErrorMessage}.",
  "idb-get": "Error thrown when reading from IndexedDB. Original error: {$originalErrorMessage}.",
  "idb-set": "Error thrown when writing to IndexedDB. Original error: {$originalErrorMessage}.",
  "idb-delete": "Error thrown when deleting from IndexedDB. Original error: {$originalErrorMessage}.",
  "finalization-registry-not-supported": "FirebaseServerApp deleteOnDeref field defined but the JS runtime does not support FinalizationRegistry.",
  "invalid-server-app-environment": "FirebaseServerApp is not for use in browser environments."
}, yn = new xa("app", "Firebase", fh);
class ph {
  constructor(e, n, r) {
    this._isDeleted = !1, this._options = { ...e }, this._config = { ...n }, this._name = n.name, this._automaticDataCollectionEnabled = n.automaticDataCollectionEnabled, this._container = r, this.container.addComponent(new sr(
      "app",
      () => this,
      "PUBLIC"
      /* ComponentType.PUBLIC */
    ));
  }
  get automaticDataCollectionEnabled() {
    return this.checkDestroyed(), this._automaticDataCollectionEnabled;
  }
  set automaticDataCollectionEnabled(e) {
    this.checkDestroyed(), this._automaticDataCollectionEnabled = e;
  }
  get name() {
    return this.checkDestroyed(), this._name;
  }
  get options() {
    return this.checkDestroyed(), this._options;
  }
  get config() {
    return this.checkDestroyed(), this._config;
  }
  get container() {
    return this._container;
  }
  get isDeleted() {
    return this._isDeleted;
  }
  set isDeleted(e) {
    this._isDeleted = e;
  }
  /**
   * This function will throw an Error if the App has already been deleted -
   * use before performing API actions on the App.
   */
  checkDestroyed() {
    if (this.isDeleted)
      throw yn.create("app-deleted", { appName: this._name });
  }
}
const hs = sh;
function mh(t, e = {}) {
  let n = t;
  typeof e != "object" && (e = { name: e });
  const r = {
    name: ch,
    automaticDataCollectionEnabled: !0,
    ...e
  }, a = r.name;
  if (typeof a != "string" || !a)
    throw yn.create("bad-app-name", {
      appName: String(a)
    });
  if (n || (n = em()), !n)
    throw yn.create(
      "no-options"
      /* AppError.NO_OPTIONS */
    );
  const o = ml.get(a);
  if (o) {
    if (dl(n, o.options) && dl(r, o.config))
      return o;
    throw yn.create("duplicate-app", { appName: a });
  }
  const l = new ym(a);
  for (const c of hl.values())
    l.addComponent(c);
  const s = new ph(n, r, l);
  return ml.set(a, s), s;
}
function Jn(t, e, n) {
  let r = dh[t] ?? t;
  n && (r += `-${n}`);
  const a = r.match(/\s|\//), o = e.match(/\s|\//);
  if (a || o) {
    const l = [
      `Unable to register library "${r}" with version "${e}":`
    ];
    a && l.push(`library name "${r}" contains illegal characters (whitespace or "/")`), a && o && l.push("and"), o && l.push(`version name "${e}" contains illegal characters (whitespace or "/")`), Ht.warn(l.join(" "));
    return;
  }
  Or(new sr(
    `${r}-version`,
    () => ({ library: r, version: e }),
    "VERSION"
    /* ComponentType.VERSION */
  ));
}
const hh = "firebase-heartbeat-database", vh = 1, Lr = "firebase-heartbeat-store";
let yo = null;
function Tu() {
  return yo || (yo = Tm(hh, vh, {
    upgrade: (t, e) => {
      switch (e) {
        case 0:
          try {
            t.createObjectStore(Lr);
          } catch (n) {
            console.warn(n);
          }
      }
    }
  }).catch((t) => {
    throw yn.create("idb-open", {
      originalErrorMessage: t.message
    });
  })), yo;
}
async function gh(t) {
  try {
    const n = (await Tu()).transaction(Lr), r = await n.objectStore(Lr).get(Au(t));
    return await n.done, r;
  } catch (e) {
    if (e instanceof Ft)
      Ht.warn(e.message);
    else {
      const n = yn.create("idb-get", {
        originalErrorMessage: e?.message
      });
      Ht.warn(n.message);
    }
  }
}
async function ac(t, e) {
  try {
    const r = (await Tu()).transaction(Lr, "readwrite");
    await r.objectStore(Lr).put(e, Au(t)), await r.done;
  } catch (n) {
    if (n instanceof Ft)
      Ht.warn(n.message);
    else {
      const r = yn.create("idb-set", {
        originalErrorMessage: n?.message
      });
      Ht.warn(r.message);
    }
  }
}
function Au(t) {
  return `${t.name}!${t.options.appId}`;
}
const yh = 1024, bh = 30;
class Eh {
  constructor(e) {
    this.container = e, this._heartbeatsCache = null;
    const n = this.container.getProvider("app").getImmediate();
    this._storage = new $h(n), this._heartbeatsCachePromise = this._storage.read().then((r) => (this._heartbeatsCache = r, r));
  }
  /**
   * Called to report a heartbeat. The function will generate
   * a HeartbeatsByUserAgent object, update heartbeatsCache, and persist it
   * to IndexedDB.
   * Note that we only store one heartbeat per day. So if a heartbeat for today is
   * already logged, subsequent calls to this function in the same day will be ignored.
   */
  async triggerHeartbeat() {
    try {
      const n = this.container.getProvider("platform-logger").getImmediate().getPlatformInfoString(), r = ic();
      if (this._heartbeatsCache?.heartbeats == null && (this._heartbeatsCache = await this._heartbeatsCachePromise, this._heartbeatsCache?.heartbeats == null) || this._heartbeatsCache.lastSentHeartbeatDate === r || this._heartbeatsCache.heartbeats.some((a) => a.date === r))
        return;
      if (this._heartbeatsCache.heartbeats.push({ date: r, agent: n }), this._heartbeatsCache.heartbeats.length > bh) {
        const a = xh(this._heartbeatsCache.heartbeats);
        this._heartbeatsCache.heartbeats.splice(a, 1);
      }
      return this._storage.overwrite(this._heartbeatsCache);
    } catch (e) {
      Ht.warn(e);
    }
  }
  /**
   * Returns a base64 encoded string which can be attached to the heartbeat-specific header directly.
   * It also clears all heartbeats from memory as well as in IndexedDB.
   *
   * NOTE: Consuming product SDKs should not send the header if this method
   * returns an empty string.
   */
  async getHeartbeatsHeader() {
    try {
      if (this._heartbeatsCache === null && await this._heartbeatsCachePromise, this._heartbeatsCache?.heartbeats == null || this._heartbeatsCache.heartbeats.length === 0)
        return "";
      const e = ic(), { heartbeatsToSend: n, unsentEntries: r } = wh(this._heartbeatsCache.heartbeats), a = xu(JSON.stringify({ version: 2, heartbeats: n }));
      return this._heartbeatsCache.lastSentHeartbeatDate = e, r.length > 0 ? (this._heartbeatsCache.heartbeats = r, await this._storage.overwrite(this._heartbeatsCache)) : (this._heartbeatsCache.heartbeats = [], this._storage.overwrite(this._heartbeatsCache)), a;
    } catch (e) {
      return Ht.warn(e), "";
    }
  }
}
function ic() {
  return (/* @__PURE__ */ new Date()).toISOString().substring(0, 10);
}
function wh(t, e = yh) {
  const n = [];
  let r = t.slice();
  for (const a of t) {
    const o = n.find((l) => l.agent === a.agent);
    if (o) {
      if (o.dates.push(a.date), oc(n) > e) {
        o.dates.pop();
        break;
      }
    } else if (n.push({
      agent: a.agent,
      dates: [a.date]
    }), oc(n) > e) {
      n.pop();
      break;
    }
    r = r.slice(1);
  }
  return {
    heartbeatsToSend: n,
    unsentEntries: r
  };
}
class $h {
  constructor(e) {
    this.app = e, this._canUseIndexedDBPromise = this.runIndexedDBEnvironmentCheck();
  }
  async runIndexedDBEnvironmentCheck() {
    return lm() ? sm().then(() => !0).catch(() => !1) : !1;
  }
  /**
   * Read all heartbeats.
   */
  async read() {
    if (await this._canUseIndexedDBPromise) {
      const n = await gh(this.app);
      return n?.heartbeats ? n : { heartbeats: [] };
    } else
      return { heartbeats: [] };
  }
  // overwrite the storage with the provided heartbeats
  async overwrite(e) {
    if (await this._canUseIndexedDBPromise) {
      const r = await this.read();
      return ac(this.app, {
        lastSentHeartbeatDate: e.lastSentHeartbeatDate ?? r.lastSentHeartbeatDate,
        heartbeats: e.heartbeats
      });
    } else
      return;
  }
  // add heartbeats
  async add(e) {
    if (await this._canUseIndexedDBPromise) {
      const r = await this.read();
      return ac(this.app, {
        lastSentHeartbeatDate: e.lastSentHeartbeatDate ?? r.lastSentHeartbeatDate,
        heartbeats: [
          ...r.heartbeats,
          ...e.heartbeats
        ]
      });
    } else
      return;
  }
}
function oc(t) {
  return xu(
    // heartbeatsCache wrapper properties
    JSON.stringify({ version: 2, heartbeats: t })
  ).length;
}
function xh(t) {
  if (t.length === 0)
    return -1;
  let e = 0, n = t[0].date;
  for (let r = 1; r < t.length; r++)
    t[r].date < n && (n = t[r].date, e = r);
  return e;
}
function Ch(t) {
  Or(new sr(
    "platform-logger",
    (e) => new Dm(e),
    "PRIVATE"
    /* ComponentType.PRIVATE */
  )), Or(new sr(
    "heartbeat",
    (e) => new Eh(e),
    "PRIVATE"
    /* ComponentType.PRIVATE */
  )), Jn(pl, nc, t), Jn(pl, nc, "esm2020"), Jn("fire-js", "");
}
Ch("");
var Mh = "firebase", Sh = "12.2.1";
Jn(Mh, Sh, "app");
function zu() {
  return {
    "dependent-sdk-initialized-before-auth": "Another Firebase SDK was initialized and is trying to use Auth before Auth is initialized. Please be sure to call `initializeAuth` or `getAuth` before starting any other Firebase SDK."
  };
}
const Fh = zu, Du = new xa("auth", "Firebase", zu()), tt = {
  EMAIL_EXISTS: "auth/email-already-in-use",
  INVALID_EMAIL: "auth/invalid-email",
  INVALID_IDP_RESPONSE: "auth/invalid-credential",
  INVALID_LOGIN_CREDENTIALS: "auth/invalid-credential",
  INVALID_PASSWORD: "auth/wrong-password",
  NETWORK_REQUEST_FAILED: "auth/network-request-failed",
  OPERATION_NOT_ALLOWED: "auth/operation-not-allowed",
  TOO_MANY_ATTEMPTS_TRY_LATER: "auth/too-many-requests",
  USER_DELETED: "auth/user-not-found",
  USER_DISABLED: "auth/user-disabled",
  WEAK_PASSWORD: "auth/weak-password"
};
const ii = new Pu("@firebase/auth");
function Ph(t, ...e) {
  ii.logLevel <= Ne.WARN && ii.warn(`Auth (${hs}): ${t}`, ...e);
}
function Ja(t, ...e) {
  ii.logLevel <= Ne.ERROR && ii.error(`Auth (${hs}): ${t}`, ...e);
}
function Rr(t, ...e) {
  throw gs(t, ...e);
}
function vs(t, ...e) {
  return gs(t, ...e);
}
function Iu(t, e, n) {
  const r = {
    ...Fh(),
    [e]: n
  };
  return new xa("auth", "Firebase", r).create(e, {
    appName: t.name
  });
}
function bn(t) {
  return Iu(t, "operation-not-supported-in-this-environment", "Operations that alter the current user are not supported in conjunction with FirebaseServerApp");
}
function gs(t, ...e) {
  if (typeof t != "string") {
    const n = e[0], r = [...e.slice(1)];
    return r[0] && (r[0].appName = t.name), t._errorFactory.create(n, ...r);
  }
  return Du.create(t, ...e);
}
function Ee(t, e, ...n) {
  if (!t)
    throw gs(e, ...n);
}
function kt(t) {
  const e = "INTERNAL ASSERTION FAILED: " + t;
  throw Ja(e), new Error(e);
}
function oi(t, e) {
  t || kt(e);
}
function Nh() {
  return lc() === "http:" || lc() === "https:";
}
function lc() {
  return typeof self < "u" && self.location?.protocol || null;
}
function _h() {
  return typeof navigator < "u" && navigator && "onLine" in navigator && typeof navigator.onLine == "boolean" && // Apply only for traditional web apps and Chrome extensions.
  // This is especially true for Cordova apps which have unreliable
  // navigator.onLine behavior unless cordova-plugin-network-information is
  // installed which overwrites the native navigator.onLine value and
  // defines navigator.connection.
  (Nh() || im() || "connection" in navigator) ? navigator.onLine : !0;
}
function Th() {
  if (typeof navigator > "u")
    return null;
  const t = navigator;
  return (
    // Most reliable, but only supported in Chrome/Firefox.
    t.languages && t.languages[0] || // Supported in most browsers, but returns the language of the browser
    // UI, not the language set in browser settings.
    t.language || // Couldn't determine language.
    null
  );
}
class Ca {
  constructor(e, n) {
    this.shortDelay = e, this.longDelay = n, oi(n > e, "Short delay should be less than long delay!"), this.isMobile = rm() || om();
  }
  get() {
    return _h() ? this.isMobile ? this.longDelay : this.shortDelay : Math.min(5e3, this.shortDelay);
  }
}
function Ah(t, e) {
  oi(t.emulator, "Emulator should always be set here");
  const { url: n } = t.emulator;
  return e ? `${n}${e.startsWith("/") ? e.slice(1) : e}` : n;
}
class ku {
  static initialize(e, n, r) {
    this.fetchImpl = e, n && (this.headersImpl = n), r && (this.responseImpl = r);
  }
  static fetch() {
    if (this.fetchImpl)
      return this.fetchImpl;
    if (typeof self < "u" && "fetch" in self)
      return self.fetch;
    if (typeof globalThis < "u" && globalThis.fetch)
      return globalThis.fetch;
    if (typeof fetch < "u")
      return fetch;
    kt("Could not find fetch implementation, make sure you call FetchProvider.initialize() with an appropriate polyfill");
  }
  static headers() {
    if (this.headersImpl)
      return this.headersImpl;
    if (typeof self < "u" && "Headers" in self)
      return self.Headers;
    if (typeof globalThis < "u" && globalThis.Headers)
      return globalThis.Headers;
    if (typeof Headers < "u")
      return Headers;
    kt("Could not find Headers implementation, make sure you call FetchProvider.initialize() with an appropriate polyfill");
  }
  static response() {
    if (this.responseImpl)
      return this.responseImpl;
    if (typeof self < "u" && "Response" in self)
      return self.Response;
    if (typeof globalThis < "u" && globalThis.Response)
      return globalThis.Response;
    if (typeof Response < "u")
      return Response;
    kt("Could not find Response implementation, make sure you call FetchProvider.initialize() with an appropriate polyfill");
  }
}
const zh = {
  // Custom token errors.
  CREDENTIAL_MISMATCH: "custom-token-mismatch",
  // This can only happen if the SDK sends a bad request.
  MISSING_CUSTOM_TOKEN: "internal-error",
  // Create Auth URI errors.
  INVALID_IDENTIFIER: "invalid-email",
  // This can only happen if the SDK sends a bad request.
  MISSING_CONTINUE_URI: "internal-error",
  // Sign in with email and password errors (some apply to sign up too).
  INVALID_PASSWORD: "wrong-password",
  // This can only happen if the SDK sends a bad request.
  MISSING_PASSWORD: "missing-password",
  // Thrown if Email Enumeration Protection is enabled in the project and the email or password is
  // invalid.
  INVALID_LOGIN_CREDENTIALS: "invalid-credential",
  // Sign up with email and password errors.
  EMAIL_EXISTS: "email-already-in-use",
  PASSWORD_LOGIN_DISABLED: "operation-not-allowed",
  // Verify assertion for sign in with credential errors:
  INVALID_IDP_RESPONSE: "invalid-credential",
  INVALID_PENDING_TOKEN: "invalid-credential",
  FEDERATED_USER_ID_ALREADY_LINKED: "credential-already-in-use",
  // This can only happen if the SDK sends a bad request.
  MISSING_REQ_TYPE: "internal-error",
  // Send Password reset email errors:
  EMAIL_NOT_FOUND: "user-not-found",
  RESET_PASSWORD_EXCEED_LIMIT: "too-many-requests",
  EXPIRED_OOB_CODE: "expired-action-code",
  INVALID_OOB_CODE: "invalid-action-code",
  // This can only happen if the SDK sends a bad request.
  MISSING_OOB_CODE: "internal-error",
  // Operations that require ID token in request:
  CREDENTIAL_TOO_OLD_LOGIN_AGAIN: "requires-recent-login",
  INVALID_ID_TOKEN: "invalid-user-token",
  TOKEN_EXPIRED: "user-token-expired",
  USER_NOT_FOUND: "user-token-expired",
  // Other errors.
  TOO_MANY_ATTEMPTS_TRY_LATER: "too-many-requests",
  PASSWORD_DOES_NOT_MEET_REQUIREMENTS: "password-does-not-meet-requirements",
  // Phone Auth related errors.
  INVALID_CODE: "invalid-verification-code",
  INVALID_SESSION_INFO: "invalid-verification-id",
  INVALID_TEMPORARY_PROOF: "invalid-credential",
  MISSING_SESSION_INFO: "missing-verification-id",
  SESSION_EXPIRED: "code-expired",
  // Other action code errors when additional settings passed.
  // MISSING_CONTINUE_URI is getting mapped to INTERNAL_ERROR above.
  // This is OK as this error will be caught by client side validation.
  MISSING_ANDROID_PACKAGE_NAME: "missing-android-pkg-name",
  UNAUTHORIZED_DOMAIN: "unauthorized-continue-uri",
  // getProjectConfig errors when clientId is passed.
  INVALID_OAUTH_CLIENT_ID: "invalid-oauth-client-id",
  // User actions (sign-up or deletion) disabled errors.
  ADMIN_ONLY_OPERATION: "admin-restricted-operation",
  // Multi factor related errors.
  INVALID_MFA_PENDING_CREDENTIAL: "invalid-multi-factor-session",
  MFA_ENROLLMENT_NOT_FOUND: "multi-factor-info-not-found",
  MISSING_MFA_ENROLLMENT_ID: "missing-multi-factor-info",
  MISSING_MFA_PENDING_CREDENTIAL: "missing-multi-factor-session",
  SECOND_FACTOR_EXISTS: "second-factor-already-in-use",
  SECOND_FACTOR_LIMIT_EXCEEDED: "maximum-second-factor-count-exceeded",
  // Blocking functions related errors.
  BLOCKING_FUNCTION_ERROR_RESPONSE: "internal-error",
  // Recaptcha related errors.
  RECAPTCHA_NOT_ENABLED: "recaptcha-not-enabled",
  MISSING_RECAPTCHA_TOKEN: "missing-recaptcha-token",
  INVALID_RECAPTCHA_TOKEN: "invalid-recaptcha-token",
  INVALID_RECAPTCHA_ACTION: "invalid-recaptcha-action",
  MISSING_CLIENT_TYPE: "missing-client-type",
  MISSING_RECAPTCHA_VERSION: "missing-recaptcha-version",
  INVALID_RECAPTCHA_VERSION: "invalid-recaptcha-version",
  INVALID_REQ_TYPE: "invalid-req-type"
  /* AuthErrorCode.INVALID_REQ_TYPE */
};
const Dh = [
  "/v1/accounts:signInWithCustomToken",
  "/v1/accounts:signInWithEmailLink",
  "/v1/accounts:signInWithIdp",
  "/v1/accounts:signInWithPassword",
  "/v1/accounts:signInWithPhoneNumber",
  "/v1/token"
  /* Endpoint.TOKEN */
], Ih = new Ca(3e4, 6e4);
function Tn(t, e) {
  return t.tenantId && !e.tenantId ? {
    ...e,
    tenantId: t.tenantId
  } : e;
}
async function sn(t, e, n, r, a = {}) {
  return Ou(t, a, async () => {
    let o = {}, l = {};
    r && (e === "GET" ? l = r : o = {
      body: JSON.stringify(r)
    });
    const s = Fu({
      key: t.config.apiKey,
      ...l
    }).slice(1), c = await t._getAdditionalHeaders();
    c[
      "Content-Type"
      /* HttpHeader.CONTENT_TYPE */
    ] = "application/json", t.languageCode && (c[
      "X-Firebase-Locale"
      /* HttpHeader.X_FIREBASE_LOCALE */
    ] = t.languageCode);
    const d = {
      method: e,
      headers: c,
      ...o
    };
    return am() || (d.referrerPolicy = "no-referrer"), t.emulatorConfig && Su(t.emulatorConfig.host) && (d.credentials = "include"), ku.fetch()(await Lu(t, t.config.apiHost, n, s), d);
  });
}
async function Ou(t, e, n) {
  t._canInitEmulator = !1;
  const r = { ...zh, ...e };
  try {
    const a = new Oh(t), o = await Promise.race([
      n(),
      a.promise
    ]);
    a.clearNetworkTimeout();
    const l = await o.json();
    if ("needConfirmation" in l)
      throw Ta(t, "account-exists-with-different-credential", l);
    if (o.ok && !("errorMessage" in l))
      return l;
    {
      const s = o.ok ? l.errorMessage : l.error.message, [c, d] = s.split(" : ");
      if (c === "FEDERATED_USER_ID_ALREADY_LINKED")
        throw Ta(t, "credential-already-in-use", l);
      if (c === "EMAIL_EXISTS")
        throw Ta(t, "email-already-in-use", l);
      if (c === "USER_DISABLED")
        throw Ta(t, "user-disabled", l);
      const u = r[c] || c.toLowerCase().replace(/[_\s]+/g, "-");
      if (d)
        throw Iu(t, u, d);
      Rr(t, u);
    }
  } catch (a) {
    if (a instanceof Ft)
      throw a;
    Rr(t, "network-request-failed", { message: String(a) });
  }
}
async function Hi(t, e, n, r, a = {}) {
  const o = await sn(t, e, n, r, a);
  return "mfaPendingCredential" in o && Rr(t, "multi-factor-auth-required", {
    _serverResponse: o
  }), o;
}
async function Lu(t, e, n, r) {
  const a = `${e}${n}?${r}`, o = t, l = o.config.emulator ? Ah(t.config, a) : `${t.config.apiScheme}://${a}`;
  return Dh.includes(n) && (await o._persistenceManagerAvailable, o._getPersistenceType() === "COOKIE") ? o._getPersistence()._getFinalTarget(l).toString() : l;
}
function kh(t) {
  switch (t) {
    case "ENFORCE":
      return "ENFORCE";
    case "AUDIT":
      return "AUDIT";
    case "OFF":
      return "OFF";
    default:
      return "ENFORCEMENT_STATE_UNSPECIFIED";
  }
}
class Oh {
  clearNetworkTimeout() {
    clearTimeout(this.timer);
  }
  constructor(e) {
    this.auth = e, this.timer = null, this.promise = new Promise((n, r) => {
      this.timer = setTimeout(() => r(vs(
        this.auth,
        "network-request-failed"
        /* AuthErrorCode.NETWORK_REQUEST_FAILED */
      )), Ih.get());
    });
  }
}
function Ta(t, e, n) {
  const r = {
    appName: t.name
  };
  n.email && (r.email = n.email), n.phoneNumber && (r.phoneNumber = n.phoneNumber);
  const a = vs(t, e, r);
  return a.customData._tokenResponse = n, a;
}
function sc(t) {
  return t !== void 0 && t.enterprise !== void 0;
}
class Lh {
  constructor(e) {
    if (this.siteKey = "", this.recaptchaEnforcementState = [], e.recaptchaKey === void 0)
      throw new Error("recaptchaKey undefined");
    this.siteKey = e.recaptchaKey.split("/")[3], this.recaptchaEnforcementState = e.recaptchaEnforcementState;
  }
  /**
   * Returns the reCAPTCHA Enterprise enforcement state for the given provider.
   *
   * @param providerStr - The provider whose enforcement state is to be returned.
   * @returns The reCAPTCHA Enterprise enforcement state for the given provider.
   */
  getProviderEnforcementState(e) {
    if (!this.recaptchaEnforcementState || this.recaptchaEnforcementState.length === 0)
      return null;
    for (const n of this.recaptchaEnforcementState)
      if (n.provider && n.provider === e)
        return kh(n.enforcementState);
    return null;
  }
  /**
   * Returns true if the reCAPTCHA Enterprise enforcement state for the provider is set to ENFORCE or AUDIT.
   *
   * @param providerStr - The provider whose enablement state is to be returned.
   * @returns Whether or not reCAPTCHA Enterprise protection is enabled for the given provider.
   */
  isProviderEnabled(e) {
    return this.getProviderEnforcementState(e) === "ENFORCE" || this.getProviderEnforcementState(e) === "AUDIT";
  }
  /**
   * Returns true if reCAPTCHA Enterprise protection is enabled in at least one provider, otherwise
   * returns false.
   *
   * @returns Whether or not reCAPTCHA Enterprise protection is enabled for at least one provider.
   */
  isAnyProviderEnabled() {
    return this.isProviderEnabled(
      "EMAIL_PASSWORD_PROVIDER"
      /* RecaptchaAuthProvider.EMAIL_PASSWORD_PROVIDER */
    ) || this.isProviderEnabled(
      "PHONE_PROVIDER"
      /* RecaptchaAuthProvider.PHONE_PROVIDER */
    );
  }
}
async function Rh(t, e) {
  return sn(t, "GET", "/v2/recaptchaConfig", Tn(t, e));
}
async function Hh(t, e) {
  return sn(t, "POST", "/v1/accounts:delete", e);
}
async function li(t, e) {
  return sn(t, "POST", "/v1/accounts:lookup", e);
}
function Tr(t) {
  if (t)
    try {
      const e = new Date(Number(t));
      if (!isNaN(e.getTime()))
        return e.toUTCString();
    } catch {
    }
}
async function Bh(t, e = !1) {
  const n = Ut(t), r = await n.getIdToken(e), a = Ru(r);
  Ee(
    a && a.exp && a.auth_time && a.iat,
    n.auth,
    "internal-error"
    /* AuthErrorCode.INTERNAL_ERROR */
  );
  const o = typeof a.firebase == "object" ? a.firebase : void 0, l = o?.sign_in_provider;
  return {
    claims: a,
    token: r,
    authTime: Tr(bo(a.auth_time)),
    issuedAtTime: Tr(bo(a.iat)),
    expirationTime: Tr(bo(a.exp)),
    signInProvider: l || null,
    signInSecondFactor: o?.sign_in_second_factor || null
  };
}
function bo(t) {
  return Number(t) * 1e3;
}
function Ru(t) {
  const [e, n, r] = t.split(".");
  if (e === void 0 || n === void 0 || r === void 0)
    return Ja("JWT malformed, contained fewer than 3 sections"), null;
  try {
    const a = Cu(n);
    return a ? JSON.parse(a) : (Ja("Failed to decode base64 JWT payload"), null);
  } catch (a) {
    return Ja("Caught error parsing JWT payload as JSON", a?.toString()), null;
  }
}
function cc(t) {
  const e = Ru(t);
  return Ee(
    e,
    "internal-error"
    /* AuthErrorCode.INTERNAL_ERROR */
  ), Ee(
    typeof e.exp < "u",
    "internal-error"
    /* AuthErrorCode.INTERNAL_ERROR */
  ), Ee(
    typeof e.iat < "u",
    "internal-error"
    /* AuthErrorCode.INTERNAL_ERROR */
  ), Number(e.exp) - Number(e.iat);
}
async function si(t, e, n = !1) {
  if (n)
    return e;
  try {
    return await e;
  } catch (r) {
    throw r instanceof Ft && jh(r) && t.auth.currentUser === t && await t.auth.signOut(), r;
  }
}
function jh({ code: t }) {
  return t === "auth/user-disabled" || t === "auth/user-token-expired";
}
class Vh {
  constructor(e) {
    this.user = e, this.isRunning = !1, this.timerId = null, this.errorBackoff = 3e4;
  }
  _start() {
    this.isRunning || (this.isRunning = !0, this.schedule());
  }
  _stop() {
    this.isRunning && (this.isRunning = !1, this.timerId !== null && clearTimeout(this.timerId));
  }
  getInterval(e) {
    if (e) {
      const n = this.errorBackoff;
      return this.errorBackoff = Math.min(
        this.errorBackoff * 2,
        96e4
        /* Duration.RETRY_BACKOFF_MAX */
      ), n;
    } else {
      this.errorBackoff = 3e4;
      const r = (this.user.stsTokenManager.expirationTime ?? 0) - Date.now() - 3e5;
      return Math.max(0, r);
    }
  }
  schedule(e = !1) {
    if (!this.isRunning)
      return;
    const n = this.getInterval(e);
    this.timerId = setTimeout(async () => {
      await this.iteration();
    }, n);
  }
  async iteration() {
    try {
      await this.user.getIdToken(!0);
    } catch (e) {
      e?.code === "auth/network-request-failed" && this.schedule(
        /* wasError */
        !0
      );
      return;
    }
    this.schedule();
  }
}
class vl {
  constructor(e, n) {
    this.createdAt = e, this.lastLoginAt = n, this._initializeTime();
  }
  _initializeTime() {
    this.lastSignInTime = Tr(this.lastLoginAt), this.creationTime = Tr(this.createdAt);
  }
  _copy(e) {
    this.createdAt = e.createdAt, this.lastLoginAt = e.lastLoginAt, this._initializeTime();
  }
  toJSON() {
    return {
      createdAt: this.createdAt,
      lastLoginAt: this.lastLoginAt
    };
  }
}
async function ci(t) {
  const e = t.auth, n = await t.getIdToken(), r = await si(t, li(e, { idToken: n }));
  Ee(
    r?.users.length,
    e,
    "internal-error"
    /* AuthErrorCode.INTERNAL_ERROR */
  );
  const a = r.users[0];
  t._notifyReloadListener(a);
  const o = a.providerUserInfo?.length ? Hu(a.providerUserInfo) : [], l = Wh(t.providerData, o), s = t.isAnonymous, c = !(t.email && a.passwordHash) && !l?.length, d = s ? c : !1, u = {
    uid: a.localId,
    displayName: a.displayName || null,
    photoURL: a.photoUrl || null,
    email: a.email || null,
    emailVerified: a.emailVerified || !1,
    phoneNumber: a.phoneNumber || null,
    tenantId: a.tenantId || null,
    providerData: l,
    metadata: new vl(a.createdAt, a.lastLoginAt),
    isAnonymous: d
  };
  Object.assign(t, u);
}
async function Uh(t) {
  const e = Ut(t);
  await ci(e), await e.auth._persistUserIfCurrent(e), e.auth._notifyListenersIfCurrent(e);
}
function Wh(t, e) {
  return [...t.filter((r) => !e.some((a) => a.providerId === r.providerId)), ...e];
}
function Hu(t) {
  return t.map(({ providerId: e, ...n }) => ({
    providerId: e,
    uid: n.rawId || "",
    displayName: n.displayName || null,
    email: n.email || null,
    phoneNumber: n.phoneNumber || null,
    photoURL: n.photoUrl || null
  }));
}
async function Gh(t, e) {
  const n = await Ou(t, {}, async () => {
    const r = Fu({
      grant_type: "refresh_token",
      refresh_token: e
    }).slice(1), { tokenApiHost: a, apiKey: o } = t.config, l = await Lu(t, a, "/v1/token", `key=${o}`), s = await t._getAdditionalHeaders();
    s[
      "Content-Type"
      /* HttpHeader.CONTENT_TYPE */
    ] = "application/x-www-form-urlencoded";
    const c = {
      method: "POST",
      headers: s,
      body: r
    };
    return t.emulatorConfig && Su(t.emulatorConfig.host) && (c.credentials = "include"), ku.fetch()(l, c);
  });
  return {
    accessToken: n.access_token,
    expiresIn: n.expires_in,
    refreshToken: n.refresh_token
  };
}
async function Kh(t, e) {
  return sn(t, "POST", "/v2/accounts:revokeToken", Tn(t, e));
}
class Qn {
  constructor() {
    this.refreshToken = null, this.accessToken = null, this.expirationTime = null;
  }
  get isExpired() {
    return !this.expirationTime || Date.now() > this.expirationTime - 3e4;
  }
  updateFromServerResponse(e) {
    Ee(
      e.idToken,
      "internal-error"
      /* AuthErrorCode.INTERNAL_ERROR */
    ), Ee(
      typeof e.idToken < "u",
      "internal-error"
      /* AuthErrorCode.INTERNAL_ERROR */
    ), Ee(
      typeof e.refreshToken < "u",
      "internal-error"
      /* AuthErrorCode.INTERNAL_ERROR */
    );
    const n = "expiresIn" in e && typeof e.expiresIn < "u" ? Number(e.expiresIn) : cc(e.idToken);
    this.updateTokensAndExpiration(e.idToken, e.refreshToken, n);
  }
  updateFromIdToken(e) {
    Ee(
      e.length !== 0,
      "internal-error"
      /* AuthErrorCode.INTERNAL_ERROR */
    );
    const n = cc(e);
    this.updateTokensAndExpiration(e, null, n);
  }
  async getToken(e, n = !1) {
    return !n && this.accessToken && !this.isExpired ? this.accessToken : (Ee(
      this.refreshToken,
      e,
      "user-token-expired"
      /* AuthErrorCode.TOKEN_EXPIRED */
    ), this.refreshToken ? (await this.refresh(e, this.refreshToken), this.accessToken) : null);
  }
  clearRefreshToken() {
    this.refreshToken = null;
  }
  async refresh(e, n) {
    const { accessToken: r, refreshToken: a, expiresIn: o } = await Gh(e, n);
    this.updateTokensAndExpiration(r, a, Number(o));
  }
  updateTokensAndExpiration(e, n, r) {
    this.refreshToken = n || null, this.accessToken = e || null, this.expirationTime = Date.now() + r * 1e3;
  }
  static fromJSON(e, n) {
    const { refreshToken: r, accessToken: a, expirationTime: o } = n, l = new Qn();
    return r && (Ee(typeof r == "string", "internal-error", {
      appName: e
    }), l.refreshToken = r), a && (Ee(typeof a == "string", "internal-error", {
      appName: e
    }), l.accessToken = a), o && (Ee(typeof o == "number", "internal-error", {
      appName: e
    }), l.expirationTime = o), l;
  }
  toJSON() {
    return {
      refreshToken: this.refreshToken,
      accessToken: this.accessToken,
      expirationTime: this.expirationTime
    };
  }
  _assign(e) {
    this.accessToken = e.accessToken, this.refreshToken = e.refreshToken, this.expirationTime = e.expirationTime;
  }
  _clone() {
    return Object.assign(new Qn(), this.toJSON());
  }
  _performRefresh() {
    return kt("not implemented");
  }
}
function Yt(t, e) {
  Ee(typeof t == "string" || typeof t > "u", "internal-error", { appName: e });
}
class dt {
  constructor({ uid: e, auth: n, stsTokenManager: r, ...a }) {
    this.providerId = "firebase", this.proactiveRefresh = new Vh(this), this.reloadUserInfo = null, this.reloadListener = null, this.uid = e, this.auth = n, this.stsTokenManager = r, this.accessToken = r.accessToken, this.displayName = a.displayName || null, this.email = a.email || null, this.emailVerified = a.emailVerified || !1, this.phoneNumber = a.phoneNumber || null, this.photoURL = a.photoURL || null, this.isAnonymous = a.isAnonymous || !1, this.tenantId = a.tenantId || null, this.providerData = a.providerData ? [...a.providerData] : [], this.metadata = new vl(a.createdAt || void 0, a.lastLoginAt || void 0);
  }
  async getIdToken(e) {
    const n = await si(this, this.stsTokenManager.getToken(this.auth, e));
    return Ee(
      n,
      this.auth,
      "internal-error"
      /* AuthErrorCode.INTERNAL_ERROR */
    ), this.accessToken !== n && (this.accessToken = n, await this.auth._persistUserIfCurrent(this), this.auth._notifyListenersIfCurrent(this)), n;
  }
  getIdTokenResult(e) {
    return Bh(this, e);
  }
  reload() {
    return Uh(this);
  }
  _assign(e) {
    this !== e && (Ee(
      this.uid === e.uid,
      this.auth,
      "internal-error"
      /* AuthErrorCode.INTERNAL_ERROR */
    ), this.displayName = e.displayName, this.photoURL = e.photoURL, this.email = e.email, this.emailVerified = e.emailVerified, this.phoneNumber = e.phoneNumber, this.isAnonymous = e.isAnonymous, this.tenantId = e.tenantId, this.providerData = e.providerData.map((n) => ({ ...n })), this.metadata._copy(e.metadata), this.stsTokenManager._assign(e.stsTokenManager));
  }
  _clone(e) {
    const n = new dt({
      ...this,
      auth: e,
      stsTokenManager: this.stsTokenManager._clone()
    });
    return n.metadata._copy(this.metadata), n;
  }
  _onReload(e) {
    Ee(
      !this.reloadListener,
      this.auth,
      "internal-error"
      /* AuthErrorCode.INTERNAL_ERROR */
    ), this.reloadListener = e, this.reloadUserInfo && (this._notifyReloadListener(this.reloadUserInfo), this.reloadUserInfo = null);
  }
  _notifyReloadListener(e) {
    this.reloadListener ? this.reloadListener(e) : this.reloadUserInfo = e;
  }
  _startProactiveRefresh() {
    this.proactiveRefresh._start();
  }
  _stopProactiveRefresh() {
    this.proactiveRefresh._stop();
  }
  async _updateTokensIfNecessary(e, n = !1) {
    let r = !1;
    e.idToken && e.idToken !== this.stsTokenManager.accessToken && (this.stsTokenManager.updateFromServerResponse(e), r = !0), n && await ci(this), await this.auth._persistUserIfCurrent(this), r && this.auth._notifyListenersIfCurrent(this);
  }
  async delete() {
    if (It(this.auth.app))
      return Promise.reject(bn(this.auth));
    const e = await this.getIdToken();
    return await si(this, Hh(this.auth, { idToken: e })), this.stsTokenManager.clearRefreshToken(), this.auth.signOut();
  }
  toJSON() {
    return {
      uid: this.uid,
      email: this.email || void 0,
      emailVerified: this.emailVerified,
      displayName: this.displayName || void 0,
      isAnonymous: this.isAnonymous,
      photoURL: this.photoURL || void 0,
      phoneNumber: this.phoneNumber || void 0,
      tenantId: this.tenantId || void 0,
      providerData: this.providerData.map((e) => ({ ...e })),
      stsTokenManager: this.stsTokenManager.toJSON(),
      // Redirect event ID must be maintained in case there is a pending
      // redirect event.
      _redirectEventId: this._redirectEventId,
      ...this.metadata.toJSON(),
      // Required for compatibility with the legacy SDK (go/firebase-auth-sdk-persistence-parsing):
      apiKey: this.auth.config.apiKey,
      appName: this.auth.name
      // Missing authDomain will be tolerated by the legacy SDK.
      // stsTokenManager.apiKey isn't actually required (despite the legacy SDK persisting it).
    };
  }
  get refreshToken() {
    return this.stsTokenManager.refreshToken || "";
  }
  static _fromJSON(e, n) {
    const r = n.displayName ?? void 0, a = n.email ?? void 0, o = n.phoneNumber ?? void 0, l = n.photoURL ?? void 0, s = n.tenantId ?? void 0, c = n._redirectEventId ?? void 0, d = n.createdAt ?? void 0, u = n.lastLoginAt ?? void 0, { uid: f, emailVerified: m, isAnonymous: g, providerData: C, stsTokenManager: b } = n;
    Ee(
      f && b,
      e,
      "internal-error"
      /* AuthErrorCode.INTERNAL_ERROR */
    );
    const E = Qn.fromJSON(this.name, b);
    Ee(
      typeof f == "string",
      e,
      "internal-error"
      /* AuthErrorCode.INTERNAL_ERROR */
    ), Yt(r, e.name), Yt(a, e.name), Ee(
      typeof m == "boolean",
      e,
      "internal-error"
      /* AuthErrorCode.INTERNAL_ERROR */
    ), Ee(
      typeof g == "boolean",
      e,
      "internal-error"
      /* AuthErrorCode.INTERNAL_ERROR */
    ), Yt(o, e.name), Yt(l, e.name), Yt(s, e.name), Yt(c, e.name), Yt(d, e.name), Yt(u, e.name);
    const x = new dt({
      uid: f,
      auth: e,
      email: a,
      emailVerified: m,
      displayName: r,
      isAnonymous: g,
      photoURL: l,
      phoneNumber: o,
      tenantId: s,
      stsTokenManager: E,
      createdAt: d,
      lastLoginAt: u
    });
    return C && Array.isArray(C) && (x.providerData = C.map((_) => ({ ..._ }))), c && (x._redirectEventId = c), x;
  }
  /**
   * Initialize a User from an idToken server response
   * @param auth
   * @param idTokenResponse
   */
  static async _fromIdTokenResponse(e, n, r = !1) {
    const a = new Qn();
    a.updateFromServerResponse(n);
    const o = new dt({
      uid: n.localId,
      auth: e,
      stsTokenManager: a,
      isAnonymous: r
    });
    return await ci(o), o;
  }
  /**
   * Initialize a User from an idToken server response
   * @param auth
   * @param idTokenResponse
   */
  static async _fromGetAccountInfoResponse(e, n, r) {
    const a = n.users[0];
    Ee(
      a.localId !== void 0,
      "internal-error"
      /* AuthErrorCode.INTERNAL_ERROR */
    );
    const o = a.providerUserInfo !== void 0 ? Hu(a.providerUserInfo) : [], l = !(a.email && a.passwordHash) && !o?.length, s = new Qn();
    s.updateFromIdToken(r);
    const c = new dt({
      uid: a.localId,
      auth: e,
      stsTokenManager: s,
      isAnonymous: l
    }), d = {
      uid: a.localId,
      displayName: a.displayName || null,
      photoURL: a.photoUrl || null,
      email: a.email || null,
      emailVerified: a.emailVerified || !1,
      phoneNumber: a.phoneNumber || null,
      tenantId: a.tenantId || null,
      providerData: o,
      metadata: new vl(a.createdAt, a.lastLoginAt),
      isAnonymous: !(a.email && a.passwordHash) && !o?.length
    };
    return Object.assign(c, d), c;
  }
}
const dc = /* @__PURE__ */ new Map();
function gn(t) {
  oi(t instanceof Function, "Expected a class definition");
  let e = dc.get(t);
  return e ? (oi(e instanceof t, "Instance stored in cache mismatched with class"), e) : (e = new t(), dc.set(t, e), e);
}
class Bu {
  constructor() {
    this.type = "NONE", this.storage = {};
  }
  async _isAvailable() {
    return !0;
  }
  async _set(e, n) {
    this.storage[e] = n;
  }
  async _get(e) {
    const n = this.storage[e];
    return n === void 0 ? null : n;
  }
  async _remove(e) {
    delete this.storage[e];
  }
  _addListener(e, n) {
  }
  _removeListener(e, n) {
  }
}
Bu.type = "NONE";
const uc = Bu;
function Eo(t, e, n) {
  return `firebase:${t}:${e}:${n}`;
}
class er {
  constructor(e, n, r) {
    this.persistence = e, this.auth = n, this.userKey = r;
    const { config: a, name: o } = this.auth;
    this.fullUserKey = Eo(this.userKey, a.apiKey, o), this.fullPersistenceKey = Eo("persistence", a.apiKey, o), this.boundEventHandler = n._onStorageEvent.bind(n), this.persistence._addListener(this.fullUserKey, this.boundEventHandler);
  }
  setCurrentUser(e) {
    return this.persistence._set(this.fullUserKey, e.toJSON());
  }
  async getCurrentUser() {
    const e = await this.persistence._get(this.fullUserKey);
    if (!e)
      return null;
    if (typeof e == "string") {
      const n = await li(this.auth, { idToken: e }).catch(() => {
      });
      return n ? dt._fromGetAccountInfoResponse(this.auth, n, e) : null;
    }
    return dt._fromJSON(this.auth, e);
  }
  removeCurrentUser() {
    return this.persistence._remove(this.fullUserKey);
  }
  savePersistenceForRedirect() {
    return this.persistence._set(this.fullPersistenceKey, this.persistence.type);
  }
  async setPersistence(e) {
    if (this.persistence === e)
      return;
    const n = await this.getCurrentUser();
    if (await this.removeCurrentUser(), this.persistence = e, n)
      return this.setCurrentUser(n);
  }
  delete() {
    this.persistence._removeListener(this.fullUserKey, this.boundEventHandler);
  }
  static async create(e, n, r = "authUser") {
    if (!n.length)
      return new er(gn(uc), e, r);
    const a = (await Promise.all(n.map(async (d) => {
      if (await d._isAvailable())
        return d;
    }))).filter((d) => d);
    let o = a[0] || gn(uc);
    const l = Eo(r, e.config.apiKey, e.name);
    let s = null;
    for (const d of n)
      try {
        const u = await d._get(l);
        if (u) {
          let f;
          if (typeof u == "string") {
            const m = await li(e, {
              idToken: u
            }).catch(() => {
            });
            if (!m)
              break;
            f = await dt._fromGetAccountInfoResponse(e, m, u);
          } else
            f = dt._fromJSON(e, u);
          d !== o && (s = f), o = d;
          break;
        }
      } catch {
      }
    const c = a.filter((d) => d._shouldAllowMigration);
    return !o._shouldAllowMigration || !c.length ? new er(o, e, r) : (o = c[0], s && await o._set(l, s.toJSON()), await Promise.all(n.map(async (d) => {
      if (d !== o)
        try {
          await d._remove(l);
        } catch {
        }
    })), new er(o, e, r));
  }
}
function fc(t) {
  const e = t.toLowerCase();
  if (e.includes("opera/") || e.includes("opr/") || e.includes("opios/"))
    return "Opera";
  if (Xh(e))
    return "IEMobile";
  if (e.includes("msie") || e.includes("trident/"))
    return "IE";
  if (e.includes("edge/"))
    return "Edge";
  if (qh(e))
    return "Firefox";
  if (e.includes("silk/"))
    return "Silk";
  if (Qh(e))
    return "Blackberry";
  if (e5(e))
    return "Webos";
  if (Yh(e))
    return "Safari";
  if ((e.includes("chrome/") || Zh(e)) && !e.includes("edge/"))
    return "Chrome";
  if (Jh(e))
    return "Android";
  {
    const n = /([a-zA-Z\d\.]+)\/[a-zA-Z\d\.]*$/, r = t.match(n);
    if (r?.length === 2)
      return r[1];
  }
  return "Other";
}
function qh(t = xt()) {
  return /firefox\//i.test(t);
}
function Yh(t = xt()) {
  const e = t.toLowerCase();
  return e.includes("safari/") && !e.includes("chrome/") && !e.includes("crios/") && !e.includes("android");
}
function Zh(t = xt()) {
  return /crios\//i.test(t);
}
function Xh(t = xt()) {
  return /iemobile/i.test(t);
}
function Jh(t = xt()) {
  return /android/i.test(t);
}
function Qh(t = xt()) {
  return /blackberry/i.test(t);
}
function e5(t = xt()) {
  return /webos/i.test(t);
}
function ju(t, e = []) {
  let n;
  switch (t) {
    case "Browser":
      n = fc(xt());
      break;
    case "Worker":
      n = `${fc(xt())}-${t}`;
      break;
    default:
      n = t;
  }
  const r = e.length ? e.join(",") : "FirebaseCore-web";
  return `${n}/JsCore/${hs}/${r}`;
}
class t5 {
  constructor(e) {
    this.auth = e, this.queue = [];
  }
  pushCallback(e, n) {
    const r = (o) => new Promise((l, s) => {
      try {
        const c = e(o);
        l(c);
      } catch (c) {
        s(c);
      }
    });
    r.onAbort = n, this.queue.push(r);
    const a = this.queue.length - 1;
    return () => {
      this.queue[a] = () => Promise.resolve();
    };
  }
  async runMiddleware(e) {
    if (this.auth.currentUser === e)
      return;
    const n = [];
    try {
      for (const r of this.queue)
        await r(e), r.onAbort && n.push(r.onAbort);
    } catch (r) {
      n.reverse();
      for (const a of n)
        try {
          a();
        } catch {
        }
      throw this.auth._errorFactory.create("login-blocked", {
        originalMessage: r?.message
      });
    }
  }
}
async function n5(t, e = {}) {
  return sn(t, "GET", "/v2/passwordPolicy", Tn(t, e));
}
const r5 = 6;
class a5 {
  constructor(e) {
    const n = e.customStrengthOptions;
    this.customStrengthOptions = {}, this.customStrengthOptions.minPasswordLength = n.minPasswordLength ?? r5, n.maxPasswordLength && (this.customStrengthOptions.maxPasswordLength = n.maxPasswordLength), n.containsLowercaseCharacter !== void 0 && (this.customStrengthOptions.containsLowercaseLetter = n.containsLowercaseCharacter), n.containsUppercaseCharacter !== void 0 && (this.customStrengthOptions.containsUppercaseLetter = n.containsUppercaseCharacter), n.containsNumericCharacter !== void 0 && (this.customStrengthOptions.containsNumericCharacter = n.containsNumericCharacter), n.containsNonAlphanumericCharacter !== void 0 && (this.customStrengthOptions.containsNonAlphanumericCharacter = n.containsNonAlphanumericCharacter), this.enforcementState = e.enforcementState, this.enforcementState === "ENFORCEMENT_STATE_UNSPECIFIED" && (this.enforcementState = "OFF"), this.allowedNonAlphanumericCharacters = e.allowedNonAlphanumericCharacters?.join("") ?? "", this.forceUpgradeOnSignin = e.forceUpgradeOnSignin ?? !1, this.schemaVersion = e.schemaVersion;
  }
  validatePassword(e) {
    const n = {
      isValid: !0,
      passwordPolicy: this
    };
    return this.validatePasswordLengthOptions(e, n), this.validatePasswordCharacterOptions(e, n), n.isValid && (n.isValid = n.meetsMinPasswordLength ?? !0), n.isValid && (n.isValid = n.meetsMaxPasswordLength ?? !0), n.isValid && (n.isValid = n.containsLowercaseLetter ?? !0), n.isValid && (n.isValid = n.containsUppercaseLetter ?? !0), n.isValid && (n.isValid = n.containsNumericCharacter ?? !0), n.isValid && (n.isValid = n.containsNonAlphanumericCharacter ?? !0), n;
  }
  /**
   * Validates that the password meets the length options for the policy.
   *
   * @param password Password to validate.
   * @param status Validation status.
   */
  validatePasswordLengthOptions(e, n) {
    const r = this.customStrengthOptions.minPasswordLength, a = this.customStrengthOptions.maxPasswordLength;
    r && (n.meetsMinPasswordLength = e.length >= r), a && (n.meetsMaxPasswordLength = e.length <= a);
  }
  /**
   * Validates that the password meets the character options for the policy.
   *
   * @param password Password to validate.
   * @param status Validation status.
   */
  validatePasswordCharacterOptions(e, n) {
    this.updatePasswordCharacterOptionsStatuses(
      n,
      /* containsLowercaseCharacter= */
      !1,
      /* containsUppercaseCharacter= */
      !1,
      /* containsNumericCharacter= */
      !1,
      /* containsNonAlphanumericCharacter= */
      !1
    );
    let r;
    for (let a = 0; a < e.length; a++)
      r = e.charAt(a), this.updatePasswordCharacterOptionsStatuses(
        n,
        /* containsLowercaseCharacter= */
        r >= "a" && r <= "z",
        /* containsUppercaseCharacter= */
        r >= "A" && r <= "Z",
        /* containsNumericCharacter= */
        r >= "0" && r <= "9",
        /* containsNonAlphanumericCharacter= */
        this.allowedNonAlphanumericCharacters.includes(r)
      );
  }
  /**
   * Updates the running validation status with the statuses for the character options.
   * Expected to be called each time a character is processed to update each option status
   * based on the current character.
   *
   * @param status Validation status.
   * @param containsLowercaseCharacter Whether the character is a lowercase letter.
   * @param containsUppercaseCharacter Whether the character is an uppercase letter.
   * @param containsNumericCharacter Whether the character is a numeric character.
   * @param containsNonAlphanumericCharacter Whether the character is a non-alphanumeric character.
   */
  updatePasswordCharacterOptionsStatuses(e, n, r, a, o) {
    this.customStrengthOptions.containsLowercaseLetter && (e.containsLowercaseLetter || (e.containsLowercaseLetter = n)), this.customStrengthOptions.containsUppercaseLetter && (e.containsUppercaseLetter || (e.containsUppercaseLetter = r)), this.customStrengthOptions.containsNumericCharacter && (e.containsNumericCharacter || (e.containsNumericCharacter = a)), this.customStrengthOptions.containsNonAlphanumericCharacter && (e.containsNonAlphanumericCharacter || (e.containsNonAlphanumericCharacter = o));
  }
}
class i5 {
  constructor(e, n, r, a) {
    this.app = e, this.heartbeatServiceProvider = n, this.appCheckServiceProvider = r, this.config = a, this.currentUser = null, this.emulatorConfig = null, this.operations = Promise.resolve(), this.authStateSubscription = new pc(this), this.idTokenSubscription = new pc(this), this.beforeStateQueue = new t5(this), this.redirectUser = null, this.isProactiveRefreshEnabled = !1, this.EXPECTED_PASSWORD_POLICY_SCHEMA_VERSION = 1, this._canInitEmulator = !0, this._isInitialized = !1, this._deleted = !1, this._initializationPromise = null, this._popupRedirectResolver = null, this._errorFactory = Du, this._agentRecaptchaConfig = null, this._tenantRecaptchaConfigs = {}, this._projectPasswordPolicy = null, this._tenantPasswordPolicies = {}, this._resolvePersistenceManagerAvailable = void 0, this.lastNotifiedUid = void 0, this.languageCode = null, this.tenantId = null, this.settings = { appVerificationDisabledForTesting: !1 }, this.frameworks = [], this.name = e.name, this.clientVersion = a.sdkClientVersion, this._persistenceManagerAvailable = new Promise((o) => this._resolvePersistenceManagerAvailable = o);
  }
  _initializeWithPersistence(e, n) {
    return n && (this._popupRedirectResolver = gn(n)), this._initializationPromise = this.queue(async () => {
      if (!this._deleted && (this.persistenceManager = await er.create(this, e), this._resolvePersistenceManagerAvailable?.(), !this._deleted)) {
        if (this._popupRedirectResolver?._shouldInitProactively)
          try {
            await this._popupRedirectResolver._initialize(this);
          } catch {
          }
        await this.initializeCurrentUser(n), this.lastNotifiedUid = this.currentUser?.uid || null, !this._deleted && (this._isInitialized = !0);
      }
    }), this._initializationPromise;
  }
  /**
   * If the persistence is changed in another window, the user manager will let us know
   */
  async _onStorageEvent() {
    if (this._deleted)
      return;
    const e = await this.assertedPersistence.getCurrentUser();
    if (!(!this.currentUser && !e)) {
      if (this.currentUser && e && this.currentUser.uid === e.uid) {
        this._currentUser._assign(e), await this.currentUser.getIdToken();
        return;
      }
      await this._updateCurrentUser(
        e,
        /* skipBeforeStateCallbacks */
        !0
      );
    }
  }
  async initializeCurrentUserFromIdToken(e) {
    try {
      const n = await li(this, { idToken: e }), r = await dt._fromGetAccountInfoResponse(this, n, e);
      await this.directlySetCurrentUser(r);
    } catch (n) {
      console.warn("FirebaseServerApp could not login user with provided authIdToken: ", n), await this.directlySetCurrentUser(null);
    }
  }
  async initializeCurrentUser(e) {
    if (It(this.app)) {
      const o = this.app.settings.authIdToken;
      return o ? new Promise((l) => {
        setTimeout(() => this.initializeCurrentUserFromIdToken(o).then(l, l));
      }) : this.directlySetCurrentUser(null);
    }
    const n = await this.assertedPersistence.getCurrentUser();
    let r = n, a = !1;
    if (e && this.config.authDomain) {
      await this.getOrInitRedirectPersistenceManager();
      const o = this.redirectUser?._redirectEventId, l = r?._redirectEventId, s = await this.tryRedirectSignIn(e);
      (!o || o === l) && s?.user && (r = s.user, a = !0);
    }
    if (!r)
      return this.directlySetCurrentUser(null);
    if (!r._redirectEventId) {
      if (a)
        try {
          await this.beforeStateQueue.runMiddleware(r);
        } catch (o) {
          r = n, this._popupRedirectResolver._overrideRedirectResult(this, () => Promise.reject(o));
        }
      return r ? this.reloadAndSetCurrentUserOrClear(r) : this.directlySetCurrentUser(null);
    }
    return Ee(
      this._popupRedirectResolver,
      this,
      "argument-error"
      /* AuthErrorCode.ARGUMENT_ERROR */
    ), await this.getOrInitRedirectPersistenceManager(), this.redirectUser && this.redirectUser._redirectEventId === r._redirectEventId ? this.directlySetCurrentUser(r) : this.reloadAndSetCurrentUserOrClear(r);
  }
  async tryRedirectSignIn(e) {
    let n = null;
    try {
      n = await this._popupRedirectResolver._completeRedirectFn(this, e, !0);
    } catch {
      await this._setRedirectUser(null);
    }
    return n;
  }
  async reloadAndSetCurrentUserOrClear(e) {
    try {
      await ci(e);
    } catch (n) {
      if (n?.code !== "auth/network-request-failed")
        return this.directlySetCurrentUser(null);
    }
    return this.directlySetCurrentUser(e);
  }
  useDeviceLanguage() {
    this.languageCode = Th();
  }
  async _delete() {
    this._deleted = !0;
  }
  async updateCurrentUser(e) {
    if (It(this.app))
      return Promise.reject(bn(this));
    const n = e ? Ut(e) : null;
    return n && Ee(
      n.auth.config.apiKey === this.config.apiKey,
      this,
      "invalid-user-token"
      /* AuthErrorCode.INVALID_AUTH */
    ), this._updateCurrentUser(n && n._clone(this));
  }
  async _updateCurrentUser(e, n = !1) {
    if (!this._deleted)
      return e && Ee(
        this.tenantId === e.tenantId,
        this,
        "tenant-id-mismatch"
        /* AuthErrorCode.TENANT_ID_MISMATCH */
      ), n || await this.beforeStateQueue.runMiddleware(e), this.queue(async () => {
        await this.directlySetCurrentUser(e), this.notifyAuthListeners();
      });
  }
  async signOut() {
    return It(this.app) ? Promise.reject(bn(this)) : (await this.beforeStateQueue.runMiddleware(null), (this.redirectPersistenceManager || this._popupRedirectResolver) && await this._setRedirectUser(null), this._updateCurrentUser(
      null,
      /* skipBeforeStateCallbacks */
      !0
    ));
  }
  setPersistence(e) {
    return It(this.app) ? Promise.reject(bn(this)) : this.queue(async () => {
      await this.assertedPersistence.setPersistence(gn(e));
    });
  }
  _getRecaptchaConfig() {
    return this.tenantId == null ? this._agentRecaptchaConfig : this._tenantRecaptchaConfigs[this.tenantId];
  }
  async validatePassword(e) {
    this._getPasswordPolicyInternal() || await this._updatePasswordPolicy();
    const n = this._getPasswordPolicyInternal();
    return n.schemaVersion !== this.EXPECTED_PASSWORD_POLICY_SCHEMA_VERSION ? Promise.reject(this._errorFactory.create("unsupported-password-policy-schema-version", {})) : n.validatePassword(e);
  }
  _getPasswordPolicyInternal() {
    return this.tenantId === null ? this._projectPasswordPolicy : this._tenantPasswordPolicies[this.tenantId];
  }
  async _updatePasswordPolicy() {
    const e = await n5(this), n = new a5(e);
    this.tenantId === null ? this._projectPasswordPolicy = n : this._tenantPasswordPolicies[this.tenantId] = n;
  }
  _getPersistenceType() {
    return this.assertedPersistence.persistence.type;
  }
  _getPersistence() {
    return this.assertedPersistence.persistence;
  }
  _updateErrorMap(e) {
    this._errorFactory = new xa("auth", "Firebase", e());
  }
  onAuthStateChanged(e, n, r) {
    return this.registerStateListener(this.authStateSubscription, e, n, r);
  }
  beforeAuthStateChanged(e, n) {
    return this.beforeStateQueue.pushCallback(e, n);
  }
  onIdTokenChanged(e, n, r) {
    return this.registerStateListener(this.idTokenSubscription, e, n, r);
  }
  authStateReady() {
    return new Promise((e, n) => {
      if (this.currentUser)
        e();
      else {
        const r = this.onAuthStateChanged(() => {
          r(), e();
        }, n);
      }
    });
  }
  /**
   * Revokes the given access token. Currently only supports Apple OAuth access tokens.
   */
  async revokeAccessToken(e) {
    if (this.currentUser) {
      const n = await this.currentUser.getIdToken(), r = {
        providerId: "apple.com",
        tokenType: "ACCESS_TOKEN",
        token: e,
        idToken: n
      };
      this.tenantId != null && (r.tenantId = this.tenantId), await Kh(this, r);
    }
  }
  toJSON() {
    return {
      apiKey: this.config.apiKey,
      authDomain: this.config.authDomain,
      appName: this.name,
      currentUser: this._currentUser?.toJSON()
    };
  }
  async _setRedirectUser(e, n) {
    const r = await this.getOrInitRedirectPersistenceManager(n);
    return e === null ? r.removeCurrentUser() : r.setCurrentUser(e);
  }
  async getOrInitRedirectPersistenceManager(e) {
    if (!this.redirectPersistenceManager) {
      const n = e && gn(e) || this._popupRedirectResolver;
      Ee(
        n,
        this,
        "argument-error"
        /* AuthErrorCode.ARGUMENT_ERROR */
      ), this.redirectPersistenceManager = await er.create(
        this,
        [gn(n._redirectPersistence)],
        "redirectUser"
        /* KeyName.REDIRECT_USER */
      ), this.redirectUser = await this.redirectPersistenceManager.getCurrentUser();
    }
    return this.redirectPersistenceManager;
  }
  async _redirectUserForId(e) {
    return this._isInitialized && await this.queue(async () => {
    }), this._currentUser?._redirectEventId === e ? this._currentUser : this.redirectUser?._redirectEventId === e ? this.redirectUser : null;
  }
  async _persistUserIfCurrent(e) {
    if (e === this.currentUser)
      return this.queue(async () => this.directlySetCurrentUser(e));
  }
  /** Notifies listeners only if the user is current */
  _notifyListenersIfCurrent(e) {
    e === this.currentUser && this.notifyAuthListeners();
  }
  _key() {
    return `${this.config.authDomain}:${this.config.apiKey}:${this.name}`;
  }
  _startProactiveRefresh() {
    this.isProactiveRefreshEnabled = !0, this.currentUser && this._currentUser._startProactiveRefresh();
  }
  _stopProactiveRefresh() {
    this.isProactiveRefreshEnabled = !1, this.currentUser && this._currentUser._stopProactiveRefresh();
  }
  /** Returns the current user cast as the internal type */
  get _currentUser() {
    return this.currentUser;
  }
  notifyAuthListeners() {
    if (!this._isInitialized)
      return;
    this.idTokenSubscription.next(this.currentUser);
    const e = this.currentUser?.uid ?? null;
    this.lastNotifiedUid !== e && (this.lastNotifiedUid = e, this.authStateSubscription.next(this.currentUser));
  }
  registerStateListener(e, n, r, a) {
    if (this._deleted)
      return () => {
      };
    const o = typeof n == "function" ? n : n.next.bind(n);
    let l = !1;
    const s = this._isInitialized ? Promise.resolve() : this._initializationPromise;
    if (Ee(
      s,
      this,
      "internal-error"
      /* AuthErrorCode.INTERNAL_ERROR */
    ), s.then(() => {
      l || o(this.currentUser);
    }), typeof n == "function") {
      const c = e.addObserver(n, r, a);
      return () => {
        l = !0, c();
      };
    } else {
      const c = e.addObserver(n);
      return () => {
        l = !0, c();
      };
    }
  }
  /**
   * Unprotected (from race conditions) method to set the current user. This
   * should only be called from within a queued callback. This is necessary
   * because the queue shouldn't rely on another queued callback.
   */
  async directlySetCurrentUser(e) {
    this.currentUser && this.currentUser !== e && this._currentUser._stopProactiveRefresh(), e && this.isProactiveRefreshEnabled && e._startProactiveRefresh(), this.currentUser = e, e ? await this.assertedPersistence.setCurrentUser(e) : await this.assertedPersistence.removeCurrentUser();
  }
  queue(e) {
    return this.operations = this.operations.then(e, e), this.operations;
  }
  get assertedPersistence() {
    return Ee(
      this.persistenceManager,
      this,
      "internal-error"
      /* AuthErrorCode.INTERNAL_ERROR */
    ), this.persistenceManager;
  }
  _logFramework(e) {
    !e || this.frameworks.includes(e) || (this.frameworks.push(e), this.frameworks.sort(), this.clientVersion = ju(this.config.clientPlatform, this._getFrameworks()));
  }
  _getFrameworks() {
    return this.frameworks;
  }
  async _getAdditionalHeaders() {
    const e = {
      "X-Client-Version": this.clientVersion
    };
    this.app.options.appId && (e[
      "X-Firebase-gmpid"
      /* HttpHeader.X_FIREBASE_GMPID */
    ] = this.app.options.appId);
    const n = await this.heartbeatServiceProvider.getImmediate({
      optional: !0
    })?.getHeartbeatsHeader();
    n && (e[
      "X-Firebase-Client"
      /* HttpHeader.X_FIREBASE_CLIENT */
    ] = n);
    const r = await this._getAppCheckToken();
    return r && (e[
      "X-Firebase-AppCheck"
      /* HttpHeader.X_FIREBASE_APP_CHECK */
    ] = r), e;
  }
  async _getAppCheckToken() {
    if (It(this.app) && this.app.settings.appCheckToken)
      return this.app.settings.appCheckToken;
    const e = await this.appCheckServiceProvider.getImmediate({ optional: !0 })?.getToken();
    return e?.error && Ph(`Error while retrieving App Check token: ${e.error}`), e?.token;
  }
}
function Ma(t) {
  return Ut(t);
}
class pc {
  constructor(e) {
    this.auth = e, this.observer = null, this.addObserver = fm((n) => this.observer = n);
  }
  get next() {
    return Ee(
      this.observer,
      this.auth,
      "internal-error"
      /* AuthErrorCode.INTERNAL_ERROR */
    ), this.observer.next.bind(this.observer);
  }
}
let ys = {
  async loadJS() {
    throw new Error("Unable to load external scripts");
  },
  recaptchaV2Script: "",
  recaptchaEnterpriseScript: "",
  gapiScript: ""
};
function o5(t) {
  ys = t;
}
function l5(t) {
  return ys.loadJS(t);
}
function s5() {
  return ys.recaptchaEnterpriseScript;
}
class c5 {
  constructor() {
    this.enterprise = new d5();
  }
  ready(e) {
    e();
  }
  execute(e, n) {
    return Promise.resolve("token");
  }
  render(e, n) {
    return "";
  }
}
class d5 {
  ready(e) {
    e();
  }
  execute(e, n) {
    return Promise.resolve("token");
  }
  render(e, n) {
    return "";
  }
}
const u5 = "recaptcha-enterprise", Vu = "NO_RECAPTCHA";
class f5 {
  /**
   *
   * @param authExtern - The corresponding Firebase {@link Auth} instance.
   *
   */
  constructor(e) {
    this.type = u5, this.auth = Ma(e);
  }
  /**
   * Executes the verification process.
   *
   * @returns A Promise for a token that can be used to assert the validity of a request.
   */
  async verify(e = "verify", n = !1) {
    async function r(o) {
      if (!n) {
        if (o.tenantId == null && o._agentRecaptchaConfig != null)
          return o._agentRecaptchaConfig.siteKey;
        if (o.tenantId != null && o._tenantRecaptchaConfigs[o.tenantId] !== void 0)
          return o._tenantRecaptchaConfigs[o.tenantId].siteKey;
      }
      return new Promise(async (l, s) => {
        Rh(o, {
          clientType: "CLIENT_TYPE_WEB",
          version: "RECAPTCHA_ENTERPRISE"
          /* RecaptchaVersion.ENTERPRISE */
        }).then((c) => {
          if (c.recaptchaKey === void 0)
            s(new Error("recaptcha Enterprise site key undefined"));
          else {
            const d = new Lh(c);
            return o.tenantId == null ? o._agentRecaptchaConfig = d : o._tenantRecaptchaConfigs[o.tenantId] = d, l(d.siteKey);
          }
        }).catch((c) => {
          s(c);
        });
      });
    }
    function a(o, l, s) {
      const c = window.grecaptcha;
      sc(c) ? c.enterprise.ready(() => {
        c.enterprise.execute(o, { action: e }).then((d) => {
          l(d);
        }).catch(() => {
          l(Vu);
        });
      }) : s(Error("No reCAPTCHA enterprise script loaded."));
    }
    return this.auth.settings.appVerificationDisabledForTesting ? new c5().execute("siteKey", { action: "verify" }) : new Promise((o, l) => {
      r(this.auth).then((s) => {
        if (!n && sc(window.grecaptcha))
          a(s, o, l);
        else {
          if (typeof window > "u") {
            l(new Error("RecaptchaVerifier is only supported in browser"));
            return;
          }
          let c = s5();
          c.length !== 0 && (c += s), l5(c).then(() => {
            a(s, o, l);
          }).catch((d) => {
            l(d);
          });
        }
      }).catch((s) => {
        l(s);
      });
    });
  }
}
async function mc(t, e, n, r = !1, a = !1) {
  const o = new f5(t);
  let l;
  if (a)
    l = Vu;
  else
    try {
      l = await o.verify(n);
    } catch {
      l = await o.verify(n, !0);
    }
  const s = { ...e };
  if (n === "mfaSmsEnrollment" || n === "mfaSmsSignIn") {
    if ("phoneEnrollmentInfo" in s) {
      const c = s.phoneEnrollmentInfo.phoneNumber, d = s.phoneEnrollmentInfo.recaptchaToken;
      Object.assign(s, {
        phoneEnrollmentInfo: {
          phoneNumber: c,
          recaptchaToken: d,
          captchaResponse: l,
          clientType: "CLIENT_TYPE_WEB",
          recaptchaVersion: "RECAPTCHA_ENTERPRISE"
          /* RecaptchaVersion.ENTERPRISE */
        }
      });
    } else if ("phoneSignInInfo" in s) {
      const c = s.phoneSignInInfo.recaptchaToken;
      Object.assign(s, {
        phoneSignInInfo: {
          recaptchaToken: c,
          captchaResponse: l,
          clientType: "CLIENT_TYPE_WEB",
          recaptchaVersion: "RECAPTCHA_ENTERPRISE"
          /* RecaptchaVersion.ENTERPRISE */
        }
      });
    }
    return s;
  }
  return r ? Object.assign(s, { captchaResp: l }) : Object.assign(s, { captchaResponse: l }), Object.assign(s, {
    clientType: "CLIENT_TYPE_WEB"
    /* RecaptchaClientType.WEB */
  }), Object.assign(s, {
    recaptchaVersion: "RECAPTCHA_ENTERPRISE"
    /* RecaptchaVersion.ENTERPRISE */
  }), s;
}
async function gl(t, e, n, r, a) {
  if (t._getRecaptchaConfig()?.isProviderEnabled(
    "EMAIL_PASSWORD_PROVIDER"
    /* RecaptchaAuthProvider.EMAIL_PASSWORD_PROVIDER */
  )) {
    const o = await mc(
      t,
      e,
      n,
      n === "getOobCode"
      /* RecaptchaActionName.GET_OOB_CODE */
    );
    return r(t, o);
  } else
    return r(t, e).catch(async (o) => {
      if (o.code === "auth/missing-recaptcha-token") {
        console.log(`${n} is protected by reCAPTCHA Enterprise for this project. Automatically triggering the reCAPTCHA flow and restarting the flow.`);
        const l = await mc(
          t,
          e,
          n,
          n === "getOobCode"
          /* RecaptchaActionName.GET_OOB_CODE */
        );
        return r(t, l);
      } else
        return Promise.reject(o);
    });
}
function p5(t, e) {
  const n = e?.persistence || [], r = (Array.isArray(n) ? n : [n]).map(gn);
  e?.errorMap && t._updateErrorMap(e.errorMap), t._initializeWithPersistence(r, e?.popupRedirectResolver);
}
class m5 {
  /** @internal */
  constructor(e, n) {
    this.providerId = e, this.signInMethod = n;
  }
  /**
   * Returns a JSON-serializable representation of this object.
   *
   * @returns a JSON-serializable representation of this object.
   */
  toJSON() {
    return kt("not implemented");
  }
  /** @internal */
  _getIdTokenResponse(e) {
    return kt("not implemented");
  }
  /** @internal */
  _linkToIdToken(e, n) {
    return kt("not implemented");
  }
  /** @internal */
  _getReauthenticationResolver(e) {
    return kt("not implemented");
  }
}
async function h5(t, e) {
  return sn(t, "POST", "/v1/accounts:signUp", e);
}
async function v5(t, e) {
  return Hi(t, "POST", "/v1/accounts:signInWithPassword", Tn(t, e));
}
async function g5(t, e) {
  return Hi(t, "POST", "/v1/accounts:signInWithEmailLink", Tn(t, e));
}
async function y5(t, e) {
  return Hi(t, "POST", "/v1/accounts:signInWithEmailLink", Tn(t, e));
}
class Hr extends m5 {
  /** @internal */
  constructor(e, n, r, a = null) {
    super("password", r), this._email = e, this._password = n, this._tenantId = a;
  }
  /** @internal */
  static _fromEmailAndPassword(e, n) {
    return new Hr(
      e,
      n,
      "password"
      /* SignInMethod.EMAIL_PASSWORD */
    );
  }
  /** @internal */
  static _fromEmailAndCode(e, n, r = null) {
    return new Hr(e, n, "emailLink", r);
  }
  /** {@inheritdoc AuthCredential.toJSON} */
  toJSON() {
    return {
      email: this._email,
      password: this._password,
      signInMethod: this.signInMethod,
      tenantId: this._tenantId
    };
  }
  /**
   * Static method to deserialize a JSON representation of an object into an {@link  AuthCredential}.
   *
   * @param json - Either `object` or the stringified representation of the object. When string is
   * provided, `JSON.parse` would be called first.
   *
   * @returns If the JSON input does not represent an {@link AuthCredential}, null is returned.
   */
  static fromJSON(e) {
    const n = typeof e == "string" ? JSON.parse(e) : e;
    if (n?.email && n?.password) {
      if (n.signInMethod === "password")
        return this._fromEmailAndPassword(n.email, n.password);
      if (n.signInMethod === "emailLink")
        return this._fromEmailAndCode(n.email, n.password, n.tenantId);
    }
    return null;
  }
  /** @internal */
  async _getIdTokenResponse(e) {
    switch (this.signInMethod) {
      case "password":
        const n = {
          returnSecureToken: !0,
          email: this._email,
          password: this._password,
          clientType: "CLIENT_TYPE_WEB"
          /* RecaptchaClientType.WEB */
        };
        return gl(e, n, "signInWithPassword", v5);
      case "emailLink":
        return g5(e, {
          email: this._email,
          oobCode: this._password
        });
      default:
        Rr(
          e,
          "internal-error"
          /* AuthErrorCode.INTERNAL_ERROR */
        );
    }
  }
  /** @internal */
  async _linkToIdToken(e, n) {
    switch (this.signInMethod) {
      case "password":
        const r = {
          idToken: n,
          returnSecureToken: !0,
          email: this._email,
          password: this._password,
          clientType: "CLIENT_TYPE_WEB"
          /* RecaptchaClientType.WEB */
        };
        return gl(e, r, "signUpPassword", h5);
      case "emailLink":
        return y5(e, {
          idToken: n,
          email: this._email,
          oobCode: this._password
        });
      default:
        Rr(
          e,
          "internal-error"
          /* AuthErrorCode.INTERNAL_ERROR */
        );
    }
  }
  /** @internal */
  _getReauthenticationResolver(e) {
    return this._getIdTokenResponse(e);
  }
}
function b5(t) {
  switch (t) {
    case "recoverEmail":
      return "RECOVER_EMAIL";
    case "resetPassword":
      return "PASSWORD_RESET";
    case "signIn":
      return "EMAIL_SIGNIN";
    case "verifyEmail":
      return "VERIFY_EMAIL";
    case "verifyAndChangeEmail":
      return "VERIFY_AND_CHANGE_EMAIL";
    case "revertSecondFactorAddition":
      return "REVERT_SECOND_FACTOR_ADDITION";
    default:
      return null;
  }
}
function E5(t) {
  const e = Fr(Pr(t)).link, n = e ? Fr(Pr(e)).deep_link_id : null, r = Fr(Pr(t)).deep_link_id;
  return (r ? Fr(Pr(r)).link : null) || r || n || e || t;
}
class bs {
  /**
   * @param actionLink - The link from which to extract the URL.
   * @returns The {@link ActionCodeURL} object, or null if the link is invalid.
   *
   * @internal
   */
  constructor(e) {
    const n = Fr(Pr(e)), r = n.apiKey ?? null, a = n.oobCode ?? null, o = b5(n.mode ?? null);
    Ee(
      r && a && o,
      "argument-error"
      /* AuthErrorCode.ARGUMENT_ERROR */
    ), this.apiKey = r, this.operation = o, this.code = a, this.continueUrl = n.continueUrl ?? null, this.languageCode = n.lang ?? null, this.tenantId = n.tenantId ?? null;
  }
  /**
   * Parses the email action link string and returns an {@link ActionCodeURL} if the link is valid,
   * otherwise returns null.
   *
   * @param link  - The email action link string.
   * @returns The {@link ActionCodeURL} object, or null if the link is invalid.
   *
   * @public
   */
  static parseLink(e) {
    const n = E5(e);
    try {
      return new bs(n);
    } catch {
      return null;
    }
  }
}
class gr {
  constructor() {
    this.providerId = gr.PROVIDER_ID;
  }
  /**
   * Initialize an {@link AuthCredential} using an email and password.
   *
   * @example
   * ```javascript
   * const authCredential = EmailAuthProvider.credential(email, password);
   * const userCredential = await signInWithCredential(auth, authCredential);
   * ```
   *
   * @example
   * ```javascript
   * const userCredential = await signInWithEmailAndPassword(auth, email, password);
   * ```
   *
   * @param email - Email address.
   * @param password - User account password.
   * @returns The auth provider credential.
   */
  static credential(e, n) {
    return Hr._fromEmailAndPassword(e, n);
  }
  /**
   * Initialize an {@link AuthCredential} using an email and an email link after a sign in with
   * email link operation.
   *
   * @example
   * ```javascript
   * const authCredential = EmailAuthProvider.credentialWithLink(auth, email, emailLink);
   * const userCredential = await signInWithCredential(auth, authCredential);
   * ```
   *
   * @example
   * ```javascript
   * await sendSignInLinkToEmail(auth, email);
   * // Obtain emailLink from user.
   * const userCredential = await signInWithEmailLink(auth, email, emailLink);
   * ```
   *
   * @param auth - The {@link Auth} instance used to verify the link.
   * @param email - Email address.
   * @param emailLink - Sign-in email link.
   * @returns - The auth provider credential.
   */
  static credentialWithLink(e, n) {
    const r = bs.parseLink(n);
    return Ee(
      r,
      "argument-error"
      /* AuthErrorCode.ARGUMENT_ERROR */
    ), Hr._fromEmailAndCode(e, r.code, r.tenantId);
  }
}
gr.PROVIDER_ID = "password";
gr.EMAIL_PASSWORD_SIGN_IN_METHOD = "password";
gr.EMAIL_LINK_SIGN_IN_METHOD = "emailLink";
async function w5(t, e) {
  return Hi(t, "POST", "/v1/accounts:signUp", Tn(t, e));
}
class Br {
  constructor(e) {
    this.user = e.user, this.providerId = e.providerId, this._tokenResponse = e._tokenResponse, this.operationType = e.operationType;
  }
  static async _fromIdTokenResponse(e, n, r, a = !1) {
    const o = await dt._fromIdTokenResponse(e, r, a), l = hc(r);
    return new Br({
      user: o,
      providerId: l,
      _tokenResponse: r,
      operationType: n
    });
  }
  static async _forOperation(e, n, r) {
    await e._updateTokensIfNecessary(
      r,
      /* reload */
      !0
    );
    const a = hc(r);
    return new Br({
      user: e,
      providerId: a,
      _tokenResponse: r,
      operationType: n
    });
  }
}
function hc(t) {
  return t.providerId ? t.providerId : "phoneNumber" in t ? "phone" : null;
}
class di extends Ft {
  constructor(e, n, r, a) {
    super(n.code, n.message), this.operationType = r, this.user = a, Object.setPrototypeOf(this, di.prototype), this.customData = {
      appName: e.name,
      tenantId: e.tenantId ?? void 0,
      _serverResponse: n.customData._serverResponse,
      operationType: r
    };
  }
  static _fromErrorAndOperation(e, n, r, a) {
    return new di(e, n, r, a);
  }
}
function $5(t, e, n, r) {
  return n._getIdTokenResponse(t).catch((o) => {
    throw o.code === "auth/multi-factor-auth-required" ? di._fromErrorAndOperation(t, o, e, r) : o;
  });
}
async function x5(t, e, n = !1) {
  if (It(t.app))
    return Promise.reject(bn(t));
  const r = "signIn", a = await $5(t, r, e), o = await Br._fromIdTokenResponse(t, r, a);
  return n || await t._updateCurrentUser(o.user), o;
}
async function C5(t, e) {
  return x5(Ma(t), e);
}
async function Uu(t) {
  const e = Ma(t);
  e._getPasswordPolicyInternal() && await e._updatePasswordPolicy();
}
async function M5(t, e, n) {
  if (It(t.app))
    return Promise.reject(bn(t));
  const r = Ma(t), l = await gl(r, {
    returnSecureToken: !0,
    email: e,
    password: n,
    clientType: "CLIENT_TYPE_WEB"
    /* RecaptchaClientType.WEB */
  }, "signUpPassword", w5).catch((c) => {
    throw c.code === "auth/password-does-not-meet-requirements" && Uu(t), c;
  }), s = await Br._fromIdTokenResponse(r, "signIn", l);
  return await r._updateCurrentUser(s.user), s;
}
function S5(t, e, n) {
  return It(t.app) ? Promise.reject(bn(t)) : C5(Ut(t), gr.credential(e, n)).catch(async (r) => {
    throw r.code === "auth/password-does-not-meet-requirements" && Uu(t), r;
  });
}
async function F5(t, e) {
  return sn(t, "POST", "/v1/accounts:update", e);
}
async function P5(t, { displayName: e, photoURL: n }) {
  if (e === void 0 && n === void 0)
    return;
  const r = Ut(t), o = {
    idToken: await r.getIdToken(),
    displayName: e,
    photoUrl: n,
    returnSecureToken: !0
  }, l = await si(r, F5(r.auth, o));
  r.displayName = l.displayName || null, r.photoURL = l.photoUrl || null;
  const s = r.providerData.find(
    ({ providerId: c }) => c === "password"
    /* ProviderId.PASSWORD */
  );
  s && (s.displayName = r.displayName, s.photoURL = r.photoURL), await r._updateTokensIfNecessary(l);
}
function Wu(t, e, n, r) {
  return Ut(t).onIdTokenChanged(e, n, r);
}
function Gu(t, e, n, r) {
  return Ut(t).onAuthStateChanged(e, n, r);
}
function N5(t) {
  return Ut(t).signOut();
}
new Ca(3e4, 6e4);
new Ca(2e3, 1e4);
new Ca(3e4, 6e4);
new Ca(5e3, 15e3);
var vc = "@firebase/auth", gc = "1.11.0";
class _5 {
  constructor(e) {
    this.auth = e, this.internalListeners = /* @__PURE__ */ new Map();
  }
  getUid() {
    return this.assertAuthConfigured(), this.auth.currentUser?.uid || null;
  }
  async getToken(e) {
    return this.assertAuthConfigured(), await this.auth._initializationPromise, this.auth.currentUser ? { accessToken: await this.auth.currentUser.getIdToken(e) } : null;
  }
  addAuthTokenListener(e) {
    if (this.assertAuthConfigured(), this.internalListeners.has(e))
      return;
    const n = this.auth.onIdTokenChanged((r) => {
      e(r?.stsTokenManager.accessToken || null);
    });
    this.internalListeners.set(e, n), this.updateProactiveRefresh();
  }
  removeAuthTokenListener(e) {
    this.assertAuthConfigured();
    const n = this.internalListeners.get(e);
    n && (this.internalListeners.delete(e), n(), this.updateProactiveRefresh());
  }
  assertAuthConfigured() {
    Ee(
      this.auth._initializationPromise,
      "dependent-sdk-initialized-before-auth"
      /* AuthErrorCode.DEPENDENT_SDK_INIT_BEFORE_AUTH */
    );
  }
  updateProactiveRefresh() {
    this.internalListeners.size > 0 ? this.auth._startProactiveRefresh() : this.auth._stopProactiveRefresh();
  }
}
function T5(t) {
  switch (t) {
    case "Node":
      return "node";
    case "ReactNative":
      return "rn";
    case "Worker":
      return "webworker";
    case "Cordova":
      return "cordova";
    case "WebExtension":
      return "web-extension";
    default:
      return;
  }
}
function A5(t) {
  Or(new sr(
    "auth",
    (e, { options: n }) => {
      const r = e.getProvider("app").getImmediate(), a = e.getProvider("heartbeat"), o = e.getProvider("app-check-internal"), { apiKey: l, authDomain: s } = r.options;
      Ee(l && !l.includes(":"), "invalid-api-key", { appName: r.name });
      const c = {
        apiKey: l,
        authDomain: s,
        clientPlatform: t,
        apiHost: "identitytoolkit.googleapis.com",
        tokenApiHost: "securetoken.googleapis.com",
        apiScheme: "https",
        sdkClientVersion: ju(t)
      }, d = new i5(r, a, o, c);
      return p5(d, n), d;
    },
    "PUBLIC"
    /* ComponentType.PUBLIC */
  ).setInstantiationMode(
    "EXPLICIT"
    /* InstantiationMode.EXPLICIT */
  ).setInstanceCreatedCallback((e, n, r) => {
    e.getProvider(
      "auth-internal"
      /* _ComponentName.AUTH_INTERNAL */
    ).initialize();
  })), Or(new sr(
    "auth-internal",
    (e) => {
      const n = Ma(e.getProvider(
        "auth"
        /* _ComponentName.AUTH */
      ).getImmediate());
      return ((r) => new _5(r))(n);
    },
    "PRIVATE"
    /* ComponentType.PRIVATE */
  ).setInstantiationMode(
    "EXPLICIT"
    /* InstantiationMode.EXPLICIT */
  )), Jn(vc, gc, T5(t)), Jn(vc, gc, "esm2020");
}
const z5 = 300;
tm("authIdTokenMaxAge");
function D5() {
  return document.getElementsByTagName("head")?.[0] ?? document;
}
o5({
  loadJS(t) {
    return new Promise((e, n) => {
      const r = document.createElement("script");
      r.setAttribute("src", t), r.onload = e, r.onerror = (a) => {
        const o = vs(
          "internal-error"
          /* AuthErrorCode.INTERNAL_ERROR */
        );
        o.customData = a, n(o);
      }, r.type = "text/javascript", r.charset = "UTF-8", D5().appendChild(r);
    });
  },
  gapiScript: "https://apis.google.com/js/api.js",
  recaptchaV2Script: "https://www.google.com/recaptcha/api.js",
  recaptchaEnterpriseScript: "https://www.google.com/recaptcha/enterprise.js?render="
});
A5(
  "Browser"
  /* ClientPlatform.BROWSER */
);
const Ue = {
  INVALID_CREDENTIALS: "shared.firebase.invalidCredentials",
  TOO_MANY_ATTEMPTS: "shared.firebase.tooManyAttempts",
  ACCOUNT_DISABLED: "shared.firebase.accountDisabled",
  NETWORK_FAILED: "shared.firebase.networkFailed",
  LOGIN_NOT_SUPPORTED: "shared.firebase.loginNotSupported",
  INVALID_EMAIL: "shared.firebase.invalidEmail",
  INVALID_PASSWORD: "shared.firebase.invalidPassword",
  LOGIN_ERROR: "shared.firebase.loginError",
  LOGOUT_ERROR: "shared.firebase.logoutError",
  EMAIL_NOT_REGISTERED: "shared.firebase.emailNotRegistered",
  RESET_EMAIL_ERROR: "shared.firebase.resetEmailError",
  EMAIL_ALREADY_IN_USE: "shared.firebase.emailAlreadyInUse",
  WEAK_PASSWORD: "shared.firebase.weakPassword",
  SIGNUP_ERROR: "shared.firebase.signupError"
}, sO = mh(
  JSON.parse('{"apiKey":"AIzaSyDr34zw5dVwpOFZRv0QT-2m0J6vfFl2d48","authDomain":"cold-ambulance-project.firebaseapp.com","projectId":"cold-ambulance-project","storageBucket":"cold-ambulance-project.firebasestorage.app","messagingSenderId":"571653031442","appId":"1:571653031442:web:65968fd97e996978d0bacb"}')
);
function cO(t) {
  return new Promise((e) => {
    const n = [], r = (a) => {
      console.log({ subject: a }), e(a || null), n.forEach((o) => o());
    };
    n.push(Gu(t, r)), n.push(Wu(t, r));
  });
}
function dO(t) {
  const [e, n] = ve(t.currentUser), r = de((a) => {
    n(a || null);
  }, []);
  return xe(() => Gu(t, r), [r, t]), xe(() => Wu(t, r), [r, t]), e;
}
async function uO(t, e, n) {
  if (t.currentUser)
    return {
      user: t.currentUser,
      token: await t.currentUser.getIdToken()
    };
  try {
    const a = (await S5(t, e, n)).user, o = await a.getIdToken();
    return { subject: a, token: o };
  } catch (r) {
    if (r instanceof Ft)
      switch (r.code) {
        case tt.INVALID_IDP_RESPONSE:
        case tt.INVALID_LOGIN_CREDENTIALS:
          throw new Error(Ue.INVALID_CREDENTIALS);
        case tt.TOO_MANY_ATTEMPTS_TRY_LATER:
          throw new Error(Ue.TOO_MANY_ATTEMPTS);
        case tt.USER_DISABLED:
          throw new Error(Ue.ACCOUNT_DISABLED);
        case tt.USER_DELETED:
        case tt.NETWORK_REQUEST_FAILED:
          throw new Error(Ue.NETWORK_FAILED);
        case tt.OPERATION_NOT_ALLOWED:
          throw new Error(Ue.LOGIN_NOT_SUPPORTED);
        case tt.INVALID_EMAIL:
          throw new Error(Ue.INVALID_EMAIL);
        case tt.INVALID_PASSWORD:
          throw new Error(Ue.INVALID_PASSWORD);
        default:
          throw new Error(Ue.LOGIN_ERROR);
      }
    throw r instanceof fs && r.status === 403 ? (await I5(t).catch(() => {
    }), new Error(Ue.INVALID_CREDENTIALS)) : r;
  }
}
async function fO(t, e) {
  try {
    if (!(await fetch(`${ps}/auth/forgot-password`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ email: e })
    })).ok)
      throw new Error(Ue.RESET_EMAIL_ERROR);
  } catch (n) {
    throw n instanceof Error && n.message.startsWith("shared.") ? n : new Error(Ue.RESET_EMAIL_ERROR);
  }
}
async function pO(t) {
  try {
    await fetch(`${ps}/auth/password-changed`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ email: t })
    });
  } catch (e) {
    console.error("Failed to notify password-changed", e);
  }
}
async function mO(t, e, n, r) {
  try {
    const o = (await M5(t, e, n)).user, l = await o.getIdToken();
    return await P5(o, { displayName: r }), { subject: o, token: l };
  } catch (a) {
    if (a instanceof Ft)
      switch (a.code) {
        case tt.EMAIL_EXISTS:
          throw new Error(Ue.EMAIL_ALREADY_IN_USE);
        case tt.WEAK_PASSWORD:
          throw new Error(Ue.WEAK_PASSWORD);
        case tt.INVALID_EMAIL:
          throw new Error(Ue.INVALID_EMAIL);
        case tt.NETWORK_REQUEST_FAILED:
          throw new Error(Ue.NETWORK_FAILED);
        default:
          throw new Error(Ue.SIGNUP_ERROR);
      }
    throw a;
  }
}
async function I5(t) {
  try {
    await N5(t);
  } catch (e) {
    throw console.error("Error during logout:", e), new Error(Ue.LOGOUT_ERROR);
  }
}
const k5 = {
  MONTHLY: "shared.payment.monthly",
  DELIVERABLES: "shared.payment.deliverables"
};
function O5(t) {
  return !t || (t.milestones || []).length === 0 ? null : k5[t.paymentType] ?? null;
}
function hO({
  children: t,
  className: e
}) {
  return /* @__PURE__ */ S(
    "div",
    {
      className: fe(
        "bg-primary text-primary-foreground relative min-h-40 w-full overflow-hidden rounded-xl",
        e
      ),
      children: [
        /* @__PURE__ */ p("div", { className: "absolute top-1/2 -left-1/4 h-full w-1/2 rounded-full bg-black/5" }),
        /* @__PURE__ */ p("div", { className: "px-14 py-8", children: t }),
        /* @__PURE__ */ p("div", { className: "absolute -top-1/4 left-3/4 h-full w-1/2 rounded-full bg-black/5" })
      ]
    }
  );
}
function vO() {
  return /* @__PURE__ */ S(
    "svg",
    {
      width: 28,
      height: 29,
      viewBox: "0 0 28 29",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ p(
          "path",
          {
            d: "M22.1667 4.84155H5.83333C4.54467 4.84155 3.5 5.88622 3.5 7.17489V23.5082C3.5 24.7969 4.54467 25.8416 5.83333 25.8416H22.1667C23.4553 25.8416 24.5 24.7969 24.5 23.5082V7.17489C24.5 5.88622 23.4553 4.84155 22.1667 4.84155Z",
            stroke: "white",
            strokeWidth: 1.8,
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }
        ),
        /* @__PURE__ */ p(
          "path",
          {
            d: "M18.6666 2.50806V7.17472",
            stroke: "white",
            strokeWidth: 1.8,
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }
        ),
        /* @__PURE__ */ p(
          "path",
          {
            d: "M3.5 11.8416H24.5",
            stroke: "white",
            strokeWidth: 1.8,
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }
        ),
        /* @__PURE__ */ p(
          "path",
          {
            d: "M9.33337 2.50806V7.17472",
            stroke: "white",
            strokeWidth: 1.8,
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }
        ),
        /* @__PURE__ */ p(
          "path",
          {
            d: "M19.8334 16.5081H12.8334",
            stroke: "white",
            strokeWidth: 1.8,
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }
        ),
        /* @__PURE__ */ p(
          "path",
          {
            d: "M15.1666 21.1748H8.16663",
            stroke: "white",
            strokeWidth: 1.8,
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }
        ),
        /* @__PURE__ */ p(
          "path",
          {
            d: "M8.16663 16.5081H8.17788",
            stroke: "white",
            strokeWidth: 1.8,
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }
        ),
        /* @__PURE__ */ p(
          "path",
          {
            d: "M19.8334 21.1748H19.8446",
            stroke: "white",
            strokeWidth: 1.8,
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }
        )
      ]
    }
  );
}
function gO() {
  return /* @__PURE__ */ S(
    "svg",
    {
      width: 28,
      height: 29,
      viewBox: "0 0 28 29",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ p(
          "path",
          {
            d: "M14 2.50806C16.2635 2.50764 18.4782 3.16568 20.3743 4.40197C22.2703 5.63826 23.7658 7.39941 24.6785 9.47077C25.5911 11.5421 25.8815 13.8342 25.5142 16.0677C25.1469 18.3012 24.1379 20.3797 22.61 22.0497",
            stroke: "white",
            strokeWidth: 2,
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }
        ),
        /* @__PURE__ */ p(
          "path",
          {
            d: "M14 7.1748V14.1748L18.6667 16.5081",
            stroke: "white",
            strokeWidth: 2,
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }
        ),
        /* @__PURE__ */ p(
          "path",
          {
            d: "M2.91671 10.5291C2.54495 11.6592 2.34823 12.8395 2.33337 14.0291",
            stroke: "white",
            strokeWidth: 2,
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }
        ),
        /* @__PURE__ */ p(
          "path",
          {
            d: "M3.30176 18.8416C3.95684 20.3487 4.92294 21.7004 6.13676 22.8082",
            stroke: "white",
            strokeWidth: 2,
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }
        ),
        /* @__PURE__ */ p(
          "path",
          {
            d: "M5.40869 6.2823C5.73424 5.92791 6.0814 5.59399 6.44819 5.28247",
            stroke: "white",
            strokeWidth: 2,
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }
        ),
        /* @__PURE__ */ p(
          "path",
          {
            d: "M10.0847 25.1648C12.994 26.2012 16.1956 26.0418 18.9876 24.7214",
            stroke: "white",
            strokeWidth: 2,
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }
        )
      ]
    }
  );
}
function yO({
  to: t,
  className: e
}) {
  const { t: n } = Ae();
  return /* @__PURE__ */ S(
    "div",
    {
      className: fe(
        "mt-8 flex items-center justify-between rounded-xl bg-[#FEF3C7] py-3 ps-7 pe-4",
        e
      ),
      children: [
        /* @__PURE__ */ S("div", { className: "flex items-center gap-2", children: [
          /* @__PURE__ */ p(kr, { size: 20, className: "text-[#92400E]" }),
          /* @__PURE__ */ p("p", { className: "text-sm font-medium text-[#92400E]", children: n("shared.banners.completeProfile") })
        ] }),
        /* @__PURE__ */ p(
          Ea,
          {
            to: t,
            className: us({
              variant: "link",
              className: "bg-[#92400E] text-sm text-white hover:bg-[#7C3A0B]"
            }),
            children: n("shared.banners.completeProfileCta")
          }
        )
      ]
    }
  );
}
function L5({
  className: t,
  ...e
}) {
  return /* @__PURE__ */ p(
    "div",
    {
      ...e,
      className: fe(
        "flex h-1.5 w-6 flex-row items-center gap-1 rounded-full bg-white/50 px-3",
        t
      )
    }
  );
}
function bO({
  className: t,
  count: e,
  value: n,
  onChange: r,
  cumulative: a = !1
}) {
  return /* @__PURE__ */ p("div", { className: fe(t, "flex items-center justify-center gap-1"), children: Array.from({ length: e }).map((o, l) => /* @__PURE__ */ p(
    L5,
    {
      role: r ? "button" : void 0,
      onClick: r ? () => r(l) : void 0,
      "data-step-active": (a ? l <= n : l === n) ? "true" : "false",
      className: (a ? l <= n : l === n) ? "bg-background" : "bg-white/50"
    },
    l
  )) });
}
function EO() {
  const { t } = Ae();
  return /* @__PURE__ */ p("div", { className: "my-16 flex h-full items-center justify-center", children: /* @__PURE__ */ S("div", { className: "flex flex-col items-center space-y-4", children: [
    /* @__PURE__ */ p("div", { className: "relative", children: /* @__PURE__ */ p("div", { className: "border-t-primary h-12 w-12 animate-spin rounded-full border-4 border-gray-200" }) }),
    /* @__PURE__ */ p("p", { className: "text-sm font-medium text-gray-600", children: t("shared.common.loading") })
  ] }) });
}
function R5(t, e) {
  return `https://www.google.com/maps/search/?api=1&query=${t},${e}`;
}
function H5(t, e) {
  return !(t === 0 && e === 0);
}
function B5({
  name: t,
  latitude: e,
  longitude: n,
  iconSize: r = 20,
  className: a,
  showMapIcon: o = !0
}) {
  const { t: l } = Ae();
  return H5(e, n) ? /* @__PURE__ */ S(
    "a",
    {
      href: R5(e, n),
      target: "_blank",
      rel: "noopener noreferrer",
      className: fe(
        "group flex items-center gap-2 hover:underline",
        a
      ),
      children: [
        o && /* @__PURE__ */ p(Xs, { size: r, className: "shrink-0" }),
        /* @__PURE__ */ p("span", { children: t }),
        /* @__PURE__ */ p(
          du,
          {
            size: 14,
            className: "shrink-0 opacity-50 group-hover:opacity-100"
          }
        )
      ]
    }
  ) : /* @__PURE__ */ S("span", { className: fe("flex items-center gap-2", a), children: [
    o && /* @__PURE__ */ p(Xs, { size: r, className: "shrink-0" }),
    /* @__PURE__ */ p("span", { children: t || l("shared.common.notSpecified") })
  ] });
}
var yc = 1, j5 = 0.9, V5 = 0.8, U5 = 0.17, wo = 0.1, $o = 0.999, W5 = 0.9999, G5 = 0.99, K5 = /[\\\/_+.#"@\[\(\{&]/, q5 = /[\\\/_+.#"@\[\(\{&]/g, Y5 = /[\s-]/, Ku = /[\s-]/g;
function yl(t, e, n, r, a, o, l) {
  if (o === e.length) return a === t.length ? yc : G5;
  var s = `${a},${o}`;
  if (l[s] !== void 0) return l[s];
  for (var c = r.charAt(o), d = n.indexOf(c, a), u = 0, f, m, g, C; d >= 0; ) f = yl(t, e, n, r, d + 1, o + 1, l), f > u && (d === a ? f *= yc : K5.test(t.charAt(d - 1)) ? (f *= V5, g = t.slice(a, d - 1).match(q5), g && a > 0 && (f *= Math.pow($o, g.length))) : Y5.test(t.charAt(d - 1)) ? (f *= j5, C = t.slice(a, d - 1).match(Ku), C && a > 0 && (f *= Math.pow($o, C.length))) : (f *= U5, a > 0 && (f *= Math.pow($o, d - a))), t.charAt(d) !== e.charAt(o) && (f *= W5)), (f < wo && n.charAt(d - 1) === r.charAt(o + 1) || r.charAt(o + 1) === r.charAt(o) && n.charAt(d - 1) !== r.charAt(o)) && (m = yl(t, e, n, r, d + 1, o + 2, l), m * wo > f && (f = m * wo)), f > u && (u = f), d = n.indexOf(c, d + 1);
  return l[s] = u, u;
}
function bc(t) {
  return t.toLowerCase().replace(Ku, " ");
}
function Z5(t, e, n) {
  return t = n && n.length > 0 ? `${t + " " + n.join(" ")}` : t, yl(t, e, bc(t), bc(e), 0, 0, {});
}
function tn(t, e, { checkForDefaultPrevented: n = !0 } = {}) {
  return function(a) {
    if (t?.(a), n === !1 || !a.defaultPrevented)
      return e?.(a);
  };
}
function Ec(t, e) {
  if (typeof t == "function")
    return t(e);
  t != null && (t.current = e);
}
function xn(...t) {
  return (e) => {
    let n = !1;
    const r = t.map((a) => {
      const o = Ec(a, e);
      return !n && typeof o == "function" && (n = !0), o;
    });
    if (n)
      return () => {
        for (let a = 0; a < r.length; a++) {
          const o = r[a];
          typeof o == "function" ? o() : Ec(t[a], null);
        }
      };
  };
}
function An(...t) {
  return $.useCallback(xn(...t), t);
}
function X5(t, e) {
  const n = $.createContext(e), r = (o) => {
    const { children: l, ...s } = o, c = $.useMemo(() => s, Object.values(s));
    return /* @__PURE__ */ p(n.Provider, { value: c, children: l });
  };
  r.displayName = t + "Provider";
  function a(o) {
    const l = $.useContext(n);
    if (l) return l;
    if (e !== void 0) return e;
    throw new Error(`\`${o}\` must be used within \`${t}\``);
  }
  return [r, a];
}
function J5(t, e = []) {
  let n = [];
  function r(o, l) {
    const s = $.createContext(l), c = n.length;
    n = [...n, l];
    const d = (f) => {
      const { scope: m, children: g, ...C } = f, b = m?.[t]?.[c] || s, E = $.useMemo(() => C, Object.values(C));
      return /* @__PURE__ */ p(b.Provider, { value: E, children: g });
    };
    d.displayName = o + "Provider";
    function u(f, m) {
      const g = m?.[t]?.[c] || s, C = $.useContext(g);
      if (C) return C;
      if (l !== void 0) return l;
      throw new Error(`\`${f}\` must be used within \`${o}\``);
    }
    return [d, u];
  }
  const a = () => {
    const o = n.map((l) => $.createContext(l));
    return function(s) {
      const c = s?.[t] || o;
      return $.useMemo(
        () => ({ [`__scope${t}`]: { ...s, [t]: c } }),
        [s, c]
      );
    };
  };
  return a.scopeName = t, [r, Q5(a, ...e)];
}
function Q5(...t) {
  const e = t[0];
  if (t.length === 1) return e;
  const n = () => {
    const r = t.map((a) => ({
      useScope: a(),
      scopeName: a.scopeName
    }));
    return function(o) {
      const l = r.reduce((s, { useScope: c, scopeName: d }) => {
        const f = c(o)[`__scope${d}`];
        return { ...s, ...f };
      }, {});
      return $.useMemo(() => ({ [`__scope${e.scopeName}`]: l }), [l]);
    };
  };
  return n.scopeName = e.scopeName, n;
}
var jr = globalThis?.document ? $.useLayoutEffect : () => {
}, e6 = $[" useId ".trim().toString()] || (() => {
}), t6 = 0;
function Ot(t) {
  const [e, n] = $.useState(e6());
  return jr(() => {
    n((r) => r ?? String(t6++));
  }, [t]), e ? `radix-${e}` : "";
}
var n6 = $[" useInsertionEffect ".trim().toString()] || jr;
function r6({
  prop: t,
  defaultProp: e,
  onChange: n = () => {
  },
  caller: r
}) {
  const [a, o, l] = a6({
    defaultProp: e,
    onChange: n
  }), s = t !== void 0, c = s ? t : a;
  {
    const u = $.useRef(t !== void 0);
    $.useEffect(() => {
      const f = u.current;
      f !== s && console.warn(
        `${r} is changing from ${f ? "controlled" : "uncontrolled"} to ${s ? "controlled" : "uncontrolled"}. Components should not switch from controlled to uncontrolled (or vice versa). Decide between using a controlled or uncontrolled value for the lifetime of the component.`
      ), u.current = s;
    }, [s, r]);
  }
  const d = $.useCallback(
    (u) => {
      if (s) {
        const f = i6(u) ? u(t) : u;
        f !== t && l.current?.(f);
      } else
        o(u);
    },
    [s, t, o, l]
  );
  return [c, d];
}
function a6({
  defaultProp: t,
  onChange: e
}) {
  const [n, r] = $.useState(t), a = $.useRef(n), o = $.useRef(e);
  return n6(() => {
    o.current = e;
  }, [e]), $.useEffect(() => {
    a.current !== n && (o.current?.(n), a.current = n);
  }, [n, a]), [n, r, o];
}
function i6(t) {
  return typeof t == "function";
}
// @__NO_SIDE_EFFECTS__
function qu(t) {
  const e = /* @__PURE__ */ o6(t), n = $.forwardRef((r, a) => {
    const { children: o, ...l } = r, s = $.Children.toArray(o), c = s.find(s6);
    if (c) {
      const d = c.props.children, u = s.map((f) => f === c ? $.Children.count(d) > 1 ? $.Children.only(null) : $.isValidElement(d) ? d.props.children : null : f);
      return /* @__PURE__ */ p(e, { ...l, ref: a, children: $.isValidElement(d) ? $.cloneElement(d, void 0, u) : null });
    }
    return /* @__PURE__ */ p(e, { ...l, ref: a, children: o });
  });
  return n.displayName = `${t}.Slot`, n;
}
// @__NO_SIDE_EFFECTS__
function o6(t) {
  const e = $.forwardRef((n, r) => {
    const { children: a, ...o } = n;
    if ($.isValidElement(a)) {
      const l = d6(a), s = c6(o, a.props);
      return a.type !== $.Fragment && (s.ref = r ? xn(r, l) : l), $.cloneElement(a, s);
    }
    return $.Children.count(a) > 1 ? $.Children.only(null) : null;
  });
  return e.displayName = `${t}.SlotClone`, e;
}
var l6 = Symbol("radix.slottable");
function s6(t) {
  return $.isValidElement(t) && typeof t.type == "function" && "__radixId" in t.type && t.type.__radixId === l6;
}
function c6(t, e) {
  const n = { ...e };
  for (const r in e) {
    const a = t[r], o = e[r];
    /^on[A-Z]/.test(r) ? a && o ? n[r] = (...s) => {
      const c = o(...s);
      return a(...s), c;
    } : a && (n[r] = a) : r === "style" ? n[r] = { ...a, ...o } : r === "className" && (n[r] = [a, o].filter(Boolean).join(" "));
  }
  return { ...t, ...n };
}
function d6(t) {
  let e = Object.getOwnPropertyDescriptor(t.props, "ref")?.get, n = e && "isReactWarning" in e && e.isReactWarning;
  return n ? t.ref : (e = Object.getOwnPropertyDescriptor(t, "ref")?.get, n = e && "isReactWarning" in e && e.isReactWarning, n ? t.props.ref : t.props.ref || t.ref);
}
var u6 = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "select",
  "span",
  "svg",
  "ul"
], We = u6.reduce((t, e) => {
  const n = /* @__PURE__ */ qu(`Primitive.${e}`), r = $.forwardRef((a, o) => {
    const { asChild: l, ...s } = a, c = l ? n : e;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ p(c, { ...s, ref: o });
  });
  return r.displayName = `Primitive.${e}`, { ...t, [e]: r };
}, {});
function f6(t, e) {
  t && _4.flushSync(() => t.dispatchEvent(e));
}
function Vr(t) {
  const e = $.useRef(t);
  return $.useEffect(() => {
    e.current = t;
  }), $.useMemo(() => (...n) => e.current?.(...n), []);
}
function p6(t, e = globalThis?.document) {
  const n = Vr(t);
  $.useEffect(() => {
    const r = (a) => {
      a.key === "Escape" && n(a);
    };
    return e.addEventListener("keydown", r, { capture: !0 }), () => e.removeEventListener("keydown", r, { capture: !0 });
  }, [n, e]);
}
var m6 = "DismissableLayer", bl = "dismissableLayer.update", h6 = "dismissableLayer.pointerDownOutside", v6 = "dismissableLayer.focusOutside", wc, Yu = $.createContext({
  layers: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set()
}), Zu = $.forwardRef(
  (t, e) => {
    const {
      disableOutsidePointerEvents: n = !1,
      onEscapeKeyDown: r,
      onPointerDownOutside: a,
      onFocusOutside: o,
      onInteractOutside: l,
      onDismiss: s,
      ...c
    } = t, d = $.useContext(Yu), [u, f] = $.useState(null), m = u?.ownerDocument ?? globalThis?.document, [, g] = $.useState({}), C = An(e, (O) => f(O)), b = Array.from(d.layers), [E] = [...d.layersWithOutsidePointerEventsDisabled].slice(-1), x = b.indexOf(E), _ = u ? b.indexOf(u) : -1, N = d.layersWithOutsidePointerEventsDisabled.size > 0, k = _ >= x, F = b6((O) => {
      const te = O.target, le = [...d.branches].some((W) => W.contains(te));
      !k || le || (a?.(O), l?.(O), O.defaultPrevented || s?.());
    }, m), A = E6((O) => {
      const te = O.target;
      [...d.branches].some((W) => W.contains(te)) || (o?.(O), l?.(O), O.defaultPrevented || s?.());
    }, m);
    return p6((O) => {
      _ === d.layers.size - 1 && (r?.(O), !O.defaultPrevented && s && (O.preventDefault(), s()));
    }, m), $.useEffect(() => {
      if (u)
        return n && (d.layersWithOutsidePointerEventsDisabled.size === 0 && (wc = m.body.style.pointerEvents, m.body.style.pointerEvents = "none"), d.layersWithOutsidePointerEventsDisabled.add(u)), d.layers.add(u), $c(), () => {
          n && d.layersWithOutsidePointerEventsDisabled.size === 1 && (m.body.style.pointerEvents = wc);
        };
    }, [u, m, n, d]), $.useEffect(() => () => {
      u && (d.layers.delete(u), d.layersWithOutsidePointerEventsDisabled.delete(u), $c());
    }, [u, d]), $.useEffect(() => {
      const O = () => g({});
      return document.addEventListener(bl, O), () => document.removeEventListener(bl, O);
    }, []), /* @__PURE__ */ p(
      We.div,
      {
        ...c,
        ref: C,
        style: {
          pointerEvents: N ? k ? "auto" : "none" : void 0,
          ...t.style
        },
        onFocusCapture: tn(t.onFocusCapture, A.onFocusCapture),
        onBlurCapture: tn(t.onBlurCapture, A.onBlurCapture),
        onPointerDownCapture: tn(
          t.onPointerDownCapture,
          F.onPointerDownCapture
        )
      }
    );
  }
);
Zu.displayName = m6;
var g6 = "DismissableLayerBranch", y6 = $.forwardRef((t, e) => {
  const n = $.useContext(Yu), r = $.useRef(null), a = An(e, r);
  return $.useEffect(() => {
    const o = r.current;
    if (o)
      return n.branches.add(o), () => {
        n.branches.delete(o);
      };
  }, [n.branches]), /* @__PURE__ */ p(We.div, { ...t, ref: a });
});
y6.displayName = g6;
function b6(t, e = globalThis?.document) {
  const n = Vr(t), r = $.useRef(!1), a = $.useRef(() => {
  });
  return $.useEffect(() => {
    const o = (s) => {
      if (s.target && !r.current) {
        let c = function() {
          Xu(
            h6,
            n,
            d,
            { discrete: !0 }
          );
        };
        const d = { originalEvent: s };
        s.pointerType === "touch" ? (e.removeEventListener("click", a.current), a.current = c, e.addEventListener("click", a.current, { once: !0 })) : c();
      } else
        e.removeEventListener("click", a.current);
      r.current = !1;
    }, l = window.setTimeout(() => {
      e.addEventListener("pointerdown", o);
    }, 0);
    return () => {
      window.clearTimeout(l), e.removeEventListener("pointerdown", o), e.removeEventListener("click", a.current);
    };
  }, [e, n]), {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: () => r.current = !0
  };
}
function E6(t, e = globalThis?.document) {
  const n = Vr(t), r = $.useRef(!1);
  return $.useEffect(() => {
    const a = (o) => {
      o.target && !r.current && Xu(v6, n, { originalEvent: o }, {
        discrete: !1
      });
    };
    return e.addEventListener("focusin", a), () => e.removeEventListener("focusin", a);
  }, [e, n]), {
    onFocusCapture: () => r.current = !0,
    onBlurCapture: () => r.current = !1
  };
}
function $c() {
  const t = new CustomEvent(bl);
  document.dispatchEvent(t);
}
function Xu(t, e, n, { discrete: r }) {
  const a = n.originalEvent.target, o = new CustomEvent(t, { bubbles: !1, cancelable: !0, detail: n });
  e && a.addEventListener(t, e, { once: !0 }), r ? f6(a, o) : a.dispatchEvent(o);
}
var xo = "focusScope.autoFocusOnMount", Co = "focusScope.autoFocusOnUnmount", xc = { bubbles: !1, cancelable: !0 }, w6 = "FocusScope", Ju = $.forwardRef((t, e) => {
  const {
    loop: n = !1,
    trapped: r = !1,
    onMountAutoFocus: a,
    onUnmountAutoFocus: o,
    ...l
  } = t, [s, c] = $.useState(null), d = Vr(a), u = Vr(o), f = $.useRef(null), m = An(e, (b) => c(b)), g = $.useRef({
    paused: !1,
    pause() {
      this.paused = !0;
    },
    resume() {
      this.paused = !1;
    }
  }).current;
  $.useEffect(() => {
    if (r) {
      let b = function(N) {
        if (g.paused || !s) return;
        const k = N.target;
        s.contains(k) ? f.current = k : Jt(f.current, { select: !0 });
      }, E = function(N) {
        if (g.paused || !s) return;
        const k = N.relatedTarget;
        k !== null && (s.contains(k) || Jt(f.current, { select: !0 }));
      }, x = function(N) {
        if (document.activeElement === document.body)
          for (const F of N)
            F.removedNodes.length > 0 && Jt(s);
      };
      document.addEventListener("focusin", b), document.addEventListener("focusout", E);
      const _ = new MutationObserver(x);
      return s && _.observe(s, { childList: !0, subtree: !0 }), () => {
        document.removeEventListener("focusin", b), document.removeEventListener("focusout", E), _.disconnect();
      };
    }
  }, [r, s, g.paused]), $.useEffect(() => {
    if (s) {
      Mc.add(g);
      const b = document.activeElement;
      if (!s.contains(b)) {
        const x = new CustomEvent(xo, xc);
        s.addEventListener(xo, d), s.dispatchEvent(x), x.defaultPrevented || ($6(F6(Qu(s)), { select: !0 }), document.activeElement === b && Jt(s));
      }
      return () => {
        s.removeEventListener(xo, d), setTimeout(() => {
          const x = new CustomEvent(Co, xc);
          s.addEventListener(Co, u), s.dispatchEvent(x), x.defaultPrevented || Jt(b ?? document.body, { select: !0 }), s.removeEventListener(Co, u), Mc.remove(g);
        }, 0);
      };
    }
  }, [s, d, u, g]);
  const C = $.useCallback(
    (b) => {
      if (!n && !r || g.paused) return;
      const E = b.key === "Tab" && !b.altKey && !b.ctrlKey && !b.metaKey, x = document.activeElement;
      if (E && x) {
        const _ = b.currentTarget, [N, k] = x6(_);
        N && k ? !b.shiftKey && x === k ? (b.preventDefault(), n && Jt(N, { select: !0 })) : b.shiftKey && x === N && (b.preventDefault(), n && Jt(k, { select: !0 })) : x === _ && b.preventDefault();
      }
    },
    [n, r, g.paused]
  );
  return /* @__PURE__ */ p(We.div, { tabIndex: -1, ...l, ref: m, onKeyDown: C });
});
Ju.displayName = w6;
function $6(t, { select: e = !1 } = {}) {
  const n = document.activeElement;
  for (const r of t)
    if (Jt(r, { select: e }), document.activeElement !== n) return;
}
function x6(t) {
  const e = Qu(t), n = Cc(e, t), r = Cc(e.reverse(), t);
  return [n, r];
}
function Qu(t) {
  const e = [], n = document.createTreeWalker(t, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (r) => {
      const a = r.tagName === "INPUT" && r.type === "hidden";
      return r.disabled || r.hidden || a ? NodeFilter.FILTER_SKIP : r.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; n.nextNode(); ) e.push(n.currentNode);
  return e;
}
function Cc(t, e) {
  for (const n of t)
    if (!C6(n, { upTo: e })) return n;
}
function C6(t, { upTo: e }) {
  if (getComputedStyle(t).visibility === "hidden") return !0;
  for (; t; ) {
    if (e !== void 0 && t === e) return !1;
    if (getComputedStyle(t).display === "none") return !0;
    t = t.parentElement;
  }
  return !1;
}
function M6(t) {
  return t instanceof HTMLInputElement && "select" in t;
}
function Jt(t, { select: e = !1 } = {}) {
  if (t && t.focus) {
    const n = document.activeElement;
    t.focus({ preventScroll: !0 }), t !== n && M6(t) && e && t.select();
  }
}
var Mc = S6();
function S6() {
  let t = [];
  return {
    add(e) {
      const n = t[0];
      e !== n && n?.pause(), t = Sc(t, e), t.unshift(e);
    },
    remove(e) {
      t = Sc(t, e), t[0]?.resume();
    }
  };
}
function Sc(t, e) {
  const n = [...t], r = n.indexOf(e);
  return r !== -1 && n.splice(r, 1), n;
}
function F6(t) {
  return t.filter((e) => e.tagName !== "A");
}
var P6 = "Portal", e2 = $.forwardRef((t, e) => {
  const { container: n, ...r } = t, [a, o] = $.useState(!1);
  jr(() => o(!0), []);
  const l = n || a && globalThis?.document?.body;
  return l ? T4.createPortal(/* @__PURE__ */ p(We.div, { ...r, ref: e }), l) : null;
});
e2.displayName = P6;
function N6(t, e) {
  return $.useReducer((n, r) => e[n][r] ?? n, t);
}
var Bi = (t) => {
  const { present: e, children: n } = t, r = _6(e), a = typeof n == "function" ? n({ present: r.isPresent }) : $.Children.only(n), o = An(r.ref, T6(a));
  return typeof n == "function" || r.isPresent ? $.cloneElement(a, { ref: o }) : null;
};
Bi.displayName = "Presence";
function _6(t) {
  const [e, n] = $.useState(), r = $.useRef(null), a = $.useRef(t), o = $.useRef("none"), l = t ? "mounted" : "unmounted", [s, c] = N6(l, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return $.useEffect(() => {
    const d = Aa(r.current);
    o.current = s === "mounted" ? d : "none";
  }, [s]), jr(() => {
    const d = r.current, u = a.current;
    if (u !== t) {
      const m = o.current, g = Aa(d);
      t ? c("MOUNT") : g === "none" || d?.display === "none" ? c("UNMOUNT") : c(u && m !== g ? "ANIMATION_OUT" : "UNMOUNT"), a.current = t;
    }
  }, [t, c]), jr(() => {
    if (e) {
      let d;
      const u = e.ownerDocument.defaultView ?? window, f = (g) => {
        const b = Aa(r.current).includes(CSS.escape(g.animationName));
        if (g.target === e && b && (c("ANIMATION_END"), !a.current)) {
          const E = e.style.animationFillMode;
          e.style.animationFillMode = "forwards", d = u.setTimeout(() => {
            e.style.animationFillMode === "forwards" && (e.style.animationFillMode = E);
          });
        }
      }, m = (g) => {
        g.target === e && (o.current = Aa(r.current));
      };
      return e.addEventListener("animationstart", m), e.addEventListener("animationcancel", f), e.addEventListener("animationend", f), () => {
        u.clearTimeout(d), e.removeEventListener("animationstart", m), e.removeEventListener("animationcancel", f), e.removeEventListener("animationend", f);
      };
    } else
      c("ANIMATION_END");
  }, [e, c]), {
    isPresent: ["mounted", "unmountSuspended"].includes(s),
    ref: $.useCallback((d) => {
      r.current = d ? getComputedStyle(d) : null, n(d);
    }, [])
  };
}
function Aa(t) {
  return t?.animationName || "none";
}
function T6(t) {
  let e = Object.getOwnPropertyDescriptor(t.props, "ref")?.get, n = e && "isReactWarning" in e && e.isReactWarning;
  return n ? t.ref : (e = Object.getOwnPropertyDescriptor(t, "ref")?.get, n = e && "isReactWarning" in e && e.isReactWarning, n ? t.props.ref : t.props.ref || t.ref);
}
var Mo = 0;
function A6() {
  $.useEffect(() => {
    const t = document.querySelectorAll("[data-radix-focus-guard]");
    return document.body.insertAdjacentElement("afterbegin", t[0] ?? Fc()), document.body.insertAdjacentElement("beforeend", t[1] ?? Fc()), Mo++, () => {
      Mo === 1 && document.querySelectorAll("[data-radix-focus-guard]").forEach((e) => e.remove()), Mo--;
    };
  }, []);
}
function Fc() {
  const t = document.createElement("span");
  return t.setAttribute("data-radix-focus-guard", ""), t.tabIndex = 0, t.style.outline = "none", t.style.opacity = "0", t.style.position = "fixed", t.style.pointerEvents = "none", t;
}
var yt = function() {
  return yt = Object.assign || function(e) {
    for (var n, r = 1, a = arguments.length; r < a; r++) {
      n = arguments[r];
      for (var o in n) Object.prototype.hasOwnProperty.call(n, o) && (e[o] = n[o]);
    }
    return e;
  }, yt.apply(this, arguments);
};
function t2(t, e) {
  var n = {};
  for (var r in t) Object.prototype.hasOwnProperty.call(t, r) && e.indexOf(r) < 0 && (n[r] = t[r]);
  if (t != null && typeof Object.getOwnPropertySymbols == "function")
    for (var a = 0, r = Object.getOwnPropertySymbols(t); a < r.length; a++)
      e.indexOf(r[a]) < 0 && Object.prototype.propertyIsEnumerable.call(t, r[a]) && (n[r[a]] = t[r[a]]);
  return n;
}
function zn(t, e, n, r) {
  function a(o) {
    return o instanceof n ? o : new n(function(l) {
      l(o);
    });
  }
  return new (n || (n = Promise))(function(o, l) {
    function s(u) {
      try {
        d(r.next(u));
      } catch (f) {
        l(f);
      }
    }
    function c(u) {
      try {
        d(r.throw(u));
      } catch (f) {
        l(f);
      }
    }
    function d(u) {
      u.done ? o(u.value) : a(u.value).then(s, c);
    }
    d((r = r.apply(t, e || [])).next());
  });
}
function z6(t, e, n) {
  if (n || arguments.length === 2) for (var r = 0, a = e.length, o; r < a; r++)
    (o || !(r in e)) && (o || (o = Array.prototype.slice.call(e, 0, r)), o[r] = e[r]);
  return t.concat(o || Array.prototype.slice.call(e));
}
var Qa = "right-scroll-bar-position", ei = "width-before-scroll-bar", D6 = "with-scroll-bars-hidden", I6 = "--removed-body-scroll-bar-size";
function So(t, e) {
  return typeof t == "function" ? t(e) : t && (t.current = e), t;
}
function k6(t, e) {
  var n = ve(function() {
    return {
      // value
      value: t,
      // last callback
      callback: e,
      // "memoized" public interface
      facade: {
        get current() {
          return n.value;
        },
        set current(r) {
          var a = n.value;
          a !== r && (n.value = r, n.callback(r, a));
        }
      }
    };
  })[0];
  return n.callback = e, n.facade;
}
var O6 = typeof window < "u" ? $.useLayoutEffect : $.useEffect, Pc = /* @__PURE__ */ new WeakMap();
function L6(t, e) {
  var n = k6(null, function(r) {
    return t.forEach(function(a) {
      return So(a, r);
    });
  });
  return O6(function() {
    var r = Pc.get(n);
    if (r) {
      var a = new Set(r), o = new Set(t), l = n.current;
      a.forEach(function(s) {
        o.has(s) || So(s, null);
      }), o.forEach(function(s) {
        a.has(s) || So(s, l);
      });
    }
    Pc.set(n, t);
  }, [t]), n;
}
function R6(t) {
  return t;
}
function H6(t, e) {
  e === void 0 && (e = R6);
  var n = [], r = !1, a = {
    read: function() {
      if (r)
        throw new Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
      return n.length ? n[n.length - 1] : t;
    },
    useMedium: function(o) {
      var l = e(o, r);
      return n.push(l), function() {
        n = n.filter(function(s) {
          return s !== l;
        });
      };
    },
    assignSyncMedium: function(o) {
      for (r = !0; n.length; ) {
        var l = n;
        n = [], l.forEach(o);
      }
      n = {
        push: function(s) {
          return o(s);
        },
        filter: function() {
          return n;
        }
      };
    },
    assignMedium: function(o) {
      r = !0;
      var l = [];
      if (n.length) {
        var s = n;
        n = [], s.forEach(o), l = n;
      }
      var c = function() {
        var u = l;
        l = [], u.forEach(o);
      }, d = function() {
        return Promise.resolve().then(c);
      };
      d(), n = {
        push: function(u) {
          l.push(u), d();
        },
        filter: function(u) {
          return l = l.filter(u), n;
        }
      };
    }
  };
  return a;
}
function B6(t) {
  t === void 0 && (t = {});
  var e = H6(null);
  return e.options = yt({ async: !0, ssr: !1 }, t), e;
}
var n2 = function(t) {
  var e = t.sideCar, n = t2(t, ["sideCar"]);
  if (!e)
    throw new Error("Sidecar: please provide `sideCar` property to import the right car");
  var r = e.read();
  if (!r)
    throw new Error("Sidecar medium not found");
  return $.createElement(r, yt({}, n));
};
n2.isSideCarExport = !0;
function j6(t, e) {
  return t.useMedium(e), n2;
}
var r2 = B6(), Fo = function() {
}, ji = $.forwardRef(function(t, e) {
  var n = $.useRef(null), r = $.useState({
    onScrollCapture: Fo,
    onWheelCapture: Fo,
    onTouchMoveCapture: Fo
  }), a = r[0], o = r[1], l = t.forwardProps, s = t.children, c = t.className, d = t.removeScrollBar, u = t.enabled, f = t.shards, m = t.sideCar, g = t.noRelative, C = t.noIsolation, b = t.inert, E = t.allowPinchZoom, x = t.as, _ = x === void 0 ? "div" : x, N = t.gapMode, k = t2(t, ["forwardProps", "children", "className", "removeScrollBar", "enabled", "shards", "sideCar", "noRelative", "noIsolation", "inert", "allowPinchZoom", "as", "gapMode"]), F = m, A = L6([n, e]), O = yt(yt({}, k), a);
  return $.createElement(
    $.Fragment,
    null,
    u && $.createElement(F, { sideCar: r2, removeScrollBar: d, shards: f, noRelative: g, noIsolation: C, inert: b, setCallbacks: o, allowPinchZoom: !!E, lockRef: n, gapMode: N }),
    l ? $.cloneElement($.Children.only(s), yt(yt({}, O), { ref: A })) : $.createElement(_, yt({}, O, { className: c, ref: A }), s)
  );
});
ji.defaultProps = {
  enabled: !0,
  removeScrollBar: !0,
  inert: !1
};
ji.classNames = {
  fullWidth: ei,
  zeroRight: Qa
};
var V6 = function() {
  if (typeof __webpack_nonce__ < "u")
    return __webpack_nonce__;
};
function U6() {
  if (!document)
    return null;
  var t = document.createElement("style");
  t.type = "text/css";
  var e = V6();
  return e && t.setAttribute("nonce", e), t;
}
function W6(t, e) {
  t.styleSheet ? t.styleSheet.cssText = e : t.appendChild(document.createTextNode(e));
}
function G6(t) {
  var e = document.head || document.getElementsByTagName("head")[0];
  e.appendChild(t);
}
var K6 = function() {
  var t = 0, e = null;
  return {
    add: function(n) {
      t == 0 && (e = U6()) && (W6(e, n), G6(e)), t++;
    },
    remove: function() {
      t--, !t && e && (e.parentNode && e.parentNode.removeChild(e), e = null);
    }
  };
}, q6 = function() {
  var t = K6();
  return function(e, n) {
    $.useEffect(function() {
      return t.add(e), function() {
        t.remove();
      };
    }, [e && n]);
  };
}, a2 = function() {
  var t = q6(), e = function(n) {
    var r = n.styles, a = n.dynamic;
    return t(r, a), null;
  };
  return e;
}, Y6 = {
  left: 0,
  top: 0,
  right: 0,
  gap: 0
}, Po = function(t) {
  return parseInt(t || "", 10) || 0;
}, Z6 = function(t) {
  var e = window.getComputedStyle(document.body), n = e[t === "padding" ? "paddingLeft" : "marginLeft"], r = e[t === "padding" ? "paddingTop" : "marginTop"], a = e[t === "padding" ? "paddingRight" : "marginRight"];
  return [Po(n), Po(r), Po(a)];
}, X6 = function(t) {
  if (t === void 0 && (t = "margin"), typeof window > "u")
    return Y6;
  var e = Z6(t), n = document.documentElement.clientWidth, r = window.innerWidth;
  return {
    left: e[0],
    top: e[1],
    right: e[2],
    gap: Math.max(0, r - n + e[2] - e[0])
  };
}, J6 = a2(), tr = "data-scroll-locked", Q6 = function(t, e, n, r) {
  var a = t.left, o = t.top, l = t.right, s = t.gap;
  return n === void 0 && (n = "margin"), `
  .`.concat(D6, ` {
   overflow: hidden `).concat(r, `;
   padding-right: `).concat(s, "px ").concat(r, `;
  }
  body[`).concat(tr, `] {
    overflow: hidden `).concat(r, `;
    overscroll-behavior: contain;
    `).concat([
    e && "position: relative ".concat(r, ";"),
    n === "margin" && `
    padding-left: `.concat(a, `px;
    padding-top: `).concat(o, `px;
    padding-right: `).concat(l, `px;
    margin-left:0;
    margin-top:0;
    margin-right: `).concat(s, "px ").concat(r, `;
    `),
    n === "padding" && "padding-right: ".concat(s, "px ").concat(r, ";")
  ].filter(Boolean).join(""), `
  }
  
  .`).concat(Qa, ` {
    right: `).concat(s, "px ").concat(r, `;
  }
  
  .`).concat(ei, ` {
    margin-right: `).concat(s, "px ").concat(r, `;
  }
  
  .`).concat(Qa, " .").concat(Qa, ` {
    right: 0 `).concat(r, `;
  }
  
  .`).concat(ei, " .").concat(ei, ` {
    margin-right: 0 `).concat(r, `;
  }
  
  body[`).concat(tr, `] {
    `).concat(I6, ": ").concat(s, `px;
  }
`);
}, Nc = function() {
  var t = parseInt(document.body.getAttribute(tr) || "0", 10);
  return isFinite(t) ? t : 0;
}, ev = function() {
  $.useEffect(function() {
    return document.body.setAttribute(tr, (Nc() + 1).toString()), function() {
      var t = Nc() - 1;
      t <= 0 ? document.body.removeAttribute(tr) : document.body.setAttribute(tr, t.toString());
    };
  }, []);
}, tv = function(t) {
  var e = t.noRelative, n = t.noImportant, r = t.gapMode, a = r === void 0 ? "margin" : r;
  ev();
  var o = $.useMemo(function() {
    return X6(a);
  }, [a]);
  return $.createElement(J6, { styles: Q6(o, !e, a, n ? "" : "!important") });
}, El = !1;
if (typeof window < "u")
  try {
    var za = Object.defineProperty({}, "passive", {
      get: function() {
        return El = !0, !0;
      }
    });
    window.addEventListener("test", za, za), window.removeEventListener("test", za, za);
  } catch {
    El = !1;
  }
var kn = El ? { passive: !1 } : !1, nv = function(t) {
  return t.tagName === "TEXTAREA";
}, i2 = function(t, e) {
  if (!(t instanceof Element))
    return !1;
  var n = window.getComputedStyle(t);
  return (
    // not-not-scrollable
    n[e] !== "hidden" && // contains scroll inside self
    !(n.overflowY === n.overflowX && !nv(t) && n[e] === "visible")
  );
}, rv = function(t) {
  return i2(t, "overflowY");
}, av = function(t) {
  return i2(t, "overflowX");
}, _c = function(t, e) {
  var n = e.ownerDocument, r = e;
  do {
    typeof ShadowRoot < "u" && r instanceof ShadowRoot && (r = r.host);
    var a = o2(t, r);
    if (a) {
      var o = l2(t, r), l = o[1], s = o[2];
      if (l > s)
        return !0;
    }
    r = r.parentNode;
  } while (r && r !== n.body);
  return !1;
}, iv = function(t) {
  var e = t.scrollTop, n = t.scrollHeight, r = t.clientHeight;
  return [
    e,
    n,
    r
  ];
}, ov = function(t) {
  var e = t.scrollLeft, n = t.scrollWidth, r = t.clientWidth;
  return [
    e,
    n,
    r
  ];
}, o2 = function(t, e) {
  return t === "v" ? rv(e) : av(e);
}, l2 = function(t, e) {
  return t === "v" ? iv(e) : ov(e);
}, lv = function(t, e) {
  return t === "h" && e === "rtl" ? -1 : 1;
}, sv = function(t, e, n, r, a) {
  var o = lv(t, window.getComputedStyle(e).direction), l = o * r, s = n.target, c = e.contains(s), d = !1, u = l > 0, f = 0, m = 0;
  do {
    if (!s)
      break;
    var g = l2(t, s), C = g[0], b = g[1], E = g[2], x = b - E - o * C;
    (C || x) && o2(t, s) && (f += x, m += C);
    var _ = s.parentNode;
    s = _ && _.nodeType === Node.DOCUMENT_FRAGMENT_NODE ? _.host : _;
  } while (
    // portaled content
    !c && s !== document.body || // self content
    c && (e.contains(s) || e === s)
  );
  return (u && Math.abs(f) < 1 || !u && Math.abs(m) < 1) && (d = !0), d;
}, Da = function(t) {
  return "changedTouches" in t ? [t.changedTouches[0].clientX, t.changedTouches[0].clientY] : [0, 0];
}, Tc = function(t) {
  return [t.deltaX, t.deltaY];
}, Ac = function(t) {
  return t && "current" in t ? t.current : t;
}, cv = function(t, e) {
  return t[0] === e[0] && t[1] === e[1];
}, dv = function(t) {
  return `
  .block-interactivity-`.concat(t, ` {pointer-events: none;}
  .allow-interactivity-`).concat(t, ` {pointer-events: all;}
`);
}, uv = 0, On = [];
function fv(t) {
  var e = $.useRef([]), n = $.useRef([0, 0]), r = $.useRef(), a = $.useState(uv++)[0], o = $.useState(a2)[0], l = $.useRef(t);
  $.useEffect(function() {
    l.current = t;
  }, [t]), $.useEffect(function() {
    if (t.inert) {
      document.body.classList.add("block-interactivity-".concat(a));
      var b = z6([t.lockRef.current], (t.shards || []).map(Ac), !0).filter(Boolean);
      return b.forEach(function(E) {
        return E.classList.add("allow-interactivity-".concat(a));
      }), function() {
        document.body.classList.remove("block-interactivity-".concat(a)), b.forEach(function(E) {
          return E.classList.remove("allow-interactivity-".concat(a));
        });
      };
    }
  }, [t.inert, t.lockRef.current, t.shards]);
  var s = $.useCallback(function(b, E) {
    if ("touches" in b && b.touches.length === 2 || b.type === "wheel" && b.ctrlKey)
      return !l.current.allowPinchZoom;
    var x = Da(b), _ = n.current, N = "deltaX" in b ? b.deltaX : _[0] - x[0], k = "deltaY" in b ? b.deltaY : _[1] - x[1], F, A = b.target, O = Math.abs(N) > Math.abs(k) ? "h" : "v";
    if ("touches" in b && O === "h" && A.type === "range")
      return !1;
    var te = _c(O, A);
    if (!te)
      return !0;
    if (te ? F = O : (F = O === "v" ? "h" : "v", te = _c(O, A)), !te)
      return !1;
    if (!r.current && "changedTouches" in b && (N || k) && (r.current = F), !F)
      return !0;
    var le = r.current || F;
    return sv(le, E, b, le === "h" ? N : k);
  }, []), c = $.useCallback(function(b) {
    var E = b;
    if (!(!On.length || On[On.length - 1] !== o)) {
      var x = "deltaY" in E ? Tc(E) : Da(E), _ = e.current.filter(function(F) {
        return F.name === E.type && (F.target === E.target || E.target === F.shadowParent) && cv(F.delta, x);
      })[0];
      if (_ && _.should) {
        E.cancelable && E.preventDefault();
        return;
      }
      if (!_) {
        var N = (l.current.shards || []).map(Ac).filter(Boolean).filter(function(F) {
          return F.contains(E.target);
        }), k = N.length > 0 ? s(E, N[0]) : !l.current.noIsolation;
        k && E.cancelable && E.preventDefault();
      }
    }
  }, []), d = $.useCallback(function(b, E, x, _) {
    var N = { name: b, delta: E, target: x, should: _, shadowParent: pv(x) };
    e.current.push(N), setTimeout(function() {
      e.current = e.current.filter(function(k) {
        return k !== N;
      });
    }, 1);
  }, []), u = $.useCallback(function(b) {
    n.current = Da(b), r.current = void 0;
  }, []), f = $.useCallback(function(b) {
    d(b.type, Tc(b), b.target, s(b, t.lockRef.current));
  }, []), m = $.useCallback(function(b) {
    d(b.type, Da(b), b.target, s(b, t.lockRef.current));
  }, []);
  $.useEffect(function() {
    return On.push(o), t.setCallbacks({
      onScrollCapture: f,
      onWheelCapture: f,
      onTouchMoveCapture: m
    }), document.addEventListener("wheel", c, kn), document.addEventListener("touchmove", c, kn), document.addEventListener("touchstart", u, kn), function() {
      On = On.filter(function(b) {
        return b !== o;
      }), document.removeEventListener("wheel", c, kn), document.removeEventListener("touchmove", c, kn), document.removeEventListener("touchstart", u, kn);
    };
  }, []);
  var g = t.removeScrollBar, C = t.inert;
  return $.createElement(
    $.Fragment,
    null,
    C ? $.createElement(o, { styles: dv(a) }) : null,
    g ? $.createElement(tv, { noRelative: t.noRelative, gapMode: t.gapMode }) : null
  );
}
function pv(t) {
  for (var e = null; t !== null; )
    t instanceof ShadowRoot && (e = t.host, t = t.host), t = t.parentNode;
  return e;
}
const mv = j6(r2, fv);
var s2 = $.forwardRef(function(t, e) {
  return $.createElement(ji, yt({}, t, { ref: e, sideCar: mv }));
});
s2.classNames = ji.classNames;
var hv = function(t) {
  if (typeof document > "u")
    return null;
  var e = Array.isArray(t) ? t[0] : t;
  return e.ownerDocument.body;
}, Ln = /* @__PURE__ */ new WeakMap(), Ia = /* @__PURE__ */ new WeakMap(), ka = {}, No = 0, c2 = function(t) {
  return t && (t.host || c2(t.parentNode));
}, vv = function(t, e) {
  return e.map(function(n) {
    if (t.contains(n))
      return n;
    var r = c2(n);
    return r && t.contains(r) ? r : (console.error("aria-hidden", n, "in not contained inside", t, ". Doing nothing"), null);
  }).filter(function(n) {
    return !!n;
  });
}, gv = function(t, e, n, r) {
  var a = vv(e, Array.isArray(t) ? t : [t]);
  ka[n] || (ka[n] = /* @__PURE__ */ new WeakMap());
  var o = ka[n], l = [], s = /* @__PURE__ */ new Set(), c = new Set(a), d = function(f) {
    !f || s.has(f) || (s.add(f), d(f.parentNode));
  };
  a.forEach(d);
  var u = function(f) {
    !f || c.has(f) || Array.prototype.forEach.call(f.children, function(m) {
      if (s.has(m))
        u(m);
      else
        try {
          var g = m.getAttribute(r), C = g !== null && g !== "false", b = (Ln.get(m) || 0) + 1, E = (o.get(m) || 0) + 1;
          Ln.set(m, b), o.set(m, E), l.push(m), b === 1 && C && Ia.set(m, !0), E === 1 && m.setAttribute(n, "true"), C || m.setAttribute(r, "true");
        } catch (x) {
          console.error("aria-hidden: cannot operate on ", m, x);
        }
    });
  };
  return u(e), s.clear(), No++, function() {
    l.forEach(function(f) {
      var m = Ln.get(f) - 1, g = o.get(f) - 1;
      Ln.set(f, m), o.set(f, g), m || (Ia.has(f) || f.removeAttribute(r), Ia.delete(f)), g || f.removeAttribute(n);
    }), No--, No || (Ln = /* @__PURE__ */ new WeakMap(), Ln = /* @__PURE__ */ new WeakMap(), Ia = /* @__PURE__ */ new WeakMap(), ka = {});
  };
}, yv = function(t, e, n) {
  n === void 0 && (n = "data-aria-hidden");
  var r = Array.from(Array.isArray(t) ? t : [t]), a = hv(t);
  return a ? (r.push.apply(r, Array.from(a.querySelectorAll("[aria-live], script"))), gv(r, a, n, "aria-hidden")) : function() {
    return null;
  };
}, Vi = "Dialog", [d2, wO] = J5(Vi), [bv, vt] = d2(Vi), u2 = (t) => {
  const {
    __scopeDialog: e,
    children: n,
    open: r,
    defaultOpen: a,
    onOpenChange: o,
    modal: l = !0
  } = t, s = $.useRef(null), c = $.useRef(null), [d, u] = r6({
    prop: r,
    defaultProp: a ?? !1,
    onChange: o,
    caller: Vi
  });
  return /* @__PURE__ */ p(
    bv,
    {
      scope: e,
      triggerRef: s,
      contentRef: c,
      contentId: Ot(),
      titleId: Ot(),
      descriptionId: Ot(),
      open: d,
      onOpenChange: u,
      onOpenToggle: $.useCallback(() => u((f) => !f), [u]),
      modal: l,
      children: n
    }
  );
};
u2.displayName = Vi;
var f2 = "DialogTrigger", Ev = $.forwardRef(
  (t, e) => {
    const { __scopeDialog: n, ...r } = t, a = vt(f2, n), o = An(e, a.triggerRef);
    return /* @__PURE__ */ p(
      We.button,
      {
        type: "button",
        "aria-haspopup": "dialog",
        "aria-expanded": a.open,
        "aria-controls": a.contentId,
        "data-state": $s(a.open),
        ...r,
        ref: o,
        onClick: tn(t.onClick, a.onOpenToggle)
      }
    );
  }
);
Ev.displayName = f2;
var Es = "DialogPortal", [wv, p2] = d2(Es, {
  forceMount: void 0
}), m2 = (t) => {
  const { __scopeDialog: e, forceMount: n, children: r, container: a } = t, o = vt(Es, e);
  return /* @__PURE__ */ p(wv, { scope: e, forceMount: n, children: $.Children.map(r, (l) => /* @__PURE__ */ p(Bi, { present: n || o.open, children: /* @__PURE__ */ p(e2, { asChild: !0, container: a, children: l }) })) });
};
m2.displayName = Es;
var ui = "DialogOverlay", h2 = $.forwardRef(
  (t, e) => {
    const n = p2(ui, t.__scopeDialog), { forceMount: r = n.forceMount, ...a } = t, o = vt(ui, t.__scopeDialog);
    return o.modal ? /* @__PURE__ */ p(Bi, { present: r || o.open, children: /* @__PURE__ */ p(xv, { ...a, ref: e }) }) : null;
  }
);
h2.displayName = ui;
var $v = /* @__PURE__ */ qu("DialogOverlay.RemoveScroll"), xv = $.forwardRef(
  (t, e) => {
    const { __scopeDialog: n, ...r } = t, a = vt(ui, n);
    return (
      // Make sure `Content` is scrollable even when it doesn't live inside `RemoveScroll`
      // ie. when `Overlay` and `Content` are siblings
      /* @__PURE__ */ p(s2, { as: $v, allowPinchZoom: !0, shards: [a.contentRef], children: /* @__PURE__ */ p(
        We.div,
        {
          "data-state": $s(a.open),
          ...r,
          ref: e,
          style: { pointerEvents: "auto", ...r.style }
        }
      ) })
    );
  }
), Cn = "DialogContent", v2 = $.forwardRef(
  (t, e) => {
    const n = p2(Cn, t.__scopeDialog), { forceMount: r = n.forceMount, ...a } = t, o = vt(Cn, t.__scopeDialog);
    return /* @__PURE__ */ p(Bi, { present: r || o.open, children: o.modal ? /* @__PURE__ */ p(Cv, { ...a, ref: e }) : /* @__PURE__ */ p(Mv, { ...a, ref: e }) });
  }
);
v2.displayName = Cn;
var Cv = $.forwardRef(
  (t, e) => {
    const n = vt(Cn, t.__scopeDialog), r = $.useRef(null), a = An(e, n.contentRef, r);
    return $.useEffect(() => {
      const o = r.current;
      if (o) return yv(o);
    }, []), /* @__PURE__ */ p(
      g2,
      {
        ...t,
        ref: a,
        trapFocus: n.open,
        disableOutsidePointerEvents: !0,
        onCloseAutoFocus: tn(t.onCloseAutoFocus, (o) => {
          o.preventDefault(), n.triggerRef.current?.focus();
        }),
        onPointerDownOutside: tn(t.onPointerDownOutside, (o) => {
          const l = o.detail.originalEvent, s = l.button === 0 && l.ctrlKey === !0;
          (l.button === 2 || s) && o.preventDefault();
        }),
        onFocusOutside: tn(
          t.onFocusOutside,
          (o) => o.preventDefault()
        )
      }
    );
  }
), Mv = $.forwardRef(
  (t, e) => {
    const n = vt(Cn, t.__scopeDialog), r = $.useRef(!1), a = $.useRef(!1);
    return /* @__PURE__ */ p(
      g2,
      {
        ...t,
        ref: e,
        trapFocus: !1,
        disableOutsidePointerEvents: !1,
        onCloseAutoFocus: (o) => {
          t.onCloseAutoFocus?.(o), o.defaultPrevented || (r.current || n.triggerRef.current?.focus(), o.preventDefault()), r.current = !1, a.current = !1;
        },
        onInteractOutside: (o) => {
          t.onInteractOutside?.(o), o.defaultPrevented || (r.current = !0, o.detail.originalEvent.type === "pointerdown" && (a.current = !0));
          const l = o.target;
          n.triggerRef.current?.contains(l) && o.preventDefault(), o.detail.originalEvent.type === "focusin" && a.current && o.preventDefault();
        }
      }
    );
  }
), g2 = $.forwardRef(
  (t, e) => {
    const { __scopeDialog: n, trapFocus: r, onOpenAutoFocus: a, onCloseAutoFocus: o, ...l } = t, s = vt(Cn, n), c = $.useRef(null), d = An(e, c);
    return A6(), /* @__PURE__ */ S($t, { children: [
      /* @__PURE__ */ p(
        Ju,
        {
          asChild: !0,
          loop: !0,
          trapped: r,
          onMountAutoFocus: a,
          onUnmountAutoFocus: o,
          children: /* @__PURE__ */ p(
            Zu,
            {
              role: "dialog",
              id: s.contentId,
              "aria-describedby": s.descriptionId,
              "aria-labelledby": s.titleId,
              "data-state": $s(s.open),
              ...l,
              ref: d,
              onDismiss: () => s.onOpenChange(!1)
            }
          )
        }
      ),
      /* @__PURE__ */ S($t, { children: [
        /* @__PURE__ */ p(Nv, { titleId: s.titleId }),
        /* @__PURE__ */ p(Tv, { contentRef: c, descriptionId: s.descriptionId })
      ] })
    ] });
  }
), ws = "DialogTitle", Sv = $.forwardRef(
  (t, e) => {
    const { __scopeDialog: n, ...r } = t, a = vt(ws, n);
    return /* @__PURE__ */ p(We.h2, { id: a.titleId, ...r, ref: e });
  }
);
Sv.displayName = ws;
var y2 = "DialogDescription", Fv = $.forwardRef(
  (t, e) => {
    const { __scopeDialog: n, ...r } = t, a = vt(y2, n);
    return /* @__PURE__ */ p(We.p, { id: a.descriptionId, ...r, ref: e });
  }
);
Fv.displayName = y2;
var b2 = "DialogClose", Pv = $.forwardRef(
  (t, e) => {
    const { __scopeDialog: n, ...r } = t, a = vt(b2, n);
    return /* @__PURE__ */ p(
      We.button,
      {
        type: "button",
        ...r,
        ref: e,
        onClick: tn(t.onClick, () => a.onOpenChange(!1))
      }
    );
  }
);
Pv.displayName = b2;
function $s(t) {
  return t ? "open" : "closed";
}
var E2 = "DialogTitleWarning", [$O, w2] = X5(E2, {
  contentName: Cn,
  titleName: ws,
  docsSlug: "dialog"
}), Nv = ({ titleId: t }) => {
  const e = w2(E2), n = `\`${e.contentName}\` requires a \`${e.titleName}\` for the component to be accessible for screen reader users.

If you want to hide the \`${e.titleName}\`, you can wrap it with our VisuallyHidden component.

For more information, see https://radix-ui.com/primitives/docs/components/${e.docsSlug}`;
  return $.useEffect(() => {
    t && (document.getElementById(t) || console.error(n));
  }, [n, t]), null;
}, _v = "DialogDescriptionWarning", Tv = ({ contentRef: t, descriptionId: e }) => {
  const r = `Warning: Missing \`Description\` or \`aria-describedby={undefined}\` for {${w2(_v).contentName}}.`;
  return $.useEffect(() => {
    const a = t.current?.getAttribute("aria-describedby");
    e && a && (document.getElementById(e) || console.warn(r));
  }, [r, t, e]), null;
}, Av = u2, zv = m2, Dv = h2, Iv = v2, xr = '[cmdk-group=""]', _o = '[cmdk-group-items=""]', kv = '[cmdk-group-heading=""]', $2 = '[cmdk-item=""]', zc = `${$2}:not([aria-disabled="true"])`, wl = "cmdk-item-select", Gn = "data-value", Ov = (t, e, n) => Z5(t, e, n), x2 = $.createContext(void 0), Sa = () => $.useContext(x2), C2 = $.createContext(void 0), xs = () => $.useContext(C2), M2 = $.createContext(void 0), S2 = $.forwardRef((t, e) => {
  let n = Kn(() => {
    var P, D;
    return { search: "", value: (D = (P = t.value) != null ? P : t.defaultValue) != null ? D : "", selectedItemId: void 0, filtered: { count: 0, items: /* @__PURE__ */ new Map(), groups: /* @__PURE__ */ new Set() } };
  }), r = Kn(() => /* @__PURE__ */ new Set()), a = Kn(() => /* @__PURE__ */ new Map()), o = Kn(() => /* @__PURE__ */ new Map()), l = Kn(() => /* @__PURE__ */ new Set()), s = F2(t), { label: c, children: d, value: u, onValueChange: f, filter: m, shouldFilter: g, loop: C, disablePointerSelection: b = !1, vimBindings: E = !0, ...x } = t, _ = Ot(), N = Ot(), k = Ot(), F = $.useRef(null), A = Yv();
  Mn(() => {
    if (u !== void 0) {
      let P = u.trim();
      n.current.value = P, O.emit();
    }
  }, [u]), Mn(() => {
    A(6, ee);
  }, []);
  let O = $.useMemo(() => ({ subscribe: (P) => (l.current.add(P), () => l.current.delete(P)), snapshot: () => n.current, setState: (P, D, B) => {
    var H, j, Z, ne;
    if (!Object.is(n.current[P], D)) {
      if (n.current[P] = D, P === "search") Y(), W(), A(1, y);
      else if (P === "value") {
        if (document.activeElement.hasAttribute("cmdk-input") || document.activeElement.hasAttribute("cmdk-root")) {
          let ie = document.getElementById(k);
          ie ? ie.focus() : (H = document.getElementById(_)) == null || H.focus();
        }
        if (A(7, () => {
          var ie;
          n.current.selectedItemId = (ie = I()) == null ? void 0 : ie.id, O.emit();
        }), B || A(5, ee), ((j = s.current) == null ? void 0 : j.value) !== void 0) {
          let ie = D ?? "";
          (ne = (Z = s.current).onValueChange) == null || ne.call(Z, ie);
          return;
        }
      }
      O.emit();
    }
  }, emit: () => {
    l.current.forEach((P) => P());
  } }), []), te = $.useMemo(() => ({ value: (P, D, B) => {
    var H;
    D !== ((H = o.current.get(P)) == null ? void 0 : H.value) && (o.current.set(P, { value: D, keywords: B }), n.current.filtered.items.set(P, le(D, B)), A(2, () => {
      W(), O.emit();
    }));
  }, item: (P, D) => (r.current.add(P), D && (a.current.has(D) ? a.current.get(D).add(P) : a.current.set(D, /* @__PURE__ */ new Set([P]))), A(3, () => {
    Y(), W(), n.current.value || y(), O.emit();
  }), () => {
    o.current.delete(P), r.current.delete(P), n.current.filtered.items.delete(P);
    let B = I();
    A(4, () => {
      Y(), B?.getAttribute("id") === P && y(), O.emit();
    });
  }), group: (P) => (a.current.has(P) || a.current.set(P, /* @__PURE__ */ new Set()), () => {
    o.current.delete(P), a.current.delete(P);
  }), filter: () => s.current.shouldFilter, label: c || t["aria-label"], getDisablePointerSelection: () => s.current.disablePointerSelection, listId: _, inputId: k, labelId: N, listInnerRef: F }), []);
  function le(P, D) {
    var B, H;
    let j = (H = (B = s.current) == null ? void 0 : B.filter) != null ? H : Ov;
    return P ? j(P, n.current.search, D) : 0;
  }
  function W() {
    if (!n.current.search || s.current.shouldFilter === !1) return;
    let P = n.current.filtered.items, D = [];
    n.current.filtered.groups.forEach((H) => {
      let j = a.current.get(H), Z = 0;
      j.forEach((ne) => {
        let ie = P.get(ne);
        Z = Math.max(ie, Z);
      }), D.push([H, Z]);
    });
    let B = F.current;
    Q().sort((H, j) => {
      var Z, ne;
      let ie = H.getAttribute("id"), ce = j.getAttribute("id");
      return ((Z = P.get(ce)) != null ? Z : 0) - ((ne = P.get(ie)) != null ? ne : 0);
    }).forEach((H) => {
      let j = H.closest(_o);
      j ? j.appendChild(H.parentElement === j ? H : H.closest(`${_o} > *`)) : B.appendChild(H.parentElement === B ? H : H.closest(`${_o} > *`));
    }), D.sort((H, j) => j[1] - H[1]).forEach((H) => {
      var j;
      let Z = (j = F.current) == null ? void 0 : j.querySelector(`${xr}[${Gn}="${encodeURIComponent(H[0])}"]`);
      Z?.parentElement.appendChild(Z);
    });
  }
  function y() {
    let P = Q().find((B) => B.getAttribute("aria-disabled") !== "true"), D = P?.getAttribute(Gn);
    O.setState("value", D || void 0);
  }
  function Y() {
    var P, D, B, H;
    if (!n.current.search || s.current.shouldFilter === !1) {
      n.current.filtered.count = r.current.size;
      return;
    }
    n.current.filtered.groups = /* @__PURE__ */ new Set();
    let j = 0;
    for (let Z of r.current) {
      let ne = (D = (P = o.current.get(Z)) == null ? void 0 : P.value) != null ? D : "", ie = (H = (B = o.current.get(Z)) == null ? void 0 : B.keywords) != null ? H : [], ce = le(ne, ie);
      n.current.filtered.items.set(Z, ce), ce > 0 && j++;
    }
    for (let [Z, ne] of a.current) for (let ie of ne) if (n.current.filtered.items.get(ie) > 0) {
      n.current.filtered.groups.add(Z);
      break;
    }
    n.current.filtered.count = j;
  }
  function ee() {
    var P, D, B;
    let H = I();
    H && (((P = H.parentElement) == null ? void 0 : P.firstChild) === H && ((B = (D = H.closest(xr)) == null ? void 0 : D.querySelector(kv)) == null || B.scrollIntoView({ block: "nearest" })), H.scrollIntoView({ block: "nearest" }));
  }
  function I() {
    var P;
    return (P = F.current) == null ? void 0 : P.querySelector(`${$2}[aria-selected="true"]`);
  }
  function Q() {
    var P;
    return Array.from(((P = F.current) == null ? void 0 : P.querySelectorAll(zc)) || []);
  }
  function M(P) {
    let D = Q()[P];
    D && O.setState("value", D.getAttribute(Gn));
  }
  function X(P) {
    var D;
    let B = I(), H = Q(), j = H.findIndex((ne) => ne === B), Z = H[j + P];
    (D = s.current) != null && D.loop && (Z = j + P < 0 ? H[H.length - 1] : j + P === H.length ? H[0] : H[j + P]), Z && O.setState("value", Z.getAttribute(Gn));
  }
  function se(P) {
    let D = I(), B = D?.closest(xr), H;
    for (; B && !H; ) B = P > 0 ? Kv(B, xr) : qv(B, xr), H = B?.querySelector(zc);
    H ? O.setState("value", H.getAttribute(Gn)) : X(P);
  }
  let he = () => M(Q().length - 1), L = (P) => {
    P.preventDefault(), P.metaKey ? he() : P.altKey ? se(1) : X(1);
  }, K = (P) => {
    P.preventDefault(), P.metaKey ? M(0) : P.altKey ? se(-1) : X(-1);
  };
  return $.createElement(We.div, { ref: e, tabIndex: -1, ...x, "cmdk-root": "", onKeyDown: (P) => {
    var D;
    (D = x.onKeyDown) == null || D.call(x, P);
    let B = P.nativeEvent.isComposing || P.keyCode === 229;
    if (!(P.defaultPrevented || B)) switch (P.key) {
      case "n":
      case "j": {
        E && P.ctrlKey && L(P);
        break;
      }
      case "ArrowDown": {
        L(P);
        break;
      }
      case "p":
      case "k": {
        E && P.ctrlKey && K(P);
        break;
      }
      case "ArrowUp": {
        K(P);
        break;
      }
      case "Home": {
        P.preventDefault(), M(0);
        break;
      }
      case "End": {
        P.preventDefault(), he();
        break;
      }
      case "Enter": {
        P.preventDefault();
        let H = I();
        if (H) {
          let j = new Event(wl);
          H.dispatchEvent(j);
        }
      }
    }
  } }, $.createElement("label", { "cmdk-label": "", htmlFor: te.inputId, id: te.labelId, style: Xv }, c), Ui(t, (P) => $.createElement(C2.Provider, { value: O }, $.createElement(x2.Provider, { value: te }, P))));
}), Lv = $.forwardRef((t, e) => {
  var n, r;
  let a = Ot(), o = $.useRef(null), l = $.useContext(M2), s = Sa(), c = F2(t), d = (r = (n = c.current) == null ? void 0 : n.forceMount) != null ? r : l?.forceMount;
  Mn(() => {
    if (!d) return s.item(a, l?.id);
  }, [d]);
  let u = P2(a, o, [t.value, t.children, o], t.keywords), f = xs(), m = nn((A) => A.value && A.value === u.current), g = nn((A) => d || s.filter() === !1 ? !0 : A.search ? A.filtered.items.get(a) > 0 : !0);
  $.useEffect(() => {
    let A = o.current;
    if (!(!A || t.disabled)) return A.addEventListener(wl, C), () => A.removeEventListener(wl, C);
  }, [g, t.onSelect, t.disabled]);
  function C() {
    var A, O;
    b(), (O = (A = c.current).onSelect) == null || O.call(A, u.current);
  }
  function b() {
    f.setState("value", u.current, !0);
  }
  if (!g) return null;
  let { disabled: E, value: x, onSelect: _, forceMount: N, keywords: k, ...F } = t;
  return $.createElement(We.div, { ref: xn(o, e), ...F, id: a, "cmdk-item": "", role: "option", "aria-disabled": !!E, "aria-selected": !!m, "data-disabled": !!E, "data-selected": !!m, onPointerMove: E || s.getDisablePointerSelection() ? void 0 : b, onClick: E ? void 0 : C }, t.children);
}), Rv = $.forwardRef((t, e) => {
  let { heading: n, children: r, forceMount: a, ...o } = t, l = Ot(), s = $.useRef(null), c = $.useRef(null), d = Ot(), u = Sa(), f = nn((g) => a || u.filter() === !1 ? !0 : g.search ? g.filtered.groups.has(l) : !0);
  Mn(() => u.group(l), []), P2(l, s, [t.value, t.heading, c]);
  let m = $.useMemo(() => ({ id: l, forceMount: a }), [a]);
  return $.createElement(We.div, { ref: xn(s, e), ...o, "cmdk-group": "", role: "presentation", hidden: f ? void 0 : !0 }, n && $.createElement("div", { ref: c, "cmdk-group-heading": "", "aria-hidden": !0, id: d }, n), Ui(t, (g) => $.createElement("div", { "cmdk-group-items": "", role: "group", "aria-labelledby": n ? d : void 0 }, $.createElement(M2.Provider, { value: m }, g))));
}), Hv = $.forwardRef((t, e) => {
  let { alwaysRender: n, ...r } = t, a = $.useRef(null), o = nn((l) => !l.search);
  return !n && !o ? null : $.createElement(We.div, { ref: xn(a, e), ...r, "cmdk-separator": "", role: "separator" });
}), Bv = $.forwardRef((t, e) => {
  let { onValueChange: n, ...r } = t, a = t.value != null, o = xs(), l = nn((d) => d.search), s = nn((d) => d.selectedItemId), c = Sa();
  return $.useEffect(() => {
    t.value != null && o.setState("search", t.value);
  }, [t.value]), $.createElement(We.input, { ref: e, ...r, "cmdk-input": "", autoComplete: "off", autoCorrect: "off", spellCheck: !1, "aria-autocomplete": "list", role: "combobox", "aria-expanded": !0, "aria-controls": c.listId, "aria-labelledby": c.labelId, "aria-activedescendant": s, id: c.inputId, type: "text", value: a ? t.value : l, onChange: (d) => {
    a || o.setState("search", d.target.value), n?.(d.target.value);
  } });
}), jv = $.forwardRef((t, e) => {
  let { children: n, label: r = "Suggestions", ...a } = t, o = $.useRef(null), l = $.useRef(null), s = nn((d) => d.selectedItemId), c = Sa();
  return $.useEffect(() => {
    if (l.current && o.current) {
      let d = l.current, u = o.current, f, m = new ResizeObserver(() => {
        f = requestAnimationFrame(() => {
          let g = d.offsetHeight;
          u.style.setProperty("--cmdk-list-height", g.toFixed(1) + "px");
        });
      });
      return m.observe(d), () => {
        cancelAnimationFrame(f), m.unobserve(d);
      };
    }
  }, []), $.createElement(We.div, { ref: xn(o, e), ...a, "cmdk-list": "", role: "listbox", tabIndex: -1, "aria-activedescendant": s, "aria-label": r, id: c.listId }, Ui(t, (d) => $.createElement("div", { ref: xn(l, c.listInnerRef), "cmdk-list-sizer": "" }, d)));
}), Vv = $.forwardRef((t, e) => {
  let { open: n, onOpenChange: r, overlayClassName: a, contentClassName: o, container: l, ...s } = t;
  return $.createElement(Av, { open: n, onOpenChange: r }, $.createElement(zv, { container: l }, $.createElement(Dv, { "cmdk-overlay": "", className: a }), $.createElement(Iv, { "aria-label": t.label, "cmdk-dialog": "", className: o }, $.createElement(S2, { ref: e, ...s }))));
}), Uv = $.forwardRef((t, e) => nn((n) => n.filtered.count === 0) ? $.createElement(We.div, { ref: e, ...t, "cmdk-empty": "", role: "presentation" }) : null), Wv = $.forwardRef((t, e) => {
  let { progress: n, children: r, label: a = "Loading...", ...o } = t;
  return $.createElement(We.div, { ref: e, ...o, "cmdk-loading": "", role: "progressbar", "aria-valuenow": n, "aria-valuemin": 0, "aria-valuemax": 100, "aria-label": a }, Ui(t, (l) => $.createElement("div", { "aria-hidden": !0 }, l)));
}), Gv = Object.assign(S2, { List: jv, Item: Lv, Input: Bv, Group: Rv, Separator: Hv, Dialog: Vv, Empty: Uv, Loading: Wv });
function Kv(t, e) {
  let n = t.nextElementSibling;
  for (; n; ) {
    if (n.matches(e)) return n;
    n = n.nextElementSibling;
  }
}
function qv(t, e) {
  let n = t.previousElementSibling;
  for (; n; ) {
    if (n.matches(e)) return n;
    n = n.previousElementSibling;
  }
}
function F2(t) {
  let e = $.useRef(t);
  return Mn(() => {
    e.current = t;
  }), e;
}
var Mn = typeof window > "u" ? $.useEffect : $.useLayoutEffect;
function Kn(t) {
  let e = $.useRef();
  return e.current === void 0 && (e.current = t()), e;
}
function nn(t) {
  let e = xs(), n = () => t(e.snapshot());
  return $.useSyncExternalStore(e.subscribe, n, n);
}
function P2(t, e, n, r = []) {
  let a = $.useRef(), o = Sa();
  return Mn(() => {
    var l;
    let s = (() => {
      var d;
      for (let u of n) {
        if (typeof u == "string") return u.trim();
        if (typeof u == "object" && "current" in u) return u.current ? (d = u.current.textContent) == null ? void 0 : d.trim() : a.current;
      }
    })(), c = r.map((d) => d.trim());
    o.value(t, s, c), (l = e.current) == null || l.setAttribute(Gn, s), a.current = s;
  }), a;
}
var Yv = () => {
  let [t, e] = $.useState(), n = Kn(() => /* @__PURE__ */ new Map());
  return Mn(() => {
    n.current.forEach((r) => r()), n.current = /* @__PURE__ */ new Map();
  }, [t]), (r, a) => {
    n.current.set(r, a), e({});
  };
};
function Zv(t) {
  let e = t.type;
  return typeof e == "function" ? e(t.props) : "render" in e ? e.render(t.props) : t;
}
function Ui({ asChild: t, children: e }, n) {
  return t && $.isValidElement(e) ? $.cloneElement(Zv(e), { ref: e.ref }, n(e.props.children)) : n(e);
}
var Xv = { position: "absolute", width: "1px", height: "1px", padding: "0", margin: "-1px", overflow: "hidden", clip: "rect(0, 0, 0, 0)", whiteSpace: "nowrap", borderWidth: "0" };
function xO({
  options: t,
  selectedValues: e,
  onSelectionChange: n,
  dir: r,
  placeholder: a,
  searchPlaceholder: o = "Search...",
  emptyMessage: l = "No options found."
}) {
  const s = $e(null), [c, d] = ve(!1), [u, f] = ve(""), m = u.length === 0, g = de(
    (x) => {
      const _ = e.filter((N) => N !== x);
      n(_);
    },
    [e, n]
  ), C = de(
    (x) => {
      const _ = s.current;
      if (_) {
        if ((x.key === "Delete" || x.key === "Backspace") && _.value === "") {
          const N = [...e];
          N.pop(), n(N);
        }
        x.key === "Escape" && _.blur();
      }
    },
    [e, n]
  ), b = t.filter(
    (x) => !e.includes(x.value)
  ), E = de(
    (x) => {
      f("");
      const _ = [...e, x.value];
      n(_);
    },
    [e, n]
  );
  return /* @__PURE__ */ S(
    nu,
    {
      onKeyDown: C,
      className: "overflow-visible bg-transparent",
      children: [
        /* @__PURE__ */ p("div", { className: "group border-input ring-offset-background focus-within:ring-ring rounded-md border px-3 py-2 text-sm focus-within:ring-2 focus-within:ring-offset-2", children: /* @__PURE__ */ S("div", { className: "flex flex-wrap gap-1", children: [
          e.map((x) => {
            const _ = t.find((N) => N.value === x);
            return _ ? /* @__PURE__ */ S(o4, { variant: "secondary", children: [
              _.label,
              /* @__PURE__ */ p(
                "button",
                {
                  className: "ring-offset-background focus:ring-ring ml-1 rounded-full outline-none focus:ring-2 focus:ring-offset-2",
                  onKeyDown: (N) => {
                    N.key === "Enter" && g(x);
                  },
                  onMouseDown: (N) => {
                    N.preventDefault(), N.stopPropagation();
                  },
                  onClick: () => g(x),
                  children: /* @__PURE__ */ p(hu, { className: "text-muted-foreground hover:text-foreground h-3 w-3" })
                }
              )
            ] }, x) : null;
          }),
          /* @__PURE__ */ p(
            Gv.Input,
            {
              ref: s,
              dir: m ? "rtl" : r,
              value: u,
              onValueChange: f,
              onBlur: () => d(!1),
              onFocus: () => d(!0),
              placeholder: e.length === 0 ? a : o,
              className: "placeholder:text-muted-foreground ml-2 flex-1 bg-transparent outline-none placeholder-shown:text-right"
            }
          )
        ] }) }),
        /* @__PURE__ */ p("div", { className: "relative mt-2", children: /* @__PURE__ */ p(ru, { dir: r, children: c && b.length > 0 ? /* @__PURE__ */ p("div", { className: "bg-popover text-popover-foreground animate-in absolute top-0 z-10 w-full rounded-md border shadow-md outline-none", children: /* @__PURE__ */ p(au, { className: "h-full overflow-auto", children: b.map((x) => /* @__PURE__ */ p(
          iu,
          {
            onMouseDown: (_) => {
              _.preventDefault(), _.stopPropagation();
            },
            onSelect: () => E(x),
            className: "cursor-pointer",
            children: x.label
          },
          x.value
        )) }) }) : null }) })
      ]
    }
  );
}
function CO(t) {
  return (e, n, r, a) => {
    if (console.error(e), e instanceof N4 && e.status === 401) {
      t.onUnauthorized();
      return;
    }
    if (!a.meta?.toast) return;
    const o = Object.values(Wp(e)).flat().map((l) => t.i18n.t(l.message)).join(", ");
    if (o) {
      lr.error(o);
      return;
    }
    lr.error(e instanceof Error ? e.message : t.fallbackMessage);
  };
}
const Jv = {
  awaiting_documents: {
    bgColor: "bg-amber-50",
    borderColor: "border-amber-200",
    iconColor: "text-amber-600",
    textColor: "text-amber-800",
    subtitleColor: "text-amber-700",
    icon: mp,
    getTitle: (t, e) => t.allDocsUploaded ? e("shared.offerAction.allDocsUploadedAwaitingReview") : e("shared.offerAction.docsRequired"),
    getSubtitle: (t, e) => e("shared.offerAction.docsUploaded", {
      uploaded: t.documentsUploaded ?? 0,
      total: t.documentsTotal ?? 0
    }),
    cta: {
      labelKey: "shared.offerAction.uploadDocs",
      getHref: (t) => `/offers/${t}/documents`,
      variant: "default"
    }
  },
  awaiting_review: {
    bgColor: "bg-blue-50",
    borderColor: "border-blue-200",
    iconColor: "text-blue-600",
    textColor: "text-blue-800",
    subtitleColor: "text-blue-700",
    icon: sl,
    getTitle: (t, e) => e("shared.offerAction.allDocsUploadedAwaitingReview"),
    getSubtitle: (t, e) => e("shared.offerAction.docsUploaded", {
      uploaded: t.documentsUploaded ?? 0,
      total: t.documentsTotal ?? 0
    }),
    cta: {
      labelKey: "shared.offerAction.viewDocs",
      getHref: (t) => `/offers/${t}/documents`,
      variant: "outline"
    }
  },
  documents_rejected: {
    bgColor: "bg-red-50",
    borderColor: "border-red-200",
    iconColor: "text-red-600",
    textColor: "text-red-800",
    subtitleColor: "text-red-700",
    icon: ri,
    getTitle: (t, e) => e("shared.offerAction.someDocsRejected"),
    getSubtitle: (t, e) => t.rejectionReason || e("shared.offerAction.reviewAndReupload"),
    cta: {
      labelKey: "shared.offerAction.updateDocs",
      getHref: (t) => `/offers/${t}/documents`,
      variant: "default"
    }
  },
  awaiting_signing: {
    bgColor: "bg-blue-50",
    borderColor: "border-blue-200",
    iconColor: "text-blue-600",
    textColor: "text-blue-800",
    subtitleColor: "text-blue-700",
    icon: ai,
    getTitle: (t, e) => e("shared.offerAction.awaitingSigning"),
    getSubtitle: (t, e) => e("shared.offerAction.project", { name: t.projectName }),
    cta: {
      labelKey: "shared.offerAction.signContract",
      getHref: (t) => `/offers/${t}/contract`,
      variant: "default"
    }
  },
  awaiting_tt: {
    bgColor: "bg-amber-50",
    borderColor: "border-amber-200",
    iconColor: "text-amber-600",
    textColor: "text-amber-800",
    subtitleColor: "text-amber-700",
    icon: cu,
    getTitle: (t, e) => e("shared.offerAction.awaitingCustomerTT"),
    getSubtitle: (t, e) => e("shared.offerAction.willNotifyOnTT"),
    cta: null
  },
  awaiting_tt_review: {
    bgColor: "bg-blue-50",
    borderColor: "border-blue-200",
    iconColor: "text-blue-600",
    textColor: "text-blue-800",
    subtitleColor: "text-blue-700",
    icon: Ir,
    getTitle: (t, e) => e("shared.offerAction.awaitingTTReview"),
    getSubtitle: (t, e) => e("shared.offerAction.ttUnderReview"),
    cta: null
  },
  tt_rejected: {
    bgColor: "bg-red-50",
    borderColor: "border-red-200",
    iconColor: "text-red-600",
    textColor: "text-red-800",
    subtitleColor: "text-red-700",
    icon: ri,
    getTitle: (t, e) => e("shared.offerAction.ttRejected"),
    getSubtitle: (t, e) => t.rejectionReason || e("shared.offerAction.awaitingCustomerReupload"),
    cta: null
  },
  in_progress: {
    bgColor: "bg-green-50",
    borderColor: "border-green-200",
    iconColor: "text-green-600",
    textColor: "text-green-800",
    subtitleColor: "text-green-700",
    icon: su,
    getTitle: (t, e) => e("shared.offerAction.serviceInProgress"),
    getSubtitle: (t, e) => e("shared.offerAction.project", { name: t.projectName }),
    cta: null
  }
};
function MO(t) {
  const { phase: e, offerId: n } = t, { t: r } = Ae(), a = Jv[e];
  if (!a)
    return null;
  const o = a.icon, l = a.getTitle(t, r), s = a.getSubtitle(t, r), c = a.cta;
  return /* @__PURE__ */ S(
    "div",
    {
      className: fe(
        "mt-4 rounded-lg border p-4",
        a.bgColor,
        a.borderColor
      ),
      children: [
        /* @__PURE__ */ S("div", { className: "flex items-center justify-between", children: [
          /* @__PURE__ */ S("div", { className: "flex-1", children: [
            /* @__PURE__ */ S("div", { className: "flex items-center gap-2", children: [
              /* @__PURE__ */ p(o, { size: 20, className: a.iconColor }),
              /* @__PURE__ */ p("p", { className: fe("font-medium", a.textColor), children: l })
            ] }),
            s && /* @__PURE__ */ p("p", { className: fe("mt-1 ms-7 text-sm", a.subtitleColor), children: s })
          ] }),
          c && /* @__PURE__ */ p(mt, { asChild: !0, variant: c.variant, children: /* @__PURE__ */ p(Ea, { to: c.getHref(n), children: r(c.labelKey) }) })
        ] }),
        t.rejectionReason && e === "documents_rejected" && t.rejectionReason !== r("shared.offerAction.reviewAndReupload") && /* @__PURE__ */ S("div", { className: "mt-3 flex items-start gap-2 rounded bg-red-100 p-2", children: [
          /* @__PURE__ */ p(Dr, { className: "mt-0.5 size-4 shrink-0 text-red-600" }),
          /* @__PURE__ */ p("span", { className: "text-sm text-red-700", children: r("shared.offerAction.rejectionReason", { reason: t.rejectionReason }) })
        ] }),
        t.rejectionReason && e === "tt_rejected" && t.rejectionReason !== r("shared.offerAction.awaitingCustomerReupload") && /* @__PURE__ */ S("div", { className: "mt-3 flex items-start gap-2 rounded bg-red-100 p-2", children: [
          /* @__PURE__ */ p(Dr, { className: "mt-0.5 size-4 shrink-0 text-red-600" }),
          /* @__PURE__ */ p("span", { className: "text-sm text-red-700", children: r("shared.offerAction.rejectionReason", { reason: t.rejectionReason }) })
        ] })
      ]
    }
  );
}
const N2 = 6048e5, Qv = 864e5, _2 = 6e4, T2 = 36e5, Dc = Symbol.for("constructDateFrom");
function Bt(t, e) {
  return typeof t == "function" ? t(e) : t && typeof t == "object" && Dc in t ? t[Dc](e) : t instanceof Date ? new t.constructor(e) : new Date(e);
}
function Xe(t, e) {
  return Bt(e || t, t);
}
let e7 = {};
function Wi() {
  return e7;
}
function Ur(t, e) {
  const n = Wi(), r = e?.weekStartsOn ?? e?.locale?.options?.weekStartsOn ?? n.weekStartsOn ?? n.locale?.options?.weekStartsOn ?? 0, a = Xe(t, e?.in), o = a.getDay(), l = (o < r ? 7 : 0) + o - r;
  return a.setDate(a.getDate() - l), a.setHours(0, 0, 0, 0), a;
}
function fi(t, e) {
  return Ur(t, { ...e, weekStartsOn: 1 });
}
function A2(t, e) {
  const n = Xe(t, e?.in), r = n.getFullYear(), a = Bt(n, 0);
  a.setFullYear(r + 1, 0, 4), a.setHours(0, 0, 0, 0);
  const o = fi(a), l = Bt(n, 0);
  l.setFullYear(r, 0, 4), l.setHours(0, 0, 0, 0);
  const s = fi(l);
  return n.getTime() >= o.getTime() ? r + 1 : n.getTime() >= s.getTime() ? r : r - 1;
}
function Ic(t) {
  const e = Xe(t), n = new Date(
    Date.UTC(
      e.getFullYear(),
      e.getMonth(),
      e.getDate(),
      e.getHours(),
      e.getMinutes(),
      e.getSeconds(),
      e.getMilliseconds()
    )
  );
  return n.setUTCFullYear(e.getFullYear()), +t - +n;
}
function Cs(t, ...e) {
  const n = Bt.bind(
    null,
    e.find((r) => typeof r == "object")
  );
  return e.map(n);
}
function kc(t, e) {
  const n = Xe(t, e?.in);
  return n.setHours(0, 0, 0, 0), n;
}
function t7(t, e, n) {
  const [r, a] = Cs(
    n?.in,
    t,
    e
  ), o = kc(r), l = kc(a), s = +o - Ic(o), c = +l - Ic(l);
  return Math.round((s - c) / Qv);
}
function n7(t, e) {
  const n = A2(t, e), r = Bt(t, 0);
  return r.setFullYear(n, 0, 4), r.setHours(0, 0, 0, 0), fi(r);
}
function Oc(t, e) {
  const n = +Xe(t) - +Xe(e);
  return n < 0 ? -1 : n > 0 ? 1 : n;
}
function r7(t) {
  return t instanceof Date || typeof t == "object" && Object.prototype.toString.call(t) === "[object Date]";
}
function a7(t) {
  return !(!r7(t) && typeof t != "number" || isNaN(+Xe(t)));
}
function i7(t, e, n) {
  const [r, a] = Cs(
    n?.in,
    t,
    e
  );
  return r.getFullYear() - a.getFullYear();
}
function o7(t, e, n) {
  const [r, a] = Cs(
    n?.in,
    t,
    e
  ), o = Oc(r, a), l = Math.abs(i7(r, a));
  r.setFullYear(1584), a.setFullYear(1584);
  const s = Oc(r, a) === -o, c = o * (l - +s);
  return c === 0 ? 0 : c;
}
function l7(t, e) {
  const n = Xe(t, e?.in);
  return n.setFullYear(n.getFullYear(), 0, 1), n.setHours(0, 0, 0, 0), n;
}
const s7 = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, c7 = (t, e, n) => {
  let r;
  const a = s7[t];
  return typeof a == "string" ? r = a : e === 1 ? r = a.one : r = a.other.replace("{{count}}", e.toString()), n?.addSuffix ? n.comparison && n.comparison > 0 ? "in " + r : r + " ago" : r;
};
function nr(t) {
  return (e = {}) => {
    const n = e.width ? String(e.width) : t.defaultWidth;
    return t.formats[n] || t.formats[t.defaultWidth];
  };
}
const d7 = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, u7 = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, f7 = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, p7 = {
  date: nr({
    formats: d7,
    defaultWidth: "full"
  }),
  time: nr({
    formats: u7,
    defaultWidth: "full"
  }),
  dateTime: nr({
    formats: f7,
    defaultWidth: "full"
  })
}, m7 = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, h7 = (t, e, n, r) => m7[t];
function bt(t) {
  return (e, n) => {
    const r = n?.context ? String(n.context) : "standalone";
    let a;
    if (r === "formatting" && t.formattingValues) {
      const l = t.defaultFormattingWidth || t.defaultWidth, s = n?.width ? String(n.width) : l;
      a = t.formattingValues[s] || t.formattingValues[l];
    } else {
      const l = t.defaultWidth, s = n?.width ? String(n.width) : t.defaultWidth;
      a = t.values[s] || t.values[l];
    }
    const o = t.argumentCallback ? t.argumentCallback(e) : e;
    return a[o];
  };
}
const v7 = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, g7 = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, y7 = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
  ],
  wide: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ]
}, b7 = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"
  ]
}, E7 = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, w7 = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, $7 = (t, e) => {
  const n = Number(t), r = n % 100;
  if (r > 20 || r < 10)
    switch (r % 10) {
      case 1:
        return n + "st";
      case 2:
        return n + "nd";
      case 3:
        return n + "rd";
    }
  return n + "th";
}, x7 = {
  ordinalNumber: $7,
  era: bt({
    values: v7,
    defaultWidth: "wide"
  }),
  quarter: bt({
    values: g7,
    defaultWidth: "wide",
    argumentCallback: (t) => t - 1
  }),
  month: bt({
    values: y7,
    defaultWidth: "wide"
  }),
  day: bt({
    values: b7,
    defaultWidth: "wide"
  }),
  dayPeriod: bt({
    values: E7,
    defaultWidth: "wide",
    formattingValues: w7,
    defaultFormattingWidth: "wide"
  })
};
function Et(t) {
  return (e, n = {}) => {
    const r = n.width, a = r && t.matchPatterns[r] || t.matchPatterns[t.defaultMatchWidth], o = e.match(a);
    if (!o)
      return null;
    const l = o[0], s = r && t.parsePatterns[r] || t.parsePatterns[t.defaultParseWidth], c = Array.isArray(s) ? M7(s, (f) => f.test(l)) : (
      // [TODO] -- I challenge you to fix the type
      C7(s, (f) => f.test(l))
    );
    let d;
    d = t.valueCallback ? t.valueCallback(c) : c, d = n.valueCallback ? (
      // [TODO] -- I challenge you to fix the type
      n.valueCallback(d)
    ) : d;
    const u = e.slice(l.length);
    return { value: d, rest: u };
  };
}
function C7(t, e) {
  for (const n in t)
    if (Object.prototype.hasOwnProperty.call(t, n) && e(t[n]))
      return n;
}
function M7(t, e) {
  for (let n = 0; n < t.length; n++)
    if (e(t[n]))
      return n;
}
function z2(t) {
  return (e, n = {}) => {
    const r = e.match(t.matchPattern);
    if (!r) return null;
    const a = r[0], o = e.match(t.parsePattern);
    if (!o) return null;
    let l = t.valueCallback ? t.valueCallback(o[0]) : o[0];
    l = n.valueCallback ? n.valueCallback(l) : l;
    const s = e.slice(a.length);
    return { value: l, rest: s };
  };
}
const S7 = /^(\d+)(th|st|nd|rd)?/i, F7 = /\d+/i, P7 = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, N7 = {
  any: [/^b/i, /^(a|c)/i]
}, _7 = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, T7 = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, A7 = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, z7 = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^may/i,
    /^jun/i,
    /^jul/i,
    /^au/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, D7 = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, I7 = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, k7 = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, O7 = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, L7 = {
  ordinalNumber: z2({
    matchPattern: S7,
    parsePattern: F7,
    valueCallback: (t) => parseInt(t, 10)
  }),
  era: Et({
    matchPatterns: P7,
    defaultMatchWidth: "wide",
    parsePatterns: N7,
    defaultParseWidth: "any"
  }),
  quarter: Et({
    matchPatterns: _7,
    defaultMatchWidth: "wide",
    parsePatterns: T7,
    defaultParseWidth: "any",
    valueCallback: (t) => t + 1
  }),
  month: Et({
    matchPatterns: A7,
    defaultMatchWidth: "wide",
    parsePatterns: z7,
    defaultParseWidth: "any"
  }),
  day: Et({
    matchPatterns: D7,
    defaultMatchWidth: "wide",
    parsePatterns: I7,
    defaultParseWidth: "any"
  }),
  dayPeriod: Et({
    matchPatterns: k7,
    defaultMatchWidth: "any",
    parsePatterns: O7,
    defaultParseWidth: "any"
  })
}, D2 = {
  code: "en-US",
  formatDistance: c7,
  formatLong: p7,
  formatRelative: h7,
  localize: x7,
  match: L7,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
function R7(t, e) {
  const n = Xe(t, e?.in);
  return t7(n, l7(n)) + 1;
}
function H7(t, e) {
  const n = Xe(t, e?.in), r = +fi(n) - +n7(n);
  return Math.round(r / N2) + 1;
}
function I2(t, e) {
  const n = Xe(t, e?.in), r = n.getFullYear(), a = Wi(), o = e?.firstWeekContainsDate ?? e?.locale?.options?.firstWeekContainsDate ?? a.firstWeekContainsDate ?? a.locale?.options?.firstWeekContainsDate ?? 1, l = Bt(e?.in || t, 0);
  l.setFullYear(r + 1, 0, o), l.setHours(0, 0, 0, 0);
  const s = Ur(l, e), c = Bt(e?.in || t, 0);
  c.setFullYear(r, 0, o), c.setHours(0, 0, 0, 0);
  const d = Ur(c, e);
  return +n >= +s ? r + 1 : +n >= +d ? r : r - 1;
}
function B7(t, e) {
  const n = Wi(), r = e?.firstWeekContainsDate ?? e?.locale?.options?.firstWeekContainsDate ?? n.firstWeekContainsDate ?? n.locale?.options?.firstWeekContainsDate ?? 1, a = I2(t, e), o = Bt(e?.in || t, 0);
  return o.setFullYear(a, 0, r), o.setHours(0, 0, 0, 0), Ur(o, e);
}
function j7(t, e) {
  const n = Xe(t, e?.in), r = +Ur(n, e) - +B7(n, e);
  return Math.round(r / N2) + 1;
}
function Se(t, e) {
  const n = t < 0 ? "-" : "", r = Math.abs(t).toString().padStart(e, "0");
  return n + r;
}
const Zt = {
  // Year
  y(t, e) {
    const n = t.getFullYear(), r = n > 0 ? n : 1 - n;
    return Se(e === "yy" ? r % 100 : r, e.length);
  },
  // Month
  M(t, e) {
    const n = t.getMonth();
    return e === "M" ? String(n + 1) : Se(n + 1, 2);
  },
  // Day of the month
  d(t, e) {
    return Se(t.getDate(), e.length);
  },
  // AM or PM
  a(t, e) {
    const n = t.getHours() / 12 >= 1 ? "pm" : "am";
    switch (e) {
      case "a":
      case "aa":
        return n.toUpperCase();
      case "aaa":
        return n;
      case "aaaaa":
        return n[0];
      case "aaaa":
      default:
        return n === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h(t, e) {
    return Se(t.getHours() % 12 || 12, e.length);
  },
  // Hour [0-23]
  H(t, e) {
    return Se(t.getHours(), e.length);
  },
  // Minute
  m(t, e) {
    return Se(t.getMinutes(), e.length);
  },
  // Second
  s(t, e) {
    return Se(t.getSeconds(), e.length);
  },
  // Fraction of second
  S(t, e) {
    const n = e.length, r = t.getMilliseconds(), a = Math.trunc(
      r * Math.pow(10, n - 3)
    );
    return Se(a, e.length);
  }
}, Rn = {
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
}, Lc = {
  // Era
  G: function(t, e, n) {
    const r = t.getFullYear() > 0 ? 1 : 0;
    switch (e) {
      // AD, BC
      case "G":
      case "GG":
      case "GGG":
        return n.era(r, { width: "abbreviated" });
      // A, B
      case "GGGGG":
        return n.era(r, { width: "narrow" });
      // Anno Domini, Before Christ
      case "GGGG":
      default:
        return n.era(r, { width: "wide" });
    }
  },
  // Year
  y: function(t, e, n) {
    if (e === "yo") {
      const r = t.getFullYear(), a = r > 0 ? r : 1 - r;
      return n.ordinalNumber(a, { unit: "year" });
    }
    return Zt.y(t, e);
  },
  // Local week-numbering year
  Y: function(t, e, n, r) {
    const a = I2(t, r), o = a > 0 ? a : 1 - a;
    if (e === "YY") {
      const l = o % 100;
      return Se(l, 2);
    }
    return e === "Yo" ? n.ordinalNumber(o, { unit: "year" }) : Se(o, e.length);
  },
  // ISO week-numbering year
  R: function(t, e) {
    const n = A2(t);
    return Se(n, e.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function(t, e) {
    const n = t.getFullYear();
    return Se(n, e.length);
  },
  // Quarter
  Q: function(t, e, n) {
    const r = Math.ceil((t.getMonth() + 1) / 3);
    switch (e) {
      // 1, 2, 3, 4
      case "Q":
        return String(r);
      // 01, 02, 03, 04
      case "QQ":
        return Se(r, 2);
      // 1st, 2nd, 3rd, 4th
      case "Qo":
        return n.ordinalNumber(r, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "QQQ":
        return n.quarter(r, {
          width: "abbreviated",
          context: "formatting"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "QQQQQ":
        return n.quarter(r, {
          width: "narrow",
          context: "formatting"
        });
      // 1st quarter, 2nd quarter, ...
      case "QQQQ":
      default:
        return n.quarter(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone quarter
  q: function(t, e, n) {
    const r = Math.ceil((t.getMonth() + 1) / 3);
    switch (e) {
      // 1, 2, 3, 4
      case "q":
        return String(r);
      // 01, 02, 03, 04
      case "qq":
        return Se(r, 2);
      // 1st, 2nd, 3rd, 4th
      case "qo":
        return n.ordinalNumber(r, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "qqq":
        return n.quarter(r, {
          width: "abbreviated",
          context: "standalone"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "qqqqq":
        return n.quarter(r, {
          width: "narrow",
          context: "standalone"
        });
      // 1st quarter, 2nd quarter, ...
      case "qqqq":
      default:
        return n.quarter(r, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Month
  M: function(t, e, n) {
    const r = t.getMonth();
    switch (e) {
      case "M":
      case "MM":
        return Zt.M(t, e);
      // 1st, 2nd, ..., 12th
      case "Mo":
        return n.ordinalNumber(r + 1, { unit: "month" });
      // Jan, Feb, ..., Dec
      case "MMM":
        return n.month(r, {
          width: "abbreviated",
          context: "formatting"
        });
      // J, F, ..., D
      case "MMMMM":
        return n.month(r, {
          width: "narrow",
          context: "formatting"
        });
      // January, February, ..., December
      case "MMMM":
      default:
        return n.month(r, { width: "wide", context: "formatting" });
    }
  },
  // Stand-alone month
  L: function(t, e, n) {
    const r = t.getMonth();
    switch (e) {
      // 1, 2, ..., 12
      case "L":
        return String(r + 1);
      // 01, 02, ..., 12
      case "LL":
        return Se(r + 1, 2);
      // 1st, 2nd, ..., 12th
      case "Lo":
        return n.ordinalNumber(r + 1, { unit: "month" });
      // Jan, Feb, ..., Dec
      case "LLL":
        return n.month(r, {
          width: "abbreviated",
          context: "standalone"
        });
      // J, F, ..., D
      case "LLLLL":
        return n.month(r, {
          width: "narrow",
          context: "standalone"
        });
      // January, February, ..., December
      case "LLLL":
      default:
        return n.month(r, { width: "wide", context: "standalone" });
    }
  },
  // Local week of year
  w: function(t, e, n, r) {
    const a = j7(t, r);
    return e === "wo" ? n.ordinalNumber(a, { unit: "week" }) : Se(a, e.length);
  },
  // ISO week of year
  I: function(t, e, n) {
    const r = H7(t);
    return e === "Io" ? n.ordinalNumber(r, { unit: "week" }) : Se(r, e.length);
  },
  // Day of the month
  d: function(t, e, n) {
    return e === "do" ? n.ordinalNumber(t.getDate(), { unit: "date" }) : Zt.d(t, e);
  },
  // Day of year
  D: function(t, e, n) {
    const r = R7(t);
    return e === "Do" ? n.ordinalNumber(r, { unit: "dayOfYear" }) : Se(r, e.length);
  },
  // Day of week
  E: function(t, e, n) {
    const r = t.getDay();
    switch (e) {
      // Tue
      case "E":
      case "EE":
      case "EEE":
        return n.day(r, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "EEEEE":
        return n.day(r, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "EEEEEE":
        return n.day(r, {
          width: "short",
          context: "formatting"
        });
      // Tuesday
      case "EEEE":
      default:
        return n.day(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Local day of week
  e: function(t, e, n, r) {
    const a = t.getDay(), o = (a - r.weekStartsOn + 8) % 7 || 7;
    switch (e) {
      // Numerical value (Nth day of week with current locale or weekStartsOn)
      case "e":
        return String(o);
      // Padded numerical value
      case "ee":
        return Se(o, 2);
      // 1st, 2nd, ..., 7th
      case "eo":
        return n.ordinalNumber(o, { unit: "day" });
      case "eee":
        return n.day(a, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "eeeee":
        return n.day(a, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "eeeeee":
        return n.day(a, {
          width: "short",
          context: "formatting"
        });
      // Tuesday
      case "eeee":
      default:
        return n.day(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone local day of week
  c: function(t, e, n, r) {
    const a = t.getDay(), o = (a - r.weekStartsOn + 8) % 7 || 7;
    switch (e) {
      // Numerical value (same as in `e`)
      case "c":
        return String(o);
      // Padded numerical value
      case "cc":
        return Se(o, e.length);
      // 1st, 2nd, ..., 7th
      case "co":
        return n.ordinalNumber(o, { unit: "day" });
      case "ccc":
        return n.day(a, {
          width: "abbreviated",
          context: "standalone"
        });
      // T
      case "ccccc":
        return n.day(a, {
          width: "narrow",
          context: "standalone"
        });
      // Tu
      case "cccccc":
        return n.day(a, {
          width: "short",
          context: "standalone"
        });
      // Tuesday
      case "cccc":
      default:
        return n.day(a, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // ISO day of week
  i: function(t, e, n) {
    const r = t.getDay(), a = r === 0 ? 7 : r;
    switch (e) {
      // 2
      case "i":
        return String(a);
      // 02
      case "ii":
        return Se(a, e.length);
      // 2nd
      case "io":
        return n.ordinalNumber(a, { unit: "day" });
      // Tue
      case "iii":
        return n.day(r, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "iiiii":
        return n.day(r, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "iiiiii":
        return n.day(r, {
          width: "short",
          context: "formatting"
        });
      // Tuesday
      case "iiii":
      default:
        return n.day(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM or PM
  a: function(t, e, n) {
    const a = t.getHours() / 12 >= 1 ? "pm" : "am";
    switch (e) {
      case "a":
      case "aa":
        return n.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return n.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return n.dayPeriod(a, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return n.dayPeriod(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM, PM, midnight, noon
  b: function(t, e, n) {
    const r = t.getHours();
    let a;
    switch (r === 12 ? a = Rn.noon : r === 0 ? a = Rn.midnight : a = r / 12 >= 1 ? "pm" : "am", e) {
      case "b":
      case "bb":
        return n.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return n.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return n.dayPeriod(a, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return n.dayPeriod(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function(t, e, n) {
    const r = t.getHours();
    let a;
    switch (r >= 17 ? a = Rn.evening : r >= 12 ? a = Rn.afternoon : r >= 4 ? a = Rn.morning : a = Rn.night, e) {
      case "B":
      case "BB":
      case "BBB":
        return n.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return n.dayPeriod(a, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return n.dayPeriod(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Hour [1-12]
  h: function(t, e, n) {
    if (e === "ho") {
      let r = t.getHours() % 12;
      return r === 0 && (r = 12), n.ordinalNumber(r, { unit: "hour" });
    }
    return Zt.h(t, e);
  },
  // Hour [0-23]
  H: function(t, e, n) {
    return e === "Ho" ? n.ordinalNumber(t.getHours(), { unit: "hour" }) : Zt.H(t, e);
  },
  // Hour [0-11]
  K: function(t, e, n) {
    const r = t.getHours() % 12;
    return e === "Ko" ? n.ordinalNumber(r, { unit: "hour" }) : Se(r, e.length);
  },
  // Hour [1-24]
  k: function(t, e, n) {
    let r = t.getHours();
    return r === 0 && (r = 24), e === "ko" ? n.ordinalNumber(r, { unit: "hour" }) : Se(r, e.length);
  },
  // Minute
  m: function(t, e, n) {
    return e === "mo" ? n.ordinalNumber(t.getMinutes(), { unit: "minute" }) : Zt.m(t, e);
  },
  // Second
  s: function(t, e, n) {
    return e === "so" ? n.ordinalNumber(t.getSeconds(), { unit: "second" }) : Zt.s(t, e);
  },
  // Fraction of second
  S: function(t, e) {
    return Zt.S(t, e);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(t, e, n) {
    const r = t.getTimezoneOffset();
    if (r === 0)
      return "Z";
    switch (e) {
      // Hours and optional minutes
      case "X":
        return Hc(r);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XX`
      case "XXXX":
      case "XX":
        return hn(r);
      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XXX`
      case "XXXXX":
      case "XXX":
      // Hours and minutes with `:` delimiter
      default:
        return hn(r, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(t, e, n) {
    const r = t.getTimezoneOffset();
    switch (e) {
      // Hours and optional minutes
      case "x":
        return Hc(r);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xx`
      case "xxxx":
      case "xx":
        return hn(r);
      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xxx`
      case "xxxxx":
      case "xxx":
      // Hours and minutes with `:` delimiter
      default:
        return hn(r, ":");
    }
  },
  // Timezone (GMT)
  O: function(t, e, n) {
    const r = t.getTimezoneOffset();
    switch (e) {
      // Short
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + Rc(r, ":");
      // Long
      case "OOOO":
      default:
        return "GMT" + hn(r, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(t, e, n) {
    const r = t.getTimezoneOffset();
    switch (e) {
      // Short
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + Rc(r, ":");
      // Long
      case "zzzz":
      default:
        return "GMT" + hn(r, ":");
    }
  },
  // Seconds timestamp
  t: function(t, e, n) {
    const r = Math.trunc(+t / 1e3);
    return Se(r, e.length);
  },
  // Milliseconds timestamp
  T: function(t, e, n) {
    return Se(+t, e.length);
  }
};
function Rc(t, e = "") {
  const n = t > 0 ? "-" : "+", r = Math.abs(t), a = Math.trunc(r / 60), o = r % 60;
  return o === 0 ? n + String(a) : n + String(a) + e + Se(o, 2);
}
function Hc(t, e) {
  return t % 60 === 0 ? (t > 0 ? "-" : "+") + Se(Math.abs(t) / 60, 2) : hn(t, e);
}
function hn(t, e = "") {
  const n = t > 0 ? "-" : "+", r = Math.abs(t), a = Se(Math.trunc(r / 60), 2), o = Se(r % 60, 2);
  return n + a + e + o;
}
const Bc = (t, e) => {
  switch (t) {
    case "P":
      return e.date({ width: "short" });
    case "PP":
      return e.date({ width: "medium" });
    case "PPP":
      return e.date({ width: "long" });
    case "PPPP":
    default:
      return e.date({ width: "full" });
  }
}, k2 = (t, e) => {
  switch (t) {
    case "p":
      return e.time({ width: "short" });
    case "pp":
      return e.time({ width: "medium" });
    case "ppp":
      return e.time({ width: "long" });
    case "pppp":
    default:
      return e.time({ width: "full" });
  }
}, V7 = (t, e) => {
  const n = t.match(/(P+)(p+)?/) || [], r = n[1], a = n[2];
  if (!a)
    return Bc(t, e);
  let o;
  switch (r) {
    case "P":
      o = e.dateTime({ width: "short" });
      break;
    case "PP":
      o = e.dateTime({ width: "medium" });
      break;
    case "PPP":
      o = e.dateTime({ width: "long" });
      break;
    case "PPPP":
    default:
      o = e.dateTime({ width: "full" });
      break;
  }
  return o.replace("{{date}}", Bc(r, e)).replace("{{time}}", k2(a, e));
}, U7 = {
  p: k2,
  P: V7
}, W7 = /^D+$/, G7 = /^Y+$/, K7 = ["D", "DD", "YY", "YYYY"];
function q7(t) {
  return W7.test(t);
}
function Y7(t) {
  return G7.test(t);
}
function Z7(t, e, n) {
  const r = X7(t, e, n);
  if (console.warn(r), K7.includes(t)) throw new RangeError(r);
}
function X7(t, e, n) {
  const r = t[0] === "Y" ? "years" : "days of the month";
  return `Use \`${t.toLowerCase()}\` instead of \`${t}\` (in \`${e}\`) for formatting ${r} to the input \`${n}\`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md`;
}
const J7 = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, Q7 = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, e8 = /^'([^]*?)'?$/, t8 = /''/g, n8 = /[a-zA-Z]/;
function Ms(t, e, n) {
  const r = Wi(), a = n?.locale ?? r.locale ?? D2, o = n?.firstWeekContainsDate ?? n?.locale?.options?.firstWeekContainsDate ?? r.firstWeekContainsDate ?? r.locale?.options?.firstWeekContainsDate ?? 1, l = n?.weekStartsOn ?? n?.locale?.options?.weekStartsOn ?? r.weekStartsOn ?? r.locale?.options?.weekStartsOn ?? 0, s = Xe(t, n?.in);
  if (!a7(s))
    throw new RangeError("Invalid time value");
  let c = e.match(Q7).map((u) => {
    const f = u[0];
    if (f === "p" || f === "P") {
      const m = U7[f];
      return m(u, a.formatLong);
    }
    return u;
  }).join("").match(J7).map((u) => {
    if (u === "''")
      return { isToken: !1, value: "'" };
    const f = u[0];
    if (f === "'")
      return { isToken: !1, value: r8(u) };
    if (Lc[f])
      return { isToken: !0, value: u };
    if (f.match(n8))
      throw new RangeError(
        "Format string contains an unescaped latin alphabet character `" + f + "`"
      );
    return { isToken: !1, value: u };
  });
  a.localize.preprocessor && (c = a.localize.preprocessor(s, c));
  const d = {
    firstWeekContainsDate: o,
    weekStartsOn: l,
    locale: a
  };
  return c.map((u) => {
    if (!u.isToken) return u.value;
    const f = u.value;
    (!n?.useAdditionalWeekYearTokens && Y7(f) || !n?.useAdditionalDayOfYearTokens && q7(f)) && Z7(f, e, String(t));
    const m = Lc[f[0]];
    return m(s, f, a.localize, d);
  }).join("");
}
function r8(t) {
  const e = t.match(e8);
  return e ? e[1].replace(t8, "'") : t;
}
function a8(t, e) {
  const n = () => Bt(e?.in, NaN), a = s8(t);
  let o;
  if (a.date) {
    const d = c8(a.date, 2);
    o = d8(d.restDateString, d.year);
  }
  if (!o || isNaN(+o)) return n();
  const l = +o;
  let s = 0, c;
  if (a.time && (s = u8(a.time), isNaN(s)))
    return n();
  if (a.timezone) {
    if (c = f8(a.timezone), isNaN(c)) return n();
  } else {
    const d = new Date(l + s), u = Xe(0, e?.in);
    return u.setFullYear(
      d.getUTCFullYear(),
      d.getUTCMonth(),
      d.getUTCDate()
    ), u.setHours(
      d.getUTCHours(),
      d.getUTCMinutes(),
      d.getUTCSeconds(),
      d.getUTCMilliseconds()
    ), u;
  }
  return Xe(l + s + c, e?.in);
}
const Oa = {
  dateTimeDelimiter: /[T ]/,
  timeZoneDelimiter: /[Z ]/i,
  timezone: /([Z+-].*)$/
}, i8 = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/, o8 = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/, l8 = /^([+-])(\d{2})(?::?(\d{2}))?$/;
function s8(t) {
  const e = {}, n = t.split(Oa.dateTimeDelimiter);
  let r;
  if (n.length > 2)
    return e;
  if (/:/.test(n[0]) ? r = n[0] : (e.date = n[0], r = n[1], Oa.timeZoneDelimiter.test(e.date) && (e.date = t.split(Oa.timeZoneDelimiter)[0], r = t.substr(
    e.date.length,
    t.length
  ))), r) {
    const a = Oa.timezone.exec(r);
    a ? (e.time = r.replace(a[1], ""), e.timezone = a[1]) : e.time = r;
  }
  return e;
}
function c8(t, e) {
  const n = new RegExp(
    "^(?:(\\d{4}|[+-]\\d{" + (4 + e) + "})|(\\d{2}|[+-]\\d{" + (2 + e) + "})$)"
  ), r = t.match(n);
  if (!r) return { year: NaN, restDateString: "" };
  const a = r[1] ? parseInt(r[1]) : null, o = r[2] ? parseInt(r[2]) : null;
  return {
    year: o === null ? a : o * 100,
    restDateString: t.slice((r[1] || r[2]).length)
  };
}
function d8(t, e) {
  if (e === null) return /* @__PURE__ */ new Date(NaN);
  const n = t.match(i8);
  if (!n) return /* @__PURE__ */ new Date(NaN);
  const r = !!n[4], a = Cr(n[1]), o = Cr(n[2]) - 1, l = Cr(n[3]), s = Cr(n[4]), c = Cr(n[5]) - 1;
  if (r)
    return g8(e, s, c) ? p8(e, s, c) : /* @__PURE__ */ new Date(NaN);
  {
    const d = /* @__PURE__ */ new Date(0);
    return !h8(e, o, l) || !v8(e, a) ? /* @__PURE__ */ new Date(NaN) : (d.setUTCFullYear(e, o, Math.max(a, l)), d);
  }
}
function Cr(t) {
  return t ? parseInt(t) : 1;
}
function u8(t) {
  const e = t.match(o8);
  if (!e) return NaN;
  const n = To(e[1]), r = To(e[2]), a = To(e[3]);
  return y8(n, r, a) ? n * T2 + r * _2 + a * 1e3 : NaN;
}
function To(t) {
  return t && parseFloat(t.replace(",", ".")) || 0;
}
function f8(t) {
  if (t === "Z") return 0;
  const e = t.match(l8);
  if (!e) return 0;
  const n = e[1] === "+" ? -1 : 1, r = parseInt(e[2]), a = e[3] && parseInt(e[3]) || 0;
  return b8(r, a) ? n * (r * T2 + a * _2) : NaN;
}
function p8(t, e, n) {
  const r = /* @__PURE__ */ new Date(0);
  r.setUTCFullYear(t, 0, 4);
  const a = r.getUTCDay() || 7, o = (e - 1) * 7 + n + 1 - a;
  return r.setUTCDate(r.getUTCDate() + o), r;
}
const m8 = [31, null, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
function O2(t) {
  return t % 400 === 0 || t % 4 === 0 && t % 100 !== 0;
}
function h8(t, e, n) {
  return e >= 0 && e <= 11 && n >= 1 && n <= (m8[e] || (O2(t) ? 29 : 28));
}
function v8(t, e) {
  return e >= 1 && e <= (O2(t) ? 366 : 365);
}
function g8(t, e, n) {
  return e >= 1 && e <= 53 && n >= 0 && n <= 6;
}
function y8(t, e, n) {
  return t === 24 ? e === 0 && n === 0 : n >= 0 && n < 60 && e >= 0 && e < 60 && t >= 0 && t < 25;
}
function b8(t, e) {
  return e >= 0 && e <= 59;
}
var ge;
(function(t) {
  t.assertEqual = (a) => {
  };
  function e(a) {
  }
  t.assertIs = e;
  function n(a) {
    throw new Error();
  }
  t.assertNever = n, t.arrayToEnum = (a) => {
    const o = {};
    for (const l of a)
      o[l] = l;
    return o;
  }, t.getValidEnumValues = (a) => {
    const o = t.objectKeys(a).filter((s) => typeof a[a[s]] != "number"), l = {};
    for (const s of o)
      l[s] = a[s];
    return t.objectValues(l);
  }, t.objectValues = (a) => t.objectKeys(a).map(function(o) {
    return a[o];
  }), t.objectKeys = typeof Object.keys == "function" ? (a) => Object.keys(a) : (a) => {
    const o = [];
    for (const l in a)
      Object.prototype.hasOwnProperty.call(a, l) && o.push(l);
    return o;
  }, t.find = (a, o) => {
    for (const l of a)
      if (o(l))
        return l;
  }, t.isInteger = typeof Number.isInteger == "function" ? (a) => Number.isInteger(a) : (a) => typeof a == "number" && Number.isFinite(a) && Math.floor(a) === a;
  function r(a, o = " | ") {
    return a.map((l) => typeof l == "string" ? `'${l}'` : l).join(o);
  }
  t.joinValues = r, t.jsonStringifyReplacer = (a, o) => typeof o == "bigint" ? o.toString() : o;
})(ge || (ge = {}));
var $l;
(function(t) {
  t.mergeShapes = (e, n) => ({
    ...e,
    ...n
    // second overwrites first
  });
})($l || ($l = {}));
const q = ge.arrayToEnum([
  "string",
  "nan",
  "number",
  "integer",
  "float",
  "boolean",
  "date",
  "bigint",
  "symbol",
  "function",
  "undefined",
  "null",
  "array",
  "object",
  "unknown",
  "promise",
  "void",
  "never",
  "map",
  "set"
]), zt = (t) => {
  switch (typeof t) {
    case "undefined":
      return q.undefined;
    case "string":
      return q.string;
    case "number":
      return Number.isNaN(t) ? q.nan : q.number;
    case "boolean":
      return q.boolean;
    case "function":
      return q.function;
    case "bigint":
      return q.bigint;
    case "symbol":
      return q.symbol;
    case "object":
      return Array.isArray(t) ? q.array : t === null ? q.null : t.then && typeof t.then == "function" && t.catch && typeof t.catch == "function" ? q.promise : typeof Map < "u" && t instanceof Map ? q.map : typeof Set < "u" && t instanceof Set ? q.set : typeof Date < "u" && t instanceof Date ? q.date : q.object;
    default:
      return q.unknown;
  }
}, R = ge.arrayToEnum([
  "invalid_type",
  "invalid_literal",
  "custom",
  "invalid_union",
  "invalid_union_discriminator",
  "invalid_enum_value",
  "unrecognized_keys",
  "invalid_arguments",
  "invalid_return_type",
  "invalid_date",
  "invalid_string",
  "too_small",
  "too_big",
  "invalid_intersection_types",
  "not_multiple_of",
  "not_finite"
]), E8 = (t) => JSON.stringify(t, null, 2).replace(/"([^"]+)":/g, "$1:");
class rt extends Error {
  get errors() {
    return this.issues;
  }
  constructor(e) {
    super(), this.issues = [], this.addIssue = (r) => {
      this.issues = [...this.issues, r];
    }, this.addIssues = (r = []) => {
      this.issues = [...this.issues, ...r];
    };
    const n = new.target.prototype;
    Object.setPrototypeOf ? Object.setPrototypeOf(this, n) : this.__proto__ = n, this.name = "ZodError", this.issues = e;
  }
  format(e) {
    const n = e || function(o) {
      return o.message;
    }, r = { _errors: [] }, a = (o) => {
      for (const l of o.issues)
        if (l.code === "invalid_union")
          l.unionErrors.map(a);
        else if (l.code === "invalid_return_type")
          a(l.returnTypeError);
        else if (l.code === "invalid_arguments")
          a(l.argumentsError);
        else if (l.path.length === 0)
          r._errors.push(n(l));
        else {
          let s = r, c = 0;
          for (; c < l.path.length; ) {
            const d = l.path[c];
            c === l.path.length - 1 ? (s[d] = s[d] || { _errors: [] }, s[d]._errors.push(n(l))) : s[d] = s[d] || { _errors: [] }, s = s[d], c++;
          }
        }
    };
    return a(this), r;
  }
  static assert(e) {
    if (!(e instanceof rt))
      throw new Error(`Not a ZodError: ${e}`);
  }
  toString() {
    return this.message;
  }
  get message() {
    return JSON.stringify(this.issues, ge.jsonStringifyReplacer, 2);
  }
  get isEmpty() {
    return this.issues.length === 0;
  }
  flatten(e = (n) => n.message) {
    const n = {}, r = [];
    for (const a of this.issues)
      if (a.path.length > 0) {
        const o = a.path[0];
        n[o] = n[o] || [], n[o].push(e(a));
      } else
        r.push(e(a));
    return { formErrors: r, fieldErrors: n };
  }
  get formErrors() {
    return this.flatten();
  }
}
rt.create = (t) => new rt(t);
const cr = (t, e) => {
  let n;
  switch (t.code) {
    case R.invalid_type:
      t.received === q.undefined ? n = "Required" : n = `Expected ${t.expected}, received ${t.received}`;
      break;
    case R.invalid_literal:
      n = `Invalid literal value, expected ${JSON.stringify(t.expected, ge.jsonStringifyReplacer)}`;
      break;
    case R.unrecognized_keys:
      n = `Unrecognized key(s) in object: ${ge.joinValues(t.keys, ", ")}`;
      break;
    case R.invalid_union:
      n = "Invalid input";
      break;
    case R.invalid_union_discriminator:
      n = `Invalid discriminator value. Expected ${ge.joinValues(t.options)}`;
      break;
    case R.invalid_enum_value:
      n = `Invalid enum value. Expected ${ge.joinValues(t.options)}, received '${t.received}'`;
      break;
    case R.invalid_arguments:
      n = "Invalid function arguments";
      break;
    case R.invalid_return_type:
      n = "Invalid function return type";
      break;
    case R.invalid_date:
      n = "Invalid date";
      break;
    case R.invalid_string:
      typeof t.validation == "object" ? "includes" in t.validation ? (n = `Invalid input: must include "${t.validation.includes}"`, typeof t.validation.position == "number" && (n = `${n} at one or more positions greater than or equal to ${t.validation.position}`)) : "startsWith" in t.validation ? n = `Invalid input: must start with "${t.validation.startsWith}"` : "endsWith" in t.validation ? n = `Invalid input: must end with "${t.validation.endsWith}"` : ge.assertNever(t.validation) : t.validation !== "regex" ? n = `Invalid ${t.validation}` : n = "Invalid";
      break;
    case R.too_small:
      t.type === "array" ? n = `Array must contain ${t.exact ? "exactly" : t.inclusive ? "at least" : "more than"} ${t.minimum} element(s)` : t.type === "string" ? n = `String must contain ${t.exact ? "exactly" : t.inclusive ? "at least" : "over"} ${t.minimum} character(s)` : t.type === "number" ? n = `Number must be ${t.exact ? "exactly equal to " : t.inclusive ? "greater than or equal to " : "greater than "}${t.minimum}` : t.type === "bigint" ? n = `Number must be ${t.exact ? "exactly equal to " : t.inclusive ? "greater than or equal to " : "greater than "}${t.minimum}` : t.type === "date" ? n = `Date must be ${t.exact ? "exactly equal to " : t.inclusive ? "greater than or equal to " : "greater than "}${new Date(Number(t.minimum))}` : n = "Invalid input";
      break;
    case R.too_big:
      t.type === "array" ? n = `Array must contain ${t.exact ? "exactly" : t.inclusive ? "at most" : "less than"} ${t.maximum} element(s)` : t.type === "string" ? n = `String must contain ${t.exact ? "exactly" : t.inclusive ? "at most" : "under"} ${t.maximum} character(s)` : t.type === "number" ? n = `Number must be ${t.exact ? "exactly" : t.inclusive ? "less than or equal to" : "less than"} ${t.maximum}` : t.type === "bigint" ? n = `BigInt must be ${t.exact ? "exactly" : t.inclusive ? "less than or equal to" : "less than"} ${t.maximum}` : t.type === "date" ? n = `Date must be ${t.exact ? "exactly" : t.inclusive ? "smaller than or equal to" : "smaller than"} ${new Date(Number(t.maximum))}` : n = "Invalid input";
      break;
    case R.custom:
      n = "Invalid input";
      break;
    case R.invalid_intersection_types:
      n = "Intersection results could not be merged";
      break;
    case R.not_multiple_of:
      n = `Number must be a multiple of ${t.multipleOf}`;
      break;
    case R.not_finite:
      n = "Number must be finite";
      break;
    default:
      n = e.defaultError, ge.assertNever(t);
  }
  return { message: n };
};
let L2 = cr;
function w8(t) {
  L2 = t;
}
function pi() {
  return L2;
}
const mi = (t) => {
  const { data: e, path: n, errorMaps: r, issueData: a } = t, o = [...n, ...a.path || []], l = {
    ...a,
    path: o
  };
  if (a.message !== void 0)
    return {
      ...a,
      path: o,
      message: a.message
    };
  let s = "";
  const c = r.filter((d) => !!d).slice().reverse();
  for (const d of c)
    s = d(l, { data: e, defaultError: s }).message;
  return {
    ...a,
    path: o,
    message: s
  };
}, $8 = [];
function U(t, e) {
  const n = pi(), r = mi({
    issueData: e,
    data: t.data,
    path: t.path,
    errorMaps: [
      t.common.contextualErrorMap,
      // contextual error map is first priority
      t.schemaErrorMap,
      // then schema-bound map if available
      n,
      // then global override map
      n === cr ? void 0 : cr
      // then global default map
    ].filter((a) => !!a)
  });
  t.common.issues.push(r);
}
class Ze {
  constructor() {
    this.value = "valid";
  }
  dirty() {
    this.value === "valid" && (this.value = "dirty");
  }
  abort() {
    this.value !== "aborted" && (this.value = "aborted");
  }
  static mergeArray(e, n) {
    const r = [];
    for (const a of n) {
      if (a.status === "aborted")
        return ae;
      a.status === "dirty" && e.dirty(), r.push(a.value);
    }
    return { status: e.value, value: r };
  }
  static async mergeObjectAsync(e, n) {
    const r = [];
    for (const a of n) {
      const o = await a.key, l = await a.value;
      r.push({
        key: o,
        value: l
      });
    }
    return Ze.mergeObjectSync(e, r);
  }
  static mergeObjectSync(e, n) {
    const r = {};
    for (const a of n) {
      const { key: o, value: l } = a;
      if (o.status === "aborted" || l.status === "aborted")
        return ae;
      o.status === "dirty" && e.dirty(), l.status === "dirty" && e.dirty(), o.value !== "__proto__" && (typeof l.value < "u" || a.alwaysSet) && (r[o.value] = l.value);
    }
    return { status: e.value, value: r };
  }
}
const ae = Object.freeze({
  status: "aborted"
}), Yn = (t) => ({ status: "dirty", value: t }), Je = (t) => ({ status: "valid", value: t }), xl = (t) => t.status === "aborted", Cl = (t) => t.status === "dirty", Sn = (t) => t.status === "valid", Wr = (t) => typeof Promise < "u" && t instanceof Promise;
var J;
(function(t) {
  t.errToObj = (e) => typeof e == "string" ? { message: e } : e || {}, t.toString = (e) => typeof e == "string" ? e : e?.message;
})(J || (J = {}));
class Ct {
  constructor(e, n, r, a) {
    this._cachedPath = [], this.parent = e, this.data = n, this._path = r, this._key = a;
  }
  get path() {
    return this._cachedPath.length || (Array.isArray(this._key) ? this._cachedPath.push(...this._path, ...this._key) : this._cachedPath.push(...this._path, this._key)), this._cachedPath;
  }
}
const jc = (t, e) => {
  if (Sn(e))
    return { success: !0, data: e.value };
  if (!t.common.issues.length)
    throw new Error("Validation failed but no issues detected.");
  return {
    success: !1,
    get error() {
      if (this._error)
        return this._error;
      const n = new rt(t.common.issues);
      return this._error = n, this._error;
    }
  };
};
function ue(t) {
  if (!t)
    return {};
  const { errorMap: e, invalid_type_error: n, required_error: r, description: a } = t;
  if (e && (n || r))
    throw new Error(`Can't use "invalid_type_error" or "required_error" in conjunction with custom error map.`);
  return e ? { errorMap: e, description: a } : { errorMap: (l, s) => {
    const { message: c } = t;
    return l.code === "invalid_enum_value" ? { message: c ?? s.defaultError } : typeof s.data > "u" ? { message: c ?? r ?? s.defaultError } : l.code !== "invalid_type" ? { message: s.defaultError } : { message: c ?? n ?? s.defaultError };
  }, description: a };
}
class pe {
  get description() {
    return this._def.description;
  }
  _getType(e) {
    return zt(e.data);
  }
  _getOrReturnCtx(e, n) {
    return n || {
      common: e.parent.common,
      data: e.data,
      parsedType: zt(e.data),
      schemaErrorMap: this._def.errorMap,
      path: e.path,
      parent: e.parent
    };
  }
  _processInputParams(e) {
    return {
      status: new Ze(),
      ctx: {
        common: e.parent.common,
        data: e.data,
        parsedType: zt(e.data),
        schemaErrorMap: this._def.errorMap,
        path: e.path,
        parent: e.parent
      }
    };
  }
  _parseSync(e) {
    const n = this._parse(e);
    if (Wr(n))
      throw new Error("Synchronous parse encountered promise.");
    return n;
  }
  _parseAsync(e) {
    const n = this._parse(e);
    return Promise.resolve(n);
  }
  parse(e, n) {
    const r = this.safeParse(e, n);
    if (r.success)
      return r.data;
    throw r.error;
  }
  safeParse(e, n) {
    const r = {
      common: {
        issues: [],
        async: n?.async ?? !1,
        contextualErrorMap: n?.errorMap
      },
      path: n?.path || [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: e,
      parsedType: zt(e)
    }, a = this._parseSync({ data: e, path: r.path, parent: r });
    return jc(r, a);
  }
  "~validate"(e) {
    const n = {
      common: {
        issues: [],
        async: !!this["~standard"].async
      },
      path: [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: e,
      parsedType: zt(e)
    };
    if (!this["~standard"].async)
      try {
        const r = this._parseSync({ data: e, path: [], parent: n });
        return Sn(r) ? {
          value: r.value
        } : {
          issues: n.common.issues
        };
      } catch (r) {
        r?.message?.toLowerCase()?.includes("encountered") && (this["~standard"].async = !0), n.common = {
          issues: [],
          async: !0
        };
      }
    return this._parseAsync({ data: e, path: [], parent: n }).then((r) => Sn(r) ? {
      value: r.value
    } : {
      issues: n.common.issues
    });
  }
  async parseAsync(e, n) {
    const r = await this.safeParseAsync(e, n);
    if (r.success)
      return r.data;
    throw r.error;
  }
  async safeParseAsync(e, n) {
    const r = {
      common: {
        issues: [],
        contextualErrorMap: n?.errorMap,
        async: !0
      },
      path: n?.path || [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: e,
      parsedType: zt(e)
    }, a = this._parse({ data: e, path: r.path, parent: r }), o = await (Wr(a) ? a : Promise.resolve(a));
    return jc(r, o);
  }
  refine(e, n) {
    const r = (a) => typeof n == "string" || typeof n > "u" ? { message: n } : typeof n == "function" ? n(a) : n;
    return this._refinement((a, o) => {
      const l = e(a), s = () => o.addIssue({
        code: R.custom,
        ...r(a)
      });
      return typeof Promise < "u" && l instanceof Promise ? l.then((c) => c ? !0 : (s(), !1)) : l ? !0 : (s(), !1);
    });
  }
  refinement(e, n) {
    return this._refinement((r, a) => e(r) ? !0 : (a.addIssue(typeof n == "function" ? n(r, a) : n), !1));
  }
  _refinement(e) {
    return new ht({
      schema: this,
      typeName: oe.ZodEffects,
      effect: { type: "refinement", refinement: e }
    });
  }
  superRefine(e) {
    return this._refinement(e);
  }
  constructor(e) {
    this.spa = this.safeParseAsync, this._def = e, this.parse = this.parse.bind(this), this.safeParse = this.safeParse.bind(this), this.parseAsync = this.parseAsync.bind(this), this.safeParseAsync = this.safeParseAsync.bind(this), this.spa = this.spa.bind(this), this.refine = this.refine.bind(this), this.refinement = this.refinement.bind(this), this.superRefine = this.superRefine.bind(this), this.optional = this.optional.bind(this), this.nullable = this.nullable.bind(this), this.nullish = this.nullish.bind(this), this.array = this.array.bind(this), this.promise = this.promise.bind(this), this.or = this.or.bind(this), this.and = this.and.bind(this), this.transform = this.transform.bind(this), this.brand = this.brand.bind(this), this.default = this.default.bind(this), this.catch = this.catch.bind(this), this.describe = this.describe.bind(this), this.pipe = this.pipe.bind(this), this.readonly = this.readonly.bind(this), this.isNullable = this.isNullable.bind(this), this.isOptional = this.isOptional.bind(this), this["~standard"] = {
      version: 1,
      vendor: "zod",
      validate: (n) => this["~validate"](n)
    };
  }
  optional() {
    return wt.create(this, this._def);
  }
  nullable() {
    return ln.create(this, this._def);
  }
  nullish() {
    return this.nullable().optional();
  }
  array() {
    return ft.create(this);
  }
  promise() {
    return ur.create(this, this._def);
  }
  or(e) {
    return Yr.create([this, e], this._def);
  }
  and(e) {
    return Zr.create(this, e, this._def);
  }
  transform(e) {
    return new ht({
      ...ue(this._def),
      schema: this,
      typeName: oe.ZodEffects,
      effect: { type: "transform", transform: e }
    });
  }
  default(e) {
    const n = typeof e == "function" ? e : () => e;
    return new ta({
      ...ue(this._def),
      innerType: this,
      defaultValue: n,
      typeName: oe.ZodDefault
    });
  }
  brand() {
    return new Ss({
      typeName: oe.ZodBranded,
      type: this,
      ...ue(this._def)
    });
  }
  catch(e) {
    const n = typeof e == "function" ? e : () => e;
    return new na({
      ...ue(this._def),
      innerType: this,
      catchValue: n,
      typeName: oe.ZodCatch
    });
  }
  describe(e) {
    const n = this.constructor;
    return new n({
      ...this._def,
      description: e
    });
  }
  pipe(e) {
    return Fa.create(this, e);
  }
  readonly() {
    return ra.create(this);
  }
  isOptional() {
    return this.safeParse(void 0).success;
  }
  isNullable() {
    return this.safeParse(null).success;
  }
}
const x8 = /^c[^\s-]{8,}$/i, C8 = /^[0-9a-z]+$/, M8 = /^[0-9A-HJKMNP-TV-Z]{26}$/i, S8 = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/i, F8 = /^[a-z0-9_-]{21}$/i, P8 = /^[A-Za-z0-9-_]+\.[A-Za-z0-9-_]+\.[A-Za-z0-9-_]*$/, N8 = /^[-+]?P(?!$)(?:(?:[-+]?\d+Y)|(?:[-+]?\d+[.,]\d+Y$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:(?:[-+]?\d+W)|(?:[-+]?\d+[.,]\d+W$))?(?:(?:[-+]?\d+D)|(?:[-+]?\d+[.,]\d+D$))?(?:T(?=[\d+-])(?:(?:[-+]?\d+H)|(?:[-+]?\d+[.,]\d+H$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:[-+]?\d+(?:[.,]\d+)?S)?)??$/, _8 = /^(?!\.)(?!.*\.\.)([A-Z0-9_'+\-\.]*)[A-Z0-9_+-]@([A-Z0-9][A-Z0-9\-]*\.)+[A-Z]{2,}$/i, T8 = "^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$";
let Ao;
const A8 = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])$/, z8 = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\/(3[0-2]|[12]?[0-9])$/, D8 = /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))$/, I8 = /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))\/(12[0-8]|1[01][0-9]|[1-9]?[0-9])$/, k8 = /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/, O8 = /^([0-9a-zA-Z-_]{4})*(([0-9a-zA-Z-_]{2}(==)?)|([0-9a-zA-Z-_]{3}(=)?))?$/, R2 = "((\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-((0[13578]|1[02])-(0[1-9]|[12]\\d|3[01])|(0[469]|11)-(0[1-9]|[12]\\d|30)|(02)-(0[1-9]|1\\d|2[0-8])))", L8 = new RegExp(`^${R2}$`);
function H2(t) {
  let e = "[0-5]\\d";
  t.precision ? e = `${e}\\.\\d{${t.precision}}` : t.precision == null && (e = `${e}(\\.\\d+)?`);
  const n = t.precision ? "+" : "?";
  return `([01]\\d|2[0-3]):[0-5]\\d(:${e})${n}`;
}
function R8(t) {
  return new RegExp(`^${H2(t)}$`);
}
function B2(t) {
  let e = `${R2}T${H2(t)}`;
  const n = [];
  return n.push(t.local ? "Z?" : "Z"), t.offset && n.push("([+-]\\d{2}:?\\d{2})"), e = `${e}(${n.join("|")})`, new RegExp(`^${e}$`);
}
function H8(t, e) {
  return !!((e === "v4" || !e) && A8.test(t) || (e === "v6" || !e) && D8.test(t));
}
function B8(t, e) {
  if (!P8.test(t))
    return !1;
  try {
    const [n] = t.split(".");
    if (!n)
      return !1;
    const r = n.replace(/-/g, "+").replace(/_/g, "/").padEnd(n.length + (4 - n.length % 4) % 4, "="), a = JSON.parse(atob(r));
    return !(typeof a != "object" || a === null || "typ" in a && a?.typ !== "JWT" || !a.alg || e && a.alg !== e);
  } catch {
    return !1;
  }
}
function j8(t, e) {
  return !!((e === "v4" || !e) && z8.test(t) || (e === "v6" || !e) && I8.test(t));
}
class ut extends pe {
  _parse(e) {
    if (this._def.coerce && (e.data = String(e.data)), this._getType(e) !== q.string) {
      const o = this._getOrReturnCtx(e);
      return U(o, {
        code: R.invalid_type,
        expected: q.string,
        received: o.parsedType
      }), ae;
    }
    const r = new Ze();
    let a;
    for (const o of this._def.checks)
      if (o.kind === "min")
        e.data.length < o.value && (a = this._getOrReturnCtx(e, a), U(a, {
          code: R.too_small,
          minimum: o.value,
          type: "string",
          inclusive: !0,
          exact: !1,
          message: o.message
        }), r.dirty());
      else if (o.kind === "max")
        e.data.length > o.value && (a = this._getOrReturnCtx(e, a), U(a, {
          code: R.too_big,
          maximum: o.value,
          type: "string",
          inclusive: !0,
          exact: !1,
          message: o.message
        }), r.dirty());
      else if (o.kind === "length") {
        const l = e.data.length > o.value, s = e.data.length < o.value;
        (l || s) && (a = this._getOrReturnCtx(e, a), l ? U(a, {
          code: R.too_big,
          maximum: o.value,
          type: "string",
          inclusive: !0,
          exact: !0,
          message: o.message
        }) : s && U(a, {
          code: R.too_small,
          minimum: o.value,
          type: "string",
          inclusive: !0,
          exact: !0,
          message: o.message
        }), r.dirty());
      } else if (o.kind === "email")
        _8.test(e.data) || (a = this._getOrReturnCtx(e, a), U(a, {
          validation: "email",
          code: R.invalid_string,
          message: o.message
        }), r.dirty());
      else if (o.kind === "emoji")
        Ao || (Ao = new RegExp(T8, "u")), Ao.test(e.data) || (a = this._getOrReturnCtx(e, a), U(a, {
          validation: "emoji",
          code: R.invalid_string,
          message: o.message
        }), r.dirty());
      else if (o.kind === "uuid")
        S8.test(e.data) || (a = this._getOrReturnCtx(e, a), U(a, {
          validation: "uuid",
          code: R.invalid_string,
          message: o.message
        }), r.dirty());
      else if (o.kind === "nanoid")
        F8.test(e.data) || (a = this._getOrReturnCtx(e, a), U(a, {
          validation: "nanoid",
          code: R.invalid_string,
          message: o.message
        }), r.dirty());
      else if (o.kind === "cuid")
        x8.test(e.data) || (a = this._getOrReturnCtx(e, a), U(a, {
          validation: "cuid",
          code: R.invalid_string,
          message: o.message
        }), r.dirty());
      else if (o.kind === "cuid2")
        C8.test(e.data) || (a = this._getOrReturnCtx(e, a), U(a, {
          validation: "cuid2",
          code: R.invalid_string,
          message: o.message
        }), r.dirty());
      else if (o.kind === "ulid")
        M8.test(e.data) || (a = this._getOrReturnCtx(e, a), U(a, {
          validation: "ulid",
          code: R.invalid_string,
          message: o.message
        }), r.dirty());
      else if (o.kind === "url")
        try {
          new URL(e.data);
        } catch {
          a = this._getOrReturnCtx(e, a), U(a, {
            validation: "url",
            code: R.invalid_string,
            message: o.message
          }), r.dirty();
        }
      else o.kind === "regex" ? (o.regex.lastIndex = 0, o.regex.test(e.data) || (a = this._getOrReturnCtx(e, a), U(a, {
        validation: "regex",
        code: R.invalid_string,
        message: o.message
      }), r.dirty())) : o.kind === "trim" ? e.data = e.data.trim() : o.kind === "includes" ? e.data.includes(o.value, o.position) || (a = this._getOrReturnCtx(e, a), U(a, {
        code: R.invalid_string,
        validation: { includes: o.value, position: o.position },
        message: o.message
      }), r.dirty()) : o.kind === "toLowerCase" ? e.data = e.data.toLowerCase() : o.kind === "toUpperCase" ? e.data = e.data.toUpperCase() : o.kind === "startsWith" ? e.data.startsWith(o.value) || (a = this._getOrReturnCtx(e, a), U(a, {
        code: R.invalid_string,
        validation: { startsWith: o.value },
        message: o.message
      }), r.dirty()) : o.kind === "endsWith" ? e.data.endsWith(o.value) || (a = this._getOrReturnCtx(e, a), U(a, {
        code: R.invalid_string,
        validation: { endsWith: o.value },
        message: o.message
      }), r.dirty()) : o.kind === "datetime" ? B2(o).test(e.data) || (a = this._getOrReturnCtx(e, a), U(a, {
        code: R.invalid_string,
        validation: "datetime",
        message: o.message
      }), r.dirty()) : o.kind === "date" ? L8.test(e.data) || (a = this._getOrReturnCtx(e, a), U(a, {
        code: R.invalid_string,
        validation: "date",
        message: o.message
      }), r.dirty()) : o.kind === "time" ? R8(o).test(e.data) || (a = this._getOrReturnCtx(e, a), U(a, {
        code: R.invalid_string,
        validation: "time",
        message: o.message
      }), r.dirty()) : o.kind === "duration" ? N8.test(e.data) || (a = this._getOrReturnCtx(e, a), U(a, {
        validation: "duration",
        code: R.invalid_string,
        message: o.message
      }), r.dirty()) : o.kind === "ip" ? H8(e.data, o.version) || (a = this._getOrReturnCtx(e, a), U(a, {
        validation: "ip",
        code: R.invalid_string,
        message: o.message
      }), r.dirty()) : o.kind === "jwt" ? B8(e.data, o.alg) || (a = this._getOrReturnCtx(e, a), U(a, {
        validation: "jwt",
        code: R.invalid_string,
        message: o.message
      }), r.dirty()) : o.kind === "cidr" ? j8(e.data, o.version) || (a = this._getOrReturnCtx(e, a), U(a, {
        validation: "cidr",
        code: R.invalid_string,
        message: o.message
      }), r.dirty()) : o.kind === "base64" ? k8.test(e.data) || (a = this._getOrReturnCtx(e, a), U(a, {
        validation: "base64",
        code: R.invalid_string,
        message: o.message
      }), r.dirty()) : o.kind === "base64url" ? O8.test(e.data) || (a = this._getOrReturnCtx(e, a), U(a, {
        validation: "base64url",
        code: R.invalid_string,
        message: o.message
      }), r.dirty()) : ge.assertNever(o);
    return { status: r.value, value: e.data };
  }
  _regex(e, n, r) {
    return this.refinement((a) => e.test(a), {
      validation: n,
      code: R.invalid_string,
      ...J.errToObj(r)
    });
  }
  _addCheck(e) {
    return new ut({
      ...this._def,
      checks: [...this._def.checks, e]
    });
  }
  email(e) {
    return this._addCheck({ kind: "email", ...J.errToObj(e) });
  }
  url(e) {
    return this._addCheck({ kind: "url", ...J.errToObj(e) });
  }
  emoji(e) {
    return this._addCheck({ kind: "emoji", ...J.errToObj(e) });
  }
  uuid(e) {
    return this._addCheck({ kind: "uuid", ...J.errToObj(e) });
  }
  nanoid(e) {
    return this._addCheck({ kind: "nanoid", ...J.errToObj(e) });
  }
  cuid(e) {
    return this._addCheck({ kind: "cuid", ...J.errToObj(e) });
  }
  cuid2(e) {
    return this._addCheck({ kind: "cuid2", ...J.errToObj(e) });
  }
  ulid(e) {
    return this._addCheck({ kind: "ulid", ...J.errToObj(e) });
  }
  base64(e) {
    return this._addCheck({ kind: "base64", ...J.errToObj(e) });
  }
  base64url(e) {
    return this._addCheck({
      kind: "base64url",
      ...J.errToObj(e)
    });
  }
  jwt(e) {
    return this._addCheck({ kind: "jwt", ...J.errToObj(e) });
  }
  ip(e) {
    return this._addCheck({ kind: "ip", ...J.errToObj(e) });
  }
  cidr(e) {
    return this._addCheck({ kind: "cidr", ...J.errToObj(e) });
  }
  datetime(e) {
    return typeof e == "string" ? this._addCheck({
      kind: "datetime",
      precision: null,
      offset: !1,
      local: !1,
      message: e
    }) : this._addCheck({
      kind: "datetime",
      precision: typeof e?.precision > "u" ? null : e?.precision,
      offset: e?.offset ?? !1,
      local: e?.local ?? !1,
      ...J.errToObj(e?.message)
    });
  }
  date(e) {
    return this._addCheck({ kind: "date", message: e });
  }
  time(e) {
    return typeof e == "string" ? this._addCheck({
      kind: "time",
      precision: null,
      message: e
    }) : this._addCheck({
      kind: "time",
      precision: typeof e?.precision > "u" ? null : e?.precision,
      ...J.errToObj(e?.message)
    });
  }
  duration(e) {
    return this._addCheck({ kind: "duration", ...J.errToObj(e) });
  }
  regex(e, n) {
    return this._addCheck({
      kind: "regex",
      regex: e,
      ...J.errToObj(n)
    });
  }
  includes(e, n) {
    return this._addCheck({
      kind: "includes",
      value: e,
      position: n?.position,
      ...J.errToObj(n?.message)
    });
  }
  startsWith(e, n) {
    return this._addCheck({
      kind: "startsWith",
      value: e,
      ...J.errToObj(n)
    });
  }
  endsWith(e, n) {
    return this._addCheck({
      kind: "endsWith",
      value: e,
      ...J.errToObj(n)
    });
  }
  min(e, n) {
    return this._addCheck({
      kind: "min",
      value: e,
      ...J.errToObj(n)
    });
  }
  max(e, n) {
    return this._addCheck({
      kind: "max",
      value: e,
      ...J.errToObj(n)
    });
  }
  length(e, n) {
    return this._addCheck({
      kind: "length",
      value: e,
      ...J.errToObj(n)
    });
  }
  /**
   * Equivalent to `.min(1)`
   */
  nonempty(e) {
    return this.min(1, J.errToObj(e));
  }
  trim() {
    return new ut({
      ...this._def,
      checks: [...this._def.checks, { kind: "trim" }]
    });
  }
  toLowerCase() {
    return new ut({
      ...this._def,
      checks: [...this._def.checks, { kind: "toLowerCase" }]
    });
  }
  toUpperCase() {
    return new ut({
      ...this._def,
      checks: [...this._def.checks, { kind: "toUpperCase" }]
    });
  }
  get isDatetime() {
    return !!this._def.checks.find((e) => e.kind === "datetime");
  }
  get isDate() {
    return !!this._def.checks.find((e) => e.kind === "date");
  }
  get isTime() {
    return !!this._def.checks.find((e) => e.kind === "time");
  }
  get isDuration() {
    return !!this._def.checks.find((e) => e.kind === "duration");
  }
  get isEmail() {
    return !!this._def.checks.find((e) => e.kind === "email");
  }
  get isURL() {
    return !!this._def.checks.find((e) => e.kind === "url");
  }
  get isEmoji() {
    return !!this._def.checks.find((e) => e.kind === "emoji");
  }
  get isUUID() {
    return !!this._def.checks.find((e) => e.kind === "uuid");
  }
  get isNANOID() {
    return !!this._def.checks.find((e) => e.kind === "nanoid");
  }
  get isCUID() {
    return !!this._def.checks.find((e) => e.kind === "cuid");
  }
  get isCUID2() {
    return !!this._def.checks.find((e) => e.kind === "cuid2");
  }
  get isULID() {
    return !!this._def.checks.find((e) => e.kind === "ulid");
  }
  get isIP() {
    return !!this._def.checks.find((e) => e.kind === "ip");
  }
  get isCIDR() {
    return !!this._def.checks.find((e) => e.kind === "cidr");
  }
  get isBase64() {
    return !!this._def.checks.find((e) => e.kind === "base64");
  }
  get isBase64url() {
    return !!this._def.checks.find((e) => e.kind === "base64url");
  }
  get minLength() {
    let e = null;
    for (const n of this._def.checks)
      n.kind === "min" && (e === null || n.value > e) && (e = n.value);
    return e;
  }
  get maxLength() {
    let e = null;
    for (const n of this._def.checks)
      n.kind === "max" && (e === null || n.value < e) && (e = n.value);
    return e;
  }
}
ut.create = (t) => new ut({
  checks: [],
  typeName: oe.ZodString,
  coerce: t?.coerce ?? !1,
  ...ue(t)
});
function V8(t, e) {
  const n = (t.toString().split(".")[1] || "").length, r = (e.toString().split(".")[1] || "").length, a = n > r ? n : r, o = Number.parseInt(t.toFixed(a).replace(".", "")), l = Number.parseInt(e.toFixed(a).replace(".", ""));
  return o % l / 10 ** a;
}
class rn extends pe {
  constructor() {
    super(...arguments), this.min = this.gte, this.max = this.lte, this.step = this.multipleOf;
  }
  _parse(e) {
    if (this._def.coerce && (e.data = Number(e.data)), this._getType(e) !== q.number) {
      const o = this._getOrReturnCtx(e);
      return U(o, {
        code: R.invalid_type,
        expected: q.number,
        received: o.parsedType
      }), ae;
    }
    let r;
    const a = new Ze();
    for (const o of this._def.checks)
      o.kind === "int" ? ge.isInteger(e.data) || (r = this._getOrReturnCtx(e, r), U(r, {
        code: R.invalid_type,
        expected: "integer",
        received: "float",
        message: o.message
      }), a.dirty()) : o.kind === "min" ? (o.inclusive ? e.data < o.value : e.data <= o.value) && (r = this._getOrReturnCtx(e, r), U(r, {
        code: R.too_small,
        minimum: o.value,
        type: "number",
        inclusive: o.inclusive,
        exact: !1,
        message: o.message
      }), a.dirty()) : o.kind === "max" ? (o.inclusive ? e.data > o.value : e.data >= o.value) && (r = this._getOrReturnCtx(e, r), U(r, {
        code: R.too_big,
        maximum: o.value,
        type: "number",
        inclusive: o.inclusive,
        exact: !1,
        message: o.message
      }), a.dirty()) : o.kind === "multipleOf" ? V8(e.data, o.value) !== 0 && (r = this._getOrReturnCtx(e, r), U(r, {
        code: R.not_multiple_of,
        multipleOf: o.value,
        message: o.message
      }), a.dirty()) : o.kind === "finite" ? Number.isFinite(e.data) || (r = this._getOrReturnCtx(e, r), U(r, {
        code: R.not_finite,
        message: o.message
      }), a.dirty()) : ge.assertNever(o);
    return { status: a.value, value: e.data };
  }
  gte(e, n) {
    return this.setLimit("min", e, !0, J.toString(n));
  }
  gt(e, n) {
    return this.setLimit("min", e, !1, J.toString(n));
  }
  lte(e, n) {
    return this.setLimit("max", e, !0, J.toString(n));
  }
  lt(e, n) {
    return this.setLimit("max", e, !1, J.toString(n));
  }
  setLimit(e, n, r, a) {
    return new rn({
      ...this._def,
      checks: [
        ...this._def.checks,
        {
          kind: e,
          value: n,
          inclusive: r,
          message: J.toString(a)
        }
      ]
    });
  }
  _addCheck(e) {
    return new rn({
      ...this._def,
      checks: [...this._def.checks, e]
    });
  }
  int(e) {
    return this._addCheck({
      kind: "int",
      message: J.toString(e)
    });
  }
  positive(e) {
    return this._addCheck({
      kind: "min",
      value: 0,
      inclusive: !1,
      message: J.toString(e)
    });
  }
  negative(e) {
    return this._addCheck({
      kind: "max",
      value: 0,
      inclusive: !1,
      message: J.toString(e)
    });
  }
  nonpositive(e) {
    return this._addCheck({
      kind: "max",
      value: 0,
      inclusive: !0,
      message: J.toString(e)
    });
  }
  nonnegative(e) {
    return this._addCheck({
      kind: "min",
      value: 0,
      inclusive: !0,
      message: J.toString(e)
    });
  }
  multipleOf(e, n) {
    return this._addCheck({
      kind: "multipleOf",
      value: e,
      message: J.toString(n)
    });
  }
  finite(e) {
    return this._addCheck({
      kind: "finite",
      message: J.toString(e)
    });
  }
  safe(e) {
    return this._addCheck({
      kind: "min",
      inclusive: !0,
      value: Number.MIN_SAFE_INTEGER,
      message: J.toString(e)
    })._addCheck({
      kind: "max",
      inclusive: !0,
      value: Number.MAX_SAFE_INTEGER,
      message: J.toString(e)
    });
  }
  get minValue() {
    let e = null;
    for (const n of this._def.checks)
      n.kind === "min" && (e === null || n.value > e) && (e = n.value);
    return e;
  }
  get maxValue() {
    let e = null;
    for (const n of this._def.checks)
      n.kind === "max" && (e === null || n.value < e) && (e = n.value);
    return e;
  }
  get isInt() {
    return !!this._def.checks.find((e) => e.kind === "int" || e.kind === "multipleOf" && ge.isInteger(e.value));
  }
  get isFinite() {
    let e = null, n = null;
    for (const r of this._def.checks) {
      if (r.kind === "finite" || r.kind === "int" || r.kind === "multipleOf")
        return !0;
      r.kind === "min" ? (n === null || r.value > n) && (n = r.value) : r.kind === "max" && (e === null || r.value < e) && (e = r.value);
    }
    return Number.isFinite(n) && Number.isFinite(e);
  }
}
rn.create = (t) => new rn({
  checks: [],
  typeName: oe.ZodNumber,
  coerce: t?.coerce || !1,
  ...ue(t)
});
class an extends pe {
  constructor() {
    super(...arguments), this.min = this.gte, this.max = this.lte;
  }
  _parse(e) {
    if (this._def.coerce)
      try {
        e.data = BigInt(e.data);
      } catch {
        return this._getInvalidInput(e);
      }
    if (this._getType(e) !== q.bigint)
      return this._getInvalidInput(e);
    let r;
    const a = new Ze();
    for (const o of this._def.checks)
      o.kind === "min" ? (o.inclusive ? e.data < o.value : e.data <= o.value) && (r = this._getOrReturnCtx(e, r), U(r, {
        code: R.too_small,
        type: "bigint",
        minimum: o.value,
        inclusive: o.inclusive,
        message: o.message
      }), a.dirty()) : o.kind === "max" ? (o.inclusive ? e.data > o.value : e.data >= o.value) && (r = this._getOrReturnCtx(e, r), U(r, {
        code: R.too_big,
        type: "bigint",
        maximum: o.value,
        inclusive: o.inclusive,
        message: o.message
      }), a.dirty()) : o.kind === "multipleOf" ? e.data % o.value !== BigInt(0) && (r = this._getOrReturnCtx(e, r), U(r, {
        code: R.not_multiple_of,
        multipleOf: o.value,
        message: o.message
      }), a.dirty()) : ge.assertNever(o);
    return { status: a.value, value: e.data };
  }
  _getInvalidInput(e) {
    const n = this._getOrReturnCtx(e);
    return U(n, {
      code: R.invalid_type,
      expected: q.bigint,
      received: n.parsedType
    }), ae;
  }
  gte(e, n) {
    return this.setLimit("min", e, !0, J.toString(n));
  }
  gt(e, n) {
    return this.setLimit("min", e, !1, J.toString(n));
  }
  lte(e, n) {
    return this.setLimit("max", e, !0, J.toString(n));
  }
  lt(e, n) {
    return this.setLimit("max", e, !1, J.toString(n));
  }
  setLimit(e, n, r, a) {
    return new an({
      ...this._def,
      checks: [
        ...this._def.checks,
        {
          kind: e,
          value: n,
          inclusive: r,
          message: J.toString(a)
        }
      ]
    });
  }
  _addCheck(e) {
    return new an({
      ...this._def,
      checks: [...this._def.checks, e]
    });
  }
  positive(e) {
    return this._addCheck({
      kind: "min",
      value: BigInt(0),
      inclusive: !1,
      message: J.toString(e)
    });
  }
  negative(e) {
    return this._addCheck({
      kind: "max",
      value: BigInt(0),
      inclusive: !1,
      message: J.toString(e)
    });
  }
  nonpositive(e) {
    return this._addCheck({
      kind: "max",
      value: BigInt(0),
      inclusive: !0,
      message: J.toString(e)
    });
  }
  nonnegative(e) {
    return this._addCheck({
      kind: "min",
      value: BigInt(0),
      inclusive: !0,
      message: J.toString(e)
    });
  }
  multipleOf(e, n) {
    return this._addCheck({
      kind: "multipleOf",
      value: e,
      message: J.toString(n)
    });
  }
  get minValue() {
    let e = null;
    for (const n of this._def.checks)
      n.kind === "min" && (e === null || n.value > e) && (e = n.value);
    return e;
  }
  get maxValue() {
    let e = null;
    for (const n of this._def.checks)
      n.kind === "max" && (e === null || n.value < e) && (e = n.value);
    return e;
  }
}
an.create = (t) => new an({
  checks: [],
  typeName: oe.ZodBigInt,
  coerce: t?.coerce ?? !1,
  ...ue(t)
});
class Gr extends pe {
  _parse(e) {
    if (this._def.coerce && (e.data = !!e.data), this._getType(e) !== q.boolean) {
      const r = this._getOrReturnCtx(e);
      return U(r, {
        code: R.invalid_type,
        expected: q.boolean,
        received: r.parsedType
      }), ae;
    }
    return Je(e.data);
  }
}
Gr.create = (t) => new Gr({
  typeName: oe.ZodBoolean,
  coerce: t?.coerce || !1,
  ...ue(t)
});
class Fn extends pe {
  _parse(e) {
    if (this._def.coerce && (e.data = new Date(e.data)), this._getType(e) !== q.date) {
      const o = this._getOrReturnCtx(e);
      return U(o, {
        code: R.invalid_type,
        expected: q.date,
        received: o.parsedType
      }), ae;
    }
    if (Number.isNaN(e.data.getTime())) {
      const o = this._getOrReturnCtx(e);
      return U(o, {
        code: R.invalid_date
      }), ae;
    }
    const r = new Ze();
    let a;
    for (const o of this._def.checks)
      o.kind === "min" ? e.data.getTime() < o.value && (a = this._getOrReturnCtx(e, a), U(a, {
        code: R.too_small,
        message: o.message,
        inclusive: !0,
        exact: !1,
        minimum: o.value,
        type: "date"
      }), r.dirty()) : o.kind === "max" ? e.data.getTime() > o.value && (a = this._getOrReturnCtx(e, a), U(a, {
        code: R.too_big,
        message: o.message,
        inclusive: !0,
        exact: !1,
        maximum: o.value,
        type: "date"
      }), r.dirty()) : ge.assertNever(o);
    return {
      status: r.value,
      value: new Date(e.data.getTime())
    };
  }
  _addCheck(e) {
    return new Fn({
      ...this._def,
      checks: [...this._def.checks, e]
    });
  }
  min(e, n) {
    return this._addCheck({
      kind: "min",
      value: e.getTime(),
      message: J.toString(n)
    });
  }
  max(e, n) {
    return this._addCheck({
      kind: "max",
      value: e.getTime(),
      message: J.toString(n)
    });
  }
  get minDate() {
    let e = null;
    for (const n of this._def.checks)
      n.kind === "min" && (e === null || n.value > e) && (e = n.value);
    return e != null ? new Date(e) : null;
  }
  get maxDate() {
    let e = null;
    for (const n of this._def.checks)
      n.kind === "max" && (e === null || n.value < e) && (e = n.value);
    return e != null ? new Date(e) : null;
  }
}
Fn.create = (t) => new Fn({
  checks: [],
  coerce: t?.coerce || !1,
  typeName: oe.ZodDate,
  ...ue(t)
});
class hi extends pe {
  _parse(e) {
    if (this._getType(e) !== q.symbol) {
      const r = this._getOrReturnCtx(e);
      return U(r, {
        code: R.invalid_type,
        expected: q.symbol,
        received: r.parsedType
      }), ae;
    }
    return Je(e.data);
  }
}
hi.create = (t) => new hi({
  typeName: oe.ZodSymbol,
  ...ue(t)
});
class Kr extends pe {
  _parse(e) {
    if (this._getType(e) !== q.undefined) {
      const r = this._getOrReturnCtx(e);
      return U(r, {
        code: R.invalid_type,
        expected: q.undefined,
        received: r.parsedType
      }), ae;
    }
    return Je(e.data);
  }
}
Kr.create = (t) => new Kr({
  typeName: oe.ZodUndefined,
  ...ue(t)
});
class qr extends pe {
  _parse(e) {
    if (this._getType(e) !== q.null) {
      const r = this._getOrReturnCtx(e);
      return U(r, {
        code: R.invalid_type,
        expected: q.null,
        received: r.parsedType
      }), ae;
    }
    return Je(e.data);
  }
}
qr.create = (t) => new qr({
  typeName: oe.ZodNull,
  ...ue(t)
});
class dr extends pe {
  constructor() {
    super(...arguments), this._any = !0;
  }
  _parse(e) {
    return Je(e.data);
  }
}
dr.create = (t) => new dr({
  typeName: oe.ZodAny,
  ...ue(t)
});
class En extends pe {
  constructor() {
    super(...arguments), this._unknown = !0;
  }
  _parse(e) {
    return Je(e.data);
  }
}
En.create = (t) => new En({
  typeName: oe.ZodUnknown,
  ...ue(t)
});
class jt extends pe {
  _parse(e) {
    const n = this._getOrReturnCtx(e);
    return U(n, {
      code: R.invalid_type,
      expected: q.never,
      received: n.parsedType
    }), ae;
  }
}
jt.create = (t) => new jt({
  typeName: oe.ZodNever,
  ...ue(t)
});
class vi extends pe {
  _parse(e) {
    if (this._getType(e) !== q.undefined) {
      const r = this._getOrReturnCtx(e);
      return U(r, {
        code: R.invalid_type,
        expected: q.void,
        received: r.parsedType
      }), ae;
    }
    return Je(e.data);
  }
}
vi.create = (t) => new vi({
  typeName: oe.ZodVoid,
  ...ue(t)
});
class ft extends pe {
  _parse(e) {
    const { ctx: n, status: r } = this._processInputParams(e), a = this._def;
    if (n.parsedType !== q.array)
      return U(n, {
        code: R.invalid_type,
        expected: q.array,
        received: n.parsedType
      }), ae;
    if (a.exactLength !== null) {
      const l = n.data.length > a.exactLength.value, s = n.data.length < a.exactLength.value;
      (l || s) && (U(n, {
        code: l ? R.too_big : R.too_small,
        minimum: s ? a.exactLength.value : void 0,
        maximum: l ? a.exactLength.value : void 0,
        type: "array",
        inclusive: !0,
        exact: !0,
        message: a.exactLength.message
      }), r.dirty());
    }
    if (a.minLength !== null && n.data.length < a.minLength.value && (U(n, {
      code: R.too_small,
      minimum: a.minLength.value,
      type: "array",
      inclusive: !0,
      exact: !1,
      message: a.minLength.message
    }), r.dirty()), a.maxLength !== null && n.data.length > a.maxLength.value && (U(n, {
      code: R.too_big,
      maximum: a.maxLength.value,
      type: "array",
      inclusive: !0,
      exact: !1,
      message: a.maxLength.message
    }), r.dirty()), n.common.async)
      return Promise.all([...n.data].map((l, s) => a.type._parseAsync(new Ct(n, l, n.path, s)))).then((l) => Ze.mergeArray(r, l));
    const o = [...n.data].map((l, s) => a.type._parseSync(new Ct(n, l, n.path, s)));
    return Ze.mergeArray(r, o);
  }
  get element() {
    return this._def.type;
  }
  min(e, n) {
    return new ft({
      ...this._def,
      minLength: { value: e, message: J.toString(n) }
    });
  }
  max(e, n) {
    return new ft({
      ...this._def,
      maxLength: { value: e, message: J.toString(n) }
    });
  }
  length(e, n) {
    return new ft({
      ...this._def,
      exactLength: { value: e, message: J.toString(n) }
    });
  }
  nonempty(e) {
    return this.min(1, e);
  }
}
ft.create = (t, e) => new ft({
  type: t,
  minLength: null,
  maxLength: null,
  exactLength: null,
  typeName: oe.ZodArray,
  ...ue(e)
});
function qn(t) {
  if (t instanceof ke) {
    const e = {};
    for (const n in t.shape) {
      const r = t.shape[n];
      e[n] = wt.create(qn(r));
    }
    return new ke({
      ...t._def,
      shape: () => e
    });
  } else return t instanceof ft ? new ft({
    ...t._def,
    type: qn(t.element)
  }) : t instanceof wt ? wt.create(qn(t.unwrap())) : t instanceof ln ? ln.create(qn(t.unwrap())) : t instanceof Mt ? Mt.create(t.items.map((e) => qn(e))) : t;
}
class ke extends pe {
  constructor() {
    super(...arguments), this._cached = null, this.nonstrict = this.passthrough, this.augment = this.extend;
  }
  _getCached() {
    if (this._cached !== null)
      return this._cached;
    const e = this._def.shape(), n = ge.objectKeys(e);
    return this._cached = { shape: e, keys: n }, this._cached;
  }
  _parse(e) {
    if (this._getType(e) !== q.object) {
      const d = this._getOrReturnCtx(e);
      return U(d, {
        code: R.invalid_type,
        expected: q.object,
        received: d.parsedType
      }), ae;
    }
    const { status: r, ctx: a } = this._processInputParams(e), { shape: o, keys: l } = this._getCached(), s = [];
    if (!(this._def.catchall instanceof jt && this._def.unknownKeys === "strip"))
      for (const d in a.data)
        l.includes(d) || s.push(d);
    const c = [];
    for (const d of l) {
      const u = o[d], f = a.data[d];
      c.push({
        key: { status: "valid", value: d },
        value: u._parse(new Ct(a, f, a.path, d)),
        alwaysSet: d in a.data
      });
    }
    if (this._def.catchall instanceof jt) {
      const d = this._def.unknownKeys;
      if (d === "passthrough")
        for (const u of s)
          c.push({
            key: { status: "valid", value: u },
            value: { status: "valid", value: a.data[u] }
          });
      else if (d === "strict")
        s.length > 0 && (U(a, {
          code: R.unrecognized_keys,
          keys: s
        }), r.dirty());
      else if (d !== "strip") throw new Error("Internal ZodObject error: invalid unknownKeys value.");
    } else {
      const d = this._def.catchall;
      for (const u of s) {
        const f = a.data[u];
        c.push({
          key: { status: "valid", value: u },
          value: d._parse(
            new Ct(a, f, a.path, u)
            //, ctx.child(key), value, getParsedType(value)
          ),
          alwaysSet: u in a.data
        });
      }
    }
    return a.common.async ? Promise.resolve().then(async () => {
      const d = [];
      for (const u of c) {
        const f = await u.key, m = await u.value;
        d.push({
          key: f,
          value: m,
          alwaysSet: u.alwaysSet
        });
      }
      return d;
    }).then((d) => Ze.mergeObjectSync(r, d)) : Ze.mergeObjectSync(r, c);
  }
  get shape() {
    return this._def.shape();
  }
  strict(e) {
    return J.errToObj, new ke({
      ...this._def,
      unknownKeys: "strict",
      ...e !== void 0 ? {
        errorMap: (n, r) => {
          const a = this._def.errorMap?.(n, r).message ?? r.defaultError;
          return n.code === "unrecognized_keys" ? {
            message: J.errToObj(e).message ?? a
          } : {
            message: a
          };
        }
      } : {}
    });
  }
  strip() {
    return new ke({
      ...this._def,
      unknownKeys: "strip"
    });
  }
  passthrough() {
    return new ke({
      ...this._def,
      unknownKeys: "passthrough"
    });
  }
  // const AugmentFactory =
  //   <Def extends ZodObjectDef>(def: Def) =>
  //   <Augmentation extends ZodRawShape>(
  //     augmentation: Augmentation
  //   ): ZodObject<
  //     extendShape<ReturnType<Def["shape"]>, Augmentation>,
  //     Def["unknownKeys"],
  //     Def["catchall"]
  //   > => {
  //     return new ZodObject({
  //       ...def,
  //       shape: () => ({
  //         ...def.shape(),
  //         ...augmentation,
  //       }),
  //     }) as any;
  //   };
  extend(e) {
    return new ke({
      ...this._def,
      shape: () => ({
        ...this._def.shape(),
        ...e
      })
    });
  }
  /**
   * Prior to zod@1.0.12 there was a bug in the
   * inferred type of merged objects. Please
   * upgrade if you are experiencing issues.
   */
  merge(e) {
    return new ke({
      unknownKeys: e._def.unknownKeys,
      catchall: e._def.catchall,
      shape: () => ({
        ...this._def.shape(),
        ...e._def.shape()
      }),
      typeName: oe.ZodObject
    });
  }
  // merge<
  //   Incoming extends AnyZodObject,
  //   Augmentation extends Incoming["shape"],
  //   NewOutput extends {
  //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
  //       ? Augmentation[k]["_output"]
  //       : k extends keyof Output
  //       ? Output[k]
  //       : never;
  //   },
  //   NewInput extends {
  //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
  //       ? Augmentation[k]["_input"]
  //       : k extends keyof Input
  //       ? Input[k]
  //       : never;
  //   }
  // >(
  //   merging: Incoming
  // ): ZodObject<
  //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
  //   Incoming["_def"]["unknownKeys"],
  //   Incoming["_def"]["catchall"],
  //   NewOutput,
  //   NewInput
  // > {
  //   const merged: any = new ZodObject({
  //     unknownKeys: merging._def.unknownKeys,
  //     catchall: merging._def.catchall,
  //     shape: () =>
  //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
  //     typeName: ZodFirstPartyTypeKind.ZodObject,
  //   }) as any;
  //   return merged;
  // }
  setKey(e, n) {
    return this.augment({ [e]: n });
  }
  // merge<Incoming extends AnyZodObject>(
  //   merging: Incoming
  // ): //ZodObject<T & Incoming["_shape"], UnknownKeys, Catchall> = (merging) => {
  // ZodObject<
  //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
  //   Incoming["_def"]["unknownKeys"],
  //   Incoming["_def"]["catchall"]
  // > {
  //   // const mergedShape = objectUtil.mergeShapes(
  //   //   this._def.shape(),
  //   //   merging._def.shape()
  //   // );
  //   const merged: any = new ZodObject({
  //     unknownKeys: merging._def.unknownKeys,
  //     catchall: merging._def.catchall,
  //     shape: () =>
  //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
  //     typeName: ZodFirstPartyTypeKind.ZodObject,
  //   }) as any;
  //   return merged;
  // }
  catchall(e) {
    return new ke({
      ...this._def,
      catchall: e
    });
  }
  pick(e) {
    const n = {};
    for (const r of ge.objectKeys(e))
      e[r] && this.shape[r] && (n[r] = this.shape[r]);
    return new ke({
      ...this._def,
      shape: () => n
    });
  }
  omit(e) {
    const n = {};
    for (const r of ge.objectKeys(this.shape))
      e[r] || (n[r] = this.shape[r]);
    return new ke({
      ...this._def,
      shape: () => n
    });
  }
  /**
   * @deprecated
   */
  deepPartial() {
    return qn(this);
  }
  partial(e) {
    const n = {};
    for (const r of ge.objectKeys(this.shape)) {
      const a = this.shape[r];
      e && !e[r] ? n[r] = a : n[r] = a.optional();
    }
    return new ke({
      ...this._def,
      shape: () => n
    });
  }
  required(e) {
    const n = {};
    for (const r of ge.objectKeys(this.shape))
      if (e && !e[r])
        n[r] = this.shape[r];
      else {
        let o = this.shape[r];
        for (; o instanceof wt; )
          o = o._def.innerType;
        n[r] = o;
      }
    return new ke({
      ...this._def,
      shape: () => n
    });
  }
  keyof() {
    return j2(ge.objectKeys(this.shape));
  }
}
ke.create = (t, e) => new ke({
  shape: () => t,
  unknownKeys: "strip",
  catchall: jt.create(),
  typeName: oe.ZodObject,
  ...ue(e)
});
ke.strictCreate = (t, e) => new ke({
  shape: () => t,
  unknownKeys: "strict",
  catchall: jt.create(),
  typeName: oe.ZodObject,
  ...ue(e)
});
ke.lazycreate = (t, e) => new ke({
  shape: t,
  unknownKeys: "strip",
  catchall: jt.create(),
  typeName: oe.ZodObject,
  ...ue(e)
});
class Yr extends pe {
  _parse(e) {
    const { ctx: n } = this._processInputParams(e), r = this._def.options;
    function a(o) {
      for (const s of o)
        if (s.result.status === "valid")
          return s.result;
      for (const s of o)
        if (s.result.status === "dirty")
          return n.common.issues.push(...s.ctx.common.issues), s.result;
      const l = o.map((s) => new rt(s.ctx.common.issues));
      return U(n, {
        code: R.invalid_union,
        unionErrors: l
      }), ae;
    }
    if (n.common.async)
      return Promise.all(r.map(async (o) => {
        const l = {
          ...n,
          common: {
            ...n.common,
            issues: []
          },
          parent: null
        };
        return {
          result: await o._parseAsync({
            data: n.data,
            path: n.path,
            parent: l
          }),
          ctx: l
        };
      })).then(a);
    {
      let o;
      const l = [];
      for (const c of r) {
        const d = {
          ...n,
          common: {
            ...n.common,
            issues: []
          },
          parent: null
        }, u = c._parseSync({
          data: n.data,
          path: n.path,
          parent: d
        });
        if (u.status === "valid")
          return u;
        u.status === "dirty" && !o && (o = { result: u, ctx: d }), d.common.issues.length && l.push(d.common.issues);
      }
      if (o)
        return n.common.issues.push(...o.ctx.common.issues), o.result;
      const s = l.map((c) => new rt(c));
      return U(n, {
        code: R.invalid_union,
        unionErrors: s
      }), ae;
    }
  }
  get options() {
    return this._def.options;
  }
}
Yr.create = (t, e) => new Yr({
  options: t,
  typeName: oe.ZodUnion,
  ...ue(e)
});
const At = (t) => t instanceof Jr ? At(t.schema) : t instanceof ht ? At(t.innerType()) : t instanceof Qr ? [t.value] : t instanceof on ? t.options : t instanceof ea ? ge.objectValues(t.enum) : t instanceof ta ? At(t._def.innerType) : t instanceof Kr ? [void 0] : t instanceof qr ? [null] : t instanceof wt ? [void 0, ...At(t.unwrap())] : t instanceof ln ? [null, ...At(t.unwrap())] : t instanceof Ss || t instanceof ra ? At(t.unwrap()) : t instanceof na ? At(t._def.innerType) : [];
class Gi extends pe {
  _parse(e) {
    const { ctx: n } = this._processInputParams(e);
    if (n.parsedType !== q.object)
      return U(n, {
        code: R.invalid_type,
        expected: q.object,
        received: n.parsedType
      }), ae;
    const r = this.discriminator, a = n.data[r], o = this.optionsMap.get(a);
    return o ? n.common.async ? o._parseAsync({
      data: n.data,
      path: n.path,
      parent: n
    }) : o._parseSync({
      data: n.data,
      path: n.path,
      parent: n
    }) : (U(n, {
      code: R.invalid_union_discriminator,
      options: Array.from(this.optionsMap.keys()),
      path: [r]
    }), ae);
  }
  get discriminator() {
    return this._def.discriminator;
  }
  get options() {
    return this._def.options;
  }
  get optionsMap() {
    return this._def.optionsMap;
  }
  /**
   * The constructor of the discriminated union schema. Its behaviour is very similar to that of the normal z.union() constructor.
   * However, it only allows a union of objects, all of which need to share a discriminator property. This property must
   * have a different value for each object in the union.
   * @param discriminator the name of the discriminator property
   * @param types an array of object schemas
   * @param params
   */
  static create(e, n, r) {
    const a = /* @__PURE__ */ new Map();
    for (const o of n) {
      const l = At(o.shape[e]);
      if (!l.length)
        throw new Error(`A discriminator value for key \`${e}\` could not be extracted from all schema options`);
      for (const s of l) {
        if (a.has(s))
          throw new Error(`Discriminator property ${String(e)} has duplicate value ${String(s)}`);
        a.set(s, o);
      }
    }
    return new Gi({
      typeName: oe.ZodDiscriminatedUnion,
      discriminator: e,
      options: n,
      optionsMap: a,
      ...ue(r)
    });
  }
}
function Ml(t, e) {
  const n = zt(t), r = zt(e);
  if (t === e)
    return { valid: !0, data: t };
  if (n === q.object && r === q.object) {
    const a = ge.objectKeys(e), o = ge.objectKeys(t).filter((s) => a.indexOf(s) !== -1), l = { ...t, ...e };
    for (const s of o) {
      const c = Ml(t[s], e[s]);
      if (!c.valid)
        return { valid: !1 };
      l[s] = c.data;
    }
    return { valid: !0, data: l };
  } else if (n === q.array && r === q.array) {
    if (t.length !== e.length)
      return { valid: !1 };
    const a = [];
    for (let o = 0; o < t.length; o++) {
      const l = t[o], s = e[o], c = Ml(l, s);
      if (!c.valid)
        return { valid: !1 };
      a.push(c.data);
    }
    return { valid: !0, data: a };
  } else return n === q.date && r === q.date && +t == +e ? { valid: !0, data: t } : { valid: !1 };
}
class Zr extends pe {
  _parse(e) {
    const { status: n, ctx: r } = this._processInputParams(e), a = (o, l) => {
      if (xl(o) || xl(l))
        return ae;
      const s = Ml(o.value, l.value);
      return s.valid ? ((Cl(o) || Cl(l)) && n.dirty(), { status: n.value, value: s.data }) : (U(r, {
        code: R.invalid_intersection_types
      }), ae);
    };
    return r.common.async ? Promise.all([
      this._def.left._parseAsync({
        data: r.data,
        path: r.path,
        parent: r
      }),
      this._def.right._parseAsync({
        data: r.data,
        path: r.path,
        parent: r
      })
    ]).then(([o, l]) => a(o, l)) : a(this._def.left._parseSync({
      data: r.data,
      path: r.path,
      parent: r
    }), this._def.right._parseSync({
      data: r.data,
      path: r.path,
      parent: r
    }));
  }
}
Zr.create = (t, e, n) => new Zr({
  left: t,
  right: e,
  typeName: oe.ZodIntersection,
  ...ue(n)
});
class Mt extends pe {
  _parse(e) {
    const { status: n, ctx: r } = this._processInputParams(e);
    if (r.parsedType !== q.array)
      return U(r, {
        code: R.invalid_type,
        expected: q.array,
        received: r.parsedType
      }), ae;
    if (r.data.length < this._def.items.length)
      return U(r, {
        code: R.too_small,
        minimum: this._def.items.length,
        inclusive: !0,
        exact: !1,
        type: "array"
      }), ae;
    !this._def.rest && r.data.length > this._def.items.length && (U(r, {
      code: R.too_big,
      maximum: this._def.items.length,
      inclusive: !0,
      exact: !1,
      type: "array"
    }), n.dirty());
    const o = [...r.data].map((l, s) => {
      const c = this._def.items[s] || this._def.rest;
      return c ? c._parse(new Ct(r, l, r.path, s)) : null;
    }).filter((l) => !!l);
    return r.common.async ? Promise.all(o).then((l) => Ze.mergeArray(n, l)) : Ze.mergeArray(n, o);
  }
  get items() {
    return this._def.items;
  }
  rest(e) {
    return new Mt({
      ...this._def,
      rest: e
    });
  }
}
Mt.create = (t, e) => {
  if (!Array.isArray(t))
    throw new Error("You must pass an array of schemas to z.tuple([ ... ])");
  return new Mt({
    items: t,
    typeName: oe.ZodTuple,
    rest: null,
    ...ue(e)
  });
};
class Xr extends pe {
  get keySchema() {
    return this._def.keyType;
  }
  get valueSchema() {
    return this._def.valueType;
  }
  _parse(e) {
    const { status: n, ctx: r } = this._processInputParams(e);
    if (r.parsedType !== q.object)
      return U(r, {
        code: R.invalid_type,
        expected: q.object,
        received: r.parsedType
      }), ae;
    const a = [], o = this._def.keyType, l = this._def.valueType;
    for (const s in r.data)
      a.push({
        key: o._parse(new Ct(r, s, r.path, s)),
        value: l._parse(new Ct(r, r.data[s], r.path, s)),
        alwaysSet: s in r.data
      });
    return r.common.async ? Ze.mergeObjectAsync(n, a) : Ze.mergeObjectSync(n, a);
  }
  get element() {
    return this._def.valueType;
  }
  static create(e, n, r) {
    return n instanceof pe ? new Xr({
      keyType: e,
      valueType: n,
      typeName: oe.ZodRecord,
      ...ue(r)
    }) : new Xr({
      keyType: ut.create(),
      valueType: e,
      typeName: oe.ZodRecord,
      ...ue(n)
    });
  }
}
class gi extends pe {
  get keySchema() {
    return this._def.keyType;
  }
  get valueSchema() {
    return this._def.valueType;
  }
  _parse(e) {
    const { status: n, ctx: r } = this._processInputParams(e);
    if (r.parsedType !== q.map)
      return U(r, {
        code: R.invalid_type,
        expected: q.map,
        received: r.parsedType
      }), ae;
    const a = this._def.keyType, o = this._def.valueType, l = [...r.data.entries()].map(([s, c], d) => ({
      key: a._parse(new Ct(r, s, r.path, [d, "key"])),
      value: o._parse(new Ct(r, c, r.path, [d, "value"]))
    }));
    if (r.common.async) {
      const s = /* @__PURE__ */ new Map();
      return Promise.resolve().then(async () => {
        for (const c of l) {
          const d = await c.key, u = await c.value;
          if (d.status === "aborted" || u.status === "aborted")
            return ae;
          (d.status === "dirty" || u.status === "dirty") && n.dirty(), s.set(d.value, u.value);
        }
        return { status: n.value, value: s };
      });
    } else {
      const s = /* @__PURE__ */ new Map();
      for (const c of l) {
        const d = c.key, u = c.value;
        if (d.status === "aborted" || u.status === "aborted")
          return ae;
        (d.status === "dirty" || u.status === "dirty") && n.dirty(), s.set(d.value, u.value);
      }
      return { status: n.value, value: s };
    }
  }
}
gi.create = (t, e, n) => new gi({
  valueType: e,
  keyType: t,
  typeName: oe.ZodMap,
  ...ue(n)
});
class Pn extends pe {
  _parse(e) {
    const { status: n, ctx: r } = this._processInputParams(e);
    if (r.parsedType !== q.set)
      return U(r, {
        code: R.invalid_type,
        expected: q.set,
        received: r.parsedType
      }), ae;
    const a = this._def;
    a.minSize !== null && r.data.size < a.minSize.value && (U(r, {
      code: R.too_small,
      minimum: a.minSize.value,
      type: "set",
      inclusive: !0,
      exact: !1,
      message: a.minSize.message
    }), n.dirty()), a.maxSize !== null && r.data.size > a.maxSize.value && (U(r, {
      code: R.too_big,
      maximum: a.maxSize.value,
      type: "set",
      inclusive: !0,
      exact: !1,
      message: a.maxSize.message
    }), n.dirty());
    const o = this._def.valueType;
    function l(c) {
      const d = /* @__PURE__ */ new Set();
      for (const u of c) {
        if (u.status === "aborted")
          return ae;
        u.status === "dirty" && n.dirty(), d.add(u.value);
      }
      return { status: n.value, value: d };
    }
    const s = [...r.data.values()].map((c, d) => o._parse(new Ct(r, c, r.path, d)));
    return r.common.async ? Promise.all(s).then((c) => l(c)) : l(s);
  }
  min(e, n) {
    return new Pn({
      ...this._def,
      minSize: { value: e, message: J.toString(n) }
    });
  }
  max(e, n) {
    return new Pn({
      ...this._def,
      maxSize: { value: e, message: J.toString(n) }
    });
  }
  size(e, n) {
    return this.min(e, n).max(e, n);
  }
  nonempty(e) {
    return this.min(1, e);
  }
}
Pn.create = (t, e) => new Pn({
  valueType: t,
  minSize: null,
  maxSize: null,
  typeName: oe.ZodSet,
  ...ue(e)
});
class rr extends pe {
  constructor() {
    super(...arguments), this.validate = this.implement;
  }
  _parse(e) {
    const { ctx: n } = this._processInputParams(e);
    if (n.parsedType !== q.function)
      return U(n, {
        code: R.invalid_type,
        expected: q.function,
        received: n.parsedType
      }), ae;
    function r(s, c) {
      return mi({
        data: s,
        path: n.path,
        errorMaps: [n.common.contextualErrorMap, n.schemaErrorMap, pi(), cr].filter((d) => !!d),
        issueData: {
          code: R.invalid_arguments,
          argumentsError: c
        }
      });
    }
    function a(s, c) {
      return mi({
        data: s,
        path: n.path,
        errorMaps: [n.common.contextualErrorMap, n.schemaErrorMap, pi(), cr].filter((d) => !!d),
        issueData: {
          code: R.invalid_return_type,
          returnTypeError: c
        }
      });
    }
    const o = { errorMap: n.common.contextualErrorMap }, l = n.data;
    if (this._def.returns instanceof ur) {
      const s = this;
      return Je(async function(...c) {
        const d = new rt([]), u = await s._def.args.parseAsync(c, o).catch((g) => {
          throw d.addIssue(r(c, g)), d;
        }), f = await Reflect.apply(l, this, u);
        return await s._def.returns._def.type.parseAsync(f, o).catch((g) => {
          throw d.addIssue(a(f, g)), d;
        });
      });
    } else {
      const s = this;
      return Je(function(...c) {
        const d = s._def.args.safeParse(c, o);
        if (!d.success)
          throw new rt([r(c, d.error)]);
        const u = Reflect.apply(l, this, d.data), f = s._def.returns.safeParse(u, o);
        if (!f.success)
          throw new rt([a(u, f.error)]);
        return f.data;
      });
    }
  }
  parameters() {
    return this._def.args;
  }
  returnType() {
    return this._def.returns;
  }
  args(...e) {
    return new rr({
      ...this._def,
      args: Mt.create(e).rest(En.create())
    });
  }
  returns(e) {
    return new rr({
      ...this._def,
      returns: e
    });
  }
  implement(e) {
    return this.parse(e);
  }
  strictImplement(e) {
    return this.parse(e);
  }
  static create(e, n, r) {
    return new rr({
      args: e || Mt.create([]).rest(En.create()),
      returns: n || En.create(),
      typeName: oe.ZodFunction,
      ...ue(r)
    });
  }
}
class Jr extends pe {
  get schema() {
    return this._def.getter();
  }
  _parse(e) {
    const { ctx: n } = this._processInputParams(e);
    return this._def.getter()._parse({ data: n.data, path: n.path, parent: n });
  }
}
Jr.create = (t, e) => new Jr({
  getter: t,
  typeName: oe.ZodLazy,
  ...ue(e)
});
class Qr extends pe {
  _parse(e) {
    if (e.data !== this._def.value) {
      const n = this._getOrReturnCtx(e);
      return U(n, {
        received: n.data,
        code: R.invalid_literal,
        expected: this._def.value
      }), ae;
    }
    return { status: "valid", value: e.data };
  }
  get value() {
    return this._def.value;
  }
}
Qr.create = (t, e) => new Qr({
  value: t,
  typeName: oe.ZodLiteral,
  ...ue(e)
});
function j2(t, e) {
  return new on({
    values: t,
    typeName: oe.ZodEnum,
    ...ue(e)
  });
}
class on extends pe {
  _parse(e) {
    if (typeof e.data != "string") {
      const n = this._getOrReturnCtx(e), r = this._def.values;
      return U(n, {
        expected: ge.joinValues(r),
        received: n.parsedType,
        code: R.invalid_type
      }), ae;
    }
    if (this._cache || (this._cache = new Set(this._def.values)), !this._cache.has(e.data)) {
      const n = this._getOrReturnCtx(e), r = this._def.values;
      return U(n, {
        received: n.data,
        code: R.invalid_enum_value,
        options: r
      }), ae;
    }
    return Je(e.data);
  }
  get options() {
    return this._def.values;
  }
  get enum() {
    const e = {};
    for (const n of this._def.values)
      e[n] = n;
    return e;
  }
  get Values() {
    const e = {};
    for (const n of this._def.values)
      e[n] = n;
    return e;
  }
  get Enum() {
    const e = {};
    for (const n of this._def.values)
      e[n] = n;
    return e;
  }
  extract(e, n = this._def) {
    return on.create(e, {
      ...this._def,
      ...n
    });
  }
  exclude(e, n = this._def) {
    return on.create(this.options.filter((r) => !e.includes(r)), {
      ...this._def,
      ...n
    });
  }
}
on.create = j2;
class ea extends pe {
  _parse(e) {
    const n = ge.getValidEnumValues(this._def.values), r = this._getOrReturnCtx(e);
    if (r.parsedType !== q.string && r.parsedType !== q.number) {
      const a = ge.objectValues(n);
      return U(r, {
        expected: ge.joinValues(a),
        received: r.parsedType,
        code: R.invalid_type
      }), ae;
    }
    if (this._cache || (this._cache = new Set(ge.getValidEnumValues(this._def.values))), !this._cache.has(e.data)) {
      const a = ge.objectValues(n);
      return U(r, {
        received: r.data,
        code: R.invalid_enum_value,
        options: a
      }), ae;
    }
    return Je(e.data);
  }
  get enum() {
    return this._def.values;
  }
}
ea.create = (t, e) => new ea({
  values: t,
  typeName: oe.ZodNativeEnum,
  ...ue(e)
});
class ur extends pe {
  unwrap() {
    return this._def.type;
  }
  _parse(e) {
    const { ctx: n } = this._processInputParams(e);
    if (n.parsedType !== q.promise && n.common.async === !1)
      return U(n, {
        code: R.invalid_type,
        expected: q.promise,
        received: n.parsedType
      }), ae;
    const r = n.parsedType === q.promise ? n.data : Promise.resolve(n.data);
    return Je(r.then((a) => this._def.type.parseAsync(a, {
      path: n.path,
      errorMap: n.common.contextualErrorMap
    })));
  }
}
ur.create = (t, e) => new ur({
  type: t,
  typeName: oe.ZodPromise,
  ...ue(e)
});
class ht extends pe {
  innerType() {
    return this._def.schema;
  }
  sourceType() {
    return this._def.schema._def.typeName === oe.ZodEffects ? this._def.schema.sourceType() : this._def.schema;
  }
  _parse(e) {
    const { status: n, ctx: r } = this._processInputParams(e), a = this._def.effect || null, o = {
      addIssue: (l) => {
        U(r, l), l.fatal ? n.abort() : n.dirty();
      },
      get path() {
        return r.path;
      }
    };
    if (o.addIssue = o.addIssue.bind(o), a.type === "preprocess") {
      const l = a.transform(r.data, o);
      if (r.common.async)
        return Promise.resolve(l).then(async (s) => {
          if (n.value === "aborted")
            return ae;
          const c = await this._def.schema._parseAsync({
            data: s,
            path: r.path,
            parent: r
          });
          return c.status === "aborted" ? ae : c.status === "dirty" || n.value === "dirty" ? Yn(c.value) : c;
        });
      {
        if (n.value === "aborted")
          return ae;
        const s = this._def.schema._parseSync({
          data: l,
          path: r.path,
          parent: r
        });
        return s.status === "aborted" ? ae : s.status === "dirty" || n.value === "dirty" ? Yn(s.value) : s;
      }
    }
    if (a.type === "refinement") {
      const l = (s) => {
        const c = a.refinement(s, o);
        if (r.common.async)
          return Promise.resolve(c);
        if (c instanceof Promise)
          throw new Error("Async refinement encountered during synchronous parse operation. Use .parseAsync instead.");
        return s;
      };
      if (r.common.async === !1) {
        const s = this._def.schema._parseSync({
          data: r.data,
          path: r.path,
          parent: r
        });
        return s.status === "aborted" ? ae : (s.status === "dirty" && n.dirty(), l(s.value), { status: n.value, value: s.value });
      } else
        return this._def.schema._parseAsync({ data: r.data, path: r.path, parent: r }).then((s) => s.status === "aborted" ? ae : (s.status === "dirty" && n.dirty(), l(s.value).then(() => ({ status: n.value, value: s.value }))));
    }
    if (a.type === "transform")
      if (r.common.async === !1) {
        const l = this._def.schema._parseSync({
          data: r.data,
          path: r.path,
          parent: r
        });
        if (!Sn(l))
          return ae;
        const s = a.transform(l.value, o);
        if (s instanceof Promise)
          throw new Error("Asynchronous transform encountered during synchronous parse operation. Use .parseAsync instead.");
        return { status: n.value, value: s };
      } else
        return this._def.schema._parseAsync({ data: r.data, path: r.path, parent: r }).then((l) => Sn(l) ? Promise.resolve(a.transform(l.value, o)).then((s) => ({
          status: n.value,
          value: s
        })) : ae);
    ge.assertNever(a);
  }
}
ht.create = (t, e, n) => new ht({
  schema: t,
  typeName: oe.ZodEffects,
  effect: e,
  ...ue(n)
});
ht.createWithPreprocess = (t, e, n) => new ht({
  schema: e,
  effect: { type: "preprocess", transform: t },
  typeName: oe.ZodEffects,
  ...ue(n)
});
class wt extends pe {
  _parse(e) {
    return this._getType(e) === q.undefined ? Je(void 0) : this._def.innerType._parse(e);
  }
  unwrap() {
    return this._def.innerType;
  }
}
wt.create = (t, e) => new wt({
  innerType: t,
  typeName: oe.ZodOptional,
  ...ue(e)
});
class ln extends pe {
  _parse(e) {
    return this._getType(e) === q.null ? Je(null) : this._def.innerType._parse(e);
  }
  unwrap() {
    return this._def.innerType;
  }
}
ln.create = (t, e) => new ln({
  innerType: t,
  typeName: oe.ZodNullable,
  ...ue(e)
});
class ta extends pe {
  _parse(e) {
    const { ctx: n } = this._processInputParams(e);
    let r = n.data;
    return n.parsedType === q.undefined && (r = this._def.defaultValue()), this._def.innerType._parse({
      data: r,
      path: n.path,
      parent: n
    });
  }
  removeDefault() {
    return this._def.innerType;
  }
}
ta.create = (t, e) => new ta({
  innerType: t,
  typeName: oe.ZodDefault,
  defaultValue: typeof e.default == "function" ? e.default : () => e.default,
  ...ue(e)
});
class na extends pe {
  _parse(e) {
    const { ctx: n } = this._processInputParams(e), r = {
      ...n,
      common: {
        ...n.common,
        issues: []
      }
    }, a = this._def.innerType._parse({
      data: r.data,
      path: r.path,
      parent: {
        ...r
      }
    });
    return Wr(a) ? a.then((o) => ({
      status: "valid",
      value: o.status === "valid" ? o.value : this._def.catchValue({
        get error() {
          return new rt(r.common.issues);
        },
        input: r.data
      })
    })) : {
      status: "valid",
      value: a.status === "valid" ? a.value : this._def.catchValue({
        get error() {
          return new rt(r.common.issues);
        },
        input: r.data
      })
    };
  }
  removeCatch() {
    return this._def.innerType;
  }
}
na.create = (t, e) => new na({
  innerType: t,
  typeName: oe.ZodCatch,
  catchValue: typeof e.catch == "function" ? e.catch : () => e.catch,
  ...ue(e)
});
class yi extends pe {
  _parse(e) {
    if (this._getType(e) !== q.nan) {
      const r = this._getOrReturnCtx(e);
      return U(r, {
        code: R.invalid_type,
        expected: q.nan,
        received: r.parsedType
      }), ae;
    }
    return { status: "valid", value: e.data };
  }
}
yi.create = (t) => new yi({
  typeName: oe.ZodNaN,
  ...ue(t)
});
const U8 = Symbol("zod_brand");
class Ss extends pe {
  _parse(e) {
    const { ctx: n } = this._processInputParams(e), r = n.data;
    return this._def.type._parse({
      data: r,
      path: n.path,
      parent: n
    });
  }
  unwrap() {
    return this._def.type;
  }
}
class Fa extends pe {
  _parse(e) {
    const { status: n, ctx: r } = this._processInputParams(e);
    if (r.common.async)
      return (async () => {
        const o = await this._def.in._parseAsync({
          data: r.data,
          path: r.path,
          parent: r
        });
        return o.status === "aborted" ? ae : o.status === "dirty" ? (n.dirty(), Yn(o.value)) : this._def.out._parseAsync({
          data: o.value,
          path: r.path,
          parent: r
        });
      })();
    {
      const a = this._def.in._parseSync({
        data: r.data,
        path: r.path,
        parent: r
      });
      return a.status === "aborted" ? ae : a.status === "dirty" ? (n.dirty(), {
        status: "dirty",
        value: a.value
      }) : this._def.out._parseSync({
        data: a.value,
        path: r.path,
        parent: r
      });
    }
  }
  static create(e, n) {
    return new Fa({
      in: e,
      out: n,
      typeName: oe.ZodPipeline
    });
  }
}
class ra extends pe {
  _parse(e) {
    const n = this._def.innerType._parse(e), r = (a) => (Sn(a) && (a.value = Object.freeze(a.value)), a);
    return Wr(n) ? n.then((a) => r(a)) : r(n);
  }
  unwrap() {
    return this._def.innerType;
  }
}
ra.create = (t, e) => new ra({
  innerType: t,
  typeName: oe.ZodReadonly,
  ...ue(e)
});
function Vc(t, e) {
  const n = typeof t == "function" ? t(e) : typeof t == "string" ? { message: t } : t;
  return typeof n == "string" ? { message: n } : n;
}
function V2(t, e = {}, n) {
  return t ? dr.create().superRefine((r, a) => {
    const o = t(r);
    if (o instanceof Promise)
      return o.then((l) => {
        if (!l) {
          const s = Vc(e, r), c = s.fatal ?? n ?? !0;
          a.addIssue({ code: "custom", ...s, fatal: c });
        }
      });
    if (!o) {
      const l = Vc(e, r), s = l.fatal ?? n ?? !0;
      a.addIssue({ code: "custom", ...l, fatal: s });
    }
  }) : dr.create();
}
const W8 = {
  object: ke.lazycreate
};
var oe;
(function(t) {
  t.ZodString = "ZodString", t.ZodNumber = "ZodNumber", t.ZodNaN = "ZodNaN", t.ZodBigInt = "ZodBigInt", t.ZodBoolean = "ZodBoolean", t.ZodDate = "ZodDate", t.ZodSymbol = "ZodSymbol", t.ZodUndefined = "ZodUndefined", t.ZodNull = "ZodNull", t.ZodAny = "ZodAny", t.ZodUnknown = "ZodUnknown", t.ZodNever = "ZodNever", t.ZodVoid = "ZodVoid", t.ZodArray = "ZodArray", t.ZodObject = "ZodObject", t.ZodUnion = "ZodUnion", t.ZodDiscriminatedUnion = "ZodDiscriminatedUnion", t.ZodIntersection = "ZodIntersection", t.ZodTuple = "ZodTuple", t.ZodRecord = "ZodRecord", t.ZodMap = "ZodMap", t.ZodSet = "ZodSet", t.ZodFunction = "ZodFunction", t.ZodLazy = "ZodLazy", t.ZodLiteral = "ZodLiteral", t.ZodEnum = "ZodEnum", t.ZodEffects = "ZodEffects", t.ZodNativeEnum = "ZodNativeEnum", t.ZodOptional = "ZodOptional", t.ZodNullable = "ZodNullable", t.ZodDefault = "ZodDefault", t.ZodCatch = "ZodCatch", t.ZodPromise = "ZodPromise", t.ZodBranded = "ZodBranded", t.ZodPipeline = "ZodPipeline", t.ZodReadonly = "ZodReadonly";
})(oe || (oe = {}));
const U2 = (t, e = {
  message: `Input not instance of ${t.name}`
}) => V2((n) => n instanceof t, e), w = ut.create, we = rn.create, G8 = yi.create, K8 = an.create, at = Gr.create, q8 = Fn.create, Y8 = hi.create, Z8 = Kr.create, X8 = qr.create, J8 = dr.create, et = En.create, Q8 = jt.create, e9 = vi.create, De = ft.create, z = ke.create, t9 = ke.strictCreate, Ke = Yr.create, n9 = Gi.create, r9 = Zr.create, a9 = Mt.create, i9 = Xr.create, o9 = gi.create, l9 = Pn.create, s9 = rr.create, c9 = Jr.create, d9 = Qr.create, ye = on.create, u9 = ea.create, f9 = ur.create, Uc = ht.create, p9 = wt.create, m9 = ln.create, h9 = ht.createWithPreprocess, v9 = Fa.create, g9 = () => w().optional(), y9 = () => we().optional(), b9 = () => at().optional(), Pe = {
  string: ((t) => ut.create({ ...t, coerce: !0 })),
  number: ((t) => rn.create({ ...t, coerce: !0 })),
  boolean: ((t) => Gr.create({
    ...t,
    coerce: !0
  })),
  bigint: ((t) => an.create({ ...t, coerce: !0 })),
  date: ((t) => Fn.create({ ...t, coerce: !0 }))
}, E9 = ae, Re = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  BRAND: U8,
  DIRTY: Yn,
  EMPTY_PATH: $8,
  INVALID: ae,
  NEVER: E9,
  OK: Je,
  ParseStatus: Ze,
  Schema: pe,
  ZodAny: dr,
  ZodArray: ft,
  ZodBigInt: an,
  ZodBoolean: Gr,
  ZodBranded: Ss,
  ZodCatch: na,
  ZodDate: Fn,
  ZodDefault: ta,
  ZodDiscriminatedUnion: Gi,
  ZodEffects: ht,
  ZodEnum: on,
  ZodError: rt,
  get ZodFirstPartyTypeKind() {
    return oe;
  },
  ZodFunction: rr,
  ZodIntersection: Zr,
  ZodIssueCode: R,
  ZodLazy: Jr,
  ZodLiteral: Qr,
  ZodMap: gi,
  ZodNaN: yi,
  ZodNativeEnum: ea,
  ZodNever: jt,
  ZodNull: qr,
  ZodNullable: ln,
  ZodNumber: rn,
  ZodObject: ke,
  ZodOptional: wt,
  ZodParsedType: q,
  ZodPipeline: Fa,
  ZodPromise: ur,
  ZodReadonly: ra,
  ZodRecord: Xr,
  ZodSchema: pe,
  ZodSet: Pn,
  ZodString: ut,
  ZodSymbol: hi,
  ZodTransformer: ht,
  ZodTuple: Mt,
  ZodType: pe,
  ZodUndefined: Kr,
  ZodUnion: Yr,
  ZodUnknown: En,
  ZodVoid: vi,
  addIssueToContext: U,
  any: J8,
  array: De,
  bigint: K8,
  boolean: at,
  coerce: Pe,
  custom: V2,
  date: q8,
  datetimeRegex: B2,
  defaultErrorMap: cr,
  discriminatedUnion: n9,
  effect: Uc,
  enum: ye,
  function: s9,
  getErrorMap: pi,
  getParsedType: zt,
  instanceof: U2,
  intersection: r9,
  isAborted: xl,
  isAsync: Wr,
  isDirty: Cl,
  isValid: Sn,
  late: W8,
  lazy: c9,
  literal: d9,
  makeIssue: mi,
  map: o9,
  nan: G8,
  nativeEnum: u9,
  never: Q8,
  null: X8,
  nullable: m9,
  number: we,
  object: z,
  get objectUtil() {
    return $l;
  },
  oboolean: b9,
  onumber: y9,
  optional: p9,
  ostring: g9,
  pipeline: v9,
  preprocess: h9,
  promise: f9,
  quotelessJson: E8,
  record: i9,
  set: l9,
  setErrorMap: w8,
  strictObject: t9,
  string: w,
  symbol: Y8,
  transformer: Uc,
  tuple: a9,
  undefined: Z8,
  union: Ke,
  unknown: et,
  get util() {
    return ge;
  },
  void: e9
}, Symbol.toStringTag, { value: "Module" }));
function Fs(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
var Hn = {}, Wc;
function w9() {
  if (Wc) return Hn;
  Wc = 1;
  const t = function() {
  };
  t.prototype = /* @__PURE__ */ Object.create(null);
  const e = /; *([!#$%&'*+.^\w`|~-]+)=("(?:[\v\u0020\u0021\u0023-\u005b\u005d-\u007e\u0080-\u00ff]|\\[\v\u0020-\u00ff])*"|[!#$%&'*+.^\w`|~-]+) */gu, n = /\\([\v\u0020-\u00ff])/gu, r = /^[!#$%&'*+.^\w|~-]+\/[!#$%&'*+.^\w|~-]+$/u, a = { type: "", parameters: new t() };
  Object.freeze(a.parameters), Object.freeze(a);
  function o(s) {
    if (typeof s != "string")
      throw new TypeError("argument header is required and must be a string");
    let c = s.indexOf(";");
    const d = c !== -1 ? s.slice(0, c).trim() : s.trim();
    if (r.test(d) === !1)
      throw new TypeError("invalid media type");
    const u = {
      type: d.toLowerCase(),
      parameters: new t()
    };
    if (c === -1)
      return u;
    let f, m, g;
    for (e.lastIndex = c; m = e.exec(s); ) {
      if (m.index !== c)
        throw new TypeError("invalid parameter format");
      c += m[0].length, f = m[1].toLowerCase(), g = m[2], g[0] === '"' && (g = g.slice(1, g.length - 1), n.test(g) && (g = g.replace(n, "$1"))), u.parameters[f] = g;
    }
    if (c !== s.length)
      throw new TypeError("invalid parameter format");
    return u;
  }
  function l(s) {
    if (typeof s != "string")
      return a;
    let c = s.indexOf(";");
    const d = c !== -1 ? s.slice(0, c).trim() : s.trim();
    if (r.test(d) === !1)
      return a;
    const u = {
      type: d.toLowerCase(),
      parameters: new t()
    };
    if (c === -1)
      return u;
    let f, m, g;
    for (e.lastIndex = c; m = e.exec(s); ) {
      if (m.index !== c)
        return a;
      c += m[0].length, f = m[1].toLowerCase(), g = m[2], g[0] === '"' && (g = g.slice(1, g.length - 1), n.test(g) && (g = g.replace(n, "$1"))), u.parameters[f] = g;
    }
    return c !== s.length ? a : u;
  }
  return Hn.default = { parse: o, safeParse: l }, Hn.parse = o, Hn.safeParse = l, Hn.defaultContentType = a, Hn;
}
w9();
const W2 = { version: 4, country_calling_codes: { 1: ["US", "AG", "AI", "AS", "BB", "BM", "BS", "CA", "DM", "DO", "GD", "GU", "JM", "KN", "KY", "LC", "MP", "MS", "PR", "SX", "TC", "TT", "VC", "VG", "VI"], 7: ["RU", "KZ"], 20: ["EG"], 27: ["ZA"], 30: ["GR"], 31: ["NL"], 32: ["BE"], 33: ["FR"], 34: ["ES"], 36: ["HU"], 39: ["IT", "VA"], 40: ["RO"], 41: ["CH"], 43: ["AT"], 44: ["GB", "GG", "IM", "JE"], 45: ["DK"], 46: ["SE"], 47: ["NO", "SJ"], 48: ["PL"], 49: ["DE"], 51: ["PE"], 52: ["MX"], 53: ["CU"], 54: ["AR"], 55: ["BR"], 56: ["CL"], 57: ["CO"], 58: ["VE"], 60: ["MY"], 61: ["AU", "CC", "CX"], 62: ["ID"], 63: ["PH"], 64: ["NZ"], 65: ["SG"], 66: ["TH"], 81: ["JP"], 82: ["KR"], 84: ["VN"], 86: ["CN"], 90: ["TR"], 91: ["IN"], 92: ["PK"], 93: ["AF"], 94: ["LK"], 95: ["MM"], 98: ["IR"], 211: ["SS"], 212: ["MA", "EH"], 213: ["DZ"], 216: ["TN"], 218: ["LY"], 220: ["GM"], 221: ["SN"], 222: ["MR"], 223: ["ML"], 224: ["GN"], 225: ["CI"], 226: ["BF"], 227: ["NE"], 228: ["TG"], 229: ["BJ"], 230: ["MU"], 231: ["LR"], 232: ["SL"], 233: ["GH"], 234: ["NG"], 235: ["TD"], 236: ["CF"], 237: ["CM"], 238: ["CV"], 239: ["ST"], 240: ["GQ"], 241: ["GA"], 242: ["CG"], 243: ["CD"], 244: ["AO"], 245: ["GW"], 246: ["IO"], 247: ["AC"], 248: ["SC"], 249: ["SD"], 250: ["RW"], 251: ["ET"], 252: ["SO"], 253: ["DJ"], 254: ["KE"], 255: ["TZ"], 256: ["UG"], 257: ["BI"], 258: ["MZ"], 260: ["ZM"], 261: ["MG"], 262: ["RE", "YT"], 263: ["ZW"], 264: ["NA"], 265: ["MW"], 266: ["LS"], 267: ["BW"], 268: ["SZ"], 269: ["KM"], 290: ["SH", "TA"], 291: ["ER"], 297: ["AW"], 298: ["FO"], 299: ["GL"], 350: ["GI"], 351: ["PT"], 352: ["LU"], 353: ["IE"], 354: ["IS"], 355: ["AL"], 356: ["MT"], 357: ["CY"], 358: ["FI", "AX"], 359: ["BG"], 370: ["LT"], 371: ["LV"], 372: ["EE"], 373: ["MD"], 374: ["AM"], 375: ["BY"], 376: ["AD"], 377: ["MC"], 378: ["SM"], 380: ["UA"], 381: ["RS"], 382: ["ME"], 383: ["XK"], 385: ["HR"], 386: ["SI"], 387: ["BA"], 389: ["MK"], 420: ["CZ"], 421: ["SK"], 423: ["LI"], 500: ["FK"], 501: ["BZ"], 502: ["GT"], 503: ["SV"], 504: ["HN"], 505: ["NI"], 506: ["CR"], 507: ["PA"], 508: ["PM"], 509: ["HT"], 590: ["GP", "BL", "MF"], 591: ["BO"], 592: ["GY"], 593: ["EC"], 594: ["GF"], 595: ["PY"], 596: ["MQ"], 597: ["SR"], 598: ["UY"], 599: ["CW", "BQ"], 670: ["TL"], 672: ["NF"], 673: ["BN"], 674: ["NR"], 675: ["PG"], 676: ["TO"], 677: ["SB"], 678: ["VU"], 679: ["FJ"], 680: ["PW"], 681: ["WF"], 682: ["CK"], 683: ["NU"], 685: ["WS"], 686: ["KI"], 687: ["NC"], 688: ["TV"], 689: ["PF"], 690: ["TK"], 691: ["FM"], 692: ["MH"], 850: ["KP"], 852: ["HK"], 853: ["MO"], 855: ["KH"], 856: ["LA"], 880: ["BD"], 886: ["TW"], 960: ["MV"], 961: ["LB"], 962: ["JO"], 963: ["SY"], 964: ["IQ"], 965: ["KW"], 966: ["SA"], 967: ["YE"], 968: ["OM"], 970: ["PS"], 971: ["AE"], 972: ["IL"], 973: ["BH"], 974: ["QA"], 975: ["BT"], 976: ["MN"], 977: ["NP"], 992: ["TJ"], 993: ["TM"], 994: ["AZ"], 995: ["GE"], 996: ["KG"], 998: ["UZ"] }, countries: { AC: ["247", "00", "(?:[01589]\\d|[46])\\d{4}", [5, 6]], AD: ["376", "00", "(?:1|6\\d)\\d{7}|[135-9]\\d{5}", [6, 8, 9], [["(\\d{3})(\\d{3})", "$1 $2", ["[135-9]"]], ["(\\d{4})(\\d{4})", "$1 $2", ["1"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6"]]]], AE: ["971", "00", "(?:[4-7]\\d|9[0-689])\\d{7}|800\\d{2,9}|[2-4679]\\d{7}", [5, 6, 7, 8, 9, 10, 11, 12], [["(\\d{3})(\\d{2,9})", "$1 $2", ["60|8"]], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[236]|[479][2-8]"], "0$1"], ["(\\d{3})(\\d)(\\d{5})", "$1 $2 $3", ["[479]"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["5"], "0$1"]], "0"], AF: ["93", "00", "[2-7]\\d{8}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-7]"], "0$1"]], "0"], AG: ["1", "011", "(?:268|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([457]\\d{6})$|1", "268$1", 0, "268"], AI: ["1", "011", "(?:264|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2457]\\d{6})$|1", "264$1", 0, "264"], AL: ["355", "00", "(?:700\\d\\d|900)\\d{3}|8\\d{5,7}|(?:[2-5]|6\\d)\\d{7}", [6, 7, 8, 9], [["(\\d{3})(\\d{3,4})", "$1 $2", ["80|9"], "0$1"], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["4[2-6]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2358][2-5]|4"], "0$1"], ["(\\d{3})(\\d{5})", "$1 $2", ["[23578]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["6"], "0$1"]], "0"], AM: ["374", "00", "(?:[1-489]\\d|55|60|77)\\d{6}", [8], [["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[89]0"], "0 $1"], ["(\\d{3})(\\d{5})", "$1 $2", ["2|3[12]"], "(0$1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["1|47"], "(0$1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["[3-9]"], "0$1"]], "0"], AO: ["244", "00", "[29]\\d{8}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[29]"]]]], AR: ["54", "00", "(?:11|[89]\\d\\d)\\d{8}|[2368]\\d{9}", [10, 11], [["(\\d{4})(\\d{2})(\\d{4})", "$1 $2-$3", ["2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9])", "2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8]))|2(?:2[24-9]|3[1-59]|47)", "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5[56][46]|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]", "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|58|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|54(?:4|5[13-7]|6[89])|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:454|85[56])[46]|3(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"], "0$1", 1], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2-$3", ["1"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["[68]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2-$3", ["[23]"], "0$1", 1], ["(\\d)(\\d{4})(\\d{2})(\\d{4})", "$2 15-$3-$4", ["9(?:2[2-469]|3[3-578])", "9(?:2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9]))", "9(?:2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8])))|92(?:2[24-9]|3[1-59]|47)", "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5(?:[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]", "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|5(?:4(?:4|5[13-7]|6[89])|[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"], "0$1", 0, "$1 $2 $3-$4"], ["(\\d)(\\d{2})(\\d{4})(\\d{4})", "$2 15-$3-$4", ["91"], "0$1", 0, "$1 $2 $3-$4"], ["(\\d{3})(\\d{3})(\\d{5})", "$1-$2-$3", ["8"], "0$1"], ["(\\d)(\\d{3})(\\d{3})(\\d{4})", "$2 15-$3-$4", ["9"], "0$1", 0, "$1 $2 $3-$4"]], "0", 0, "0?(?:(11|2(?:2(?:02?|[13]|2[13-79]|4[1-6]|5[2457]|6[124-8]|7[1-4]|8[13-6]|9[1267])|3(?:02?|1[467]|2[03-6]|3[13-8]|[49][2-6]|5[2-8]|[67])|4(?:7[3-578]|9)|6(?:[0136]|2[24-6]|4[6-8]?|5[15-8])|80|9(?:0[1-3]|[19]|2\\d|3[1-6]|4[02568]?|5[2-4]|6[2-46]|72?|8[23]?))|3(?:3(?:2[79]|6|8[2578])|4(?:0[0-24-9]|[12]|3[5-8]?|4[24-7]|5[4-68]?|6[02-9]|7[126]|8[2379]?|9[1-36-8])|5(?:1|2[1245]|3[237]?|4[1-46-9]|6[2-4]|7[1-6]|8[2-5]?)|6[24]|7(?:[069]|1[1568]|2[15]|3[145]|4[13]|5[14-8]|7[2-57]|8[126])|8(?:[01]|2[15-7]|3[2578]?|4[13-6]|5[4-8]?|6[1-357-9]|7[36-8]?|8[5-8]?|9[124])))15)?", "9$1"], AS: ["1", "011", "(?:[58]\\d\\d|684|900)\\d{7}", [10], 0, "1", 0, "([267]\\d{6})$|1", "684$1", 0, "684"], AT: ["43", "00", "1\\d{3,12}|2\\d{6,12}|43(?:(?:0\\d|5[02-9])\\d{3,9}|2\\d{4,5}|[3467]\\d{4}|8\\d{4,6}|9\\d{4,7})|5\\d{4,12}|8\\d{7,12}|9\\d{8,12}|(?:[367]\\d|4[0-24-9])\\d{4,11}", [4, 5, 6, 7, 8, 9, 10, 11, 12, 13], [["(\\d)(\\d{3,12})", "$1 $2", ["1(?:11|[2-9])"], "0$1"], ["(\\d{3})(\\d{2})", "$1 $2", ["517"], "0$1"], ["(\\d{2})(\\d{3,5})", "$1 $2", ["5[079]"], "0$1"], ["(\\d{3})(\\d{3,10})", "$1 $2", ["(?:31|4)6|51|6(?:48|5[0-3579]|[6-9])|7(?:20|32|8)|[89]", "(?:31|4)6|51|6(?:485|5[0-3579]|[6-9])|7(?:20|32|8)|[89]"], "0$1"], ["(\\d{4})(\\d{3,9})", "$1 $2", ["[2-467]|5[2-6]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["5"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4,7})", "$1 $2 $3", ["5"], "0$1"]], "0"], AU: ["61", "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011", "1(?:[0-79]\\d{7}(?:\\d(?:\\d{2})?)?|8[0-24-9]\\d{7})|[2-478]\\d{8}|1\\d{4,7}", [5, 6, 7, 8, 9, 10, 12], [["(\\d{2})(\\d{3,4})", "$1 $2", ["16"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2,4})", "$1 $2 $3", ["16"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["14|4"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["[2378]"], "(0$1)"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1(?:30|[89])"]]], "0", 0, "(183[12])|0", 0, 0, 0, [["(?:(?:241|349)0\\d\\d|8(?:51(?:0(?:0[03-9]|[12479]\\d|3[2-9]|5[0-8]|6[1-9]|8[0-7])|1(?:[0235689]\\d|1[0-69]|4[0-589]|7[0-47-9])|2(?:0[0-79]|[18][13579]|2[14-9]|3[0-46-9]|[4-6]\\d|7[89]|9[0-4])|[34]\\d\\d)|91(?:(?:[0-58]\\d|6[0135-9])\\d|7(?:0[0-24-9]|[1-9]\\d)|9(?:[0-46-9]\\d|5[0-79]))))\\d{3}|(?:2(?:[0-26-9]\\d|3[0-8]|4[02-9]|5[0135-9])|3(?:[0-3589]\\d|4[0-578]|6[1-9]|7[0-35-9])|7(?:[013-57-9]\\d|2[0-8])|8(?:55|6[0-8]|[78]\\d|9[02-9]))\\d{6}", [9]], ["4(?:79[01]|83[0-36-9]|95[0-3])\\d{5}|4(?:[0-36]\\d|4[047-9]|[58][0-24-9]|7[02-8]|9[0-47-9])\\d{6}", [9]], ["180(?:0\\d{3}|2)\\d{3}", [7, 10]], ["190[0-26]\\d{6}", [10]], 0, 0, 0, ["163\\d{2,6}", [5, 6, 7, 8, 9]], ["14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}", [9]], ["13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}", [6, 8, 10, 12]]], "0011"], AW: ["297", "00", "(?:[25-79]\\d\\d|800)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[25-9]"]]]], AX: ["358", "00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))", "2\\d{4,9}|35\\d{4,5}|(?:60\\d\\d|800)\\d{4,6}|7\\d{5,11}|(?:[14]\\d|3[0-46-9]|50)\\d{4,8}", [5, 6, 7, 8, 9, 10, 11, 12], 0, "0", 0, 0, 0, 0, "18", 0, "00"], AZ: ["994", "00", "365\\d{6}|(?:[124579]\\d|60|88)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["90"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[28]|2|365|46", "1[28]|2|365[45]|46", "1[28]|2|365(?:4|5[02])|46"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[13-9]"], "0$1"]], "0"], BA: ["387", "00", "6\\d{8}|(?:[35689]\\d|49|70)\\d{6}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["6[1-3]|[7-9]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2-$3", ["[3-5]|6[56]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["6"], "0$1"]], "0"], BB: ["1", "011", "(?:246|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "246$1", 0, "246"], BD: ["880", "00", "[1-469]\\d{9}|8[0-79]\\d{7,8}|[2-79]\\d{8}|[2-9]\\d{7}|[3-9]\\d{6}|[57-9]\\d{5}", [6, 7, 8, 9, 10], [["(\\d{2})(\\d{4,6})", "$1-$2", ["31[5-8]|[459]1"], "0$1"], ["(\\d{3})(\\d{3,7})", "$1-$2", ["3(?:[67]|8[013-9])|4(?:6[168]|7|[89][18])|5(?:6[128]|9)|6(?:[15]|28|4[14])|7[2-589]|8(?:0[014-9]|[12])|9[358]|(?:3[2-5]|4[235]|5[2-578]|6[0389]|76|8[3-7]|9[24])1|(?:44|66)[01346-9]"], "0$1"], ["(\\d{4})(\\d{3,6})", "$1-$2", ["[13-9]|2[23]"], "0$1"], ["(\\d)(\\d{7,8})", "$1-$2", ["2"], "0$1"]], "0"], BE: ["32", "00", "4\\d{8}|[1-9]\\d{7}", [8, 9], [["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["(?:80|9)0"], "0$1"], ["(\\d)(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[239]|4[23]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[15-8]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["4"], "0$1"]], "0"], BF: ["226", "00", "(?:[025-7]\\d|44)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[024-7]"]]]], BG: ["359", "00", "00800\\d{7}|[2-7]\\d{6,7}|[89]\\d{6,8}|2\\d{5}", [6, 7, 8, 9, 12], [["(\\d)(\\d)(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["2"], "0$1"], ["(\\d{3})(\\d{4})", "$1 $2", ["43[1-6]|70[1-9]"], "0$1"], ["(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2,3})", "$1 $2 $3", ["[356]|4[124-7]|7[1-9]|8[1-6]|9[1-7]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["(?:70|8)0"], "0$1"], ["(\\d{3})(\\d{3})(\\d{2})", "$1 $2 $3", ["43[1-7]|7"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[48]|9[08]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"], "0$1"]], "0"], BH: ["973", "00", "[136-9]\\d{7}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[13679]|8[02-4679]"]]]], BI: ["257", "00", "(?:[267]\\d|31)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2367]"]]]], BJ: ["229", "00", "(?:01\\d|8)\\d{7}", [8, 10], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["0"]]]], BL: ["590", "00", "(?:590\\d|7090)\\d{5}|(?:69|80|9\\d)\\d{7}", [9], 0, "0", 0, 0, 0, 0, 0, [["590(?:2[7-9]|3[3-7]|5[12]|87)\\d{4}"], ["(?:69(?:0\\d\\d|1(?:2[2-9]|3[0-5])|4(?:0[89]|1[2-6]|9\\d)|6(?:1[016-9]|5[0-4]|[67]\\d))|7090[0-4])\\d{4}"], ["80[0-5]\\d{6}"], 0, 0, 0, 0, 0, ["9(?:(?:39[5-7]|76[018])\\d|475[0-6])\\d{4}"]]], BM: ["1", "011", "(?:441|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "441$1", 0, "441"], BN: ["673", "00", "[2-578]\\d{6}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-578]"]]]], BO: ["591", "00(?:1\\d)?", "8001\\d{5}|(?:[2-467]\\d|50)\\d{6}", [8, 9], [["(\\d)(\\d{7})", "$1 $2", ["[235]|4[46]"]], ["(\\d{8})", "$1", ["[67]"]], ["(\\d{3})(\\d{2})(\\d{4})", "$1 $2 $3", ["8"]]], "0", 0, "0(1\\d)?"], BQ: ["599", "00", "(?:[34]1|7\\d)\\d{5}", [7], 0, 0, 0, 0, 0, 0, "[347]"], BR: ["55", "00(?:1[245]|2[1-35]|31|4[13]|[56]5|99)", "[1-467]\\d{9,10}|55[0-46-9]\\d{8}|[34]\\d{7}|55\\d{7,8}|(?:5[0-46-9]|[89]\\d)\\d{7,9}", [8, 9, 10, 11], [["(\\d{4})(\\d{4})", "$1-$2", ["300|4(?:0[02]|37|86)", "300|4(?:0(?:0|20)|370|864)"]], ["(\\d{3})(\\d{2,3})(\\d{4})", "$1 $2 $3", ["(?:[358]|90)0"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2-$3", ["(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])[2-57]"], "($1)"], ["(\\d{2})(\\d{5})(\\d{4})", "$1 $2-$3", ["[16][1-9]|[2-57-9]"], "($1)"]], "0", 0, "(?:0|90)(?:(1[245]|2[1-35]|31|4[13]|[56]5|99)(\\d{10,11}))?", "$2"], BS: ["1", "011", "(?:242|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([3-8]\\d{6})$|1", "242$1", 0, "242"], BT: ["975", "00", "[178]\\d{7}|[2-8]\\d{6}", [7, 8], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-6]|7[246]|8[2-4]"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[67]|[78]"]]]], BW: ["267", "00", "(?:0800|(?:[37]|800)\\d)\\d{6}|(?:[2-6]\\d|90)\\d{5}", [7, 8, 10], [["(\\d{2})(\\d{5})", "$1 $2", ["90"]], ["(\\d{3})(\\d{4})", "$1 $2", ["[24-6]|3[15-9]"]], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[37]"]], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["0"]], ["(\\d{3})(\\d{4})(\\d{3})", "$1 $2 $3", ["8"]]]], BY: ["375", "810", "(?:[12]\\d|33|44|902)\\d{7}|8(?:0[0-79]\\d{5,7}|[1-7]\\d{9})|8(?:1[0-489]|[5-79]\\d)\\d{7}|8[1-79]\\d{6,7}|8[0-79]\\d{5}|8\\d{5}", [6, 7, 8, 9, 10, 11], [["(\\d{3})(\\d{3})", "$1 $2", ["800"], "8 $1"], ["(\\d{3})(\\d{2})(\\d{2,4})", "$1 $2 $3", ["800"], "8 $1"], ["(\\d{4})(\\d{2})(\\d{3})", "$1 $2-$3", ["1(?:5[169]|6[3-5]|7[179])|2(?:1[35]|2[34]|3[3-5])", "1(?:5[169]|6(?:3[1-3]|4|5[125])|7(?:1[3-9]|7[0-24-6]|9[2-7]))|2(?:1[35]|2[34]|3[3-5])"], "8 0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["1(?:[56]|7[467])|2[1-3]"], "8 0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["[1-4]"], "8 0$1"], ["(\\d{3})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["[89]"], "8 $1"]], "8", 0, "0|80?", 0, 0, 0, 0, "8~10"], BZ: ["501", "00", "(?:0800\\d|[2-8])\\d{6}", [7, 11], [["(\\d{3})(\\d{4})", "$1-$2", ["[2-8]"]], ["(\\d)(\\d{3})(\\d{4})(\\d{3})", "$1-$2-$3-$4", ["0"]]]], CA: ["1", "011", "[2-9]\\d{9}|3\\d{6}", [7, 10], 0, "1", 0, 0, 0, 0, 0, [["(?:2(?:04|[23]6|[48]9|5[07]|63)|3(?:06|43|54|6[578]|82)|4(?:03|1[68]|[26]8|3[178]|50|74)|5(?:06|1[49]|48|79|8[147])|6(?:04|[18]3|39|47|72)|7(?:0[59]|42|53|78|8[02])|8(?:[06]7|19|25|7[39])|9(?:0[25]|42))[2-9]\\d{6}", [10]], ["", [10]], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", [10]], ["900[2-9]\\d{6}", [10]], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|(?:5(?:2[125-9]|33|44|66|77|88)|6(?:22|33))[2-9]\\d{6}", [10]], 0, ["310\\d{4}", [7]], 0, ["600[2-9]\\d{6}", [10]]]], CC: ["61", "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011", "1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}", [6, 7, 8, 9, 10, 12], 0, "0", 0, "([59]\\d{7})$|0", "8$1", 0, 0, [["8(?:51(?:0(?:02|31|60|89)|1(?:18|76)|223)|91(?:0(?:1[0-2]|29)|1(?:[28]2|50|79)|2(?:10|64)|3(?:[06]8|22)|4[29]8|62\\d|70[23]|959))\\d{3}", [9]], ["4(?:79[01]|83[0-36-9]|95[0-3])\\d{5}|4(?:[0-36]\\d|4[047-9]|[58][0-24-9]|7[02-8]|9[0-47-9])\\d{6}", [9]], ["180(?:0\\d{3}|2)\\d{3}", [7, 10]], ["190[0-26]\\d{6}", [10]], 0, 0, 0, 0, ["14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}", [9]], ["13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}", [6, 8, 10, 12]]], "0011"], CD: ["243", "00", "(?:(?:[189]|5\\d)\\d|2)\\d{7}|[1-68]\\d{6}", [7, 8, 9, 10], [["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["88"], "0$1"], ["(\\d{2})(\\d{5})", "$1 $2", ["[1-6]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[89]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["5"], "0$1"]], "0"], CF: ["236", "00", "(?:[27]\\d{3}|8776)\\d{4}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[278]"]]]], CG: ["242", "00", "222\\d{6}|(?:0\\d|80)\\d{7}", [9], [["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["8"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[02]"]]]], CH: ["41", "00", "8\\d{11}|[2-9]\\d{8}", [9, 12], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8[047]|90"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-79]|81"], "0$1"], ["(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["8"], "0$1"]], "0"], CI: ["225", "00", "[02]\\d{9}", [10], [["(\\d{2})(\\d{2})(\\d)(\\d{5})", "$1 $2 $3 $4", ["2"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3 $4", ["0"]]]], CK: ["682", "00", "[2-578]\\d{4}", [5], [["(\\d{2})(\\d{3})", "$1 $2", ["[2-578]"]]]], CL: ["56", "(?:0|1(?:1[0-69]|2[02-5]|5[13-58]|69|7[0167]|8[018]))0", "12300\\d{6}|6\\d{9,10}|[2-9]\\d{8}", [9, 10, 11], [["(\\d{5})(\\d{4})", "$1 $2", ["219", "2196"], "($1)"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["60|809"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["44"]], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["2[1-36]"], "($1)"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["9(?:10|[2-9])"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["3[2-5]|[47]|5[1-3578]|6[13-57]|8(?:0[1-8]|[1-9])"], "($1)"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["60|8"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]], ["(\\d{3})(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["60"]]]], CM: ["237", "00", "[26]\\d{8}|88\\d{6,7}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["88"]], ["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["[26]|88"]]]], CN: ["86", "00|1(?:[12]\\d|79)\\d\\d00", "(?:(?:1[03-689]|2\\d)\\d\\d|6)\\d{8}|1\\d{10}|[126]\\d{6}(?:\\d(?:\\d{2})?)?|86\\d{5,6}|(?:[3-579]\\d|8[0-57-9])\\d{5,9}", [7, 8, 9, 10, 11, 12], [["(\\d{2})(\\d{5,6})", "$1 $2", ["(?:10|2[0-57-9])[19]|3(?:[157]|35|49|9[1-68])|4(?:1[124-9]|2[179]|6[47-9]|7|8[23])|5(?:[1357]|2[37]|4[36]|6[1-46]|80)|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:07|1[236-8]|2[5-7]|[37]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3|4[13]|5[1-5]|7[0-79]|9[0-35-9])|(?:4[35]|59|85)[1-9]", "(?:10|2[0-57-9])(?:1[02]|9[56])|8078|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))1", "10(?:1(?:0|23)|9[56])|2[0-57-9](?:1(?:00|23)|9[56])|80781|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))12", "10(?:1(?:0|23)|9[56])|2[0-57-9](?:1(?:00|23)|9[56])|807812|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))123", "10(?:1(?:0|23)|9[56])|2[0-57-9](?:1(?:00|23)|9[56])|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:078|1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))123"], "0$1"], ["(\\d{3})(\\d{5,6})", "$1 $2", ["3(?:[157]|35|49|9[1-68])|4(?:[17]|2[179]|6[47-9]|8[23])|5(?:[1357]|2[37]|4[36]|6[1-46]|80)|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]|4[13]|5[1-5])|(?:4[35]|59|85)[1-9]", "(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))[19]", "85[23](?:10|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:10|9[56])", "85[23](?:100|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:100|9[56])"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["(?:4|80)0"]], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["10|2(?:[02-57-9]|1[1-9])", "10|2(?:[02-57-9]|1[1-9])", "10[0-79]|2(?:[02-57-9]|1[1-79])|(?:10|21)8(?:0[1-9]|[1-9])"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["3(?:[3-59]|7[02-68])|4(?:[26-8]|3[3-9]|5[2-9])|5(?:3[03-9]|[468]|7[028]|9[2-46-9])|6|7(?:[0-247]|3[04-9]|5[0-4689]|6[2368])|8(?:[1-358]|9[1-7])|9(?:[013479]|5[1-5])|(?:[34]1|55|79|87)[02-9]"], "0$1", 1], ["(\\d{3})(\\d{7,8})", "$1 $2", ["9"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["80"], "0$1", 1], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["[3-578]"], "0$1", 1], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["1[3-9]"]], ["(\\d{2})(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["[12]"], "0$1", 1]], "0", 0, "(1(?:[12]\\d|79)\\d\\d)|0", 0, 0, 0, 0, "00"], CO: ["57", "00(?:4(?:[14]4|56)|[579])", "(?:46|60\\d\\d)\\d{6}|(?:1\\d|[39])\\d{9}", [8, 10, 11], [["(\\d{4})(\\d{4})", "$1 $2", ["46"]], ["(\\d{3})(\\d{7})", "$1 $2", ["6|90"], "($1)"], ["(\\d{3})(\\d{7})", "$1 $2", ["3[0-357]|9[14]"]], ["(\\d)(\\d{3})(\\d{7})", "$1-$2-$3", ["1"], "0$1", 0, "$1 $2 $3"]], "0", 0, "0([3579]|4(?:[14]4|56))?"], CR: ["506", "00", "(?:8\\d|90)\\d{8}|(?:[24-8]\\d{3}|3005)\\d{4}", [8, 10], [["(\\d{4})(\\d{4})", "$1 $2", ["[2-7]|8[3-9]"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["[89]"]]], 0, 0, "(19(?:0[0-2468]|1[09]|20|66|77|99))"], CU: ["53", "119", "(?:[2-7]|8\\d\\d)\\d{7}|[2-47]\\d{6}|[34]\\d{5}", [6, 7, 8, 10], [["(\\d{2})(\\d{4,6})", "$1 $2", ["2[1-4]|[34]"], "(0$1)"], ["(\\d)(\\d{6,7})", "$1 $2", ["7"], "(0$1)"], ["(\\d)(\\d{7})", "$1 $2", ["[56]"], "0$1"], ["(\\d{3})(\\d{7})", "$1 $2", ["8"], "0$1"]], "0"], CV: ["238", "0", "(?:[2-59]\\d\\d|800)\\d{4}", [7], [["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["[2-589]"]]]], CW: ["599", "00", "(?:[34]1|60|(?:7|9\\d)\\d)\\d{5}", [7, 8], [["(\\d{3})(\\d{4})", "$1 $2", ["[3467]"]], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["9[4-8]"]]], 0, 0, 0, 0, 0, "[69]"], CX: ["61", "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011", "1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}", [6, 7, 8, 9, 10, 12], 0, "0", 0, "([59]\\d{7})$|0", "8$1", 0, 0, [["8(?:51(?:0(?:01|30|59|88)|1(?:17|46|75)|2(?:22|35))|91(?:00[6-9]|1(?:[28]1|49|78)|2(?:09|63)|3(?:12|26|75)|4(?:56|97)|64\\d|7(?:0[01]|1[0-2])|958))\\d{3}", [9]], ["4(?:79[01]|83[0-36-9]|95[0-3])\\d{5}|4(?:[0-36]\\d|4[047-9]|[58][0-24-9]|7[02-8]|9[0-47-9])\\d{6}", [9]], ["180(?:0\\d{3}|2)\\d{3}", [7, 10]], ["190[0-26]\\d{6}", [10]], 0, 0, 0, 0, ["14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}", [9]], ["13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}", [6, 8, 10, 12]]], "0011"], CY: ["357", "00", "(?:[279]\\d|[58]0)\\d{6}", [8], [["(\\d{2})(\\d{6})", "$1 $2", ["[257-9]"]]]], CZ: ["420", "00", "(?:[2-578]\\d|60)\\d{7}|9\\d{8,11}", [9, 10, 11, 12], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-8]|9[015-7]"]], ["(\\d{2})(\\d{3})(\\d{3})(\\d{2})", "$1 $2 $3 $4", ["96"]], ["(\\d{2})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["9"]], ["(\\d{3})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["9"]]]], DE: ["49", "00", "[2579]\\d{5,14}|49(?:[34]0|69|8\\d)\\d\\d?|49(?:37|49|60|7[089]|9\\d)\\d{1,3}|49(?:2[024-9]|3[2-689]|7[1-7])\\d{1,8}|(?:1|[368]\\d|4[0-8])\\d{3,13}|49(?:[015]\\d|2[13]|31|[46][1-8])\\d{1,9}", [4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15], [["(\\d{2})(\\d{3,13})", "$1 $2", ["3[02]|40|[68]9"], "0$1"], ["(\\d{3})(\\d{3,12})", "$1 $2", ["2(?:0[1-389]|1[124]|2[18]|3[14])|3(?:[35-9][15]|4[015])|906|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1", "2(?:0[1-389]|12[0-8])|3(?:[35-9][15]|4[015])|906|2(?:[13][14]|2[18])|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1"], "0$1"], ["(\\d{4})(\\d{2,11})", "$1 $2", ["[24-6]|3(?:[3569][02-46-9]|4[2-4679]|7[2-467]|8[2-46-8])|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]", "[24-6]|3(?:3(?:0[1-467]|2[127-9]|3[124578]|7[1257-9]|8[1256]|9[145])|4(?:2[135]|4[13578]|9[1346])|5(?:0[14]|2[1-3589]|6[1-4]|7[13468]|8[13568])|6(?:2[1-489]|3[124-6]|6[13]|7[12579]|8[1-356]|9[135])|7(?:2[1-7]|4[145]|6[1-5]|7[1-4])|8(?:21|3[1468]|6|7[1467]|8[136])|9(?:0[12479]|2[1358]|4[134679]|6[1-9]|7[136]|8[147]|9[1468]))|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]|3[68]4[1347]|3(?:47|60)[1356]|3(?:3[46]|46|5[49])[1246]|3[4579]3[1357]"], "0$1"], ["(\\d{3})(\\d{4})", "$1 $2", ["138"], "0$1"], ["(\\d{5})(\\d{2,10})", "$1 $2", ["3"], "0$1"], ["(\\d{3})(\\d{5,11})", "$1 $2", ["181"], "0$1"], ["(\\d{3})(\\d)(\\d{4,10})", "$1 $2 $3", ["1(?:3|80)|9"], "0$1"], ["(\\d{3})(\\d{7,8})", "$1 $2", ["1[67]"], "0$1"], ["(\\d{3})(\\d{7,12})", "$1 $2", ["8"], "0$1"], ["(\\d{5})(\\d{6})", "$1 $2", ["185", "1850", "18500"], "0$1"], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["7"], "0$1"], ["(\\d{4})(\\d{7})", "$1 $2", ["18[68]"], "0$1"], ["(\\d{4})(\\d{7})", "$1 $2", ["15[1279]"], "0$1"], ["(\\d{5})(\\d{6})", "$1 $2", ["15[03568]", "15(?:[0568]|3[13])"], "0$1"], ["(\\d{3})(\\d{8})", "$1 $2", ["18"], "0$1"], ["(\\d{3})(\\d{2})(\\d{7,8})", "$1 $2 $3", ["1(?:6[023]|7)"], "0$1"], ["(\\d{4})(\\d{2})(\\d{7})", "$1 $2 $3", ["15[279]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{8})", "$1 $2 $3", ["15"], "0$1"]], "0"], DJ: ["253", "00", "(?:2\\d|77)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[27]"]]]], DK: ["45", "00", "[2-9]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-9]"]]]], DM: ["1", "011", "(?:[58]\\d\\d|767|900)\\d{7}", [10], 0, "1", 0, "([2-7]\\d{6})$|1", "767$1", 0, "767"], DO: ["1", "011", "(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, 0, 0, 0, "8001|8[024]9"], DZ: ["213", "00", "(?:[1-4]|[5-79]\\d|80)\\d{7}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[1-4]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["9"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-8]"], "0$1"]], "0"], EC: ["593", "00", "1\\d{9,10}|(?:[2-7]|9\\d)\\d{7}", [8, 9, 10, 11], [["(\\d)(\\d{3})(\\d{4})", "$1 $2-$3", ["[2-7]"], "(0$1)", 0, "$1-$2-$3"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["1"]]], "0"], EE: ["372", "00", "8\\d{9}|[4578]\\d{7}|(?:[3-8]\\d|90)\\d{5}", [7, 8, 10], [["(\\d{3})(\\d{4})", "$1 $2", ["[369]|4[3-8]|5(?:[0-2]|5[0-478]|6[45])|7[1-9]|88", "[369]|4[3-8]|5(?:[02]|1(?:[0-8]|95)|5[0-478]|6(?:4[0-4]|5[1-589]))|7[1-9]|88"]], ["(\\d{4})(\\d{3,4})", "$1 $2", ["[45]|8(?:00|[1-49])", "[45]|8(?:00[1-9]|[1-49])"]], ["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["7"]], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]]]], EG: ["20", "00", "[189]\\d{8,9}|[24-6]\\d{8}|[135]\\d{7}", [8, 9, 10], [["(\\d)(\\d{7,8})", "$1 $2", ["[23]"], "0$1"], ["(\\d{2})(\\d{6,7})", "$1 $2", ["1[35]|[4-6]|8[2468]|9[235-7]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[89]"], "0$1"], ["(\\d{2})(\\d{8})", "$1 $2", ["1"], "0$1"]], "0"], EH: ["212", "00", "[5-8]\\d{8}", [9], 0, "0", 0, 0, 0, 0, "528[89]"], ER: ["291", "00", "[178]\\d{6}", [7], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[178]"], "0$1"]], "0"], ES: ["34", "00", "[5-9]\\d{8}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[89]00"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-9]"]]]], ET: ["251", "00", "(?:11|[2-579]\\d)\\d{7}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1-579]"], "0$1"]], "0"], FI: ["358", "00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))", "[1-35689]\\d{4}|7\\d{10,11}|(?:[124-7]\\d|3[0-46-9])\\d{8}|[1-9]\\d{5,8}", [5, 6, 7, 8, 9, 10, 11, 12], [["(\\d{5})", "$1", ["20[2-59]"], "0$1"], ["(\\d{3})(\\d{3,7})", "$1 $2", ["(?:[1-3]0|[68])0|70[07-9]"], "0$1"], ["(\\d{2})(\\d{4,8})", "$1 $2", ["[14]|2[09]|50|7[135]"], "0$1"], ["(\\d{2})(\\d{6,10})", "$1 $2", ["7"], "0$1"], ["(\\d)(\\d{4,9})", "$1 $2", ["(?:19|[2568])[1-8]|3(?:0[1-9]|[1-9])|9"], "0$1"]], "0", 0, 0, 0, 0, "1[03-79]|[2-9]", 0, "00"], FJ: ["679", "0(?:0|52)", "45\\d{5}|(?:0800\\d|[235-9])\\d{6}", [7, 11], [["(\\d{3})(\\d{4})", "$1 $2", ["[235-9]|45"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["0"]]], 0, 0, 0, 0, 0, 0, 0, "00"], FK: ["500", "00", "[2-7]\\d{4}", [5]], FM: ["691", "00", "(?:[39]\\d\\d|820)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[389]"]]]], FO: ["298", "00", "[2-9]\\d{5}", [6], [["(\\d{6})", "$1", ["[2-9]"]]], 0, 0, "(10(?:01|[12]0|88))"], FR: ["33", "00", "[1-9]\\d{8}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0 $1"], ["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["[1-79]"], "0$1"]], "0"], GA: ["241", "00", "(?:[067]\\d|11)\\d{6}|[2-7]\\d{6}", [7, 8], [["(\\d)(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-7]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["0"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["11|[67]"], "0$1"]], 0, 0, "0(11\\d{6}|60\\d{6}|61\\d{6}|6[256]\\d{6}|7[467]\\d{6})", "$1"], GB: ["44", "00", "[1-357-9]\\d{9}|[18]\\d{8}|8\\d{6}", [7, 9, 10], [["(\\d{3})(\\d{4})", "$1 $2", ["800", "8001", "80011", "800111", "8001111"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["845", "8454", "84546", "845464"], "0$1"], ["(\\d{3})(\\d{6})", "$1 $2", ["800"], "0$1"], ["(\\d{5})(\\d{4,5})", "$1 $2", ["1(?:38|5[23]|69|76|94)", "1(?:(?:38|69)7|5(?:24|39)|768|946)", "1(?:3873|5(?:242|39[4-6])|(?:697|768)[347]|9467)"], "0$1"], ["(\\d{4})(\\d{5,6})", "$1 $2", ["1(?:[2-69][02-9]|[78])"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["[25]|7(?:0|6[02-9])", "[25]|7(?:0|6(?:[03-9]|2[356]))"], "0$1"], ["(\\d{4})(\\d{6})", "$1 $2", ["7"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1389]"], "0$1"]], "0", 0, "0|180020", 0, 0, 0, [["(?:1(?:1(?:3(?:[0-58]\\d\\d|73[0-5])|4(?:(?:[0-5]\\d|70)\\d|69[7-9])|(?:(?:5[0-26-9]|[78][0-49])\\d|6(?:[0-4]\\d|5[01]))\\d)|(?:2(?:(?:0[024-9]|2[3-9]|3[3-79]|4[1-689]|[58][02-9]|6[0-47-9]|7[013-9]|9\\d)\\d|1(?:[0-7]\\d|8[0-3]))|(?:3(?:0\\d|1[0-8]|[25][02-9]|3[02-579]|[468][0-46-9]|7[1-35-79]|9[2-578])|4(?:0[03-9]|[137]\\d|[28][02-57-9]|4[02-69]|5[0-8]|[69][0-79])|5(?:0[1-35-9]|[16]\\d|2[024-9]|3[015689]|4[02-9]|5[03-9]|7[0-35-9]|8[0-468]|9[0-57-9])|6(?:0[034689]|1\\d|2[0-35689]|[38][013-9]|4[1-467]|5[0-69]|6[13-9]|7[0-8]|9[0-24578])|7(?:0[0246-9]|2\\d|3[0236-8]|4[03-9]|5[0-46-9]|6[013-9]|7[0-35-9]|8[024-9]|9[02-9])|8(?:0[35-9]|2[1-57-9]|3[02-578]|4[0-578]|5[124-9]|6[2-69]|7\\d|8[02-9]|9[02569])|9(?:0[02-589]|[18]\\d|2[02-689]|3[1-57-9]|4[2-9]|5[0-579]|6[2-47-9]|7[0-24578]|9[2-57]))\\d)\\d)|2(?:0[013478]|3[0189]|4[017]|8[0-46-9]|9[0-2])\\d{3})\\d{4}|1(?:2(?:0(?:46[1-4]|87[2-9])|545[1-79]|76(?:2\\d|3[1-8]|6[1-6])|9(?:7(?:2[0-4]|3[2-5])|8(?:2[2-8]|7[0-47-9]|8[3-5])))|3(?:6(?:38[2-5]|47[23])|8(?:47[04-9]|64[0157-9]))|4(?:044[1-7]|20(?:2[23]|8\\d)|6(?:0(?:30|5[2-57]|6[1-8]|7[2-8])|140)|8(?:052|87[1-3]))|5(?:2(?:4(?:3[2-79]|6\\d)|76\\d)|6(?:26[06-9]|686))|6(?:06(?:4\\d|7[4-79])|295[5-7]|35[34]\\d|47(?:24|61)|59(?:5[08]|6[67]|74)|9(?:55[0-4]|77[23]))|7(?:26(?:6[13-9]|7[0-7])|(?:442|688)\\d|50(?:2[0-3]|[3-68]2|76))|8(?:27[56]\\d|37(?:5[2-5]|8[239])|843[2-58])|9(?:0(?:0(?:6[1-8]|85)|52\\d)|3583|4(?:66[1-8]|9(?:2[01]|81))|63(?:23|3[1-4])|9561))\\d{3}", [9, 10]], ["7(?:457[0-57-9]|700[01]|911[028])\\d{5}|7(?:[1-3]\\d\\d|4(?:[0-46-9]\\d|5[0-689])|5(?:0[0-8]|[13-9]\\d|2[0-35-9])|7(?:0[1-9]|[1-7]\\d|8[02-9]|9[0-689])|8(?:[014-9]\\d|[23][0-8])|9(?:[024-9]\\d|1[02-9]|3[0-689]))\\d{6}", [10]], ["80[08]\\d{7}|800\\d{6}|8001111"], ["(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[2-49]))\\d{7}|845464\\d", [7, 10]], ["70\\d{8}", [10]], 0, ["(?:3[0347]|55)\\d{8}", [10]], ["76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}", [10]], ["56\\d{8}", [10]]], 0, " x"], GD: ["1", "011", "(?:473|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "473$1", 0, "473"], GE: ["995", "00", "(?:[3-57]\\d\\d|800)\\d{6}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["70"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["32"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[57]"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[348]"], "0$1"]], "0"], GF: ["594", "00", "(?:[56]94\\d|7093)\\d{5}|(?:80|9\\d)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-7]|9[47]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[89]"], "0$1"]], "0"], GG: ["44", "00", "(?:1481|[357-9]\\d{3})\\d{6}|8\\d{6}(?:\\d{2})?", [7, 9, 10], 0, "0", 0, "([25-9]\\d{5})$|0|180020", "1481$1", 0, 0, [["1481[25-9]\\d{5}", [10]], ["7(?:(?:781|839)\\d|911[17])\\d{5}", [10]], ["80[08]\\d{7}|800\\d{6}|8001111"], ["(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[0-3]))\\d{7}|845464\\d", [7, 10]], ["70\\d{8}", [10]], 0, ["(?:3[0347]|55)\\d{8}", [10]], ["76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}", [10]], ["56\\d{8}", [10]]]], GH: ["233", "00", "(?:[235]\\d{3}|800)\\d{5}", [8, 9], [["(\\d{3})(\\d{5})", "$1 $2", ["8"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[235]"], "0$1"]], "0"], GI: ["350", "00", "(?:[25]\\d|60)\\d{6}", [8], [["(\\d{3})(\\d{5})", "$1 $2", ["2"]]]], GL: ["299", "00", "(?:19|[2-689]\\d|70)\\d{4}", [6], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["19|[2-9]"]]]], GM: ["220", "00", "[2-9]\\d{6}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-9]"]]]], GN: ["224", "00", "722\\d{6}|(?:3|6\\d)\\d{7}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["3"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[67]"]]]], GP: ["590", "00", "(?:590\\d|7090)\\d{5}|(?:69|80|9\\d)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-79]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0$1"]], "0", 0, 0, 0, 0, 0, [["590(?:0[1-68]|[14][0-24-9]|2[0-68]|3[1-9]|5[3-579]|[68][0-689]|7[08]|9\\d)\\d{4}"], ["(?:69(?:0\\d\\d|1(?:2[2-9]|3[0-5])|4(?:0[89]|1[2-6]|9\\d)|6(?:1[016-9]|5[0-4]|[67]\\d))|7090[0-4])\\d{4}"], ["80[0-5]\\d{6}"], 0, 0, 0, 0, 0, ["9(?:(?:39[5-7]|76[018])\\d|475[0-6])\\d{4}"]]], GQ: ["240", "00", "222\\d{6}|(?:3\\d|55|[89]0)\\d{7}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[235]"]], ["(\\d{3})(\\d{6})", "$1 $2", ["[89]"]]]], GR: ["30", "00", "5005000\\d{3}|8\\d{9,11}|(?:[269]\\d|70)\\d{8}", [10, 11, 12], [["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["21|7"]], ["(\\d{4})(\\d{6})", "$1 $2", ["2(?:2|3[2-57-9]|4[2-469]|5[2-59]|6[2-9]|7[2-69]|8[2-49])|5"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2689]"]], ["(\\d{3})(\\d{3,4})(\\d{5})", "$1 $2 $3", ["8"]]]], GT: ["502", "00", "80\\d{6}|(?:1\\d{3}|[2-7])\\d{7}", [8, 11], [["(\\d{4})(\\d{4})", "$1 $2", ["[2-8]"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]]]], GU: ["1", "011", "(?:[58]\\d\\d|671|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "671$1", 0, "671"], GW: ["245", "00", "[49]\\d{8}|4\\d{6}", [7, 9], [["(\\d{3})(\\d{4})", "$1 $2", ["40"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[49]"]]]], GY: ["592", "001", "(?:[2-8]\\d{3}|9008)\\d{3}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-9]"]]]], HK: ["852", "00(?:30|5[09]|[126-9]?)", "8[0-46-9]\\d{6,7}|9\\d{4,7}|(?:[2-7]|9\\d{3})\\d{7}", [5, 6, 7, 8, 9, 11], [["(\\d{3})(\\d{2,5})", "$1 $2", ["900", "9003"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[2-7]|8[1-4]|9(?:0[1-9]|[1-8])"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]], ["(\\d{3})(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["9"]]], 0, 0, 0, 0, 0, 0, 0, "00"], HN: ["504", "00", "8\\d{10}|[237-9]\\d{7}", [8, 11], [["(\\d{4})(\\d{4})", "$1-$2", ["[237-9]"]]]], HR: ["385", "00", "[2-69]\\d{8}|80\\d{5,7}|[1-79]\\d{7}|6\\d{6}", [7, 8, 9], [["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["6[01]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["8"], "0$1"], ["(\\d)(\\d{4})(\\d{3})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["6|7[245]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-57]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"], "0$1"]], "0"], HT: ["509", "00", "[2-589]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["[2-589]"]]]], HU: ["36", "00", "[235-7]\\d{8}|[1-9]\\d{7}", [8, 9], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "(06 $1)"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[27][2-9]|3[2-7]|4[24-9]|5[2-79]|6|8[2-57-9]|9[2-69]"], "(06 $1)"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-9]"], "06 $1"]], "06"], ID: ["62", "00[89]", "00[1-9]\\d{9,14}|(?:[1-36]|8\\d{5})\\d{6}|00\\d{9}|[1-9]\\d{8,10}|[2-9]\\d{7}", [7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["15"]], ["(\\d{2})(\\d{5,9})", "$1 $2", ["2[124]|[36]1"], "(0$1)"], ["(\\d{3})(\\d{5,7})", "$1 $2", ["800"], "0$1"], ["(\\d{3})(\\d{5,8})", "$1 $2", ["[2-79]"], "(0$1)"], ["(\\d{3})(\\d{3,4})(\\d{3})", "$1-$2-$3", ["8[1-35-9]"], "0$1"], ["(\\d{3})(\\d{6,8})", "$1 $2", ["1"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["804"], "0$1"], ["(\\d{3})(\\d)(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["80"], "0$1"], ["(\\d{3})(\\d{4})(\\d{4,5})", "$1-$2-$3", ["8"], "0$1"]], "0"], IE: ["353", "00", "(?:1\\d|[2569])\\d{6,8}|4\\d{6,9}|7\\d{8}|8\\d{8,9}", [7, 8, 9, 10], [["(\\d{2})(\\d{5})", "$1 $2", ["2[24-9]|47|58|6[237-9]|9[35-9]"], "(0$1)"], ["(\\d{3})(\\d{5})", "$1 $2", ["[45]0"], "(0$1)"], ["(\\d)(\\d{3,4})(\\d{4})", "$1 $2 $3", ["1"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2569]|4[1-69]|7[14]"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["70"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["81"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[78]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["4"], "(0$1)"], ["(\\d{2})(\\d)(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["8"], "0$1"]], "0"], IL: ["972", "0(?:0|1[2-9])", "1\\d{6}(?:\\d{3,5})?|[57]\\d{8}|[1-489]\\d{7}", [7, 8, 9, 10, 11, 12], [["(\\d{4})(\\d{3})", "$1-$2", ["125"]], ["(\\d{4})(\\d{2})(\\d{2})", "$1-$2-$3", ["121"]], ["(\\d)(\\d{3})(\\d{4})", "$1-$2-$3", ["[2-489]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["[57]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1-$2-$3", ["12"]], ["(\\d{4})(\\d{6})", "$1-$2", ["159"]], ["(\\d)(\\d{3})(\\d{3})(\\d{3})", "$1-$2-$3-$4", ["1[7-9]"]], ["(\\d{3})(\\d{1,2})(\\d{3})(\\d{4})", "$1-$2 $3-$4", ["15"]]], "0"], IM: ["44", "00", "1624\\d{6}|(?:[3578]\\d|90)\\d{8}", [10], 0, "0", 0, "([25-8]\\d{5})$|0|180020", "1624$1", 0, "74576|(?:16|7[56])24"], IN: ["91", "00", "(?:000800|[2-9]\\d\\d)\\d{7}|1\\d{7,12}", [8, 9, 10, 11, 12, 13], [["(\\d{8})", "$1", ["5(?:0|2[23]|3[03]|[67]1|88)", "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|888)", "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|8888)"], 0, 1], ["(\\d{4})(\\d{4,5})", "$1 $2", ["180", "1800"], 0, 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["140"], 0, 1], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["11|2[02]|33|4[04]|79[1-7]|80[2-46]", "11|2[02]|33|4[04]|79(?:[1-6]|7[19])|80(?:[2-4]|6[0-589])", "11|2[02]|33|4[04]|79(?:[124-6]|3(?:[02-9]|1[0-24-9])|7(?:1|9[1-6]))|80(?:[2-4]|6[0-589])"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["1(?:2[0-249]|3[0-25]|4[145]|[68]|7[1257])|2(?:1[257]|3[013]|4[01]|5[0137]|6[0158]|78|8[1568])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|5[12]|[78]1)|6(?:12|[2-4]1|5[17]|6[13]|80)|7(?:12|3[134]|4[47]|61|88)|8(?:16|2[014]|3[126]|6[136]|7[078]|8[34]|91)|(?:43|59|75)[15]|(?:1[59]|29|67|72)[14]", "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|674|7(?:(?:2[14]|3[34]|5[15])[2-6]|61[346]|88[0-8])|8(?:70[2-6]|84[235-7]|91[3-7])|(?:1(?:29|60|8[06])|261|552|6(?:12|[2-47]1|5[17]|6[13]|80)|7(?:12|31|4[47])|8(?:16|2[014]|3[126]|6[136]|7[78]|83))[2-7]", "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|6(?:12(?:[2-6]|7[0-8])|74[2-7])|7(?:(?:2[14]|5[15])[2-6]|3171|61[346]|88(?:[2-7]|82))|8(?:70[2-6]|84(?:[2356]|7[19])|91(?:[3-6]|7[19]))|73[134][2-6]|(?:74[47]|8(?:16|2[014]|3[126]|6[136]|7[78]|83))(?:[2-6]|7[19])|(?:1(?:29|60|8[06])|261|552|6(?:[2-4]1|5[17]|6[13]|7(?:1|4[0189])|80)|7(?:12|88[01]))[2-7]"], "0$1", 1], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2[2457-9]|3[2-5]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1[013-9]|28|3[129]|4[1-35689]|5[29]|6[02-5]|70)|807", "1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2(?:[2457]|84|95)|3(?:[2-4]|55)|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1(?:[013-8]|9[6-9])|28[6-8]|3(?:17|2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4|5[0-367])|70[13-7])|807[19]", "1(?:[2-479]|5(?:[0236-9]|5[013-9]))|[2-5]|6(?:2(?:84|95)|355|83)|73179|807(?:1|9[1-3])|(?:1552|6(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[124-6])\\d|7(?:1(?:[013-8]\\d|9[6-9])|28[6-8]|3(?:2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]\\d|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4\\d|5[0-367])|70[13-7]))[2-7]"], "0$1", 1], ["(\\d{5})(\\d{5})", "$1 $2", ["[6-9]"], "0$1", 1], ["(\\d{4})(\\d{2,4})(\\d{4})", "$1 $2 $3", ["1(?:6|8[06])", "1(?:6|8[06]0)"], 0, 1], ["(\\d{4})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["18"], 0, 1]], "0"], IO: ["246", "00", "3\\d{6}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["3"]]]], IQ: ["964", "00", "(?:1|7\\d\\d)\\d{7}|[2-6]\\d{7,8}", [8, 9, 10], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-6]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "0$1"]], "0"], IR: ["98", "00", "[1-9]\\d{9}|(?:[1-8]\\d\\d|9)\\d{3,4}", [4, 5, 6, 7, 10], [["(\\d{4,5})", "$1", ["96"], "0$1"], ["(\\d{2})(\\d{4,5})", "$1 $2", ["(?:1[137]|2[13-68]|3[1458]|4[145]|5[1468]|6[16]|7[1467]|8[13467])[12689]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["[1-8]"], "0$1"]], "0"], IS: ["354", "00|1(?:0(?:01|[12]0)|100)", "(?:38\\d|[4-9])\\d{6}", [7, 9], [["(\\d{3})(\\d{4})", "$1 $2", ["[4-9]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["3"]]], 0, 0, 0, 0, 0, 0, 0, "00"], IT: ["39", "00", "0\\d{5,11}|1\\d{8,10}|3(?:[0-8]\\d{7,10}|9\\d{7,8})|(?:43|55|70)\\d{8}|8\\d{5}(?:\\d{2,4})?", [6, 7, 8, 9, 10, 11, 12], [["(\\d{2})(\\d{4,6})", "$1 $2", ["0[26]"]], ["(\\d{3})(\\d{3,6})", "$1 $2", ["0[13-57-9][0159]|8(?:03|4[17]|9[2-5])", "0[13-57-9][0159]|8(?:03|4[17]|9(?:2|3[04]|[45][0-4]))"]], ["(\\d{4})(\\d{2,6})", "$1 $2", ["0(?:[13-579][2-46-8]|8[236-8])"]], ["(\\d{4})(\\d{4})", "$1 $2", ["894"]], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["0[26]|5"]], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["1(?:44|[679])|[378]|43"]], ["(\\d{3})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["0[13-57-9][0159]|14"]], ["(\\d{2})(\\d{4})(\\d{5})", "$1 $2 $3", ["0[26]"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["0"]], ["(\\d{3})(\\d{4})(\\d{4,5})", "$1 $2 $3", ["[03]"]]], 0, 0, 0, 0, 0, 0, [["0(?:669[0-79]\\d{1,6}|831\\d{2,8})|0(?:1(?:[0159]\\d|[27][1-5]|31|4[1-4]|6[1356]|8[2-57])|2\\d\\d|3(?:[0159]\\d|2[1-4]|3[12]|[48][1-6]|6[2-59]|7[1-7])|4(?:[0159]\\d|[23][1-9]|4[245]|6[1-5]|7[1-4]|81)|5(?:[0159]\\d|2[1-5]|3[2-6]|4[1-79]|6[4-6]|7[1-578]|8[3-8])|6(?:[0-57-9]\\d|6[0-8])|7(?:[0159]\\d|2[12]|3[1-7]|4[2-46]|6[13569]|7[13-6]|8[1-59])|8(?:[0159]\\d|2[3-578]|3[2356]|[6-8][1-5])|9(?:[0159]\\d|[238][1-5]|4[12]|6[1-8]|7[1-6]))\\d{2,7}"], ["3[2-9]\\d{7,8}|(?:31|43)\\d{8}", [9, 10]], ["80(?:0\\d{3}|3)\\d{3}", [6, 9]], ["(?:0878\\d{3}|89(?:2\\d|3[04]|4(?:[0-4]|[5-9]\\d\\d)|5[0-4]))\\d\\d|(?:1(?:44|6[346])|89(?:38|5[5-9]|9))\\d{6}", [6, 8, 9, 10]], ["1(?:78\\d|99)\\d{6}", [9, 10]], ["3[2-8]\\d{9,10}", [11, 12]], 0, 0, ["55\\d{8}", [10]], ["84(?:[08]\\d{3}|[17])\\d{3}", [6, 9]]]], JE: ["44", "00", "1534\\d{6}|(?:[3578]\\d|90)\\d{8}", [10], 0, "0", 0, "([0-24-8]\\d{5})$|0|180020", "1534$1", 0, 0, [["1534[0-24-8]\\d{5}"], ["7(?:(?:(?:50|82)9|937)\\d|7(?:00[378]|97\\d))\\d{5}"], ["80(?:07(?:35|81)|8901)\\d{4}"], ["(?:8(?:4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|90(?:066[59]|1810|71(?:07|55)))\\d{4}"], ["701511\\d{4}"], 0, ["(?:3(?:0(?:07(?:35|81)|8901)|3\\d{4}|4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|55\\d{4})\\d{4}"], ["76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}"], ["56\\d{8}"]]], JM: ["1", "011", "(?:[58]\\d\\d|658|900)\\d{7}", [10], 0, "1", 0, 0, 0, 0, "658|876"], JO: ["962", "00", "(?:(?:[2689]|7\\d)\\d|32|427|53)\\d{6}", [8, 9], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[2356]|87"], "(0$1)"], ["(\\d{3})(\\d{5,6})", "$1 $2", ["[89]"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["70"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["[47]"], "0$1"]], "0"], JP: ["81", "010", "00[1-9]\\d{6,14}|[25-9]\\d{9}|(?:00|[1-9]\\d\\d)\\d{6}", [8, 9, 10, 11, 12, 13, 14, 15, 16, 17], [["(\\d{3})(\\d{3})(\\d{3})", "$1-$2-$3", ["(?:12|57|99)0"], "0$1"], ["(\\d{4})(\\d)(\\d{4})", "$1-$2-$3", ["1(?:26|3[79]|4[56]|5[4-68]|6[3-5])|499|5(?:76|97)|746|8(?:3[89]|47|51)|9(?:80|9[16])", "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:76|97)9|7468|8(?:3(?:8[7-9]|96)|477|51[2-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]", "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:769|979[2-69])|7468|8(?:3(?:8[7-9]|96[2457-9])|477|51[2-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["60"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1-$2-$3", ["3|4(?:2[09]|7[01])|6[1-9]", "3|4(?:2(?:0|9[02-69])|7(?:0[019]|1))|6[1-9]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["1(?:1|5[45]|77|88|9[69])|2(?:2[1-37]|3[0-269]|4[59]|5|6[24]|7[1-358]|8[1369]|9[0-38])|4(?:[28][1-9]|3[0-57]|[45]|6[248]|7[2-579]|9[29])|5(?:2|3[0459]|4[0-369]|5[29]|8[02389]|9[0-389])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9[2-6])|8(?:2[124589]|3[26-9]|49|51|6|7[0-468]|8[68]|9[019])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9[1-489])", "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2(?:[127]|3[014-9])|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9[19])|62|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|8[1-9]|9[29])|5(?:2|3(?:[045]|9[0-8])|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0-2469])|3(?:[29]|60)|49|51|6(?:[0-24]|36|5[0-3589]|7[23]|9[01459])|7[0-468]|8[68])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9(?:[1289]|3[34]|4[0178]))|(?:264|837)[016-9]|2(?:57|93)[015-9]|(?:25[0468]|422|838)[01]|(?:47[59]|59[89]|8(?:6[68]|9))[019]", "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2[127]|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9(?:17|99))|6(?:2|4[016-9])|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|9[29])|5(?:2|3(?:[045]|9(?:[0-58]|6[4-9]|7[0-35689]))|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0169])|3(?:[29]|60|7(?:[017-9]|6[6-8]))|49|51|6(?:[0-24]|36[2-57-9]|5(?:[0-389]|5[23])|6(?:[01]|9[178])|7(?:2[2-468]|3[78])|9[0145])|7[0-468]|8[68])|9(?:4[15]|5[138]|7[156]|8[189]|9(?:[1289]|3(?:31|4[357])|4[0178]))|(?:8294|96)[1-3]|2(?:57|93)[015-9]|(?:223|8699)[014-9]|(?:25[0468]|422|838)[01]|(?:48|8292|9[23])[1-9]|(?:47[59]|59[89]|8(?:68|9))[019]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{4})", "$1-$2-$3", ["[14]|[289][2-9]|5[3-9]|7[2-4679]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["800"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1-$2-$3", ["[25-9]"], "0$1"]], "0", 0, "(000[2569]\\d{4,6})$|(?:(?:003768)0?)|0", "$1"], KE: ["254", "000", "(?:[17]\\d\\d|900)\\d{6}|(?:2|80)0\\d{6,7}|[4-6]\\d{6,8}", [7, 8, 9, 10], [["(\\d{2})(\\d{5,7})", "$1 $2", ["[24-6]"], "0$1"], ["(\\d{3})(\\d{6})", "$1 $2", ["[17]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[89]"], "0$1"]], "0"], KG: ["996", "00", "8\\d{9}|[235-9]\\d{8}", [9, 10], [["(\\d{4})(\\d{5})", "$1 $2", ["3(?:1[346]|[24-79])"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[235-79]|88"], "0$1"], ["(\\d{3})(\\d{3})(\\d)(\\d{2,3})", "$1 $2 $3 $4", ["8"], "0$1"]], "0"], KH: ["855", "00[14-9]", "1\\d{9}|[1-9]\\d{7,8}", [8, 9, 10], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[1-9]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]]], "0"], KI: ["686", "00", "(?:[37]\\d|6[0-79])\\d{6}|(?:[2-48]\\d|50)\\d{3}", [5, 8], 0, "0"], KM: ["269", "00", "[3478]\\d{6}", [7], [["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["[3478]"]]]], KN: ["1", "011", "(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-7]\\d{6})$|1", "869$1", 0, "869"], KP: ["850", "00|99", "85\\d{6}|(?:19\\d|[2-7])\\d{7}", [8, 10], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"], "0$1"], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-7]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"]], "0"], KR: ["82", "00(?:[125689]|3(?:[46]5|91)|7(?:00|27|3|55|6[126]))", "00[1-9]\\d{8,11}|(?:[12]|5\\d{3})\\d{7}|[13-6]\\d{9}|(?:[1-6]\\d|80)\\d{7}|[3-6]\\d{4,5}|(?:00|7)0\\d{8}", [5, 6, 8, 9, 10, 11, 12, 13, 14], [["(\\d{2})(\\d{3,4})", "$1-$2", ["(?:3[1-3]|[46][1-4]|5[1-5])1"], "0$1"], ["(\\d{4})(\\d{4})", "$1-$2", ["1"]], ["(\\d)(\\d{3,4})(\\d{4})", "$1-$2-$3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["[36]0|8"], "0$1"], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1-$2-$3", ["[1346]|5[1-5]"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1-$2-$3", ["[57]"], "0$1"], ["(\\d{2})(\\d{5})(\\d{4})", "$1-$2-$3", ["5"], "0$1"]], "0", 0, "0(8(?:[1-46-8]|5\\d\\d))?"], KW: ["965", "00", "18\\d{5}|(?:[2569]\\d|41)\\d{6}", [7, 8], [["(\\d{4})(\\d{3,4})", "$1 $2", ["[169]|2(?:[235]|4[1-35-9])|52"]], ["(\\d{3})(\\d{5})", "$1 $2", ["[245]"]]]], KY: ["1", "011", "(?:345|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "345$1", 0, "345"], KZ: ["7", "810", "(?:33622|8\\d{8})\\d{5}|[78]\\d{9}", [10, 14], 0, "8", 0, 0, 0, 0, "33622|7", 0, "8~10"], LA: ["856", "00", "[23]\\d{9}|3\\d{8}|(?:[235-8]\\d|41)\\d{6}", [8, 9, 10], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["2[13]|3[14]|[4-8]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["3"], "0$1"], ["(\\d{2})(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["[23]"], "0$1"]], "0"], LB: ["961", "00", "[27-9]\\d{7}|[13-9]\\d{6}", [7, 8], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[13-69]|7(?:[2-57]|62|8[0-6]|9[04-9])|8[02-9]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[27-9]"]]], "0"], LC: ["1", "011", "(?:[58]\\d\\d|758|900)\\d{7}", [10], 0, "1", 0, "([2-8]\\d{6})$|1", "758$1", 0, "758"], LI: ["423", "00", "[68]\\d{8}|(?:[2378]\\d|90)\\d{5}", [7, 9], [["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["[2379]|8(?:0[09]|7)", "[2379]|8(?:0(?:02|9)|7)"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["69"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6"]]], "0", 0, "(1001)|0"], LK: ["94", "00", "[1-9]\\d{8}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[1-689]"], "0$1"]], "0"], LR: ["231", "00", "(?:[2457]\\d|33|88)\\d{7}|(?:2\\d|[4-6])\\d{6}", [7, 8, 9], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["4[67]|[56]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-578]"], "0$1"]], "0"], LS: ["266", "00", "(?:[256]\\d\\d|800)\\d{5}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[2568]"]]]], LT: ["370", "00", "(?:[3469]\\d|52|[78]0)\\d{6}", [8], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["52[0-7]"], "(0-$1)", 1], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[7-9]"], "0 $1", 1], ["(\\d{2})(\\d{6})", "$1 $2", ["37|4(?:[15]|6[1-8])"], "(0-$1)", 1], ["(\\d{3})(\\d{5})", "$1 $2", ["[3-6]"], "(0-$1)", 1]], "0", 0, "[08]"], LU: ["352", "00", "35[013-9]\\d{4,8}|6\\d{8}|35\\d{2,4}|(?:[2457-9]\\d|3[0-46-9])\\d{2,9}", [4, 5, 6, 7, 8, 9, 10, 11], [["(\\d{2})(\\d{3})", "$1 $2", ["2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"]], ["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"]], ["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["20[2-689]"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})", "$1 $2 $3 $4", ["2(?:[0367]|4[3-8])"]], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["80[01]|90[015]"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["20"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})", "$1 $2 $3 $4 $5", ["2(?:[0367]|4[3-8])"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{1,5})", "$1 $2 $3 $4", ["[3-57]|8[13-9]|9(?:0[89]|[2-579])|(?:2|80)[2-9]"]]], 0, 0, "(15(?:0[06]|1[12]|[35]5|4[04]|6[26]|77|88|99)\\d)"], LV: ["371", "00", "(?:[268]\\d|78|90)\\d{6}", [8], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2679]|8[01]"]]]], LY: ["218", "00", "[2-9]\\d{8}", [9], [["(\\d{2})(\\d{7})", "$1-$2", ["[2-9]"], "0$1"]], "0"], MA: ["212", "00", "[5-8]\\d{8}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["5[45]"], "0$1"], ["(\\d{4})(\\d{5})", "$1-$2", ["5(?:2[2-46-9]|3[3-9]|9)|8(?:0[89]|92)"], "0$1"], ["(\\d{2})(\\d{7})", "$1-$2", ["8"], "0$1"], ["(\\d{3})(\\d{6})", "$1-$2", ["[5-7]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["5(?:2(?:[0-25-79]\\d|3[1-578]|4[02-46-8]|8[0235-7])|3(?:[0-47]\\d|5[02-9]|6[02-8]|8[014-9]|9[3-9])|(?:4[067]|5[03])\\d)\\d{5}"], ["(?:6(?:[0-79]\\d|8[0-247-9])|7(?:[0167]\\d|2[0-8]|5[0-5]|8[0-7]))\\d{6}"], ["80[0-7]\\d{6}"], ["89\\d{7}"], 0, 0, 0, 0, ["(?:592(?:4[0-2]|93)|80[89]\\d\\d)\\d{4}"]]], MC: ["377", "00", "(?:[3489]|[67]\\d)\\d{7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["4"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[389]"]], ["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["[67]"], "0$1"]], "0"], MD: ["373", "00", "(?:[235-7]\\d|[89]0)\\d{6}", [8], [["(\\d{3})(\\d{5})", "$1 $2", ["[89]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["22|3"], "0$1"], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[25-7]"], "0$1"]], "0"], ME: ["382", "00", "(?:20|[3-79]\\d)\\d{6}|80\\d{6,7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-9]"], "0$1"]], "0"], MF: ["590", "00", "(?:590\\d|7090)\\d{5}|(?:69|80|9\\d)\\d{7}", [9], 0, "0", 0, 0, 0, 0, 0, [["590(?:0[079]|[14]3|[27][79]|3[03-7]|5[0-268]|87)\\d{4}"], ["(?:69(?:0\\d\\d|1(?:2[2-9]|3[0-5])|4(?:0[89]|1[2-6]|9\\d)|6(?:1[016-9]|5[0-4]|[67]\\d))|7090[0-4])\\d{4}"], ["80[0-5]\\d{6}"], 0, 0, 0, 0, 0, ["9(?:(?:39[5-7]|76[018])\\d|475[0-6])\\d{4}"]]], MG: ["261", "00", "[23]\\d{8}", [9], [["(\\d{2})(\\d{2})(\\d{3})(\\d{2})", "$1 $2 $3 $4", ["[23]"], "0$1"]], "0", 0, "([24-9]\\d{6})$|0", "20$1"], MH: ["692", "011", "329\\d{4}|(?:[256]\\d|45)\\d{5}", [7], [["(\\d{3})(\\d{4})", "$1-$2", ["[2-6]"]]], "1"], MK: ["389", "00", "[2-578]\\d{7}", [8], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["2|34[47]|4(?:[37]7|5[47]|64)"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[347]"], "0$1"], ["(\\d{3})(\\d)(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[58]"], "0$1"]], "0"], ML: ["223", "00", "[24-9]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[24-9]"]]]], MM: ["95", "00", "1\\d{5,7}|95\\d{6}|(?:[4-7]|9[0-46-9])\\d{6,8}|(?:2|8\\d)\\d{5,8}", [6, 7, 8, 9, 10], [["(\\d)(\\d{2})(\\d{3})", "$1 $2 $3", ["16|2"], "0$1"], ["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["4(?:[2-46]|5[3-5])|5|6(?:[1-689]|7[235-7])|7(?:[0-4]|5[2-7])|8[1-5]|(?:60|86)[23]"], "0$1"], ["(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[12]|452|678|86", "[12]|452|6788|86"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[4-7]|8[1-35]"], "0$1"], ["(\\d)(\\d{3})(\\d{4,6})", "$1 $2 $3", ["9(?:2[0-4]|[35-9]|4[137-9])"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"], "0$1"], ["(\\d)(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["92"], "0$1"], ["(\\d)(\\d{5})(\\d{4})", "$1 $2 $3", ["9"], "0$1"]], "0"], MN: ["976", "001", "[12]\\d{7,9}|[5-9]\\d{7}", [8, 9, 10], [["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["[12]1"], "0$1"], ["(\\d{4})(\\d{4})", "$1 $2", ["[5-9]"]], ["(\\d{3})(\\d{5,6})", "$1 $2", ["[12]2[1-3]"], "0$1"], ["(\\d{4})(\\d{5,6})", "$1 $2", ["[12](?:27|3[2-8]|4[2-68]|5[1-4689])", "[12](?:27|3[2-8]|4[2-68]|5[1-4689])[0-3]"], "0$1"], ["(\\d{5})(\\d{4,5})", "$1 $2", ["[12]"], "0$1"]], "0"], MO: ["853", "00", "0800\\d{3}|(?:28|[68]\\d)\\d{6}", [7, 8], [["(\\d{4})(\\d{3})", "$1 $2", ["0"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[268]"]]]], MP: ["1", "011", "[58]\\d{9}|(?:67|90)0\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "670$1", 0, "670"], MQ: ["596", "00", "(?:596\\d|7091)\\d{5}|(?:69|[89]\\d)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-79]|8(?:0[6-9]|[36])"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0$1"]], "0"], MR: ["222", "00", "(?:[2-4]\\d\\d|800)\\d{5}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-48]"]]]], MS: ["1", "011", "(?:[58]\\d\\d|664|900)\\d{7}", [10], 0, "1", 0, "([34]\\d{6})$|1", "664$1", 0, "664"], MT: ["356", "00", "3550\\d{4}|(?:[2579]\\d\\d|800)\\d{5}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[2357-9]"]]]], MU: ["230", "0(?:0|[24-7]0|3[03])", "(?:[57]|8\\d\\d)\\d{7}|[2-468]\\d{6}", [7, 8, 10], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-46]|8[013]"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[57]"]], ["(\\d{5})(\\d{5})", "$1 $2", ["8"]]], 0, 0, 0, 0, 0, 0, 0, "020"], MV: ["960", "0(?:0|19)", "(?:800|9[0-57-9]\\d)\\d{7}|[34679]\\d{6}", [7, 10], [["(\\d{3})(\\d{4})", "$1-$2", ["[34679]"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[89]"]]], 0, 0, 0, 0, 0, 0, 0, "00"], MW: ["265", "00", "(?:[1289]\\d|31|77)\\d{7}|1\\d{6}", [7, 9], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["1[2-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[137-9]"], "0$1"]], "0"], MX: ["52", "0[09]", "[2-9]\\d{9}", [10], [["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["33|5[56]|81"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-9]"]]], 0, 0, 0, 0, 0, 0, 0, "00"], MY: ["60", "00", "1\\d{8,9}|(?:3\\d|[4-9])\\d{7}", [8, 9, 10], [["(\\d)(\\d{3})(\\d{4})", "$1-$2 $3", ["[4-79]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1-$2 $3", ["1(?:[02469]|[378][1-9]|53)|8", "1(?:[02469]|[37][1-9]|53|8(?:[1-46-9]|5[7-9]))|8"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1-$2 $3", ["3"], "0$1"], ["(\\d)(\\d{3})(\\d{2})(\\d{4})", "$1-$2-$3-$4", ["1(?:[367]|80)"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2 $3", ["15"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1-$2 $3", ["1"], "0$1"]], "0"], MZ: ["258", "00", "(?:2|8\\d)\\d{7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2|8[2-79]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]]]], NA: ["264", "00", "[68]\\d{7,8}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["88"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["6"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["87"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"], "0$1"]], "0"], NC: ["687", "00", "(?:050|[2-57-9]\\d\\d)\\d{3}", [6], [["(\\d{2})(\\d{2})(\\d{2})", "$1.$2.$3", ["[02-57-9]"]]]], NE: ["227", "00", "[027-9]\\d{7}", [8], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["08"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[089]|2[013]|7[0467]"]]]], NF: ["672", "00", "[13]\\d{5}", [6], [["(\\d{2})(\\d{4})", "$1 $2", ["1[0-3]"]], ["(\\d)(\\d{5})", "$1 $2", ["[13]"]]], 0, 0, "([0-258]\\d{4})$", "3$1"], NG: ["234", "009", "(?:20|9\\d)\\d{8}|[78]\\d{9,13}", [10, 11, 12, 13, 14], [["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[7-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["20[129]"], "0$1"], ["(\\d{4})(\\d{2})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{3})(\\d{4})(\\d{4,5})", "$1 $2 $3", ["[78]"], "0$1"], ["(\\d{3})(\\d{5})(\\d{5,6})", "$1 $2 $3", ["[78]"], "0$1"]], "0"], NI: ["505", "00", "(?:1800|[25-8]\\d{3})\\d{4}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[125-8]"]]]], NL: ["31", "00", "(?:[124-7]\\d\\d|3(?:[02-9]\\d|1[0-8]))\\d{6}|8\\d{6,9}|9\\d{6,10}|1\\d{4,5}", [5, 6, 7, 8, 9, 10, 11], [["(\\d{3})(\\d{4,7})", "$1 $2", ["[89]0"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["66"], "0$1"], ["(\\d)(\\d{8})", "$1 $2", ["6"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["1[16-8]|2[259]|3[124]|4[17-9]|5[124679]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1-578]|91"], "0$1"], ["(\\d{3})(\\d{3})(\\d{5})", "$1 $2 $3", ["9"], "0$1"]], "0"], NO: ["47", "00", "(?:0|[2-9]\\d{3})\\d{4}", [5, 8], [["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["8"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-79]"]]], 0, 0, 0, 0, 0, "[02-689]|7[0-8]"], NP: ["977", "00", "(?:1\\d|9)\\d{9}|[1-9]\\d{7}", [8, 10, 11], [["(\\d)(\\d{7})", "$1-$2", ["1[2-6]"], "0$1"], ["(\\d{2})(\\d{6})", "$1-$2", ["1[01]|[2-8]|9(?:[1-59]|[67][2-6])"], "0$1"], ["(\\d{3})(\\d{7})", "$1-$2", ["9"]]], "0"], NR: ["674", "00", "(?:222|444|(?:55|8\\d)\\d|666|777|999)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[24-9]"]]]], NU: ["683", "00", "(?:[4-7]|888\\d)\\d{3}", [4, 7], [["(\\d{3})(\\d{4})", "$1 $2", ["8"]]]], NZ: ["64", "0(?:0|161)", "[1289]\\d{9}|50\\d{5}(?:\\d{2,3})?|[27-9]\\d{7,8}|(?:[34]\\d|6[0-35-9])\\d{6}|8\\d{4,6}", [5, 6, 7, 8, 9, 10], [["(\\d{2})(\\d{3,8})", "$1 $2", ["8[1-79]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["50[036-8]|8|90", "50(?:[0367]|88)|8|90"], "0$1"], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["24|[346]|7[2-57-9]|9[2-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2(?:10|74)|[589]"], "0$1"], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["1|2[028]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,5})", "$1 $2 $3", ["2(?:[169]|7[0-35-9])|7"], "0$1"]], "0", 0, 0, 0, 0, 0, 0, "00"], OM: ["968", "00", "(?:1505|[279]\\d{3}|500)\\d{4}|800\\d{5,6}", [7, 8, 9], [["(\\d{3})(\\d{4,6})", "$1 $2", ["[58]"]], ["(\\d{2})(\\d{6})", "$1 $2", ["2"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[179]"]]]], PA: ["507", "00", "(?:00800|8\\d{3})\\d{6}|[68]\\d{7}|[1-57-9]\\d{6}", [7, 8, 10, 11], [["(\\d{3})(\\d{4})", "$1-$2", ["[1-57-9]"]], ["(\\d{4})(\\d{4})", "$1-$2", ["[68]"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"]]]], PE: ["51", "00|19(?:1[124]|77|90)00", "(?:[14-8]|9\\d)\\d{7}", [8, 9], [["(\\d{3})(\\d{5})", "$1 $2", ["80"], "(0$1)"], ["(\\d)(\\d{7})", "$1 $2", ["1"], "(0$1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["[4-8]"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"]]], "0", 0, 0, 0, 0, 0, 0, "00", " Anexo "], PF: ["689", "00", "4\\d{5}(?:\\d{2})?|8\\d{7,8}", [6, 8, 9], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["44"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["4|8[7-9]"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"]]]], PG: ["675", "00|140[1-3]", "(?:180|[78]\\d{3})\\d{4}|(?:[2-589]\\d|64)\\d{5}", [7, 8], [["(\\d{3})(\\d{4})", "$1 $2", ["18|[2-69]|85"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[78]"]]], 0, 0, 0, 0, 0, 0, 0, "00"], PH: ["63", "00", "(?:[2-7]|9\\d)\\d{8}|2\\d{5}|(?:1800|8)\\d{7,9}", [6, 8, 9, 10, 11, 12, 13], [["(\\d)(\\d{5})", "$1 $2", ["2"], "(0$1)"], ["(\\d{4})(\\d{4,6})", "$1 $2", ["3(?:23|39|46)|4(?:2[3-6]|[35]9|4[26]|76)|544|88[245]|(?:52|64|86)2", "3(?:230|397|461)|4(?:2(?:35|[46]4|51)|396|4(?:22|63)|59[347]|76[15])|5(?:221|446)|642[23]|8(?:622|8(?:[24]2|5[13]))"], "(0$1)"], ["(\\d{5})(\\d{4})", "$1 $2", ["346|4(?:27|9[35])|883", "3469|4(?:279|9(?:30|56))|8834"], "(0$1)"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["2"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[3-7]|8[2-8]"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[89]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]], ["(\\d{4})(\\d{1,2})(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["1"]]], "0"], PK: ["92", "00", "122\\d{6}|[24-8]\\d{10,11}|9(?:[013-9]\\d{8,10}|2(?:[01]\\d\\d|2(?:[06-8]\\d|1[01]))\\d{7})|(?:[2-8]\\d{3}|92(?:[0-7]\\d|8[1-9]))\\d{6}|[24-9]\\d{8}|[89]\\d{7}", [8, 9, 10, 11, 12], [["(\\d{3})(\\d{3})(\\d{2,7})", "$1 $2 $3", ["[89]0"], "0$1"], ["(\\d{4})(\\d{5})", "$1 $2", ["1"]], ["(\\d{3})(\\d{6,7})", "$1 $2", ["2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:2[2-8]|3[27-9]|4[2-6]|6[3569]|9[25-8])", "9(?:2[3-8]|98)|(?:2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:22|3[27-9]|4[2-6]|6[3569]|9[25-7]))[2-9]"], "(0$1)"], ["(\\d{2})(\\d{7,8})", "$1 $2", ["(?:2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)[2-9]"], "(0$1)"], ["(\\d{5})(\\d{5})", "$1 $2", ["58"], "(0$1)"], ["(\\d{3})(\\d{7})", "$1 $2", ["3"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["[24-9]"], "(0$1)"]], "0"], PL: ["48", "00", "(?:6|8\\d\\d)\\d{7}|[1-9]\\d{6}(?:\\d{2})?|[26]\\d{5}", [6, 7, 8, 9, 10], [["(\\d{5})", "$1", ["19"]], ["(\\d{3})(\\d{3})", "$1 $2", ["11|20|64"]], ["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])1", "(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])19"]], ["(\\d{3})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["64"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["21|39|45|5[0137]|6[0469]|7[02389]|8(?:0[14]|8)"]], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[2-8]|[2-7]|8[1-79]|9[145]"]], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["8"]]]], PM: ["508", "00", "[45]\\d{5}|(?:708|8\\d\\d)\\d{6}", [6, 9], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["[45]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["7"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0$1"]], "0"], PR: ["1", "011", "(?:[589]\\d\\d|787)\\d{7}", [10], 0, "1", 0, 0, 0, 0, "787|939"], PS: ["970", "00", "[2489]2\\d{6}|(?:1\\d|5)\\d{8}", [8, 9, 10], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[2489]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["5"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]]], "0"], PT: ["351", "00", "1693\\d{5}|(?:[26-9]\\d|30)\\d{7}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["2[12]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["16|[236-9]"]]]], PW: ["680", "01[12]", "(?:[24-8]\\d\\d|345|900)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-9]"]]]], PY: ["595", "00", "59\\d{4,6}|9\\d{5,10}|(?:[2-46-8]\\d|5[0-8])\\d{4,7}", [6, 7, 8, 9, 10, 11], [["(\\d{3})(\\d{3,6})", "$1 $2", ["[2-9]0"], "0$1"], ["(\\d{2})(\\d{5})", "$1 $2", ["[26]1|3[289]|4[1246-8]|7[1-3]|8[1-36]"], "(0$1)"], ["(\\d{3})(\\d{4,5})", "$1 $2", ["2[279]|3[13-5]|4[359]|5|6(?:[34]|7[1-46-8])|7[46-8]|85"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2[14-68]|3[26-9]|4[1246-8]|6(?:1|75)|7[1-35]|8[1-36]"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["87"]], ["(\\d{3})(\\d{6})", "$1 $2", ["9(?:[5-79]|8[1-7])"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-8]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["9"]]], "0"], QA: ["974", "00", "800\\d{4}|(?:2|800)\\d{6}|(?:0080|[3-7])\\d{7}", [7, 8, 9, 11], [["(\\d{3})(\\d{4})", "$1 $2", ["2[136]|8"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[3-7]"]]]], RE: ["262", "00", "709\\d{6}|(?:26|[689]\\d)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[26-9]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["26(?:2\\d\\d|3(?:0\\d|1[0-6]))\\d{4}"], ["(?:69(?:2\\d\\d|3(?:[06][0-6]|1[0-3]|2[0-2]|3[0-39]|4\\d|5[0-5]|7[0-37]|8[0-8]|9[0-479]))|7092[0-3])\\d{4}"], ["80\\d{7}"], ["89[1-37-9]\\d{6}"], 0, 0, 0, 0, ["9(?:399[0-3]|479[0-6]|76(?:2[278]|3[0-37]))\\d{4}"], ["8(?:1[019]|2[0156]|84|90)\\d{6}"]]], RO: ["40", "00", "(?:[236-8]\\d|90)\\d{7}|[23]\\d{5}", [6, 9], [["(\\d{3})(\\d{3})", "$1 $2", ["2[3-6]", "2[3-6]\\d9"], "0$1"], ["(\\d{2})(\\d{4})", "$1 $2", ["219|31"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[23]1"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[236-9]"], "0$1"]], "0", 0, 0, 0, 0, 0, 0, 0, " int "], RS: ["381", "00", "38[02-9]\\d{6,9}|6\\d{7,9}|90\\d{4,8}|38\\d{5,6}|(?:7\\d\\d|800)\\d{3,9}|(?:[12]\\d|3[0-79])\\d{5,10}", [6, 7, 8, 9, 10, 11, 12], [["(\\d{3})(\\d{3,9})", "$1 $2", ["(?:2[389]|39)0|[7-9]"], "0$1"], ["(\\d{2})(\\d{5,10})", "$1 $2", ["[1-36]"], "0$1"]], "0"], RU: ["7", "810", "8\\d{13}|[347-9]\\d{9}", [10, 14], [["(\\d{4})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["7(?:1[0-8]|2[1-9])", "7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:1[23]|[2-9]2))", "7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:13[03-69]|62[013-9]))|72[1-57-9]2"], "8 ($1)", 1], ["(\\d{5})(\\d)(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["7(?:1[0-68]|2[1-9])", "7(?:1(?:[06][3-6]|[18]|2[35]|[3-5][3-5])|2(?:[13][3-5]|[24-689]|7[457]))", "7(?:1(?:0(?:[356]|4[023])|[18]|2(?:3[013-9]|5)|3[45]|43[013-79]|5(?:3[1-8]|4[1-7]|5)|6(?:3[0-35-9]|[4-6]))|2(?:1(?:3[178]|[45])|[24-689]|3[35]|7[457]))|7(?:14|23)4[0-8]|71(?:33|45)[1-79]"], "8 ($1)", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "8 ($1)", 1], ["(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["[349]|8(?:[02-7]|1[1-8])"], "8 ($1)", 1], ["(\\d{4})(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["8"], "8 ($1)"]], "8", 0, 0, 0, 0, 0, [["336(?:[013-9]\\d|2[013-9])\\d{5}|(?:3(?:0[12]|4[1-35-79]|5[1-3]|65|8[1-58]|9[0145])|4(?:01|1[1356]|2[13467]|7[1-5]|8[1-7]|9[1-689])|8(?:1[1-8]|2[01]|3[13-6]|4[0-8]|5[15-7]|6[0-35-79]|7[1-37-9]))\\d{7}", [10]], ["9\\d{9}", [10]], ["8(?:0[04]|108\\d{3})\\d{7}"], ["80[39]\\d{7}", [10]], ["808\\d{7}", [10]]], "8~10"], RW: ["250", "00", "(?:06|[27]\\d\\d|[89]00)\\d{6}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["0"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["2"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[7-9]"], "0$1"]], "0"], SA: ["966", "00", "(?:[15]\\d|800|92)\\d{7}", [9, 10], [["(\\d{4})(\\d{5})", "$1 $2", ["9"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["5"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"]]], "0"], SB: ["677", "0[01]", "[6-9]\\d{6}|[1-6]\\d{4}", [5, 7], [["(\\d{2})(\\d{5})", "$1 $2", ["6[89]|7|8[4-9]|9(?:[1-8]|9[0-8])"]]]], SC: ["248", "010|0[0-2]", "(?:[2489]\\d|64)\\d{5}", [7], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[246]|9[57]"]]], 0, 0, 0, 0, 0, 0, 0, "00"], SD: ["249", "00", "[19]\\d{8}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[19]"], "0$1"]], "0"], SE: ["46", "00", "(?:[26]\\d\\d|9)\\d{9}|[1-9]\\d{8}|[1-689]\\d{7}|[1-4689]\\d{6}|2\\d{5}", [6, 7, 8, 9, 10, 12], [["(\\d{2})(\\d{2,3})(\\d{2})", "$1-$2 $3", ["20"], "0$1", 0, "$1 $2 $3"], ["(\\d{3})(\\d{4})", "$1-$2", ["9(?:00|39|44|9)"], "0$1", 0, "$1 $2"], ["(\\d{2})(\\d{3})(\\d{2})", "$1-$2 $3", ["[12][136]|3[356]|4[0246]|6[03]|90[1-9]"], "0$1", 0, "$1 $2 $3"], ["(\\d)(\\d{2,3})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["8"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2,3})(\\d{2})", "$1-$2 $3", ["1[2457]|2(?:[247-9]|5[0138])|3[0247-9]|4[1357-9]|5[0-35-9]|6(?:[125689]|4[02-57]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"], "0$1", 0, "$1 $2 $3"], ["(\\d{3})(\\d{2,3})(\\d{3})", "$1-$2 $3", ["9(?:00|39|44)"], "0$1", 0, "$1 $2 $3"], ["(\\d{2})(\\d{2,3})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["1[13689]|2[0136]|3[1356]|4[0246]|54|6[03]|90[1-9]"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["10|7"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d)(\\d{3})(\\d{3})(\\d{2})", "$1-$2 $3 $4", ["8"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["[13-5]|2(?:[247-9]|5[0138])|6(?:[124-689]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{3})", "$1-$2 $3 $4", ["9"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1-$2 $3 $4 $5", ["[26]"], "0$1", 0, "$1 $2 $3 $4 $5"]], "0"], SG: ["65", "0[0-3]\\d", "(?:(?:1\\d|8)\\d\\d|7000)\\d{7}|[3689]\\d{7}", [8, 10, 11], [["(\\d{4})(\\d{4})", "$1 $2", ["[369]|8(?:0[1-9]|[1-9])"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"]], ["(\\d{4})(\\d{4})(\\d{3})", "$1 $2 $3", ["7"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]]]], SH: ["290", "00", "(?:[256]\\d|8)\\d{3}", [4, 5], 0, 0, 0, 0, 0, 0, "[256]"], SI: ["386", "00|10(?:22|66|88|99)", "[1-7]\\d{7}|8\\d{4,7}|90\\d{4,6}", [5, 6, 7, 8], [["(\\d{2})(\\d{3,6})", "$1 $2", ["8[09]|9"], "0$1"], ["(\\d{3})(\\d{5})", "$1 $2", ["59|8"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[37][01]|4[0139]|51|6"], "0$1"], ["(\\d)(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[1-57]"], "(0$1)"]], "0", 0, 0, 0, 0, 0, 0, "00"], SJ: ["47", "00", "0\\d{4}|(?:[489]\\d|79)\\d{6}", [5, 8], 0, 0, 0, 0, 0, 0, "79"], SK: ["421", "00", "[2-689]\\d{8}|[2-59]\\d{6}|[2-5]\\d{5}", [6, 7, 9], [["(\\d)(\\d{2})(\\d{3,4})", "$1 $2 $3", ["21"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["[3-5][1-8]1", "[3-5][1-8]1[67]"], "0$1"], ["(\\d)(\\d{3})(\\d{3})(\\d{2})", "$1/$2 $3 $4", ["2"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[689]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1/$2 $3 $4", ["[3-5]"], "0$1"]], "0"], SL: ["232", "00", "(?:[237-9]\\d|66)\\d{6}", [8], [["(\\d{2})(\\d{6})", "$1 $2", ["[236-9]"], "(0$1)"]], "0"], SM: ["378", "00", "(?:0549|[5-7]\\d)\\d{6}", [8, 10], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-7]"]], ["(\\d{4})(\\d{6})", "$1 $2", ["0"]]], 0, 0, "([89]\\d{5})$", "0549$1"], SN: ["221", "00", "(?:[378]\\d|93)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"]], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[379]"]]]], SO: ["252", "00", "[346-9]\\d{8}|[12679]\\d{7}|[1-5]\\d{6}|[1348]\\d{5}", [6, 7, 8, 9], [["(\\d{2})(\\d{4})", "$1 $2", ["8[125]"]], ["(\\d{6})", "$1", ["[134]"]], ["(\\d)(\\d{6})", "$1 $2", ["[15]|2[0-79]|3[0-46-8]|4[0-7]"]], ["(\\d)(\\d{7})", "$1 $2", ["(?:2|90)4|[67]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[348]|64|79|90"]], ["(\\d{2})(\\d{5,7})", "$1 $2", ["1|28|6[0-35-9]|7[67]|9[2-9]"]]], "0"], SR: ["597", "00", "(?:[2-5]|[6-8]\\d|90)\\d{5}", [6, 7], [["(\\d{2})(\\d{2})(\\d{2})", "$1-$2-$3", ["56"]], ["(\\d{3})(\\d{3})", "$1-$2", ["[2-5]"]], ["(\\d{3})(\\d{4})", "$1-$2", ["[6-9]"]]]], SS: ["211", "00", "[19]\\d{8}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[19]"], "0$1"]], "0"], ST: ["239", "00", "(?:22|9\\d)\\d{5}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[29]"]]]], SV: ["503", "00", "(?:[267]\\d\\d|500)\\d{5}|(?:80\\d|900)\\d{4}(?:\\d{4})?", [7, 8, 11], [["(\\d{3})(\\d{4})", "$1 $2", ["[89]"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[25-7]"]], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["[89]"]]]], SX: ["1", "011", "7215\\d{6}|(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "(5\\d{6})$|1", "721$1", 0, "721"], SY: ["963", "00", "[1-359]\\d{8}|[1-5]\\d{7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[1-4]|5[1-3]"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[59]"], "0$1", 1]], "0"], SZ: ["268", "00", "0800\\d{4}|(?:[237]\\d|900)\\d{6}", [8, 9], [["(\\d{4})(\\d{4})", "$1 $2", ["[0237]"]], ["(\\d{5})(\\d{4})", "$1 $2", ["9"]]]], TA: ["290", "00", "8\\d{3}", [4], 0, 0, 0, 0, 0, 0, "8"], TC: ["1", "011", "(?:[58]\\d\\d|649|900)\\d{7}", [10], 0, "1", 0, "([2-479]\\d{6})$|1", "649$1", 0, "649"], TD: ["235", "00|16", "(?:22|30|[689]\\d|77)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[236-9]"]]], 0, 0, 0, 0, 0, 0, 0, "00"], TG: ["228", "00", "[279]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[279]"]]]], TH: ["66", "00[1-9]", "(?:001800|[2-57]|[689]\\d)\\d{7}|1\\d{7,9}", [8, 9, 10, 13], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[13-9]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]]], "0"], TJ: ["992", "810", "(?:[0-57-9]\\d|66)\\d{7}", [9], [["(\\d{6})(\\d)(\\d{2})", "$1 $2 $3", ["331", "3317"]], ["(\\d{3})(\\d{2})(\\d{4})", "$1 $2 $3", ["44[02-479]|[34]7"]], ["(\\d{4})(\\d)(\\d{4})", "$1 $2 $3", ["3(?:[1245]|3[12])"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["\\d"]]], 0, 0, 0, 0, 0, 0, 0, "8~10"], TK: ["690", "00", "[2-47]\\d{3,6}", [4, 5, 6, 7]], TL: ["670", "00", "7\\d{7}|(?:[2-47]\\d|[89]0)\\d{5}", [7, 8], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-489]|70"]], ["(\\d{4})(\\d{4})", "$1 $2", ["7"]]]], TM: ["993", "810", "(?:[1-6]\\d|71)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["12"], "(8 $1)"], ["(\\d{3})(\\d)(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["[1-5]"], "(8 $1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["[67]"], "8 $1"]], "8", 0, 0, 0, 0, 0, 0, "8~10"], TN: ["216", "00", "[2-57-9]\\d{7}", [8], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-57-9]"]]]], TO: ["676", "00", "(?:0800|(?:[5-8]\\d\\d|999)\\d)\\d{3}|[2-8]\\d{4}", [5, 7], [["(\\d{2})(\\d{3})", "$1-$2", ["[2-4]|50|6[09]|7[0-24-69]|8[05]"]], ["(\\d{4})(\\d{3})", "$1 $2", ["0"]], ["(\\d{3})(\\d{4})", "$1 $2", ["[5-9]"]]]], TR: ["90", "00", "4\\d{6}|8\\d{11,12}|(?:[2-58]\\d\\d|900)\\d{7}", [7, 10, 12, 13], [["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["512|8[01589]|90"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["5(?:[0-59]|61)", "5(?:[0-59]|61[06])", "5(?:[0-59]|61[06]1)"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[24][1-8]|3[1-9]"], "(0$1)", 1], ["(\\d{3})(\\d{3})(\\d{6,7})", "$1 $2 $3", ["80"], "0$1", 1]], "0"], TT: ["1", "011", "(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-46-8]\\d{6})$|1", "868$1", 0, "868"], TV: ["688", "00", "(?:2|7\\d\\d|90)\\d{4}", [5, 6, 7], [["(\\d{2})(\\d{3})", "$1 $2", ["2"]], ["(\\d{2})(\\d{4})", "$1 $2", ["90"]], ["(\\d{2})(\\d{5})", "$1 $2", ["7"]]]], TW: ["886", "0(?:0[25-79]|19)", "[2-689]\\d{8}|7\\d{9,10}|[2-8]\\d{7}|2\\d{6}", [7, 8, 9, 10, 11], [["(\\d{2})(\\d)(\\d{4})", "$1 $2 $3", ["202"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[258]0"], "0$1"], ["(\\d)(\\d{3,4})(\\d{4})", "$1 $2 $3", ["[23568]|4(?:0[02-48]|[1-47-9])|7[1-9]", "[23568]|4(?:0[2-48]|[1-47-9])|(?:400|7)[1-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[49]"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4,5})", "$1 $2 $3", ["7"], "0$1"]], "0", 0, 0, 0, 0, 0, 0, 0, "#"], TZ: ["255", "00[056]", "(?:[25-8]\\d|41|90)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{4})", "$1 $2 $3", ["[89]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[24]"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["5"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[67]"], "0$1"]], "0"], UA: ["380", "00", "[89]\\d{9}|[3-9]\\d{8}", [9, 10], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6[12][29]|(?:3[1-8]|4[136-8]|5[12457]|6[49])2|(?:56|65)[24]", "6[12][29]|(?:35|4[1378]|5[12457]|6[49])2|(?:56|65)[24]|(?:3[1-46-8]|46)2[013-9]"], "0$1"], ["(\\d{4})(\\d{5})", "$1 $2", ["3[1-8]|4(?:[1367]|[45][6-9]|8[4-6])|5(?:[1-5]|6[0135689]|7[4-6])|6(?:[12][3-7]|[459])", "3[1-8]|4(?:[1367]|[45][6-9]|8[4-6])|5(?:[1-5]|6(?:[015689]|3[02389])|7[4-6])|6(?:[12][3-7]|[459])"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[3-7]|89|9[1-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[89]"], "0$1"]], "0", 0, 0, 0, 0, 0, 0, "0~0"], UG: ["256", "00[057]", "800\\d{6}|(?:[29]0|[347]\\d)\\d{7}", [9], [["(\\d{4})(\\d{5})", "$1 $2", ["202", "2024"], "0$1"], ["(\\d{3})(\\d{6})", "$1 $2", ["[27-9]|4(?:6[45]|[7-9])"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["[34]"], "0$1"]], "0"], US: ["1", "011", "[2-9]\\d{9}|3\\d{6}", [10], [["(\\d{3})(\\d{4})", "$1-$2", ["310"], 0, 1], ["(\\d{3})(\\d{3})(\\d{4})", "($1) $2-$3", ["[2-9]"], 0, 1, "$1-$2-$3"]], "1", 0, 0, 0, 0, 0, [["3052(?:0[0-8]|[1-9]\\d)\\d{4}|(?:2742|305[3-9])\\d{6}|(?:472|983)[2-47-9]\\d{6}|(?:2(?:0[1-35-9]|1[02-9]|2[03-57-9]|3[1459]|4[08]|5[1-46]|6[0279]|7[0269]|8[13])|3(?:0[1-47-9]|1[02-9]|2[013-79]|3[0-24679]|4[167]|5[0-2]|6[01349]|8[056])|4(?:0[124-9]|1[02-579]|2[3-5]|3[0245]|4[023578]|58|6[349]|7[0589]|8[04])|5(?:0[1-57-9]|1[0235-8]|20|3[0149]|4[01]|5[179]|6[1-47]|7[0-5]|8[0256])|6(?:0[1-35-9]|1[024-9]|2[03689]|3[016]|4[0156]|5[01679]|6[0-279]|78|8[0-269])|7(?:0[1-46-8]|1[2-9]|2[04-8]|3[0-247]|4[0378]|5[47]|6[02359]|7[0-59]|8[156])|8(?:0[1-68]|1[02-8]|2[0168]|3[0-2589]|4[03578]|5[046-9]|6[02-5]|7[028])|9(?:0[1346-9]|1[02-9]|2[0589]|3[0146-8]|4[01357-9]|5[12469]|7[0-3589]|8[04-69]))[2-9]\\d{6}"], [""], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"], 0, 0, 0, ["305209\\d{4}"]]], UY: ["598", "0(?:0|1[3-9]\\d)", "0004\\d{2,9}|[1249]\\d{7}|2\\d{3,4}|(?:[49]\\d|80)\\d{5}", [4, 5, 6, 7, 8, 9, 10, 11, 12, 13], [["(\\d{4,5})", "$1", ["21"]], ["(\\d{3})(\\d{3,4})", "$1 $2", ["0"]], ["(\\d{3})(\\d{4})", "$1 $2", ["[49]0|8"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{4})(\\d{4})", "$1 $2", ["[124]"]], ["(\\d{3})(\\d{3})(\\d{2,4})", "$1 $2 $3", ["0"]], ["(\\d{3})(\\d{3})(\\d{3})(\\d{2,4})", "$1 $2 $3 $4", ["0"]]], "0", 0, 0, 0, 0, 0, 0, "00", " int. "], UZ: ["998", "00", "(?:20|33|[5-9]\\d)\\d{7}", [9], [["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[235-9]"]]]], VA: ["39", "00", "0\\d{5,10}|3[0-8]\\d{7,10}|55\\d{8}|8\\d{5}(?:\\d{2,4})?|(?:1\\d|39)\\d{7,8}", [6, 7, 8, 9, 10, 11, 12], 0, 0, 0, 0, 0, 0, "06698"], VC: ["1", "011", "(?:[58]\\d\\d|784|900)\\d{7}", [10], 0, "1", 0, "([2-7]\\d{6})$|1", "784$1", 0, "784"], VE: ["58", "00", "[68]00\\d{7}|(?:[24]\\d|[59]0)\\d{8}", [10], [["(\\d{3})(\\d{7})", "$1-$2", ["[24-689]"], "0$1"]], "0"], VG: ["1", "011", "(?:284|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-578]\\d{6})$|1", "284$1", 0, "284"], VI: ["1", "011", "[58]\\d{9}|(?:34|90)0\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "340$1", 0, "340"], VN: ["84", "00", "[12]\\d{9}|[135-9]\\d{8}|[16]\\d{7}|[16-8]\\d{6}", [7, 8, 9, 10], [["(\\d{2})(\\d{5})", "$1 $2", ["80"], "0$1", 1], ["(\\d{4})(\\d{4,6})", "$1 $2", ["1"], 0, 1], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["6"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[357-9]"], "0$1", 1], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["2[48]"], "0$1", 1], ["(\\d{3})(\\d{4})(\\d{3})", "$1 $2 $3", ["2"], "0$1", 1]], "0"], VU: ["678", "00", "[57-9]\\d{6}|(?:[238]\\d|48)\\d{3}", [5, 7], [["(\\d{3})(\\d{4})", "$1 $2", ["[57-9]"]]]], WF: ["681", "00", "(?:40|72|8\\d{4})\\d{4}|[89]\\d{5}", [6, 9], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["[47-9]"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"]]]], WS: ["685", "0", "(?:[2-6]|8\\d{5})\\d{4}|[78]\\d{6}|[68]\\d{5}", [5, 6, 7, 10], [["(\\d{5})", "$1", ["[2-5]|6[1-9]"]], ["(\\d{3})(\\d{3,7})", "$1 $2", ["[68]"]], ["(\\d{2})(\\d{5})", "$1 $2", ["7"]]]], XK: ["383", "00", "2\\d{7,8}|3\\d{7,11}|(?:4\\d\\d|[89]00)\\d{5}", [8, 9, 10, 11, 12], [["(\\d{3})(\\d{5})", "$1 $2", ["[89]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-4]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["2|39"], "0$1"], ["(\\d{2})(\\d{7,10})", "$1 $2", ["3"], "0$1"]], "0"], YE: ["967", "00", "(?:1|7\\d)\\d{7}|[1-7]\\d{6}", [7, 8, 9], [["(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[1-6]|7(?:[24-6]|8[0-7])"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["7"], "0$1"]], "0"], YT: ["262", "00", "7093\\d{5}|(?:80|9\\d)\\d{7}|(?:26|63)9\\d{6}", [9], 0, "0", 0, 0, 0, 0, 0, [["269(?:0[0-467]|15|5[0-4]|6\\d|[78]0)\\d{4}"], ["(?:639(?:0[0-79]|1[019]|[267]\\d|3[09]|40|5[05-9]|9[04-79])|7093[5-7])\\d{4}"], ["80\\d{7}"], 0, 0, 0, 0, 0, ["9(?:(?:39|47)8[01]|769\\d)\\d{4}"]]], ZA: ["27", "00", "[1-79]\\d{8}|8\\d{4,9}", [5, 6, 7, 8, 9, 10], [["(\\d{2})(\\d{3,4})", "$1 $2", ["8[1-4]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2,3})", "$1 $2 $3", ["8[1-4]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["860"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"], "0$1"]], "0"], ZM: ["260", "00", "800\\d{6}|(?:21|[579]\\d|63)\\d{7}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[28]"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["[579]"], "0$1"]], "0"], ZW: ["263", "00", "2(?:[0-57-9]\\d{6,8}|6[0-24-9]\\d{6,7})|[38]\\d{9}|[35-8]\\d{8}|[3-6]\\d{7}|[1-689]\\d{6}|[1-3569]\\d{5}|[1356]\\d{4}", [5, 6, 7, 8, 9, 10], [["(\\d{3})(\\d{3,5})", "$1 $2", ["2(?:0[45]|2[278]|[49]8)|3(?:[09]8|17)|6(?:[29]8|37|75)|[23][78]|(?:33|5[15]|6[68])[78]"], "0$1"], ["(\\d)(\\d{3})(\\d{2,4})", "$1 $2 $3", ["[49]"], "0$1"], ["(\\d{3})(\\d{4})", "$1 $2", ["80"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["24|8[13-59]|(?:2[05-79]|39|5[45]|6[15-8])2", "2(?:02[014]|4|[56]20|[79]2)|392|5(?:42|525)|6(?:[16-8]21|52[013])|8[13-59]"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2(?:1[39]|2[0157]|[378]|[56][14])|3(?:12|29)", "2(?:1[39]|2[0157]|[378]|[56][14])|3(?:123|29)"], "0$1"], ["(\\d{4})(\\d{6})", "$1 $2", ["8"], "0$1"], ["(\\d{2})(\\d{3,5})", "$1 $2", ["1|2(?:0[0-36-9]|12|29|[56])|3(?:1[0-689]|[24-6])|5(?:[0236-9]|1[2-4])|6(?:[013-59]|7[0-46-9])|(?:33|55|6[68])[0-69]|(?:29|3[09]|62)[0-79]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["29[013-9]|39|54"], "0$1"], ["(\\d{4})(\\d{3,5})", "$1 $2", ["(?:25|54)8", "258|5483"], "0$1"]], "0"] }, nonGeographic: { 800: ["800", 0, "(?:00|[1-9]\\d)\\d{6}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["\\d"]]], 0, 0, 0, 0, 0, 0, [0, 0, ["(?:00|[1-9]\\d)\\d{6}"]]], 808: ["808", 0, "[1-9]\\d{7}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[1-9]"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, 0, 0, 0, ["[1-9]\\d{7}"]]], 870: ["870", 0, "7\\d{11}|[235-7]\\d{8}", [9, 12], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[235-7]"]]], 0, 0, 0, 0, 0, 0, [0, ["(?:[356]|774[45])\\d{8}|7[6-8]\\d{7}"], 0, 0, 0, 0, 0, 0, ["2\\d{8}", [9]]]], 878: ["878", 0, "10\\d{10}", [12], [["(\\d{2})(\\d{5})(\\d{5})", "$1 $2 $3", ["1"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, 0, 0, ["10\\d{10}"]]], 881: ["881", 0, "6\\d{9}|[0-36-9]\\d{8}", [9, 10], [["(\\d)(\\d{3})(\\d{5})", "$1 $2 $3", ["[0-37-9]"]], ["(\\d)(\\d{3})(\\d{5,6})", "$1 $2 $3", ["6"]]], 0, 0, 0, 0, 0, 0, [0, ["6\\d{9}|[0-36-9]\\d{8}"]]], 882: ["882", 0, "[13]\\d{6}(?:\\d{2,5})?|[19]\\d{7}|(?:[25]\\d\\d|4)\\d{7}(?:\\d{2})?", [7, 8, 9, 10, 11, 12], [["(\\d{2})(\\d{5})", "$1 $2", ["16|342"]], ["(\\d{2})(\\d{6})", "$1 $2", ["49"]], ["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["1[36]|9"]], ["(\\d{2})(\\d{4})(\\d{3})", "$1 $2 $3", ["3[23]"]], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["16"]], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["10|23|3(?:[15]|4[57])|4|51"]], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["34"]], ["(\\d{2})(\\d{4,5})(\\d{5})", "$1 $2 $3", ["[1-35]"]]], 0, 0, 0, 0, 0, 0, [0, ["342\\d{4}|(?:337|49)\\d{6}|(?:3(?:2|47|7\\d{3})|50\\d{3})\\d{7}", [7, 8, 9, 10, 12]], 0, 0, 0, ["348[57]\\d{7}", [11]], 0, 0, ["1(?:3(?:0[0347]|[13][0139]|2[035]|4[013568]|6[0459]|7[06]|8[15-8]|9[0689])\\d{4}|6\\d{5,10})|(?:345\\d|9[89])\\d{6}|(?:10|2(?:3|85\\d)|3(?:[15]|[69]\\d\\d)|4[15-8]|51)\\d{8}"]]], 883: ["883", 0, "(?:[1-4]\\d|51)\\d{6,10}", [8, 9, 10, 11, 12], [["(\\d{3})(\\d{3})(\\d{2,8})", "$1 $2 $3", ["[14]|2[24-689]|3[02-689]|51[24-9]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["510"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["21"]], ["(\\d{4})(\\d{4})(\\d{4})", "$1 $2 $3", ["51[13]"]], ["(\\d{3})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["[235]"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, 0, 0, ["(?:2(?:00\\d\\d|10)|(?:370[1-9]|51\\d0)\\d)\\d{7}|51(?:00\\d{5}|[24-9]0\\d{4,7})|(?:1[0-79]|2[24-689]|3[02-689]|4[0-4])0\\d{5,9}"]]], 888: ["888", 0, "\\d{11}", [11], [["(\\d{3})(\\d{3})(\\d{5})", "$1 $2 $3"]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, ["\\d{11}"]]], 979: ["979", 0, "[1359]\\d{8}", [9], [["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["[1359]"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, ["[1359]\\d{8}"]]] } };
function Gc(t, e) {
  t = t.split("-"), e = e.split("-");
  for (var n = t[0].split("."), r = e[0].split("."), a = 0; a < 3; a++) {
    var o = Number(n[a]), l = Number(r[a]);
    if (o > l) return 1;
    if (l > o) return -1;
    if (!isNaN(o) && isNaN(l)) return 1;
    if (isNaN(o) && !isNaN(l)) return -1;
  }
  return t[1] && e[1] ? t[1] > e[1] ? 1 : t[1] < e[1] ? -1 : 0 : !t[1] && e[1] ? 1 : t[1] && !e[1] ? -1 : 0;
}
var $9 = {}.constructor;
function wn(t) {
  return t != null && t.constructor === $9;
}
function fr(t) {
  "@babel/helpers - typeof";
  return fr = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, fr(t);
}
function Ki(t, e) {
  if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
}
function x9(t, e) {
  for (var n = 0; n < e.length; n++) {
    var r = e[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, C9(r.key), r);
  }
}
function qi(t, e, n) {
  return e && x9(t.prototype, e), Object.defineProperty(t, "prototype", { writable: !1 }), t;
}
function C9(t) {
  var e = M9(t, "string");
  return fr(e) == "symbol" ? e : e + "";
}
function M9(t, e) {
  if (fr(t) != "object" || !t) return t;
  var n = t[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(t, e);
    if (fr(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(t);
}
var S9 = "1.2.0", F9 = "1.7.35", Kc = " ext. ", P9 = /^\d+$/, He = /* @__PURE__ */ (function() {
  function t(e) {
    Ki(this, t), G2(e), this.metadata = e, q2.call(this, e);
  }
  return qi(t, [{
    key: "getCountries",
    value: function() {
      return Object.keys(this.metadata.countries).filter(function(n) {
        return n !== "001";
      });
    }
  }, {
    key: "getCountryMetadata",
    value: function(n) {
      return this.metadata.countries[n];
    }
  }, {
    key: "nonGeographic",
    value: function() {
      if (!(this.v1 || this.v2 || this.v3))
        return this.metadata.nonGeographic || this.metadata.nonGeographical;
    }
  }, {
    key: "hasCountry",
    value: function(n) {
      return this.getCountryMetadata(n) !== void 0;
    }
  }, {
    key: "hasCallingCode",
    value: function(n) {
      if (this.getCountryCodesForCallingCode(n))
        return !0;
      if (this.nonGeographic()) {
        if (this.nonGeographic()[n])
          return !0;
      } else {
        var r = this.countryCallingCodes()[n];
        if (r && r.length === 1 && r[0] === "001")
          return !0;
      }
    }
  }, {
    key: "isNonGeographicCallingCode",
    value: function(n) {
      return this.nonGeographic() ? !!this.nonGeographic()[n] : !this.getCountryCodesForCallingCode(n);
    }
    // Deprecated.
  }, {
    key: "country",
    value: function(n) {
      return this.selectNumberingPlan(n);
    }
  }, {
    key: "selectNumberingPlan",
    value: function(n, r) {
      if (n && P9.test(n) && (r = n, n = null), n && n !== "001") {
        if (!this.hasCountry(n))
          throw new Error("Unknown country: ".concat(n));
        this.numberingPlan = new qc(this.getCountryMetadata(n), this);
      } else if (r) {
        if (!this.hasCallingCode(r))
          throw new Error("Unknown calling code: ".concat(r));
        this.numberingPlan = new qc(this.getNumberingPlanMetadata(r), this);
      } else
        this.numberingPlan = void 0;
      return this;
    }
  }, {
    key: "getCountryCodesForCallingCode",
    value: function(n) {
      var r = this.countryCallingCodes()[n];
      if (r)
        return r.length === 1 && r[0].length === 3 ? void 0 : r;
    }
  }, {
    key: "getCountryCodeForCallingCode",
    value: function(n) {
      var r = this.getCountryCodesForCallingCode(n);
      if (r)
        return r[0];
    }
  }, {
    key: "getNumberingPlanMetadata",
    value: function(n) {
      var r = this.getCountryCodeForCallingCode(n);
      if (r)
        return this.getCountryMetadata(r);
      if (this.nonGeographic()) {
        var a = this.nonGeographic()[n];
        if (a)
          return a;
      } else {
        var o = this.countryCallingCodes()[n];
        if (o && o.length === 1 && o[0] === "001")
          return this.metadata.countries["001"];
      }
    }
    // Deprecated.
  }, {
    key: "countryCallingCode",
    value: function() {
      return this.numberingPlan.callingCode();
    }
    // Deprecated.
  }, {
    key: "IDDPrefix",
    value: function() {
      return this.numberingPlan.IDDPrefix();
    }
    // Deprecated.
  }, {
    key: "defaultIDDPrefix",
    value: function() {
      return this.numberingPlan.defaultIDDPrefix();
    }
    // Deprecated.
  }, {
    key: "nationalNumberPattern",
    value: function() {
      return this.numberingPlan.nationalNumberPattern();
    }
    // Deprecated.
  }, {
    key: "possibleLengths",
    value: function() {
      return this.numberingPlan.possibleLengths();
    }
    // Deprecated.
  }, {
    key: "formats",
    value: function() {
      return this.numberingPlan.formats();
    }
    // Deprecated.
  }, {
    key: "nationalPrefixForParsing",
    value: function() {
      return this.numberingPlan.nationalPrefixForParsing();
    }
    // Deprecated.
  }, {
    key: "nationalPrefixTransformRule",
    value: function() {
      return this.numberingPlan.nationalPrefixTransformRule();
    }
    // Deprecated.
  }, {
    key: "leadingDigits",
    value: function() {
      return this.numberingPlan.leadingDigits();
    }
    // Deprecated.
  }, {
    key: "hasTypes",
    value: function() {
      return this.numberingPlan.hasTypes();
    }
    // Deprecated.
  }, {
    key: "type",
    value: function(n) {
      return this.numberingPlan.type(n);
    }
    // Deprecated.
  }, {
    key: "ext",
    value: function() {
      return this.numberingPlan.ext();
    }
  }, {
    key: "countryCallingCodes",
    value: function() {
      return this.v1 ? this.metadata.country_phone_code_to_countries : this.metadata.country_calling_codes;
    }
    // Deprecated.
  }, {
    key: "chooseCountryByCountryCallingCode",
    value: function(n) {
      return this.selectNumberingPlan(n);
    }
  }, {
    key: "hasSelectedNumberingPlan",
    value: function() {
      return this.numberingPlan !== void 0;
    }
  }]);
})(), qc = /* @__PURE__ */ (function() {
  function t(e, n) {
    Ki(this, t), this.globalMetadataObject = n, this.metadata = e, q2.call(this, n.metadata);
  }
  return qi(t, [{
    key: "callingCode",
    value: function() {
      return this.metadata[0];
    }
    // Formatting information for regions which share
    // a country calling code is contained by only one region
    // for performance reasons. For example, for NANPA region
    // ("North American Numbering Plan Administration",
    //  which includes USA, Canada, Cayman Islands, Bahamas, etc)
    // it will be contained in the metadata for `US`.
  }, {
    key: "getDefaultCountryMetadataForRegion",
    value: function() {
      return this.globalMetadataObject.getNumberingPlanMetadata(this.callingCode());
    }
    // Is always present.
  }, {
    key: "IDDPrefix",
    value: function() {
      if (!(this.v1 || this.v2))
        return this.metadata[1];
    }
    // Is only present when a country supports multiple IDD prefixes.
  }, {
    key: "defaultIDDPrefix",
    value: function() {
      if (!(this.v1 || this.v2))
        return this.metadata[12];
    }
  }, {
    key: "nationalNumberPattern",
    value: function() {
      return this.v1 || this.v2 ? this.metadata[1] : this.metadata[2];
    }
    // "possible length" data is always present in Google's metadata.
  }, {
    key: "possibleLengths",
    value: function() {
      if (!this.v1)
        return this.metadata[this.v2 ? 2 : 3];
    }
  }, {
    key: "_getFormats",
    value: function(n) {
      return n[this.v1 ? 2 : this.v2 ? 3 : 4];
    }
    // For countries of the same region (e.g. NANPA)
    // formats are all stored in the "main" country for that region.
    // E.g. "RU" and "KZ", "US" and "CA".
  }, {
    key: "formats",
    value: function() {
      var n = this, r = this._getFormats(this.metadata) || this._getFormats(this.getDefaultCountryMetadataForRegion()) || [];
      return r.map(function(a) {
        return new N9(a, n);
      });
    }
  }, {
    key: "nationalPrefix",
    value: function() {
      return this.metadata[this.v1 ? 3 : this.v2 ? 4 : 5];
    }
  }, {
    key: "_getNationalPrefixFormattingRule",
    value: function(n) {
      return n[this.v1 ? 4 : this.v2 ? 5 : 6];
    }
    // For countries of the same region (e.g. NANPA)
    // national prefix formatting rule is stored in the "main" country for that region.
    // E.g. "RU" and "KZ", "US" and "CA".
  }, {
    key: "nationalPrefixFormattingRule",
    value: function() {
      return this._getNationalPrefixFormattingRule(this.metadata) || this._getNationalPrefixFormattingRule(this.getDefaultCountryMetadataForRegion());
    }
  }, {
    key: "_nationalPrefixForParsing",
    value: function() {
      return this.metadata[this.v1 ? 5 : this.v2 ? 6 : 7];
    }
  }, {
    key: "nationalPrefixForParsing",
    value: function() {
      return this._nationalPrefixForParsing() || this.nationalPrefix();
    }
  }, {
    key: "nationalPrefixTransformRule",
    value: function() {
      return this.metadata[this.v1 ? 6 : this.v2 ? 7 : 8];
    }
  }, {
    key: "_getNationalPrefixIsOptionalWhenFormatting",
    value: function() {
      return !!this.metadata[this.v1 ? 7 : this.v2 ? 8 : 9];
    }
    // For countries of the same region (e.g. NANPA)
    // "national prefix is optional when formatting" flag is
    // stored in the "main" country for that region.
    // E.g. "RU" and "KZ", "US" and "CA".
  }, {
    key: "nationalPrefixIsOptionalWhenFormattingInNationalFormat",
    value: function() {
      return this._getNationalPrefixIsOptionalWhenFormatting(this.metadata) || this._getNationalPrefixIsOptionalWhenFormatting(this.getDefaultCountryMetadataForRegion());
    }
  }, {
    key: "leadingDigits",
    value: function() {
      return this.metadata[this.v1 ? 8 : this.v2 ? 9 : 10];
    }
  }, {
    key: "types",
    value: function() {
      return this.metadata[this.v1 ? 9 : this.v2 ? 10 : 11];
    }
  }, {
    key: "hasTypes",
    value: function() {
      return this.types() && this.types().length === 0 ? !1 : !!this.types();
    }
  }, {
    key: "type",
    value: function(n) {
      if (this.hasTypes() && Yc(this.types(), n))
        return new T9(Yc(this.types(), n), this);
    }
  }, {
    key: "ext",
    value: function() {
      return this.v1 || this.v2 ? Kc : this.metadata[13] || Kc;
    }
  }]);
})(), N9 = /* @__PURE__ */ (function() {
  function t(e, n) {
    Ki(this, t), this._format = e, this.metadata = n;
  }
  return qi(t, [{
    key: "pattern",
    value: function() {
      return this._format[0];
    }
  }, {
    key: "format",
    value: function() {
      return this._format[1];
    }
  }, {
    key: "leadingDigitsPatterns",
    value: function() {
      return this._format[2] || [];
    }
  }, {
    key: "nationalPrefixFormattingRule",
    value: function() {
      return this._format[3] || this.metadata.nationalPrefixFormattingRule();
    }
  }, {
    key: "nationalPrefixIsOptionalWhenFormattingInNationalFormat",
    value: function() {
      return !!this._format[4] || this.metadata.nationalPrefixIsOptionalWhenFormattingInNationalFormat();
    }
  }, {
    key: "nationalPrefixIsMandatoryWhenFormattingInNationalFormat",
    value: function() {
      return this.usesNationalPrefix() && !this.nationalPrefixIsOptionalWhenFormattingInNationalFormat();
    }
    // Checks whether national prefix formatting rule contains national prefix.
  }, {
    key: "usesNationalPrefix",
    value: function() {
      return !!(this.nationalPrefixFormattingRule() && // Check that national prefix formatting rule is not a "dummy" one.
      !_9.test(this.nationalPrefixFormattingRule()));
    }
  }, {
    key: "internationalFormat",
    value: function() {
      return this._format[5] || this.format();
    }
  }]);
})(), _9 = /^\(?\$1\)?$/, T9 = /* @__PURE__ */ (function() {
  function t(e, n) {
    Ki(this, t), this.type = e, this.metadata = n;
  }
  return qi(t, [{
    key: "pattern",
    value: function() {
      return this.metadata.v1 ? this.type : this.type[0];
    }
  }, {
    key: "possibleLengths",
    value: function() {
      if (!this.metadata.v1)
        return this.type[1] || this.metadata.possibleLengths();
    }
  }]);
})();
function Yc(t, e) {
  switch (e) {
    case "FIXED_LINE":
      return t[0];
    case "MOBILE":
      return t[1];
    case "TOLL_FREE":
      return t[2];
    case "PREMIUM_RATE":
      return t[3];
    case "PERSONAL_NUMBER":
      return t[4];
    case "VOICEMAIL":
      return t[5];
    case "UAN":
      return t[6];
    case "PAGER":
      return t[7];
    case "VOIP":
      return t[8];
    case "SHARED_COST":
      return t[9];
  }
}
function G2(t) {
  if (!t)
    throw new Error("[libphonenumber-js] `metadata` argument not passed. Check your arguments.");
  if (!wn(t) || !wn(t.countries))
    throw new Error("[libphonenumber-js] `metadata` argument was passed but it's not a valid metadata. Must be an object having `.countries` child object property. Got ".concat(wn(t) ? "an object of shape: { " + Object.keys(t).join(", ") + " }" : "a " + A9(t) + ": " + t, "."));
}
var A9 = function(e) {
  return fr(e);
};
function Wt(t, e) {
  if (e = new He(e), e.hasCountry(t))
    return e.selectNumberingPlan(t).countryCallingCode();
  throw new Error("Unknown country: ".concat(t));
}
function K2(t, e) {
  return e.countries.hasOwnProperty(t);
}
function q2(t) {
  var e = t.version;
  typeof e == "number" ? (this.v1 = e === 1, this.v2 = e === 2, this.v3 = e === 3, this.v4 = e === 4) : e ? Gc(e, S9) === -1 ? this.v2 = !0 : Gc(e, F9) === -1 ? this.v3 = !0 : this.v4 = !0 : this.v1 = !0;
}
function Yi(t, e, n) {
  return z9(t, e, void 0, n);
}
function z9(t, e, n, r) {
  e && (r = new He(r.metadata), r.selectNumberingPlan(e));
  var a = r.type(n), o = a && a.possibleLengths() || r.possibleLengths();
  if (!o)
    return "IS_POSSIBLE";
  var l = t.length, s = o[0];
  return s === l ? "IS_POSSIBLE" : s > l ? "TOO_SHORT" : o[o.length - 1] < l ? "TOO_LONG" : o.indexOf(l, 1) >= 0 ? "IS_POSSIBLE" : "INVALID_LENGTH";
}
function D9(t, e, n) {
  if (e === void 0 && (e = {}), n = new He(n), e.v2) {
    if (!t.countryCallingCode)
      throw new Error("Invalid phone number object passed");
    n.selectNumberingPlan(t.countryCallingCode);
  } else {
    if (!t.phone)
      return !1;
    if (t.country) {
      if (!n.hasCountry(t.country))
        throw new Error("Unknown country: ".concat(t.country));
      n.selectNumberingPlan(t.country);
    } else {
      if (!t.countryCallingCode)
        throw new Error("Invalid phone number object passed");
      n.selectNumberingPlan(t.countryCallingCode);
    }
  }
  if (n.possibleLengths())
    return Y2(t.phone || t.nationalNumber, t.country, n);
  if (t.countryCallingCode && n.isNonGeographicCallingCode(t.countryCallingCode))
    return !0;
  throw new Error('Missing "possibleLengths" in metadata. Perhaps the metadata has been generated before v1.0.18.');
}
function Y2(t, e, n) {
  switch (Yi(t, e, n)) {
    case "IS_POSSIBLE":
      return !0;
    // This library ignores "local-only" phone numbers (for simplicity).
    // See the readme for more info on what are "local-only" phone numbers.
    // case 'IS_POSSIBLE_LOCAL_ONLY':
    // 	return !isInternational
    default:
      return !1;
  }
}
function Vt(t, e) {
  return t = t || "", new RegExp("^(?:" + e + ")$").test(t);
}
function I9(t, e) {
  var n = typeof Symbol < "u" && t[Symbol.iterator] || t["@@iterator"];
  if (n) return (n = n.call(t)).next.bind(n);
  if (Array.isArray(t) || (n = k9(t)) || e) {
    n && (t = n);
    var r = 0;
    return function() {
      return r >= t.length ? { done: !0 } : { done: !1, value: t[r++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function k9(t, e) {
  if (t) {
    if (typeof t == "string") return Zc(t, e);
    var n = {}.toString.call(t).slice(8, -1);
    return n === "Object" && t.constructor && (n = t.constructor.name), n === "Map" || n === "Set" ? Array.from(t) : n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? Zc(t, e) : void 0;
  }
}
function Zc(t, e) {
  (e == null || e > t.length) && (e = t.length);
  for (var n = 0, r = Array(e); n < e; n++) r[n] = t[n];
  return r;
}
var O9 = ["MOBILE", "PREMIUM_RATE", "TOLL_FREE", "SHARED_COST", "VOIP", "PERSONAL_NUMBER", "PAGER", "UAN", "VOICEMAIL"];
function Ps(t, e, n) {
  if (e = e || {}, !(!t.country && !t.countryCallingCode)) {
    n = new He(n), n.selectNumberingPlan(t.country, t.countryCallingCode);
    var r = e.v2 ? t.nationalNumber : t.phone;
    if (Vt(r, n.nationalNumberPattern())) {
      if (zo(r, "FIXED_LINE", n))
        return n.type("MOBILE") && n.type("MOBILE").pattern() === "" || !n.type("MOBILE") || zo(r, "MOBILE", n) ? "FIXED_LINE_OR_MOBILE" : "FIXED_LINE";
      for (var a = I9(O9), o; !(o = a()).done; ) {
        var l = o.value;
        if (zo(r, l, n))
          return l;
      }
    }
  }
}
function zo(t, e, n) {
  return e = n.type(e), !e || !e.pattern() || e.possibleLengths() && e.possibleLengths().indexOf(t.length) < 0 ? !1 : Vt(t, e.pattern());
}
function L9(t, e, n) {
  if (e = e || {}, n = new He(n), n.selectNumberingPlan(t.country, t.countryCallingCode), n.hasTypes())
    return Ps(t, e, n.metadata) !== void 0;
  var r = e.v2 ? t.nationalNumber : t.phone;
  return Vt(r, n.nationalNumberPattern());
}
function R9(t, e, n) {
  var r = new He(n), a = r.getCountryCodesForCallingCode(t);
  return a ? a.filter(function(o) {
    return H9(e, o, n);
  }) : [];
}
function H9(t, e, n) {
  var r = new He(n);
  return r.selectNumberingPlan(e), r.numberingPlan.possibleLengths().indexOf(t.length) >= 0;
}
var Ns = 2, B9 = 17, j9 = 3, Qe = "0-9０-９٠-٩۰-۹", V9 = "-‐-―−ー－", U9 = "／/", W9 = "．.", G9 = "  ­​⁠　", K9 = "()（）［］\\[\\]", q9 = "~⁓∼～", pt = "".concat(V9).concat(U9).concat(W9).concat(G9).concat(K9).concat(q9), Zi = "+＋", Y9 = new RegExp("([" + Qe + "])");
function Z2(t, e, n, r) {
  if (e) {
    var a = new He(r);
    a.selectNumberingPlan(e, n);
    var o = new RegExp(a.IDDPrefix());
    if (t.search(o) === 0) {
      t = t.slice(t.match(o)[0].length);
      var l = t.match(Y9);
      if (!(l && l[1] != null && l[1].length > 0 && l[1] === "0"))
        return t;
    }
  }
}
function Sl(t, e) {
  if (t && e.numberingPlan.nationalPrefixForParsing()) {
    var n = new RegExp("^(?:" + e.numberingPlan.nationalPrefixForParsing() + ")"), r = n.exec(t);
    if (r) {
      var a, o, l = r.length - 1, s = l > 0 && r[l];
      if (e.nationalPrefixTransformRule() && s)
        a = t.replace(n, e.nationalPrefixTransformRule()), l > 1 && (o = r[1]);
      else {
        var c = r[0];
        a = t.slice(c.length), s && (o = r[1]);
      }
      var d;
      if (s) {
        var u = t.indexOf(r[1]), f = t.slice(0, u);
        f === e.numberingPlan.nationalPrefix() && (d = e.numberingPlan.nationalPrefix());
      } else
        d = r[0];
      return {
        nationalNumber: a,
        nationalPrefix: d,
        carrierCode: o
      };
    }
  }
  return {
    nationalNumber: t
  };
}
function Z9(t, e) {
  var n = typeof Symbol < "u" && t[Symbol.iterator] || t["@@iterator"];
  if (n) return (n = n.call(t)).next.bind(n);
  if (Array.isArray(t) || (n = X9(t)) || e) {
    n && (t = n);
    var r = 0;
    return function() {
      return r >= t.length ? { done: !0 } : { done: !1, value: t[r++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function X9(t, e) {
  if (t) {
    if (typeof t == "string") return Xc(t, e);
    var n = {}.toString.call(t).slice(8, -1);
    return n === "Object" && t.constructor && (n = t.constructor.name), n === "Map" || n === "Set" ? Array.from(t) : n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? Xc(t, e) : void 0;
  }
}
function Xc(t, e) {
  (e == null || e > t.length) && (e = t.length);
  for (var n = 0, r = Array(e); n < e; n++) r[n] = t[n];
  return r;
}
function X2(t, e) {
  var n = e.countries, r = e.metadata;
  r = new He(r);
  for (var a = Z9(n), o; !(o = a()).done; ) {
    var l = o.value;
    if (r.selectNumberingPlan(l), r.leadingDigits()) {
      if (t && t.search(r.leadingDigits()) === 0)
        return l;
    } else if (Ps({
      phone: t,
      country: l
    }, void 0, r.metadata))
      return l;
  }
}
function _s(t, e) {
  var n = e.nationalNumber, r = e.metadata, a = r.getCountryCodesForCallingCode(t);
  if (a)
    return a.length === 1 ? a[0] : X2(n, {
      countries: a,
      metadata: r.metadata
    });
}
function Fl(t, e, n) {
  var r = Sl(t, n), a = r.carrierCode, o = r.nationalNumber;
  if (o !== t) {
    if (!J9(t, o, n))
      return {
        nationalNumber: t
      };
    if (n.numberingPlan.possibleLengths() && (e || (e = _s(n.numberingPlan.callingCode(), {
      nationalNumber: o,
      metadata: n
    })), !Q9(o, e, n)))
      return {
        nationalNumber: t
      };
  }
  return {
    nationalNumber: o,
    carrierCode: a
  };
}
function J9(t, e, n) {
  return !(Vt(t, n.nationalNumberPattern()) && !Vt(e, n.nationalNumberPattern()));
}
function Q9(t, e, n) {
  switch (Yi(t, e, n)) {
    case "TOO_SHORT":
    case "INVALID_LENGTH":
      return !1;
    default:
      return !0;
  }
}
function J2(t, e, n, r, a) {
  var o = e || n ? Wt(e || n, a) : r;
  if (t.indexOf(o) === 0) {
    a = new He(a), a.selectNumberingPlan(e || n, o);
    var l = t.slice(o.length), s = Fl(l, e, a), c = s.nationalNumber, d = Fl(t, e, a), u = d.nationalNumber;
    if (!Vt(u, a.nationalNumberPattern()) && Vt(c, a.nationalNumberPattern()) || Yi(u, e, a) === "TOO_LONG")
      return {
        countryCallingCode: o,
        number: l
      };
  }
  return {
    number: t
  };
}
function Ts(t, e, n, r, a) {
  if (!t)
    return {};
  var o;
  if (t[0] !== "+") {
    var l = Z2(t, e || n, r, a);
    if (l && l !== t)
      o = !0, t = "+" + l;
    else {
      if (e || n || r) {
        var s = J2(t, e, n, r, a), c = s.countryCallingCode, d = s.number;
        if (c)
          return {
            countryCallingCodeSource: "FROM_NUMBER_WITHOUT_PLUS_SIGN",
            countryCallingCode: c,
            number: d
          };
      }
      return {
        // No need to set it to `UNSPECIFIED`. It can be just `undefined`.
        // countryCallingCodeSource: 'UNSPECIFIED',
        number: t
      };
    }
  }
  if (t[1] === "0")
    return {};
  a = new He(a);
  for (var u = 2; u - 1 <= j9 && u <= t.length; ) {
    var f = t.slice(1, u);
    if (a.hasCallingCode(f))
      return a.selectNumberingPlan(f), {
        countryCallingCodeSource: o ? "FROM_NUMBER_WITH_IDD" : "FROM_NUMBER_WITH_PLUS_SIGN",
        countryCallingCode: f,
        number: t.slice(u)
      };
    u++;
  }
  return {};
}
function Q2(t) {
  return t.replace(new RegExp("[".concat(pt, "]+"), "g"), " ").trim();
}
var e0 = /(\$\d)/;
function t0(t, e, n) {
  var r = n.useInternationalFormat, a = n.withNationalPrefix;
  n.carrierCode, n.metadata;
  var o = t.replace(new RegExp(e.pattern()), r ? e.internationalFormat() : (
    // This library doesn't use `domestic_carrier_code_formatting_rule`,
    // because that one is only used when formatting phone numbers
    // for dialing from a mobile phone, and this is not a dialing library.
    // carrierCode && format.domesticCarrierCodeFormattingRule()
    // 	// First, replace the $CC in the formatting rule with the desired carrier code.
    // 	// Then, replace the $FG in the formatting rule with the first group
    // 	// and the carrier code combined in the appropriate way.
    // 	? format.format().replace(FIRST_GROUP_PATTERN, format.domesticCarrierCodeFormattingRule().replace('$CC', carrierCode))
    // 	: (
    // 		withNationalPrefix && format.nationalPrefixFormattingRule()
    // 			? format.format().replace(FIRST_GROUP_PATTERN, format.nationalPrefixFormattingRule())
    // 			: format.format()
    // 	)
    a && e.nationalPrefixFormattingRule() ? e.format().replace(e0, e.nationalPrefixFormattingRule()) : e.format()
  ));
  return r ? Q2(o) : o;
}
var eg = /^[\d]+(?:[~\u2053\u223C\uFF5E][\d]+)?$/;
function tg(t, e, n) {
  var r = new He(n);
  if (r.selectNumberingPlan(t, e), r.defaultIDDPrefix())
    return r.defaultIDDPrefix();
  if (eg.test(r.IDDPrefix()))
    return r.IDDPrefix();
}
var ng = ";ext=", Bn = function(e) {
  return "([".concat(Qe, "]{1,").concat(e, "})");
};
function n0(t) {
  var e = "20", n = "15", r = "9", a = "6", o = "[  \\t,]*", l = "[:\\.．]?[  \\t,-]*", s = "#?", c = "(?:e?xt(?:ensi(?:ó?|ó))?n?|ｅ?ｘｔｎ?|доб|anexo)", d = "(?:[xｘ#＃~～]|int|ｉｎｔ)", u = "[- ]+", f = "[  \\t]*", m = "(?:,{2}|;)", g = ng + Bn(e), C = o + c + l + Bn(e) + s, b = o + d + l + Bn(r) + s, E = u + Bn(a) + "#", x = f + m + l + Bn(n) + s, _ = f + "(?:,)+" + l + Bn(r) + s;
  return g + "|" + C + "|" + b + "|" + E + "|" + x + "|" + _;
}
var rg = "[" + Qe + "]{" + Ns + "}", ag = "[" + Zi + "]{0,1}(?:[" + pt + "]*[" + Qe + "]){3,}[" + pt + Qe + "]*", ig = new RegExp("^[" + Zi + "]{0,1}(?:[" + pt + "]*[" + Qe + "]){1,2}$", "i"), og = ag + // Phone number extensions
"(?:" + n0() + ")?", lg = new RegExp(
  // Either a short two-digit-only phone number
  "^" + rg + "$|^" + og + "$",
  "i"
);
function sg(t) {
  return t.length >= Ns && lg.test(t);
}
function cg(t) {
  return ig.test(t);
}
function dg(t) {
  var e = t.number, n = t.ext;
  if (!e)
    return "";
  if (e[0] !== "+")
    throw new Error('"formatRFC3966()" expects "number" to be in E.164 format.');
  return "tel:".concat(e).concat(n ? ";ext=" + n : "");
}
var Jc = {
  formatExtension: function(e, n, r) {
    return "".concat(e).concat(r.ext()).concat(n);
  }
};
function ug(t, e, n, r) {
  if (n ? n = mg({}, Jc, n) : n = Jc, r = new He(r), t.country && t.country !== "001") {
    if (!r.hasCountry(t.country))
      throw new Error("Unknown country: ".concat(t.country));
    r.selectNumberingPlan(t.country);
  } else if (t.countryCallingCode)
    r.selectNumberingPlan(t.countryCallingCode);
  else return t.phone || "";
  var a = r.countryCallingCode(), o = n.v2 ? t.nationalNumber : t.phone, l;
  switch (e) {
    case "NATIONAL":
      return o ? (l = bi(o, t.carrierCode, "NATIONAL", r, n), Do(l, t.ext, r, n.formatExtension)) : "";
    case "INTERNATIONAL":
      return o ? (l = bi(o, null, "INTERNATIONAL", r, n), l = "+".concat(a, " ").concat(l), Do(l, t.ext, r, n.formatExtension)) : "+".concat(a);
    case "E.164":
      return "+".concat(a).concat(o);
    case "RFC3966":
      return dg({
        number: "+".concat(a).concat(o),
        ext: t.ext
      });
    // For reference, here's Google's IDD formatter:
    // https://github.com/google/libphonenumber/blob/32719cf74e68796788d1ca45abc85dcdc63ba5b9/java/libphonenumber/src/com/google/i18n/phonenumbers/PhoneNumberUtil.java#L1546
    // Not saying that this IDD formatter replicates it 1:1, but it seems to work.
    // Who would even need to format phone numbers in IDD format anyway?
    case "IDD":
      if (!n.fromCountry)
        return;
      var s = pg(o, t.carrierCode, a, n.fromCountry, r);
      return Do(s, t.ext, r, n.formatExtension);
    default:
      throw new Error('Unknown "format" argument passed to "formatNumber()": "'.concat(e, '"'));
  }
}
function bi(t, e, n, r, a) {
  var o = fg(r.formats(), t);
  return o ? t0(t, o, {
    useInternationalFormat: n === "INTERNATIONAL",
    withNationalPrefix: !(o.nationalPrefixIsOptionalWhenFormattingInNationalFormat() && a && a.nationalPrefix === !1),
    carrierCode: e,
    metadata: r
  }) : t;
}
function fg(t, e) {
  return hg(t, function(n) {
    if (n.leadingDigitsPatterns().length > 0) {
      var r = n.leadingDigitsPatterns()[n.leadingDigitsPatterns().length - 1];
      if (e.search(r) !== 0)
        return !1;
    }
    return Vt(e, n.pattern());
  });
}
function Do(t, e, n, r) {
  return e ? r(t, e, n) : t;
}
function pg(t, e, n, r, a) {
  var o = Wt(r, a.metadata);
  if (o === n) {
    var l = bi(t, e, "NATIONAL", a);
    return n === "1" ? n + " " + l : l;
  }
  var s = tg(r, void 0, a.metadata);
  if (s)
    return "".concat(s, " ").concat(n, " ").concat(bi(t, null, "INTERNATIONAL", a));
}
function mg() {
  for (var t = 1, e = arguments.length, n = new Array(e), r = 0; r < e; r++)
    n[r] = arguments[r];
  for (; t < n.length; ) {
    if (n[t])
      for (var a in n[t])
        n[0][a] = n[t][a];
    t++;
  }
  return n[0];
}
function hg(t, e) {
  for (var n = 0; n < t.length; ) {
    if (e(t[n]))
      return t[n];
    n++;
  }
}
function aa(t) {
  "@babel/helpers - typeof";
  return aa = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, aa(t);
}
function Qc(t, e) {
  var n = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(t);
    e && (r = r.filter(function(a) {
      return Object.getOwnPropertyDescriptor(t, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function e1(t) {
  for (var e = 1; e < arguments.length; e++) {
    var n = arguments[e] != null ? arguments[e] : {};
    e % 2 ? Qc(Object(n), !0).forEach(function(r) {
      vg(t, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : Qc(Object(n)).forEach(function(r) {
      Object.defineProperty(t, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return t;
}
function vg(t, e, n) {
  return (e = r0(e)) in t ? Object.defineProperty(t, e, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = n, t;
}
function gg(t, e) {
  if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
}
function yg(t, e) {
  for (var n = 0; n < e.length; n++) {
    var r = e[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r0(r.key), r);
  }
}
function bg(t, e, n) {
  return e && yg(t.prototype, e), Object.defineProperty(t, "prototype", { writable: !1 }), t;
}
function r0(t) {
  var e = Eg(t, "string");
  return aa(e) == "symbol" ? e : e + "";
}
function Eg(t, e) {
  if (aa(t) != "object" || !t) return t;
  var n = t[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(t, e);
    if (aa(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(t);
}
var a0 = /* @__PURE__ */ (function() {
  function t(e, n, r) {
    if (gg(this, t), !e)
      throw new TypeError("First argument is required");
    if (typeof e != "string")
      throw new TypeError("First argument must be a string");
    if (e[0] === "+" && !n)
      throw new TypeError("`metadata` argument not passed");
    if (wn(n) && wn(n.countries)) {
      r = n;
      var a = e;
      if (!xg.test(a))
        throw new Error('Invalid `number` argument passed: must consist of a "+" followed by digits');
      var o = Ts(a, void 0, void 0, void 0, r), l = o.countryCallingCode, s = o.number;
      if (n = s, e = l, !n)
        throw new Error("Invalid `number` argument passed: too short");
    }
    if (!n)
      throw new TypeError("`nationalNumber` argument is required");
    if (typeof n != "string")
      throw new TypeError("`nationalNumber` argument must be a string");
    G2(r);
    var c = $g(e, r), d = c.country, u = c.countryCallingCode;
    this.country = d, this.countryCallingCode = u, this.nationalNumber = n, this.number = "+" + this.countryCallingCode + this.nationalNumber, this.getMetadata = function() {
      return r;
    };
  }
  return bg(t, [{
    key: "setExt",
    value: function(n) {
      this.ext = n;
    }
  }, {
    key: "getPossibleCountries",
    value: function() {
      return this.country ? [this.country] : R9(this.countryCallingCode, this.nationalNumber, this.getMetadata());
    }
  }, {
    key: "isPossible",
    value: function() {
      return D9(this, {
        v2: !0
      }, this.getMetadata());
    }
  }, {
    key: "isValid",
    value: function() {
      return L9(this, {
        v2: !0
      }, this.getMetadata());
    }
  }, {
    key: "isNonGeographic",
    value: function() {
      var n = new He(this.getMetadata());
      return n.isNonGeographicCallingCode(this.countryCallingCode);
    }
  }, {
    key: "isEqual",
    value: function(n) {
      return this.number === n.number && this.ext === n.ext;
    }
    // This function was originally meant to be an equivalent for `validatePhoneNumberLength()`,
    // but later it was found out that it doesn't include the possible `TOO_SHORT` result
    // returned from `parsePhoneNumberWithError()` in the original `validatePhoneNumberLength()`,
    // so eventually I simply commented out this method from the `PhoneNumber` class
    // and just left the `validatePhoneNumberLength()` function, even though that one would require
    // and additional step to also validate the actual country / calling code of the phone number.
    // validateLength() {
    // 	const metadata = new Metadata(this.getMetadata())
    // 	metadata.selectNumberingPlan(this.countryCallingCode)
    // 	const result = checkNumberLength(this.nationalNumber, metadata)
    // 	if (result !== 'IS_POSSIBLE') {
    // 		return result
    // 	}
    // }
  }, {
    key: "getType",
    value: function() {
      return Ps(this, {
        v2: !0
      }, this.getMetadata());
    }
  }, {
    key: "format",
    value: function(n, r) {
      return ug(this, n, r ? e1(e1({}, r), {}, {
        v2: !0
      }) : {
        v2: !0
      }, this.getMetadata());
    }
  }, {
    key: "formatNational",
    value: function(n) {
      return this.format("NATIONAL", n);
    }
  }, {
    key: "formatInternational",
    value: function(n) {
      return this.format("INTERNATIONAL", n);
    }
  }, {
    key: "getURI",
    value: function(n) {
      return this.format("RFC3966", n);
    }
  }]);
})(), wg = function(e) {
  return /^[A-Z]{2}$/.test(e);
};
function $g(t, e) {
  var n, r, a = new He(e);
  return wg(t) ? (n = t, a.selectNumberingPlan(n), r = a.countryCallingCode()) : r = t, {
    country: n,
    countryCallingCode: r
  };
}
var xg = /^\+\d+$/;
function Pl(t) {
  "@babel/helpers - typeof";
  return Pl = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, Pl(t);
}
function Cg(t, e, n) {
  return Object.defineProperty(t, "prototype", { writable: !1 }), t;
}
function Mg(t, e) {
  if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
}
function Sg(t, e, n) {
  return e = oa(e), Fg(t, As() ? Reflect.construct(e, n || [], oa(t).constructor) : e.apply(t, n));
}
function Fg(t, e) {
  if (e && (Pl(e) == "object" || typeof e == "function")) return e;
  if (e !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
  return Pg(t);
}
function Pg(t) {
  if (t === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}
function Ng(t, e) {
  if (typeof e != "function" && e !== null) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && ia(t, e);
}
function Nl(t) {
  var e = typeof Map == "function" ? /* @__PURE__ */ new Map() : void 0;
  return Nl = function(r) {
    if (r === null || !Tg(r)) return r;
    if (typeof r != "function") throw new TypeError("Super expression must either be null or a function");
    if (e !== void 0) {
      if (e.has(r)) return e.get(r);
      e.set(r, a);
    }
    function a() {
      return _g(r, arguments, oa(this).constructor);
    }
    return a.prototype = Object.create(r.prototype, { constructor: { value: a, enumerable: !1, writable: !0, configurable: !0 } }), ia(a, r);
  }, Nl(t);
}
function _g(t, e, n) {
  if (As()) return Reflect.construct.apply(null, arguments);
  var r = [null];
  r.push.apply(r, e);
  var a = new (t.bind.apply(t, r))();
  return n && ia(a, n.prototype), a;
}
function As() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (As = function() {
    return !!t;
  })();
}
function Tg(t) {
  try {
    return Function.toString.call(t).indexOf("[native code]") !== -1;
  } catch {
    return typeof t == "function";
  }
}
function ia(t, e) {
  return ia = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, r) {
    return n.__proto__ = r, n;
  }, ia(t, e);
}
function oa(t) {
  return oa = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(e) {
    return e.__proto__ || Object.getPrototypeOf(e);
  }, oa(t);
}
var Dt = /* @__PURE__ */ (function(t) {
  function e(n) {
    var r;
    return Mg(this, e), r = Sg(this, e, [n]), Object.setPrototypeOf(r, e.prototype), r.name = r.constructor.name, r;
  }
  return Ng(e, t), Cg(e);
})(/* @__PURE__ */ Nl(Error)), t1 = new RegExp("(?:" + n0() + ")$", "i");
function Ag(t) {
  var e = t.search(t1);
  if (e < 0)
    return {};
  for (var n = t.slice(0, e), r = t.match(t1), a = 1; a < r.length; ) {
    if (r[a])
      return {
        number: n,
        ext: r[a]
      };
    a++;
  }
}
function zg(t, e) {
  var n = typeof Symbol < "u" && t[Symbol.iterator] || t["@@iterator"];
  if (n) return (n = n.call(t)).next.bind(n);
  if (Array.isArray(t) || (n = Dg(t)) || e) {
    n && (t = n);
    var r = 0;
    return function() {
      return r >= t.length ? { done: !0 } : { done: !1, value: t[r++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Dg(t, e) {
  if (t) {
    if (typeof t == "string") return n1(t, e);
    var n = {}.toString.call(t).slice(8, -1);
    return n === "Object" && t.constructor && (n = t.constructor.name), n === "Map" || n === "Set" ? Array.from(t) : n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? n1(t, e) : void 0;
  }
}
function n1(t, e) {
  (e == null || e > t.length) && (e = t.length);
  for (var n = 0, r = Array(e); n < e; n++) r[n] = t[n];
  return r;
}
var Ig = {
  0: "0",
  1: "1",
  2: "2",
  3: "3",
  4: "4",
  5: "5",
  6: "6",
  7: "7",
  8: "8",
  9: "9",
  "０": "0",
  // Fullwidth digit 0
  "１": "1",
  // Fullwidth digit 1
  "２": "2",
  // Fullwidth digit 2
  "３": "3",
  // Fullwidth digit 3
  "４": "4",
  // Fullwidth digit 4
  "５": "5",
  // Fullwidth digit 5
  "６": "6",
  // Fullwidth digit 6
  "７": "7",
  // Fullwidth digit 7
  "８": "8",
  // Fullwidth digit 8
  "９": "9",
  // Fullwidth digit 9
  "٠": "0",
  // Arabic-indic digit 0
  "١": "1",
  // Arabic-indic digit 1
  "٢": "2",
  // Arabic-indic digit 2
  "٣": "3",
  // Arabic-indic digit 3
  "٤": "4",
  // Arabic-indic digit 4
  "٥": "5",
  // Arabic-indic digit 5
  "٦": "6",
  // Arabic-indic digit 6
  "٧": "7",
  // Arabic-indic digit 7
  "٨": "8",
  // Arabic-indic digit 8
  "٩": "9",
  // Arabic-indic digit 9
  "۰": "0",
  // Eastern-Arabic digit 0
  "۱": "1",
  // Eastern-Arabic digit 1
  "۲": "2",
  // Eastern-Arabic digit 2
  "۳": "3",
  // Eastern-Arabic digit 3
  "۴": "4",
  // Eastern-Arabic digit 4
  "۵": "5",
  // Eastern-Arabic digit 5
  "۶": "6",
  // Eastern-Arabic digit 6
  "۷": "7",
  // Eastern-Arabic digit 7
  "۸": "8",
  // Eastern-Arabic digit 8
  "۹": "9"
  // Eastern-Arabic digit 9
};
function i0(t) {
  return Ig[t];
}
function Ei(t) {
  for (var e = "", n = zg(t.split("")), r; !(r = n()).done; ) {
    var a = r.value, o = i0(a);
    o && (e += o);
  }
  return e;
}
function kg(t, e) {
  var n = typeof Symbol < "u" && t[Symbol.iterator] || t["@@iterator"];
  if (n) return (n = n.call(t)).next.bind(n);
  if (Array.isArray(t) || (n = Og(t)) || e) {
    n && (t = n);
    var r = 0;
    return function() {
      return r >= t.length ? { done: !0 } : { done: !1, value: t[r++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Og(t, e) {
  if (t) {
    if (typeof t == "string") return r1(t, e);
    var n = {}.toString.call(t).slice(8, -1);
    return n === "Object" && t.constructor && (n = t.constructor.name), n === "Map" || n === "Set" ? Array.from(t) : n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? r1(t, e) : void 0;
  }
}
function r1(t, e) {
  (e == null || e > t.length) && (e = t.length);
  for (var n = 0, r = Array(e); n < e; n++) r[n] = t[n];
  return r;
}
function _l(t) {
  for (var e = "", n = kg(t.split("")), r; !(r = n()).done; ) {
    var a = r.value;
    e += o0(a, e) || "";
  }
  return e;
}
function o0(t, e, n) {
  if (t === "+") {
    if (e) {
      typeof n == "function" && n("end");
      return;
    }
    return "+";
  }
  return i0(t);
}
var l0 = "+", Lg = "[\\-\\.\\(\\)]?", a1 = "([" + Qe + "]|" + Lg + ")", Rg = "^\\" + l0 + a1 + "*[" + Qe + "]" + a1 + "*$", Hg = new RegExp(Rg, "g"), Tl = Qe, Bg = "[" + Tl + "]+((\\-)*[" + Tl + "])*", jg = "a-zA-Z", Vg = "[" + jg + "]+((\\-)*[" + Tl + "])*", Ug = "^(" + Bg + "\\.)*" + Vg + "\\.?$", Wg = new RegExp(Ug, "g"), i1 = "tel:", Al = ";phone-context=", Gg = ";isub=";
function Kg(t) {
  var e = t.indexOf(Al);
  if (e < 0)
    return null;
  var n = e + Al.length;
  if (n >= t.length)
    return "";
  var r = t.indexOf(";", n);
  return r >= 0 ? t.substring(n, r) : t.substring(n);
}
function qg(t) {
  return t === null ? !0 : t.length === 0 ? !1 : Hg.test(t) || Wg.test(t);
}
function Yg(t, e) {
  var n = e.extractFormattedPhoneNumber, r = Kg(t);
  if (!qg(r))
    throw new Dt("NOT_A_NUMBER");
  var a;
  if (r === null)
    a = n(t) || "";
  else {
    a = "", r.charAt(0) === l0 && (a += r);
    var o = t.indexOf(i1), l;
    o >= 0 ? l = o + i1.length : l = 0;
    var s = t.indexOf(Al);
    a += t.substring(l, s);
  }
  var c = a.indexOf(Gg);
  if (c > 0 && (a = a.substring(0, c)), a !== "")
    return a;
}
var Zg = 250, Xg = new RegExp("[" + Zi + Qe + "]"), Jg = new RegExp("[^" + Qe + "#]+$");
function Qg(t, e, n) {
  if (e = e || {}, n = new He(n), e.defaultCountry && !n.hasCountry(e.defaultCountry))
    throw e.v2 ? new Dt("INVALID_COUNTRY") : new Error("Unknown country: ".concat(e.defaultCountry));
  var r = ty(t, e.v2, e.extract), a = r.number, o = r.ext, l = r.error;
  if (!a) {
    if (e.v2)
      throw l === "TOO_SHORT" ? new Dt("TOO_SHORT") : new Dt("NOT_A_NUMBER");
    return {};
  }
  var s = ry(a, e.defaultCountry, e.defaultCallingCode, n), c = s.country, d = s.nationalNumber, u = s.countryCallingCode, f = s.countryCallingCodeSource, m = s.carrierCode;
  if (!n.hasSelectedNumberingPlan()) {
    if (e.v2)
      throw new Dt("INVALID_COUNTRY");
    return {};
  }
  if (!d || d.length < Ns) {
    if (e.v2)
      throw new Dt("TOO_SHORT");
    return {};
  }
  if (d.length > B9) {
    if (e.v2)
      throw new Dt("TOO_LONG");
    return {};
  }
  if (e.v2) {
    var g = new a0(u, d, n.metadata);
    return c && (g.country = c), m && (g.carrierCode = m), o && (g.ext = o), g.__countryCallingCodeSource = f, g;
  }
  var C = (e.extended ? n.hasSelectedNumberingPlan() : c) ? Vt(d, n.nationalNumberPattern()) : !1;
  return e.extended ? {
    country: c,
    countryCallingCode: u,
    carrierCode: m,
    valid: C,
    possible: C ? !0 : !!(e.extended === !0 && n.possibleLengths() && Y2(d, c, n)),
    phone: d,
    ext: o
  } : C ? ny(c, d, o) : {};
}
function ey(t, e, n) {
  if (t) {
    if (t.length > Zg) {
      if (n)
        throw new Dt("TOO_LONG");
      return;
    }
    if (e === !1)
      return t;
    var r = t.search(Xg);
    if (!(r < 0))
      return t.slice(r).replace(Jg, "");
  }
}
function ty(t, e, n) {
  var r = Yg(t, {
    extractFormattedPhoneNumber: function(l) {
      return ey(l, n, e);
    }
  });
  if (!r)
    return {};
  if (!sg(r))
    return cg(r) ? {
      error: "TOO_SHORT"
    } : {};
  var a = Ag(r);
  return a.ext ? a : {
    number: r
  };
}
function ny(t, e, n) {
  var r = {
    country: t,
    phone: e
  };
  return n && (r.ext = n), r;
}
function ry(t, e, n, r) {
  var a = Ts(_l(t), void 0, e, n, r.metadata), o = a.countryCallingCodeSource, l = a.countryCallingCode, s = a.number, c;
  if (l)
    r.selectNumberingPlan(l);
  else if (s && (e || n))
    r.selectNumberingPlan(e, n), e && (c = e), l = n || Wt(e, r.metadata);
  else return {};
  if (!s)
    return {
      countryCallingCodeSource: o,
      countryCallingCode: l
    };
  var d = Fl(_l(s), c, r), u = d.nationalNumber, f = d.carrierCode, m = _s(l, {
    nationalNumber: u,
    metadata: r
  });
  return m && (c = m, m === "001" || r.selectNumberingPlan(c)), {
    country: c,
    countryCallingCode: l,
    countryCallingCodeSource: o,
    nationalNumber: u,
    carrierCode: f
  };
}
function la(t) {
  "@babel/helpers - typeof";
  return la = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, la(t);
}
function o1(t, e) {
  var n = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(t);
    e && (r = r.filter(function(a) {
      return Object.getOwnPropertyDescriptor(t, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function l1(t) {
  for (var e = 1; e < arguments.length; e++) {
    var n = arguments[e] != null ? arguments[e] : {};
    e % 2 ? o1(Object(n), !0).forEach(function(r) {
      ay(t, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : o1(Object(n)).forEach(function(r) {
      Object.defineProperty(t, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return t;
}
function ay(t, e, n) {
  return (e = iy(e)) in t ? Object.defineProperty(t, e, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = n, t;
}
function iy(t) {
  var e = oy(t, "string");
  return la(e) == "symbol" ? e : e + "";
}
function oy(t, e) {
  if (la(t) != "object" || !t) return t;
  var n = t[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(t, e);
    if (la(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(t);
}
function ly(t, e, n) {
  return Qg(t, l1(l1({}, e), {}, {
    v2: !0
  }), n);
}
function sa(t) {
  "@babel/helpers - typeof";
  return sa = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, sa(t);
}
function s1(t, e) {
  var n = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(t);
    e && (r = r.filter(function(a) {
      return Object.getOwnPropertyDescriptor(t, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function sy(t) {
  for (var e = 1; e < arguments.length; e++) {
    var n = arguments[e] != null ? arguments[e] : {};
    e % 2 ? s1(Object(n), !0).forEach(function(r) {
      cy(t, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : s1(Object(n)).forEach(function(r) {
      Object.defineProperty(t, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return t;
}
function cy(t, e, n) {
  return (e = dy(e)) in t ? Object.defineProperty(t, e, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = n, t;
}
function dy(t) {
  var e = uy(t, "string");
  return sa(e) == "symbol" ? e : e + "";
}
function uy(t, e) {
  if (sa(t) != "object" || !t) return t;
  var n = t[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(t, e);
    if (sa(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(t);
}
function fy(t, e) {
  return vy(t) || hy(t, e) || my(t, e) || py();
}
function py() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function my(t, e) {
  if (t) {
    if (typeof t == "string") return c1(t, e);
    var n = {}.toString.call(t).slice(8, -1);
    return n === "Object" && t.constructor && (n = t.constructor.name), n === "Map" || n === "Set" ? Array.from(t) : n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? c1(t, e) : void 0;
  }
}
function c1(t, e) {
  (e == null || e > t.length) && (e = t.length);
  for (var n = 0, r = Array(e); n < e; n++) r[n] = t[n];
  return r;
}
function hy(t, e) {
  var n = t == null ? null : typeof Symbol < "u" && t[Symbol.iterator] || t["@@iterator"];
  if (n != null) {
    var r, a, o, l, s = [], c = !0, d = !1;
    try {
      if (o = (n = n.call(t)).next, e !== 0) for (; !(c = (r = o.call(n)).done) && (s.push(r.value), s.length !== e); c = !0) ;
    } catch (u) {
      d = !0, a = u;
    } finally {
      try {
        if (!c && n.return != null && (l = n.return(), Object(l) !== l)) return;
      } finally {
        if (d) throw a;
      }
    }
    return s;
  }
}
function vy(t) {
  if (Array.isArray(t)) return t;
}
function gy(t) {
  var e = Array.prototype.slice.call(t), n = fy(e, 4), r = n[0], a = n[1], o = n[2], l = n[3], s, c, d;
  if (typeof r == "string")
    s = r;
  else throw new TypeError("A text for parsing must be a string.");
  if (!a || typeof a == "string")
    l ? (c = o, d = l) : (c = void 0, d = o), a && (c = sy({
      defaultCountry: a
    }, c));
  else if (wn(a))
    o ? (c = a, d = o) : d = a;
  else throw new Error("Invalid second argument: ".concat(a));
  return {
    text: s,
    options: c,
    metadata: d
  };
}
function ca(t) {
  "@babel/helpers - typeof";
  return ca = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, ca(t);
}
function d1(t, e) {
  var n = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(t);
    e && (r = r.filter(function(a) {
      return Object.getOwnPropertyDescriptor(t, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function u1(t) {
  for (var e = 1; e < arguments.length; e++) {
    var n = arguments[e] != null ? arguments[e] : {};
    e % 2 ? d1(Object(n), !0).forEach(function(r) {
      yy(t, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : d1(Object(n)).forEach(function(r) {
      Object.defineProperty(t, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return t;
}
function yy(t, e, n) {
  return (e = by(e)) in t ? Object.defineProperty(t, e, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = n, t;
}
function by(t) {
  var e = Ey(t, "string");
  return ca(e) == "symbol" ? e : e + "";
}
function Ey(t, e) {
  if (ca(t) != "object" || !t) return t;
  var n = t[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(t, e);
    if (ca(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(t);
}
function wy(t, e, n) {
  e && e.defaultCountry && !K2(e.defaultCountry, n) && (e = u1(u1({}, e), {}, {
    defaultCountry: void 0
  }));
  try {
    return ly(t, e, n);
  } catch (r) {
    if (!(r instanceof Dt)) throw r;
  }
}
function $y() {
  var t = gy(arguments), e = t.text, n = t.options, r = t.metadata;
  return wy(e, n, r);
}
function da(t) {
  "@babel/helpers - typeof";
  return da = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, da(t);
}
function xy(t, e) {
  if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
}
function Cy(t, e) {
  for (var n = 0; n < e.length; n++) {
    var r = e[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, Sy(r.key), r);
  }
}
function My(t, e, n) {
  return e && Cy(t.prototype, e), Object.defineProperty(t, "prototype", { writable: !1 }), t;
}
function Sy(t) {
  var e = Fy(t, "string");
  return da(e) == "symbol" ? e : e + "";
}
function Fy(t, e) {
  if (da(t) != "object" || !t) return t;
  var n = t[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(t, e);
    if (da(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(t);
}
var Py = /* @__PURE__ */ (function() {
  function t(e) {
    var n = e.onCountryChange, r = e.onCallingCodeChange;
    xy(this, t), this.onCountryChange = n, this.onCallingCodeChange = r;
  }
  return My(t, [{
    key: "reset",
    value: function(n) {
      var r = n.country, a = n.callingCode;
      this.international = !1, this.missingPlus = !1, this.IDDPrefix = void 0, this.callingCode = void 0, this.digits = "", this.resetNationalSignificantNumber(), this.initCountryAndCallingCode(r, a);
    }
  }, {
    key: "resetNationalSignificantNumber",
    value: function() {
      this.nationalSignificantNumber = this.getNationalDigits(), this.nationalSignificantNumberIsModified = !1, this.nationalPrefix = void 0, this.carrierCode = void 0, this.prefixBeforeNationalSignificantNumberThatIsNotNationalPrefix = void 0;
    }
  }, {
    key: "update",
    value: function(n) {
      for (var r = 0, a = Object.keys(n); r < a.length; r++) {
        var o = a[r];
        this[o] = n[o];
      }
    }
  }, {
    key: "initCountryAndCallingCode",
    value: function(n, r) {
      this.setCountry(n), this.setCallingCode(r);
    }
  }, {
    key: "setCountry",
    value: function(n) {
      this.country = n, this.onCountryChange(n);
    }
  }, {
    key: "setCallingCode",
    value: function(n) {
      this.callingCode = n, this.onCallingCodeChange(n, this.country);
    }
  }, {
    key: "startInternationalNumber",
    value: function(n, r) {
      this.international = !0, this.initCountryAndCallingCode(n, r);
    }
  }, {
    key: "appendDigits",
    value: function(n) {
      this.digits += n;
    }
  }, {
    key: "appendNationalSignificantNumberDigits",
    value: function(n) {
      this.nationalSignificantNumber += n;
    }
    /**
     * Returns the part of `this.digits` that corresponds to the national number.
     * Basically, all digits that have been input by the user, except for the
     * international prefix and the country calling code part
     * (if the number is an international one).
     * @return {string}
     */
  }, {
    key: "getNationalDigits",
    value: function() {
      return this.international ? this.digits.slice((this.IDDPrefix ? this.IDDPrefix.length : 0) + (this.callingCode ? this.callingCode.length : 0)) : this.digits;
    }
  }, {
    key: "getDigitsWithoutInternationalPrefix",
    value: function() {
      return this.international && this.IDDPrefix ? this.digits.slice(this.IDDPrefix.length) : this.digits;
    }
  }]);
})();
function Ny(t, e) {
  var n = typeof Symbol < "u" && t[Symbol.iterator] || t["@@iterator"];
  if (n) return (n = n.call(t)).next.bind(n);
  if (Array.isArray(t) || (n = _y(t)) || e) {
    n && (t = n);
    var r = 0;
    return function() {
      return r >= t.length ? { done: !0 } : { done: !1, value: t[r++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _y(t, e) {
  if (t) {
    if (typeof t == "string") return f1(t, e);
    var n = {}.toString.call(t).slice(8, -1);
    return n === "Object" && t.constructor && (n = t.constructor.name), n === "Map" || n === "Set" ? Array.from(t) : n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? f1(t, e) : void 0;
  }
}
function f1(t, e) {
  (e == null || e > t.length) && (e = t.length);
  for (var n = 0, r = Array(e); n < e; n++) r[n] = t[n];
  return r;
}
var ct = "x", Io = new RegExp(ct);
function ti(t, e) {
  if (e < 1)
    return "";
  for (var n = ""; e > 1; )
    e & 1 && (n += t), e >>= 1, t += t;
  return n + t;
}
function p1(t, e) {
  return t[e] === ")" && e++, Ty(t.slice(0, e));
}
function Ty(t) {
  for (var e = [], n = 0; n < t.length; )
    t[n] === "(" ? e.push(n) : t[n] === ")" && e.pop(), n++;
  var r = 0, a = "";
  e.push(t.length);
  for (var o = 0, l = e; o < l.length; o++) {
    var s = l[o];
    a += t.slice(r, s), r = s + 1;
  }
  return a;
}
function Ay(t, e, n) {
  for (var r = Ny(n.split("")), a; !(a = r()).done; ) {
    var o = a.value;
    if (t.slice(e + 1).search(Io) < 0)
      return;
    e = t.search(Io), t = t.replace(Io, o);
  }
  return [t, e];
}
function zy(t, e, n) {
  var r = n.metadata, a = n.shouldTryNationalPrefixFormattingRule, o = n.getSeparatorAfterNationalPrefix, l = new RegExp("^(?:".concat(e.pattern(), ")$"));
  if (l.test(t.nationalSignificantNumber))
    return Iy(t, e, {
      metadata: r,
      shouldTryNationalPrefixFormattingRule: a,
      getSeparatorAfterNationalPrefix: o
    });
}
function Dy(t, e, n) {
  return Yi(t, e, n) === "IS_POSSIBLE";
}
function Iy(t, e, n) {
  var r = n.metadata, a = n.shouldTryNationalPrefixFormattingRule, o = n.getSeparatorAfterNationalPrefix;
  if (t.nationalSignificantNumber, t.international, t.nationalPrefix, t.carrierCode, a(e)) {
    var l = m1(t, e, {
      useNationalPrefixFormattingRule: !0,
      getSeparatorAfterNationalPrefix: o,
      metadata: r
    });
    if (l)
      return l;
  }
  return m1(t, e, {
    useNationalPrefixFormattingRule: !1,
    getSeparatorAfterNationalPrefix: o,
    metadata: r
  });
}
function m1(t, e, n) {
  var r = n.metadata, a = n.useNationalPrefixFormattingRule, o = n.getSeparatorAfterNationalPrefix, l = t0(t.nationalSignificantNumber, e, {
    carrierCode: t.carrierCode,
    useInternationalFormat: t.international,
    withNationalPrefix: a,
    metadata: r
  });
  if (a || (t.nationalPrefix ? l = t.nationalPrefix + o(e) + l : t.prefixBeforeNationalSignificantNumberThatIsNotNationalPrefix && (l = t.prefixBeforeNationalSignificantNumberThatIsNotNationalPrefix + " " + l)), ky(l, t))
    return l;
}
function ky(t, e) {
  return Ei(t) === e.getNationalDigits();
}
function ua(t) {
  "@babel/helpers - typeof";
  return ua = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, ua(t);
}
function Oy(t, e) {
  if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
}
function Ly(t, e) {
  for (var n = 0; n < e.length; n++) {
    var r = e[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, Hy(r.key), r);
  }
}
function Ry(t, e, n) {
  return e && Ly(t.prototype, e), Object.defineProperty(t, "prototype", { writable: !1 }), t;
}
function Hy(t) {
  var e = By(t, "string");
  return ua(e) == "symbol" ? e : e + "";
}
function By(t, e) {
  if (ua(t) != "object" || !t) return t;
  var n = t[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(t, e);
    if (ua(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(t);
}
var jy = /* @__PURE__ */ (function() {
  function t() {
    Oy(this, t);
  }
  return Ry(t, [{
    key: "parse",
    value: function(n) {
      if (this.context = [{
        or: !0,
        instructions: []
      }], this.parsePattern(n), this.context.length !== 1)
        throw new Error("Non-finalized contexts left when pattern parse ended");
      var r = this.context[0], a = r.branches, o = r.instructions;
      if (a)
        return {
          op: "|",
          args: a.concat([ko(o)])
        };
      if (o.length === 0)
        throw new Error("Pattern is required");
      return o.length === 1 ? o[0] : o;
    }
  }, {
    key: "startContext",
    value: function(n) {
      this.context.push(n);
    }
  }, {
    key: "endContext",
    value: function() {
      this.context.pop();
    }
  }, {
    key: "getContext",
    value: function() {
      return this.context[this.context.length - 1];
    }
  }, {
    key: "parsePattern",
    value: function(n) {
      if (!n)
        throw new Error("Pattern is required");
      var r = n.match(Wy);
      if (!r) {
        if (Uy.test(n))
          throw new Error("Illegal characters found in a pattern: ".concat(n));
        this.getContext().instructions = this.getContext().instructions.concat(n.split(""));
        return;
      }
      var a = r[1], o = n.slice(0, r.index), l = n.slice(r.index + a.length);
      switch (a) {
        case "(?:":
          o && this.parsePattern(o), this.startContext({
            or: !0,
            instructions: [],
            branches: []
          });
          break;
        case ")":
          if (!this.getContext().or)
            throw new Error('")" operator must be preceded by "(?:" operator');
          if (o && this.parsePattern(o), this.getContext().instructions.length === 0)
            throw new Error('No instructions found after "|" operator in an "or" group');
          var s = this.getContext(), c = s.branches;
          c.push(ko(this.getContext().instructions)), this.endContext(), this.getContext().instructions.push({
            op: "|",
            args: c
          });
          break;
        case "|":
          if (!this.getContext().or)
            throw new Error('"|" operator can only be used inside "or" groups');
          if (o && this.parsePattern(o), !this.getContext().branches)
            if (this.context.length === 1)
              this.getContext().branches = [];
            else
              throw new Error('"branches" not found in an "or" group context');
          this.getContext().branches.push(ko(this.getContext().instructions)), this.getContext().instructions = [];
          break;
        case "[":
          o && this.parsePattern(o), this.startContext({
            oneOfSet: !0
          });
          break;
        case "]":
          if (!this.getContext().oneOfSet)
            throw new Error('"]" operator must be preceded by "[" operator');
          this.endContext(), this.getContext().instructions.push({
            op: "[]",
            args: Vy(o)
          });
          break;
        /* istanbul ignore next */
        default:
          throw new Error("Unknown operator: ".concat(a));
      }
      l && this.parsePattern(l);
    }
  }]);
})();
function Vy(t) {
  for (var e = [], n = 0; n < t.length; ) {
    if (t[n] === "-") {
      if (n === 0 || n === t.length - 1)
        throw new Error("Couldn't parse a one-of set pattern: ".concat(t));
      for (var r = t[n - 1].charCodeAt(0) + 1, a = t[n + 1].charCodeAt(0) - 1, o = r; o <= a; )
        e.push(String.fromCharCode(o)), o++;
    } else
      e.push(t[n]);
    n++;
  }
  return e;
}
var Uy = /[\(\)\[\]\?\:\|]/, Wy = new RegExp(
  // any of:
  "(\\||\\(\\?\\:|\\)|\\[|\\])"
);
function ko(t) {
  return t.length === 1 ? t[0] : t;
}
function h1(t, e) {
  var n = typeof Symbol < "u" && t[Symbol.iterator] || t["@@iterator"];
  if (n) return (n = n.call(t)).next.bind(n);
  if (Array.isArray(t) || (n = Gy(t)) || e) {
    n && (t = n);
    var r = 0;
    return function() {
      return r >= t.length ? { done: !0 } : { done: !1, value: t[r++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Gy(t, e) {
  if (t) {
    if (typeof t == "string") return v1(t, e);
    var n = {}.toString.call(t).slice(8, -1);
    return n === "Object" && t.constructor && (n = t.constructor.name), n === "Map" || n === "Set" ? Array.from(t) : n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? v1(t, e) : void 0;
  }
}
function v1(t, e) {
  (e == null || e > t.length) && (e = t.length);
  for (var n = 0, r = Array(e); n < e; n++) r[n] = t[n];
  return r;
}
function fa(t) {
  "@babel/helpers - typeof";
  return fa = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, fa(t);
}
function Ky(t, e) {
  if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
}
function qy(t, e) {
  for (var n = 0; n < e.length; n++) {
    var r = e[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, Zy(r.key), r);
  }
}
function Yy(t, e, n) {
  return e && qy(t.prototype, e), Object.defineProperty(t, "prototype", { writable: !1 }), t;
}
function Zy(t) {
  var e = Xy(t, "string");
  return fa(e) == "symbol" ? e : e + "";
}
function Xy(t, e) {
  if (fa(t) != "object" || !t) return t;
  var n = t[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(t, e);
    if (fa(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(t);
}
var Jy = /* @__PURE__ */ (function() {
  function t(e) {
    Ky(this, t), this.matchTree = new jy().parse(e);
  }
  return Yy(t, [{
    key: "match",
    value: function(n) {
      var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, a = r.allowOverflow;
      if (!n)
        throw new Error("String is required");
      var o = zl(n.split(""), this.matchTree, !0);
      if (o && o.match && delete o.matchedChars, !(o && o.overflow && !a))
        return o;
    }
  }]);
})();
function zl(t, e, n) {
  if (typeof e == "string") {
    var r = t.join("");
    return e.indexOf(r) === 0 ? t.length === e.length ? {
      match: !0,
      matchedChars: t
    } : {
      partialMatch: !0
      // matchedChars: characters
    } : r.indexOf(e) === 0 ? n && t.length > e.length ? {
      overflow: !0
    } : {
      match: !0,
      matchedChars: t.slice(0, e.length)
    } : void 0;
  }
  if (Array.isArray(e)) {
    for (var a = t.slice(), o = 0; o < e.length; ) {
      var l = e[o], s = zl(a, l, n && o === e.length - 1);
      if (s) {
        if (s.overflow)
          return s;
        if (s.match) {
          if (a = a.slice(s.matchedChars.length), a.length === 0)
            return o === e.length - 1 ? {
              match: !0,
              matchedChars: t
            } : {
              partialMatch: !0
              // matchedChars: characters
            };
        } else {
          if (s.partialMatch)
            return {
              partialMatch: !0
              // matchedChars: characters
            };
          throw new Error(`Unsupported match result:
`.concat(JSON.stringify(s, null, 2)));
        }
      } else return;
      o++;
    }
    return n ? {
      overflow: !0
    } : {
      match: !0,
      matchedChars: t.slice(0, t.length - a.length)
    };
  }
  switch (e.op) {
    case "|":
      for (var c, d = h1(e.args), u; !(u = d()).done; ) {
        var f = u.value, m = zl(t, f, n);
        if (m) {
          if (m.overflow)
            return m;
          if (m.match)
            return {
              match: !0,
              matchedChars: m.matchedChars
            };
          if (m.partialMatch)
            c = !0;
          else
            throw new Error(`Unsupported match result:
`.concat(JSON.stringify(m, null, 2)));
        }
      }
      return c ? {
        partialMatch: !0
        // matchedChars: ...
      } : void 0;
    case "[]":
      for (var g = h1(e.args), C; !(C = g()).done; ) {
        var b = C.value;
        if (t[0] === b)
          return t.length === 1 ? {
            match: !0,
            matchedChars: t
          } : n ? {
            overflow: !0
          } : {
            match: !0,
            matchedChars: [b]
          };
      }
      return;
    /* istanbul ignore next */
    default:
      throw new Error("Unsupported instruction tree: ".concat(e));
  }
}
function pa(t) {
  "@babel/helpers - typeof";
  return pa = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, pa(t);
}
function g1(t, e) {
  var n = typeof Symbol < "u" && t[Symbol.iterator] || t["@@iterator"];
  if (n) return (n = n.call(t)).next.bind(n);
  if (Array.isArray(t) || (n = Qy(t)) || e) {
    n && (t = n);
    var r = 0;
    return function() {
      return r >= t.length ? { done: !0 } : { done: !1, value: t[r++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Qy(t, e) {
  if (t) {
    if (typeof t == "string") return y1(t, e);
    var n = {}.toString.call(t).slice(8, -1);
    return n === "Object" && t.constructor && (n = t.constructor.name), n === "Map" || n === "Set" ? Array.from(t) : n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? y1(t, e) : void 0;
  }
}
function y1(t, e) {
  (e == null || e > t.length) && (e = t.length);
  for (var n = 0, r = Array(e); n < e; n++) r[n] = t[n];
  return r;
}
function eb(t, e) {
  if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
}
function tb(t, e) {
  for (var n = 0; n < e.length; n++) {
    var r = e[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, rb(r.key), r);
  }
}
function nb(t, e, n) {
  return e && tb(t.prototype, e), Object.defineProperty(t, "prototype", { writable: !1 }), t;
}
function rb(t) {
  var e = ab(t, "string");
  return pa(e) == "symbol" ? e : e + "";
}
function ab(t, e) {
  if (pa(t) != "object" || !t) return t;
  var n = t[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(t, e);
    if (pa(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(t);
}
var Dl = "9", ib = 15, ob = ti(Dl, ib), lb = /[- ]/, sb = function() {
  return /\[([^\[\]])*\]/g;
}, cb = function() {
  return /\d(?=[^,}][^,}])/g;
}, db = new RegExp("[" + pt + "]*\\$1[" + pt + "]*(\\$\\d[" + pt + "]*)*$"), b1 = 3, ub = /* @__PURE__ */ (function() {
  function t(e) {
    e.state;
    var n = e.metadata;
    eb(this, t), this.metadata = n, this.resetFormat();
  }
  return nb(t, [{
    key: "resetFormat",
    value: function() {
      this.chosenFormat = void 0, this.template = void 0, this.nationalNumberTemplate = void 0, this.populatedNationalNumberTemplate = void 0, this.populatedNationalNumberTemplatePosition = -1;
    }
  }, {
    key: "reset",
    value: function(n, r) {
      this.resetFormat(), n ? (this.isNANP = n.callingCode() === "1", this.matchingFormats = n.formats(), r.nationalSignificantNumber && this.narrowDownMatchingFormats(r)) : (this.isNANP = void 0, this.matchingFormats = []);
    }
    /**
     * Formats an updated phone number.
     * @param  {string} nextDigits — Additional phone number digits.
     * @param  {object} state — `AsYouType` state.
     * @return {[string]} Returns undefined if the updated phone number can't be formatted using any of the available formats.
     */
  }, {
    key: "format",
    value: function(n, r) {
      var a = this;
      if (Dy(r.nationalSignificantNumber, r.country, this.metadata))
        for (var o = g1(this.matchingFormats), l; !(l = o()).done; ) {
          var s = l.value, c = zy(r, s, {
            metadata: this.metadata,
            shouldTryNationalPrefixFormattingRule: function(u) {
              return a.shouldTryNationalPrefixFormattingRule(u, {
                international: r.international,
                nationalPrefix: r.nationalPrefix
              });
            },
            getSeparatorAfterNationalPrefix: function(u) {
              return a.getSeparatorAfterNationalPrefix(u);
            }
          });
          if (c)
            return this.resetFormat(), this.chosenFormat = s, this.setNationalNumberTemplate(c.replace(/\d/g, ct), r), this.populatedNationalNumberTemplate = c, this.populatedNationalNumberTemplatePosition = this.template.lastIndexOf(ct), c;
        }
      return this.formatNationalNumberWithNextDigits(n, r);
    }
    // Formats the next phone number digits.
  }, {
    key: "formatNationalNumberWithNextDigits",
    value: function(n, r) {
      var a = this.chosenFormat, o = this.chooseFormat(r);
      if (o)
        return o === a ? this.formatNextNationalNumberDigits(n) : this.formatNextNationalNumberDigits(r.getNationalDigits());
    }
  }, {
    key: "narrowDownMatchingFormats",
    value: function(n) {
      var r = this, a = n.nationalSignificantNumber, o = n.nationalPrefix, l = n.international, s = a, c = s.length - b1;
      c < 0 && (c = 0), this.matchingFormats = this.matchingFormats.filter(function(d) {
        return r.formatSuits(d, l, o) && r.formatMatches(d, s, c);
      }), this.chosenFormat && this.matchingFormats.indexOf(this.chosenFormat) === -1 && this.resetFormat();
    }
  }, {
    key: "formatSuits",
    value: function(n, r, a) {
      return !(a && !n.usesNationalPrefix() && // !format.domesticCarrierCodeFormattingRule() &&
      !n.nationalPrefixIsOptionalWhenFormattingInNationalFormat() || !r && !a && n.nationalPrefixIsMandatoryWhenFormattingInNationalFormat());
    }
  }, {
    key: "formatMatches",
    value: function(n, r, a) {
      var o = n.leadingDigitsPatterns().length;
      if (o === 0)
        return !0;
      a = Math.min(a, o - 1);
      var l = n.leadingDigitsPatterns()[a];
      if (r.length < b1)
        try {
          return new Jy(l).match(r, {
            allowOverflow: !0
          }) !== void 0;
        } catch (s) {
          return console.error(s), !0;
        }
      return new RegExp("^(".concat(l, ")")).test(r);
    }
  }, {
    key: "getFormatFormat",
    value: function(n, r) {
      return r ? n.internationalFormat() : n.format();
    }
  }, {
    key: "chooseFormat",
    value: function(n) {
      for (var r = this, a = function() {
        var d = s.value;
        return r.chosenFormat === d ? 0 : db.test(r.getFormatFormat(d, n.international)) ? r.createTemplateForFormat(d, n) ? (r.chosenFormat = d, 0) : (r.matchingFormats = r.matchingFormats.filter(function(u) {
          return u !== d;
        }), 1) : 1;
      }, o, l = g1(this.matchingFormats.slice()), s; !(s = l()).done && (o = a(), o !== 0); )
        ;
      return this.chosenFormat || this.resetFormat(), this.chosenFormat;
    }
  }, {
    key: "createTemplateForFormat",
    value: function(n, r) {
      if (!(n.pattern().indexOf("|") >= 0)) {
        var a = this.getTemplateForFormat(n, r);
        if (a)
          return this.setNationalNumberTemplate(a, r), !0;
      }
    }
  }, {
    key: "getSeparatorAfterNationalPrefix",
    value: function(n) {
      return this.isNANP || n && n.nationalPrefixFormattingRule() && lb.test(n.nationalPrefixFormattingRule()) ? " " : "";
    }
  }, {
    key: "getInternationalPrefixBeforeCountryCallingCode",
    value: function(n, r) {
      var a = n.IDDPrefix, o = n.missingPlus;
      return a ? r && r.spacing === !1 ? a : a + " " : o ? "" : "+";
    }
  }, {
    key: "getTemplate",
    value: function(n) {
      if (this.template) {
        for (var r = -1, a = 0, o = n.international ? this.getInternationalPrefixBeforeCountryCallingCode(n, {
          spacing: !1
        }) : ""; a < o.length + n.getDigitsWithoutInternationalPrefix().length; )
          r = this.template.indexOf(ct, r + 1), a++;
        return p1(this.template, r + 1);
      }
    }
  }, {
    key: "setNationalNumberTemplate",
    value: function(n, r) {
      this.nationalNumberTemplate = n, this.populatedNationalNumberTemplate = n, this.populatedNationalNumberTemplatePosition = -1, r.international ? this.template = this.getInternationalPrefixBeforeCountryCallingCode(r).replace(/[\d\+]/g, ct) + ti(ct, r.callingCode.length) + " " + n : this.template = n;
    }
    /**
     * Generates formatting template for a national phone number,
     * optionally containing a national prefix, for a format.
     * @param  {Format} format
     * @param  {string} nationalPrefix
     * @return {string}
     */
  }, {
    key: "getTemplateForFormat",
    value: function(n, r) {
      var a = r.nationalSignificantNumber, o = r.international, l = r.nationalPrefix, s = r.prefixBeforeNationalSignificantNumberThatIsNotNationalPrefix, c = n.pattern();
      c = c.replace(sb(), "\\d").replace(cb(), "\\d");
      var d = ob.match(c)[0];
      if (!(a.length > d.length)) {
        var u = new RegExp("^" + c + "$"), f = a.replace(/\d/g, Dl);
        u.test(f) && (d = f);
        var m = this.getFormatFormat(n, o), g;
        if (this.shouldTryNationalPrefixFormattingRule(n, {
          international: o,
          nationalPrefix: l
        })) {
          var C = m.replace(e0, n.nationalPrefixFormattingRule());
          if (Ei(n.nationalPrefixFormattingRule()) === (l || "") + Ei("$1") && (m = C, g = !0, l))
            for (var b = l.length; b > 0; )
              m = m.replace(/\d/, ct), b--;
        }
        var E = d.replace(new RegExp(c), m).replace(new RegExp(Dl, "g"), ct);
        return g || (s ? E = ti(ct, s.length) + " " + E : l && (E = ti(ct, l.length) + this.getSeparatorAfterNationalPrefix(n) + E)), o && (E = Q2(E)), E;
      }
    }
  }, {
    key: "formatNextNationalNumberDigits",
    value: function(n) {
      var r = Ay(this.populatedNationalNumberTemplate, this.populatedNationalNumberTemplatePosition, n);
      if (!r) {
        this.resetFormat();
        return;
      }
      return this.populatedNationalNumberTemplate = r[0], this.populatedNationalNumberTemplatePosition = r[1], p1(this.populatedNationalNumberTemplate, this.populatedNationalNumberTemplatePosition + 1);
    }
  }, {
    key: "shouldTryNationalPrefixFormattingRule",
    value: function(n, r) {
      var a = r.international, o = r.nationalPrefix;
      if (n.nationalPrefixFormattingRule()) {
        var l = n.usesNationalPrefix();
        if (l && o || !l && !a)
          return !0;
      }
    }
  }]);
})();
function ma(t) {
  "@babel/helpers - typeof";
  return ma = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, ma(t);
}
function s0(t, e) {
  return hb(t) || mb(t, e) || pb(t, e) || fb();
}
function fb() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function pb(t, e) {
  if (t) {
    if (typeof t == "string") return E1(t, e);
    var n = {}.toString.call(t).slice(8, -1);
    return n === "Object" && t.constructor && (n = t.constructor.name), n === "Map" || n === "Set" ? Array.from(t) : n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? E1(t, e) : void 0;
  }
}
function E1(t, e) {
  (e == null || e > t.length) && (e = t.length);
  for (var n = 0, r = Array(e); n < e; n++) r[n] = t[n];
  return r;
}
function mb(t, e) {
  var n = t == null ? null : typeof Symbol < "u" && t[Symbol.iterator] || t["@@iterator"];
  if (n != null) {
    var r, a, o, l, s = [], c = !0, d = !1;
    try {
      if (o = (n = n.call(t)).next, e !== 0) for (; !(c = (r = o.call(n)).done) && (s.push(r.value), s.length !== e); c = !0) ;
    } catch (u) {
      d = !0, a = u;
    } finally {
      try {
        if (!c && n.return != null && (l = n.return(), Object(l) !== l)) return;
      } finally {
        if (d) throw a;
      }
    }
    return s;
  }
}
function hb(t) {
  if (Array.isArray(t)) return t;
}
function vb(t, e) {
  if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
}
function gb(t, e) {
  for (var n = 0; n < e.length; n++) {
    var r = e[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, bb(r.key), r);
  }
}
function yb(t, e, n) {
  return e && gb(t.prototype, e), Object.defineProperty(t, "prototype", { writable: !1 }), t;
}
function bb(t) {
  var e = Eb(t, "string");
  return ma(e) == "symbol" ? e : e + "";
}
function Eb(t, e) {
  if (ma(t) != "object" || !t) return t;
  var n = t[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(t, e);
    if (ma(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(t);
}
var wb = "[" + pt + Qe + "]+", $b = new RegExp("^" + wb + "$", "i"), xb = "(?:[" + Zi + "][" + pt + Qe + "]*|[" + pt + Qe + "]+)", Cb = new RegExp("[^" + pt + Qe + "]+.*$"), Mb = /[^\d\[\]]/, Sb = /* @__PURE__ */ (function() {
  function t(e) {
    var n = e.defaultCountry, r = e.defaultCallingCode, a = e.metadata, o = e.onNationalSignificantNumberChange;
    vb(this, t), this.defaultCountry = n, this.defaultCallingCode = r, this.metadata = a, this.onNationalSignificantNumberChange = o;
  }
  return yb(t, [{
    key: "input",
    value: function(n, r) {
      var a = Nb(n), o = s0(a, 2), l = o[0], s = o[1], c = Ei(l), d;
      return s && (r.digits || (r.startInternationalNumber(void 0, void 0), c || (d = !0))), c && this.inputDigits(c, r), {
        digits: c,
        justLeadingPlus: d
      };
    }
    /**
     * Inputs "next" phone number digits.
     * @param  {string} digits
     * @return {string} [formattedNumber] Formatted national phone number (if it can be formatted at this stage). Returning `undefined` means "don't format the national phone number at this stage".
     */
  }, {
    key: "inputDigits",
    value: function(n, r) {
      var a = r.digits, o = a.length < 3 && a.length + n.length >= 3;
      if (r.appendDigits(n), o && this.extractIddPrefix(r), this.isWaitingForCountryCallingCode(r)) {
        if (!this.extractCountryCallingCode(r))
          return;
      } else
        r.appendNationalSignificantNumberDigits(n);
      r.international || this.hasExtractedNationalSignificantNumber || this.extractNationalSignificantNumber(r.getNationalDigits(), function(l) {
        return r.update(l);
      });
    }
  }, {
    key: "isWaitingForCountryCallingCode",
    value: function(n) {
      var r = n.international, a = n.callingCode;
      return r && !a;
    }
    // Extracts a country calling code from a number
    // being entered in internatonal format.
  }, {
    key: "extractCountryCallingCode",
    value: function(n) {
      var r = Ts("+" + n.getDigitsWithoutInternationalPrefix(), n.country, this.defaultCountry, this.defaultCallingCode, this.metadata.metadata), a = r.countryCallingCode, o = r.number;
      if (a)
        return n.setCallingCode(a), n.update({
          nationalSignificantNumber: o
        }), !0;
    }
  }, {
    key: "reset",
    value: function(n) {
      if (n) {
        this.hasSelectedNumberingPlan = !0;
        var r = n._nationalPrefixForParsing();
        this.couldPossiblyExtractAnotherNationalSignificantNumber = r && Mb.test(r);
      } else
        this.hasSelectedNumberingPlan = void 0, this.couldPossiblyExtractAnotherNationalSignificantNumber = void 0;
    }
    /**
     * Extracts a national (significant) number from user input.
     * Google's library is different in that it only applies `national_prefix_for_parsing`
     * and doesn't apply `national_prefix_transform_rule` after that.
     * https://github.com/google/libphonenumber/blob/a3d70b0487875475e6ad659af404943211d26456/java/libphonenumber/src/com/google/i18n/phonenumbers/AsYouTypeFormatter.java#L539
     * @return {boolean} [extracted]
     */
  }, {
    key: "extractNationalSignificantNumber",
    value: function(n, r) {
      if (this.hasSelectedNumberingPlan) {
        var a = Sl(n, this.metadata), o = a.nationalPrefix, l = a.nationalNumber, s = a.carrierCode;
        if (l !== n)
          return this.onExtractedNationalNumber(o, s, l, n, r), !0;
      }
    }
    /**
     * In Google's code this function is called "attempt to extract longer NDD".
     * "Some national prefixes are a substring of others", they say.
     * @return {boolean} [result] — Returns `true` if extracting a national prefix produced different results from what they were.
     */
  }, {
    key: "extractAnotherNationalSignificantNumber",
    value: function(n, r, a) {
      if (!this.hasExtractedNationalSignificantNumber)
        return this.extractNationalSignificantNumber(n, a);
      if (this.couldPossiblyExtractAnotherNationalSignificantNumber) {
        var o = Sl(n, this.metadata), l = o.nationalPrefix, s = o.nationalNumber, c = o.carrierCode;
        if (s !== r)
          return this.onExtractedNationalNumber(l, c, s, n, a), !0;
      }
    }
  }, {
    key: "onExtractedNationalNumber",
    value: function(n, r, a, o, l) {
      var s = !1, c, d = o.lastIndexOf(a);
      if (d < 0 || d !== o.length - a.length)
        s = !0;
      else {
        var u = o.slice(0, d);
        u && u !== n && (c = u);
      }
      l({
        nationalPrefix: n,
        carrierCode: r,
        nationalSignificantNumber: a,
        nationalSignificantNumberIsModified: s,
        prefixBeforeNationalSignificantNumberThatIsNotNationalPrefix: c
      }), this.hasExtractedNationalSignificantNumber = !0, this.onNationalSignificantNumberChange();
    }
  }, {
    key: "reExtractNationalSignificantNumber",
    value: function(n) {
      if (this.extractAnotherNationalSignificantNumber(n.getNationalDigits(), n.nationalSignificantNumber, function(r) {
        return n.update(r);
      }))
        return !0;
      if (this.extractIddPrefix(n))
        return this.extractCallingCodeAndNationalSignificantNumber(n), !0;
      if (this.fixMissingPlus(n))
        return this.extractCallingCodeAndNationalSignificantNumber(n), !0;
    }
  }, {
    key: "extractIddPrefix",
    value: function(n) {
      var r = n.international, a = n.IDDPrefix, o = n.digits;
      if (n.nationalSignificantNumber, !(r || a)) {
        var l = Z2(o, this.defaultCountry, this.defaultCallingCode, this.metadata.metadata);
        if (l !== void 0 && l !== o)
          return n.update({
            IDDPrefix: o.slice(0, o.length - l.length)
          }), this.startInternationalNumber(n, {
            country: void 0,
            callingCode: void 0
          }), !0;
      }
    }
  }, {
    key: "fixMissingPlus",
    value: function(n) {
      if (!n.international) {
        var r = J2(n.digits, n.country, this.defaultCountry, this.defaultCallingCode, this.metadata.metadata), a = r.countryCallingCode;
        if (a)
          return n.update({
            missingPlus: !0
          }), this.startInternationalNumber(n, {
            country: n.country,
            callingCode: a
          }), !0;
      }
    }
  }, {
    key: "startInternationalNumber",
    value: function(n, r) {
      var a = r.country, o = r.callingCode;
      n.startInternationalNumber(a, o), n.nationalSignificantNumber && (n.resetNationalSignificantNumber(), this.onNationalSignificantNumberChange(), this.hasExtractedNationalSignificantNumber = void 0);
    }
  }, {
    key: "extractCallingCodeAndNationalSignificantNumber",
    value: function(n) {
      this.extractCountryCallingCode(n) && this.extractNationalSignificantNumber(n.getNationalDigits(), function(r) {
        return n.update(r);
      });
    }
  }]);
})();
function Fb(t) {
  var e = t.search(xb);
  if (!(e < 0)) {
    t = t.slice(e);
    var n;
    return t[0] === "+" && (n = !0, t = t.slice(1)), t = t.replace(Cb, ""), n && (t = "+" + t), t;
  }
}
function Pb(t) {
  var e = Fb(t) || "";
  return e[0] === "+" ? [e.slice(1), !0] : [e];
}
function Nb(t) {
  var e = Pb(t), n = s0(e, 2), r = n[0], a = n[1];
  return $b.test(r) || (r = ""), [r, a];
}
function ha(t) {
  "@babel/helpers - typeof";
  return ha = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, ha(t);
}
function _b(t, e) {
  return Db(t) || zb(t, e) || Ab(t, e) || Tb();
}
function Tb() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Ab(t, e) {
  if (t) {
    if (typeof t == "string") return w1(t, e);
    var n = {}.toString.call(t).slice(8, -1);
    return n === "Object" && t.constructor && (n = t.constructor.name), n === "Map" || n === "Set" ? Array.from(t) : n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? w1(t, e) : void 0;
  }
}
function w1(t, e) {
  (e == null || e > t.length) && (e = t.length);
  for (var n = 0, r = Array(e); n < e; n++) r[n] = t[n];
  return r;
}
function zb(t, e) {
  var n = t == null ? null : typeof Symbol < "u" && t[Symbol.iterator] || t["@@iterator"];
  if (n != null) {
    var r, a, o, l, s = [], c = !0, d = !1;
    try {
      if (o = (n = n.call(t)).next, e !== 0) for (; !(c = (r = o.call(n)).done) && (s.push(r.value), s.length !== e); c = !0) ;
    } catch (u) {
      d = !0, a = u;
    } finally {
      try {
        if (!c && n.return != null && (l = n.return(), Object(l) !== l)) return;
      } finally {
        if (d) throw a;
      }
    }
    return s;
  }
}
function Db(t) {
  if (Array.isArray(t)) return t;
}
function Ib(t, e) {
  if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
}
function kb(t, e) {
  for (var n = 0; n < e.length; n++) {
    var r = e[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, Lb(r.key), r);
  }
}
function Ob(t, e, n) {
  return e && kb(t.prototype, e), Object.defineProperty(t, "prototype", { writable: !1 }), t;
}
function Lb(t) {
  var e = Rb(t, "string");
  return ha(e) == "symbol" ? e : e + "";
}
function Rb(t, e) {
  if (ha(t) != "object" || !t) return t;
  var n = t[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(t, e);
    if (ha(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(t);
}
var yr = /* @__PURE__ */ (function() {
  function t(e, n) {
    Ib(this, t), this.metadata = new He(n);
    var r = this.getCountryAndCallingCode(e), a = _b(r, 2), o = a[0], l = a[1];
    this.defaultCountry = o, this.defaultCallingCode = l, this.reset();
  }
  return Ob(t, [{
    key: "getCountryAndCallingCode",
    value: function(n) {
      var r, a;
      return n && (wn(n) ? (r = n.defaultCountry, a = n.defaultCallingCode) : r = n), r && !this.metadata.hasCountry(r) && (r = void 0), [r, a];
    }
    /**
     * Inputs "next" phone number characters.
     * @param  {string} text
     * @return {string} Formatted phone number characters that have been input so far.
     */
  }, {
    key: "input",
    value: function(n) {
      var r = this.parser.input(n, this.state), a = r.digits, o = r.justLeadingPlus;
      if (o)
        this.formattedOutput = "+";
      else if (a) {
        this.determineTheCountryIfNeeded(), this.state.nationalSignificantNumber && this.formatter.narrowDownMatchingFormats(this.state);
        var l;
        if (this.metadata.hasSelectedNumberingPlan() && (l = this.formatter.format(a, this.state)), l === void 0 && this.parser.reExtractNationalSignificantNumber(this.state)) {
          this.determineTheCountryIfNeeded();
          var s = this.state.getNationalDigits();
          s && (l = this.formatter.format(s, this.state));
        }
        this.formattedOutput = l ? this.getFullNumber(l) : this.getNonFormattedNumber();
      }
      return this.formattedOutput;
    }
  }, {
    key: "reset",
    value: function() {
      var n = this;
      return this.state = new Py({
        onCountryChange: function(a) {
          n.country = a;
        },
        onCallingCodeChange: function(a, o) {
          n.metadata.selectNumberingPlan(o, a), n.formatter.reset(n.metadata.numberingPlan, n.state), n.parser.reset(n.metadata.numberingPlan);
        }
      }), this.formatter = new ub({
        state: this.state,
        metadata: this.metadata
      }), this.parser = new Sb({
        defaultCountry: this.defaultCountry,
        defaultCallingCode: this.defaultCallingCode,
        metadata: this.metadata,
        state: this.state,
        onNationalSignificantNumberChange: function() {
          n.determineTheCountryIfNeeded(), n.formatter.reset(n.metadata.numberingPlan, n.state);
        }
      }), this.state.reset({
        country: this.defaultCountry,
        callingCode: this.defaultCallingCode
      }), this.formattedOutput = "", this;
    }
    /**
     * Returns `true` if the phone number is being input in international format.
     * In other words, returns `true` if and only if the parsed phone number starts with a `"+"`.
     * @return {boolean}
     */
  }, {
    key: "isInternational",
    value: function() {
      return this.state.international;
    }
    /**
     * Returns the "calling code" part of the phone number when it's being input
     * in an international format.
     * If no valid calling code has been entered so far, returns `undefined`.
     * @return {string} [callingCode]
     */
  }, {
    key: "getCallingCode",
    value: function() {
      if (this.isInternational())
        return this.state.callingCode;
    }
    // A legacy alias.
  }, {
    key: "getCountryCallingCode",
    value: function() {
      return this.getCallingCode();
    }
    /**
     * Returns a two-letter country code of the phone number.
     * Returns `undefined` for "non-geographic" phone numbering plans.
     * Returns `undefined` if no phone number has been input yet.
     * @return {string} [country]
     */
  }, {
    key: "getCountry",
    value: function() {
      var n = this.state.digits;
      if (n)
        return this._getCountry();
    }
    /**
     * Returns a two-letter country code of the phone number.
     * Returns `undefined` for "non-geographic" phone numbering plans.
     * @return {string} [country]
     */
  }, {
    key: "_getCountry",
    value: function() {
      var n = this.state.country;
      return n;
    }
  }, {
    key: "determineTheCountryIfNeeded",
    value: function() {
      (!this.state.country || this.isCountryCallingCodeAmbiguous()) && this.determineTheCountry();
    }
    // Prepends `+CountryCode ` in case of an international phone number
  }, {
    key: "getFullNumber",
    value: function(n) {
      var r = this;
      if (this.isInternational()) {
        var a = function(s) {
          return r.formatter.getInternationalPrefixBeforeCountryCallingCode(r.state, {
            spacing: !!s
          }) + s;
        }, o = this.state.callingCode;
        return a(o ? n ? "".concat(o, " ").concat(n) : o : "".concat(this.state.getDigitsWithoutInternationalPrefix()));
      }
      return n;
    }
  }, {
    key: "getNonFormattedNationalNumberWithPrefix",
    value: function() {
      var n = this.state, r = n.nationalSignificantNumber, a = n.prefixBeforeNationalSignificantNumberThatIsNotNationalPrefix, o = n.nationalPrefix, l = r, s = a || o;
      return s && (l = s + l), l;
    }
  }, {
    key: "getNonFormattedNumber",
    value: function() {
      var n = this.state.nationalSignificantNumberIsModified;
      return this.getFullNumber(n ? this.state.getNationalDigits() : this.getNonFormattedNationalNumberWithPrefix());
    }
  }, {
    key: "getNonFormattedTemplate",
    value: function() {
      var n = this.getNonFormattedNumber();
      if (n)
        return n.replace(/[\+\d]/g, ct);
    }
  }, {
    key: "isCountryCallingCodeAmbiguous",
    value: function() {
      var n = this.state.callingCode, r = this.metadata.getCountryCodesForCallingCode(n);
      return r && r.length > 1;
    }
    // Determines the exact country of the phone number
    // entered so far based on the country phone code
    // and the national phone number.
  }, {
    key: "determineTheCountry",
    value: function() {
      this.state.setCountry(_s(this.isInternational() ? this.state.callingCode : this.defaultCallingCode, {
        nationalNumber: this.state.nationalSignificantNumber,
        metadata: this.metadata
      }));
    }
    /**
     * Returns a E.164 phone number value for the user's input.
     *
     * For example, for country `"US"` and input `"(222) 333-4444"`
     * it will return `"+12223334444"`.
     *
     * For international phone number input, it will also auto-correct
     * some minor errors such as using a national prefix when writing
     * an international phone number. For example, if the user inputs
     * `"+44 0 7400 000000"` then it will return an auto-corrected
     * `"+447400000000"` phone number value.
     *
     * Will return `undefined` if no digits have been input,
     * or when inputting a phone number in national format and no
     * default country or default "country calling code" have been set.
     *
     * @return {string} [value]
     */
  }, {
    key: "getNumberValue",
    value: function() {
      var n = this.state, r = n.digits, a = n.callingCode, o = n.country, l = n.nationalSignificantNumber;
      if (r) {
        if (this.isInternational())
          return a ? "+" + a + l : "+" + r;
        if (o || a) {
          var s = o ? this.metadata.countryCallingCode() : a;
          return "+" + s + l;
        }
      }
    }
    /**
     * Returns an instance of `PhoneNumber` class.
     * Will return `undefined` if no national (significant) number
     * digits have been entered so far, or if no `defaultCountry` has been
     * set and the user enters a phone number not in international format.
     */
  }, {
    key: "getNumber",
    value: function() {
      var n = this.state, r = n.nationalSignificantNumber, a = n.carrierCode, o = n.callingCode, l = this._getCountry();
      if (r && !(!l && !o)) {
        if (l && l === this.defaultCountry) {
          var s = new He(this.metadata.metadata);
          s.selectNumberingPlan(l);
          var c = s.numberingPlan.callingCode(), d = this.metadata.getCountryCodesForCallingCode(c);
          if (d.length > 1) {
            var u = X2(r, {
              countries: d,
              metadata: this.metadata.metadata
            });
            u && (l = u);
          }
        }
        var f = new a0(l || o, r, this.metadata.metadata);
        return a && (f.carrierCode = a), f;
      }
    }
    /**
     * Returns `true` if the phone number is "possible".
     * Is just a shortcut for `PhoneNumber.isPossible()`.
     * @return {boolean}
     */
  }, {
    key: "isPossible",
    value: function() {
      var n = this.getNumber();
      return n ? n.isPossible() : !1;
    }
    /**
     * Returns `true` if the phone number is "valid".
     * Is just a shortcut for `PhoneNumber.isValid()`.
     * @return {boolean}
     */
  }, {
    key: "isValid",
    value: function() {
      var n = this.getNumber();
      return n ? n.isValid() : !1;
    }
    /**
     * @deprecated
     * This method is used in `react-phone-number-input/source/input-control.js`
     * in versions before `3.0.16`.
     */
  }, {
    key: "getNationalNumber",
    value: function() {
      return this.state.nationalSignificantNumber;
    }
    /**
     * Returns the phone number characters entered by the user.
     * @return {string}
     */
  }, {
    key: "getChars",
    value: function() {
      return (this.state.international ? "+" : "") + this.state.digits;
    }
    /**
     * Returns the template for the formatted phone number.
     * @return {string}
     */
  }, {
    key: "getTemplate",
    value: function() {
      return this.formatter.getTemplate(this.state) || this.getNonFormattedTemplate() || "";
    }
  }]);
})();
function $1(t) {
  return new He(t).getCountries();
}
function Hb(t, e, n) {
  return n || (n = e, e = void 0), new yr(e, n).input(t);
}
function Bb(t) {
  let [e, n] = t.toLowerCase().split("e");
  const r = parseInt(n, 10);
  let a = "";
  e[0] === "-" && (a = "-", e = e.slice(1));
  const o = e.indexOf("."), l = o === -1 ? e : e.slice(0, o) + e.slice(o + 1), c = (o === -1 ? e.length : o) + r;
  return c >= l.length ? a + l + "0".repeat(c - l.length) : c <= 0 ? a + "0." + "0".repeat(-c) + l : a + l.slice(0, c) + "." + l.slice(c);
}
function jb(t) {
  return t.includes("e") || t.includes("E");
}
function Vb(t) {
  const e = typeof t;
  if (e === "bigint") {
    if (t <= 0n)
      throw new RangeError("Ordinals must be positive integers");
    return t;
  }
  if (e === "number") {
    if (!Number.isFinite(t))
      throw new RangeError("Ordinals must be finite numbers");
    if (!Number.isInteger(t))
      throw new RangeError("Ordinals must be whole numbers");
    if (t <= 0)
      throw new RangeError("Ordinals must be positive integers");
    return BigInt(t);
  }
  if (e === "string")
    return Ub(t);
  throw new TypeError(
    `Invalid value type: expected number, string, or bigint, received ${e}`
  );
}
function Ub(t) {
  const e = t.trim();
  if (e.length === 0)
    throw new RangeError("Ordinals cannot be empty strings");
  if (e[0] === "-")
    throw new RangeError("Ordinals cannot be negative");
  if (e.includes("."))
    throw new RangeError("Ordinals must be whole numbers");
  if (jb(e)) {
    const n = Bb(e);
    if (n.includes("."))
      throw new RangeError("Ordinals must be whole numbers");
    const r = BigInt(n);
    if (r <= 0n)
      throw new RangeError("Ordinals must be positive integers");
    return r;
  }
  try {
    const n = BigInt(e);
    if (n <= 0n)
      throw new RangeError("Ordinals must be positive integers");
    return n;
  } catch (n) {
    throw n instanceof RangeError ? n : new RangeError(`Invalid ordinal format: "${t}"`);
  }
}
function Wb(t) {
  if (t === null || typeof t != "object") return !1;
  const e = Object.getPrototypeOf(t);
  return e === null || e === Object.prototype;
}
function Gb(t) {
  if (t === void 0) return {};
  if (Wb(t)) return t;
  throw new TypeError(
    `Invalid options: expected plain object or undefined, got ${typeof t}`
  );
}
const Kb = ["عشرون", "ثلاثون", "أربعون", "خمسون", "ستون", "سبعون", "ثمانون", "تسعون"], qb = ["", "مائة", "مئتان", "ثلاثمائة", "أربعمائة", "خمسمائة", "ستمائة", "سبعمائة", "ثمانمائة", "تسعمائة"], Il = ["مائة", "ألف", "مليون", "مليار", "تريليون", "كوادريليون", "كوينتليون", "سكستيليون"], Yb = ["", "ألفاً", "مليوناً", "ملياراً", "تريليوناً", "كوادريليوناً", "كوينتليوناً", "سكستيليوناً"], Zb = ["", "آلاف", "ملايين", "مليارات", "تريليونات", "كوادريليونات", "كوينتليونات", "سكستيليونات"], Oo = ["مئتان", "ألفان", "مليونان", "ملياران", "تريليونان", "كوادريليونان", "كوينتليونان", "سكستيليونان"], Xb = ["مئتا", "ألفا", "مليونا", "مليارا", "تريليونا", "كوادريليونا", "كوينتليونا", "سكستيليونا"], Jb = ["واحد", "اثنان", "ثلاثة", "أربعة", "خمسة", "ستة", "سبعة", "ثمانية", "تسعة", "عشرة", "أحد عشر", "اثنا عشر", "ثلاثة عشر", "أربعة عشر", "خمسة عشر", "ستة عشر", "سبعة عشر", "ثمانية عشر", "تسعة عشر"], Qb = ["واحدة", "اثنتان", "ثلاث", "أربع", "خمس", "ست", "سبع", "ثمان", "تسع", "عشر", "إحدى عشرة", "اثنتا عشرة", "ثلاث عشرة", "أربع عشرة", "خمس عشرة", "ست عشرة", "سبع عشرة", "ثماني عشرة", "تسع عشرة"], eE = "صفر", kl = "و", tE = ["الأول", "الثاني", "الثالث", "الرابع", "الخامس", "السادس", "السابع", "الثامن", "التاسع", "العاشر"], nE = ["الأولى", "الثانية", "الثالثة", "الرابعة", "الخامسة", "السادسة", "السابعة", "الثامنة", "التاسعة", "العاشرة"];
function rE(t, e, n, r) {
  const a = t % 100, o = Math.trunc(t / 100);
  let l = "";
  if (o > 0)
    if (a === 0 && o === 2)
      l = Oo[0];
    else {
      const s = qb[o];
      s && (l = s, a !== 0 && (l += " " + kl));
    }
  if (a > 0)
    if (a < 20)
      if (a === 2 && o === 0 && e > 0) {
        const s = Number(n), c = Math.trunc(Math.log10(s));
        c % 3 === 0 && n === BigInt(2 * Math.pow(10, c)) ? l += t === 2 ? Oo[e] : Xb[e] : l += Oo[e];
      } else a === 1 && e > 0 ? l += Il[e] : l += r[a - 1];
    else {
      const s = a % 10, c = Math.trunc(a / 10) - 2;
      s > 0 && (l += r[s - 1] + " " + kl), l += Kb[c];
    }
  return l;
}
function aE(t, e) {
  if (t === 0n) return eE;
  const n = e === "feminine" ? Qb : Jb;
  let r = t, a = 0;
  const o = [];
  for (; r > 0n; ) {
    const s = Number(r % 1000n);
    if (r = r / 1000n, s > 0) {
      const c = rE(s, a, t, n);
      if (c) {
        let d = c;
        a > 0 && s > 2 && (s % 100 === 1 ? d += " " + Il[a] : s >= 3 && s <= 10 ? d += " " + Zb[a] : d += " " + (o.length > 0 ? Yb[a] : Il[a])), o.unshift(d);
      }
    }
    a++;
  }
  if (o.length === 1) return o[0];
  let l = o[0];
  for (let s = 1; s < o.length; s++)
    l += " " + kl + o[s];
  return l;
}
function iE(t, e) {
  const n = e === "feminine" ? nE : tE;
  return t >= 1n && t <= 10n ? n[Number(t) - 1] : "ال" + aE(t, e);
}
function oE(t, e) {
  e = Gb(e);
  const n = Vb(t), { gender: r = "masculine" } = e;
  return iE(n, r);
}
var jn = {
  type1: {
    name: "Basic Life Support (BLS)"
  },
  type2: {
    name: "Advanced Life Support (ALS)"
  },
  type3: {
    name: "Critical Care"
  }
}, lE = /^([01]\d|2[0-3]):([0-5]\d):([0-5]\d)$/;
function sE(t) {
  const e = lE.exec(t);
  if (!e)
    throw new Error(`Invalid schedule time: ${t}`);
  const n = Number(e[1]), r = Number(e[2]), a = Number(e[3]);
  return {
    hours: n,
    minutes: r,
    seconds: a,
    totalMinutes: n * 60 + r + a / 60
  };
}
var cE = Re.function().args(Re.custom()).returns(Re.promise(Re.custom())).optional();
z({
  page: Pe.number().int().gt(0).optional().default(1),
  pageSize: Pe.number().int().min(1).max(1e3).optional().default(50),
  query: Ke([w(), w(), w()]).optional(),
  sortBy: ye(["firstName", "lastName", "email", "createdAt"]).optional().default("createdAt"),
  sortOrder: ye(["asc", "desc"]).optional().default("desc")
});
z({}).catchall(et());
z({
  firstName: w().optional(),
  lastName: w().optional()
});
z({
  email: w().email(),
  firstName: w(),
  lastName: w()
});
z({
  email: w().email().optional(),
  firstName: w().optional(),
  lastName: w().optional(),
  id: w()
});
z({ id: w() });
z({
  page: Pe.number().int().gt(0).optional().default(1),
  pageSize: Pe.number().int().min(1).max(1e3).optional().default(50),
  sortBy: ye(["createdAt", "updatedAt"]).optional().default("createdAt"),
  sortOrder: ye(["asc", "desc"]).optional().default("desc")
});
z({ offerId: w().uuid() });
z({
  documentId: w().uuid()
});
z({
  reason: w().optional(),
  documentId: w().uuid()
});
z({
  page: Pe.number().int().gt(0).optional().default(1),
  pageSize: Pe.number().int().min(1).max(1e3).optional().default(50),
  sortBy: w().optional().default("createdAt"),
  sortOrder: ye(["asc", "desc"]).optional().default("desc")
});
z({ offerId: w().uuid() });
z({
  reason: w().optional(),
  offerId: w().uuid()
});
z({ id: w().uuid() });
z({
  submissionId: w()
});
z({ newPassword: w() });
z({
  mode: ye(["resetPassword", "verifyEmail"]),
  oobCode: w(),
  apiKey: w(),
  lang: w().optional()
});
z({ email: w().email() });
z({ email: w().email() });
z({
  page: Pe.number().int().gt(0).optional().default(1),
  pageSize: Pe.number().int().min(1).max(1e3).optional().default(50),
  query: Ke([w(), w(), w()]).optional(),
  sortBy: ye(["name", "email", "createdAt", "approved"]).optional().default("createdAt"),
  sortOrder: ye(["asc", "desc"]).optional().default("desc")
});
z({}).catchall(et());
z({
  bankCertificate: w().optional(),
  commercialRegistrationFile: w().optional(),
  companyLogo: w().optional(),
  firstName: w().optional(),
  jobTitle: w().optional(),
  lastName: w().optional(),
  name: w().optional(),
  nationalAddressCertificate: w().optional(),
  phoneNumber: w().optional(),
  signatoryEmail: w().email().optional(),
  signatoryFirstName: w().optional(),
  signatoryJobTitle: w().optional(),
  signatoryLastName: w().optional(),
  taxCertificate: w().optional(),
  zakaCertificate: w().optional()
});
z({}).catchall(et());
z({}).catchall(et());
z({ id: w() });
z({}).catchall(et());
z({
  fileId: w().optional(),
  name: w(),
  reason: w(),
  id: w()
});
z({
  id: w(),
  fileId: w()
});
z({
  email: w().email(),
  id: w(),
  name: w(),
  termsAccepted: at().default(!0)
});
z({
  address: Ke([w(), w().default("")]).optional(),
  commercialRegistrationNumber: Ke([w(), w().default("")]).optional(),
  email: w().email().optional(),
  name: w().optional(),
  id: w()
});
z({ id: w() });
z({ id: w() });
z({
  reason: w().optional(),
  id: w()
});
z({
  name: w(),
  size: we().optional(),
  type: ye([
    "application/pdf",
    "image/png",
    "image/jpeg",
    "image/jpg",
    "application/dicom"
  ])
});
z({ id: w() });
z({ userId: w().optional() });
z({ id: w() });
z({
  id: w(),
  purpose: ye(["view", "download"])
});
z({
  read: Ke([
    w().optional().default("false"),
    at().optional().default(!1)
  ]).optional(),
  page: Pe.number().int().gt(0).optional().default(1),
  pageSize: Pe.number().int().min(1).max(1e3).optional().default(50)
});
z({ id: w().uuid() });
z({}).catchall(et());
z({
  requestId: w().uuid(),
  page: Pe.number().int().gt(0).optional().default(1),
  pageSize: Pe.number().int().min(1).max(1e3).optional().default(50),
  sortBy: ye(["createdAt", "updatedAt"]).optional().default("createdAt"),
  sortOrder: ye(["asc", "desc"]).optional().default("desc"),
  status: ye(["PENDING", "ACCEPTED", "IN_PROGRESS", "CANCELED", "NOT_SELECTED"]).optional()
});
z({
  notes: w().optional(),
  priceItems: De(
    z({
      serviceName: w(),
      serviceType: w(),
      count: we().int().gt(0),
      unitPrice: we().gt(0)
    })
  ),
  requestId: w().uuid()
});
z({
  page: Pe.number().int().gt(0).optional().default(1),
  pageSize: Pe.number().int().min(1).max(1e3).optional().default(50),
  sortBy: ye(["createdAt", "updatedAt"]).optional().default("createdAt"),
  sortOrder: ye(["asc", "desc"]).optional().default("desc"),
  status: ye(["PENDING", "ACCEPTED", "IN_PROGRESS", "CANCELED", "NOT_SELECTED"]).optional()
});
z({
  requiredDocuments: De(w()).optional().default([]),
  id: w().uuid()
});
z({ id: w().uuid() });
z({ id: w().uuid() });
z({
  fileId: w().uuid().optional(),
  requirementId: w().uuid(),
  id: w().uuid()
});
z({
  id: w().uuid(),
  docId: w().uuid()
});
z({
  fileId: w().uuid().optional(),
  id: w().uuid()
});
z({ id: w().uuid() });
z({
  fileId: w().uuid().optional(),
  id: w().uuid()
});
z({ id: w().uuid() });
z({ id: w().uuid() });
z({
  reason: w().optional(),
  id: w().uuid()
});
z({
  id: w().uuid()
});
z({ id: w().uuid() });
z({
  page: Pe.number().int().gt(0).optional().default(1),
  pageSize: Pe.number().int().min(1).max(1e3).optional().default(50),
  sortBy: ye(["createdAt", "updatedAt", "projectName", "proposalDeadline"]).optional().default("createdAt"),
  sortOrder: ye(["asc", "desc"]).optional().default("desc"),
  query: Ke([w(), w(), w()]).optional()
});
z({
  page: Pe.number().int().gt(0).optional().default(1),
  pageSize: Pe.number().int().min(1).max(1e3).optional().default(50),
  sortBy: ye(["createdAt", "updatedAt"]).optional().default("createdAt"),
  sortOrder: ye(["asc", "desc"]).optional().default("desc"),
  status: ye(["PENDING", "ACCEPTED", "IN_PROGRESS", "CANCELED", "NOT_SELECTED"]).optional()
});
z({
  ambulance4x4WithDriver: z({
    amount: we().int().min(0),
    equipment: De(
      z({ name: w(), quantity: we().int().min(1) })
    ).optional().default([])
  }).optional(),
  ambulance4x4WithoutDriver: z({
    amount: we().int().min(0),
    equipment: De(
      z({ name: w(), quantity: we().int().min(1) })
    ).optional().default([])
  }).optional(),
  ambulanceServiceWithDriver: De(
    z({
      type1Amount: we().int().min(0),
      type2Amount: we().int().min(0),
      type3Amount: we().int().min(0),
      type1Equipment: De(
        z({ name: w(), quantity: we().int().min(1) })
      ).optional().default([]),
      type2Equipment: De(
        z({ name: w(), quantity: we().int().min(1) })
      ).optional().default([]),
      type3Equipment: De(
        z({ name: w(), quantity: we().int().min(1) })
      ).optional().default([])
    })
  ).optional(),
  ambulanceServiceWithoutDriver: De(
    z({
      type1Amount: we().int().min(0),
      type2Amount: we().int().min(0),
      type3Amount: we().int().min(0),
      type1Equipment: De(
        z({ name: w(), quantity: we().int().min(1) })
      ).optional().default([]),
      type2Equipment: De(
        z({ name: w(), quantity: we().int().min(1) })
      ).optional().default([]),
      type3Equipment: De(
        z({ name: w(), quantity: we().int().min(1) })
      ).optional().default([])
    })
  ).optional(),
  bankGuaranteePercent: we().min(0).max(20).optional(),
  dates: z({ from: w().datetime(), to: w().datetime() }),
  doctorServices: De(
    z({ specialization: w(), amount: we().int().min(1) })
  ).optional(),
  draftId: w().uuid().optional(),
  hours: z({ from: w(), to: w() }),
  housingTransportProvided: at(),
  isolatedWorkArea: at(),
  kpis: De(w()).optional().default([]),
  location: z({ name: w(), latitude: we(), longitude: we() }).optional(),
  mealsProvided: at(),
  medicalEquipment: De(z({ name: w(), quantity: we().int().min(1) })).optional().default([]),
  mobileClinicServices: De(
    z({
      amount: we().int().min(1),
      type: ye(["BASIC", "ADVANCED"]),
      equipment: De(
        z({ name: w(), quantity: we().int().min(1) })
      ).optional().default([])
    })
  ).optional(),
  notes: w().optional(),
  nurseServices: De(
    z({
      amount: we().int().min(1),
      type: ye(["SPECIALIST", "TECHNICIAN"])
    })
  ).optional(),
  paramedicServices: De(
    z({
      amount: we().int().min(1),
      type: ye(["SPECIALIST", "TECHNICIAN"])
    })
  ).optional(),
  paymentSchedule: Ke([
    z({
      paymentType: w().default("MONTHLY"),
      milestones: De(
        z({
          percentage: we().min(0).max(100).refine(
            (t) => Number.isInteger(t / 5),
            "Must be a multiple of 5"
          )
        })
      )
    }),
    z({
      paymentType: w().default("DELIVERABLES"),
      milestones: De(
        z({
          name: w(),
          percentage: we().min(0).max(100).refine(
            (t) => Number.isInteger(t / 5),
            "Must be a multiple of 5"
          )
        })
      )
    })
  ]),
  projectName: w(),
  projectType: ye(["GOVERNMENT", "PRIVATE"]),
  proposalDeadline: w().datetime(),
  requiredDocuments: De(w()).optional().default([])
});
z({
  page: Pe.number().int().gt(0).optional().default(1),
  pageSize: Pe.number().int().min(1).max(1e3).optional().default(50),
  sortBy: ye(["createdAt", "updatedAt"]).optional().default("createdAt"),
  sortOrder: ye(["asc", "desc"]).optional().default("desc"),
  status: ye(["PENDING", "ACCEPTED", "IN_PROGRESS", "CANCELED", "NOT_SELECTED"]).optional(),
  active: Ke([w().optional(), at().optional()]).optional()
});
z({
  page: Pe.number().int().gt(0).optional().default(1),
  pageSize: Pe.number().int().min(1).max(1e3).optional().default(50),
  sortBy: ye(["createdAt", "updatedAt"]).optional().default("createdAt"),
  sortOrder: ye(["asc", "desc"]).optional().default("desc")
});
z({ id: w().uuid() });
z({}).catchall(et());
z({
  data: z({}).catchall(et()),
  id: w().uuid().optional()
});
z({ id: w().uuid() });
z({
  data: z({}).catchall(et()).optional(),
  id: w().uuid()
});
z({ id: w().uuid() });
z({
  key: w().optional(),
  section: w().optional(),
  isActive: Ke([w().optional(), at().optional()]).optional()
});
z({
  description: w().optional(),
  isActive: at().default(!0),
  key: w(),
  section: w().default("general"),
  value: w()
});
z({
  settings: De(
    z({
      key: w(),
      value: w(),
      section: w().optional().default("general"),
      description: w().optional(),
      isActive: at().optional()
    })
  ).optional()
});
z({
  description: w().optional(),
  isActive: at().optional(),
  value: w().optional(),
  section: w(),
  key: w()
});
z({
  section: w(),
  key: w()
});
z({
  page: Pe.number().int().gt(0).optional().default(1),
  pageSize: Pe.number().int().min(1).max(1e3).optional().default(50),
  query: Ke([w(), w(), w()]).optional(),
  sortBy: ye(["name", "email", "createdAt", "approved"]).optional().default("createdAt"),
  sortOrder: ye(["asc", "desc"]).optional().default("desc")
});
z({}).catchall(et());
z({
  bankCertificate: w().optional(),
  commercialRegistrationFile: w().optional(),
  companyLogo: w().optional(),
  firstName: w().optional(),
  jobTitle: w().optional(),
  lastName: w().optional(),
  name: w().optional(),
  nationalAddressCertificate: w().optional(),
  phoneNumber: w().optional(),
  redCrescentComplianceCertificate: w().optional(),
  signatoryEmail: w().email().optional(),
  signatoryFirstName: w().optional(),
  signatoryJobTitle: w().optional(),
  signatoryLastName: w().optional(),
  taxCertificate: w().optional(),
  zakaCertificate: w().optional()
});
z({}).catchall(et());
z({}).catchall(et());
z({ id: w() });
z({
  email: w().email(),
  id: w(),
  name: w(),
  termsAccepted: at().default(!0)
});
z({
  address: Ke([w(), w().default("")]).optional(),
  bankAccountName: Ke([w(), w().default("")]).optional(),
  bankName: Ke([w(), w().default("")]).optional(),
  commercialRegistrationNumber: Ke([w(), w().default("")]).optional(),
  email: w().email().optional(),
  iban: Ke([w(), w().default("")]).optional(),
  name: w().optional(),
  id: w()
});
z({ id: w() });
z({ id: w() });
z({
  reason: w().optional(),
  id: w()
});
z({}).catchall(et());
z({
  fileId: w().optional(),
  name: w(),
  reason: w(),
  id: w()
});
z({
  id: w(),
  fileId: w()
});
Re.object({
  token: Re.union([
    Re.string(),
    Re.function().returns(Re.union([Re.string(), Re.promise(Re.string())]))
  ]).optional().transform(async (t) => {
    if (t)
      return typeof t == "function" && (t = await Promise.resolve(t())), `Bearer ${t}`;
  }).describe(
    "Bearer token for authentication. Can be a string or a function that returns a string."
  ),
  fetch: cE.describe(
    "Custom fetch implementation. Defaults to globalThis.fetch."
  ),
  baseUrl: Re.union([
    Re.string(),
    Re.function().returns(Re.union([Re.string(), Re.promise(Re.string())]))
  ]).transform(async (t) => typeof t == "function" ? Promise.resolve(t()) : t).describe(
    "Base URL of the API server. Can be a string or a function that returns a string."
  ),
  headers: Re.record(Re.string()).optional().describe("Default headers to include in all requests."),
  skipValidation: Re.boolean().optional().describe(
    "Skip request input validation. Client options and TypeScript types still enforce correct usage."
  )
});
function dE(t, e) {
  const n = t.filter((a) => a.type !== "DOCUMENT_SUBMITTED" && a.type !== "DOCUMENT_APPROVED" && a.type !== "DOCUMENT_REJECTED" ? !1 : a.context?.documentId === e).sort(
    (a, o) => new Date(o.createdAt).getTime() - new Date(a.createdAt).getTime()
  );
  if (n.length === 0)
    return "NOT_SUBMITTED";
  switch (n[0].type) {
    case "DOCUMENT_SUBMITTED":
      return "PENDING";
    case "DOCUMENT_APPROVED":
      return "APPROVED";
    case "DOCUMENT_REJECTED":
      return "REJECTED";
    default:
      return "NOT_SUBMITTED";
  }
}
function uE(t) {
  const e = t.filter(
    (r) => r.type === "TT_UPLOADED" || r.type === "TT_APPROVED" || r.type === "TT_REJECTED"
  ).sort(
    (r, a) => new Date(a.createdAt).getTime() - new Date(r.createdAt).getTime()
  );
  if (e.length === 0)
    return "NOT_UPLOADED";
  switch (e[0].type) {
    case "TT_UPLOADED":
      return "PENDING";
    case "TT_APPROVED":
      return "APPROVED";
    case "TT_REJECTED":
      return "REJECTED";
    default:
      return "NOT_UPLOADED";
  }
}
function fE(t) {
  const e = t.filter(
    (r) => r.type === "TT_UPLOADED" || r.type === "TT_APPROVED" || r.type === "TT_REJECTED"
  ).sort(
    (r, a) => new Date(a.createdAt).getTime() - new Date(r.createdAt).getTime()
  );
  if (e.length === 0)
    return null;
  const n = e[0];
  return n.type === "TT_REJECTED" ? n.context.reason ?? null : null;
}
function x1(t) {
  const e = t.filter((a) => a.type === "CONTRACT_SIGNED"), n = e.some((a) => a.source === "VENDOR"), r = e.some((a) => a.source === "CUSTOMER");
  return {
    vendorSigned: n,
    customerSigned: r,
    bothSigned: n && r
  };
}
function pE(t, e) {
  for (const n of e)
    if (dE(t, n) !== "APPROVED")
      return !1;
  return !0;
}
function c0(t, e) {
  const n = t.filter(
    (a) => a.type === "DOCUMENT_SUBMITTED" || a.type === "DOCUMENT_APPROVED" || a.type === "DOCUMENT_REJECTED"
  ).sort(
    (a, o) => new Date(o.createdAt).getTime() - new Date(a.createdAt).getTime()
  ), r = /* @__PURE__ */ new Map();
  for (const a of n) {
    const o = a.context;
    o?.documentId && !r.has(o.documentId) && r.set(o.documentId, a);
  }
  for (const [a, o] of r.entries())
    if (!(e && !e.includes(a)) && o.type === "DOCUMENT_REJECTED")
      return o.context.reason ?? null;
  return null;
}
function mE(t, e) {
  return c0(t, e) !== null;
}
w().datetime().transform((t) => a8(t)).refine(
  (t) => t >= /* @__PURE__ */ new Date(),
  {
    message: "Date must not be in the past"
  }
);
Pe.string().or(Pe.boolean()).nullish().transform((t) => t == null ? !1 : typeof t == "string" ? t.toLowerCase() === "true" : !1);
Pe.number().int().positive().nullish().default(1).transform((t) => t ?? 1);
Pe.number().int().min(1).max(100).nullish().default(50).transform((t) => t ?? 50);
w().min(2).max(100).trim().optional();
ye(["asc", "desc"]).optional().default("asc");
function hE(t, e) {
  return oE(t, { gender: e });
}
function vE({
  phase: t,
  rejectionReason: e,
  className: n
}) {
  const { t: r } = Ae();
  switch (t) {
    case "open":
      return /* @__PURE__ */ S("div", { className: fe("flex items-center gap-2", n), children: [
        /* @__PURE__ */ p("span", { className: "size-3 rounded-full bg-green-500" }),
        /* @__PURE__ */ p("span", { className: "text-sm font-medium text-green-700", children: r("shared.offerStatus.open") })
      ] });
    case "awaiting_documents":
      return /* @__PURE__ */ S("div", { className: fe("flex items-center gap-2", n), children: [
        /* @__PURE__ */ p(Ir, { className: "size-4 text-amber-600" }),
        /* @__PURE__ */ p("span", { className: "text-sm font-medium text-amber-700", children: r("shared.offerStatus.awaitingDocuments") })
      ] });
    case "awaiting_review":
      return /* @__PURE__ */ S("div", { className: fe("flex items-center gap-2", n), children: [
        /* @__PURE__ */ p(sl, { className: "size-4 text-blue-600" }),
        /* @__PURE__ */ p("span", { className: "text-sm font-medium text-blue-700", children: r("shared.offerStatus.awaitingReview") })
      ] });
    case "documents_rejected":
      return /* @__PURE__ */ S("div", { className: fe("flex flex-col gap-1", n), children: [
        /* @__PURE__ */ S("div", { className: "flex items-center gap-2", children: [
          /* @__PURE__ */ p(ri, { className: "size-4 text-red-600" }),
          /* @__PURE__ */ p("span", { className: "text-sm font-medium text-red-700", children: r("shared.offerStatus.documentsRejected") })
        ] }),
        e && /* @__PURE__ */ S("div", { className: "flex items-start gap-2 rounded bg-red-50 p-2", children: [
          /* @__PURE__ */ p(Dr, { className: "mt-0.5 size-3 shrink-0 text-red-500" }),
          /* @__PURE__ */ p("span", { className: "text-xs text-red-600", children: e })
        ] })
      ] });
    case "awaiting_signing":
      return /* @__PURE__ */ S("div", { className: fe("flex items-center gap-2", n), children: [
        /* @__PURE__ */ p(ai, { className: "size-4 text-blue-600" }),
        /* @__PURE__ */ p("span", { className: "text-sm font-medium text-blue-700", children: r("shared.offerStatus.awaitingSigning") })
      ] });
    case "contract_ready":
      return /* @__PURE__ */ S("div", { className: fe("flex items-center gap-2", n), children: [
        /* @__PURE__ */ p(zr, { className: "size-4 text-green-600" }),
        /* @__PURE__ */ p("span", { className: "text-sm font-medium text-green-700", children: r("shared.offerStatus.contractReady") })
      ] });
    case "awaiting_tt":
      return /* @__PURE__ */ S("div", { className: fe("flex items-center gap-2", n), children: [
        /* @__PURE__ */ p(cu, { className: "size-4 text-amber-600" }),
        /* @__PURE__ */ p("span", { className: "text-sm font-medium text-amber-700", children: r("shared.offerStatus.awaitingTT") })
      ] });
    case "awaiting_tt_review":
      return /* @__PURE__ */ S("div", { className: fe("flex items-center gap-2", n), children: [
        /* @__PURE__ */ p(sl, { className: "size-4 text-blue-600" }),
        /* @__PURE__ */ p("span", { className: "text-sm font-medium text-blue-700", children: r("shared.offerStatus.awaitingTTReview") })
      ] });
    case "tt_rejected":
      return /* @__PURE__ */ S("div", { className: fe("flex flex-col gap-1", n), children: [
        /* @__PURE__ */ S("div", { className: "flex items-center gap-2", children: [
          /* @__PURE__ */ p(ri, { className: "size-4 text-red-600" }),
          /* @__PURE__ */ p("span", { className: "text-sm font-medium text-red-700", children: r("shared.offerStatus.ttRejected") })
        ] }),
        e && /* @__PURE__ */ S("div", { className: "flex items-start gap-2 rounded bg-red-50 p-2", children: [
          /* @__PURE__ */ p(Dr, { className: "mt-0.5 size-3 shrink-0 text-red-500" }),
          /* @__PURE__ */ p("span", { className: "text-xs text-red-600", children: e })
        ] })
      ] });
    case "in_progress":
      return /* @__PURE__ */ S("div", { className: fe("flex items-center gap-2", n), children: [
        /* @__PURE__ */ p(zr, { className: "size-4 text-green-600" }),
        /* @__PURE__ */ p("span", { className: "text-sm font-medium text-green-700", children: r("shared.offerStatus.inProgress") })
      ] });
    default:
      return null;
  }
}
function gE(t) {
  const { offerId: e, acceptedOffer: n, requiredDocuments: r = [] } = t;
  if (!e || !n)
    return { phase: "open" };
  const a = n.timeline ?? [];
  if (n.status === "IN_PROGRESS")
    return { phase: "in_progress" };
  if (n.status === "ACCEPTED") {
    const o = uE(a);
    return o === "APPROVED" ? { phase: "in_progress" } : o === "REJECTED" ? {
      phase: "tt_rejected",
      rejectionReason: fE(a)
    } : n.ttFileId || o === "PENDING" ? { phase: "awaiting_tt_review" } : { phase: "awaiting_tt" };
  }
  if (n.status === "PENDING") {
    const o = n.documents?.map((c) => c.id);
    if (mE(a, o))
      return {
        phase: "documents_rejected",
        rejectionReason: c0(
          a,
          o
        )
      };
    const l = n.documents?.length ?? 0, s = r.length;
    return s === 0 ? x1(a).bothSigned ? { phase: "contract_ready" } : { phase: "awaiting_signing" } : l >= s ? pE(a, o ?? []) ? x1(a).bothSigned ? { phase: "contract_ready" } : { phase: "awaiting_signing" } : { phase: "awaiting_review" } : { phase: "awaiting_documents" };
  }
  return { phase: "open" };
}
function SO({
  title: t,
  children: e,
  className: n,
  showBackButton: r,
  size: a = "md"
}) {
  const { t: o } = Ae();
  return /* @__PURE__ */ p("div", { className: fe("page-container", n), children: /* @__PURE__ */ S(
    "div",
    {
      className: fe(
        "mx-auto w-full",
        a === "sm" ? "max-w-2xl" : a === "md" ? "max-w-3xl" : a === "lg" ? "max-w-4xl" : "max-w-3xl"
      ),
      children: [
        /* @__PURE__ */ S("div", { className: "flex items-center justify-between", children: [
          /* @__PURE__ */ p("h1", { className: "text-3xl font-bold", children: t }),
          r && /* @__PURE__ */ S(
            Ea,
            {
              to: "../",
              className: "text-primary flex gap-x-1 text-sm font-bold",
              children: [
                /* @__PURE__ */ p("span", { children: o("shared.common.back") }),
                /* @__PURE__ */ p(H4, {})
              ]
            }
          )
        ] }),
        /* @__PURE__ */ p("div", { className: "mt-8", children: e })
      ]
    }
  ) });
}
const yE = _n(
  ({ className: t, showPasswordByDefault: e = !1, ...n }, r) => {
    const [a, o] = ve(e);
    return /* @__PURE__ */ S("div", { className: "relative", children: [
      /* @__PURE__ */ p(
        $a,
        {
          type: a ? "text" : "password",
          className: fe("ltr:ps-10 rtl:pe-10", t),
          dir: "ltr",
          ref: r,
          ...n
        }
      ),
      /* @__PURE__ */ p(
        mt,
        {
          type: "button",
          variant: "ghost",
          size: "sm",
          className: "absolute top-1/2 -translate-y-1/2 h-full px-3 py-2 hover:bg-transparent ltr:left-0 rtl:right-0",
          onClick: () => o((l) => !l),
          "aria-label": a ? "Hide password" : "Show password",
          children: a ? /* @__PURE__ */ p(sp, { className: "text-muted-foreground h-4 w-4" }) : /* @__PURE__ */ p(dp, { className: "text-muted-foreground h-4 w-4" })
        }
      )
    ] });
  }
);
yE.displayName = "PasswordInput";
function FO() {
  const { t } = Ae();
  return /* @__PURE__ */ S("div", { className: "mt-8 flex items-center justify-between rounded-xl bg-[#D5DCFF] py-3 ps-7 pe-4", children: [
    /* @__PURE__ */ S("div", { className: "flex items-center gap-2", children: [
      /* @__PURE__ */ p(kr, { size: 20, className: "text-black" }),
      /* @__PURE__ */ p("p", { className: "text-sm font-medium text-black", children: t("shared.banners.completeVerification") })
    ] }),
    /* @__PURE__ */ p(
      Ea,
      {
        to: "/additional-documents",
        className: us({
          variant: "link",
          className: "bg-[#333E75] text-sm text-white"
        }),
        children: t("shared.banners.submitAdditionalDocs")
      }
    )
  ] });
}
function PO() {
  const { t } = Ae();
  return /* @__PURE__ */ p("div", { className: "my-8 rounded-xl bg-[#FFF6F0] px-7 py-3", children: /* @__PURE__ */ S("div", { className: "flex items-center gap-2", children: [
    /* @__PURE__ */ p(kr, { size: 20, className: "text-[#EF7014]" }),
    /* @__PURE__ */ p("p", { className: "text-sm font-medium text-black", children: t("shared.banners.accountUnderReview") })
  ] }) });
}
function NO({ reason: t }) {
  const { t: e } = Ae();
  return /* @__PURE__ */ p("div", { className: "my-8 rounded-xl border border-red-200 bg-red-50 px-7 py-4", children: /* @__PURE__ */ S("div", { className: "flex items-start gap-3", children: [
    /* @__PURE__ */ p(Dr, { size: 20, className: "mt-0.5 text-red-600" }),
    /* @__PURE__ */ S("div", { className: "flex-1", children: [
      /* @__PURE__ */ p("p", { className: "font-semibold text-black", children: e("shared.banners.accountRejectedTitle") }),
      t && /* @__PURE__ */ p("p", { className: "mt-1 text-sm text-black/80", children: e("shared.banners.accountRejectedReason", { reason: t }) })
    ] })
  ] }) });
}
var La = { exports: {} }, Ra = { exports: {} }, Ce = {};
var C1;
function bE() {
  if (C1) return Ce;
  C1 = 1;
  var t = typeof Symbol == "function" && Symbol.for, e = t ? Symbol.for("react.element") : 60103, n = t ? Symbol.for("react.portal") : 60106, r = t ? Symbol.for("react.fragment") : 60107, a = t ? Symbol.for("react.strict_mode") : 60108, o = t ? Symbol.for("react.profiler") : 60114, l = t ? Symbol.for("react.provider") : 60109, s = t ? Symbol.for("react.context") : 60110, c = t ? Symbol.for("react.async_mode") : 60111, d = t ? Symbol.for("react.concurrent_mode") : 60111, u = t ? Symbol.for("react.forward_ref") : 60112, f = t ? Symbol.for("react.suspense") : 60113, m = t ? Symbol.for("react.suspense_list") : 60120, g = t ? Symbol.for("react.memo") : 60115, C = t ? Symbol.for("react.lazy") : 60116, b = t ? Symbol.for("react.block") : 60121, E = t ? Symbol.for("react.fundamental") : 60117, x = t ? Symbol.for("react.responder") : 60118, _ = t ? Symbol.for("react.scope") : 60119;
  function N(F) {
    if (typeof F == "object" && F !== null) {
      var A = F.$$typeof;
      switch (A) {
        case e:
          switch (F = F.type, F) {
            case c:
            case d:
            case r:
            case o:
            case a:
            case f:
              return F;
            default:
              switch (F = F && F.$$typeof, F) {
                case s:
                case u:
                case C:
                case g:
                case l:
                  return F;
                default:
                  return A;
              }
          }
        case n:
          return A;
      }
    }
  }
  function k(F) {
    return N(F) === d;
  }
  return Ce.AsyncMode = c, Ce.ConcurrentMode = d, Ce.ContextConsumer = s, Ce.ContextProvider = l, Ce.Element = e, Ce.ForwardRef = u, Ce.Fragment = r, Ce.Lazy = C, Ce.Memo = g, Ce.Portal = n, Ce.Profiler = o, Ce.StrictMode = a, Ce.Suspense = f, Ce.isAsyncMode = function(F) {
    return k(F) || N(F) === c;
  }, Ce.isConcurrentMode = k, Ce.isContextConsumer = function(F) {
    return N(F) === s;
  }, Ce.isContextProvider = function(F) {
    return N(F) === l;
  }, Ce.isElement = function(F) {
    return typeof F == "object" && F !== null && F.$$typeof === e;
  }, Ce.isForwardRef = function(F) {
    return N(F) === u;
  }, Ce.isFragment = function(F) {
    return N(F) === r;
  }, Ce.isLazy = function(F) {
    return N(F) === C;
  }, Ce.isMemo = function(F) {
    return N(F) === g;
  }, Ce.isPortal = function(F) {
    return N(F) === n;
  }, Ce.isProfiler = function(F) {
    return N(F) === o;
  }, Ce.isStrictMode = function(F) {
    return N(F) === a;
  }, Ce.isSuspense = function(F) {
    return N(F) === f;
  }, Ce.isValidElementType = function(F) {
    return typeof F == "string" || typeof F == "function" || F === r || F === d || F === o || F === a || F === f || F === m || typeof F == "object" && F !== null && (F.$$typeof === C || F.$$typeof === g || F.$$typeof === l || F.$$typeof === s || F.$$typeof === u || F.$$typeof === E || F.$$typeof === x || F.$$typeof === _ || F.$$typeof === b);
  }, Ce.typeOf = N, Ce;
}
var Me = {};
var M1;
function EE() {
  return M1 || (M1 = 1, process.env.NODE_ENV !== "production" && (function() {
    var t = typeof Symbol == "function" && Symbol.for, e = t ? Symbol.for("react.element") : 60103, n = t ? Symbol.for("react.portal") : 60106, r = t ? Symbol.for("react.fragment") : 60107, a = t ? Symbol.for("react.strict_mode") : 60108, o = t ? Symbol.for("react.profiler") : 60114, l = t ? Symbol.for("react.provider") : 60109, s = t ? Symbol.for("react.context") : 60110, c = t ? Symbol.for("react.async_mode") : 60111, d = t ? Symbol.for("react.concurrent_mode") : 60111, u = t ? Symbol.for("react.forward_ref") : 60112, f = t ? Symbol.for("react.suspense") : 60113, m = t ? Symbol.for("react.suspense_list") : 60120, g = t ? Symbol.for("react.memo") : 60115, C = t ? Symbol.for("react.lazy") : 60116, b = t ? Symbol.for("react.block") : 60121, E = t ? Symbol.for("react.fundamental") : 60117, x = t ? Symbol.for("react.responder") : 60118, _ = t ? Symbol.for("react.scope") : 60119;
    function N(V) {
      return typeof V == "string" || typeof V == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      V === r || V === d || V === o || V === a || V === f || V === m || typeof V == "object" && V !== null && (V.$$typeof === C || V.$$typeof === g || V.$$typeof === l || V.$$typeof === s || V.$$typeof === u || V.$$typeof === E || V.$$typeof === x || V.$$typeof === _ || V.$$typeof === b);
    }
    function k(V) {
      if (typeof V == "object" && V !== null) {
        var Be = V.$$typeof;
        switch (Be) {
          case e:
            var Pt = V.type;
            switch (Pt) {
              case c:
              case d:
              case r:
              case o:
              case a:
              case f:
                return Pt;
              default:
                var dn = Pt && Pt.$$typeof;
                switch (dn) {
                  case s:
                  case u:
                  case C:
                  case g:
                  case l:
                    return dn;
                  default:
                    return Be;
                }
            }
          case n:
            return Be;
        }
      }
    }
    var F = c, A = d, O = s, te = l, le = e, W = u, y = r, Y = C, ee = g, I = n, Q = o, M = a, X = f, se = !1;
    function he(V) {
      return se || (se = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), L(V) || k(V) === c;
    }
    function L(V) {
      return k(V) === d;
    }
    function K(V) {
      return k(V) === s;
    }
    function P(V) {
      return k(V) === l;
    }
    function D(V) {
      return typeof V == "object" && V !== null && V.$$typeof === e;
    }
    function B(V) {
      return k(V) === u;
    }
    function H(V) {
      return k(V) === r;
    }
    function j(V) {
      return k(V) === C;
    }
    function Z(V) {
      return k(V) === g;
    }
    function ne(V) {
      return k(V) === n;
    }
    function ie(V) {
      return k(V) === o;
    }
    function ce(V) {
      return k(V) === a;
    }
    function Oe(V) {
      return k(V) === f;
    }
    Me.AsyncMode = F, Me.ConcurrentMode = A, Me.ContextConsumer = O, Me.ContextProvider = te, Me.Element = le, Me.ForwardRef = W, Me.Fragment = y, Me.Lazy = Y, Me.Memo = ee, Me.Portal = I, Me.Profiler = Q, Me.StrictMode = M, Me.Suspense = X, Me.isAsyncMode = he, Me.isConcurrentMode = L, Me.isContextConsumer = K, Me.isContextProvider = P, Me.isElement = D, Me.isForwardRef = B, Me.isFragment = H, Me.isLazy = j, Me.isMemo = Z, Me.isPortal = ne, Me.isProfiler = ie, Me.isStrictMode = ce, Me.isSuspense = Oe, Me.isValidElementType = N, Me.typeOf = k;
  })()), Me;
}
var S1;
function d0() {
  return S1 || (S1 = 1, process.env.NODE_ENV === "production" ? Ra.exports = bE() : Ra.exports = EE()), Ra.exports;
}
var Lo, F1;
function wE() {
  if (F1) return Lo;
  F1 = 1;
  var t = Object.getOwnPropertySymbols, e = Object.prototype.hasOwnProperty, n = Object.prototype.propertyIsEnumerable;
  function r(o) {
    if (o == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(o);
  }
  function a() {
    try {
      if (!Object.assign)
        return !1;
      var o = new String("abc");
      if (o[5] = "de", Object.getOwnPropertyNames(o)[0] === "5")
        return !1;
      for (var l = {}, s = 0; s < 10; s++)
        l["_" + String.fromCharCode(s)] = s;
      var c = Object.getOwnPropertyNames(l).map(function(u) {
        return l[u];
      });
      if (c.join("") !== "0123456789")
        return !1;
      var d = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(u) {
        d[u] = u;
      }), Object.keys(Object.assign({}, d)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return Lo = a() ? Object.assign : function(o, l) {
    for (var s, c = r(o), d, u = 1; u < arguments.length; u++) {
      s = Object(arguments[u]);
      for (var f in s)
        e.call(s, f) && (c[f] = s[f]);
      if (t) {
        d = t(s);
        for (var m = 0; m < d.length; m++)
          n.call(s, d[m]) && (c[d[m]] = s[d[m]]);
      }
    }
    return c;
  }, Lo;
}
var Ro, P1;
function zs() {
  if (P1) return Ro;
  P1 = 1;
  var t = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return Ro = t, Ro;
}
var Ho, N1;
function u0() {
  return N1 || (N1 = 1, Ho = Function.call.bind(Object.prototype.hasOwnProperty)), Ho;
}
var Bo, _1;
function $E() {
  if (_1) return Bo;
  _1 = 1;
  var t = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var e = /* @__PURE__ */ zs(), n = {}, r = /* @__PURE__ */ u0();
    t = function(o) {
      var l = "Warning: " + o;
      typeof console < "u" && console.error(l);
      try {
        throw new Error(l);
      } catch {
      }
    };
  }
  function a(o, l, s, c, d) {
    if (process.env.NODE_ENV !== "production") {
      for (var u in o)
        if (r(o, u)) {
          var f;
          try {
            if (typeof o[u] != "function") {
              var m = Error(
                (c || "React class") + ": " + s + " type `" + u + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof o[u] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              throw m.name = "Invariant Violation", m;
            }
            f = o[u](l, u, c, s, null, e);
          } catch (C) {
            f = C;
          }
          if (f && !(f instanceof Error) && t(
            (c || "React class") + ": type specification of " + s + " `" + u + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof f + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), f instanceof Error && !(f.message in n)) {
            n[f.message] = !0;
            var g = d ? d() : "";
            t(
              "Failed " + s + " type: " + f.message + (g ?? "")
            );
          }
        }
    }
  }
  return a.resetWarningCache = function() {
    process.env.NODE_ENV !== "production" && (n = {});
  }, Bo = a, Bo;
}
var jo, T1;
function xE() {
  if (T1) return jo;
  T1 = 1;
  var t = d0(), e = wE(), n = /* @__PURE__ */ zs(), r = /* @__PURE__ */ u0(), a = /* @__PURE__ */ $E(), o = function() {
  };
  process.env.NODE_ENV !== "production" && (o = function(s) {
    var c = "Warning: " + s;
    typeof console < "u" && console.error(c);
    try {
      throw new Error(c);
    } catch {
    }
  });
  function l() {
    return null;
  }
  return jo = function(s, c) {
    var d = typeof Symbol == "function" && Symbol.iterator, u = "@@iterator";
    function f(L) {
      var K = L && (d && L[d] || L[u]);
      if (typeof K == "function")
        return K;
    }
    var m = "<<anonymous>>", g = {
      array: x("array"),
      bigint: x("bigint"),
      bool: x("boolean"),
      func: x("function"),
      number: x("number"),
      object: x("object"),
      string: x("string"),
      symbol: x("symbol"),
      any: _(),
      arrayOf: N,
      element: k(),
      elementType: F(),
      instanceOf: A,
      node: W(),
      objectOf: te,
      oneOf: O,
      oneOfType: le,
      shape: Y,
      exact: ee
    };
    function C(L, K) {
      return L === K ? L !== 0 || 1 / L === 1 / K : L !== L && K !== K;
    }
    function b(L, K) {
      this.message = L, this.data = K && typeof K == "object" ? K : {}, this.stack = "";
    }
    b.prototype = Error.prototype;
    function E(L) {
      if (process.env.NODE_ENV !== "production")
        var K = {}, P = 0;
      function D(H, j, Z, ne, ie, ce, Oe) {
        if (ne = ne || m, ce = ce || Z, Oe !== n) {
          if (c) {
            var V = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw V.name = "Invariant Violation", V;
          } else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
            var Be = ne + ":" + Z;
            !K[Be] && // Avoid spamming the console because they are often not actionable except for lib authors
            P < 3 && (o(
              "You are manually calling a React.PropTypes validation function for the `" + ce + "` prop on `" + ne + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), K[Be] = !0, P++);
          }
        }
        return j[Z] == null ? H ? j[Z] === null ? new b("The " + ie + " `" + ce + "` is marked as required " + ("in `" + ne + "`, but its value is `null`.")) : new b("The " + ie + " `" + ce + "` is marked as required in " + ("`" + ne + "`, but its value is `undefined`.")) : null : L(j, Z, ne, ie, ce);
      }
      var B = D.bind(null, !1);
      return B.isRequired = D.bind(null, !0), B;
    }
    function x(L) {
      function K(P, D, B, H, j, Z) {
        var ne = P[D], ie = M(ne);
        if (ie !== L) {
          var ce = X(ne);
          return new b(
            "Invalid " + H + " `" + j + "` of type " + ("`" + ce + "` supplied to `" + B + "`, expected ") + ("`" + L + "`."),
            { expectedType: L }
          );
        }
        return null;
      }
      return E(K);
    }
    function _() {
      return E(l);
    }
    function N(L) {
      function K(P, D, B, H, j) {
        if (typeof L != "function")
          return new b("Property `" + j + "` of component `" + B + "` has invalid PropType notation inside arrayOf.");
        var Z = P[D];
        if (!Array.isArray(Z)) {
          var ne = M(Z);
          return new b("Invalid " + H + " `" + j + "` of type " + ("`" + ne + "` supplied to `" + B + "`, expected an array."));
        }
        for (var ie = 0; ie < Z.length; ie++) {
          var ce = L(Z, ie, B, H, j + "[" + ie + "]", n);
          if (ce instanceof Error)
            return ce;
        }
        return null;
      }
      return E(K);
    }
    function k() {
      function L(K, P, D, B, H) {
        var j = K[P];
        if (!s(j)) {
          var Z = M(j);
          return new b("Invalid " + B + " `" + H + "` of type " + ("`" + Z + "` supplied to `" + D + "`, expected a single ReactElement."));
        }
        return null;
      }
      return E(L);
    }
    function F() {
      function L(K, P, D, B, H) {
        var j = K[P];
        if (!t.isValidElementType(j)) {
          var Z = M(j);
          return new b("Invalid " + B + " `" + H + "` of type " + ("`" + Z + "` supplied to `" + D + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return E(L);
    }
    function A(L) {
      function K(P, D, B, H, j) {
        if (!(P[D] instanceof L)) {
          var Z = L.name || m, ne = he(P[D]);
          return new b("Invalid " + H + " `" + j + "` of type " + ("`" + ne + "` supplied to `" + B + "`, expected ") + ("instance of `" + Z + "`."));
        }
        return null;
      }
      return E(K);
    }
    function O(L) {
      if (!Array.isArray(L))
        return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? o(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : o("Invalid argument supplied to oneOf, expected an array.")), l;
      function K(P, D, B, H, j) {
        for (var Z = P[D], ne = 0; ne < L.length; ne++)
          if (C(Z, L[ne]))
            return null;
        var ie = JSON.stringify(L, function(Oe, V) {
          var Be = X(V);
          return Be === "symbol" ? String(V) : V;
        });
        return new b("Invalid " + H + " `" + j + "` of value `" + String(Z) + "` " + ("supplied to `" + B + "`, expected one of " + ie + "."));
      }
      return E(K);
    }
    function te(L) {
      function K(P, D, B, H, j) {
        if (typeof L != "function")
          return new b("Property `" + j + "` of component `" + B + "` has invalid PropType notation inside objectOf.");
        var Z = P[D], ne = M(Z);
        if (ne !== "object")
          return new b("Invalid " + H + " `" + j + "` of type " + ("`" + ne + "` supplied to `" + B + "`, expected an object."));
        for (var ie in Z)
          if (r(Z, ie)) {
            var ce = L(Z, ie, B, H, j + "." + ie, n);
            if (ce instanceof Error)
              return ce;
          }
        return null;
      }
      return E(K);
    }
    function le(L) {
      if (!Array.isArray(L))
        return process.env.NODE_ENV !== "production" && o("Invalid argument supplied to oneOfType, expected an instance of array."), l;
      for (var K = 0; K < L.length; K++) {
        var P = L[K];
        if (typeof P != "function")
          return o(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + se(P) + " at index " + K + "."
          ), l;
      }
      function D(B, H, j, Z, ne) {
        for (var ie = [], ce = 0; ce < L.length; ce++) {
          var Oe = L[ce], V = Oe(B, H, j, Z, ne, n);
          if (V == null)
            return null;
          V.data && r(V.data, "expectedType") && ie.push(V.data.expectedType);
        }
        var Be = ie.length > 0 ? ", expected one of type [" + ie.join(", ") + "]" : "";
        return new b("Invalid " + Z + " `" + ne + "` supplied to " + ("`" + j + "`" + Be + "."));
      }
      return E(D);
    }
    function W() {
      function L(K, P, D, B, H) {
        return I(K[P]) ? null : new b("Invalid " + B + " `" + H + "` supplied to " + ("`" + D + "`, expected a ReactNode."));
      }
      return E(L);
    }
    function y(L, K, P, D, B) {
      return new b(
        (L || "React class") + ": " + K + " type `" + P + "." + D + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + B + "`."
      );
    }
    function Y(L) {
      function K(P, D, B, H, j) {
        var Z = P[D], ne = M(Z);
        if (ne !== "object")
          return new b("Invalid " + H + " `" + j + "` of type `" + ne + "` " + ("supplied to `" + B + "`, expected `object`."));
        for (var ie in L) {
          var ce = L[ie];
          if (typeof ce != "function")
            return y(B, H, j, ie, X(ce));
          var Oe = ce(Z, ie, B, H, j + "." + ie, n);
          if (Oe)
            return Oe;
        }
        return null;
      }
      return E(K);
    }
    function ee(L) {
      function K(P, D, B, H, j) {
        var Z = P[D], ne = M(Z);
        if (ne !== "object")
          return new b("Invalid " + H + " `" + j + "` of type `" + ne + "` " + ("supplied to `" + B + "`, expected `object`."));
        var ie = e({}, P[D], L);
        for (var ce in ie) {
          var Oe = L[ce];
          if (r(L, ce) && typeof Oe != "function")
            return y(B, H, j, ce, X(Oe));
          if (!Oe)
            return new b(
              "Invalid " + H + " `" + j + "` key `" + ce + "` supplied to `" + B + "`.\nBad object: " + JSON.stringify(P[D], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(L), null, "  ")
            );
          var V = Oe(Z, ce, B, H, j + "." + ce, n);
          if (V)
            return V;
        }
        return null;
      }
      return E(K);
    }
    function I(L) {
      switch (typeof L) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !L;
        case "object":
          if (Array.isArray(L))
            return L.every(I);
          if (L === null || s(L))
            return !0;
          var K = f(L);
          if (K) {
            var P = K.call(L), D;
            if (K !== L.entries) {
              for (; !(D = P.next()).done; )
                if (!I(D.value))
                  return !1;
            } else
              for (; !(D = P.next()).done; ) {
                var B = D.value;
                if (B && !I(B[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function Q(L, K) {
      return L === "symbol" ? !0 : K ? K["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && K instanceof Symbol : !1;
    }
    function M(L) {
      var K = typeof L;
      return Array.isArray(L) ? "array" : L instanceof RegExp ? "object" : Q(K, L) ? "symbol" : K;
    }
    function X(L) {
      if (typeof L > "u" || L === null)
        return "" + L;
      var K = M(L);
      if (K === "object") {
        if (L instanceof Date)
          return "date";
        if (L instanceof RegExp)
          return "regexp";
      }
      return K;
    }
    function se(L) {
      var K = X(L);
      switch (K) {
        case "array":
        case "object":
          return "an " + K;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + K;
        default:
          return K;
      }
    }
    function he(L) {
      return !L.constructor || !L.constructor.name ? m : L.constructor.name;
    }
    return g.checkPropTypes = a, g.resetWarningCache = a.resetWarningCache, g.PropTypes = g, g;
  }, jo;
}
var Vo, A1;
function CE() {
  if (A1) return Vo;
  A1 = 1;
  var t = /* @__PURE__ */ zs();
  function e() {
  }
  function n() {
  }
  return n.resetWarningCache = e, Vo = function() {
    function r(l, s, c, d, u, f) {
      if (f !== t) {
        var m = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw m.name = "Invariant Violation", m;
      }
    }
    r.isRequired = r;
    function a() {
      return r;
    }
    var o = {
      array: r,
      bigint: r,
      bool: r,
      func: r,
      number: r,
      object: r,
      string: r,
      symbol: r,
      any: r,
      arrayOf: a,
      element: r,
      elementType: r,
      instanceOf: a,
      node: r,
      objectOf: a,
      oneOf: a,
      oneOfType: a,
      shape: a,
      exact: a,
      checkPropTypes: n,
      resetWarningCache: e
    };
    return o.PropTypes = o, o;
  }, Vo;
}
var z1;
function ME() {
  if (z1) return La.exports;
  if (z1 = 1, process.env.NODE_ENV !== "production") {
    var t = d0(), e = !0;
    La.exports = /* @__PURE__ */ xE()(t.isElement, e);
  } else
    La.exports = /* @__PURE__ */ CE()();
  return La.exports;
}
var SE = /* @__PURE__ */ ME();
const T = /* @__PURE__ */ Fs(SE);
var Uo = { exports: {} };
var D1;
function FE() {
  return D1 || (D1 = 1, (function(t) {
    (function() {
      var e = {}.hasOwnProperty;
      function n() {
        for (var o = "", l = 0; l < arguments.length; l++) {
          var s = arguments[l];
          s && (o = a(o, r(s)));
        }
        return o;
      }
      function r(o) {
        if (typeof o == "string" || typeof o == "number")
          return o;
        if (typeof o != "object")
          return "";
        if (Array.isArray(o))
          return n.apply(null, o);
        if (o.toString !== Object.prototype.toString && !o.toString.toString().includes("[native code]"))
          return o.toString();
        var l = "";
        for (var s in o)
          e.call(o, s) && o[s] && (l = a(l, s));
        return l;
      }
      function a(o, l) {
        return l ? o ? o + " " + l : o + l : o;
      }
      t.exports ? (n.default = n, t.exports = n) : window.classNames = n;
    })();
  })(Uo)), Uo.exports;
}
var PE = FE();
const wi = /* @__PURE__ */ Fs(PE);
function NE(t, e, n) {
  switch (n) {
    case "Backspace":
      e > 0 && (t = t.slice(0, e - 1) + t.slice(e), e--);
      break;
    case "Delete":
      t = t.slice(0, e) + t.slice(e + 1);
      break;
  }
  return {
    value: t,
    caret: e
  };
}
function _E(t, e, n) {
  for (var r = {}, a = "", o = 0, l = 0; l < t.length; ) {
    var s = n(t[l], a, r);
    s !== void 0 && (a += s, e !== void 0 && (e === l ? o = a.length - 1 : e > l && (o = a.length))), l++;
  }
  e === void 0 && (o = a.length);
  var c = {
    value: a,
    caret: o
  };
  return c;
}
function TE(t, e) {
  var n = typeof Symbol < "u" && t[Symbol.iterator] || t["@@iterator"];
  if (n) return (n = n.call(t)).next.bind(n);
  if (Array.isArray(t) || (n = AE(t)) || e) {
    n && (t = n);
    var r = 0;
    return function() {
      return r >= t.length ? { done: !0 } : { done: !1, value: t[r++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function AE(t, e) {
  if (t) {
    if (typeof t == "string") return I1(t, e);
    var n = Object.prototype.toString.call(t).slice(8, -1);
    if (n === "Object" && t.constructor && (n = t.constructor.name), n === "Map" || n === "Set") return Array.from(t);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return I1(t, e);
  }
}
function I1(t, e) {
  (e == null || e > t.length) && (e = t.length);
  for (var n = 0, r = new Array(e); n < e; n++)
    r[n] = t[n];
  return r;
}
function Ol(t, e) {
  for (var n = 0, r = TE(e.split("")), a; !(a = r()).done; ) {
    var o = a.value;
    o === t && n++;
  }
  return n;
}
function zE(t, e) {
  for (var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "x", r = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : " ", a = t.length, o = Ol("(", t), l = Ol(")", t), s = o - l; s > 0 && a < e.length; )
    t += e[a].replace(n, r), e[a] === ")" && s--, a++;
  return t;
}
function DE(t, e) {
  var n = typeof Symbol < "u" && t[Symbol.iterator] || t["@@iterator"];
  if (n) return (n = n.call(t)).next.bind(n);
  if (Array.isArray(t) || (n = IE(t)) || e) {
    n && (t = n);
    var r = 0;
    return function() {
      return r >= t.length ? { done: !0 } : { done: !1, value: t[r++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function IE(t, e) {
  if (t) {
    if (typeof t == "string") return k1(t, e);
    var n = Object.prototype.toString.call(t).slice(8, -1);
    if (n === "Object" && t.constructor && (n = t.constructor.name), n === "Map" || n === "Set") return Array.from(t);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return k1(t, e);
  }
}
function k1(t, e) {
  (e == null || e > t.length) && (e = t.length);
  for (var n = 0, r = new Array(e); n < e; n++)
    r[n] = t[n];
  return r;
}
function kE(t) {
  var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "x", n = arguments.length > 2 ? arguments[2] : void 0;
  if (!t)
    return function(a) {
      return {
        text: a
      };
    };
  var r = Ol(e, t);
  return function(a) {
    if (!a)
      return {
        text: "",
        template: t
      };
    for (var o = 0, l = "", s = DE(t.split("")), c; !(c = s()).done; ) {
      var d = c.value;
      if (d !== e) {
        l += d;
        continue;
      }
      if (l += a[o], o++, o === a.length && a.length < r)
        break;
    }
    return n && (l = zE(l, t)), {
      text: l,
      template: t
    };
  };
}
function OE(t, e, n) {
  typeof n == "string" && (n = kE(n));
  var r = n(t) || {}, a = r.text, o = r.template;
  if (a === void 0 && (a = t), o)
    if (e === void 0)
      e = a.length;
    else {
      for (var l = 0, s = !1, c = -1; l < a.length && l < o.length; ) {
        if (a[l] !== o[l]) {
          if (e === 0) {
            s = !0, e = l;
            break;
          }
          c = l, e--;
        }
        l++;
      }
      s || (e = c + 1);
    }
  return {
    text: a,
    caret: e
  };
}
function LE(t) {
  return t.hasAttribute("readonly");
}
function RE(t) {
  if (t.selectionStart !== t.selectionEnd)
    return {
      start: t.selectionStart,
      end: t.selectionEnd
    };
}
var O1 = {
  Backspace: 8,
  Delete: 46
};
function HE(t) {
  switch (t.keyCode) {
    case O1.Backspace:
      return "Backspace";
    case O1.Delete:
      return "Delete";
  }
}
function BE(t) {
  return t.selectionStart;
}
function f0(t, e) {
  e !== void 0 && (jE() ? setTimeout(function() {
    return t.setSelectionRange(e, e);
  }, 0) : t.setSelectionRange(e, e));
}
function jE() {
  if (typeof navigator < "u")
    return VE.test(navigator.userAgent);
}
var VE = /Android/i;
function UE(t, e, n, r, a) {
  Ll(e, n, r, void 0, a);
}
function WE(t, e, n, r, a) {
  if (!LE(e)) {
    var o = HE(t);
    switch (o) {
      case "Delete":
      case "Backspace":
        t.preventDefault();
        var l = RE(e);
        return l ? (GE(e, l), Ll(e, n, r, void 0, a)) : Ll(e, n, r, o, a);
    }
  }
}
function GE(t, e) {
  var n = t.value;
  n = n.slice(0, e.start) + n.slice(e.end), t.value = n, f0(t, e.start);
}
function Ll(t, e, n, r, a) {
  var o = _E(t.value, BE(t), e), l = o.value, s = o.caret;
  if (r) {
    var c = NE(l, s, r);
    l = c.value, s = c.caret;
  }
  var d = OE(l, s, n), u = d.text;
  s = d.caret, t.value = u, f0(t, s), a && a(l);
}
var KE = ["ref", "parse", "format", "value", "defaultValue", "controlled", "onChange", "onKeyDown"];
function L1(t, e) {
  var n = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(t);
    e && (r = r.filter(function(a) {
      return Object.getOwnPropertyDescriptor(t, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function Vn(t) {
  for (var e = 1; e < arguments.length; e++) {
    var n = arguments[e] != null ? arguments[e] : {};
    e % 2 ? L1(Object(n), !0).forEach(function(r) {
      qE(t, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : L1(Object(n)).forEach(function(r) {
      Object.defineProperty(t, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return t;
}
function qE(t, e, n) {
  return e in t ? Object.defineProperty(t, e, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = n, t;
}
function YE(t, e) {
  if (t == null) return {};
  var n = ZE(t, e), r, a;
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(t);
    for (a = 0; a < o.length; a++)
      r = o[a], !(e.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(t, r) && (n[r] = t[r]);
  }
  return n;
}
function ZE(t, e) {
  if (t == null) return {};
  var n = {}, r = Object.keys(t), a, o;
  for (o = 0; o < r.length; o++)
    a = r[o], !(e.indexOf(a) >= 0) && (n[a] = t[a]);
  return n;
}
function XE(t) {
  var e = t.ref, n = t.parse, r = t.format, a = t.value, o = t.defaultValue, l = t.controlled, s = l === void 0 ? !0 : l, c = t.onChange, d = t.onKeyDown, u = YE(t, KE), f = $e(), m = de(function(E) {
    f.current = E, e && (typeof e == "function" ? e(E) : e.current = E);
  }, [e]), g = de(function(E) {
    return UE(E, f.current, n, r, c);
  }, [f, n, r, c]), C = de(function(E) {
    if (d && d(E), !E.defaultPrevented)
      return WE(E, f.current, n, r, c);
  }, [f, n, r, c, d]), b = Vn(Vn({}, u), {}, {
    ref: m,
    onChange: g,
    onKeyDown: C
  });
  return s ? Vn(Vn({}, b), {}, {
    value: r(R1(a) ? "" : a).text
  }) : Vn(Vn({}, b), {}, {
    defaultValue: r(R1(o) ? "" : o).text
  });
}
function R1(t) {
  return t == null;
}
var JE = ["inputComponent", "parse", "format", "value", "defaultValue", "onChange", "controlled", "onKeyDown", "type"];
function H1(t, e) {
  var n = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(t);
    e && (r = r.filter(function(a) {
      return Object.getOwnPropertyDescriptor(t, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function QE(t) {
  for (var e = 1; e < arguments.length; e++) {
    var n = arguments[e] != null ? arguments[e] : {};
    e % 2 ? H1(Object(n), !0).forEach(function(r) {
      ew(t, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : H1(Object(n)).forEach(function(r) {
      Object.defineProperty(t, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return t;
}
function ew(t, e, n) {
  return e in t ? Object.defineProperty(t, e, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = n, t;
}
function tw(t, e) {
  if (t == null) return {};
  var n = nw(t, e), r, a;
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(t);
    for (a = 0; a < o.length; a++)
      r = o[a], !(e.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(t, r) && (n[r] = t[r]);
  }
  return n;
}
function nw(t, e) {
  if (t == null) return {};
  var n = {}, r = Object.keys(t), a, o;
  for (o = 0; o < r.length; o++)
    a = r[o], !(e.indexOf(a) >= 0) && (n[a] = t[a]);
  return n;
}
function $i(t, e) {
  var n = t.inputComponent, r = n === void 0 ? "input" : n, a = t.parse, o = t.format, l = t.value, s = t.defaultValue, c = t.onChange, d = t.controlled, u = t.onKeyDown, f = t.type, m = f === void 0 ? "text" : f, g = tw(t, JE), C = XE(QE({
    ref: e,
    parse: a,
    format: o,
    value: l,
    defaultValue: s,
    onChange: c,
    controlled: d,
    onKeyDown: u,
    type: m
  }, g));
  return /* @__PURE__ */ i.createElement(r, C);
}
$i = /* @__PURE__ */ i.forwardRef($i);
$i.propTypes = {
  // Parses a single characher of `<input/>` text.
  parse: T.func.isRequired,
  // Formats `value` into `<input/>` text.
  format: T.func.isRequired,
  // Renders `<input/>` by default.
  inputComponent: T.elementType,
  // `<input/>` `type` attribute.
  type: T.string,
  // Is parsed from <input/> text.
  value: T.string,
  // An initial value for an "uncontrolled" <input/>.
  defaultValue: T.string,
  // This handler is called each time `<input/>` text is changed.
  onChange: T.func,
  // Whether this input should be "controlled" or "uncontrolled".
  // The default value is `true` meaning "uncontrolled".
  controlled: T.bool,
  // Passthrough
  onKeyDown: T.func,
  onCut: T.func,
  onPaste: T.func
};
function p0(t) {
  var e = t.inputFormat, n = t.country, r = t.metadata;
  return e === "NATIONAL_PART_OF_INTERNATIONAL" ? "+".concat(Wt(n, r)) : "";
}
function Rl(t, e) {
  return e && (t = t.slice(e.length), t[0] === " " && (t = t.slice(1))), t;
}
function rw(t, e, n) {
  if (!(n && n.ignoreRest)) {
    var r = function(o) {
      if (n)
        switch (o) {
          case "end":
            n.ignoreRest = !0;
            break;
        }
    };
    return o0(t, e, r);
  }
}
function m0(t) {
  var e = t.onKeyDown, n = t.inputFormat;
  return de(function(r) {
    if (r.keyCode === iw && n === "INTERNATIONAL" && r.target instanceof HTMLInputElement && aw(r.target) === ow.length) {
      r.preventDefault();
      return;
    }
    e && e(r);
  }, [e, n]);
}
function aw(t) {
  return t.selectionStart;
}
var iw = 8, ow = "+", lw = ["onKeyDown", "country", "inputFormat", "metadata", "international", "withCountryCallingCode"];
function Hl() {
  return Hl = Object.assign ? Object.assign.bind() : function(t) {
    for (var e = 1; e < arguments.length; e++) {
      var n = arguments[e];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
    }
    return t;
  }, Hl.apply(this, arguments);
}
function sw(t, e) {
  if (t == null) return {};
  var n = cw(t, e), r, a;
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(t);
    for (a = 0; a < o.length; a++)
      r = o[a], !(e.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(t, r) && (n[r] = t[r]);
  }
  return n;
}
function cw(t, e) {
  if (t == null) return {};
  var n = {}, r = Object.keys(t), a, o;
  for (o = 0; o < r.length; o++)
    a = r[o], !(e.indexOf(a) >= 0) && (n[a] = t[a]);
  return n;
}
function dw(t) {
  function e(n, r) {
    var a = n.onKeyDown, o = n.country, l = n.inputFormat, s = n.metadata, c = s === void 0 ? t : s;
    n.international, n.withCountryCallingCode;
    var d = sw(n, lw), u = de(function(m) {
      var g = new yr(o, c), C = p0({
        inputFormat: l,
        country: o,
        metadata: c
      }), b = g.input(C + m), E = g.getTemplate();
      return C && (b = Rl(b, C), E && (E = Rl(E, C))), {
        text: b,
        template: E
      };
    }, [o, c]), f = m0({
      onKeyDown: a,
      inputFormat: l
    });
    return /* @__PURE__ */ i.createElement($i, Hl({}, d, {
      ref: r,
      parse: rw,
      format: u,
      onKeyDown: f
    }));
  }
  return e = /* @__PURE__ */ i.forwardRef(e), e.propTypes = {
    /**
     * The parsed phone number.
     * "Parsed" not in a sense of "E.164"
     * but rather in a sense of "having only
     * digits and possibly a leading plus character".
     * Examples: `""`, `"+"`, `"+123"`, `"123"`.
     */
    value: T.string.isRequired,
    /**
     * A function of `value: string`.
     * Updates the `value` property.
     */
    onChange: T.func.isRequired,
    /**
     * A function of `event: Event`.
     * Handles `keydown` events.
     */
    onKeyDown: T.func,
    /**
     * A two-letter country code for formatting `value`
     * as a national phone number (e.g. `(800) 555 35 35`).
     * E.g. "US", "RU", etc.
     * If no `country` is passed then `value`
     * is formatted as an international phone number.
     * (e.g. `+7 800 555 35 35`)
     * This property should've been called `defaultCountry`
     * because it only applies when the user inputs a phone number in a national format
     * and is completely ignored when the user inputs a phone number in an international format.
     */
    country: T.string,
    /**
     * The format that the input field value is being input/output in.
     */
    inputFormat: T.oneOf(["INTERNATIONAL", "NATIONAL_PART_OF_INTERNATIONAL", "NATIONAL", "INTERNATIONAL_OR_NATIONAL"]).isRequired,
    /**
     * `libphonenumber-js` metadata.
     */
    metadata: T.object
  }, e;
}
const uw = dw();
var fw = ["value", "onChange", "onKeyDown", "country", "inputFormat", "metadata", "inputComponent", "international", "withCountryCallingCode"];
function Bl() {
  return Bl = Object.assign ? Object.assign.bind() : function(t) {
    for (var e = 1; e < arguments.length; e++) {
      var n = arguments[e];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
    }
    return t;
  }, Bl.apply(this, arguments);
}
function pw(t, e) {
  if (t == null) return {};
  var n = mw(t, e), r, a;
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(t);
    for (a = 0; a < o.length; a++)
      r = o[a], !(e.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(t, r) && (n[r] = t[r]);
  }
  return n;
}
function mw(t, e) {
  if (t == null) return {};
  var n = {}, r = Object.keys(t), a, o;
  for (o = 0; o < r.length; o++)
    a = r[o], !(e.indexOf(a) >= 0) && (n[a] = t[a]);
  return n;
}
function hw(t) {
  function e(n, r) {
    var a = n.value, o = n.onChange, l = n.onKeyDown, s = n.country, c = n.inputFormat, d = n.metadata, u = d === void 0 ? t : d, f = n.inputComponent, m = f === void 0 ? "input" : f;
    n.international, n.withCountryCallingCode;
    var g = pw(n, fw), C = p0({
      inputFormat: c,
      country: s,
      metadata: u
    }), b = de(function(x) {
      var _ = _l(x.target.value);
      if (_ === a) {
        var N = B1(C, _, s, u);
        N.indexOf(x.target.value) === 0 && (_ = _.slice(0, -1));
      }
      o(_);
    }, [C, a, o, s, u]), E = m0({
      onKeyDown: l,
      inputFormat: c
    });
    return /* @__PURE__ */ i.createElement(m, Bl({}, g, {
      ref: r,
      value: B1(C, a, s, u),
      onChange: b,
      onKeyDown: E
    }));
  }
  return e = /* @__PURE__ */ i.forwardRef(e), e.propTypes = {
    /**
     * The parsed phone number.
     * "Parsed" not in a sense of "E.164"
     * but rather in a sense of "having only
     * digits and possibly a leading plus character".
     * Examples: `""`, `"+"`, `"+123"`, `"123"`.
     */
    value: T.string.isRequired,
    /**
     * A function of `value: string`.
     * Updates the `value` property.
     */
    onChange: T.func.isRequired,
    /**
     * A function of `event: Event`.
     * Handles `keydown` events.
     */
    onKeyDown: T.func,
    /**
     * A two-letter country code for formatting `value`
     * as a national phone number (e.g. `(800) 555 35 35`).
     * E.g. "US", "RU", etc.
     * If no `country` is passed then `value`
     * is formatted as an international phone number.
     * (e.g. `+7 800 555 35 35`)
     * This property should've been called `defaultCountry`
     * because it only applies when the user inputs a phone number in a national format
     * and is completely ignored when the user inputs a phone number in an international format.
     */
    country: T.string,
    /**
     * The format that the input field value is being input/output in.
     */
    inputFormat: T.oneOf(["INTERNATIONAL", "NATIONAL_PART_OF_INTERNATIONAL", "NATIONAL", "INTERNATIONAL_OR_NATIONAL"]).isRequired,
    /**
     * `libphonenumber-js` metadata.
     */
    metadata: T.object,
    /**
     * The `<input/>` component.
     */
    inputComponent: T.elementType
  }, e;
}
const vw = hw();
function B1(t, e, n, r) {
  return Rl(Hb(t + e, n, r), t);
}
function gw(t) {
  return j1(t[0]) + j1(t[1]);
}
function j1(t) {
  return String.fromCodePoint(127397 + t.toUpperCase().charCodeAt(0));
}
var yw = ["value", "onChange", "options", "disabled", "readOnly"], bw = ["value", "options", "className", "iconComponent", "getIconAspectRatio", "arrowComponent", "unicodeFlags"];
function Ew(t, e) {
  var n = typeof Symbol < "u" && t[Symbol.iterator] || t["@@iterator"];
  if (n) return (n = n.call(t)).next.bind(n);
  if (Array.isArray(t) || (n = ww(t)) || e) {
    n && (t = n);
    var r = 0;
    return function() {
      return r >= t.length ? { done: !0 } : { done: !1, value: t[r++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function ww(t, e) {
  if (t) {
    if (typeof t == "string") return V1(t, e);
    var n = Object.prototype.toString.call(t).slice(8, -1);
    if (n === "Object" && t.constructor && (n = t.constructor.name), n === "Map" || n === "Set") return Array.from(t);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return V1(t, e);
  }
}
function V1(t, e) {
  (e == null || e > t.length) && (e = t.length);
  for (var n = 0, r = new Array(e); n < e; n++) r[n] = t[n];
  return r;
}
function xi() {
  return xi = Object.assign ? Object.assign.bind() : function(t) {
    for (var e = 1; e < arguments.length; e++) {
      var n = arguments[e];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
    }
    return t;
  }, xi.apply(this, arguments);
}
function h0(t, e) {
  if (t == null) return {};
  var n = $w(t, e), r, a;
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(t);
    for (a = 0; a < o.length; a++)
      r = o[a], !(e.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(t, r) && (n[r] = t[r]);
  }
  return n;
}
function $w(t, e) {
  if (t == null) return {};
  var n = {}, r = Object.keys(t), a, o;
  for (o = 0; o < r.length; o++)
    a = r[o], !(e.indexOf(a) >= 0) && (n[a] = t[a]);
  return n;
}
function v0(t) {
  var e = t.value, n = t.onChange, r = t.options, a = t.disabled, o = t.readOnly, l = h0(t, yw), s = de(function(c) {
    var d = c.target.value;
    n(d === "ZZ" ? void 0 : d);
  }, [n]);
  return Fe(function() {
    return y0(r, e);
  }, [r, e]), /* @__PURE__ */ i.createElement("select", xi({}, l, {
    disabled: a || o,
    readOnly: o,
    value: e || "ZZ",
    onChange: s
  }), r.map(function(c) {
    var d = c.value, u = c.label, f = c.divider;
    return /* @__PURE__ */ i.createElement("option", {
      key: f ? "|" : d || "ZZ",
      value: f ? "|" : d || "ZZ",
      disabled: !!f,
      style: f ? xw : void 0
    }, u);
  }));
}
v0.propTypes = {
  /**
   * A two-letter country code.
   * Example: "US", "RU", etc.
   */
  value: T.string,
  /**
   * A function of `value: string`.
   * Updates the `value` property.
   */
  onChange: T.func.isRequired,
  // `<select/>` options.
  options: T.arrayOf(T.shape({
    value: T.string,
    label: T.string,
    divider: T.bool
  })).isRequired,
  // `readonly` attribute doesn't work on a `<select/>`.
  // https://github.com/catamphetamine/react-phone-number-input/issues/419#issuecomment-1764384480
  // https://www.delftstack.com/howto/html/html-select-readonly/
  // To work around that, if `readOnly: true` property is passed
  // to this component, it behaves analogous to `disabled: true`.
  disabled: T.bool,
  readOnly: T.bool
};
var xw = {
  fontSize: "1px",
  backgroundColor: "currentColor",
  color: "inherit"
};
function g0(t) {
  var e = t.value, n = t.options, r = t.className, a = t.iconComponent;
  t.getIconAspectRatio;
  var o = t.arrowComponent, l = o === void 0 ? Cw : o, s = t.unicodeFlags, c = h0(t, bw), d = Fe(function() {
    return y0(n, e);
  }, [n, e]);
  return /* @__PURE__ */ i.createElement("div", {
    className: "PhoneInputCountry"
  }, /* @__PURE__ */ i.createElement(v0, xi({}, c, {
    value: e,
    options: n,
    className: wi("PhoneInputCountrySelect", r)
  })), d && (s && e ? /* @__PURE__ */ i.createElement("div", {
    className: "PhoneInputCountryIconUnicode"
  }, gw(e)) : /* @__PURE__ */ i.createElement(a, {
    "aria-hidden": !0,
    country: e,
    label: d.label,
    aspectRatio: s ? 1 : void 0
  })), /* @__PURE__ */ i.createElement(l, null));
}
g0.propTypes = {
  // Country flag component.
  iconComponent: T.elementType,
  // Select arrow component.
  arrowComponent: T.elementType,
  // Set to `true` to render Unicode flag icons instead of SVG images.
  unicodeFlags: T.bool
};
function Cw() {
  return /* @__PURE__ */ i.createElement("div", {
    className: "PhoneInputCountrySelectArrow"
  });
}
function y0(t, e) {
  for (var n = Ew(t), r; !(r = n()).done; ) {
    var a = r.value;
    if (!a.divider && Mw(a.value, e))
      return a;
  }
}
function Mw(t, e) {
  return t == null ? e == null : t === e;
}
var Sw = ["country", "countryName", "flags", "flagUrl"];
function jl() {
  return jl = Object.assign ? Object.assign.bind() : function(t) {
    for (var e = 1; e < arguments.length; e++) {
      var n = arguments[e];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
    }
    return t;
  }, jl.apply(this, arguments);
}
function Fw(t, e) {
  if (t == null) return {};
  var n = Pw(t, e), r, a;
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(t);
    for (a = 0; a < o.length; a++)
      r = o[a], !(e.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(t, r) && (n[r] = t[r]);
  }
  return n;
}
function Pw(t, e) {
  if (t == null) return {};
  var n = {}, r = Object.keys(t), a, o;
  for (o = 0; o < r.length; o++)
    a = r[o], !(e.indexOf(a) >= 0) && (n[a] = t[a]);
  return n;
}
function Ds(t) {
  var e = t.country, n = t.countryName, r = t.flags, a = t.flagUrl, o = Fw(t, Sw);
  return r && r[e] ? r[e]({
    title: n
  }) : /* @__PURE__ */ i.createElement("img", jl({}, o, {
    alt: n,
    role: n ? void 0 : "presentation",
    src: a.replace("{XX}", e).replace("{xx}", e.toLowerCase())
  }));
}
Ds.propTypes = {
  // The country to be selected by default.
  // Two-letter country code ("ISO 3166-1 alpha-2").
  country: T.string.isRequired,
  // Will be HTML `title` attribute of the `<img/>`.
  countryName: T.string.isRequired,
  // Country flag icon components.
  // By default flag icons are inserted as `<img/>`s
  // with their `src` pointed to `country-flag-icons` gitlab pages website.
  // There might be cases (e.g. an offline application)
  // where having a large (3 megabyte) `<svg/>` flags
  // bundle is more appropriate.
  // `import flags from 'react-phone-number-input/flags'`.
  flags: T.objectOf(T.elementType),
  // A URL for a country flag icon.
  // By default it points to `country-flag-icons` gitlab pages website.
  flagUrl: T.string.isRequired
};
var Nw = ["aspectRatio"], _w = ["title"], Tw = ["title"];
function Ci() {
  return Ci = Object.assign ? Object.assign.bind() : function(t) {
    for (var e = 1; e < arguments.length; e++) {
      var n = arguments[e];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
    }
    return t;
  }, Ci.apply(this, arguments);
}
function Is(t, e) {
  if (t == null) return {};
  var n = Aw(t, e), r, a;
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(t);
    for (a = 0; a < o.length; a++)
      r = o[a], !(e.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(t, r) && (n[r] = t[r]);
  }
  return n;
}
function Aw(t, e) {
  if (t == null) return {};
  var n = {}, r = Object.keys(t), a, o;
  for (o = 0; o < r.length; o++)
    a = r[o], !(e.indexOf(a) >= 0) && (n[a] = t[a]);
  return n;
}
function Xi(t) {
  var e = t.aspectRatio, n = Is(t, Nw);
  return e === 1 ? /* @__PURE__ */ i.createElement(E0, n) : /* @__PURE__ */ i.createElement(b0, n);
}
Xi.propTypes = {
  title: T.string.isRequired,
  aspectRatio: T.number
};
function b0(t) {
  var e = t.title, n = Is(t, _w);
  return /* @__PURE__ */ i.createElement("svg", Ci({}, n, {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 75 50"
  }), /* @__PURE__ */ i.createElement("title", null, e), /* @__PURE__ */ i.createElement("g", {
    className: "PhoneInputInternationalIconGlobe",
    stroke: "currentColor",
    fill: "none",
    strokeWidth: "2",
    strokeMiterlimit: "10"
  }, /* @__PURE__ */ i.createElement("path", {
    strokeLinecap: "round",
    d: "M47.2,36.1C48.1,36,49,36,50,36c7.4,0,14,1.7,18.5,4.3"
  }), /* @__PURE__ */ i.createElement("path", {
    d: "M68.6,9.6C64.2,12.3,57.5,14,50,14c-7.4,0-14-1.7-18.5-4.3"
  }), /* @__PURE__ */ i.createElement("line", {
    x1: "26",
    y1: "25",
    x2: "74",
    y2: "25"
  }), /* @__PURE__ */ i.createElement("line", {
    x1: "50",
    y1: "1",
    x2: "50",
    y2: "49"
  }), /* @__PURE__ */ i.createElement("path", {
    strokeLinecap: "round",
    d: "M46.3,48.7c1.2,0.2,2.5,0.3,3.7,0.3c13.3,0,24-10.7,24-24S63.3,1,50,1S26,11.7,26,25c0,2,0.3,3.9,0.7,5.8"
  }), /* @__PURE__ */ i.createElement("path", {
    strokeLinecap: "round",
    d: "M46.8,48.2c1,0.6,2.1,0.8,3.2,0.8c6.6,0,12-10.7,12-24S56.6,1,50,1S38,11.7,38,25c0,1.4,0.1,2.7,0.2,4c0,0.1,0,0.2,0,0.2"
  })), /* @__PURE__ */ i.createElement("path", {
    className: "PhoneInputInternationalIconPhone",
    stroke: "none",
    fill: "currentColor",
    d: "M12.4,17.9c2.9-2.9,5.4-4.8,0.3-11.2S4.1,5.2,1.3,8.1C-2,11.4,1.1,23.5,13.1,35.6s24.3,15.2,27.5,11.9c2.8-2.8,7.8-6.3,1.4-11.5s-8.3-2.6-11.2,0.3c-2,2-7.2-2.2-11.7-6.7S10.4,19.9,12.4,17.9z"
  }));
}
b0.propTypes = {
  title: T.string.isRequired
};
function E0(t) {
  var e = t.title, n = Is(t, Tw);
  return /* @__PURE__ */ i.createElement("svg", Ci({}, n, {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50"
  }), /* @__PURE__ */ i.createElement("title", null, e), /* @__PURE__ */ i.createElement("g", {
    className: "PhoneInputInternationalIconGlobe",
    stroke: "currentColor",
    fill: "none",
    strokeWidth: "2",
    strokeLinecap: "round"
  }, /* @__PURE__ */ i.createElement("path", {
    d: "M8.45,13A21.44,21.44,0,1,1,37.08,41.56"
  }), /* @__PURE__ */ i.createElement("path", {
    d: "M19.36,35.47a36.9,36.9,0,0,1-2.28-13.24C17.08,10.39,21.88.85,27.8.85s10.72,9.54,10.72,21.38c0,6.48-1.44,12.28-3.71,16.21"
  }), /* @__PURE__ */ i.createElement("path", {
    d: "M17.41,33.4A39,39,0,0,1,27.8,32.06c6.62,0,12.55,1.5,16.48,3.86"
  }), /* @__PURE__ */ i.createElement("path", {
    d: "M44.29,8.53c-3.93,2.37-9.86,3.88-16.49,3.88S15.25,10.9,11.31,8.54"
  }), /* @__PURE__ */ i.createElement("line", {
    x1: "27.8",
    y1: "0.85",
    x2: "27.8",
    y2: "34.61"
  }), /* @__PURE__ */ i.createElement("line", {
    x1: "15.2",
    y1: "22.23",
    x2: "49.15",
    y2: "22.23"
  })), /* @__PURE__ */ i.createElement("path", {
    className: "PhoneInputInternationalIconPhone",
    stroke: "transparent",
    fill: "currentColor",
    d: "M9.42,26.64c2.22-2.22,4.15-3.59.22-8.49S3.08,17,.93,19.17c-2.49,2.48-.13,11.74,9,20.89s18.41,11.5,20.89,9c2.15-2.15,5.91-4.77,1-8.71s-6.27-2-8.49.22c-1.55,1.55-5.48-1.69-8.86-5.08S7.87,28.19,9.42,26.64Z"
  }));
}
E0.propTypes = {
  title: T.string.isRequired
};
function zw(t) {
  if (t.length < 2 || t[0] !== "+")
    return !1;
  for (var e = 1; e < t.length; ) {
    var n = t.charCodeAt(e);
    if (!(n >= 48 && n <= 57)) return !1;
    e++;
  }
  return !0;
}
function w0(t) {
  zw(t) || console.error("[react-phone-number-input] Expected the initial `value` to be a E.164 phone number. Got", t);
}
function Dw(t, e) {
  var n = typeof Symbol < "u" && t[Symbol.iterator] || t["@@iterator"];
  if (n) return (n = n.call(t)).next.bind(n);
  if (Array.isArray(t) || (n = Iw(t)) || e) {
    n && (t = n);
    var r = 0;
    return function() {
      return r >= t.length ? { done: !0 } : { done: !1, value: t[r++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Iw(t, e) {
  if (t) {
    if (typeof t == "string") return U1(t, e);
    var n = Object.prototype.toString.call(t).slice(8, -1);
    if (n === "Object" && t.constructor && (n = t.constructor.name), n === "Map" || n === "Set") return Array.from(t);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return U1(t, e);
  }
}
function U1(t, e) {
  (e == null || e > t.length) && (e = t.length);
  for (var n = 0, r = new Array(e); n < e; n++) r[n] = t[n];
  return r;
}
function kw(t, e) {
  if (!e)
    return t;
  for (var n = [], r = [], a = n, o = function() {
    var d = s.value;
    if (d === "|")
      a.push({
        divider: !0
      });
    else if (d === "..." || d === "…")
      a = r;
    else {
      var u;
      d === "🌐" ? u = void 0 : u = d;
      var f = t.indexOf(t.filter(function(g) {
        return g.value === u;
      })[0]), m = t[f];
      t.splice(f, 1), a.push(m);
    }
  }, l = Dw(e), s; !(s = l()).done; )
    o();
  return n.concat(t).concat(r);
}
function Ow(t, e) {
  if (t && (t = t.filter(function(n) {
    switch (n) {
      case "🌐":
      case "|":
      case "...":
      case "…":
        return !0;
      default:
        return Ji(n, e);
    }
  }), t.length > 0))
    return t;
}
function Ji(t, e) {
  return K2(t, e) ? !0 : (console.error("Country not found: ".concat(t)), !1);
}
function $0(t, e) {
  return t && (t = t.filter(function(n) {
    return Ji(n, e);
  }), t.length === 0 && (t = void 0)), t;
}
var Lw = ["country", "label", "aspectRatio"];
function Vl() {
  return Vl = Object.assign ? Object.assign.bind() : function(t) {
    for (var e = 1; e < arguments.length; e++) {
      var n = arguments[e];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
    }
    return t;
  }, Vl.apply(this, arguments);
}
function Rw(t, e) {
  if (t == null) return {};
  var n = Hw(t, e), r, a;
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(t);
    for (a = 0; a < o.length; a++)
      r = o[a], !(e.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(t, r) && (n[r] = t[r]);
  }
  return n;
}
function Hw(t, e) {
  if (t == null) return {};
  var n = {}, r = Object.keys(t), a, o;
  for (o = 0; o < r.length; o++)
    a = r[o], !(e.indexOf(a) >= 0) && (n[a] = t[a]);
  return n;
}
function x0(t) {
  var e = t.flags, n = t.flagUrl, r = t.flagComponent, a = t.internationalIcon;
  function o(l) {
    var s = l.country, c = l.label, d = l.aspectRatio, u = Rw(l, Lw), f = a === Xi ? d : void 0;
    return /* @__PURE__ */ i.createElement("div", Vl({}, u, {
      className: wi("PhoneInputCountryIcon", {
        "PhoneInputCountryIcon--square": f === 1,
        "PhoneInputCountryIcon--border": s
      })
    }), s ? /* @__PURE__ */ i.createElement(r, {
      country: s,
      countryName: c,
      flags: e,
      flagUrl: n,
      className: "PhoneInputCountryIconImg"
    }) : /* @__PURE__ */ i.createElement(a, {
      title: c,
      aspectRatio: f,
      className: "PhoneInputCountryIconImg"
    }));
  }
  return o.propTypes = {
    country: T.string,
    label: T.string.isRequired,
    aspectRatio: T.number
  }, o;
}
x0({
  // Must be equal to `defaultProps.flagUrl` in `./PhoneInputWithCountry.js`.
  flagUrl: "https://purecatamphetamine.github.io/country-flag-icons/3x2/{XX}.svg",
  flagComponent: Ds,
  internationalIcon: Xi
});
function Bw(t, e) {
  var n = typeof Symbol < "u" && t[Symbol.iterator] || t["@@iterator"];
  if (n) return (n = n.call(t)).next.bind(n);
  if (Array.isArray(t) || (n = jw(t)) || e) {
    n && (t = n);
    var r = 0;
    return function() {
      return r >= t.length ? { done: !0 } : { done: !1, value: t[r++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function jw(t, e) {
  if (t) {
    if (typeof t == "string") return W1(t, e);
    var n = Object.prototype.toString.call(t).slice(8, -1);
    if (n === "Object" && t.constructor && (n = t.constructor.name), n === "Map" || n === "Set") return Array.from(t);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return W1(t, e);
  }
}
function W1(t, e) {
  (e == null || e > t.length) && (e = t.length);
  for (var n = 0, r = new Array(e); n < e; n++) r[n] = t[n];
  return r;
}
function Vw(t, e) {
  for (var n = Bw(t), r; !(r = n()).done; ) {
    var a = r.value;
    a && Uw(a, e);
  }
}
function Uw(t, e) {
  typeof t == "function" ? t(e) : t.current = e;
}
var C0 = T.shape({
  country_calling_codes: T.object.isRequired,
  countries: T.object.isRequired
}), M0 = T.objectOf(T.string);
function Lt(t, e) {
  var n = "+" + Wt(t, e);
  return n;
}
function Ww(t) {
  var e = t.value, n = t.phoneNumber, r = t.defaultCountry, a = t.getAnyCountry, o = t.countries, l = t.required, s = t.metadata, c;
  return n && n.country ? c = n.country : r && (!e || ar(e, r, s)) && (c = r), o && o.indexOf(c) < 0 && (c = void 0), !c && l && o && o.length > 0 && (c = a()), c;
}
function Gw(t) {
  var e = t.countries, n = t.countryNames, r = t.addInternationalOption, a = t.compareStringsLocales, o = t.compareStrings;
  o || (o = Qw);
  var l = e.map(function(s) {
    return {
      value: s,
      // All `locale` country names included in this library
      // include all countries (this is checked at build time).
      // The only case when a country name might be missing
      // is when a developer supplies their own `labels` property.
      // To guard against such cases, a missing country name
      // is substituted by country code.
      label: n[s] || s
    };
  });
  return l.sort(function(s, c) {
    return o(s.label, c.label, a);
  }), r && l.unshift({
    label: n.ZZ
  }), l;
}
function S0(t, e) {
  return $y(t || "", e);
}
function Kw(t) {
  return t.formatNational().replace(/\D/g, "");
}
function qw(t, e) {
  var n = e.prevCountry, r = e.newCountry, a = e.metadata, o = e.useNationalFormat;
  if (n === r)
    return t;
  if (!t)
    return o ? "" : r ? Lt(r, a) : "";
  if (r) {
    if (t[0] === "+") {
      if (o)
        return t.indexOf("+" + Wt(r, a)) === 0 ? e$(t, r, a) : "";
      if (n) {
        var l = Lt(r, a);
        return t.indexOf(l) === 0 ? t : l;
      } else {
        var s = Lt(r, a);
        return t.indexOf(s) === 0 ? t : s;
      }
    }
  } else if (t[0] !== "+")
    return Zn(t, n, a) || "";
  return t;
}
function Zn(t, e, n) {
  if (t) {
    if (t[0] === "+") {
      if (t === "+")
        return;
      var r = new yr(e, n);
      return r.input(t), r.getNumberValue();
    }
    if (e) {
      var a = P0(t, e, n);
      return "+".concat(Wt(e, n)).concat(a || "");
    }
  }
}
function Yw(t, e, n) {
  var r = P0(t, e, n);
  if (r) {
    var a = r.length - Zw(e, n);
    if (a > 0)
      return t.slice(0, t.length - a);
  }
  return t;
}
function Zw(t, e) {
  return e = new He(e), e.selectNumberingPlan(t), e.numberingPlan.possibleLengths()[e.numberingPlan.possibleLengths().length - 1];
}
function F0(t, e) {
  var n = e.country, r = e.countries, a = e.defaultCountry, o = e.latestCountrySelectedByUser, l = e.required, s = e.metadata;
  if (t === "+")
    return n;
  var c = Jw(t, s);
  if (c)
    return !r || r.indexOf(c) >= 0 ? c : void 0;
  if (n) {
    if (ar(t, n, s)) {
      if (o && ar(t, o, s))
        return o;
      if (a && ar(t, a, s))
        return a;
      if (!l)
        return;
    } else if (!l)
      return;
  }
  return n;
}
function Xw(t, e) {
  var n = e.prevPhoneDigits, r = e.country, a = e.defaultCountry, o = e.latestCountrySelectedByUser, l = e.countryRequired, s = e.getAnyCountry, c = e.countries, d = e.international, u = e.limitMaxLength, f = e.countryCallingCodeEditable, m = e.metadata;
  if (d && f === !1 && r) {
    var g = Lt(r, m);
    if (t.indexOf(g) !== 0) {
      var C, b = t && t[0] !== "+";
      return b ? (t = g + t, C = Zn(t, r, m)) : t = g, {
        phoneDigits: t,
        value: C,
        country: r
      };
    }
  }
  d === !1 && r && t && t[0] === "+" && (t = G1(t, r, m)), t && r && u && (t = Yw(t, r, m)), t && t[0] !== "+" && (!r || d) && (t = "+" + t), !t && n && n[0] === "+" && (d ? r = void 0 : r = a), t === "+" && n && n[0] === "+" && n.length > 1 && (r = void 0);
  var E;
  return t && (t[0] === "+" && (t === "+" || r && Lt(r, m).indexOf(t) === 0) ? E = void 0 : E = Zn(t, r, m)), E && (r = F0(E, {
    country: r,
    countries: c,
    defaultCountry: a,
    latestCountrySelectedByUser: o,
    // `countryRequired` flag is not passed here.
    // Instead, it's explicitly checked a bit later in the code.
    required: !1,
    metadata: m
  }), d === !1 && r && t && t[0] === "+" && (t = G1(t, r, m), E = Zn(t, r, m))), !r && l && (r = a || s()), {
    // `phoneDigits` returned here are a "normalized" version of the original `phoneDigits`.
    // The returned `phoneDigits` shouldn't be used anywhere except for passing it as
    // `prevPhoneDigits` parameter to this same function on next input change event.
    phoneDigits: t,
    country: r,
    value: E
  };
}
function G1(t, e, n) {
  if (t.indexOf(Lt(e, n)) === 0) {
    var r = new yr(e, n);
    r.input(t);
    var a = r.getNumber();
    return a ? a.formatNational().replace(/\D/g, "") : "";
  } else
    return t.replace(/\D/g, "");
}
function Jw(t, e) {
  var n = new yr(null, e);
  return n.input(t), n.getCountry();
}
function Qw(t, e, n) {
  return String.prototype.localeCompare ? t.localeCompare(e, n) : t < e ? -1 : t > e ? 1 : 0;
}
function e$(t, e, n) {
  if (e) {
    var r = "+" + Wt(e, n);
    if (t.length < r.length) {
      if (r.indexOf(t) === 0)
        return "";
    } else if (t.indexOf(r) === 0)
      return t.slice(r.length);
  }
  for (var a = 0, o = Object.keys(n.country_calling_codes); a < o.length; a++) {
    var l = o[a];
    if (t.indexOf(l) === 1)
      return t.slice(1 + l.length);
  }
  return "";
}
function P0(t, e, n) {
  var r = new yr(e, n);
  r.input(t);
  var a = r.getNumber();
  return a && a.nationalNumber;
}
function ar(t, e, n) {
  for (var r = Lt(e, n), a = 0; a < t.length && a < r.length; ) {
    if (t[a] !== r[a])
      return !1;
    a++;
  }
  return !0;
}
function N0(t) {
  var e = t.value, n = t.phoneNumber, r = t.defaultCountry, a = t.international, o = t.useNationalFormat, l = t.metadata;
  return (a === !1 || o) && n && n.country ? Kw(n) : !e && a && r ? Lt(r, l) : e;
}
function va(t) {
  "@babel/helpers - typeof";
  return va = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, va(t);
}
function K1(t, e) {
  var n = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(t);
    e && (r = r.filter(function(a) {
      return Object.getOwnPropertyDescriptor(t, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function Ha(t) {
  for (var e = 1; e < arguments.length; e++) {
    var n = arguments[e] != null ? arguments[e] : {};
    e % 2 ? K1(Object(n), !0).forEach(function(r) {
      t$(t, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : K1(Object(n)).forEach(function(r) {
      Object.defineProperty(t, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return t;
}
function t$(t, e, n) {
  return e = n$(e), e in t ? Object.defineProperty(t, e, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = n, t;
}
function n$(t) {
  var e = r$(t, "string");
  return va(e) == "symbol" ? e : e + "";
}
function r$(t, e) {
  if (va(t) != "object" || !t) return t;
  var n = t[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(t, e);
    if (va(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(t);
}
function a$(t, e, n) {
  var r = t.metadata, a = t.countries, o = t.defaultCountry, l = t.value, s = t.reset, c = t.international, d = t.displayInitialValueAsLocalNumber, u = t.initialValueFormat, f = e.defaultCountry, m = e.value, g = e.reset;
  n.country;
  var C = n.value, b = n.hasUserSelectedACountry, E = n.latestCountrySelectedByUser, x = function(y) {
    return N0(Ha(Ha({}, y), {}, {
      international: c,
      useNationalFormat: d || u === "national",
      metadata: r
    }));
  };
  if (s !== g)
    return {
      phoneDigits: x({
        value: void 0,
        defaultCountry: o
      }),
      value: void 0,
      country: o,
      latestCountrySelectedByUser: void 0,
      hasUserSelectedACountry: void 0
    };
  if (o !== f) {
    var _ = !o || Ji(o, r), N = (
      // By default, "no value has been entered" means `value` is `undefined`.
      !C || // When `international` is `true`, and some country has been pre-selected,
      // then the `<input/>` contains a pre-filled value of `+${countryCallingCode}${leadingDigits}`,
      // so in case of `international` being `true`, "the user hasn't entered anything" situation
      // doesn't just mean `value` is `undefined`, but could also mean `value` is `+${countryCallingCode}`.
      c && C === x({
        value: void 0,
        defaultCountry: f
      })
    ), k = !l && N;
    if (!b && _ && k)
      return {
        country: o,
        // If `phoneDigits` is empty, then automatically select the new `country`
        // and set `phoneDigits` to `+{getCountryCallingCode(newCountry)}`.
        // The code assumes that "no phone number has been entered by the user",
        // and no `value` property has been passed, so the `phoneNumber` parameter
        // of `_getInitialPhoneDigits({ value, phoneNumber, ... })` is `undefined`.
        phoneDigits: x({
          value: void 0,
          defaultCountry: o
        }),
        // `value` is `undefined` and it stays so.
        value: void 0
      };
  }
  if (!q1(l, m) && !q1(l, C)) {
    var F, A;
    if (l) {
      l && w0(l), F = S0(l, r);
      var O = $0(a, r);
      F && F.country ? (!O || O.indexOf(F.country) >= 0) && (A = F.country) : (A = F0(l, {
        country: void 0,
        countries: O,
        metadata: r
      }), A || o && l.indexOf(Lt(o, r)) === 0 && (A = o));
    }
    var te;
    if (l) {
      if (E) {
        var le = A ? E === A : ar(l, E, r);
        le ? A || (A = E) : te = {
          latestCountrySelectedByUser: void 0
        };
      }
    } else
      te = {
        latestCountrySelectedByUser: void 0,
        hasUserSelectedACountry: void 0
      };
    return Ha(Ha({}, te), {}, {
      phoneDigits: x({
        phoneNumber: F,
        value: l,
        defaultCountry: o
      }),
      value: l,
      country: l ? A : o
    });
  }
}
function q1(t, e) {
  return t === null && (t = void 0), e === null && (e = void 0), t === e;
}
var i$ = ["name", "disabled", "readOnly", "autoComplete", "style", "className", "inputRef", "inputComponent", "numberInputProps", "smartCaret", "countrySelectComponent", "countrySelectProps", "containerComponent", "containerComponentProps", "defaultCountry", "countries", "countryOptionsOrder", "labels", "flags", "flagComponent", "flagUrl", "addInternationalOption", "internationalIcon", "displayInitialValueAsLocalNumber", "initialValueFormat", "onCountryChange", "limitMaxLength", "countryCallingCodeEditable", "focusInputOnCountrySelection", "reset", "metadata", "international", "locales"];
function pr(t) {
  "@babel/helpers - typeof";
  return pr = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, pr(t);
}
function Y1(t, e) {
  var n = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(t);
    e && (r = r.filter(function(a) {
      return Object.getOwnPropertyDescriptor(t, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function _0(t) {
  for (var e = 1; e < arguments.length; e++) {
    var n = arguments[e] != null ? arguments[e] : {};
    e % 2 ? Y1(Object(n), !0).forEach(function(r) {
      st(t, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : Y1(Object(n)).forEach(function(r) {
      Object.defineProperty(t, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return t;
}
function ir() {
  return ir = Object.assign ? Object.assign.bind() : function(t) {
    for (var e = 1; e < arguments.length; e++) {
      var n = arguments[e];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
    }
    return t;
  }, ir.apply(this, arguments);
}
function o$(t, e) {
  if (t == null) return {};
  var n = l$(t, e), r, a;
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(t);
    for (a = 0; a < o.length; a++)
      r = o[a], !(e.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(t, r) && (n[r] = t[r]);
  }
  return n;
}
function l$(t, e) {
  if (t == null) return {};
  var n = {}, r = Object.keys(t), a, o;
  for (o = 0; o < r.length; o++)
    a = r[o], !(e.indexOf(a) >= 0) && (n[a] = t[a]);
  return n;
}
function s$(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function Z1(t, e) {
  for (var n = 0; n < e.length; n++) {
    var r = e[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, A0(r.key), r);
  }
}
function c$(t, e, n) {
  return e && Z1(t.prototype, e), n && Z1(t, n), Object.defineProperty(t, "prototype", { writable: !1 }), t;
}
function d$(t, e, n) {
  return e = Mi(e), u$(t, T0() ? Reflect.construct(e, n || [], Mi(t).constructor) : e.apply(t, n));
}
function u$(t, e) {
  if (e && (pr(e) === "object" || typeof e == "function"))
    return e;
  if (e !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return f$(t);
}
function f$(t) {
  if (t === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}
function T0() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (T0 = function() {
    return !!t;
  })();
}
function Mi(t) {
  return Mi = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, Mi(t);
}
function p$(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && Ul(t, e);
}
function Ul(t, e) {
  return Ul = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(r, a) {
    return r.__proto__ = a, r;
  }, Ul(t, e);
}
function st(t, e, n) {
  return e = A0(e), e in t ? Object.defineProperty(t, e, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = n, t;
}
function A0(t) {
  var e = m$(t, "string");
  return pr(e) == "symbol" ? e : e + "";
}
function m$(t, e) {
  if (pr(t) != "object" || !t) return t;
  var n = t[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(t, e);
    if (pr(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(t);
}
var h$ = /* @__PURE__ */ (function(t) {
  function e(n) {
    var r;
    s$(this, e), r = d$(this, e, [n]), st(r, "setInputRef", function(E) {
      Vw([r.props.inputRef, r.inputRef], E);
    }), st(r, "isCountrySupportedWithError", function(E) {
      var x = r.props.metadata;
      return Ji(E, x);
    }), st(r, "onCountryChange", function(E) {
      var x = r.props, _ = x.international, N = x.metadata, k = x.onChange, F = x.focusInputOnCountrySelection, A = r.state, O = A.phoneDigits, te = A.country, le = qw(O, {
        prevCountry: te,
        newCountry: E,
        metadata: N,
        // Convert the phone number to "national" format
        // when the user changes the selected country by hand.
        useNationalFormat: !_
      }), W = Zn(le, E, N);
      F && r.inputRef.current.focus(), r.setState({
        country: E,
        latestCountrySelectedByUser: E,
        hasUserSelectedACountry: !0,
        phoneDigits: le,
        value: W
      }, function() {
        k(W);
      });
    }), st(r, "onChange", function(E) {
      var x = r.props, _ = x.defaultCountry, N = x.onChange, k = x.addInternationalOption, F = x.international, A = x.limitMaxLength, O = x.countryCallingCodeEditable, te = x.metadata, le = r.state, W = le.countries, y = le.phoneDigits, Y = le.country, ee = le.latestCountrySelectedByUser, I = Xw(E, {
        prevPhoneDigits: y,
        country: Y,
        countryRequired: !k,
        defaultCountry: _,
        latestCountrySelectedByUser: ee,
        getAnyCountry: function() {
          return r.getFirstSupportedCountry({
            countries: W
          });
        },
        countries: W,
        international: F,
        limitMaxLength: A,
        countryCallingCodeEditable: O,
        metadata: te
      }), Q = I.phoneDigits, M = I.country, X = I.value, se = {
        phoneDigits: Q,
        value: X,
        country: M
      };
      ee && X && !ar(X, ee, te) && (se.latestCountrySelectedByUser = void 0), O === !1 && !X && Q === r.state.phoneDigits && (se.forceRerender = {}), r.setState(
        se,
        // Update the new `value` property.
        // Doing it after the `state` has been updated
        // because `onChange()` will trigger `getDerivedStateFromProps()`
        // with the new `value` which will be compared to `state.value` there.
        function() {
          return N(X);
        }
      );
    }), st(r, "_onFocus", function() {
      return r.setState({
        isFocused: !0
      });
    }), st(r, "_onBlur", function() {
      return r.setState({
        isFocused: !1
      });
    }), st(r, "onFocus", function(E) {
      r._onFocus();
      var x = r.props.onFocus;
      x && x(E);
    }), st(r, "onBlur", function(E) {
      var x = r.props.onBlur;
      r._onBlur(), x && x(E);
    }), st(r, "onCountryFocus", function(E) {
      r._onFocus();
      var x = r.props.countrySelectProps;
      if (x) {
        var _ = x.onFocus;
        _ && _(E);
      }
    }), st(r, "onCountryBlur", function(E) {
      r._onBlur();
      var x = r.props.countrySelectProps;
      if (x) {
        var _ = x.onBlur;
        _ && _(E);
      }
    }), r.inputRef = /* @__PURE__ */ i.createRef();
    var a = r.props, o = a.value;
    a.labels;
    var l = a.international, s = a.addInternationalOption, c = a.displayInitialValueAsLocalNumber, d = a.initialValueFormat, u = a.metadata, f = r.props, m = f.defaultCountry, g = f.countries;
    m && (r.isCountrySupportedWithError(m) || (m = void 0)), o && w0(o), g = $0(g, u);
    var C = S0(o, u);
    r.CountryIcon = x0(r.props);
    var b = Ww({
      value: o,
      phoneNumber: C,
      defaultCountry: m,
      required: !s,
      countries: g || $1(u),
      getAnyCountry: function() {
        return r.getFirstSupportedCountry({
          countries: g
        });
      },
      metadata: u
    });
    return r.state = {
      // Workaround for `this.props` inside `getDerivedStateFromProps()`.
      props: r.props,
      // The country selected.
      country: b,
      // `countries` are stored in `this.state` because they're filtered.
      // For example, a developer might theoretically pass some unsupported
      // countries as part of the `countries` property, and because of that
      // the component uses `this.state.countries` (which are filtered)
      // instead of `this.props.countries`
      // (which could potentially contain unsupported countries).
      countries: g,
      // `phoneDigits` state property holds non-formatted user's input.
      // The reason is that there's no way of finding out
      // in which form should `value` be displayed: international or national.
      // E.g. if `value` is `+78005553535` then it could be input
      // by a user both as `8 (800) 555-35-35` and `+7 800 555 35 35`.
      // Hence storing just `value` is not sufficient for correct formatting.
      // E.g. if a user entered `8 (800) 555-35-35`
      // then value is `+78005553535` and `phoneDigits` are `88005553535`
      // and if a user entered `+7 800 555 35 35`
      // then value is `+78005553535` and `phoneDigits` are `+78005553535`.
      phoneDigits: N0({
        value: o,
        phoneNumber: C,
        defaultCountry: m,
        international: l,
        useNationalFormat: c || d === "national",
        metadata: u
      }),
      // `value` property is duplicated in state.
      // The reason is that `getDerivedStateFromProps()`
      // needs this `value` to compare to the new `value` property
      // to find out if `phoneDigits` needs updating:
      // If the `value` property was changed externally
      // then it won't be equal to `state.value`
      // in which case `phoneDigits` and `country` should be updated.
      value: o
    }, r;
  }
  return p$(e, t), c$(e, [{
    key: "componentDidMount",
    value: function() {
      var r = this.props.onCountryChange, a = this.props.defaultCountry, o = this.state.country;
      r && (a && (this.isCountrySupportedWithError(a) || (a = void 0)), o !== a && r(o));
    }
  }, {
    key: "componentDidUpdate",
    value: function(r, a) {
      var o = this.props.onCountryChange, l = this.state.country;
      o && l !== a.country && o(l);
    }
  }, {
    key: "getCountrySelectOptions",
    value: function(r) {
      var a = r.countries, o = this.props, l = o.international, s = o.countryCallingCodeEditable, c = o.countryOptionsOrder, d = o.addInternationalOption, u = o.labels, f = o.locales, m = o.metadata;
      return this.useMemoCountrySelectOptions(function() {
        return kw(Gw({
          countries: a || $1(m),
          countryNames: u,
          addInternationalOption: l && s === !1 ? !1 : d,
          compareStringsLocales: f
          // compareStrings
        }), Ow(c, m));
      }, [a, c, d, u, m]);
    }
  }, {
    key: "useMemoCountrySelectOptions",
    value: function(r, a) {
      return (!this.countrySelectOptionsMemoDependencies || !g$(a, this.countrySelectOptionsMemoDependencies)) && (this.countrySelectOptionsMemo = r(), this.countrySelectOptionsMemoDependencies = a), this.countrySelectOptionsMemo;
    }
  }, {
    key: "getFirstSupportedCountry",
    value: function(r) {
      var a = r.countries, o = this.getCountrySelectOptions({
        countries: a
      });
      return o[0].value;
    }
  }, {
    key: "render",
    value: function() {
      var r = this.props, a = r.name, o = r.disabled, l = r.readOnly, s = r.autoComplete, c = r.style, d = r.className;
      r.inputRef;
      var u = r.inputComponent, f = r.numberInputProps, m = r.smartCaret, g = r.countrySelectComponent, C = r.countrySelectProps, b = r.containerComponent, E = r.containerComponentProps;
      r.defaultCountry, r.countries, r.countryOptionsOrder;
      var x = r.labels;
      r.flags, r.flagComponent, r.flagUrl, r.addInternationalOption, r.internationalIcon, r.displayInitialValueAsLocalNumber, r.initialValueFormat, r.onCountryChange, r.limitMaxLength, r.countryCallingCodeEditable, r.focusInputOnCountrySelection, r.reset;
      var _ = r.metadata, N = r.international;
      r.locales;
      var k = o$(r, i$), F = this.state, A = F.country, O = F.countries, te = F.phoneDigits, le = F.isFocused, W = m ? uw : vw, y = this.getCountrySelectOptions({
        countries: O
      });
      return /* @__PURE__ */ i.createElement(b, ir({
        style: c,
        className: wi(d, "PhoneInput", {
          "PhoneInput--focus": le,
          "PhoneInput--disabled": o,
          "PhoneInput--readOnly": l
        })
      }, E), /* @__PURE__ */ i.createElement(g, ir({
        name: a ? "".concat(a, "Country") : void 0,
        "aria-label": x.country
      }, C, {
        value: A,
        options: y,
        onChange: this.onCountryChange,
        onFocus: this.onCountryFocus,
        onBlur: this.onCountryBlur,
        disabled: o || C && C.disabled,
        readOnly: l || C && C.readOnly,
        iconComponent: this.CountryIcon
      })), /* @__PURE__ */ i.createElement(W, ir({
        ref: this.setInputRef,
        type: "tel",
        autoComplete: s
      }, f, k, {
        inputFormat: N === !0 ? "INTERNATIONAL" : N === !1 ? "NATIONAL" : "INTERNATIONAL_OR_NATIONAL",
        international: N ? !0 : void 0,
        withCountryCallingCode: N ? !0 : void 0,
        name: a,
        metadata: _,
        country: A,
        value: te || "",
        onChange: this.onChange,
        onFocus: this.onFocus,
        onBlur: this.onBlur,
        disabled: o,
        readOnly: l,
        inputComponent: u,
        className: wi("PhoneInputInput", f && f.className, k.className)
      })));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: (
      // `state` holds previous props as `props`, and also:
      // * `country` — The currently selected country, e.g. `"RU"`.
      // * `value` — The currently entered phone number (E.164), e.g. `+78005553535`.
      // * `phoneDigits` — The parsed `<input/>` value, e.g. `8005553535`.
      // (and a couple of other less significant properties)
      function(r, a) {
        return _0({
          // Emulate `prevProps` via `state.props`.
          props: r
        }, a$(r, a.props, a));
      }
    )
  }]);
})(i.PureComponent), z0 = /* @__PURE__ */ i.forwardRef(function(t, e) {
  return /* @__PURE__ */ i.createElement(h$, ir({}, v$(t), {
    inputRef: e
  }));
});
z0.propTypes = {
  /**
   * Phone number in `E.164` format.
   *
   * Example:
   *
   * `"+12223333333"`
   *
   * Any "falsy" value like `undefined`, `null` or an empty string `""` is treated like "empty".
   */
  value: T.string,
  /**
   * A function of `value: string?`.
   *
   * Updates the `value` property as the user inputs a phone number.
   *
   * If the user erases the input value, the argument is `undefined`.
   */
  onChange: T.func.isRequired,
  /**
   * Toggles the `--focus` CSS class.
   * @ignore
   */
  onFocus: T.func,
  /**
   * `onBlur` is usually passed by `redux-form`.
   * @ignore
   */
  onBlur: T.func,
  /**
   * Set to `true` to mark both the phone number `<input/>`
   * and the country `<select/>` as `disabled`.
   */
  disabled: T.bool,
  /**
   * Set to `true` to mark both the phone number `<input/>`
   * and the country `<select/>` as `readonly`.
   */
  readOnly: T.bool,
  /**
   * Sets `autoComplete` property for phone number `<input/>`.
   *
   * Web browser's "autocomplete" feature
   * remembers the phone number being input
   * and can also autofill the `<input/>`
   * with previously remembered phone numbers.
   *
   * https://developers.google.com
   * /web/updates/2015/06/checkout-faster-with-autofill
   *
   * For example, can be used to turn it off:
   *
   * "So when should you use `autocomplete="off"`?
   *  One example is when you've implemented your own version
   *  of autocomplete for search. Another example is any form field
   *  where users will input and submit different kinds of information
   *  where it would not be useful to have the browser remember
   *  what was submitted previously".
   */
  // (is `"tel"` by default)
  autoComplete: T.string,
  /**
   * Set to `"national"` to show the initial `value` in
   * "national" format rather than "international".
   *
   * For example, if `initialValueFormat` is `"national"`
   * and the initial `value="+12133734253"` is passed
   * then the `<input/>` value will be `"(213) 373-4253"`.
   *
   * By default, `initialValueFormat` is `undefined`,
   * meaning that if the initial `value="+12133734253"` is passed
   * then the `<input/>` value will be `"+1 213 373 4253"`.
   *
   * The reason for such default behaviour is that
   * the newer generation grows up when there are no stationary phones
   * and therefore everyone inputs phone numbers in international format
   * in their smartphones so people gradually get more accustomed to
   * writing phone numbers in international format rather than in local format.
   * Future people won't be using "national" format, only "international".
   */
  // (is `undefined` by default)
  initialValueFormat: T.oneOf(["national"]),
  // `displayInitialValueAsLocalNumber` property has been
  // superceded by `initialValueFormat` property.
  displayInitialValueAsLocalNumber: T.bool,
  /**
   * The country to be selected by default.
   * For example, can be set after a GeoIP lookup.
   *
   * Example: `"US"`.
   */
  // A two-letter country code ("ISO 3166-1 alpha-2").
  defaultCountry: T.string,
  /**
   * If specified, only these countries will be available for selection.
   *
   * Example:
   *
   * `["RU", "UA", "KZ"]`
   */
  countries: T.arrayOf(T.string),
  /**
   * Custom country `<select/>` option names.
   * Also some labels like "ext" and country `<select/>` `aria-label`.
   *
   * Example:
   *
   * `{ "ZZ": "Международный", RU: "Россия", US: "США", ... }`
   *
   * See the `locales` directory for examples.
   */
  labels: M0,
  /**
   * Country `<select/>` options are sorted by their labels.
   * The default sorting function uses `a.localeCompare(b, locales)`,
   * and, if that's not available, falls back to simple `a > b` / `a < b`.
   * Some languages, like Chinese, support multiple sorting variants
   * (called "collations"), and the user might prefer one or another.
   * Also, sometimes the Operating System language is not always
   * the preferred language for a person using a website or an application,
   * so there should be a way to specify custom locale.
   * This `locales` property mimicks the `locales` argument of `Intl` constructors,
   * and can be either a Unicode BCP 47 locale identifier or an array of such locale identifiers.
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl#locales_argument
   */
  locales: T.oneOfType([T.string, T.arrayOf(T.string)]),
  /*
   * Custom country `<select/>` options sorting function.
   * The default one uses `a.localeCompare(b)`, and,
   * if that's not available, falls back to simple `a > b`/`a < b`.
   * There have been requests to add custom sorter for cases
   * like Chinese language and "pinyin" (non-default) sorting order.
   * https://stackoverflow.com/questions/22907288/chinese-sorting-by-pinyin-in-javascript-with-localecompare
  compareStrings: PropTypes.func,
   */
  /**
   * A URL template of a country flag, where
   * "{XX}" is a two-letter country code in upper case,
   * or where "{xx}" is a two-letter country code in lower case.
   * By default it points to `country-flag-icons` gitlab pages website.
   * I imagine someone might want to download those country flag icons
   * and host them on their own servers instead
   * (all flags are available in the `country-flag-icons` library).
   * There's a catch though: new countries may be added in future,
   * so when hosting country flag icons on your own server
   * one should check the `CHANGELOG.md` every time before updating this library,
   * otherwise there's a possibility that some new country flag would be missing.
   */
  flagUrl: T.string,
  /**
   * Custom country flag icon components.
   * These flags will be used instead of the default ones.
   * The the "Flags" section of the readme for more info.
   *
   * The shape is an object where keys are country codes
   * and values are flag icon components.
   * Flag icon components receive the same properties
   * as `flagComponent` (see below).
   *
   * Example:
   *
   * `{ "RU": (props) => <img src="..."/> }`
   *
   * Example:
   *
   * `import flags from 'country-flag-icons/react/3x2'`
   *
   * `import PhoneInput from 'react-phone-number-input'`
   *
   * `<PhoneInput flags={flags} .../>`
   */
  flags: T.objectOf(T.elementType),
  /**
   * Country flag icon component.
   *
   * Takes properties:
   *
   * * `country: string` — The country code.
   * * `countryName: string` — The country name.
   * * `flagUrl: string` — The `flagUrl` property (see above).
   * * `flags: object` — The `flags` property (see above).
   */
  flagComponent: T.elementType,
  /**
   * Set to `false` to remove the "International" option from country `<select/>`.
   */
  addInternationalOption: T.bool,
  /**
   * "International" icon component.
   * Should have the same aspect ratio.
   *
   * Receives properties:
   *
   * * `title: string` — "International" country option label.
   */
  internationalIcon: T.elementType,
  /**
   * Can be used to place some countries on top of the list of country `<select/>` options.
   *
   * * `"XX"` — inserts an option for "XX" country.
   * * `"🌐"` — inserts "International" option.
   * * `"|"` — inserts a separator.
   * * `"..."` — inserts options for the rest of the countries (can be omitted, in which case it will be automatically added at the end).
   *
   * Example:
   *
   * `["US", "CA", "AU", "|", "..."]`
   */
  countryOptionsOrder: T.arrayOf(T.string),
  /**
   * `<Phone/>` component CSS style object.
   */
  style: T.object,
  /**
   * `<Phone/>` component CSS class.
   */
  className: T.string,
  /**
   * Country `<select/>` component.
   *
   * Receives properties:
   *
   * * `name: string?` — HTML `name` attribute.
   * * `value: string?` — The currently selected country code.
   * * `onChange(value: string?)` — Updates the `value`.
   * * `onFocus()` — Is used to toggle the `--focus` CSS class.
   * * `onBlur()` — Is used to toggle the `--focus` CSS class.
   * * `options: object[]` — The list of all selectable countries (including "International") each being an object of shape `{ value: string?, label: string }`.
   * * `iconComponent: PropTypes.elementType` — React component that renders a country icon: `<Icon country={value}/>`. If `country` is `undefined` then it renders an "International" icon.
   * * `disabled: boolean?` — HTML `disabled` attribute.
   * * `readOnly: boolean?` — HTML `readOnly` attribute.
   * * `tabIndex: (number|string)?` — HTML `tabIndex` attribute.
   * * `className: string` — CSS class name.
   */
  countrySelectComponent: T.elementType,
  /**
   * Country `<select/>` component props.
   * Along with the usual DOM properties such as `aria-label` and `tabIndex`,
   * some custom properties are supported, such as `arrowComponent` and `unicodeFlags`.
   */
  countrySelectProps: T.object,
  /**
   * Phone number `<input/>` component.
   *
   * Receives properties:
   *
   * * `value: string` — The formatted `value`.
   * * `onChange(event: Event)` — Updates the formatted `value` from `event.target.value`.
   * * `onFocus()` — Is used to toggle the `--focus` CSS class.
   * * `onBlur()` — Is used to toggle the `--focus` CSS class.
   * * Other properties like `type="tel"` or `autoComplete="tel"` that should be passed through to the DOM `<input/>`.
   *
   * Must also either use `React.forwardRef()` to "forward" `ref` to the `<input/>` or implement `.focus()` method.
   */
  inputComponent: T.elementType,
  /**
   * Phone number `<input/>` component props.
   */
  numberInputProps: T.object,
  /**
   * Wrapping `<div/>` component.
   *
   * Receives properties:
   *
   * * `style: object` — A component CSS style object.
   * * `className: string` — Classes to attach to the component, typically changes when component focuses or blurs.
   */
  containerComponent: T.elementType,
  /**
   * Wrapping `<div/>` component props.
   */
  containerComponentProps: T.object,
  /**
   * When the user attempts to insert a digit somewhere in the middle of a phone number,
   * the caret position is moved right before the next available digit skipping
   * any punctuation in between. This is called "smart" caret positioning.
   * Another case would be the phone number format changing as a result of
   * the user inserting the digit somewhere in the middle, which would require
   * re-positioning the caret because all digit positions have changed.
   * This "smart" caret positioning feature can be turned off by passing
   * `smartCaret={false}` property: use it in case of any possible issues
   * with caret position during phone number input.
   */
  // Is `true` by default.
  smartCaret: T.bool,
  /**
   * Set to `true` to force "international" phone number format.
   * Set to `false` to force "national" phone number format.
   * By default it's `undefined` meaning that it doesn't enforce any phone number format:
   * the user can input their phone number in either "national" or "international" format.
   */
  international: T.bool,
  /**
   * If set to `true`, the phone number input will get trimmed
   * if it exceeds the maximum length for the country.
   */
  limitMaxLength: T.bool,
  /**
   * If set to `false`, and `international` is `true`, then
   * users won't be able to erase the "country calling part"
   * of a phone number in the `<input/>`.
   */
  countryCallingCodeEditable: T.bool,
  /**
   * `libphonenumber-js` metadata.
   *
   * Can be used to pass custom `libphonenumber-js` metadata
   * to reduce the overall bundle size for those who compile "custom" metadata.
   */
  metadata: C0,
  /**
   * Is called every time the selected country changes:
   * either programmatically or when user selects it manually from the list.
   */
  // People have been asking for a way to get the selected country.
  // @see  https://github.com/catamphetamine/react-phone-number-input/issues/128
  // For some it's just a "business requirement".
  // I guess it's about gathering as much info on the user as a website can
  // without introducing any addional fields that would complicate the form
  // therefore reducing "conversion" (that's a marketing term).
  // Assuming that the phone number's country is the user's country
  // is not 100% correct but in most cases I guess it's valid.
  onCountryChange: T.func,
  /**
   * If set to `false`, will not focus the `<input/>` component
   * when the user selects a country from the list of countries.
   * This can be used to conform to the Web Content Accessibility Guidelines (WCAG).
   * Quote:
   * "On input: Changing the setting of any user interface component
   *  does not automatically cause a change of context unless the user
   *  has been advised of the behaviour before using the component."
   */
  focusInputOnCountrySelection: T.bool
};
var X1 = {
  /**
   * Remember (and autofill) the value as a phone number.
   */
  autoComplete: "tel",
  /**
   * Country `<select/>` component.
   */
  countrySelectComponent: g0,
  /**
   * Flag icon component.
   */
  flagComponent: Ds,
  /**
   * By default, uses icons from `country-flag-icons` gitlab pages website.
   */
  // Must be equal to `flagUrl` in `./CountryIcon.js`.
  flagUrl: "https://purecatamphetamine.github.io/country-flag-icons/3x2/{XX}.svg",
  /**
   * Default "International" country `<select/>` option icon.
   */
  internationalIcon: Xi,
  /**
   * Phone number `<input/>` component.
   */
  inputComponent: "input",
  /**
   * Wrapping `<div/>` component.
   */
  containerComponent: "div",
  /**
   * Some users requested a way to reset the component:
   * both number `<input/>` and country `<select/>`.
   * Whenever `reset` property changes both number `<input/>`
   * and country `<select/>` are reset.
   * It's not implemented as some instance `.reset()` method
   * because `ref` is forwarded to `<input/>`.
   * It's also not replaced with just resetting `country` on
   * external `value` reset, because a user could select a country
   * and then not input any `value`, and so the selected country
   * would be "stuck", if not using this `reset` property.
   */
  // https://github.com/catamphetamine/react-phone-number-input/issues/300
  reset: T.any,
  /**
   *
   */
  /**
   * Set to `false` to use "basic" caret instead of the "smart" one.
   */
  smartCaret: !0,
  /**
   * Whether to add the "International" option
   * to the list of countries.
   */
  addInternationalOption: !0,
  /**
   * If set to `false`, and `international` is `true`, then
   * users won't be able to erase the "country calling part"
   * of a phone number in the `<input/>`.
   */
  countryCallingCodeEditable: !0,
  /**
   * If set to `false`, will not focus the `<input/>` component
   * when the user selects a country from the list of countries.
   * This can be used to conform to the Web Content Accessibility Guidelines (WCAG).
   * Quote:
   * "On input: Changing the setting of any user interface component
   *  does not automatically cause a change of context unless the user
   *  has been advised of the behaviour before using the component."
   */
  focusInputOnCountrySelection: !0
};
function v$(t) {
  t = _0({}, t);
  for (var e in X1)
    t[e] === void 0 && (t[e] = X1[e]);
  return t;
}
function g$(t, e) {
  if (t.length !== e.length)
    return !1;
  for (var n = 0; n < t.length; ) {
    if (t[n] !== e[n])
      return !1;
    n++;
  }
  return !0;
}
const y$ = {
  ext: "ext.",
  country: "Phone number country",
  phone: "Phone",
  AC: "Ascension Island",
  AD: "Andorra",
  AE: "United Arab Emirates",
  AF: "Afghanistan",
  AG: "Antigua and Barbuda",
  AI: "Anguilla",
  AL: "Albania",
  AM: "Armenia",
  AO: "Angola",
  AQ: "Antarctica",
  AR: "Argentina",
  AS: "American Samoa",
  AT: "Austria",
  AU: "Australia",
  AW: "Aruba",
  AX: "Åland Islands",
  AZ: "Azerbaijan",
  BA: "Bosnia and Herzegovina",
  BB: "Barbados",
  BD: "Bangladesh",
  BE: "Belgium",
  BF: "Burkina Faso",
  BG: "Bulgaria",
  BH: "Bahrain",
  BI: "Burundi",
  BJ: "Benin",
  BL: "Saint Barthélemy",
  BM: "Bermuda",
  BN: "Brunei Darussalam",
  BO: "Bolivia",
  BQ: "Bonaire, Sint Eustatius and Saba",
  BR: "Brazil",
  BS: "Bahamas",
  BT: "Bhutan",
  BV: "Bouvet Island",
  BW: "Botswana",
  BY: "Belarus",
  BZ: "Belize",
  CA: "Canada",
  CC: "Cocos (Keeling) Islands",
  CD: "Congo, Democratic Republic of the",
  CF: "Central African Republic",
  CG: "Congo",
  CH: "Switzerland",
  CI: "Cote d'Ivoire",
  CK: "Cook Islands",
  CL: "Chile",
  CM: "Cameroon",
  CN: "China",
  CO: "Colombia",
  CR: "Costa Rica",
  CU: "Cuba",
  CV: "Cape Verde",
  CW: "Curaçao",
  CX: "Christmas Island",
  CY: "Cyprus",
  CZ: "Czech Republic",
  DE: "Germany",
  DJ: "Djibouti",
  DK: "Denmark",
  DM: "Dominica",
  DO: "Dominican Republic",
  DZ: "Algeria",
  EC: "Ecuador",
  EE: "Estonia",
  EG: "Egypt",
  EH: "Western Sahara",
  ER: "Eritrea",
  ES: "Spain",
  ET: "Ethiopia",
  FI: "Finland",
  FJ: "Fiji",
  FK: "Falkland Islands",
  FM: "Federated States of Micronesia",
  FO: "Faroe Islands",
  FR: "France",
  GA: "Gabon",
  GB: "United Kingdom",
  GD: "Grenada",
  GE: "Georgia",
  GF: "French Guiana",
  GG: "Guernsey",
  GH: "Ghana",
  GI: "Gibraltar",
  GL: "Greenland",
  GM: "Gambia",
  GN: "Guinea",
  GP: "Guadeloupe",
  GQ: "Equatorial Guinea",
  GR: "Greece",
  GS: "South Georgia and the South Sandwich Islands",
  GT: "Guatemala",
  GU: "Guam",
  GW: "Guinea-Bissau",
  GY: "Guyana",
  HK: "Hong Kong",
  HM: "Heard Island and McDonald Islands",
  HN: "Honduras",
  HR: "Croatia",
  HT: "Haiti",
  HU: "Hungary",
  ID: "Indonesia",
  IE: "Ireland",
  IL: "Israel",
  IM: "Isle of Man",
  IN: "India",
  IO: "British Indian Ocean Territory",
  IQ: "Iraq",
  IR: "Iran",
  IS: "Iceland",
  IT: "Italy",
  JE: "Jersey",
  JM: "Jamaica",
  JO: "Jordan",
  JP: "Japan",
  KE: "Kenya",
  KG: "Kyrgyzstan",
  KH: "Cambodia",
  KI: "Kiribati",
  KM: "Comoros",
  KN: "Saint Kitts and Nevis",
  KP: "North Korea",
  KR: "South Korea",
  KW: "Kuwait",
  KY: "Cayman Islands",
  KZ: "Kazakhstan",
  LA: "Laos",
  LB: "Lebanon",
  LC: "Saint Lucia",
  LI: "Liechtenstein",
  LK: "Sri Lanka",
  LR: "Liberia",
  LS: "Lesotho",
  LT: "Lithuania",
  LU: "Luxembourg",
  LV: "Latvia",
  LY: "Libya",
  MA: "Morocco",
  MC: "Monaco",
  MD: "Moldova",
  ME: "Montenegro",
  MF: "Saint Martin (French Part)",
  MG: "Madagascar",
  MH: "Marshall Islands",
  MK: "North Macedonia",
  ML: "Mali",
  MM: "Myanmar",
  MN: "Mongolia",
  MO: "Macao",
  MP: "Northern Mariana Islands",
  MQ: "Martinique",
  MR: "Mauritania",
  MS: "Montserrat",
  MT: "Malta",
  MU: "Mauritius",
  MV: "Maldives",
  MW: "Malawi",
  MX: "Mexico",
  MY: "Malaysia",
  MZ: "Mozambique",
  NA: "Namibia",
  NC: "New Caledonia",
  NE: "Niger",
  NF: "Norfolk Island",
  NG: "Nigeria",
  NI: "Nicaragua",
  NL: "Netherlands",
  NO: "Norway",
  NP: "Nepal",
  NR: "Nauru",
  NU: "Niue",
  NZ: "New Zealand",
  OM: "Oman",
  PA: "Panama",
  PE: "Peru",
  PF: "French Polynesia",
  PG: "Papua New Guinea",
  PH: "Philippines",
  PK: "Pakistan",
  PL: "Poland",
  PM: "Saint Pierre and Miquelon",
  PN: "Pitcairn",
  PR: "Puerto Rico",
  PS: "Palestine",
  PT: "Portugal",
  PW: "Palau",
  PY: "Paraguay",
  QA: "Qatar",
  RE: "Reunion",
  RO: "Romania",
  RS: "Serbia",
  RU: "Russia",
  RW: "Rwanda",
  SA: "Saudi Arabia",
  SB: "Solomon Islands",
  SC: "Seychelles",
  SD: "Sudan",
  SE: "Sweden",
  SG: "Singapore",
  SH: "Saint Helena",
  SI: "Slovenia",
  SJ: "Svalbard and Jan Mayen",
  SK: "Slovakia",
  SL: "Sierra Leone",
  SM: "San Marino",
  SN: "Senegal",
  SO: "Somalia",
  SR: "Suriname",
  SS: "South Sudan",
  ST: "Sao Tome and Principe",
  SV: "El Salvador",
  SX: "Sint Maarten",
  SY: "Syria",
  SZ: "Swaziland",
  TA: "Tristan da Cunha",
  TC: "Turks and Caicos Islands",
  TD: "Chad",
  TF: "French Southern Territories",
  TG: "Togo",
  TH: "Thailand",
  TJ: "Tajikistan",
  TK: "Tokelau",
  TL: "Timor-Leste",
  TM: "Turkmenistan",
  TN: "Tunisia",
  TO: "Tonga",
  TR: "Turkey",
  TT: "Trinidad and Tobago",
  TV: "Tuvalu",
  TW: "Taiwan",
  TZ: "Tanzania",
  UA: "Ukraine",
  UG: "Uganda",
  UM: "United States Minor Outlying Islands",
  US: "United States",
  UY: "Uruguay",
  UZ: "Uzbekistan",
  VA: "Holy See (Vatican City State)",
  VC: "Saint Vincent and the Grenadines",
  VE: "Venezuela",
  VG: "Virgin Islands, British",
  VI: "Virgin Islands, U.S.",
  VN: "Vietnam",
  VU: "Vanuatu",
  WF: "Wallis and Futuna",
  WS: "Samoa",
  XA: "Abkhazia",
  XK: "Kosovo",
  XO: "South Ossetia",
  YE: "Yemen",
  YT: "Mayotte",
  ZA: "South Africa",
  ZM: "Zambia",
  ZW: "Zimbabwe",
  ZZ: "International"
};
var b$ = ["metadata", "labels"];
function Wl() {
  return Wl = Object.assign ? Object.assign.bind() : function(t) {
    for (var e = 1; e < arguments.length; e++) {
      var n = arguments[e];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
    }
    return t;
  }, Wl.apply(this, arguments);
}
function E$(t, e) {
  if (t == null) return {};
  var n = w$(t, e), r, a;
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(t);
    for (a = 0; a < o.length; a++)
      r = o[a], !(e.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(t, r) && (n[r] = t[r]);
  }
  return n;
}
function w$(t, e) {
  if (t == null) return {};
  var n = {}, r = Object.keys(t), a, o;
  for (o = 0; o < r.length; o++)
    a = r[o], !(e.indexOf(a) >= 0) && (n[a] = t[a]);
  return n;
}
function D0(t) {
  var e = /* @__PURE__ */ i.forwardRef(function(n, r) {
    var a = n.metadata, o = a === void 0 ? t : a, l = n.labels, s = l === void 0 ? y$ : l, c = E$(n, b$);
    return /* @__PURE__ */ i.createElement(z0, Wl({}, c, {
      ref: r,
      metadata: o,
      labels: s
    }));
  });
  return e.propTypes = {
    metadata: C0,
    labels: M0
  }, e;
}
D0();
function $$(t, e) {
  var n = Array.prototype.slice.call(e);
  return n.push(W2), t.apply(this, n);
}
const x$ = D0(W2);
function C$() {
  return $$(Wt, arguments);
}
var M$ = ["title"], S$ = ["title"], F$ = ["title"], P$ = ["title"], N$ = ["title"], _$ = ["title"], T$ = ["title"], A$ = ["title"], z$ = ["title"], D$ = ["title"], I$ = ["title"], k$ = ["title"], O$ = ["title"], L$ = ["title"], R$ = ["title"], H$ = ["title"], B$ = ["title"], j$ = ["title"], V$ = ["title"], U$ = ["title"], W$ = ["title"], G$ = ["title"], K$ = ["title"], q$ = ["title"], Y$ = ["title"], Z$ = ["title"], X$ = ["title"], J$ = ["title"], Q$ = ["title"], ex = ["title"], tx = ["title"], nx = ["title"], rx = ["title"], ax = ["title"], ix = ["title"], ox = ["title"], lx = ["title"], sx = ["title"], cx = ["title"], dx = ["title"], ux = ["title"], fx = ["title"], px = ["title"], mx = ["title"], hx = ["title"], vx = ["title"], gx = ["title"], yx = ["title"], bx = ["title"], Ex = ["title"], wx = ["title"], $x = ["title"], xx = ["title"], Cx = ["title"], Mx = ["title"], Sx = ["title"], Fx = ["title"], Px = ["title"], Nx = ["title"], _x = ["title"], Tx = ["title"], Ax = ["title"], zx = ["title"], Dx = ["title"], Ix = ["title"], kx = ["title"], Ox = ["title"], Lx = ["title"], Rx = ["title"], Hx = ["title"], Bx = ["title"], jx = ["title"], Vx = ["title"], Ux = ["title"], Wx = ["title"], Gx = ["title"], Kx = ["title"], qx = ["title"], Yx = ["title"], Zx = ["title"], Xx = ["title"], Jx = ["title"], Qx = ["title"], eC = ["title"], tC = ["title"], nC = ["title"], rC = ["title"], aC = ["title"], iC = ["title"], oC = ["title"], lC = ["title"], sC = ["title"], cC = ["title"], dC = ["title"], uC = ["title"], fC = ["title"], pC = ["title"], mC = ["title"], hC = ["title"], vC = ["title"], gC = ["title"], yC = ["title"], bC = ["title"], EC = ["title"], wC = ["title"], $C = ["title"], xC = ["title"], CC = ["title"], MC = ["title"], SC = ["title"], FC = ["title"], PC = ["title"], NC = ["title"], _C = ["title"], TC = ["title"], AC = ["title"], zC = ["title"], DC = ["title"], IC = ["title"], kC = ["title"], OC = ["title"], LC = ["title"], RC = ["title"], HC = ["title"], BC = ["title"], jC = ["title"], VC = ["title"], UC = ["title"], WC = ["title"], GC = ["title"], KC = ["title"], qC = ["title"], YC = ["title"], ZC = ["title"], XC = ["title"], JC = ["title"], QC = ["title"], eM = ["title"], tM = ["title"], nM = ["title"], rM = ["title"], aM = ["title"], iM = ["title"], oM = ["title"], lM = ["title"], sM = ["title"], cM = ["title"], dM = ["title"], uM = ["title"], fM = ["title"], pM = ["title"], mM = ["title"], hM = ["title"], vM = ["title"], gM = ["title"], yM = ["title"], bM = ["title"], EM = ["title"], wM = ["title"], $M = ["title"], xM = ["title"], CM = ["title"], MM = ["title"], SM = ["title"], FM = ["title"], PM = ["title"], NM = ["title"], _M = ["title"], TM = ["title"], AM = ["title"], zM = ["title"], DM = ["title"], IM = ["title"], kM = ["title"], OM = ["title"], LM = ["title"], RM = ["title"], HM = ["title"], BM = ["title"], jM = ["title"], VM = ["title"], UM = ["title"], WM = ["title"], GM = ["title"], KM = ["title"], qM = ["title"], YM = ["title"], ZM = ["title"], XM = ["title"], JM = ["title"], QM = ["title"], eS = ["title"], tS = ["title"], nS = ["title"], rS = ["title"], aS = ["title"], iS = ["title"], oS = ["title"], lS = ["title"], sS = ["title"], cS = ["title"], dS = ["title"], uS = ["title"], fS = ["title"], pS = ["title"], mS = ["title"], hS = ["title"], vS = ["title"], gS = ["title"], yS = ["title"], bS = ["title"], ES = ["title"], wS = ["title"], $S = ["title"], xS = ["title"], CS = ["title"], MS = ["title"], SS = ["title"], FS = ["title"], PS = ["title"], NS = ["title"], _S = ["title"], TS = ["title"], AS = ["title"], zS = ["title"], DS = ["title"], IS = ["title"], kS = ["title"], OS = ["title"], LS = ["title"], RS = ["title"], HS = ["title"], BS = ["title"], jS = ["title"], VS = ["title"], US = ["title"], WS = ["title"], GS = ["title"], KS = ["title"], qS = ["title"], YS = ["title"], ZS = ["title"], XS = ["title"], JS = ["title"], QS = ["title"], eF = ["title"], tF = ["title"], nF = ["title"], rF = ["title"], aF = ["title"], iF = ["title"], oF = ["title"], lF = ["title"], sF = ["title"];
function h() {
  return h = Object.assign || function(t) {
    for (var e = 1; e < arguments.length; e++) {
      var n = arguments[e];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
    }
    return t;
  }, h.apply(this, arguments);
}
function v(t, e) {
  if (t == null) return {};
  var n = cF(t, e), r, a;
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(t);
    for (a = 0; a < o.length; a++)
      r = o[a], !(e.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(t, r) && (n[r] = t[r]);
  }
  return n;
}
function cF(t, e) {
  if (t == null) return {};
  var n = {}, r = Object.keys(t), a, o;
  for (o = 0; o < r.length; o++)
    a = r[o], !(e.indexOf(a) >= 0) && (n[a] = t[a]);
  return n;
}
var dF = function(e) {
  var n = e.title, r = v(e, M$);
  return /* @__PURE__ */ i.createElement("svg", h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ i.createElement("title", null, n), /* @__PURE__ */ i.createElement("path", {
    fill: "#0052B4",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFF",
    d: "M440.1 181.1c-.1 39.2-6.4 81.4-57.4 101.5-51.1-20.1-57.3-62.3-57.4-101.5h114.8z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#29DBFF",
    d: "M439.6 197.7c-2.8 34.9-12.4 67.4-57 85-44.4-17.6-54.5-51.2-56.9-84.9"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFF",
    d: "M437.8 214.1c-3.2 24.3-16.7 53.5-55.1 68.6-38.4-15.1-50.5-42.5-55.1-68.4"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#29DBFF",
    d: "M434.2 230.3c-5.7 17.7-19.3 39.4-51.3 52.8-32-12.6-45.2-33.8-51.4-53"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFF",
    d: "M426.7 246.9c-6.5 11.3-17.7 25.4-44 35.9-27.5-11.5-37.4-25.3-44-36.1"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#29DBFF",
    d: "M412.4 265.1c-8.1 7.2-12 11.2-29.6 17.9-20.1-7.9-22.6-11.6-29.2-17.5"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#5CC85C",
    d: "M383.3 231.6c-.2-.2-27.9 35.7-27.9 35.7-1.8-1.3-10-9.5-13.3-15l41.3-50.1 40.2 49.7c-3.9 6.5-11.4 13.6-13.2 15M382.6 85.3l-26.5 45h53z"
  }), /* @__PURE__ */ i.createElement("ellipse", {
    transform: "rotate(-82.3 291.431 225.686)",
    fill: "#F7A226",
    cx: 291.4,
    cy: 225.7,
    rx: 48.7,
    ry: 15.7
  }), /* @__PURE__ */ i.createElement("ellipse", {
    transform: "rotate(-68.099 303.087 164.67)",
    fill: "#DDC7AB",
    cx: 303.1,
    cy: 164.7,
    rx: 11.7,
    ry: 7.2
  }), /* @__PURE__ */ i.createElement("ellipse", {
    transform: "rotate(-81.738 291.697 271.697)",
    fill: "#DDC7AB",
    cx: 291.7,
    cy: 271.7,
    rx: 11.4,
    ry: 3.3
  }), /* @__PURE__ */ i.createElement("ellipse", {
    transform: "matrix(.9986 -.05353 .05353 .9986 -13.992 16.424)",
    fill: "#DDC7AB",
    cx: 299.6,
    cy: 269.4,
    rx: 3.3,
    ry: 11
  }), /* @__PURE__ */ i.createElement("ellipse", {
    transform: "rotate(-21.518 314.54 201.06)",
    fill: "#DDC7AB",
    cx: 314.5,
    cy: 201.1,
    rx: 4.1,
    ry: 13.7
  }), /* @__PURE__ */ i.createElement("ellipse", {
    transform: "rotate(-21.518 317.511 178.077)",
    fill: "#DDC7AB",
    cx: 317.5,
    cy: 178.1,
    rx: 13.7,
    ry: 4.1
  }), /* @__PURE__ */ i.createElement("ellipse", {
    transform: "rotate(-7.7 473.781 225.857)",
    fill: "#F7A226",
    cx: 473.6,
    cy: 225.9,
    rx: 15.7,
    ry: 48.7
  }), /* @__PURE__ */ i.createElement("ellipse", {
    transform: "rotate(-21.901 462.057 164.866)",
    fill: "#DDC7AB",
    cx: 462,
    cy: 164.9,
    rx: 7.2,
    ry: 11.7
  }), /* @__PURE__ */ i.createElement("ellipse", {
    transform: "rotate(-8.27 473.27 271.908)",
    fill: "#DDC7AB",
    cx: 473.4,
    cy: 271.9,
    rx: 3.3,
    ry: 11.4
  }), /* @__PURE__ */ i.createElement("ellipse", {
    transform: "matrix(.05353 -.9986 .9986 .05353 171.34 719.998)",
    fill: "#DDC7AB",
    cx: 465.5,
    cy: 269.6,
    rx: 11,
    ry: 3.3
  }), /* @__PURE__ */ i.createElement("ellipse", {
    transform: "rotate(-68.482 450.552 201.247)",
    fill: "#DDC7AB",
    cx: 450.6,
    cy: 201.2,
    rx: 13.7,
    ry: 4.1
  }), /* @__PURE__ */ i.createElement("ellipse", {
    transform: "rotate(-68.482 447.58 178.265)",
    fill: "#DDC7AB",
    cx: 447.6,
    cy: 178.3,
    rx: 4.1,
    ry: 13.7
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#B0C6CC",
    d: "M373.3 130.3 356.1 155l17.8 26.1H396l4.7-25.4-5.4-25.4z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFF",
    d: "M256 0v117.4h-46.1l46.1 30.7v22.6h-22.6L160 121.8v48.9H96v-48.9l-73.4 48.9H0v-22.6l46.1-30.7H0v-64h46.1L0 22.7V0h22.6L96 48.9V0h64v48.9L233.4 0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#D80027",
    d: "M144 0h-32v69.4H0v32h112v69.3h32v-69.3h112v-32H144z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#2E52B2",
    d: "M256 22.7v30.7h-46.1z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#D80027",
    d: "M0 170.7v-11l62.5-42.3h22.6L7.3 170.7zM7.3.1l77.8 53.2H62.5L0 11.1V.1zM256 .1v11l-62.5 42.3h-22.6L248.7.1zm-7.3 170.6-77.8-53.3h22.6l62.5 42.3v11z"
  }));
}, uF = function(e) {
  var n = e.title, r = v(e, S$);
  return /* @__PURE__ */ i.createElement("svg", h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ i.createElement("title", null, n), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFDA44",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#0052B4",
    d: "M0 0h171v342H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#D80027",
    d: "M342 0h171v342H342zM198.9 113.6H256v64.8h-57.1z"
  }), /* @__PURE__ */ i.createElement("path", {
    d: "M267.6 113.6v64.7m16.6-64.7v64.7m16.6-64.7v64.7",
    stroke: "#D80027",
    strokeWidth: 7
  }), /* @__PURE__ */ i.createElement("path", {
    d: "M247.4 178.4v64.7m-13.3-64.7v64.7m-13.3-64.6v53.9m-13.7-53.9v47.1",
    stroke: "#D80027",
    strokeWidth: 5
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFDA44",
    d: "m199.9 146 27.6-32.4 28.5 32.3-28.1 32.4z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#BC8B00",
    d: "M182.2 95.9v92.2c0 34.3 27.3 54.2 48.6 64.5-.8 1.4 25.1 8.3 25.1 8.3s25.9-6.9 25.1-8.3c21.4-10.3 48.6-30.1 48.6-64.5V95.9H182.2zm129.9 92.2c0 16.9-10 29.4-32.8 43.9-8.6 5.5-17.5 9-23.3 11-5.8-2-14.7-5.5-23.3-11-22.8-14.5-32.8-28-32.8-43.9v-74.5h112.2v74.5z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#D80027",
    d: "M264.4 188.9h29.5v8.6h-29.5zm0 17.6h29.5v8.6h-29.5z"
  }));
}, fF = function(e) {
  var n = e.title, r = v(e, F$);
  return /* @__PURE__ */ i.createElement("svg", h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ i.createElement("title", null, n), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFF",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#009e49",
    d: "M0 0h513v114H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    d: "M0 228h513v114H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#ce1126",
    d: "M0 0h171v342H0z"
  }));
}, pF = function(e) {
  var n = e.title, r = v(e, P$);
  return /* @__PURE__ */ i.createElement("svg", h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ i.createElement("title", null, n), /* @__PURE__ */ i.createElement("path", {
    fill: "#DB3E00",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#479900",
    d: "M331 0h182v342H331z"
  }), /* @__PURE__ */ i.createElement("path", {
    d: "M0 0h181.8v342H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFF",
    d: "M256 126.7c-19.4 0-35.2 15.8-35.2 35.2v52.8h70.4v-52.8c0-19.5-15.8-35.2-35.2-35.2z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFF",
    d: "M256 84.3c-47.7 0-86.4 38.7-86.4 86.4S208.3 257 256 257s86.4-38.7 86.4-86.4-38.7-86.3-86.4-86.3zm0 157.7c-39.4 0-71.4-32-71.4-71.4 0-39.4 32-71.4 71.4-71.4 39.4 0 71.4 32 71.4 71.4 0 39.5-32 71.4-71.4 71.4z"
  }));
}, mF = function(e) {
  var n = e.title, r = v(e, N$);
  return /* @__PURE__ */ i.createElement("svg", h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ i.createElement("title", null, n), /* @__PURE__ */ i.createElement("path", {
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#0072c6",
    d: "M88.8 136.5c-2.2 12.9-3.4 26.2-3.4 39.8 0 13.6 1.2 27 3.4 39.8L256 228.3l167.2-12.1c2.2-12.9 3.4-26.2 3.4-39.8s-1.2-27-3.4-39.8"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFF",
    d: "M423.2 219H88.8c15.8 69.8 84.7 122.3 167.2 122.3S407.4 288.8 423.2 219z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFDA44",
    d: "M365.9 136.5H146.1l44.9-21.1-23.9-43.5 48.8 9.4L222 32l34 36.2L290 32l6.1 49.3 48.8-9.4-23.9 43.5z"
  }), /* @__PURE__ */ i.createElement("g", {
    fill: "#ce1126"
  }, /* @__PURE__ */ i.createElement("path", {
    d: "M256.5 342 0 0v342z"
  }), /* @__PURE__ */ i.createElement("path", {
    d: "M513 342V0L256 342z"
  })));
}, hF = function(e) {
  var n = e.title, r = v(e, _$);
  return /* @__PURE__ */ i.createElement("svg", h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ i.createElement("title", null, n), /* @__PURE__ */ i.createElement("path", {
    fill: "#00318b",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFF",
    d: "M454.8 265.38c7.94-10.93 13.24-24.27 13.24-40.42V104.89a59.754 59.754 0 0 1-36.02 12.01c-19.64 0-37.07-9.43-48.03-24.01-10.95 14.58-28.39 24.01-48.03 24.01-13.52 0-25.99-4.47-36.02-12v120.06c0 16.16 5.3 29.5 13.24 40.42H454.8z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#8DCCFF",
    d: "M310.23 260.98C332.65 296.96 384 309 384 309s51.35-12.04 73.77-48.02H310.23z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#D87B00",
    d: "M396.66 172.21c.32 1.42 8.72 10.17 17.56 20.15 1.39 1.57-8.74 12.63-6.91 12.59 4.75-.12 19.27-17.26 19.34 6.65.05 15.94-30 27.51-30 27.51h17.47l.65 14.96s4.97-13.34 7.59-16.57c8.1-9.97 20.18-30.07 34.59-27.1 14.41 2.97-13.66-13.92-13.66-13.92s-5.2-15.19-16.63-16.97c-10.06-1.57-14.29-2.51-26.64-7.3-1.68-.65-3.88-2.32-3.36 0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#D87B00",
    d: "M359.69 198.69c1.07-.99 4.46-12.63 8.69-25.28.67-1.99 15.31 1.27 14.35-.3-2.47-4.06-24.58-8.08-3.9-20.08 13.79-8 38.82 12.27 38.82 12.27l-8.72-15.14 12.64-8.03s-14.05 2.35-18.14 1.69c-12.68-2.04-36.13-2.48-40.75-16.45-4.62-13.97-5.25 18.79-5.25 18.79s-10.56 12.08-6.4 22.88c3.66 9.5 4.96 13.64 6.97 26.73.29 1.79-.06 4.53 1.69 2.92z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#D87B00",
    d: "M395.67 219.87c-1.39-.43-13.16 2.49-26.22 5.18-2.06.42-6.59-13.88-7.47-12.26-2.27 4.17 5.36 25.31-15.41 13.45-13.84-7.91-8.89-39.73-8.89-39.73l-8.71 15.14-13.29-6.9s9.09 10.96 10.57 14.84c4.6 11.99 16 32.49 6.24 43.49-9.76 11.01 18.88-4.9 18.88-4.9s15.76 3.07 23-5.96c6.38-7.94 9.3-11.14 19.61-19.45 1.43-1.12 3.97-2.19 1.69-2.9z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFF",
    d: "M256.5 0h-23.1L160 48.9V0H96v48.9L22.6 0H0v22.7l46.1 30.7H0v64h46.1L0 148.1V171h22.6L96 121.8V171h64v-49.2l73.4 49.2h23.1v-22.9l-46.6-30.7h46.6v-64h-46.6l46.6-30.7z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#D80027",
    d: "M144 0h-32v69.4H0v32h112V171h32v-69.6h112.5v-32H144z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#D80027",
    d: "M0 171v-11.3l62.5-42.3h22.6L7.3 171zM7.3.1l77.8 53.2H62.5L0 11.1V.1zm249.2 0v11l-63 42.3h-22.6L248.7.1zM248.7 171l-77.8-53.6h22.6l63 42.3V171z"
  }));
}, vF = function(e) {
  var n = e.title, r = v(e, T$);
  return /* @__PURE__ */ i.createElement("svg", h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 90 60"
  }, r), n && /* @__PURE__ */ i.createElement("title", null, n), /* @__PURE__ */ i.createElement("path", {
    fill: "#ED2024",
    d: "M0 0h90v60H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#212121",
    d: "M32.5 12.2v16l7.1 2.5-5 4.9 2.4 3 5.3-5.5 1.2 2.3-3 4.9 3.6 5.6-1.8 2.6 2.8 3.6 2.7-3.7-1.5-2.6 3-5.8-2.7-4.6 1.2-2.3 5.2 5.5 2.5-2.9-5.2-5.1 7.2-2.6V12.2l-5.2 1.9-.1 3.8-3.3.3v-2.6l1.7-2.3 5.6-2.2-2.3-.4 1.4-1.2.9.4-.8-1.4L54 9l-1-1.1L47.5 9l1.4 1.1-3.8 4.9-3.8-4.8 1.3-1.1-5-1.2L36.2 9l-1.5-.4-.8 1.4.9-.6 1.6 1.1-2.3.5 5.5 2 1.6 2.3v2.9l-3.3-.3v-3.6z"
  }), /* @__PURE__ */ i.createElement("path", {
    d: "M26.2 25h6.4v2.5h-6.4zm0-4.1h6.4v2.7h-6.4zm0-4.2h6.4v2.6h-6.4zm0-4h6.4v2.5h-6.4zM57.4 25h6.4v2.5h-6.4zm0-4.1h6.4v2.7h-6.4zm0-4.2h6.4v2.6h-6.4zm0-4h6.4v2.5h-6.4zM53.4 36.1h6.4V38h-6.4zm-23.2 0h6.4V38h-6.4z",
    fill: "#212121"
  }));
}, gF = function(e) {
  var n = e.title, r = v(e, A$);
  return /* @__PURE__ */ i.createElement("svg", h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ i.createElement("title", null, n), /* @__PURE__ */ i.createElement("path", {
    fill: "#0052B4",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#D80027",
    d: "M0 0h513v114H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#FF9811",
    d: "M0 228h513v114H0z"
  }));
}, yF = function(e) {
  var n = e.title, r = v(e, z$);
  return /* @__PURE__ */ i.createElement("svg", h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ i.createElement("title", null, n), /* @__PURE__ */ i.createElement("path", {
    d: "M0 171h513v171H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#D80027",
    d: "M0 0h513v171H0z"
  }), /* @__PURE__ */ i.createElement("g", {
    fill: "#FFDA44"
  }, /* @__PURE__ */ i.createElement("path", {
    d: "m332.7 135.6 17.5-8.6-7.4-19-18.7 6.2zm-45.6-56 5.5-18.8-19.1-7.2-8 18zm29.4 23.2 12.2-15.3-14.9-13.9-14.2 13.6zm19.4 68.9 19.5-.8v-21.3l-22.9.2zm-12.6 38.1 18.8 5.5 7.3-19-18-8zm-29 32.4 14.9 12.7 14.4-14.4-13.1-14.7zm-47-147.7 9.8 19.9 21.9 3.3-15.9 15.5 3.6 21.9-19.6-10.4-19.7 10.2 3.8-21.9-15.8-15.5 22-3.1z"
  }), /* @__PURE__ */ i.createElement("path", {
    d: "m250.8 61.3-2.7 18.3c43.1 3.2 77 39.2 77 83.1 0 46-37.3 82.9-83.4 83.4-29.2.3-51.3-14.8-67-33.7l-13.9 12.3c15 19 40.8 39.9 80.9 39.9 56.3 0 101.9-45.6 101.9-101.9.1-53.2-40.7-96.9-92.8-101.4z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#000",
    d: "m291.9 223.4-11.8 14s51.9 38.9 53.6 40.4c1.7 1.5 5.2 2 9.1-2.7 3.7-4.5 2.8-8.1.9-9.7-2-1.5-51.8-42-51.8-42z"
  }), /* @__PURE__ */ i.createElement("path", {
    d: "M206.1 157.2c-7.7 10.3-7.5 23.1 2.8 30.9 0 0 135.2 101.5 136.9 103 1.7 1.5 5.2 2 9.1-2.7 3.7-4.5 2.8-8.1.9-9.7-1.9-1.5-149.7-121.5-149.7-121.5zm47.7 99.1 7.3 18.2 19.5-6-4.8-19.1zm-40.4-3.7-2 19.5 20.1 3.6 4.5-19.1zm-35.7-21.2L167.4 248l16.4 12.1 12.5-15.2z"
  })));
}, bF = function(e) {
  var n = e.title, r = v(e, D$);
  return /* @__PURE__ */ i.createElement("svg", h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 744 496"
  }, r), n && /* @__PURE__ */ i.createElement("title", null, n), /* @__PURE__ */ i.createElement("path", {
    fill: "#3A7DCE",
    d: "M0 0h744v496H0V0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#fff",
    d: "m120 125 90 63 54-14 23-81 61-36 92 14 105 55 6 90 34 12v92l-65 115-78 24-72-17 18-30-8-32-10 9-162-25-49-85 20-46-49-62z"
  }));
}, EF = function(e) {
  var n = e.title, r = v(e, I$);
  return /* @__PURE__ */ i.createElement("svg", h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ i.createElement("title", null, n), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFF",
    d: "M0 0h512v342H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#338AF3",
    d: "M0 0h512v114H0zm0 228h512v114H0z"
  }), /* @__PURE__ */ i.createElement("circle", {
    fill: "#FFDA44",
    stroke: "#d6ab00",
    strokeWidth: 5,
    cx: 256.5,
    cy: 171,
    r: 40
  }));
}, wF = function(e) {
  var n = e.title, r = v(e, k$);
  return /* @__PURE__ */ i.createElement("svg", h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ i.createElement("title", null, n), /* @__PURE__ */ i.createElement("path", {
    fill: "#10338c",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#D80027",
    d: "M513 33 95.3 171 513 310.76V342L0 171 513 0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFF",
    d: "M513 287.18v24.58L81.72 171 513 30v24.16"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#A2001D",
    d: "m476.98 140.21-21.89 10.68-3.18-15.32 31.19-29.77s-9.42-40.65-13.75-44.98l-112.32 55.82-6.84 36.76-31.9 28.59-.4 34.2 34.29-22.76 67.23-2.66-1.51 38.11h22.23l11.9-44.64 31.55-24.61-6.6-19.42z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#EFC100",
    stroke: "#231F20",
    strokeMiterlimit: 10,
    d: "m317.89 238.41-22.24-11.11 22.24-11.11h144.46v22.22z"
  }));
}, $F = function(e) {
  var n = e.title, r = v(e, O$);
  return /* @__PURE__ */ i.createElement("svg", h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ i.createElement("title", null, n), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFF",
    d: "M0 114h513v114H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#D80027",
    d: "M0 0h513v114H0zm0 228h513v114H0z"
  }));
}, xF = function(e) {
  var n = e.title, r = v(e, L$);
  return /* @__PURE__ */ i.createElement("svg", h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ i.createElement("title", null, n), /* @__PURE__ */ i.createElement("path", {
    fill: "#10338c",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ i.createElement("g", {
    fill: "#FFF"
  }, /* @__PURE__ */ i.createElement("path", {
    d: "M222.2 170.7c.3-.3.5-.6.8-.9-.2.3-.5.6-.8.9zM188 212.6l11 22.9 24.7-5.7-11 22.8 19.9 15.8-24.8 5.6.1 25.4-19.9-15.9-19.8 15.9.1-25.4-24.8-5.6 19.9-15.8-11.1-22.8 24.8 5.7zm197.9 28.5 5.2 10.9 11.8-2.7-5.3 10.9 9.5 7.5-11.8 2.6v12.2l-9.4-7.6-9.5 7.6.1-12.2-11.8-2.6 9.5-7.5-5.3-10.9 11.8 2.7zm-48.6-116 5.2 10.9 11.8-2.7-5.3 10.9 9.5 7.5-11.8 2.7v12.1l-9.4-7.6-9.5 7.6.1-12.1-11.9-2.7 9.5-7.5-5.3-10.9L332 136zm48.6-66.2 5.2 10.9 11.8-2.7-5.3 10.9 9.5 7.5-11.8 2.7v12.1l-9.4-7.6-9.5 7.6.1-12.1-11.8-2.7 9.5-7.5-5.3-10.9 11.8 2.7zm42.5 49.7 5.2 10.9 11.8-2.7-5.3 10.9 9.5 7.5-11.8 2.6V150l-9.4-7.6-9.5 7.6v-12.2l-11.8-2.6 9.5-7.5-5.3-10.9 11.8 2.7zM398 166.5l4.1 12.7h13.3l-10.8 7.8 4.2 12.7-10.8-7.9-10.8 7.9 4.1-12.7-10.7-7.8h13.3z"
  }), /* @__PURE__ */ i.createElement("path", {
    d: "M254.8 0v30.6l-45.1 25.1h45.1V115h-59.1l59.1 32.8v22.9h-26.7l-73.5-40.9v40.9H99v-48.6l-87.4 48.6H-1.2v-30.6L44 115H-1.2V55.7h59.1L-1.2 22.8V0h26.7L99 40.8V0h55.6v48.6L242.1 0z"
  })), /* @__PURE__ */ i.createElement("path", {
    fill: "#D80027",
    d: "M142.8 0h-32v69.3h-112v32h112v69.4h32v-69.4h112v-32h-112z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#0052B4",
    d: "m154.6 115 100.2 55.7v-15.8L183 115z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFF",
    d: "m154.6 115 100.2 55.7v-15.8L183 115z"
  }), /* @__PURE__ */ i.createElement("path", {
    d: "m154.6 115 100.2 55.7v-15.8L183 115zm-83.9 0-71.9 39.9v15.8L99 115z",
    fill: "#D80027"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#0052B4",
    d: "M99 55.7-1.2 0v15.7l71.9 40z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFF",
    d: "M99 55.7-1.2 0v15.7l71.9 40z"
  }), /* @__PURE__ */ i.createElement("path", {
    d: "M99 55.7-1.2 0v15.7l71.9 40zm84 0 71.8-40V0L154.6 55.7z",
    fill: "#D80027"
  }));
}, CF = function(e) {
  var n = e.title, r = v(e, R$);
  return /* @__PURE__ */ i.createElement("svg", h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 363 242"
  }, r), n && /* @__PURE__ */ i.createElement("title", null, n), /* @__PURE__ */ i.createElement("path", {
    fill: "#338AF3",
    d: "M0 0h363v242H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFF",
    d: "M57 96.9 14.7 78.2 57 59.6l18.6-42.2 18.6 42.2 42.3 18.6-42.3 18.7-18.6 42.2z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#f30028",
    d: "m75.6 40.6 11.5 26.1 26.1 11.5-26.1 11.5-11.5 26.1-11.5-26.1L38 78.2l26.1-11.5z"
  }), /* @__PURE__ */ i.createElement("path", {
    d: "M0 152.2h363v15.7H0zm0 31.4h363v15.7H0z",
    fill: "#FFDA44"
  }));
}, MF = function(e) {
  var n = e.title, r = v(e, H$);
  return /* @__PURE__ */ i.createElement("svg", h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ i.createElement("title", null, n), /* @__PURE__ */ i.createElement("path", {
    fill: "#0052B4",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFDA44",
    d: "M513 210.9H202.2V342h-79.8V210.9H0v-79.8h122.4V0h79.8v131.1H513v61.2z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#D80027",
    d: "M513 149.7v42.6H183.7V342H141V192.3H0v-42.6h141V0h42.7v149.7z"
  }));
}, SF = function(e) {
  var n = e.title, r = v(e, B$);
  return /* @__PURE__ */ i.createElement("svg", h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ i.createElement("title", null, n), /* @__PURE__ */ i.createElement("path", {
    fill: "#ef3340",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#00b5e2",
    d: "M0 0h513v114H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#509e2f",
    d: "M0 228h513v114H0z"
  }), /* @__PURE__ */ i.createElement("g", {
    fill: "#FFF"
  }, /* @__PURE__ */ i.createElement("path", {
    d: "M265.6 212.6c-23 0-41.6-18.6-41.6-41.6s18.6-41.6 41.6-41.6c7.2 0 13.9 1.8 19.8 5-9.2-9-21.9-14.6-35.8-14.6-28.3 0-51.2 22.9-51.2 51.2s22.9 51.2 51.2 51.2c13.9 0 26.6-5.6 35.8-14.6-5.9 3.2-12.6 5-19.8 5z"
  }), /* @__PURE__ */ i.createElement("path", {
    d: "m297.6 142.2 5.5 15.5 14.9-7.1-7.1 14.9 15.5 5.5-15.5 5.5 7.1 14.9-14.9-7.1-5.5 15.5-5.5-15.5-14.9 7.1 7.1-14.9-15.5-5.5 15.5-5.5-7.1-14.9 14.9 7.1z"
  })));
}, FF = function(e) {
  var n = e.title, r = v(e, j$);
  return /* @__PURE__ */ i.createElement("svg", h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ i.createElement("title", null, n), /* @__PURE__ */ i.createElement("path", {
    fill: "#10338C",
    d: "M0 0h513.1v342H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#F6C500",
    d: "M99.9 0h342v342"
  }), /* @__PURE__ */ i.createElement("g", {
    fill: "#FFF"
  }, /* @__PURE__ */ i.createElement("path", {
    d: "M19.9 21.1 40.3 6.2 60.9 21 54 0H26.7z"
  }), /* @__PURE__ */ i.createElement("path", {
    d: "M92.3 25.5 84.4 1.3l-7.8 24.2H51.3l20.5 14.8-7.8 24 20.4-14.8L105 64.3l-7.9-24 20.5-14.9z"
  }), /* @__PURE__ */ i.createElement("path", {
    d: "m136.3 69.2-7.8-24-7.8 24H95.5l20.4 14.9-7.8 24 20.4-14.8 20.6 14.8-7.8-24 20.4-14.9z"
  }), /* @__PURE__ */ i.createElement("path", {
    d: "m179.4 112.3-7.8-24.1-7.8 24.1h-25.3l20.5 14.9-7.8 24 20.4-14.8 20.6 14.8-7.9-24 20.5-15z"
  }), /* @__PURE__ */ i.createElement("path", {
    d: "m222.5 155.3-7.8-24-7.8 24h-25.4l20.6 15-7.8 24 20.4-14.9 20.4 14.9-7.8-24 20.6-15z"
  }), /* @__PURE__ */ i.createElement("path", {
    d: "m265.6 198.4-7.8-24-7.8 24h-25.4l20.6 14.9-7.8 24.1 20.4-14.9 20.4 14.9-7.8-24.2 20.5-14.8z"
  }), /* @__PURE__ */ i.createElement("path", {
    d: "m308.7 241.5-7.9-24-7.8 24h-25.3l20.5 14.8-7.9 24.2 20.6-14.9 20.4 14.8-7.8-24.1 20.5-14.8z"
  }), /* @__PURE__ */ i.createElement("path", {
    d: "m351.7 284.6-7.8-24.2-7.8 24.2h-25.3l20.4 14.8-7.8 24.1 20.5-14.9 20.5 14.9-7.8-24.1 20.4-14.8z"
  }), /* @__PURE__ */ i.createElement("path", {
    d: "m387 303.5-7.9 24.1-25.3.1 19.8 14.3h26.6l19.9-14.4h-25.3z"
  })));
}, PF = function(e) {
  var n = e.title, r = v(e, V$);
  return /* @__PURE__ */ i.createElement("svg", h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ i.createElement("title", null, n), /* @__PURE__ */ i.createElement("path", {
    fill: "#ffc726",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    d: "M0 0h171v342H0zm342 0h171v342H342z",
    fill: "#00267f"
  }), /* @__PURE__ */ i.createElement("path", {
    d: "m325.74 101.02-31.97 12.4c-.68 1.35-5.79 7.54-8.18 53.06h-17.05v-60.42L256 78.68l-12.54 27v60.8H226.4c-2.39-45.53-7.8-52.48-8.47-53.84l-31.68-11.63c.15.31 15.4 31.34 15.4 78.01v12.54h41.81v71.07h25.08v-71.07h41.81v-12.54c0-24.13 4.17-44.02 7.68-56.46 3.82-13.57 7.7-21.49 7.74-21.57l-.03.03z"
  }));
}, NF = function(e) {
  var n = e.title, r = v(e, U$);
  return /* @__PURE__ */ i.createElement("svg", h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 513 342"
  }, r), n && /* @__PURE__ */ i.createElement("title", null, n), /* @__PURE__ */ i.createElement("path", {
    fill: "#2d6e41",
    d: "M0 85.331h513v342H0z"
  }), /* @__PURE__ */ i.createElement("circle", {
    fill: "#F40B32",
    cx: 218.902,
    cy: 256.5,
    r: 115
  }));
}, _F = function(e) {
  var n = e.title, r = v(e, W$);
  return /* @__PURE__ */ i.createElement("svg", h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ i.createElement("title", null, n), /* @__PURE__ */ i.createElement("path", {
    fill: "#fdda25",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    d: "M0 0h171v342H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#ef3340",
    d: "M342 0h171v342H342z"
  }));
}, TF = function(e) {
  var n = e.title, r = v(e, G$);
  return /* @__PURE__ */ i.createElement("svg", h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ i.createElement("title", null, n), /* @__PURE__ */ i.createElement("path", {
    fill: "#3d944f",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#ef2b2d",
    d: "M0 0h513v171H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFDA44",
    d: "m256 102.6 16.9 52h54.7l-44.2 32.2 16.8 52-44.2-32.1-44.2 32.1 16.8-52-44.2-32.2h54.7z"
  }));
}, AF = function(e) {
  var n = e.title, r = v(e, K$);
  return /* @__PURE__ */ i.createElement("svg", h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ i.createElement("title", null, n), /* @__PURE__ */ i.createElement("path", {
    fill: "#00966e",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFF",
    d: "M0 0h513v114H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#d62612",
    d: "M0 228h513v114H0z"
  }));
}, zF = function(e) {
  var n = e.title, r = v(e, q$);
  return /* @__PURE__ */ i.createElement("svg", h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ i.createElement("title", null, n), /* @__PURE__ */ i.createElement("path", {
    fill: "#D80027",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFF",
    d: "m222.8 34.3-85.2 34.2 85.2 34.1-85.2 34.1 85.2 34.1-85.2 34.1 85.2 34.1-85.2 34.1 85.2 34.1-85.2 34.8H0V0h137.6z"
  }));
}, DF = function(e) {
  var n = e.title, r = v(e, Y$);
  return /* @__PURE__ */ i.createElement("svg", h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ i.createElement("title", null, n), /* @__PURE__ */ i.createElement("path", {
    fill: "#D80027",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    d: "M215.9 170.7 0 314.6V26.8zM513 26.8v287.8L297.1 170.7z",
    fill: "#47a644"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#0052B4",
    d: "M513 26.8 296.1 170.7 513 314.6V342h-41.1L256 197.4 40.1 342H0v-27.4l215.9-143.9L0 26.8V0h40.1L256 143.9 471.9 0H513z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFF",
    d: "M513 26.8 297.1 170.7 513 314.6V342h-40L256 197.4 39 342H0v-27.4l215.9-143.9L0 26.8V0h40.1L256 143.9 471.9 0H513z"
  }), /* @__PURE__ */ i.createElement("circle", {
    fill: "#FFF",
    cx: 251.6,
    cy: 170.7,
    r: 100.2
  }), /* @__PURE__ */ i.createElement("path", {
    d: "m251.4 103.6 7.4 12.9h14.8l-7.4 12.8 7.4 12.8h-14.8l-7.4 12.9-7.4-12.9h-14.8l7.4-12.8-7.4-12.8H244zm38.8 66.7 7.4 12.9h14.8L305 196l7.4 12.8h-14.8l-7.4 12.9-7.4-12.9h-14.9l7.4-12.8-7.4-12.8h14.9zm-77.2 0 7.4 12.9h14.9l-7.4 12.8 7.4 12.8h-14.9l-7.4 12.9-7.4-12.9h-14.8l7.4-12.8-7.4-12.8h14.8z",
    fill: "#D80027",
    stroke: "#47a644",
    strokeWidth: 3
  }));
}, IF = function(e) {
  var n = e.title, r = v(e, Z$);
  return /* @__PURE__ */ i.createElement("svg", h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 513 342"
  }, r), n && /* @__PURE__ */ i.createElement("title", null, n), /* @__PURE__ */ i.createElement("path", {
    fill: "#008751",
    d: "M0 85.333h513v342H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#fcd116",
    d: "M196.666 85.333H513v171H196.666z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#e8112d",
    d: "M196.666 256H513v171H196.666z"
  }));
}, kF = function(e) {
  var n = e.title, r = v(e, X$);
  return /* @__PURE__ */ i.createElement("svg", h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ i.createElement("title", null, n), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFF",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#E6BC00",
    d: "M157.31 199.76s-9.04 43.93-19.31 40.39c-10.62-3.54-17.53-18.76-17.53-18.76l-14.52 21.24s38.18 8.48 41.01 5.47c1.22-1.14 8.21-15.1 10.34-26.05v-22.29zm-56.13 60.57s-2.48 20.18-1.06 22.66c1.24 2.3 39.48 11.33 39.48 11.33s-24.96 16.46-29.74 20.54L91.8 284.94l-.71-24.61h10.09zm11.33-165.69s39.65 41.6 40.36 45.5c.71 3.72-4.25 3.19-4.25 3.19s-44.79-37.53-49.92-41.07c-5.31-3.55 13.81-7.62 13.81-7.62z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#ADADAD",
    d: "M99.41 104.73s16.99-.71 16.64-11.51c-.35-10.62-11.15-14.87-19.12-12.39-7.97 2.3-23.01 13.45-13.63 35.05 9.38 21.42 23.37 29.39 26.2 47.8 0 0-5.46 9.86-19.12.35-16.9-11.77-6.2-38.24-10.44-44.96-4.25-7.08-40.95-38.92-40.95-38.92s-30.24 39.37-18 74.92c16.95 49.21 51.74 31.98 64.61 36.76 0 0-42.13 61.96-49.57 67.09 0 0 24.08 8.32 47.8-18.76 0 0 5.84 9.74 7.08 20.18h10.27c4.78-26.2 51.51-64.26 49.92-82.32-1.77-21.25-49.21-49.39-51.69-73.29z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#E6BC00",
    d: "M359.17 201.27s8.96 42.43 19.23 38.89c10.62-3.54 17.53-18.76 17.53-18.76l14.52 21.24s-37 8.48-39.83 5.47c-1.21-1.14-9.32-13.79-11.52-24.66l.07-22.18zm56.05 59.06s2.48 20.18 1.06 22.66c-1.24 2.3-39.48 11.33-39.48 11.33s24.96 16.46 29.74 20.54l18.06-29.92.71-24.61h-10.09zM403.89 94.64s-39.65 41.6-40.36 45.5c-.71 3.72 4.25 3.19 4.25 3.19s44.79-37.53 49.92-41.07c5.14-3.55-13.81-7.62-13.81-7.62z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#125ECC",
    d: "M157.31 87.06H359.1v145.46c0 16.06-9.69 21.39-21.91 31.85l-45.92 39.41c-18.25 15.62-47.91 15.57-66.07 0l-46.01-39.43c-12.08-10.35-21.88-15.71-21.88-31.82V87.06z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFE600",
    d: "M200.55 147.71c-7.96 0-14.41-6.45-14.41-14.41s6.45-14.41 14.41-14.41 14.41 6.45 14.41 14.41-6.45 14.41-14.41 14.41zm57.65-3c-7.96 0-14.41-6.45-14.41-14.41s6.45-14.41 14.41-14.41 14.41 6.45 14.41 14.41-6.45 14.41-14.41 14.41zm57.65 3c-7.96 0-14.41-6.45-14.41-14.41s6.45-14.41 14.41-14.41 14.41 6.45 14.41 14.41-6.45 14.41-14.41 14.41zM214.96 274.43c-7.96 0-14.41-6.45-14.41-14.41s6.45-14.41 14.41-14.41 14.41 6.45 14.41 14.41c.01 7.96-6.45 14.41-14.41 14.41zm43.24 14.42c-7.96 0-14.41-6.45-14.41-14.41s6.45-14.41 14.41-14.41 14.41 6.45 14.41 14.41c0 7.95-6.45 14.41-14.41 14.41zm43.24-14.42c-7.96 0-14.41-6.45-14.41-14.41s6.45-14.41 14.41-14.41 14.41 6.45 14.41 14.41-6.45 14.41-14.41 14.41z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#D60537",
    d: "M157.31 175.36H359.1v57.65H157.31v-57.65z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#EACE00",
    d: "M142.9 43.82s57.65-14.41 115.31-14.41 115.31 14.41 115.31 14.41l-14.41 57.65s-50.45-14.41-100.89-14.41-100.89 14.41-100.89 14.41L142.9 43.82z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#7A6920",
    d: "M258.2 72.65c-7.96 0-14.41-6.45-14.41-14.41s6.45-14.41 14.41-14.41 14.41 6.45 14.41 14.41-6.45 14.41-14.41 14.41zm57.65 5c-7.96 0-14.41-6.45-14.41-14.41s6.45-14.41 14.41-14.41 14.41 6.45 14.41 14.41-6.45 14.41-14.41 14.41zm-115.3 0c-7.96 0-14.41-6.45-14.41-14.41s6.45-14.41 14.41-14.41 14.41 6.45 14.41 14.41-6.45 14.41-14.41 14.41z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#ADADAD",
    d: "M365.08 178.02c-1.59 18.06 45.14 56.12 49.92 82.32h10.27c1.24-10.44 7.08-20.18 7.08-20.18 23.72 27.09 47.8 18.76 47.8 18.76-7.44-5.13-49.57-67.09-49.57-67.09 12.88-4.78 47.67 12.45 64.61-36.76 12.24-35.55-18-74.92-18-74.92s-36.7 31.84-40.95 38.92c-4.25 6.73 6.46 33.2-10.44 44.96-13.66 9.51-19.12-.35-19.12-.35 2.83-18.41 16.82-26.38 26.2-47.8 9.38-21.6-5.66-32.75-13.63-35.05-7.97-2.48-18.76 1.77-19.12 12.39-.35 10.8 16.64 11.51 16.64 11.51-2.48 23.9-49.92 52.04-51.69 73.29z"
  }), /* @__PURE__ */ i.createElement("circle", {
    fill: "#FFF",
    cx: 258.2,
    cy: 204.19,
    r: 16.93
  }));
}, OF = function(e) {
  var n = e.title, r = v(e, J$);
  return /* @__PURE__ */ i.createElement("svg", h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ i.createElement("title", null, n), /* @__PURE__ */ i.createElement("path", {
    fill: "#c8102e",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#012169",
    d: "M0 .1h256.5v171H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFF",
    d: "M256 0h-22.6L160 48.9V0H96v48.9L22.6 0H0v22.7l46.1 30.7H0v64h46.1L0 148.1v22.6h22.6L96 121.8v48.9h64v-48.9l73.4 48.9H256v-22.6l-46.1-30.7H256v-64h-46.1L256 22.7z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#c8102e",
    d: "M144 0h-32v69.4H0v32h112v69.3h32v-69.3h112v-32H144z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#c8102e",
    d: "M0 170.7v-11l62.5-42.3h22.6L7.3 170.7zM7.3.1l77.8 53.2H62.5L0 11.1V.1zM256 .1v11l-62.5 42.3h-22.6L248.7.1zm-7.3 170.6-77.8-53.3h22.6l62.5 42.3v11z"
  }), /* @__PURE__ */ i.createElement("g", {
    transform: "translate(13 5)"
  }, /* @__PURE__ */ i.createElement("path", {
    fill: "#fff",
    d: "M303.9 94.94v99.69c0 59.81 79.75 99.69 79.75 99.69s79.75-39.88 79.75-99.69V94.94H303.9z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#2F8F22",
    d: "M436.37 254.44H330.93c23.13 25.08 52.72 39.88 52.72 39.88s29.59-14.8 52.72-39.88z"
  }), /* @__PURE__ */ i.createElement("circle", {
    fill: "#65B5D2",
    cx: 383.65,
    cy: 214.56,
    r: 39.88
  }), /* @__PURE__ */ i.createElement("circle", {
    fill: "#c8102e",
    cx: 343.77,
    cy: 194.63,
    r: 19.94
  }), /* @__PURE__ */ i.createElement("circle", {
    fill: "#c8102e",
    cx: 423.52,
    cy: 194.63,
    r: 19.94
  }), /* @__PURE__ */ i.createElement("circle", {
    fill: "#c8102e",
    cx: 383.65,
    cy: 154.75,
    r: 19.94
  })));
}, LF = function(e) {
  var n = e.title, r = v(e, Q$);
  return /* @__PURE__ */ i.createElement("svg", h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ i.createElement("title", null, n), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFDA44",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    d: "m0 193.74 513 127.19V214.26L0 97.08z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFF",
    d: "M513 234.26v-86.67L0 20.41v86.67"
  }), /* @__PURE__ */ i.createElement("g", {
    fill: "#D80027",
    stroke: "#231F20",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }, /* @__PURE__ */ i.createElement("path", {
    d: "M306.4 134.01a50.28 50.28 0 0 1 6.07 24.02c0 21.55-13.51 39.94-32.52 47.19v-59.51c5.7-1.19 10-6.37 10-12.59 6.9 0 12.5-5.75 12.5-12.85h-.42c6.9 0 12.91-5.75 12.91-12.85h-34.99V76.58l-14.99-27.71-15 27.71v30.84h-34.99c0 7.1 6.01 12.85 12.91 12.85h-.42c0 7.1 5.6 12.85 12.5 12.85 0 6.22 4.29 11.4 9.99 12.59v61.37c-22.09-5.39-38.48-25.3-38.48-49.05 0-8.7 2.2-16.88 6.07-24.02-10.96 11.21-17.72 26.53-17.72 43.44 0 34.32 27.82 62.15 62.15 62.15s62.15-27.83 62.15-62.15c0-16.91-6.77-32.24-17.72-43.44z"
  }), /* @__PURE__ */ i.createElement("path", {
    d: "M198.46 226.81s20.69 27.71 66.5 27.71 66.5-27.71 66.5-27.71l13.47 28.37s-21.03 27.71-79.97 27.71-79.97-27.71-79.97-27.71l13.47-28.37zm-69.22-93.63h20.88l24.93 27.26v73.45h-26.28v-68.37zm270.76 0h-20.88l-24.93 27.26v73.45h26.27v-68.37z"
  })));
}, RF = function(e) {
  var n = e.title, r = v(e, ex);
  return /* @__PURE__ */ i.createElement("svg", h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ i.createElement("title", null, n), /* @__PURE__ */ i.createElement("path", {
    fill: "#d52b1e",
    d: "M0 0h513v114H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#f9e300",
    d: "M0 114h513v114H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#007934",
    d: "M0 228h513v114H0z"
  }));
}, HF = function(e) {
  var n = e.title, r = v(e, tx);
  return /* @__PURE__ */ i.createElement("svg", h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ i.createElement("title", null, n), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFF",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#012a87",
    d: "M0 342h513V0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#f9d90f",
    d: "M250.4 0H0v166.9z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#dc171d",
    d: "m140.4 118.3 12.2 21.2h24.5l-12.3 21.1 12.3 21.2h-24.5L140.4 203l-12.2-21.2h-24.5l12.3-21.2-12.3-21.1h24.5z"
  }), /* @__PURE__ */ i.createElement("circle", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 9,
    strokeMiterlimit: 10,
    cx: 140.4,
    cy: 160.6,
    r: 57.7
  }));
}, BF = function(e) {
  var n = e.title, r = v(e, nx);
  return /* @__PURE__ */ i.createElement("svg", h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ i.createElement("title", null, n), /* @__PURE__ */ i.createElement("path", {
    fill: "#009b3a",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#fedf00",
    d: "m256.5 19.3 204.9 151.4L256.5 322 50.6 170.7z"
  }), /* @__PURE__ */ i.createElement("circle", {
    fill: "#FFF",
    cx: 256.5,
    cy: 171,
    r: 80.4
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#002776",
    d: "M215.9 165.7c-13.9 0-27.4 2.1-40.1 6 .6 43.9 36.3 79.3 80.3 79.3 27.2 0 51.3-13.6 65.8-34.3-24.9-31-63.2-51-106-51zm119 20.3c.9-5 1.5-10.1 1.5-15.4 0-44.4-36-80.4-80.4-80.4-33.1 0-61.5 20.1-73.9 48.6 10.9-2.2 22.1-3.4 33.6-3.4 46.8.1 89 19.5 119.2 50.6z"
  }));
}, jF = function(e) {
  var n = e.title, r = v(e, rx);
  return /* @__PURE__ */ i.createElement("svg", h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ i.createElement("title", null, n), /* @__PURE__ */ i.createElement("path", {
    fill: "#ffc72c",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    d: "M0 0h513v114H0zm0 228h513v114H0z",
    fill: "#00778b"
  }), /* @__PURE__ */ i.createElement("path", {
    d: "M256 171 0 342V0z"
  }));
}, VF = function(e) {
  var n = e.title, r = v(e, ax);
  return /* @__PURE__ */ i.createElement("svg", h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ i.createElement("title", null, n), /* @__PURE__ */ i.createElement("path", {
    fill: "#FF7415",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFDA44",
    d: "M513 0H0v342"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "none",
    stroke: "#FFF",
    strokeWidth: 42,
    strokeMiterlimit: 10,
    d: "M128.7 255.5s35 54 67.3 32.4c56.9-37.9-68.9-108.6-2.9-152.6 58.3-38.8 76.6 103.5 137.6 62.8 59-39.3-64.7-111.4-9.2-148.4 33.4-22.2 67.1 32.6 67.1 32.6"
  }));
}, UF = function(e) {
  var n = e.title, r = v(e, ix);
  return /* @__PURE__ */ i.createElement("svg", h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 33.333 1100 733.333"
  }, r), n && /* @__PURE__ */ i.createElement("title", null, n), /* @__PURE__ */ i.createElement("path", {
    fill: "#ef2b2d",
    d: "M0 0h1100v800H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#fff",
    d: "M300 0h200v800H300z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#fff",
    d: "M0 300h1100v200H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#002868",
    d: "M350 0h100v800H350z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#002868",
    d: "M0 350h1100v100H0z"
  }));
}, WF = function(e) {
  var n = e.title, r = v(e, ox);
  return /* @__PURE__ */ i.createElement("svg", h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ i.createElement("title", null, n), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFF",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    d: "M0 238h513v104H0zM0 0h513v104H0z",
    fill: "#6da9d2"
  }), /* @__PURE__ */ i.createElement("path", {
    d: "M0 125.5h513v89.656H0z"
  }));
}, GF = function(e) {
  var n = e.title, r = v(e, lx);
  return /* @__PURE__ */ i.createElement("svg", h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ i.createElement("title", null, n), /* @__PURE__ */ i.createElement("path", {
    fill: "#007C30",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#CE1720",
    d: "M0 230h513V0H0"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFF",
    d: "M100 230V0H0v342h513-413z"
  }), /* @__PURE__ */ i.createElement("path", {
    d: "M28 159.6 8.6 128.2 28 97.4l19.3 30.8zm44.6 0-19.3-31.4 19.3-30.8L92 128.2zM28 241.2 8.6 209.8 28 179l19.3 30.8zm44.6 0-19.3-31.4L72.6 179 92 209.8z",
    fill: "#CE1720"
  }), /* @__PURE__ */ i.createElement("path", {
    d: "m28 73.8-16.1-26L28 22.2l16 25.6zm44.6 0-16-26 16-25.6 16.1 25.6zM28 318l-16.1-26.1L28 266.3l16 25.6zm44.6 0-16-26.1 16-25.6 16.1 25.6z",
    fill: "none",
    stroke: "#CE1720",
    strokeWidth: 7
  }));
}, KF = function(e) {
  var n = e.title, r = v(e, sx);
  return /* @__PURE__ */ i.createElement("svg", h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ i.createElement("title", null, n), /* @__PURE__ */ i.createElement("path", {
    fill: "#003e87",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ i.createElement("circle", {
    fill: "#FFF",
    cx: 260.9,
    cy: 170.9,
    r: 118.9
  }), /* @__PURE__ */ i.createElement("circle", {
    fill: "none",
    stroke: "#6DA544",
    strokeWidth: 18,
    strokeMiterlimit: 10,
    cx: 261.9,
    cy: 173.1,
    r: 94.5
  }), /* @__PURE__ */ i.createElement("g", {
    stroke: "#000"
  }, /* @__PURE__ */ i.createElement("path", {
    fill: "#003e87",
    d: "m261.9 151.5-50.6 23.4v20c0 11.8 6.1 22.8 16.2 28.9L262 239l34.5-15.2c10-6.2 16.2-17.1 16.2-28.9v-20l-50.8-23.4z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFDA44",
    d: "M211.3 128.1h101.3v46.7H211.3z"
  })), /* @__PURE__ */ i.createElement("path", {
    d: "M0 0h513v35H0zm0 306h513v35H0z",
    fill: "#ce1127"
  }));
}, qF = function(e) {
  var n = e.title, r = v(e, cx);
  return /* @__PURE__ */ i.createElement("svg", h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ i.createElement("title", null, n), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFF",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    d: "M0 0h142v342H0zm371 0h142v342H371zm-64.5 206 50.4-25.2-25.2-12.6V143l-50.4 25.2 25.2-50.4h-25.2L256.1 80l-25.2 37.8h-25.2l25.2 50.4-50.4-25.2v25.2l-25.2 12.6 50.4 25.2-12.6 25.2h50.4V269h25.2v-37.8h50.4z",
    fill: "red"
  }));
}, YF = function(e) {
  var n = e.title, r = v(e, dx);
  return /* @__PURE__ */ i.createElement("svg", h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ i.createElement("title", null, n), /* @__PURE__ */ i.createElement("path", {
    fill: "green",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    d: "m422.7 252.4 6.2 12.8 13.8-3.2-6.2 12.8 11.2 8.8-13.9 3.2V301l-11.1-8.9-11.1 8.9v-14.2l-13.8-3.2 11.1-8.8-6.2-12.8 13.9 3.2zm-46.6-136.3 6.2 12.9 13.8-3.2-6.2 12.8 11.2 8.8-13.9 3.1v14.3l-11.1-8.9-11.1 8.9.1-14.3-13.9-3.1 11.1-8.8-6.2-12.8L370 129zm37-77.8 6.2 12.8 13.8-3.2-6.2 12.8 11.2 8.9-13.9 3.1v14.2L413.1 78 402 86.9l.1-14.2-13.9-3.1 11.1-8.9-6.2-12.8 13.9 3.2zm51.8 58.4 6.2 12.8 13.9-3.2-6.3 12.8 11.2 8.9-13.9 3.1.1 14.2-11.2-8.9-11.1 8.9.1-14.2L440 128l11.2-8.9-6.3-12.8 13.9 3.2zm-28 68.1 4.9 14.8h15.6l-12.6 9.2 4.8 14.9-12.7-9.2-12.6 9.2 4.8-14.9-12.6-9.2h15.6zM306.8 254.7c-49.2 0-89.1-39.9-89.1-89.1s39.9-89.1 89.1-89.1c15.3 0 29.8 3.9 42.4 10.7C329.4 67.9 302.3 56 272.5 56c-60.5 0-109.6 49.1-109.6 109.6S212 275.3 272.5 275.3c29.8 0 56.9-11.9 76.6-31.3-12.6 6.8-27 10.7-42.3 10.7zM140.4 59.5C129.7 41 109.7 28.6 86.8 28.6S44 41 33.3 59.5h107.1zm.2.4-53.8 53.8-53.7-53.8C28 68.9 25 79.3 25 90.5c0 34.2 27.7 61.9 61.9 61.9s61.9-27.7 61.9-61.9c-.1-11.2-3.1-21.6-8.2-30.6z",
    fill: "#FFDA44"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#A2001D",
    d: "M71.4 98.2v52.2c4.9 1.3 10.1 1.9 15.5 1.9s10.5-.7 15.5-1.9V98.2h-31z"
  }));
}, ZF = function(e) {
  var n = e.title, r = v(e, ux);
  return /* @__PURE__ */ i.createElement("svg", h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ i.createElement("title", null, n), /* @__PURE__ */ i.createElement("path", {
    fill: "#338AF3",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFDA44",
    d: "M513 66.9V0H411.7L0 274.4V342h100.3z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#D80027",
    d: "M513 0v40.1L60.2 342H0v-40.8L451.8 0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFDA44",
    d: "m93.6 31.2 16.3 50.4H163l-42.9 31.2 16.4 50.5-42.9-31.2-43 31.2L67 112.8 24.1 81.6h53.1z"
  }));
}, XF = function(e) {
  var n = e.title, r = v(e, fx);
  return /* @__PURE__ */ i.createElement("svg", h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ i.createElement("title", null, n), /* @__PURE__ */ i.createElement("path", {
    fill: "#d21034",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    d: "M0 171h211.5v85.3H0zm300.5 0H512v85.3H300.5z",
    fill: "#3a9927"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#003082",
    d: "M0 0v85.3h211.5V0h89v85.3H513V0z"
  }), /* @__PURE__ */ i.createElement("path", {
    d: "M300.5 85.3H512v85.3H300.5zM0 85.3h211.5v85.3H0z",
    fill: "#FFF"
  }), /* @__PURE__ */ i.createElement("path", {
    d: "M300.5 342h-89v-86H0v86h513v-86H300.5zM105.7 8.6l8.6 26.2h27.5L119.5 51l8.6 26.2L105.7 61 83.4 77.2 91.9 51 69.6 34.8h27.6z",
    fill: "#ffce00"
  }));
}, JF = function(e) {
  var n = e.title, r = v(e, px);
  return /* @__PURE__ */ i.createElement("svg", h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 513 342"
  }, r), n && /* @__PURE__ */ i.createElement("title", null, n), /* @__PURE__ */ i.createElement("path", {
    fill: "#da1a35",
    d: "M0 85.331h513v342H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#009543",
    d: "M443.726 85.331 102.4 426.657H0V85.331z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#fbde4a",
    d: "M500.124 85.331 158.798 426.657H11.876L353.202 85.331z"
  }));
}, QF = function(e) {
  var n = e.title, r = v(e, mx);
  return /* @__PURE__ */ i.createElement("svg", h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 513 342"
  }, r), n && /* @__PURE__ */ i.createElement("title", null, n), /* @__PURE__ */ i.createElement("path", {
    fill: "red",
    d: "M0 85.337h513v342H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFF",
    d: "M356.174 222.609h-66.783v-66.783h-66.782v66.783h-66.783v66.782h66.783v66.783h66.782v-66.783h66.783z"
  }));
}, eP = function(e) {
  var n = e.title, r = v(e, hx);
  return /* @__PURE__ */ i.createElement("svg", h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ i.createElement("title", null, n), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFF",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#009e60",
    d: "M342 0h171v342H342z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#f77f00",
    d: "M0 0h171v342H0z"
  }));
}, tP = function(e) {
  var n = e.title, r = v(e, vx);
  return /* @__PURE__ */ i.createElement("svg", h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 513 342"
  }, r), n && /* @__PURE__ */ i.createElement("title", null, n), /* @__PURE__ */ i.createElement("path", {
    fill: "#01237a",
    d: "M0 85.332h513v342H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    d: "m384 156.705 5.283 16.254h17.089l-13.826 10.045 5.281 16.254L384 189.211l-13.825 10.047 5.28-16.254-13.825-10.045h17.089zm-70.209 29.081 15.228 7.758 12.084-12.083-2.673 16.879 15.227 7.759-16.879 2.673-2.674 16.88-7.76-15.227-16.878 2.673 12.086-12.084zm-29.081 70.209 16.254-5.281.001-17.089 10.044 13.825 16.254-5.282-10.046 13.827 10.046 13.826-16.254-5.28-10.044 13.825v-17.09zm29.081 70.209 7.759-15.229-12.084-12.084 16.881 2.674 7.757-15.227 2.674 16.879 16.879 2.672-15.227 7.759 2.673 16.882-12.084-12.087zM384 355.284l-5.281-16.253h-17.091l13.827-10.045-5.28-16.254L384 322.776l13.827-10.044-5.281 16.254 13.826 10.045h-17.089zm70.209-29.08-15.229-7.758-12.083 12.084 2.673-16.882-15.227-7.756 16.879-2.675 2.675-16.879 7.756 15.227 16.881-2.674-12.086 12.085zm29.081-70.209-16.254 5.281v17.09l-10.045-13.826-16.254 5.281 10.046-13.826-10.046-13.827 16.254 5.282 10.045-13.825v17.089zm-29.081-70.207-7.757 15.226 12.082 12.084-16.881-2.673-7.756 15.227-2.675-16.88-16.879-2.675 15.227-7.757-2.673-16.878 12.084 12.082zM0 186.665v16h46.069L0 233.377v7.539l57.377-38.252H80L0 255.998h112v-69.334H0zm96 69.331H22.628L96 207.083v48.913zm80-117.331 80-53.334H144v69.334h112v-16h-46.069L256 107.951v-7.539l-57.377 38.251H176v.002zm-16-53.332h73.372L160 134.246V85.333zm-16 170.665h112l-80-53.334h22.623L256 240.917v-7.539l-46.069-30.713H256v-16H144v69.333zm16-48.915 73.372 48.913H160v-48.913zM112 85.331H0l80 53.334H57.377L0 100.413v7.539l46.069 30.712H0v16h112V85.331zm-16 48.915L22.628 85.333H96v48.913z",
    fill: "#FFF"
  }), /* @__PURE__ */ i.createElement("g", {
    fill: "#D80027"
  }, /* @__PURE__ */ i.createElement("path", {
    d: "M144 85.331h-32v69.334H0v32h112v69.333h32v-69.333h112v-32H144z"
  }), /* @__PURE__ */ i.createElement("path", {
    d: "M80 138.665 0 85.331v15.082l57.377 38.252zm96 0h22.623L256 100.413V85.331zm-118.623 64L0 240.917v15.081l80-53.333zm118.623 0 80 53.333v-15.081l-57.377-38.252z"
  })));
}, nP = function(e) {
  var n = e.title, r = v(e, gx);
  return /* @__PURE__ */ i.createElement("svg", h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ i.createElement("title", null, n), /* @__PURE__ */ i.createElement("path", {
    fill: "#D80027",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFF",
    d: "M196 0h317v171H196z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#0037A1",
    d: "M0 0h196v171H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFF",
    d: "M98 24.5 113.1 71H162l-39.6 28.7 15.2 46.5L98 117.5l-39.6 28.7 15.2-46.5L34 71h48.9z"
  }));
}, rP = function(e) {
  var n = e.title, r = v(e, yx);
  return /* @__PURE__ */ i.createElement("svg", h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ i.createElement("title", null, n), /* @__PURE__ */ i.createElement("path", {
    fill: "#ce1126",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#007a5e",
    d: "M0 0h171v342H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    d: "M342 0h171v342H342zm-86 102.2 17.2 53H329L283.9 188l17.2 53-45.1-32.7-45.1 32.7 17.2-53-45.1-32.8h55.8z",
    fill: "#fcd116"
  }));
}, aP = function(e) {
  var n = e.title, r = v(e, bx);
  return /* @__PURE__ */ i.createElement("svg", h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ i.createElement("title", null, n), /* @__PURE__ */ i.createElement("path", {
    fill: "#D80027",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    d: "m226.8 239.2-9.7-15.6-17.9 4.4 11.9-14.1-9.7-15.6 17.1 6.9 11.8-14.1-1.3 18.4 17.1 6.9-17.9 4.4zM290.6 82l-10.1 15.4 11.6 14.3-17.7-4.8-10.1 15.5-1-18.4-17.7-4.8 17.2-6.6-1-18.4 11.6 14.3zm-54.4-56.6-2 18.3 16.8 7.6-18 3.8-2 18.3-9.2-16-17.9 3.8 12.3-13.7-9.2-15.9 16.8 7.5zm56.6 136.4-14.9 10.9 5.8 17.5-14.9-10.8-14.9 11 5.6-17.6-14.9-10.7 18.4-.1 5.6-17.6 5.8 17.5zM115 46.3l17.3 53.5h56.2l-45.4 32.9 17.3 53.5-45.4-33-45.5 33 17.4-53.5-45.5-32.9h56.3z",
    fill: "#FFDA44"
  }));
}, iP = function(e) {
  var n = e.title, r = v(e, Ex);
  return /* @__PURE__ */ i.createElement("svg", h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ i.createElement("title", null, n), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFDA44",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#D80027",
    d: "M0 256.5h513V342H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#0052B4",
    d: "M0 171h513v85.5H0z"
  }));
}, oP = function(e) {
  var n = e.title, r = v(e, wx);
  return /* @__PURE__ */ i.createElement("svg", h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ i.createElement("title", null, n), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFF",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#D80027",
    d: "M0 114h513v114H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#0052B4",
    d: "M0 285h513v57H0zM0 0h513v57H0z"
  }));
}, lP = function(e) {
  var n = e.title, r = v(e, $x);
  return /* @__PURE__ */ i.createElement("svg", h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ i.createElement("title", null, n), /* @__PURE__ */ i.createElement("path", {
    fill: "#FF9811",
    d: "M0-40.8v422.9-211.4z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFF",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    d: "M0 0h513v68.3H0zm0 136.5h513v68.3H0zm0 136.6h513v68.3H0z",
    fill: "#0052B4"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#D80027",
    d: "M256 170.7 0 342V0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFF",
    d: "m86.5 111.4 12.7 39.2h41.3l-33.4 24.2 12.8 39.3-33.4-24.2-33.4 24.2 12.8-39.3-33.4-24.2h41.2z"
  }));
}, sP = function(e) {
  var n = e.title, r = v(e, xx);
  return /* @__PURE__ */ i.createElement("svg", h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ i.createElement("title", null, n), /* @__PURE__ */ i.createElement("path", {
    fill: "#003893",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#cf2027",
    d: "M0 182.2h513v41.4H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFF",
    d: "M0 140.8h513v41.4H0zm0 82.8h513V265H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    d: "m150.4 70 6.9 21.1h22.2l-18 13.1 6.9 21.1-18-13.1-17.9 13.1 6.8-21.1-17.9-13.1h22.2zm0 209.7 6.9 21.1h22.2l-18 13 6.9 21.2-18-13.1-17.9 13.1 6.8-21.2-17.9-13h22.2zm-97.6-70.9 6.9 21.1h22.2l-18 13 6.9 21.2-18-13.1-17.9 13.1 6.8-21.2-17.9-13H46zM90.1 91l6.9 21.1h22.2l-18 13 6.9 21.2-18-13.1-17.9 13.1 6.8-21.2-18-13h22.3zm-66.3 71H46l6.8-21.1 6.9 21.1h22.2l-18 13.1 6.9 21.1-18-13-17.9 13 6.8-21.1zm48.4 148.9 6.8-21.1-18-13h22.3l6.8-21.2 6.9 21.2h22.2l-18 13 6.9 21.1-18-13zM248 208.8l-6.9 21.1h-22.2l18 13-6.9 21.2 18-13.1 18 13.1-6.9-21.2 18-13h-22.2zM210.7 91l-6.8 21.1h-22.2l17.9 13-6.8 21.2 17.9-13.1 18 13.1-6.9-21.2 18-13h-22.2zm66.4 71h-22.2l-6.9-21.1-6.9 21.1h-22.2l18 13.1-6.9 21.1 18-13 18 13-6.9-21.1zm-48.4 148.9-6.9-21.1 18-13h-22.2l-6.9-21.2-6.8 21.2h-22.2l17.9 13-6.8 21.1 17.9-13z",
    fill: "#f7d116",
    stroke: "#000"
  }));
}, cP = function(e) {
  var n = e.title, r = v(e, Cx);
  return /* @__PURE__ */ i.createElement("svg", h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ i.createElement("title", null, n), /* @__PURE__ */ i.createElement("path", {
    fill: "#002b7f",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#f9e814",
    d: "M0 233.5h513v51H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    d: "m168.7 86.5 12.9 39.8h41.8l-33.8 24.5 12.9 39.7-33.8-24.5-33.8 24.5 12.9-39.7-33.8-24.5h41.8zm-83.3-54 7.8 23.9h25L97.9 71.1l7.8 23.8-20.3-14.7-20.3 14.7 7.8-23.8-20.3-14.7h25.1z",
    fill: "#FFF"
  }));
}, dP = function(e) {
  var n = e.title, r = v(e, Mx);
  return /* @__PURE__ */ i.createElement("svg", h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ i.createElement("title", null, n), /* @__PURE__ */ i.createElement("path", {
    fill: "#0021ad",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#1c8a42",
    d: "M0 0h513v342"
  }), /* @__PURE__ */ i.createElement("path", {
    d: "m77.6 272 5.7 11.9 12.8-3-5.7 11.9 10.3 8.1-12.8 2.9V317l-10.3-8.3-10.2 8.3v-13.2l-12.8-2.9 10.3-8.1-5.8-11.9 12.9 3zm-37.1-98.9 5.7 11.9 12.8-3-5.7 11.8 10.3 8.2-12.9 2.9.1 13.2-10.3-8.3-10.3 8.3.1-13.2-12.9-2.9 10.4-8.2L22 182l12.8 3zm37.1-80.9 5.7 11.8 12.8-2.9-5.7 11.8 10.3 8.2-12.8 2.9v13.1l-10.3-8.2-10.2 8.2V124l-12.8-2.9 10.3-8.2-5.8-11.8L72 104zm46.1 62.9 5.7 11.9 12.8-3-5.7 11.9 10.3 8.1-12.8 2.9v13.2l-10.3-8.2-10.2 8.2v-13.2l-12.8-2.9 10.3-8.1-5.7-11.9 12.8 3zm-32.9 54 4.4 13.7h14.5L98 231.3l4.5 13.7-11.7-8.4-11.7 8.4 4.5-13.7-11.7-8.5h14.4z",
    fill: "#FFF"
  }), /* @__PURE__ */ i.createElement("circle", {
    fill: "#ffc639",
    cx: 267.1,
    cy: 170.7,
    r: 74.5
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#1c8a42",
    d: "M267.1 220.3h24.8s10.8-19 0-37.2l24.8-24.8-12.4-24.8h-12.4s-6.2 18.6-31 18.6-31-18.6-31-18.6h-12.4l12.4 24.8-12.4 24.8 12.4 12.4s12.4-24.8 37.2-12.4c0 0 10.5 15.5 0 37.2z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#ffc639",
    d: "M464.4 92.2c.6-2.9-.2-17.6-.2-20.7 0-21.3-13.9-39.4-33.2-45.7 5.9 12 9.2 25.4 9.2 39.7 0 4.8-.4 9.5-1.1 14.1-2.9-4.7-6.6-8.9-11.2-12.6-17.1-13.6-40.6-14-57.9-2.5 13.4 2.9 26.3 8.9 37.7 18 9 7.1 16.2 16.8 21.7 26.1 0 0-17.8 10.9-31 15.1s-42.3 7.9-42.3 7.9c72 12 132-36 132-36-6.5-13.4-15.8-4-23.7-3.4z"
  }));
}, uP = function(e) {
  var n = e.title, r = v(e, Sx);
  return /* @__PURE__ */ i.createElement("svg", h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ i.createElement("title", null, n), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFF",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#DB7D00",
    d: "M141.7 154.7s.2 67.1 74.7 65.3l4.5 13.9h8.9s-7.4-41.1 60.1-41.5c0 0 0-27.6 27.6-27.6H359s-66-51.8 58.9-118l1.8-13.1s-129.9 71-198.9 57.2c0 0 10.7 42.5-10.8 42.5-10.8 0-9.7-8.1-32.3-8.1-18.7 0-17.3 19.7-26.3 19.5-8.9-.2-18.8-12.3-19.6-10.2-.7 2.1 9.9 20.1 9.9 20.1z"
  }), /* @__PURE__ */ i.createElement("g", {
    fill: "#006651"
  }, /* @__PURE__ */ i.createElement("path", {
    d: "M237.2 308.1c6.9-5 13-6.6 22.4-8.3s19.4-4.4 24.6-5.8-17.7 6.6-23.5 8.3c-5.8 1.6-23.5 5.8-23.5 5.8zm37.9-14.7c-1.9-11.9 2.8-24.3 13.5-29.3 2.5 8.6-5.2 23.2-13.5 29.3zm18.2-6.2c-5.8-9.8 4-22.6 11.1-28.8 3.3 6-2.5 23.7-11.1 28.8zm16.9-7.6c-6.2-8.4 1.1-23.2 8.8-29 3.1 8.2.1 23.2-8.8 29zm16.9-10.6c-5.6-8-1.7-20.4 6.3-28.4 5.8 6.6.9 21-6.3 28.4zm13.5-10.7c-4.7-7.5 1.1-25.4 8.6-30.4 3.3 6.6.8 25.4-8.6 30.4zm10.8-2.8c-1.4-10.8 17.4-22.7 25.2-22.4-.9 8.9-8.9 18.6-25.2 22.4zm-10.5 12.2c8.8-9.1 26-9.1 32.1-7.2-1.7 5.3-21.9 16.9-32.1 7.2z"
  }), /* @__PURE__ */ i.createElement("path", {
    d: "M328.7 276.8c12.4-3.3 20.5-6.1 27.9 1.7-5.2 6.6-25.4 4.7-27.9-1.7zm-17.7 8c11.9-6.4 26.3 3 28.5 8.6-13.3 5.5-28.7-7.2-28.5-8.6zm-16.3 9.2c10.8-4.1 23.2 1.4 28.2 7.5-5.8 2.7-21 5.7-28.2-7.5zm-14.9 4.7c12.4-1.4 24.4 8 27 13.4-15.9 1.5-22-3.2-27-13.4zm-4 9.4c-6.9-5-13-6.6-22.4-8.3-9.4-1.7-19.4-4.4-24.6-5.8-5.3-1.4 17.7 6.6 23.5 8.3 5.8 1.6 23.5 5.8 23.5 5.8zm-37.9-14.7c1.9-11.9-2.8-24.3-13.5-29.3-2.5 8.6 5.2 23.2 13.5 29.3zm-18.2-6.2c5.8-9.8-4-22.6-11.1-28.8-3.3 6 2.5 23.7 11.1 28.8zm-16.9-7.6c6.2-8.4-1.1-23.2-8.8-29-3.1 8.2-.1 23.2 8.8 29zM185.9 269c5.6-8 1.7-20.4-6.3-28.4-5.8 6.6-.9 21 6.3 28.4zm-13.5-10.7c4.7-7.5-1.1-25.4-8.6-30.4-3.3 6.6-.8 25.4 8.6 30.4zm-10.8-2.8c1.4-10.8-17.4-22.7-25.2-22.4.9 8.9 8.9 18.6 25.2 22.4zm10.5 12.2c-8.8-9.1-26-9.1-32.1-7.2 1.7 5.3 21.9 16.9 32.1 7.2z"
  }), /* @__PURE__ */ i.createElement("path", {
    d: "M184.3 276.8c-12.4-3.3-20.5-6.1-27.9 1.7 5.2 6.6 25.4 4.7 27.9-1.7zm17.7 8c-11.9-6.4-26.3 3-28.5 8.6 13.3 5.5 28.7-7.2 28.5-8.6zm16.3 9.2c-10.8-4.1-23.2 1.4-28.2 7.5 5.8 2.7 21 5.7 28.2-7.5zm14.9 4.7c-12.4-1.4-24.4 8-27 13.4 15.9 1.5 22-3.2 27-13.4z"
  })));
}, fP = function(e) {
  var n = e.title, r = v(e, Fx);
  return /* @__PURE__ */ i.createElement("svg", h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ i.createElement("title", null, n), /* @__PURE__ */ i.createElement("path", {
    fill: "#11457e",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#d7141a",
    d: "M513 171v171H0l256.5-171z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFF",
    d: "M513 0v171H256.5L0 0z"
  }));
}, pP = function(e) {
  var n = e.title, r = v(e, Px);
  return /* @__PURE__ */ i.createElement("svg", h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ i.createElement("title", null, n), /* @__PURE__ */ i.createElement("path", {
    fill: "#D80027",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    d: "M0 0h513v114H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFDA44",
    d: "M0 228h513v114H0z"
  }));
}, mP = function(e) {
  var n = e.title, r = v(e, Nx);
  return /* @__PURE__ */ i.createElement("svg", h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ i.createElement("title", null, n), /* @__PURE__ */ i.createElement("path", {
    fill: "#12ad2b",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#6ab2e7",
    d: "M513 0v166.7L0 170.8V0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFF",
    d: "M256 170.7 0 342V0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#d7141a",
    d: "m89.8 92.5 17 52.4H162l-44.6 32.5 17 52.4-44.6-32.4-44.6 32.4 17-52.4-44.6-32.5h55.2z"
  }));
}, hP = function(e) {
  var n = e.title, r = v(e, _x);
  return /* @__PURE__ */ i.createElement("svg", h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ i.createElement("title", null, n), /* @__PURE__ */ i.createElement("path", {
    fill: "#c60c30",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFF",
    d: "M190 0h-60v140H0v60h130v142h60V200h323v-60H190z"
  }));
}, vP = function(e) {
  var n = e.title, r = v(e, Tx);
  return /* @__PURE__ */ i.createElement("svg", h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ i.createElement("title", null, n), /* @__PURE__ */ i.createElement("path", {
    fill: "#496E2D",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    d: "M0 110.7v120h513v-120z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFDA44",
    d: "M0 110.7h513v40H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFF",
    d: "M0 190.7h513v40H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    d: "M196 0h120v342H196z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFDA44",
    d: "M196 0h40v342h-40z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFF",
    d: "M274.7 0h40v342h-40z"
  }), /* @__PURE__ */ i.createElement("circle", {
    fill: "#D80027",
    cx: 256,
    cy: 170.7,
    r: 123.1
  }), /* @__PURE__ */ i.createElement("path", {
    d: "m256 58.6 4.6 14.2h15l-12.1 8.9 4.6 14.2-12.1-8.8-12.1 8.8 4.6-14.2-12.1-8.9h15zM190.1 80l12.2 8.8 12.1-8.8-4.6 14.3 12.1 8.8h-15l-4.6 14.2-4.7-14.2h-15l12.1-8.8zm-40.7 56h15l4.6-14.2 4.7 14.2h15l-12.2 8.8 4.7 14.3-12.2-8.8-12.1 8.8 4.6-14.3zm0 69.3 12.1-8.8-4.6-14.3L169 191l12.2-8.8-4.7 14.3 12.2 8.8h-15l-4.7 14.3-4.6-14.3zm40.7 56.1 4.6-14.3-12.1-8.8h15l4.7-14.3 4.6 14.3h15l-12.1 8.8 4.6 14.3-12.1-8.9zm65.9 21.4-4.6-14.3h-15l12.1-8.8-4.6-14.3 12.1 8.8 12.1-8.8-4.6 14.3 12.1 8.8h-15zm65.9-21.4-12.2-8.9-12.1 8.9 4.6-14.3-12.1-8.8h15l4.6-14.3 4.7 14.3h15l-12.1 8.8zm40.7-56.1h-15l-4.6 14.3-4.7-14.3h-15l12.2-8.8-4.7-14.3L343 191l12.1-8.8-4.6 14.3zm0-69.3-12.1 8.8 4.6 14.3-12.1-8.8-12.2 8.8 4.7-14.3-12.2-8.8h15l4.7-14.2 4.6 14.2zm-40.7-56-4.6 14.3 12.1 8.8h-15l-4.7 14.2-4.6-14.2h-15l12.1-8.8-4.6-14.3 12.1 8.8zM279.3 168.7c-11-21.1-14.5-25.1-14.5-25.1s.4-9.7.4-15.6c0-8.8-7.4-15.8-16.5-15.8-8.6 0-15.7 2.9-16.5 11-4.2.9-8.6 4.1-8.6 10.7 0 4.8 1 7.3 5.2 9.3 2.1-4.6 4.3-4.8 9.3-6.4.8.6 1.7 3 2.6 3.4l.3 1s-13.3 6.6-13.3 30.9c0 29.5 22 45.4 22 45.4l-1.8.3-1.9 7.1h22v-7.2l11 17.5c.3-.3 10.2-47.6.3-66.5z",
    fill: "#496E2D"
  }));
}, gP = function(e) {
  var n = e.title, r = v(e, Ax);
  return /* @__PURE__ */ i.createElement("svg", h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ i.createElement("title", null, n), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFF",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#D80027",
    d: "M0 215.2h211.5v126.1H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#0052B4",
    d: "M0 0h211.5v126.2H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#D80027",
    d: "M300.5 0H512v126.2H300.5z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#0052B4",
    d: "M300.5 215.2H512v126.1H300.5z"
  }), /* @__PURE__ */ i.createElement("g", {
    stroke: "#FFF",
    strokeWidth: 5,
    strokeMiterlimit: 10
  }, /* @__PURE__ */ i.createElement("path", {
    fill: "#0052B4",
    d: "M256 130h-49.9v49.4s19.5 6 49.9 6V130z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#D80027",
    d: "M206.1 179.4v6c0 27.5 22.3 49.9 49.9 49.9v-49.9c-30.4 0-49.9-6-49.9-6z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#0052B4",
    d: "M256 235.3c27.5 0 49.9-22.3 49.9-49.9v-6s-19.5 6-49.9 6v49.9z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#D80027",
    d: "M256 130v55.4c30.4 0 49.9-6 49.9-6V130H256z"
  })));
}, yP = function(e) {
  var n = e.title, r = v(e, zx);
  return /* @__PURE__ */ i.createElement("svg", h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ i.createElement("title", null, n), /* @__PURE__ */ i.createElement("path", {
    fill: "#41662E",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFF",
    d: "M256.5 0H513v342H256.5z"
  }), /* @__PURE__ */ i.createElement("g", {
    fill: "#D80027"
  }, /* @__PURE__ */ i.createElement("path", {
    d: "m341.5 105.3-29.4 40.4-47.5-15.4 29.4 40.4-29.4 40.4 47.5-15.4 29.4 40.4v-50l47.5-15.5-47.5-15.4z"
  }), /* @__PURE__ */ i.createElement("path", {
    d: "M309.9 276.7c-58.5 0-106-47.5-106-106s47.5-106 106-106c18.3 0 35.4 4.6 50.4 12.7-23.5-23-55.7-37.2-91.2-37.2-72 0-130.4 58.4-130.4 130.4S197.1 301 269.1 301c35.5 0 67.7-14.2 91.2-37.2-14.9 8.2-32.1 12.9-50.4 12.9z"
  })));
}, bP = function(e) {
  var n = e.title, r = v(e, Dx);
  return /* @__PURE__ */ i.createElement("svg", h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ i.createElement("title", null, n), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFDA44",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#0052B4",
    d: "M0 170.7h513V256H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#D80027",
    d: "M0 256h513v85.3H0z"
  }), /* @__PURE__ */ i.createElement("circle", {
    fill: "#FFDA44",
    cx: 256,
    cy: 171,
    r: 60
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#4C1F00",
    d: "M369.2 79.9s-27.2-13.8-33.9-16c-6.7-2.2-49.1-13.2-49.1-7 0 10.3-13.5 12-15.5 12s-2-5.3-14.8-5.3-13.7 4.8-15.8 4.8c-2.2 0-14.5-1-14.5-11.5 0-5.2-42.9 4-49.1 7-6.1 3.1-33.9 16-33.9 16s45.8 2.7 53.9 6.2 43.8 16.5 43.8 16.5l-2.8 13.3h37.8l-3.8-13.3s35.1-12.7 43.8-16.5 53.9-6.2 53.9-6.2z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#57BA17",
    d: "M217.7 171.7c0 21.1 17.2 38.3 38.3 38.3 21.1 0 38.3-17.2 38.3-38.3v-11.5h-76.5v11.5z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#338AF3",
    d: "M256 110.5c-21.1 0-38.3 17.2-38.3 38.3v11.5h76.5v-11.5c.1-21.1-17.1-38.3-38.2-38.3z"
  }));
}, EP = function(e) {
  var n = e.title, r = v(e, Ix);
  return /* @__PURE__ */ i.createElement("svg", h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ i.createElement("title", null, n), /* @__PURE__ */ i.createElement("path", {
    fill: "#111",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#368FD8",
    d: "M0 0h513v114H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFF",
    d: "M0 228h513v114H0z"
  }));
}, wP = function(e) {
  var n = e.title, r = v(e, kx);
  return /* @__PURE__ */ i.createElement("svg", h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ i.createElement("title", null, n), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFF",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#D80027",
    d: "M0 0h513v114H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    d: "M0 228h513v114H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#C09300",
    d: "M220.3 204.4s0-58.4 4.5-64.7c3.1-4.3 16.8 5.2 22.7 4.5 0 0 4.2-7.5 4.5-12 .3-4.6-1.1-7.6-4.9-6.2 0 0-1.2-2.1.5-3.3 1.6-1.2 5.6.1 5.6.1s-.5-1 1.6-.9c2.9.2 7.2 1.4 7.4 5.6.2 3.1.3 7.7.4 8.7.7 6.8 2.7 8.7 2.7 8.7s18.4-9.2 22-5.2c3.3 3.8 4.5 64.7 4.5 64.7l-18.1-16.8 12.1 29.5s-14.4 2.4-28.9 2.4c-14.5 0-31.1-4.2-31.1-4.2l13.8-28.2-19.3 17.3z"
  }));
}, $P = function(e) {
  var n = e.title, r = v(e, Ox);
  return /* @__PURE__ */ i.createElement("svg", h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ i.createElement("title", null, n), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFF",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    d: "M0 0h513v114H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#428823",
    d: "M0 228h513v114H0z"
  }), /* @__PURE__ */ i.createElement("g", {
    fill: "#D80027"
  }, /* @__PURE__ */ i.createElement("path", {
    d: "M256 171 0 342V0zm53.1 0c0-22.9 13.1-42.1 34.6-46.8-3.3-.7-6.7-1.1-10.3-1.1-26.4 0-47.9 21.4-47.9 47.9s21.4 47.9 47.9 47.9c3.5 0 7-.4 10.3-1.1-21.5-5.1-34.6-24.2-34.6-46.8z"
  }), /* @__PURE__ */ i.createElement("path", {
    d: "m365 129.2 10.3 31.7h33.3l-27 19.6 10.3 31.7-26.9-19.6-27 19.6 10.3-31.7-27-19.6h33.4z"
  })));
}, xP = function(e) {
  var n = e.title, r = v(e, Lx);
  return /* @__PURE__ */ i.createElement("svg", h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ i.createElement("title", null, n), /* @__PURE__ */ i.createElement("path", {
    fill: "#338AF3",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#56AF35",
    d: "M0 0h513v171H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#D80027",
    d: "m0 342 513-171L0 0v342z"
  }), /* @__PURE__ */ i.createElement("g", {
    fill: "#ffc945"
  }, /* @__PURE__ */ i.createElement("path", {
    d: "M134.7 231.5c33.6 0 60.8-27.2 60.8-60.8s-27.2-60.8-60.8-60.8-60.8 27.2-60.8 60.8 27.2 60.8 60.8 60.8zm0 24.3c-47 0-85.2-38.1-85.2-85.2s38.1-85.2 85.2-85.2 85.2 38.1 85.2 85.2-38.2 85.2-85.2 85.2z"
  }), /* @__PURE__ */ i.createElement("circle", {
    cx: 119.5,
    cy: 148.3,
    r: 17.5
  }), /* @__PURE__ */ i.createElement("circle", {
    cx: 148.9,
    cy: 158.5,
    r: 17.5
  }), /* @__PURE__ */ i.createElement("circle", {
    cx: 134.7,
    cy: 135.2,
    r: 17.5
  }), /* @__PURE__ */ i.createElement("circle", {
    cx: 119.5,
    cy: 172.7,
    r: 17.5
  }), /* @__PURE__ */ i.createElement("circle", {
    cx: 149.9,
    cy: 182.8,
    r: 17.5
  }), /* @__PURE__ */ i.createElement("circle", {
    cx: 122.5,
    cy: 198,
    r: 17.5
  }), /* @__PURE__ */ i.createElement("circle", {
    cx: 145.9,
    cy: 205.2,
    r: 17.5
  })));
}, CP = function(e) {
  var n = e.title, r = v(e, Rx);
  return /* @__PURE__ */ i.createElement("svg", h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22.5 15"
  }, r), n && /* @__PURE__ */ i.createElement("title", null, n), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFF",
    d: "M0 0h22.5v15H0V0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#D03433",
    d: "M0 0h22.5v4H0V0zm0 11h22.5v4H0v-4z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#FBCA46",
    d: "M0 4h22.5v7H0V4z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFF",
    d: "M7.8 7h1v.5h-1V7z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#A41517",
    d: "M7.2 8.5c0 .3.3.5.6.5s.6-.2.6-.5L8.5 7H7.1l.1 1.5zM6.6 7c0-.3.2-.5.4-.5h1.5c.3 0 .5.2.5.4V7l-.1 1.5c-.1.6-.5 1-1.1 1-.6 0-1-.4-1.1-1L6.6 7z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#A41517",
    d: "M6.8 7.5h2V8h-.5l-.5 1-.5-1h-.5v-.5zM5.3 6h1v3.5h-1V6zm4 0h1v3.5h-1V6zm-2.5-.5c0-.3.2-.5.5-.5h1c.3 0 .5.2.5.5v.2c0 .2-.1.3-.3.3H7c-.1 0-.2-.1-.2-.2v-.3z"
  }));
}, MP = function(e) {
  var n = e.title, r = v(e, Hx);
  return /* @__PURE__ */ i.createElement("svg", h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22.5 15"
  }, r), n && /* @__PURE__ */ i.createElement("title", null, n), /* @__PURE__ */ i.createElement("path", {
    fill: "#20AA46",
    d: "M0 0h22.5v5H0V0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#E92F3B",
    d: "M0 10h22.5v5H0v-5z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#FADF50",
    d: "M0 5h22.5v5H0V5z"
  }), /* @__PURE__ */ i.createElement("circle", {
    fill: "#205CCA",
    cx: 11.3,
    cy: 7.5,
    r: 5.2
  }), /* @__PURE__ */ i.createElement("g", {
    stroke: "#FFDB3D",
    fill: "none"
  }, /* @__PURE__ */ i.createElement("path", {
    d: "m11.3 8.8-2.1 1.5.8-2.4-2-1.5h2.5l.8-2.3.8 2.3h2.6l-2.1 1.5.8 2.4-2.1-1.5zm-1-2.4h1.9M9.9 7.8l1.3 1m.8-2.6.7 1.8M10 7.9l.6-1.8M11 9l1.6-1.1",
    strokeWidth: 0.5
  }), /* @__PURE__ */ i.createElement("path", {
    d: "m8.7 3.9 1.1 1.6m4-1.7-1 1.6m-1.5 4.7V12M8.9 8.3 7.1 9m8.4 0-1.8-.7",
    strokeWidth: 0.25
  })));
}, SP = function(e) {
  var n = e.title, r = v(e, Bx);
  return /* @__PURE__ */ i.createElement("svg", h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 810 540"
  }, r), n && /* @__PURE__ */ i.createElement("title", null, n), /* @__PURE__ */ i.createElement("path", {
    fill: "#039",
    d: "M0 0h810v540H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#FC0",
    d: "m404.951 59.865 6.735 20.718h21.894l-17.633 12.812 6.638 20.74-17.634-12.812-17.634 12.812 6.736-20.729-17.633-12.812h21.796zm-90 24 6.735 20.718h21.894l-17.633 12.812 6.638 20.74-17.634-12.812-17.634 12.812 6.736-20.729-17.633-12.812h21.796zm-66 66 6.735 20.718h21.894l-17.633 12.812 6.638 20.74-17.634-12.812-17.634 12.812 6.736-20.729-17.633-12.812h21.796zm-24 89.999 6.735 20.719h21.894l-17.633 12.813 6.638 20.74-17.634-12.813-17.634 12.813 6.736-20.731-17.633-12.811h21.796zm24 90.001 6.735 20.719h21.894l-17.633 12.811 6.638 20.74-17.634-12.811-17.634 12.811 6.736-20.729-17.633-12.812h21.796zm66 66 6.735 20.719h21.894l-17.633 12.811 6.638 20.74-17.634-12.811-17.634 12.811 6.736-20.729-17.633-12.812h21.796zm180-312 6.735 20.718h21.894l-17.633 12.812 6.637 20.74-17.633-12.812-17.635 12.812 6.737-20.729-17.633-12.812h21.795zm66 66 6.735 20.718h21.894l-17.633 12.812 6.637 20.74-17.633-12.812-17.635 12.812 6.737-20.729-17.633-12.812h21.795zm24 90 6.735 20.718h21.894l-17.633 12.813 6.638 20.74-17.634-12.813-17.634 12.813 6.736-20.731-17.633-12.811h21.796zm-24 90 6.735 20.719h21.894l-17.633 12.811 6.638 20.74-17.634-12.811-17.634 12.811 6.736-20.729-17.633-12.812h21.796zm-156 90 6.735 20.719h21.894l-17.633 12.811 6.638 20.74-17.634-12.811-17.634 12.811 6.736-20.729-17.633-12.812h21.796zm90-24.001 6.735 20.719h21.894l-17.633 12.812 6.639 20.74-17.635-12.812-17.633 12.812 6.735-20.73-17.633-12.811h21.797z"
  }));
}, FP = function(e) {
  var n = e.title, r = v(e, jx);
  return /* @__PURE__ */ i.createElement("svg", h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ i.createElement("title", null, n), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFF",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#2E52B2",
    d: "M513 129.3V212H203.7v130H121V212H0v-82.7h121V0h82.7v129.3z"
  }));
}, PP = function(e) {
  var n = e.title, r = v(e, Vx);
  return /* @__PURE__ */ i.createElement("svg", h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ i.createElement("title", null, n), /* @__PURE__ */ i.createElement("path", {
    fill: "#62B5E5",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#F3F3F3",
    d: "M307.1 127.1v92c0 61.6 80.5 80.5 80.5 80.5s80.4-19 80.4-80.6v-92l-80.5-23-80.4 23.1z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#D80027",
    d: "M468 132.8V98.3H307.1v34.5h69v69h-69v23h69V296c6.9 2.5 11.5 3.5 11.5 3.5s4.6-1.1 11.5-3.5v-71.2h69v-23h-69v-69H468z"
  }), /* @__PURE__ */ i.createElement("g", {
    fill: "#FFF"
  }, /* @__PURE__ */ i.createElement("path", {
    d: "M0 0h256.5v170.6H0V0z"
  }), /* @__PURE__ */ i.createElement("path", {
    d: "m155.9 115 100.6 55.6v-15.8L184.6 115h-28.7zm-55.7-59.3L0 0v15.8l71.8 39.9h28.4z"
  })), /* @__PURE__ */ i.createElement("path", {
    d: "m196.9 115 59.6 32.9V115h-59.6zm-41 0 100.6 55.6v-15.8L184.6 115h-28.7zm73.4 55.6-73.5-40.9v40.9h73.5zM45.2 115 0 140.1V115h45.2zm55 7.1v48.6H12.8l87.4-48.6zM59.1 55.7 0 22.8v32.8s59.1 0 59.1.1zm41.1 0L0 0v15.8l71.8 39.9h28.4zM26.7 0l73.5 40.8V0H26.7zm184.2 55.7 45.6-25.1v25.1h-45.6zm-55-7.2V0h87.4l-87.4 48.5z",
    fill: "#0052B4"
  }), /* @__PURE__ */ i.createElement("g", {
    fill: "#D80027"
  }, /* @__PURE__ */ i.createElement("path", {
    d: "M144.3-.2h-32.1v69.5H0v32.1h112.2v69.5h32.1v-69.5h112.2V69.3H144.3V-.2z"
  }), /* @__PURE__ */ i.createElement("path", {
    d: "m155.9 115 100.6 55.6v-15.8L184.6 115h-28.7zm-84.1 0L0 154.9v15.8L100.2 115H71.8zm28.4-59.3L0 0v15.8l71.8 39.9h28.4zm83.9 0 72.4-39.9V0L155.9 55.7h28.2z"
  })));
}, NP = function(e) {
  var n = e.title, r = v(e, Ux);
  return /* @__PURE__ */ i.createElement("svg", h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ i.createElement("title", null, n), /* @__PURE__ */ i.createElement("path", {
    fill: "#0052B4",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFF",
    d: "M256 0v30.6l-45.2 25.1H256V115h-59.1l59.1 32.8v22.9h-26.7l-73.5-40.9v40.9h-55.6v-48.6l-87.5 48.6H0v-30.6L45.2 115H0V55.7h59.1L0 22.8V0h26.7l73.5 40.8V0h55.6v48.6L243.3 0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#D80027",
    d: "M144 0h-32v69.3H0v32h112v69.4h32v-69.4h112v-32H144z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#0052B4",
    d: "M155.8 115 256 170.7v-15.8L184.2 115z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFF",
    d: "M155.8 115 256 170.7v-15.8L184.2 115z"
  }), /* @__PURE__ */ i.createElement("path", {
    d: "M155.8 115 256 170.7v-15.8L184.2 115zm-84 0L0 154.9v15.8L100.2 115z",
    fill: "#D80027"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#0052B4",
    d: "M100.2 55.6 0 0v15.7l71.8 39.9z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFF",
    d: "M100.2 55.6 0 0v15.7l71.8 39.9z"
  }), /* @__PURE__ */ i.createElement("path", {
    d: "M100.2 55.6 0 0v15.7l71.8 39.9zm84 0L256 15.7V0L155.8 55.6z",
    fill: "#D80027"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#1F8BDE",
    d: "M312.2 194.2v-90c0-8.5 6.5-15.3 15-15.3h120.5c8.3 0 15 6.8 15 15.3v90c0 75.2-75.2 105.3-75.2 105.3s-75.3-30.1-75.3-105.3z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFF",
    d: "M312.2 194.2v-90c0-8.5 6.5-15.3 15-15.3h120.5c8.3 0 15 6.8 15 15.3v90c0 75.2-75.2 105.3-75.2 105.3s-75.3-30.1-75.3-105.3zm79.6 86.3c7.9-4.5 15.9-10 23.2-16.7 20.5-18.5 32.6-41.4 32.6-69.7v-90c0-.3-120.4-.3-120.4-.3v90.3c0 28.3 12.1 51.2 32.6 69.7 8.3 7.5 17.6 13.9 27.6 19 1.4-.6 2.8-1.4 4.4-2.3z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#187536",
    d: "M347.1 193.4c-2.6-7.9 1.7-14.3 10.1-14.3h60.5c8.2 0 12.8 6.3 10.1 14.3l-5.5 16.5c-2.6 7.9-8.9 9.2-15.8 4 0 0 2.6-4.8-19.1-4.8-21.7 0-19.1 4.8-19.1 4.8-6.1 5.7-13.1 4-15.8-4 .1.1-5.4-16.5-5.4-16.5z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFF",
    d: "M357.4 179.1c8.1 1.6 17.8-15 30.1-15 13.1 0 21.8 17.1 30.1 15 7.4-1.8 15-22.2 15-30.1 0-16.6-20.2-30.1-45.1-30.1-24.9 0-45.1 13.5-45.1 30.1-.1 8.5 6.6 28.5 15 30.1zm-1.4 91.6c6.2.4 12.5-1.8 17.2-6.5l9-9c2.9-2.9 7.5-2.9 10.4 0l9 9c4.7 4.7 11 6.9 17.1 6.5 5.3-.3 32.5-33.5 25.7-32.6-4.6.6-9.1 2.8-12.7 6.3l-.1.1-9 9c-2.9 2.9-7.5 2.9-10.4 0l-9-9c-8.7-8.8-22.9-8.8-31.7-.1l-.1.1-9 9c-2.9 2.9-7.5 2.9-10.4 0l-9-9c-3.5-3.5-7.8-5.6-12.3-6.3-6.7-1.1 20.1 32.2 25.3 32.5zM322.1 210c2.9-2.9 7.5-2.9 10.4 0l9 9c8.8 8.7 22.9 8.7 31.7 0l9-9c2.9-2.9 7.5-2.9 10.4 0l9 9c8.8 8.7 22.9 8.7 31.7 0l9-9c2.9-2.9 7.5-2.9 10.4 0 0 0 5.5-14.8 2.5-15.9-7.9-2.9-17.2-1.2-23.5 5.2l-.1.1-9 9c-2.9 2.9-7.5 2.9-10.4 0l-9-9c-8.7-8.8-22.9-8.8-31.7-.1l-.1.1-9 9c-2.9 2.9-7.5 2.9-10.4 0l-9-9c-6.2-6.2-15.1-8-22.8-5.5-3.1 1.1 1.9 16.1 1.9 16.1z"
  }));
}, _P = function(e) {
  var n = e.title, r = v(e, Wx);
  return /* @__PURE__ */ i.createElement("svg", h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ i.createElement("title", null, n), /* @__PURE__ */ i.createElement("path", {
    fill: "#338AF3",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    d: "m256 37.9 10.1 31.2H299l-26.6 19.3 10.2 31.2-26.6-19.3-26.6 19.3 10.2-31.2L213 69.1h32.9zM123.2 170.7l31.2-10.2v-32.8l19.3 26.6 31.2-10.2-19.3 26.6 19.3 26.5-31.2-10.1-19.3 26.5v-32.8zM256 303.5l-10.1-31.2H213l26.6-19.3-10.2-31.3L256 241l26.6-19.3-10.2 31.3 26.6 19.3h-32.9zm132.8-132.8-31.2 10.1v32.8l-19.3-26.5-31.2 10.1 19.3-26.5-19.3-26.6 31.2 10.2 19.3-26.6v32.8z",
    fill: "#FFF"
  }));
}, TP = function(e) {
  var n = e.title, r = v(e, Gx);
  return /* @__PURE__ */ i.createElement("svg", h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ i.createElement("title", null, n), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFF",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#0F61A5",
    d: "M513 214.5H206.2V342h-87.8V214.5H0v-87.7h118.4V0h87.8v126.8H513V192z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#E50E3D",
    d: "M513 149.3V192H183.7v150H141V192H0v-42.7h141V0h42.7v149.3z"
  }));
}, AP = function(e) {
  var n = e.title, r = v(e, Kx);
  return /* @__PURE__ */ i.createElement("svg", h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ i.createElement("title", null, n), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFF",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#00318A",
    d: "M0 0h171v342H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#D80027",
    d: "M342 0h171v342H342z"
  }));
}, zP = function(e) {
  var n = e.title, r = v(e, qx);
  return /* @__PURE__ */ i.createElement("svg", h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ i.createElement("title", null, n), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFDA44",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#6DA544",
    d: "M0 0h513v114H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#0052B4",
    d: "M0 228h513v114H0z"
  }));
}, DP = function(e) {
  var n = e.title, r = v(e, Yx);
  return /* @__PURE__ */ i.createElement("svg", h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ i.createElement("title", null, n), /* @__PURE__ */ i.createElement("g", {
    fill: "#FFF"
  }, /* @__PURE__ */ i.createElement("path", {
    d: "M0 0h513v341.3H0V0z"
  }), /* @__PURE__ */ i.createElement("path", {
    d: "M311.7 230 513 341.3v-31.5L369.3 230h-57.6zM200.3 111.3 0 0v31.5l143.7 79.8h56.6z"
  })), /* @__PURE__ */ i.createElement("path", {
    d: "M393.8 230 513 295.7V230H393.8zm-82.1 0L513 341.3v-31.5L369.3 230h-57.6zm146.9 111.3-147-81.7v81.7h147zM90.3 230 0 280.2V230h90.3zm110 14.2v97.2H25.5l174.8-97.2zm-82.1-132.9L0 45.6v65.7h118.2zm82.1 0L0 0v31.5l143.7 79.8h56.6zM53.4 0l147 81.7V0h-147zm368.3 111.3L513 61.1v50.2h-91.3zm-110-14.2V0h174.9L311.7 97.1z",
    fill: "#0052B4"
  }), /* @__PURE__ */ i.createElement("g", {
    fill: "#D80027"
  }, /* @__PURE__ */ i.createElement("path", {
    d: "M288 0h-64v138.7H0v64h224v138.7h64V202.7h224v-64H288V0z"
  }), /* @__PURE__ */ i.createElement("path", {
    d: "M311.7 230 513 341.3v-31.5L369.3 230h-57.6zm-168 0L0 309.9v31.5L200.3 230h-56.6zm56.6-118.7L0 0v31.5l143.7 79.8h56.6zm168 0L513 31.5V0L311.7 111.3h56.6z"
  })));
}, IP = function(e) {
  var n = e.title, r = v(e, Zx);
  return /* @__PURE__ */ i.createElement("svg", h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ i.createElement("title", null, n), /* @__PURE__ */ i.createElement("path", {
    fill: "#c60a0a",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#3E8446",
    d: "m256.5 170.7-212 126.1V44.5z"
  }), /* @__PURE__ */ i.createElement("path", {
    d: "m256.5 170.7 211 126.1h-423zm211-126.2-211 126.2-212-126.2z",
    fill: "#FFDA44"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#3E8446",
    d: "M467.5 44.5v252.3l-211-126.1z"
  }), /* @__PURE__ */ i.createElement("path", {
    d: "m256.5 10.4 2.8 10.2H270l-8.6 6.3 3.3 10.2-8.2-6.3-9.2 6.3 3.3-10.2-8.6-6.3h10.7zm-86.4 0 3.3 10.2h10.7l-8.6 6.3 3.3 10.2-8.7-6.3-8.7 6.3 3.3-10.2-8.6-6.3h10.7zm171.8 0 3.3 10.2H356l-8.7 6.3 3.3 10.2-8.7-6.3-8.7 6.3 3.3-10.2-8.6-6.3h10.7zm-85.4 293.8 2.8 10.2H270l-8.6 6.3 3.3 10.2-8.2-6.3-9.2 6.3 3.3-10.2-8.6-6.3h10.7zm-86.4 0 3.3 10.2h10.7l-8.6 6.3 3.3 10.2-8.7-6.3-8.7 6.3 3.3-10.2-8.6-6.3h10.7zm171.8 0 3.3 10.2H356l-8.7 6.3 3.3 10.2-8.7-6.3-8.7 6.3 3.3-10.2-8.6-6.3h10.7z",
    fill: "#FFDA44"
  }), /* @__PURE__ */ i.createElement("circle", {
    fill: "#c60a0a",
    cx: 244.5,
    cy: 170.7,
    r: 76.2
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFDA44",
    d: "m244.5 110.1 13.6 41.8h44l-35.6 25.8 13.6 41.8-35.6-25.8-35.5 25.8 13.6-41.8-35.6-25.8h44zm-136.8 57.7c4.4 6.9 2.3 16.1-4.6 20.5s-16.1 2.3-20.5-4.6c-7.9-12.5-3.3-33-3.3-33s20.4 4.6 28.4 17.1z"
  }), /* @__PURE__ */ i.createElement("circle", {
    fill: "#A2001D",
    cx: 99.1,
    cy: 182.1,
    r: 7.4
  }));
}, kP = function(e) {
  var n = e.title, r = v(e, Xx);
  return /* @__PURE__ */ i.createElement("svg", h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22.5 15"
  }, r), n && /* @__PURE__ */ i.createElement("title", null, n), /* @__PURE__ */ i.createElement("path", {
    fill: "#fff",
    d: "M0 0h22.5v15H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#eb000e",
    d: "M9.8 6H0v3h9.8v6h3V9h9.8V6h-9.8V0h-3v6z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#eb000e",
    d: "m17.3 2.7-.2-1.2h1l-.2 1.2 1.2-.2v1l-1.2-.2.2 1.2h-1l.2-1.2-1.2.2v-1l1.2.2zm-12.7 0-.2-1.2h1l-.2 1.2 1.2-.2v1l-1.2-.2.2 1.2h-1l.2-1.2-1.2.2v-1l1.2.2zm0 9-.2-1.2h1l-.2 1.2 1.2-.2v1l-1.2-.2.2 1.2h-1l.2-1.2-1.2.2v-1l1.2.2zm12.7 0-.2-1.2h1l-.2 1.2 1.2-.2v1l-1.2-.2.2 1.2h-1l.2-1.2-1.2.2v-1l1.2.2z"
  }));
}, OP = function(e) {
  var n = e.title, r = v(e, Jx);
  return /* @__PURE__ */ i.createElement("svg", h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 90 60"
  }, r), n && /* @__PURE__ */ i.createElement("title", null, n), /* @__PURE__ */ i.createElement("path", {
    fill: "#FDEB01",
    d: "m0 0 90 60H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#58A846",
    d: "M90 0v60L0 0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#ED3D24",
    d: "m50.7 33.3 9.3-6.7H48.5L45 15.7l-3.5 10.9H30l9.3 6.7-3.6 11 9.3-6.7 9.3 6.7z"
  }));
}, LP = function(e) {
  var n = e.title, r = v(e, Qx);
  return /* @__PURE__ */ i.createElement("svg", h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ i.createElement("title", null, n), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFF",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#D80027",
    d: "M308 0H204v118.7H0v104h204V342h104V222.7h205v-104H308z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFDA44",
    d: "m368.6 188 26 17.3V136l-26 17.3h-95.3V58.1l17.3-26h-69.2l17.3 26v95.2h-95.3l-26-17.3v69.3l26-17.3h95.3v95.2l-17.3 26h69.2l-17.3-26V188z"
  }));
}, RP = function(e) {
  var n = e.title, r = v(e, eC);
  return /* @__PURE__ */ i.createElement("svg", h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ i.createElement("title", null, n), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFDA44",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#D80027",
    d: "M0 0h513v114H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#496E2D",
    d: "M0 228h513v114H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    d: "m255.9 113.8 14.1 43.4 40.4 3.2-37 26.9 19.5 40.3-37-26.9-37 26.9 14.1-43.5-36.9-26.9h45.7z"
  }));
}, HP = function(e) {
  var n = e.title, r = v(e, tC);
  return /* @__PURE__ */ i.createElement("svg", h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ i.createElement("title", null, n), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFF",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#D80027",
    d: "M0 230h513v112H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#D80027",
    stroke: "#000",
    strokeMiterlimit: 10,
    d: "M363.1 131.8V99.1H374V77.3h-21.9v10.9h-21.8V77.3h-21.8v21.8h10.9v32.7h-21.8V55.5h10.9V33.7h-21.8v10.9h-10.9V33.7H254v10.9h-10.9V33.7h-21.8v21.8h10.9v76.3h-21.8V99.1h10.9V77.3h-21.8v10.9h-21.8V77.3h-21.8v21.8h10.9v32.7H145V219h239.9v-87.2z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFDA44",
    stroke: "#000",
    strokeMiterlimit: 10,
    d: "m264.9 235.5-24.2 18.2 19.1 14.3v31.3h-23.2v9h23v7.9h-23v9.3H270V268l19.1-14.3-24.2-18.2zm0 25.3-10.1-7.1 10.1-7.1 10.1 7.1-10.1 7.1z"
  }), /* @__PURE__ */ i.createElement("path", {
    d: "M239.6 209.7v-27.9s.1-22.3 25-22.3c24.8 0 25.7 22 25.7 22v28.2h-50.7zm-69.1 0v-24.3s.1-18.7 19.6-18.7 20.2 18.4 20.2 18.4v24.5h-39.8z"
  }), /* @__PURE__ */ i.createElement("path", {
    d: "M169.1 209.7v-24.3s.1-18.7 19.6-18.7 20.2 18.4 20.2 18.4v24.5h-39.8zm151.8 0v-24.3s.1-18.7 19.6-18.7 20.2 18.4 20.2 18.4v24.5h-39.8zm8.4-77.7v-15.7s.1-12.1 11.3-12.1c11.3 0 11.7 11.9 11.7 11.9V132h-23zm-78.8 0v-23.7s.1-18.3 14.3-18.3c14.2 0 14.7 18 14.7 18v24h-29zm-73 0v-15.7s.1-12.1 11.3-12.1 11.7 11.9 11.7 11.9V132h-23z"
  }));
}, BP = function(e) {
  var n = e.title, r = v(e, nC);
  return /* @__PURE__ */ i.createElement("svg", h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ i.createElement("title", null, n), /* @__PURE__ */ i.createElement("path", {
    fill: "#D80027",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFF",
    d: "M513 0v171H0V0z"
  }), /* @__PURE__ */ i.createElement("circle", {
    fill: "#FFF",
    cx: 185.8,
    cy: 171.2,
    r: 117.8
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#D80027",
    d: "M68 171c0-65.1 52.8-117.8 117.8-117.8 65.1 0 117.8 52.8 117.8 117.8"
  }));
}, jP = function(e) {
  var n = e.title, r = v(e, rC);
  return /* @__PURE__ */ i.createElement("svg", h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ i.createElement("title", null, n), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFF",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#cf0d19",
    d: "M0 0h513v100H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#0052B4",
    d: "M0 121h513v100H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#1a7e25",
    d: "M0 242h513v100H0z"
  }));
}, VP = function(e) {
  var n = e.title, r = v(e, aC);
  return /* @__PURE__ */ i.createElement("svg", h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ i.createElement("title", null, n), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFDA44",
    d: "M0 0h512v342H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#6DA544",
    d: "M342 0h171v342H342z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#D80027",
    d: "M0 0h171v342H0z"
  }));
}, UP = function(e) {
  var n = e.title, r = v(e, iC);
  return /* @__PURE__ */ i.createElement("svg", h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ i.createElement("title", null, n), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFF",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#00318A",
    d: "M0 0h171v342H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#D80027",
    d: "M342 0h171v342H342z"
  }));
}, WP = function(e) {
  var n = e.title, r = v(e, oC);
  return /* @__PURE__ */ i.createElement("svg", h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ i.createElement("title", null, n), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFF",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#6DA544",
    d: "M0 0h513v113.8H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#D80027",
    d: "M0 227.6h513V342H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#0070C8",
    d: "M126 171 0 342V0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    d: "M233.8 139.4v40.4c0 35.6 35.6 35.6 35.6 35.6s35.6 0 35.6-35.6v-40.4h-71.2z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#786145",
    d: "M264.5 179.8h9.8l4 25.8h-17.8z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#6DA544",
    d: "M287.2 162c0-9.8-8-14.8-17.8-14.8s-17.8 5-17.8 14.8c-4.9 0-8.9 4-8.9 8.9s4 8.9 8.9 8.9h35.6c4.9 0 8.9-4 8.9-8.9s-4-8.9-8.9-8.9z"
  }), /* @__PURE__ */ i.createElement("path", {
    d: "m230.7 120 1.9 3.3h3.8l-1.9 3.3 1.9 3.2h-3.8l-1.9 3.3-1.9-3.3H225l1.9-3.2-1.9-3.3h3.8zm15.3 0 1.9 3.3h3.7l-1.9 3.3 1.9 3.2h-3.7l-1.9 3.3-1.9-3.3h-3.8l1.9-3.2-1.9-3.3h3.8zm15.3 0 1.9 3.3h3.7l-1.9 3.3 1.9 3.2h-3.7l-1.9 3.3-1.9-3.3h-3.8l1.9-3.2-1.9-3.3h3.8zm15.8 0 1.9 3.3h3.8l-1.9 3.3 1.9 3.2H279l-1.9 3.3-1.9-3.3h-3.7l1.8-3.2-1.8-3.3h3.7zm16 0 1.9 3.3h3.8l-1.9 3.3 1.9 3.2H295l-1.9 3.3-1.9-3.3h-3.7l1.8-3.2-1.8-3.3h3.7zm15 0 1.9 3.3h3.7l-1.9 3.3 1.9 3.2H310l-1.9 3.3-1.9-3.3h-3.8l1.9-3.2-1.9-3.3h3.8z",
    fill: "#FFDA00",
    stroke: "#000",
    strokeMiterlimit: 10
  }));
}, GP = function(e) {
  var n = e.title, r = v(e, lC);
  return /* @__PURE__ */ i.createElement("svg", h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ i.createElement("title", null, n), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFF",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ i.createElement("g", {
    fill: "#0d5eaf"
  }, /* @__PURE__ */ i.createElement("path", {
    d: "M0 0h513v38H0zm0 76h513v38H0zm0 76h513v38H0zm0 76h513v38H0zm0 76h513v38H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    d: "M0 0h190v190H0z"
  })), /* @__PURE__ */ i.createElement("g", {
    fill: "#FFF"
  }, /* @__PURE__ */ i.createElement("path", {
    d: "M0 76h190v38H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    d: "M76 0h38v190H76z"
  })));
}, KP = function(e) {
  var n = e.title, r = v(e, sC);
  return /* @__PURE__ */ i.createElement("svg", h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ i.createElement("title", null, n), /* @__PURE__ */ i.createElement("path", {
    fill: "#0052B4",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFF",
    d: "M256 0v117.4h-46.1l46.1 30.7v22.6h-22.6L160 121.8v48.9H96v-48.9l-73.4 48.9H0v-22.6l46.1-30.7H0v-64h46.1L0 22.7V0h22.6L96 48.9V0h64v48.9L233.4 0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#D80027",
    d: "M144 0h-32v69.4H0v32h112v69.3h32v-69.3h112v-32H144z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#2E52B2",
    d: "M256 22.7v30.7h-46.1z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#D80027",
    d: "M0 170.7v-11l62.5-42.3h22.6L7.3 170.7zM7.3.1l77.8 53.2H62.5L0 11.1V.1zM256 .1v11l-62.5 42.3h-22.6L248.7.1zm-7.3 170.6-77.8-53.3h22.6l62.5 42.3v11z"
  }), /* @__PURE__ */ i.createElement("ellipse", {
    fill: "#FFF",
    cx: 443.4,
    cy: 233.6,
    rx: 29,
    ry: 43.5
  }), /* @__PURE__ */ i.createElement("ellipse", {
    fill: "#FFCE00",
    cx: 406.9,
    cy: 317.7,
    rx: 22,
    ry: 9.3
  }), /* @__PURE__ */ i.createElement("ellipse", {
    fill: "#FFCE00",
    cx: 364,
    cy: 317.7,
    rx: 22,
    ry: 9.3
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#39B200",
    d: "m342 190.1 43.4 86.9 43.5-86.9z"
  }), /* @__PURE__ */ i.createElement("ellipse", {
    fill: "#9B9B9B",
    cx: 327.5,
    cy: 233.6,
    rx: 29,
    ry: 43.5
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#757575",
    d: "m371 175.6-14.5 14.5h57.9l-14.5-14.5 14.5-43.5s-13-29-29-29-29 29-29 29l14.6 43.5z"
  }), /* @__PURE__ */ i.createElement("circle", {
    fill: "#C6B56F",
    cx: 385.4,
    cy: 67,
    r: 29
  }), /* @__PURE__ */ i.createElement("circle", {
    fill: "#A54A00",
    cx: 386,
    cy: 88.7,
    r: 29
  }), /* @__PURE__ */ i.createElement("circle", {
    fill: "#FFF",
    cx: 443.4,
    cy: 117.7,
    r: 29
  }), /* @__PURE__ */ i.createElement("circle", {
    fill: "#0049FF",
    cx: 342.2,
    cy: 146.7,
    r: 29
  }), /* @__PURE__ */ i.createElement("circle", {
    fill: "#0041F9",
    cx: 429.8,
    cy: 146.7,
    r: 29
  }), /* @__PURE__ */ i.createElement("circle", {
    fill: "#F7D71E",
    cx: 386,
    cy: 233.6,
    r: 29
  }), /* @__PURE__ */ i.createElement("circle", {
    fill: "#CEC851",
    cx: 457.9,
    cy: 190.1,
    r: 29
  }), /* @__PURE__ */ i.createElement("circle", {
    fill: "#FFF",
    cx: 385.4,
    cy: 289.5,
    r: 29
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#7C0B29",
    d: "m371 135.7 14.5-3.5 14.5 3.5c0 7.5-14.5 11-14.5 11s-14.5-3.5-14.5-11z"
  }), /* @__PURE__ */ i.createElement("circle", {
    fill: "#FFF",
    cx: 327.5,
    cy: 117.4,
    r: 29
  }));
}, qP = function(e) {
  var n = e.title, r = v(e, cC);
  return /* @__PURE__ */ i.createElement("svg", h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ i.createElement("title", null, n), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFF",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    d: "M0 0h171v342H0zm342 0h171v342H342z",
    fill: "#338AF3"
  }), /* @__PURE__ */ i.createElement("circle", {
    fill: "#DCC26D",
    cx: 256,
    cy: 155.8,
    r: 25.5
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#628A40",
    d: "M194.2 155.9c0 22.1 11.8 42.5 30.8 53.5 5.9 3.4 13.5 1.4 16.9-4.5 3.4-5.9 1.4-13.5-4.5-16.9-11.5-6.6-18.5-18.9-18.5-32.1 0-6.8-5.5-12.4-12.4-12.4s-12.3 5.5-12.3 12.4zm95.1 52.1c17.8-11.4 28.6-31 28.5-52.1 0-6.8-5.5-12.4-12.4-12.4-6.8 0-12.4 5.5-12.4 12.4 0 12.7-6.5 24.5-17.1 31.3-5.8 3.6-7.7 11.2-4.1 17 3.6 5.8 11.2 7.7 17 4.1.2-.1.3-.2.5-.3z"
  }));
}, YP = function(e) {
  var n = e.title, r = v(e, dC);
  return /* @__PURE__ */ i.createElement("svg", h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ i.createElement("title", null, n), /* @__PURE__ */ i.createElement("path", {
    fill: "#D80027",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#0052B4",
    d: "M11.1 11.1h489.7v319.1H11.1z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#7DBEF1",
    d: "M256 285.3s76.4-51.3 76.4-114.6S256 56 256 56s-76.4 51.3-76.4 114.6S256 285.3 256 285.3z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#1C8AE6",
    d: "M179.8 180.7h152.6l-29.3 64.9h-95.2z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFF042",
    d: "M192.3 205.9s40.5 38.2 51 38.2c12.4 0 12.6-18.4 25.5-25.5 20.2-11.1 51-12.7 51-12.7L297 248.7l-41 36.6-46.8-39.7-16.9-39.7z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#259C7B",
    d: "m256 157.5-22.5 15.6 7.9-26.2-21.8-16.5 27.4-.5 9-25.9 9 25.9 27.4.5-21.8 16.6 7.9 26.2-22.5-15.7z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#8E5715",
    d: "M249.7 144.6c-.9 9.2-1.5 18.4-1.7 27.6-.3 11.9.3 20.7 2 26 2.2 6.6 7.2 12.9 14.2 18.9 5.3 4.6 10.6 8.1 14.2 10.1 3.1 1.7 7 .6 8.7-2.4 1.7-3.1.6-7-2.4-8.7-4.3-2.5-8.4-5.4-12.2-8.7-5.4-4.6-9.1-9.2-10.4-13.3-1.1-3.4-1.6-11.3-1.4-21.7.2-8.9.8-17.8 1.7-26.6.4-3.5-2.2-6.6-5.7-7-3.6-.3-6.7 2.3-7 5.8z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFF",
    d: "m217.8 170.7 25.5 38.2h-25.5v-38.2z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "none",
    stroke: "#D80027",
    strokeWidth: 12,
    strokeMiterlimit: 10,
    d: "M256 285.3s76.4-51.3 76.4-114.6S256 56 256 56s-76.4 51.3-76.4 114.6S256 285.3 256 285.3z"
  }));
}, ZP = function(e) {
  var n = e.title, r = v(e, uC);
  return /* @__PURE__ */ i.createElement("svg", h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ i.createElement("title", null, n), /* @__PURE__ */ i.createElement("path", {
    fill: "#6DA544",
    d: "M0 0h512v342H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFDA44",
    d: "M0 0h512v171H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#D80027",
    d: "M0 0h182v342H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    d: "m98.3 109.8 15.1 46.5h48.9L122.8 185l15.1 46.5-39.6-28.7-39.5 28.7L73.9 185l-39.6-28.7h48.9z"
  }));
}, XP = function(e) {
  var n = e.title, r = v(e, fC);
  return /* @__PURE__ */ i.createElement("svg", h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 900 600"
  }, r), n && /* @__PURE__ */ i.createElement("title", null, n), /* @__PURE__ */ i.createElement("path", {
    fill: "#009E49",
    d: "M0 0h900v600H0V0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFF",
    d: "m0 0 947 300L0 600V0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFD00D",
    d: "M0 26.1 870 300 0 573.9V26.1z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#2D2D2D",
    d: "m0 0 450 300L0 600V0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#D3132F",
    d: "m0 35 397.5 265L0 565V35z"
  }));
}, JP = function(e) {
  var n = e.title, r = v(e, pC);
  return /* @__PURE__ */ i.createElement("svg", h({
    viewBox: "0 0.5 21 14",
    xmlns: "http://www.w3.org/2000/svg"
  }, r), n && /* @__PURE__ */ i.createElement("title", null, n), /* @__PURE__ */ i.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /* @__PURE__ */ i.createElement("path", {
    fill: "#FFF",
    d: "M0 0h21v15H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#ee1c25",
    d: "M0 0h21v15H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    d: "M12 7.19c-.798-.5-1 .409-1 0 0-.828.895-1.5 2-1.5s2 .672 2 1.5c-.949 0-1.044.5-1.5.5-.56 0-.702 0-1.5-.5zM13.25 7a.25.25 0 1 0 0-.5.25.25 0 0 0 0 .5zm-1.81 1.962c.228-.913-.698-.824-.31-.95.788-.257 1.703.387 2.045 1.438.341 1.05-.021 2.11-.809 2.366-.293-.903-.798-.838-.939-1.272-.173-.533-.217-.668.012-1.582zm.566 1.13a.25.25 0 1 0 .476-.154.25.25 0 0 0-.476.154zM9.58 8.977c.94-.065.57-.919.81-.588.486.67.157 1.74-.737 2.389-.894.65-2.013.632-2.5-.038.768-.558.55-1.018.92-1.286.453-.33.568-.413 1.507-.477zm-.899.888a.25.25 0 1 0 .294.405.25.25 0 0 0-.294-.405zm.312-2.652c.351.874 1.049.258.809.588-.487.67-1.606.687-2.5.038-.894-.65-1.223-1.719-.736-2.39.767.559 1.138.21 1.507.478.453.33.568.413.92 1.286zm-1.124-.58a.25.25 0 1 0-.293.404.25.25 0 0 0 .293-.404zm2.619-.524c-.722.605.08 1.078-.309.951-.788-.256-1.15-1.315-.809-2.365.342-1.05 1.257-1.695 2.045-1.439-.293.903.153 1.147.012 1.581-.173.533-.217.668-.939 1.272zm.205-1.247a.25.25 0 1 0-.475-.155.25.25 0 0 0 .475.155z",
    fill: "#FFF"
  })));
}, QP = function(e) {
  var n = e.title, r = v(e, mC);
  return /* @__PURE__ */ i.createElement("svg", h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ i.createElement("title", null, n), /* @__PURE__ */ i.createElement("path", {
    fill: "#0052B4",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ i.createElement("g", {
    fill: "#FFF"
  }, /* @__PURE__ */ i.createElement("path", {
    d: "M223.4 170.7c.3-.3.5-.6.8-.9-.3.3-.5.6-.8.9zm-34.2 41.9 11 22.9 24.7-5.7-11.1 22.8 19.9 15.8L209 274v25.4l-19.8-15.9-19.8 15.9.1-25.4-24.8-5.6 19.9-15.8-11.1-22.8 24.8 5.7zm197.9 28.5 5.2 10.9 11.8-2.7-5.3 10.9 9.5 7.5-11.8 2.6v12.2l-9.4-7.6-9.5 7.6.1-12.2-11.9-2.6 9.5-7.5-5.3-10.9 11.9 2.7zm-48.6-116 5.2 10.9 11.8-2.7-5.3 10.9 9.5 7.5-11.8 2.7v12.1l-9.4-7.6-9.5 7.6v-12.1l-11.8-2.7 9.5-7.5-5.3-10.9 11.8 2.7zm48.6-66.2 5.2 10.9 11.8-2.7-5.3 10.9 9.5 7.5-11.8 2.7v12.1l-9.4-7.6-9.5 7.6.1-12.1-11.9-2.7 9.5-7.5-5.3-10.9 11.9 2.7zm42.4 49.7 5.3 10.9 11.8-2.7-5.3 10.9 9.5 7.5-11.8 2.6V150l-9.5-7.6-9.4 7.6v-12.2l-11.8-2.6 9.5-7.5-5.3-10.9 11.8 2.7zm-30.3 57.9 4.1 12.7h13.3l-10.8 7.8 4.1 12.6-10.7-7.8-10.8 7.8 4.1-12.6-10.7-7.8h13.3z"
  }), /* @__PURE__ */ i.createElement("path", {
    d: "M256 0v30.6l-45.2 25.1H256V115h-59.1l59.1 32.8v22.9h-26.7l-73.5-40.9v40.9h-55.6v-48.6l-87.5 48.6H0v-30.6L45.2 115H0V55.7h59.1L0 22.8V0h26.7l73.5 40.8V0h55.6v48.6L243.3 0z"
  })), /* @__PURE__ */ i.createElement("path", {
    fill: "#D80027",
    d: "M144 0h-32v69.3H0v32h112v69.4h32v-69.4h112v-32H144z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#0052B4",
    d: "M155.8 115 256 170.7v-15.8L184.2 115z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFF",
    d: "M155.8 115 256 170.7v-15.8L184.2 115z"
  }), /* @__PURE__ */ i.createElement("path", {
    d: "M155.8 115 256 170.7v-15.8L184.2 115zm-84 0L0 154.9v15.8L100.2 115z",
    fill: "#D80027"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#0052B4",
    d: "M100.2 55.6 0 0v15.7l71.8 39.9z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFF",
    d: "M100.2 55.6 0 0v15.7l71.8 39.9z"
  }), /* @__PURE__ */ i.createElement("path", {
    d: "M100.2 55.6 0 0v15.7l71.8 39.9zm84 0L256 15.7V0L155.8 55.6z",
    fill: "#D80027"
  }));
}, eN = function(e) {
  var n = e.title, r = v(e, hC);
  return /* @__PURE__ */ i.createElement("svg", h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ i.createElement("title", null, n), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFF",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    d: "M0 0h513v114H0zm0 228h513v114H0zm203.5-110.1 6.7 16.6 17.6 1-14 10.9 4.7 17.7-15-9.9-15 9.9 4.7-17.7-14-10.9 17.6-1zm105 0 6.7 16.6 17.6 1-14 10.9 4.7 17.7-15-9.9-15 9.9 4.7-17.7-14-10.9 17.6-1zM256 147.6l6.7 16.6 17.6 1-14 10.9 4.7 17.7-15-9.9-15 9.9 4.7-17.7-14-10.9 17.6-1zm-52.5 29.7 6.7 16.6 17.6 1-14 10.9 4.7 17.6-15-9.9-15 9.9 4.7-17.6-14-10.9 17.6-1zm105 0 6.7 16.6 17.6 1-14 10.9 4.7 17.6-15-9.9-15 9.9 4.7-17.6-14-10.9 17.6-1z",
    fill: "#338AF3"
  }));
}, tN = function(e) {
  var n = e.title, r = v(e, vC);
  return /* @__PURE__ */ i.createElement("svg", h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ i.createElement("title", null, n), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFF",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#D80027",
    d: "M0 0h513v114H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#0052B4",
    d: "M0 228h513v114H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    d: "M309.3 113.2v-44l17.5-14.4 17.7 14.4v44zm-105.6 0v-44l-17.3-14.4-17.9 14.4v44zm35.2 0v-44l17.6-14.4 17.6 14.4v44z",
    fill: "#338AF3"
  }), /* @__PURE__ */ i.createElement("path", {
    d: "M309.3 113.2h-35.2v-44l17.5-14.4 17.7 14.4zm-70.4 0h-35.2v-44l17.5-14.4 17.7 14.4z",
    fill: "#0052B4"
  }), /* @__PURE__ */ i.createElement("path", {
    stroke: "#D80027",
    fill: "#FFF",
    d: "M168.5 113.2v101.9c0 24.3 14.4 46.2 35.4 59.4 21.3 13.4 42.1 14.7 52.6 14.7s31.4-1.7 52.6-14.8c21-13 35.4-35.1 35.4-59.3V113.2h-176z"
  }), /* @__PURE__ */ i.createElement("path", {
    d: "M168.5 113.2h35.2v35.2h-35.2zm70.4 0h35.2v35.2h-35.2zm70.4 0h35.2v35.2h-35.2zm-105.6 35.2h35.2v35.2h-35.2zm70.4 0h35.2v35.2h-35.2zm-105.6 35.2h35.2v35.2h-35.2zm35.2 35.2h35.2V254h-35.2zm35.2-35.2h35.2v35.2h-35.2zm70.4 0h35.2v35.2h-35.2zm-35.2 35.2h35.2V254h-35.2zm35.2 55.5c8.6-5.4 16.2-12.3 22-20.3h-22v20.3zM181.7 254c5.8 8 13.3 14.9 22 20.4V254h-22zm57.2 0v33.7c7.2 1.2 13.3 1.5 17.6 1.5 4.3 0 10.4-.3 17.6-1.6V254h-35.2z",
    fill: "#D80027"
  }));
}, nN = function(e) {
  var n = e.title, r = v(e, gC);
  return /* @__PURE__ */ i.createElement("svg", h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ i.createElement("title", null, n), /* @__PURE__ */ i.createElement("path", {
    fill: "#A2001D",
    d: "M0 0h513v172H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#0052B4",
    d: "M0 172h513v172H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFF",
    d: "m381.4 251.5-110.7-13.8-110.8 13.8V85.4h221.5z"
  }), /* @__PURE__ */ i.createElement("circle", {
    fill: "#0052B4",
    cx: 270.7,
    cy: 182.3,
    r: 55.4
  }), /* @__PURE__ */ i.createElement("circle", {
    fill: "#A2001D",
    cx: 270.7,
    cy: 182.3,
    r: 27.7
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#6DA544",
    d: "M229.1 113.1h83.1l-41.5 41.5z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFDA44",
    d: "M256.8 140.8h27.7v83h-27.7z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#6DA544",
    d: "M314.9 215.5h-88.5l-66.5 36h221.5z"
  }));
}, rN = function(e) {
  var n = e.title, r = v(e, yC);
  return /* @__PURE__ */ i.createElement("svg", h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ i.createElement("title", null, n), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFF",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#D80027",
    d: "M0 0h513v114H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#6DA544",
    d: "M0 228h513v114H0z"
  }));
}, aN = function(e) {
  var n = e.title, r = v(e, bC);
  return /* @__PURE__ */ i.createElement("svg", h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 300 200"
  }, r), n && /* @__PURE__ */ i.createElement("title", null, n), /* @__PURE__ */ i.createElement("path", {
    fill: "#fc0",
    d: "M0 0h300v200H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#0768a9",
    d: "M0 0h200v200H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#fff",
    d: "M0 0h100v200H0z"
  }));
}, iN = function(e) {
  var n = e.title, r = v(e, EC);
  return /* @__PURE__ */ i.createElement("svg", h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ i.createElement("title", null, n), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFF",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#E00",
    d: "M0 0h513v171H0z"
  }));
}, oN = function(e) {
  var n = e.title, r = v(e, wC);
  return /* @__PURE__ */ i.createElement("svg", h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ i.createElement("title", null, n), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFF",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#6DA544",
    d: "M0 0h171v342H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#FF9811",
    d: "M342 0h171v342H342z"
  }));
}, lN = function(e) {
  var n = e.title, r = v(e, $C);
  return /* @__PURE__ */ i.createElement("svg", h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ i.createElement("title", null, n), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFF",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    d: "M340.6 122.4h-56.1l-28-48.6-28 48.6h-56.1l28 48.6-28 48.6h56.1l28 48.6 28-48.6h56.1l-28-48.6 28-48.6zM293.2 171 276 204.2h-38.9L219.8 171l17.2-33.2h38.9l17.3 33.2zm-36.7-71.8 11.9 23.3h-23.9l12-23.3zm-58.3 38.6h23.9l-10.8 21-13.1-21zm0 66.4 13-22.1 11.9 22.1h-24.9zm58.3 37.5-11.9-22.1h23.9l-12 22.1zm59.4-37.5h-25l11.9-22.1 13.1 22.1zm-26.1-66.4h26.1l-13 22.1-13.1-22.1zM0 21.3h512V64H0zm0 256h512V320H0z",
    fill: "#2E52B2"
  }));
}, sN = function(e) {
  var n = e.title, r = v(e, xC);
  return /* @__PURE__ */ i.createElement("svg", h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ i.createElement("title", null, n), /* @__PURE__ */ i.createElement("path", {
    fill: "#E52D42",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFF",
    d: "M393.3 68.2h-45.8l-33.8 80.2-34.4-22.9s-24.7-59.1-34.4-68.2c-9.7-9.7-18.7-.6-48.9 7.8-29.6 8.4-30.8 18.7-42.2 18.7-4.8 0-19.9-17.5-27.7-22.3-12.1-7.8-16.9-4.2-13.9 7.2 1.2 4.8 10.9 10.9 16.9 19.9 7.8 11.5 12.7 25.9 12.7 25.9s10.9-10.3 16.9-12.1c9-2.4 19.3 1.8 31.4 0 15.1-2.4 31.4-10.9 31.4-10.9l4.2 43.4s-54.3 50.7-49.5 70.6 56.1 44.6 68.2 62.7c12.1 17.5-7.2 24.1-7.2 32.6s-1.8 19.9 7.2 16.3c9-3.6 10.3-18.1 18.7-31.4 6-9 10.3-13.9 11.5-17.5 1.8-9-23.5-32-37.4-48.9-6.6-7.8-19.9-18.7-19.9-18.7l39.2-29.6s67.6 27.7 82.6 18.7c15.1-9 19.3-98.3 19.3-98.3l47-11.5-12.1-11.7z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#F8DD4E",
    d: "M279.3 262.4c-6 0-11.5-4.8-11.5-11.5s4.8-11.5 11.5-11.5c6 0 11.5 4.8 11.5 11.5s-5.5 11.5-11.5 11.5zm45.8-182.8c-6 0-11.5-4.8-11.5-11.5s4.8-11.5 11.5-11.5c6 0 11.5 4.8 11.5 11.5s-5.5 11.5-11.5 11.5zm0 91.1c-6 0-11.5-4.8-11.5-11.5 0-6 4.8-11.5 11.5-11.5 6 0 11.5 4.8 11.5 11.5-.6 6.7-5.5 11.5-11.5 11.5zm-136.9 45.8c-6 0-11.5-4.8-11.5-11.5 0-6 4.8-11.5 11.5-11.5 6.6 0 11.5 4.8 11.5 11.5s-5.5 11.5-11.5 11.5zm45.2-136.9c-6 0-11.5-4.8-11.5-11.5s4.8-11.5 11.5-11.5c6 0 11.5 4.8 11.5 11.5s-4.8 11.5-11.5 11.5zm22.9 91.1c-6 0-11.5-10.3-11.5-22.9s4.8-22.9 11.5-22.9c6 0 11.5 10.3 11.5 22.9s-4.8 22.9-11.5 22.9zm-114-45.2c-6 0-11.5-4.8-11.5-11.5 0-6.6 4.8-11.5 11.5-11.5 6.6 0 11.5 4.8 11.5 11.5 0 6.6-4.8 11.5-11.5 11.5z"
  }));
}, cN = function(e) {
  var n = e.title, r = v(e, CC);
  return /* @__PURE__ */ i.createElement("svg", h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ i.createElement("title", null, n), /* @__PURE__ */ i.createElement("path", {
    fill: "#F93",
    d: "M0 0h513v114H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#fff",
    d: "M0 114h513v114H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#138808",
    d: "M0 228h513v114H0z"
  }), /* @__PURE__ */ i.createElement("circle", {
    cx: 256.5,
    cy: 171,
    r: 34.2,
    stroke: "navy",
    strokeWidth: 4,
    fill: "none"
  }), /* @__PURE__ */ i.createElement("circle", {
    cx: 256.5,
    cy: 171,
    r: 3.42,
    fill: "navy"
  }), /* @__PURE__ */ i.createElement("path", {
    d: "m265.3 138.159-17.6 65.682m17.6-65.682-17.6 65.682m25.8-62.286-34 58.89m41.042-53.487-48.084 48.084M285.945 154l-58.89 34m62.286-25.8-65.682 17.6M290.5 171h-68m66.841 8.8-65.682-17.6m62.286 25.8-58.89-34m53.487 41.042-48.084-48.084m41.042 53.487-34-58.89m25.8 62.286-17.6-65.682M256.5 205v-68m-8.8 66.841 17.6-65.682m-25.8 62.286 34-58.89m-41.042 53.487 48.084-48.084M227.055 188l58.89-34m-62.286 25.8 65.682-17.6M222.5 171h68m-66.841-8.8 65.682 17.6M227.055 154l58.89 34m-53.487-41.042 48.084 48.084M239.5 141.555l34 58.89m-25.8-62.286 17.6 65.682",
    stroke: "navy",
    strokeWidth: 2
  }));
}, dN = function(e) {
  var n = e.title, r = v(e, MC);
  return /* @__PURE__ */ i.createElement("svg", h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ i.createElement("title", null, n), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFF",
    d: "M0-.3h513V342H0V-.3z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#0052B4",
    d: "M462.9 198.1c-4 0-14-5-21-9-11-6-21-12-31.1-12s-20 6-31.1 12c-7 4-16 9-20 9s-14-5-20-9c-11-6-22-12-32.1-12-9 0-20 6-31.1 12-7 4-16 9-20 9s-13-5-20-9c-11-6-22-12-31.1-12-10 0-21 6-32.1 12-6 4-16 9-20 9s-13-5-20-9c-11-6-21-12-31.1-12s-20 6-31.1 12c-7 4-17 9-21 9s-13-5-20-9c-10-6-20-12-30.1-12v22l19 10c11 6 21 12 31.1 12s21-6 32.1-12c6-4 16-10 20-10s13 6 20 10c11 6 21 12 31.1 12s20-6 31.1-12c7-4 17-10 21-10s13 6 20 10c11 6 21 12 31.1 12s20-6 31.1-12c7-4 16-10 20-10s14 6 21 10c11 6 21 12 31.1 12s20-6 31.1-12c7-4 16-10 20-10s14 6 20 10c11 6 22 12 32.1 12s20-6 31.1-12l19-10v-22c-10 0-20 6-30.1 12-7 4-16 9-20 9zM0 31.7l19 10c11 6 21 12 31.1 12s21-6 32.1-12c6-4 16-10 20-10s13 6 20 10c11 6 21 12 31.1 12s20-6 31.1-12c7-4 17-10 21-10s13 6 20 10c11 6 21 12 31.1 12s20-6 31.1-12c7-4 16-10 20-10s14 6 21 10c11 6 21 12 31.1 12s20-6 31.1-12c7-4 16-10 20-10s14 6 20 10c11 6 22 12 32.1 12s20-6 31.1-12l19-10v-22c-10 1-20 6-30.1 12-7 4-16 9-20 9s-14-5-21-9c-11-6-21-12-31.1-12s-20 6-31.1 12c-7 4-16 9-20 9s-14-5-20-9c-11-6-22-12-32.1-12s-20 6-31.1 12c-7 4-16 9-20 9s-13-5-20-9c-11-6-22-12-31.1-12s-21 6-32.1 12c-6 4-16 9-20 9s-13-5-20-9c-11-6-21-12-31.1-12s-20 6-31.1 12c-7 4-17 9-21 9s-13-5-20-9c-10-6-20-11-30.1-12v22zm462.9 55.2c-4 0-14-5-21-9-11-6-21-12-31.1-12s-20 6-31.1 12c-7 4-16 9-20 9s-14-5-20-9c-11-6-22-12-32.1-12-9 0-20 6-31.1 12-7 4-16 9-20 9s-13-5-20-9c-11-6-22-12-31.1-12-10 0-21 6-32.1 12-6 4-16 9-20 9s-13-5-20-9c-11-6-21-12-31.1-12s-20 6-31.1 12c-7 4-17 9-21 9s-13-5-20-9c-10-6-20-12-30.1-12v22l19 9c11 6 21 12 31.1 12s21-6 32.1-12c6-4 16-9 20-9s13 5 20 9c11 6 21 12 31.1 12s20-6 31.1-12c7-4 17-9 21-9s13 5 20 9c11 6 21 12 31.1 12s20-6 31.1-12c7-4 16-9 20-9s14 5 21 9c11 6 21 12 31.1 12s20-6 31.1-12c7-4 16-9 20-9s14 5 20 9c11 6 22 12 32.1 12s20-6 31.1-12l19-9v-22c-10 0-20 6-30.1 12-7 3.9-16 9-20 9zm50.1 34c-10 1-20 6-30.1 12-7 4-16 10-20 10s-14-6-21-10c-11-6-21-12-31.1-12s-20 6-31.1 12c-7 4-16 10-20 10s-14-6-20-10c-11-6-22-12-32.1-12s-20 6-31.1 12c-7 4-16 10-20 10s-13-6-20-10c-11-6-22-12-31.1-12s-21 6-32.1 12c-6 4-16 10-20 10s-13-6-20-10c-11-6-21-12-31.1-12s-20 6-31.1 12c-7 4-17 10-21 10s-13-6-20-10c-10-6-20-11-30.1-12v23c4 1 13 5 19 9 11 6 21 12 31.1 12s21-6 32.1-12c6-4 16-9 20-9s13 5 20 9c11 6 21 12 31.1 12s20-6 31.1-12c7-4 17-9 21-9s13 5 20 9c11 6 21 12 31.1 12s20-6 31.1-12c7-4 16-9 20-9s14 5 21 9c11 6 21 12 31.1 12s20-6 31.1-12c7-4 16-9 20-9s14 5 20 9c11 6 22 12 32.1 12s20-6 31.1-12c6-4 15-8 19-9v-23zm-50.1 133.3c-4 0-14-5-21-9-11-6-21-12-31.1-12s-20 6-31.1 12c-7 4-16 9-20 9s-14-5-20-9c-11-6-22-12-32.1-12-9 0-20 6-31.1 12-7 4-16 9-20 9s-13-5-20-9c-11-6-22-12-31.1-12-10 0-21 6-32.1 12-6 4-16 9-20 9s-13-5-20-9c-11-6-21-12-31.1-12s-20 6-31.1 12c-7 4-17 9-21 9s-13-5-20-9c-10-6-20-12-30.1-12v22l19 9c11 6 21 12 31.1 12s21-6 32.1-12c6-4 16-9 20-9s13 5 20 9c11 6 21 12 31.1 12s20-6 31.1-12c7-4 17-9 21-9s13 5 20 9c11 6 21 12 31.1 12s20-6 31.1-12c7-4 16-9 20-9s14 5 21 9c11 6 21 12 31.1 12s20-6 31.1-12c7-4 16-9 20-9s14 5 20 9c11 6 22 12 32.1 12s20-6 31.1-12l19-9v-22c-10 0-20 6-30.1 12-7 4-16 9-20 9zm50.1 34c-10 1-20 6-30.1 12-7 4-16 10-20 10s-14-6-21-10c-11-6-21-12-31.1-12s-20 6-31.1 12c-7 4-16 10-20 10s-14-6-20-10c-11-6-22-12-32.1-12s-20 6-31.1 12c-7 4-16 10-20 10s-13-6-20-10c-11-6-22-12-31.1-12s-21 6-32.1 12c-6 4-16 10-20 10s-13-6-20-10c-11-6-21-12-31.1-12s-20 6-31.1 12c-7 4-17 10-21 10s-13-6-20-10c-10-6-20-11-30.1-12v23c4 0 13 5 19 9 11 6 21 12 31.1 12s21-6 32.1-12c6-4 16-9 20-9s13 5 20 9c11 6 21 12 31.1 12s20-6 31.1-12c7-4 17-9 21-9s13 5 20 9c11 6 21 12 31.1 12s20-6 31.1-12c7-4 16-9 20-9s14 5 21 9c11 6 21 12 31.1 12s20-6 31.1-12c7-4 16-9 20-9s14 5 20 9c11 6 22 12 32.1 12s20-6 31.1-12c6-4 15-9 19-9v-23z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFF",
    d: "M0-.3h256v171H0V-.3z"
  }), /* @__PURE__ */ i.createElement("path", {
    d: "M389.8 119.9H408v78.8h-18.3l.1-78.8zm0 117.8H408v75.1h-18.3l.1-75.1z",
    fill: "#A2001D"
  }), /* @__PURE__ */ i.createElement("g", {
    fill: "#D80027"
  }, /* @__PURE__ */ i.createElement("path", {
    d: "M144-.3h-32v70H0v32h112v69h32v-69h112v-32H144v-70z"
  }), /* @__PURE__ */ i.createElement("path", {
    d: "M0-.3v15l57 39h23L0-.3zm256 0v15l-57 39h-23l80-54z"
  }), /* @__PURE__ */ i.createElement("path", {
    d: "M0-.3v15l57 39h23L0-.3zm256 0v15l-57 39h-23l80-54zM0 170.7v-15l57-38h23l-80 53zm256 0v-15l-57-38h-23l80 53z"
  })), /* @__PURE__ */ i.createElement("g", {
    fill: "#2E52B2"
  }, /* @__PURE__ */ i.createElement("path", {
    d: "M0 22.7v31h46l-46-31zm96-23v49L23-.3h73zm160 23v31h-46l46-31zm-96-23v49l73-49h-73z"
  }), /* @__PURE__ */ i.createElement("path", {
    d: "M0 22.7v31h46l-46-31zm96-23v49L23-.3h73zm160 23v31h-46l46-31zm-96-23v49l73-49h-73zM0 147.7v-30h46l-46 30zm96 23v-49l-73 49h73zm160-23v-30h-46l46 30zm-96 23v-49l73 49h-73z"
  })), /* @__PURE__ */ i.createElement("path", {
    fill: "#5DA51E",
    stroke: "#45602C",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    d: "M462.8 91.5h-29.1l25.7-25.7c4.5-4.4 4.5-11.4 0-15.8l-3.4-3.4c-4.4-4.4-11.4-4.4-15.8 0l-25.9 25.9V37.4c0-6.2-5.1-11.3-11.3-11.3h-4.7c-6.2 0-11.3 5.1-11.3 11.3v31.7l-23.5-23.8c-4.7-4.7-12.2-4.7-16.9 0l-3.6 3.6c-4.7 4.7-4.7 12.4 0 17.2l25 25.4h-30.6c-6 0-10.9 4.9-10.9 10.9v4.6c0 6 4.9 10.9 10.9 10.9H369l-20.7 20.7c-4.4 4.4-4.4 11.4 0 15.8l3.4 3.4c4.4 4.4 11.4 4.4 15.8 0l19.6-19.6V167c0 6.1 5.1 11.1 11.3 11.3h4.7c6.2 0 11.3-5.1 11.3-11.3v-28.3l22.2 22.6c4.7 4.7 12.4 4.7 17.1 0l3.6-3.6c4.7-4.7 4.7-12.4 0-17.2L435.2 118h27.6c5.9 0 10.7-4.9 10.9-10.9v-4.6c0-6.1-4.9-11-10.9-11z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#E2DD24",
    stroke: "#525625",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    d: "M439.2 249.1h-79.8s-.9-13.4-6-21.8c-6.2-10.4-13.9-28.1-1.4-36.7 15.9-10.9 33.7.8 48.2.8 11.8.1 26.9-14 45-.8 12.2 8.9 3.9 28.2-1.3 36.7-7 11.5-4.7 21.8-4.7 21.8z"
  }));
}, uN = function(e) {
  var n = e.title, r = v(e, SC);
  return /* @__PURE__ */ i.createElement("svg", h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ i.createElement("title", null, n), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFF",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#CE1126",
    d: "M0 0h513v114H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    d: "M0 228h513v114H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    d: "M219.2 160.7h-29.3c1.5-5.7 6.6-9.9 12.8-9.9v-19.9c-18.3 0-33.1 14.9-33.1 33.1v16.5h49.6c1.8 0 3.3 1.5 3.3 3.3v6.6h-66.2v19.9h86.1v-26.5c0-12.7-10.4-23.1-23.2-23.1zm49.6 29.8v-59.6H249v79.5h33.1v-19.9zm66.2 0v-59.6h-19.8v59.6h-6.6v-19.8h-19.9v39.7h59.6v-19.9z",
    fill: "#547C31"
  }));
}, fN = function(e) {
  var n = e.title, r = v(e, FC);
  return /* @__PURE__ */ i.createElement("svg", h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ i.createElement("title", null, n), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFF",
    d: "M0 0h512v342H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#6DA544",
    d: "M0 0h513v114H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    d: "M0 227.9h513v114H0zm278.8-93.1c.1 2 8.7 26.2 4.4 39.4-6.6 20.3-15.8 21.8-19.8 24.5V134l-6.9-4.2-6.9 4.2v64.7c-4-2.7-12.4-2.4-19.8-24.5-4.3-12.7 5.7-37.3 5.8-39.2 0 0-9.5 8.1-15.8 24-5.9 14.8 1.9 49.6 29.5 54.8 2.3.4 4.7 5.6 7.2 5.6 2.1 0 4.1-5.2 6-5.5 28.4-4.6 35-41.7 29.9-55.6-5.4-14.6-13.6-23.5-13.6-23.5z",
    fill: "#D80027"
  }), /* @__PURE__ */ i.createElement("path", {
    d: "M44.6 98.9h22.3v24.4H44.6zM0 98.9h22.3v24.4H0zm89.2 0h22.3v24.4H89.2zm44.6 0h22.3v24.4h-22.3zm44.6 0h22.3v24.4h-22.3zm44.6 0h22.3v24.4H223zm44.7 0H290v24.4h-22.3zm44.6 0h22.3v24.4h-22.3zm44.6 0h22.3v24.4h-22.3zm44.6 0h22.3v24.4h-22.3zm44.6 0h22.3v24.4h-22.3zm44.6 0H513v24.4h-22.3zm-446.1 118h22.3v25.5H44.6zm-44.6 0h22.3v25.5H0zm89.2 0h22.3v25.5H89.2zm44.6 0h22.3v25.5h-22.3zm44.6 0h22.3v25.5h-22.3zm44.6 0h22.3v25.5H223zm44.7 0H290v25.5h-22.3zm44.6 0h22.3v25.5h-22.3zm44.6 0h22.3v25.5h-22.3zm44.6 0h22.3v25.5h-22.3zm44.6 0h22.3v25.5h-22.3zm44.6 0H513v25.5h-22.3z",
    fill: "#FFF",
    opacity: 0.5
  }));
}, pN = function(e) {
  var n = e.title, r = v(e, PC);
  return /* @__PURE__ */ i.createElement("svg", h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ i.createElement("title", null, n), /* @__PURE__ */ i.createElement("path", {
    fill: "#0052B4",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFF",
    d: "M513 210.6H202.2v130.7h-79.8V210.6H0v-79.8h122.4V0h79.8v130.8H513v18.5l-1 42.7z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#D80027",
    d: "M513 149.3V192H183.7v149.3H141V192H0v-42.7h141V0h42.7v149.3z"
  }));
}, mN = function(e) {
  var n = e.title, r = v(e, NC);
  return /* @__PURE__ */ i.createElement("svg", h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ i.createElement("title", null, n), /* @__PURE__ */ i.createElement("path", {
    fill: "#F4F5F0",
    d: "M342 0H0v341.3h512V0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#008C45",
    d: "M0 0h171v342H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#CD212A",
    d: "M342 0h171v342H342z"
  }));
}, hN = function(e) {
  var n = e.title, r = v(e, _C);
  return /* @__PURE__ */ i.createElement("svg", h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ i.createElement("title", null, n), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFF",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#D80027",
    d: "M301.8 171 513 30.2V0h-45.3L256.5 140.8 45.3 0H0v30.2L211.2 171 0 311.8V342h45.3l211.2-140.8L467.7 342H513v-30.2z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFDA44",
    d: "m233.7 44.6 22.3 5.6 22.3-5.6 4-20.9-14.9 6.5L256 14.8l-11.4 15.4-14.9-6.5z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#D80027",
    d: "M233.7 44.6s-4 12.9-4 29.9c0 27.9 26.3 41.3 26.3 41.3s26.3-15.5 26.3-41.3c0-15.4-4-29.9-4-29.9s-8.1-5-22.3-5-22.3 5-22.3 5z"
  }));
}, vN = function(e) {
  var n = e.title, r = v(e, TC);
  return /* @__PURE__ */ i.createElement("svg", h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ i.createElement("title", null, n), /* @__PURE__ */ i.createElement("path", {
    fill: "#6DA544",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    d: "M215.9 171 0 314.6V26.8zM513 26.8v287.8L296.1 171z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#0052B4",
    d: "M513 26.8 296.1 171 513 314.6V342h-41.1L256 197.4 40.1 342H0v-27.4L215.9 171 0 26.8V0h40.1L256 143.9 471.9 0H513z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFDA44",
    d: "M513 26.8 296.1 171 513 314.6V342h-41.1L256 197.4 40.1 342H0v-27.4L215.9 171 0 26.8V0h40.1L256 143.9 471.9 0H513z"
  }));
}, gN = function(e) {
  var n = e.title, r = v(e, AC);
  return /* @__PURE__ */ i.createElement("svg", h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ i.createElement("title", null, n), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFF",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    d: "M0 0h513v114H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#6DA544",
    d: "M0 228h513v114H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#D80027",
    d: "M256.5 170.7 0 341.3V0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFF",
    d: "m77.9 139.5 7.9 16.4 17.8-4.1-8 16.5 14.3 11.3-17.8 4 .1 18.3-14.3-11.5-14.2 11.5v-18.3l-17.8-4 14.3-11.3-7.9-16.5 17.7 4.1z"
  }));
}, yN = function(e) {
  var n = e.title, r = v(e, zC);
  return /* @__PURE__ */ i.createElement("svg", h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ i.createElement("title", null, n), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFF",
    d: "M0 0h512v342H0z"
  }), /* @__PURE__ */ i.createElement("circle", {
    fill: "#D80027",
    cx: 256.5,
    cy: 171,
    r: 96
  }));
}, bN = function(e) {
  var n = e.title, r = v(e, DC);
  return /* @__PURE__ */ i.createElement("svg", h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ i.createElement("title", null, n), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFF",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    d: "M0 0h512v90.579H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#496E2D",
    d: "M0 251h513v91H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#A2001D",
    d: "M0 114h513v114H0z"
  }), /* @__PURE__ */ i.createElement("g", {
    fill: "#FFF"
  }, /* @__PURE__ */ i.createElement("path", {
    d: "m323.3 54.5-25.6-11.8L256 137l-41.7-94.3-25.6 11.8 51.8 116.2-51.8 116.2 25.6 11.8 41.7-94.4 41.7 94.4 25.6-11.8-51.8-116.2z"
  }), /* @__PURE__ */ i.createElement("path", {
    d: "M273.4 65.6c-9.9-10.8-17.4-17-17.4-17s-7.5 6.2-17.4 17v210.1c9.9 10.8 17.4 17 17.4 17s7.5-6.2 17.4-17V65.6z"
  })), /* @__PURE__ */ i.createElement("path", {
    d: "M209 105.9v129.5c10.5 18.5 23.3 33.7 32.9 43.8V62.1c-9.6 10.1-22.4 25.3-32.9 43.8zm94 0c-10.5-18.5-23.3-33.7-32.9-43.8v217.2c9.6-10.1 22.4-25.3 32.9-43.8V105.9z",
    fill: "#A2001D"
  }), /* @__PURE__ */ i.createElement("path", {
    d: "M303 105.9v129.5c10.6-18.8 18.8-41 18.8-64.8s-8.2-45.9-18.8-64.7zm-94 0v129.5c-10.6-18.8-18.8-41-18.8-64.8s8.2-45.9 18.8-64.7z"
  }));
}, EN = function(e) {
  var n = e.title, r = v(e, IC);
  return /* @__PURE__ */ i.createElement("svg", h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 342"
  }, r), n && /* @__PURE__ */ i.createElement("title", null, n), /* @__PURE__ */ i.createElement("g", {
    fill: "#D80027"
  }, /* @__PURE__ */ i.createElement("path", {
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ i.createElement("circle", {
    cx: 256,
    cy: 170.7,
    r: 170.7
  })), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFDA44",
    d: "M382.4 170.7 330.8 195l27.5 50-56.1-10.7-7.1 56.6-39.1-41.7-39.1 41.7-7.1-56.6-56.1 10.7 27.5-50-51.6-24.3 51.6-24.3-27.5-50.1 56.1 10.8 7.1-56.7L256 92.1l39.1-41.7 7.1 56.7 56.1-10.8-27.5 50.1z"
  }), /* @__PURE__ */ i.createElement("circle", {
    fill: "#D80027",
    cx: 257.4,
    cy: 170.7,
    r: 71.6
  }), /* @__PURE__ */ i.createElement("path", {
    d: "M214.2 170.7c-2.1 0-4.1.1-6.2.3.1 12 4.4 22.9 11.6 31.5 3.8-10.3 9.5-19.6 16.7-27.7-6.9-2.7-14.3-4.1-22.1-4.1zm26.6 46.5c5.2 1.9 10.8 2.9 16.6 2.9 5.8 0 11.4-1 16.6-2.9-2.8-11.1-8.7-21-16.6-28.8-7.9 7.8-13.8 17.7-16.6 28.8zm59.4-71.2c-8.5-14.8-24.5-24.7-42.8-24.7-18.3 0-34.2 9.9-42.8 24.7 15.6.1 30.2 4.3 42.8 11.6 12.6-7.3 27.2-11.6 42.8-11.6zm-21.7 28.8c7.2 8 12.9 17.4 16.7 27.7 7.2-8.5 11.5-19.5 11.6-31.5-2-.2-4.1-.3-6.2-.3-7.7 0-15.2 1.4-22.1 4.1z",
    fill: "#FFDA44"
  }));
}, wN = function(e) {
  var n = e.title, r = v(e, kC);
  return /* @__PURE__ */ i.createElement("svg", h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ i.createElement("title", null, n), /* @__PURE__ */ i.createElement("path", {
    fill: "#D80027",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    d: "M0 0h513v114H0zm0 228h513v114H0z",
    fill: "#0052B4"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFF",
    d: "M303.5 196.6v-17.8h-11.9v-23.7l-11.9-11.9-11.8 11.9v-23.8L256 119.5l-11.9 11.8v23.8l-11.8-11.9-11.9 11.9v23.7h-11.9v17.8h-11.9v17.8h118.8v-17.8z"
  }));
}, $N = function(e) {
  var n = e.title, r = v(e, OC);
  return /* @__PURE__ */ i.createElement("svg", h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 450 300"
  }, r), n && /* @__PURE__ */ i.createElement("title", null, n), /* @__PURE__ */ i.createElement("path", {
    fill: "#CE1126",
    d: "M0 0h450v300H0V0z"
  }), /* @__PURE__ */ i.createElement("g", {
    fill: "#FCD116"
  }, /* @__PURE__ */ i.createElement("circle", {
    cx: 227.6,
    cy: 161.2,
    r: 56.2
  }), /* @__PURE__ */ i.createElement("path", {
    d: "m254.1 73.4-23.7 26 28.6 6.5zm-51.5.2-4.8 33.1 28.5-8zm94.3 26.7-34.7 8.5 20.1 23.7zm-138.3-1.8 15.5 32.7 20.2-22.7zm159 45.3-34.4-9.9 5.6 29.5zm-182-2.6 31.9 19.8 5.2-27.7z"
  })), /* @__PURE__ */ i.createElement("path", {
    fill: "#003F87",
    d: "M0 175h450v125H0V175z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFF",
    d: "M0 267c15 0 30 13 45 13s30-13 45-13 30 13 45 13 30-13 45-13 30 13 45 13 30-13 45-13 30 13 45 13 30-13 45-13 30 13 45 13 30-13 45-13v-21c-15 0-30 13-45 13s-30-13-45-13-30 13-45 13-30-13-45-13-30 13-45 13-30-13-45-13-30 13-45 13-30-13-45-13-30 13-45 13-30-13-45-13v21zm0-43c15 0 30 13 45 13s30-13 45-13 30 13 45 13 30-13 45-13 30 13 45 13 30-13 45-13 30 13 45 13 30-13 45-13 30 13 45 13 30-13 45-13v-21c-15 0-30 13-45 13s-30-13-45-13-30 13-45 13-30-13-45-13-30 13-45 13-30-13-45-13-30 13-45 13-30-13-45-13-30 13-45 13-30-13-45-13v21zm0-43c15 0 30 13 45 13s30-13 45-13 30 13 45 13 30-13 45-13 30 13 45 13 30-13 45-13 30 13 45 13 30-13 45-13 30 13 45 13 30-13 45-13v-21c-15 0-30 13-45 13s-30-13-45-13-30 13-45 13-30-13-45-13-30 13-45 13-30-13-45-13-30 13-45 13-30-13-45-13-30 13-45 13-30-13-45-13v21z"
  }), /* @__PURE__ */ i.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#FCD116",
    d: "m183.2 48.3-1.1-5.3 22.4-3.7s-30.1-7.1-40-10.7c-14.3-5.1-16.3-12.1-16.3-12.1s44.7 11 64.8 11c4.3 0 12.8 10.7 12.8 10.7s14.8-14.9 21.9-15.4c32.1-2.3 66.6-6.4 66.6-6.4s-10 6.7-16 8.5c-16.2 4.9-50.6 11.7-50.6 11.7l-4.8 7.5H277l-14.4 4.3 7.4 6.9s-7.8-4.1-18.1-2.1c-7.1 1.3-15.4 6-22.9 8-18.7 4.8-29.9-12.8-29.9-12.8l-15.9-.1z"
  }));
}, xN = function(e) {
  var n = e.title, r = v(e, LC);
  return /* @__PURE__ */ i.createElement("svg", h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ i.createElement("title", null, n), /* @__PURE__ */ i.createElement("path", {
    fill: "#0052B4",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFDA44",
    d: "M0 0h513v85.5H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFF",
    d: "M0 85.5h513V171H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#D80027",
    d: "M0 171h513v85.5H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#6DA544",
    d: "M256.5 171 0 342V0z"
  }), /* @__PURE__ */ i.createElement("g", {
    fill: "#FFF"
  }, /* @__PURE__ */ i.createElement("path", {
    d: "M68.6 170.7c0-24.9 17.5-45.6 40.8-50.7-3.6-.8-7.3-1.2-11.1-1.2-28.7 0-51.9 23.3-51.9 51.9s23.3 51.9 51.9 51.9c3.8 0 7.5-.4 11.1-1.2-23.3-5.1-40.8-25.9-40.8-50.7z"
  }), /* @__PURE__ */ i.createElement("path", {
    d: "m108.9 126.1 2.7 8.5h9l-7.3 5.3 2.8 8.5-7.2-5.2-7.3 5.2 2.8-8.5-7.2-5.3h8.9zm0 22.3 2.7 8.5h9l-7.3 5.3 2.8 8.5-7.2-5.3-7.3 5.3 2.8-8.5-7.2-5.3h8.9z"
  }), /* @__PURE__ */ i.createElement("path", {
    d: "m108.9 170.7 2.7 8.5h9l-7.3 5.2 2.8 8.5-7.2-5.2-7.3 5.2 2.8-8.5-7.2-5.2h8.9zm0 22.2 2.7 8.5h9l-7.3 5.3 2.8 8.5-7.2-5.3-7.3 5.3 2.8-8.5-7.2-5.3h8.9z"
  })));
}, CN = function(e) {
  var n = e.title, r = v(e, RC);
  return /* @__PURE__ */ i.createElement("svg", h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ i.createElement("title", null, n), /* @__PURE__ */ i.createElement("path", {
    fill: "#D80027",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#6DA544",
    d: "M512 0H0v342"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFDA44",
    d: "M307.7 0 0 194.5V342h206.9L513 148.5V0z"
  }), /* @__PURE__ */ i.createElement("path", {
    d: "M513 0H385.2L0 249.4V341l126.2 1L513 91.6z"
  }), /* @__PURE__ */ i.createElement("path", {
    d: "m141.1 187 31.2 24 32.3-22.2-13.1 37 31.1 23.9-39.2-1.1-13.2 37-11.1-37.6-39.2-1.1 32.3-22.2zM310.6 70.8l31.2 23.9 32.3-22.2-13.1 37 31.1 23.9-39.2-1.1-13.2 37-11.1-37.6-39.2-1.1 32.4-22.2z",
    fill: "#FFF"
  }));
}, MN = function(e) {
  var n = e.title, r = v(e, HC);
  return /* @__PURE__ */ i.createElement("svg", h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ i.createElement("title", null, n), /* @__PURE__ */ i.createElement("path", {
    fill: "#91DC5A",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFF",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    d: "M0 0h513v57.188H0zm0 284.1h513v57.177H0z",
    fill: "#0052B4"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#D80027",
    d: "M0 79.9h513v181.582H0z"
  }), /* @__PURE__ */ i.createElement("circle", {
    fill: "#FFF",
    cx: 190.33,
    cy: 171,
    r: 65.668
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#D80027",
    d: "m190.3 105 14.8 45.3h47.7l-38.6 28.1 14.8 45.5-38.7-28.2-38.6 28.1 14.8-45.4-38.6-28.1h47.7z"
  }));
}, SN = function(e) {
  var n = e.title, r = v(e, BC);
  return /* @__PURE__ */ i.createElement("svg", h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 900 600"
  }, r), n && /* @__PURE__ */ i.createElement("title", null, n), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFF",
    d: "M0 0h900v600H0z"
  }), /* @__PURE__ */ i.createElement("g", {
    transform: "rotate(-56.31)"
  }, /* @__PURE__ */ i.createElement("path", {
    d: "M-75 228.3H75m-150 37.5H75m-150 37.5H75m-150 475H75m-150 37.5H75m-150 37.5H75",
    stroke: "#000",
    strokeWidth: 25
  }), /* @__PURE__ */ i.createElement("path", {
    stroke: "#FFF",
    strokeWidth: 12.5,
    d: "M0 753.3v125"
  }), /* @__PURE__ */ i.createElement("circle", {
    fill: "#ca163a",
    cy: 540.8,
    r: 150
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#0e4896",
    d: "M0 390.8c-41.4 0-75 33.6-75 75s33.6 75 75 75 75 33.6 75 75-33.6 75-75 75c-82.8 0-150-67.2-150-150s67.2-150 150-150z"
  })), /* @__PURE__ */ i.createElement("path", {
    d: "m231.56 535.73-83.205-124.808M262.76 514.928l-83.205-124.807m114.407 104.006-83.205-124.808m478.43-138.675-83.205-124.807M720.39 209.843 637.184 85.036m114.407 104.006L668.386 64.234",
    stroke: "#000",
    strokeWidth: 25
  }), /* @__PURE__ */ i.createElement("path", {
    stroke: "#FFF",
    strokeWidth: 12.5,
    d: "m205.6 462.897 31.202-20.8m389.981-259.989 36.444-24.296m31.202-20.801 31.202-20.801"
  }));
}, FN = function(e) {
  var n = e.title, r = v(e, jC);
  return /* @__PURE__ */ i.createElement("svg", h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ i.createElement("title", null, n), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFF",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#6DA544",
    d: "M0 0h513v114H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#D80027",
    d: "M0 228h513v114H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    d: "M167 227.6 0 341.3V0l167 113.8z"
  }));
}, PN = function(e) {
  var n = e.title, r = v(e, VC);
  return /* @__PURE__ */ i.createElement("svg", h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ i.createElement("title", null, n), /* @__PURE__ */ i.createElement("path", {
    fill: "#0052B4",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ i.createElement("circle", {
    fill: "#6DA544",
    cx: 384,
    cy: 96.5,
    r: 29.7
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#D80027",
    d: "M332.1 89H436v44.5H332.1z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#496E2D",
    d: "M435.9 170.7z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFDA44",
    d: "M332.1 200.3V230h15.6c9.4 9.2 22.2 14.8 36.3 14.8 14.1 0 27-5.7 36.3-14.8h15.6v-29.7H332.1z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#338AF3",
    d: "M332.1 126.1v44.5c0 39.8 51.9 51.9 51.9 51.9s51.9-12.2 51.9-51.9v-44.5H332.1z"
  }), /* @__PURE__ */ i.createElement("path", {
    d: "M384 149.9c-13 0-13 11.9-26 11.9s-13-11.9-26-11.9v20.8c13 0 13 11.9 26 11.9s13-11.9 26-11.9 13 11.9 26 11.9 13-11.9 26-11.9v-20.8c-13 0-13 11.9-26 11.9s-13-11.9-26-11.9zm0-41.6c-13 0-13 11.9-26 11.9s-13-11.9-26-11.9v20.8c13 0 13 11.9 26 11.9s13-11.9 26-11.9 13 11.9 26 11.9 13-11.9 26-11.9v-20.8c-13 0-13 11.9-26 11.9s-13-11.9-26-11.9z",
    fill: "#F3F3F3"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFF",
    d: "M256 0v22.6l-46.1 30.7H256v64h-46.1L256 148v22.7h-22.6l-73.4-49v49H96v-49l-73.4 49H0V148l46.1-30.7H0v-64h46.1L0 22.6V0h22.6L96 48.9V0h64v48.9L233.4 0z"
  }), /* @__PURE__ */ i.createElement("g", {
    fill: "#D80027"
  }, /* @__PURE__ */ i.createElement("path", {
    d: "M144 0h-32v69.3H0v32h112v69.4h32v-69.4h112v-32H144z"
  }), /* @__PURE__ */ i.createElement("path", {
    d: "M0 0v15.1l57.4 38.2H80zm256 0v15.1l-57.4 38.2H176z"
  }), /* @__PURE__ */ i.createElement("path", {
    d: "M0 0v15.1l57.4 38.2H80zm256 0v15.1l-57.4 38.2H176zM0 170.7v-15.1l57.4-38.3H80zm256 0v-15.1l-57.4-38.3H176z"
  })));
}, NN = function(e) {
  var n = e.title, r = v(e, UC);
  return /* @__PURE__ */ i.createElement("svg", h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ i.createElement("title", null, n), /* @__PURE__ */ i.createElement("path", {
    fill: "#36B6CC",
    d: "M0 0h513v342H0V0z"
  }), /* @__PURE__ */ i.createElement("circle", {
    fill: "#FFD400",
    cx: 256.5,
    cy: 170.9,
    r: 68.4
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFD400",
    d: "m256.5 251.5-27.9 41.7-7.1-49.7-43.2 25.5 15.2-47.8-50 4.2 34.4-36.5-46.9-18 46.8-18-34.4-36.5 50 4.2-15.2-47.8 43.2 25.4 7.1-49.7 27.9 41.7 27.9-41.7 7.1 49.7 43.2-25.4-15.2 47.8 50-4.2-34.3 36.6 46.8 17.9-46.8 18 34.4 36.5-50-4.2 15.2 47.8-43.2-25.4-7.1 49.7c0-.1-27.9-41.8-27.9-41.8zm0-.8c44.1 0 79.9-35.8 79.9-79.9S300.6 91 256.5 91s-79.9 35.8-79.9 79.9 35.8 79.8 79.9 79.8zM22.8 28.3c0-3.2 2.4-5.7 5.7-5.7h11.3c3.2 0 5.7 2.4 5.7 5.7v11.3c.1 3.1-2.4 5.7-5.6 5.7H28.5c-3.1 0-5.7-2.5-5.7-5.6V28.3zm0 45.7c0-3.2 2.4-5.7 5.7-5.7h11.3c3.2 0 5.7 2.4 5.7 5.7v11.3c.1 3.1-2.4 5.7-5.6 5.7H28.5c-3.1 0-5.7-2.5-5.7-5.6V74zm0 45.6c0-3.2 2.4-5.7 5.7-5.7h11.3c3.2 0 5.7 2.4 5.7 5.7v11.3c.1 3.1-2.4 5.7-5.6 5.7H28.5c-3.1 0-5.7-2.5-5.7-5.6v-11.4zm0 45.6c0-3.2 2.4-5.7 5.7-5.7h11.3c3.2 0 5.7 2.4 5.7 5.7v11.3c.1 3.1-2.4 5.7-5.6 5.7H28.5c-3.1 0-5.7-2.5-5.7-5.6v-11.4zm0 45.7c0-3.2 2.4-5.7 5.7-5.7h11.3c3.2 0 5.7 2.4 5.7 5.7v11.3c.1 3.1-2.4 5.7-5.6 5.7H28.5c-3.1 0-5.7-2.5-5.7-5.6v-11.4zm0 45.6c0-3.2 2.4-5.7 5.7-5.7h11.3c3.2 0 5.7 2.4 5.7 5.7v11.3c.1 3.1-2.4 5.7-5.6 5.7H28.5c-3.1 0-5.7-2.5-5.7-5.6v-11.4zm0 45.6c0-3.2 2.4-5.7 5.7-5.7h11.3c3.2 0 5.7 2.4 5.7 5.7v11.3c.1 3.1-2.4 5.7-5.6 5.7H28.5c-3.1 0-5.7-2.5-5.7-5.6v-11.4zm22.8-22.8c0-3.2 2.4-5.7 5.7-5.7h11.3c3.2 0 5.7 2.4 5.7 5.7v11.3c.1 3.1-2.4 5.7-5.6 5.7H51.3c-3.1 0-5.7-2.5-5.7-5.6v-11.4zm0-45.6c0-3.2 2.4-5.7 5.7-5.7h11.3c3.2 0 5.7 2.4 5.7 5.7V245c.1 3.1-2.4 5.7-5.6 5.7H51.3c-3.1 0-5.7-2.5-5.7-5.6v-11.4zm0-45.7c0-3.2 2.4-5.7 5.7-5.7h11.3c3.2 0 5.7 2.4 5.7 5.7v11.3c.1 3.1-2.4 5.7-5.6 5.7H51.3c-3.1 0-5.7-2.5-5.7-5.6V188zm0-45.6c0-3.2 2.4-5.7 5.7-5.7h11.3c3.2 0 5.7 2.4 5.7 5.7v11.3c.1 3.1-2.4 5.7-5.6 5.7H51.3c-3.1 0-5.7-2.5-5.7-5.6v-11.4zm0-45.6c0-3.2 2.4-5.7 5.7-5.7h11.3c3.2 0 5.7 2.4 5.7 5.7v11.3c.1 3.1-2.4 5.7-5.6 5.7H51.3c-3.1 0-5.7-2.5-5.7-5.6V96.8zm0-45.6c0-3.2 2.4-5.7 5.7-5.7h11.3c3.2 0 5.7 2.4 5.7 5.7v11.3c.1 3.1-2.4 5.7-5.6 5.7H51.3c-3.1 0-5.7-2.5-5.7-5.6V51.2z"
  }));
}, _N = function(e) {
  var n = e.title, r = v(e, WC);
  return /* @__PURE__ */ i.createElement("svg", h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ i.createElement("title", null, n), /* @__PURE__ */ i.createElement("path", {
    fill: "#0052B4",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    d: "M0 .1h513v90.7H0zm0 251.2h513V342H0z",
    fill: "#D80027"
  }), /* @__PURE__ */ i.createElement("circle", {
    fill: "#FFF",
    cx: 256.5,
    cy: 171,
    r: 65.9
  }));
}, TN = function(e) {
  var n = e.title, r = v(e, GC);
  return /* @__PURE__ */ i.createElement("svg", h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ i.createElement("title", null, n), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFF",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    d: "M0 .2h513v90.7H0zm.5 251.1H513V342H.5z",
    fill: "#D80027"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#6DA544",
    d: "M290.3 193.5 256 130.7l-34.3 62.8h25.7v17.2h17.2v-17.2z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#14AF5A",
    d: "M241.3 213.1c4.4-4.4 4.4-11.6-.1-16l4.7 4.7c-5.2-4.7-12.2-6.6-19.1-5.3l-23.5 5.9c-6.1 1.5-6.8-.4-1.8-4.2l27.1-20.3c5.1-3.8 4.2-6.9-2.3-6.9h-11c-6.4 0-7-2.3-1.5-5.1l25.3-12.7c5.6-2.8 5.1-5.1-1.5-5.1h-11c-6.4 0-7.4-3.1-2.3-6.9l27.1-20.3c5.6-3.8 12.9-3.8 18.5 0l27.1 20.3c5.1 3.8 4.2 6.9-2.3 6.9h-11c-6.4 0-7 2.3-1.5 5.1l25.3 12.7c5.6 2.8 5.1 5.1-1.5 5.1h-11c-6.4 0-7.4 3.1-2.3 6.9l27.1 20.3c5.1 3.8 4.4 5.7-1.8 4.2l-23.5-5.9c-6.8-1.3-13.9.6-19.1 5.3l4.7-4.7c-4.4 4.4-4.5 11.5-.1 16l6.8 6.8c4.4 4.4 3.1 8-3.3 8h-45.8c-6.2 0-7.7-3.6-3.3-8 .1.1 6.9-6.8 6.9-6.8z"
  }));
}, AN = function(e) {
  var n = e.title, r = v(e, KC);
  return /* @__PURE__ */ i.createElement("svg", h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ i.createElement("title", null, n), /* @__PURE__ */ i.createElement("path", {
    fill: "#55B2FF",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#F3F3F3",
    d: "M148.5 298.1h216l-108-254.2z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#333",
    d: "m186 272.7 70.5-160.3L327 272.7z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFDA44",
    d: "M148.5 298.1h216l-108-101.7z"
  }));
}, zN = function(e) {
  var n = e.title, r = v(e, qC);
  return /* @__PURE__ */ i.createElement("svg", h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ i.createElement("title", null, n), /* @__PURE__ */ i.createElement("path", {
    fill: "#D80027",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#0052B4",
    d: "M0 0h513v171H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFDA44",
    d: "M149.3 98.1c0-14-11.3-25.3-25.3-25.3-6.5 0-12.4 2.4-16.9 6.4V64.4h8.4V47.5h-8.4v-8.4H90.3v8.4h-8.4v16.9h8.4v14.9c-4.5-4-10.4-6.4-16.9-6.4-14 0-25.3 11.3-25.3 25.3 0 7.5 3.3 14.2 8.4 18.8v14.9h84.3V117c5.3-4.7 8.5-11.5 8.5-18.9z"
  }));
}, DN = function(e) {
  var n = e.title, r = v(e, YC);
  return /* @__PURE__ */ i.createElement("svg", h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ i.createElement("title", null, n), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFDA44",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#A2001D",
    d: "M222.6 22.3h267.1v296.8H222.6z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#D80027",
    d: "M22.3 22.3h200.3v296.8H22.3z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFDA44",
    d: "M200.3 0h22.3v342h-22.3z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#6DA544",
    d: "M22.3 22.3h89v296.8h-89z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#FF9811",
    d: "M111.3 22.3h89v296.8h-89z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFDA44",
    d: "M368.2 156.8c-1.4-2 0-37.9 0-37.9.9-7.4.1-8.4 1-11.4.9-2.9 5.4-11.6 5.4-11.6s-6-2.3-10.3-.6c-4.3 1.7-24.7-7.5-31.2 3.4-4.4 7-23.6 16.2-24.6 14-1-2.2-5.9-5-6.9-2.9s-.7 13.9 0 16c.8 2.6 9.8 2 12.3 3.1 3.7 1.8 12.2 8.2 11.9 10.7-.3 2.5-22.5-6-24.2-4.5-1.4 1.2-1.9 13.2-.4 15 1.8 2.1 23.4 5.6 25 7.5 1.6 1.9-13.1 7.4-12.3 25 .7 14.7 8 17.4 8 17.4s-2.4 3.6-7.8 3.1c-6.2-.6-27.4-17.7-27.4-17.7s-3.5-109 3.6-121.4c4.9-8.5-22.7 10.1-22.7 50.8V151c0 6.6-1.4 22.4 2.6 34 0 0-.4 46.9 1.5 49.6s12.7 2.2 14.8 0 0-30 0-30c7.7.2 18.3 17.5 32.5 16.4 20.6-1.6 28.7-9.9 34.3-5 8.1 7.1 5.5 23.2.4 31.5-2.2 3.5-14.3 4.7-15.7 7.6-1.4 2.9.5 5.4.5 5.4h29.7s1.4-20.5 2.7-26.1c1.3-5.7-.6-10.7 5.9-10.4 23.5 1.1 39.8-15.3 45.5-8 3.2 4.1 5.6 29.9 3.3 33.3-2.2 3.4-13.8 2.8-15.2 6.7-1.4 4 .8 4.4.8 4.4h29.7s-.4-21.2 2.5-27.7 4.9-10.4 9.3-17.2c4.4-6.8 11.3-15.7 11.3-36.2 0-14.2-8.1-22.8-8.1-22.8H417c-14.1.2-47.4 2.3-48.8.3zm-136-124.5c10.7-10.6 20.2-2.7 22.2 2.1 1.9 4.8 2.1 8.2 2.8 13.6.9 6.9 4.9 14 4.9 14s-7.1-3.8-14.7-4.2c-4.7-.3-9-.6-13.6-2.5-5.7-2.3-11.7-12.9-1.6-23zm248.4-.1c10.7 10.6 2.8 20.2-2 22.2s-8.2 2.1-13.6 2.8c-6.9.9-14 5-14 5s3.7-7.1 4.2-14.7c.3-4.7.6-9.1 2.4-13.6 2.2-5.7 12.8-11.8 23-1.7zm.1 276.9c-10.7 10.6-20.2 2.6-22.2-2.2-1.9-4.8-2.1-8.2-2.7-13.6-.8-6.9-4.9-14.1-4.9-14.1s7 3.8 14.7 4.3c4.7.3 9 .6 13.6 2.5 5.7 2.4 11.7 13.1 1.5 23.1zm-248.2-.1c-10.6-10.7-2.7-20.2 2.1-22.2 4.8-1.9 8.2-2.1 13.6-2.8 6.9-.9 14-4.9 14-4.9s-3.8 7.1-4.2 14.7c-.3 4.7-.6 9-2.5 13.6-2.3 5.7-12.9 11.8-23 1.6z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "none",
    stroke: "#FFDA44",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    d: "M446.9 162.4s7.5-2.6 8.4-16.1c.6-8.6-19.8-16-39-11.5-19.7 4.6-34-3.1-34-14.6 0-22.9 29.7-16.2 38.9-11.3 9.1 4.9 29.7 23.5 35.1 9.4"
  }));
}, IN = function(e) {
  var n = e.title, r = v(e, ZC);
  return /* @__PURE__ */ i.createElement("svg", h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ i.createElement("title", null, n), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFF",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    d: "M0 0h513v31.1H0zm0 62.2h513v31.1H0zm0 62.3h513v31.1H0zm0 62.3h513v31.1H0zm0 62.5h513v31.1H0zm0 61.6h513V342H0z",
    fill: "#bf0a30"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#002868",
    d: "M0 0h155.6v155.6H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFF",
    d: "m77.8 30.2 10.7 32.9h34.6l-28 20.4 10.7 32.9-28-20.3-28 20.3 10.7-32.9-28-20.4h34.6z"
  }));
}, kN = function(e) {
  var n = e.title, r = v(e, XC);
  return /* @__PURE__ */ i.createElement("svg", h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ i.createElement("title", null, n), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFF",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#0052B4",
    d: "M0 0h513v114H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#6DA544",
    d: "M0 227.6h513v114H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    d: "m245.2 171 7.7-23.1c2-5.9 5.1-6 7.1 0l7.7 23.1 19.4 29.1c1.7 2.6 1.3 6.3-1.2 8 0 0-6.9 8-29.5 8s-29.5-8-29.5-8c-2.4-2-2.9-5.4-1.2-8l19.5-29.1z"
  }), /* @__PURE__ */ i.createElement("path", {
    d: "M256.5 171c-12.5 0-22.6-10.1-22.6-22.6 0-12.5 10.1-22.6 22.6-22.6s22.6 10.1 22.6 22.6c0 12.5-10.2 22.6-22.6 22.6zm0 0c6.2 0 11.3-16.3 11.3-22.6 0-6.2-5.1-11.3-11.3-11.3-6.2 0-11.3 5.1-11.3 11.3 0 6.3 5 22.6 11.3 22.6z"
  }));
}, ON = function(e) {
  var n = e.title, r = v(e, JC);
  return /* @__PURE__ */ i.createElement("svg", h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ i.createElement("title", null, n), /* @__PURE__ */ i.createElement("path", {
    fill: "#6DA544",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFDA44",
    d: "M0 0h513v114H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#D80027",
    d: "M0 228h513v114H0z"
  }));
}, LN = function(e) {
  var n = e.title, r = v(e, QC);
  return /* @__PURE__ */ i.createElement("svg", h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ i.createElement("title", null, n), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFF",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#D80027",
    d: "M0 0h513v114H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#338AF3",
    d: "M0 228h513v114H0z"
  }));
}, RN = function(e) {
  var n = e.title, r = v(e, eM);
  return /* @__PURE__ */ i.createElement("svg", h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ i.createElement("title", null, n), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFF",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    className: "prefix__st1",
    d: "M0 0h513v127.6H0zm0 214.4h513V342H0z",
    fill: "#A2001D"
  }));
}, HN = function(e) {
  var n = e.title, r = v(e, tM);
  return /* @__PURE__ */ i.createElement("svg", h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ i.createElement("title", null, n), /* @__PURE__ */ i.createElement("path", {
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#D80027",
    d: "M0 0h513v114H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#496E2D",
    d: "M0 228h513v114H0z"
  }), /* @__PURE__ */ i.createElement("g", {
    fill: "#FFF"
  }, /* @__PURE__ */ i.createElement("path", {
    d: "m281.4 150.7 9 12.3 14.5-4.7-9 12.4 9 12.3-14.5-4.7-9 12.3v-15.2l-14.5-4.7 14.5-4.7z"
  }), /* @__PURE__ */ i.createElement("path", {
    d: "M257 201.5c-17 0-30.9-13.8-30.9-30.9s13.8-30.9 30.9-30.9c5.3 0 10.3 1.3 14.7 3.7-6.9-6.7-16.2-10.8-26.6-10.8-21 0-38 17-38 38s17 38 38 38c10.3 0 19.7-4.1 26.6-10.8-4.4 2.4-9.4 3.7-14.7 3.7z"
  })));
}, BN = function(e) {
  var n = e.title, r = v(e, nM);
  return /* @__PURE__ */ i.createElement("svg", h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ i.createElement("title", null, n), /* @__PURE__ */ i.createElement("path", {
    fill: "#D80027",
    d: "M0 .3V342h513V.3z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#20661B",
    d: "M359.8 148.9h-73.3l-22.7-69.7-22.7 69.7h-73.3l59.3 43.1-22.7 69.7 59.3-43.1 59.3 43.1-22.5-69.7 59.3-43.1zm-116.1 37.7 7.7-23.6h24.8l7.7 23.6-20.1 14.6-20.1-14.6zm27.9-37.7H256l7.8-24 7.8 24zm24.3 29-4.8-14.9h25.3l-20.5 14.9zM236.6 163l-4.8 14.9-20.5-14.9h25.3zm-5.3 61.8 7.8-24 12.6 9.2-20.4 14.8zm44.5-14.9 12.6-9.2 7.8 24-20.4-14.8z"
  }));
}, jN = function(e) {
  var n = e.title, r = v(e, rM);
  return /* @__PURE__ */ i.createElement("svg", h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ i.createElement("title", null, n), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFF",
    d: "M0 85.333h512v341.333H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#c70000",
    d: "M0 85.333h512V256H0z"
  }));
}, VN = function(e) {
  var n = e.title, r = v(e, aM);
  return /* @__PURE__ */ i.createElement("svg", h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ i.createElement("title", null, n), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFDA44",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#D80027",
    d: "M342 0h171v342H342z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#0052B4",
    d: "M0 0h171v342H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#AF7F59",
    d: "M206.2 129.1h33.2L256 79.3l16.6 49.8h33.2v99.6L256 262l-49.8-33.2v-99.7zm33.2 33.3v49.8h33.2v-49.8h-33.2z"
  }));
}, UN = function(e) {
  var n = e.title, r = v(e, iM);
  return /* @__PURE__ */ i.createElement("svg", h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ i.createElement("title", null, n), /* @__PURE__ */ i.createElement("path", {
    fill: "#E6BE53",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#E01D24",
    d: "M20 20h473v302H20z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#E6BE53",
    d: "M248.5 112.9c4.4 4.4 11.6 4.4 16 0l-4.7 4.7 22.7-22.7c4.9-4.5 12.1-5.6 18.2-2.8l2.1 1c5.7 2.9 6.7 8.7 2.3 13.1l4.7-4.7-22.8 22.8c-4.5 4.9-5.6 12.1-2.8 18.2l1 2.1c2.9 5.7 5.1 15.4 5.1 21.6v-11.3c0 6.2 4.4 9.1 10.2 6.2l2.1-1c5.7-2.9 6.7-8.7 2.3-13.1l4.7 4.7c-4.4-4.4-4.4-11.6 0-16l-4.7 4.7c5.2-5.5 9.6-11.6 13.1-18.2l1-2.1c2.9-5.7 6.3-15.1 7.9-21.2l5.8-23.3c1.5-6 5.9-6.8 9.6-1.8l20.2 26.9c3.8 5.1 6.9 14 6.9 20.6v22.4c0 6.3-2.2 15.8-5.1 21.7l-1 2.1c-3.5 6.6-7.9 12.7-13.1 18.2l-6.8 6.8c-5.4 5.2-11.5 9.6-18.2 13.1l-2.1 1c-5.7 2.9-15.5 5.1-21.6 5.1-6.2 0-6.9 2.2-1.1 5.1l2.1 1c5.7 2.9 13.8 8.7 18.2 13.1l-4.7-4.7c4.4 4.4 11.6 4.4 16 0l-4.7 4.7c4.4-4.4 11.6-4.4 16 0L339 226c4.6 4.9 5.7 12.1 2.9 18.2l-1 2.1c-2.9 5.7-10.4 10.2-16.4 10.2-7.5-.3-14.8-2-21.6-5.1l-2.1-1c-6.5-3.6-11.8-8.9-15.4-15.4l-1-2.1c-2.9-5.7-8.7-6.7-13.1-2.3l4.7-4.7c-4.4 4.7-5.2 11.8-1.8 17.3l10.3 15.4c3.4 5.1 2 12.1-3.1 15.5L266 284.4c-5.7 3.4-12.8 3.4-18.6 0L232 274.1c-5.1-3.4-6.5-10.3-3.1-15.5l10.3-15.4c3.4-5.5 2.6-12.6-1.8-17.3l4.7 4.7c-4.4-4.4-10.2-3.6-13.1 2.3l-1 2.1c-2.9 5.7-9.5 12.4-15.4 15.4l-2.1 1c-5.7 2.9-15.5 5.1-21.6 5.1-6.9-.3-13.1-4.2-16.4-10.2l-1-2.1c-2.8-6.1-1.6-13.3 2.9-18.2l-4.7 4.7c4.4-4.4 11.6-4.4 16 0L181 226c4.4 4.4 11.6 4.4 16 0l-4.7 4.7c5.5-5.2 11.6-9.6 18.2-13.1l2.1-1c5.7-2.9 5-5.1-1.1-5.1-7.5-.3-14.8-2-21.6-5.1l-2.1-1c-6.6-3.5-12.7-7.9-18.2-13.1l-6.8-6.8c-5.2-5.4-9.6-11.5-13.1-18.2l-1-2.1c-3.1-6.8-4.9-14.2-5.1-21.7V121c0-6.3 3.1-15.6 6.9-20.6l20.2-26.9c3.8-5.1 8.1-4.3 9.6 1.8l5.8 23.3c2 7.3 4.6 14.4 7.9 21.2l1 2.1c2.9 5.7 8.7 13.8 13.1 18.2l-4.7-4.7c4.4 4.4 4.4 11.6 0 16l4.7-4.7c-4.4 4.4-3.6 10.2 2.3 13.1l2.1 1c5.7 2.9 10.2 0 10.2-6.2v11.3c0-6.2 2.2-15.7 5.1-21.6l1-2.1c2.8-6.1 1.7-13.2-2.8-18.2l-22.7-22.7 4.7 4.7c-4.4-4.4-3.6-10.2 2.3-13.1l2.1-1c6.1-2.8 13.2-1.7 18.2 2.8l22.7 22.7-4.8-4.5zm-18-40.7c-4.4-4.4-3.2-9.5 2.8-11.5l12.4-4.2c6-2 15.5-2 21.5 0l12.4 4.2c6 2 7.2 7.1 2.8 11.5l-6.8 6.8c-5.3 4.7-12.1 7.5-19.2 7.9-6.2 0-14.8-3.5-19.2-7.9.1 0-6.7-6.8-6.7-6.8z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#215F90",
    d: "M233.9 200.2c0 6.2 1.7 6.4 4.2.5 0 0 7.1-23.2 18.4-23.2 11.3 0 18.6 23.6 18.6 23.6 2.2 5.7 4 5.3 4-1.1v-11.2c0-18.7-10.1-33.9-22.6-33.9-12.5 0-22.6 15.2-22.6 33.9v11.4z"
  }));
}, WN = function(e) {
  var n = e.title, r = v(e, oM);
  return /* @__PURE__ */ i.createElement("svg", h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 108 72"
  }, r), n && /* @__PURE__ */ i.createElement("title", null, n), /* @__PURE__ */ i.createElement("path", {
    d: "M0 0h108v72H0z",
    fill: "#003787"
  }), /* @__PURE__ */ i.createElement("path", {
    d: "M0 0h108L60 48v24H48V48z",
    fill: "#fff"
  }), /* @__PURE__ */ i.createElement("circle", {
    cx: 54,
    cy: 30,
    r: 8,
    fill: "#f9d90f"
  }), /* @__PURE__ */ i.createElement("path", {
    d: "M44 30h20L54 48z",
    fill: "#fff"
  }), /* @__PURE__ */ i.createElement("path", {
    d: "M54 48 38 33h32z",
    fill: "#cf142b"
  }));
}, GN = function(e) {
  var n = e.title, r = v(e, lM);
  return /* @__PURE__ */ i.createElement("svg", h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ i.createElement("title", null, n), /* @__PURE__ */ i.createElement("path", {
    fill: "#6DA544",
    d: "M512 426.666V85.329H0v341.337h512z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#D80027",
    d: "M512 85.331H0v170.666h512V85.331z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFF",
    d: "M0 85.334h181.793v341.337H0z"
  }));
}, KN = function(e) {
  var n = e.title, r = v(e, sM);
  return /* @__PURE__ */ i.createElement("svg", h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ i.createElement("title", null, n), /* @__PURE__ */ i.createElement("path", {
    fill: "#1E509C",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFF",
    d: "M513 176.1V81.3L0 342l513-165.9z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#F18D36",
    d: "M513 0v81.3L0 342 513 0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFF",
    d: "m126.7 99.3-7.8-54.1-7.7 54.1-20.8-23.7 10.7 31.6-31.5-10.7 23.6 20.8-54.1 7.7 54.1 7.7-23.6 20.8 31.5-10.7-10.7 31.6 20.8-23.7 7.7 54.1 7.8-54.1 20.7 23.7-10.6-31.6 31.5 10.7-23.6-20.8 54-7.7-54-7.7 23.6-20.8-31.5 10.7 10.6-31.6z"
  }));
}, qN = function(e) {
  var n = e.title, r = v(e, cM);
  return /* @__PURE__ */ i.createElement("svg", h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ i.createElement("title", null, n), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFDA44",
    d: "M0 85.333h512V426.67H0z"
  }), /* @__PURE__ */ i.createElement("g", {
    fill: "#D80027"
  }, /* @__PURE__ */ i.createElement("path", {
    d: "M383.875 426.662 256 252.286l26.827 174.376zM133.565 85.33 256 252.286 230.314 85.33zm95.606 341.332L256 252.286 128.124 426.662zM0 85.33V212.9l256 39.386L28.333 85.33zm0 341.332h18.212L256 252.286 0 291.67zm256-174.376L512 212.9V85.33h-28.331zM281.686 85.33 256 252.286 378.434 85.33zM512 426.662V291.671l-256-39.385 237.787 174.376z"
  }), /* @__PURE__ */ i.createElement("circle", {
    cx: 256,
    cy: 252.29,
    r: 59.359
  })), /* @__PURE__ */ i.createElement("circle", {
    fill: "#FFDA44",
    cx: 256,
    cy: 252.29,
    r: 44.522
  }));
}, YN = function(e) {
  var n = e.title, r = v(e, dM);
  return /* @__PURE__ */ i.createElement("svg", h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ i.createElement("title", null, n), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFDA44",
    d: "M0 85.331h512v341.337H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#6DA544",
    d: "M0 85.331h170.663v341.337H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#D80027",
    d: "M341.337 85.331H512v341.337H341.337z"
  }));
}, ZN = function(e) {
  var n = e.title, r = v(e, uM);
  return /* @__PURE__ */ i.createElement("svg", h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ i.createElement("title", null, n), /* @__PURE__ */ i.createElement("path", {
    fill: "#6DA544",
    d: "M0 85.337h512v341.326H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFDA44",
    d: "M0 85.337h512v113.775H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#D80027",
    d: "M0 312.888h512v113.775H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFF",
    d: "M384 227.261h-97.783L256 134.265l-30.217 92.997H128l79.108 57.475-30.217 92.998L256 320.925l79.108 56.81-30.217-92.998L384 227.261z"
  }));
}, XN = function(e) {
  var n = e.title, r = v(e, fM);
  return /* @__PURE__ */ i.createElement("svg", h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ i.createElement("title", null, n), /* @__PURE__ */ i.createElement("path", {
    fill: "#095FAD",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    d: "M342 0h171v342H342zM0 0h171v342H0z",
    fill: "#BE1229"
  }), /* @__PURE__ */ i.createElement("g", {
    fill: "#FFDA44"
  }, /* @__PURE__ */ i.createElement("path", {
    d: "M108.3 166.3h14.8v74.2h-14.8zm-59.4 0h14.8v74.2H48.9z"
  }), /* @__PURE__ */ i.createElement("circle", {
    cx: 86,
    cy: 203.4,
    r: 14.8
  }), /* @__PURE__ */ i.createElement("path", {
    d: "M71.2 225.7h29.7v14.8H71.2zm0-59.4h29.7v14.8H71.2z"
  }), /* @__PURE__ */ i.createElement("circle", {
    cx: 86,
    cy: 144,
    r: 14.8
  }), /* @__PURE__ */ i.createElement("path", {
    d: "M76.3 123.9h19.5L86 108.3z"
  })));
}, JN = function(e) {
  var n = e.title, r = v(e, pM);
  return /* @__PURE__ */ i.createElement("svg", h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ i.createElement("title", null, n), /* @__PURE__ */ i.createElement("path", {
    fill: "#00745a",
    d: "M0 85.331h512v341.337H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFF",
    d: "M285.682 248.878c-4.19 0-8.166.836-11.861 2.164 2.023-4.509 3.379-9.527 3.379-14.885 0-21.201-21.201-37.101-21.201-37.101s-21.201 15.901-21.201 37.101c0 5.357 1.356 10.375 3.379 14.885-3.693-1.328-7.671-2.164-11.861-2.164-21.201 0-37.101 21.201-37.101 21.201s15.901 21.201 37.101 21.201c12.429 0 23.031-7.286 29.682-13.315 6.65 6.03 17.251 13.315 29.682 13.315 21.201 0 37.101-21.201 37.101-21.201s-15.899-21.201-37.099-21.201z"
  }), /* @__PURE__ */ i.createElement("path", {
    d: "m256 152.111 4.38 13.476h14.171l-11.464 8.332 4.376 13.476-11.463-8.33-11.463 8.33 4.376-13.476-11.464-8.332h14.171zm-53.888 23.572 8.425 7.585 9.818-5.667-4.61 10.355 8.423 7.588-11.274-1.185-4.611 10.355-2.358-11.088-11.275-1.185 9.818-5.669zm-39.45 39.449 11.09 2.358 5.668-9.818 1.186 11.274 11.089 2.358-10.357 4.61 1.186 11.274-7.587-8.423-10.357 4.61 5.669-9.818zm147.227-39.449-8.425 7.585-9.818-5.667 4.611 10.355-8.425 7.588 11.275-1.185 4.61 10.355 2.359-11.088 11.275-1.185-9.818-5.669zm39.449 39.449-11.089 2.358-5.669-9.818-1.186 11.274-11.088 2.358 10.357 4.61-1.185 11.274 7.586-8.423 10.357 4.61-5.669-9.818z",
    fill: "#FFDA44"
  }), /* @__PURE__ */ i.createElement("path", {
    d: "M256 350.642c16.84 0 32.363-5.619 44.816-15.073h-89.63c12.451 9.454 27.974 15.073 44.814 15.073zm-68.023-44.522a74.138 74.138 0 0 0 8.85 15.073h118.345a74.13 74.13 0 0 0 8.85-15.073H187.977z",
    fill: "#FFF"
  }));
}, QN = function(e) {
  var n = e.title, r = v(e, mM);
  return /* @__PURE__ */ i.createElement("svg", h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 750 500"
  }, r), n && /* @__PURE__ */ i.createElement("title", null, n), /* @__PURE__ */ i.createElement("path", {
    fill: "#0071BC",
    d: "M0 0h750v500H0V0z"
  }), /* @__PURE__ */ i.createElement("g", {
    fill: "#FFF",
    stroke: "#000",
    strokeWidth: 1.9
  }, /* @__PURE__ */ i.createElement("circle", {
    cx: 375,
    cy: 245,
    r: 225,
    fill: "#fff"
  }), /* @__PURE__ */ i.createElement("circle", {
    cx: 375,
    cy: 245,
    r: 165,
    fill: "#0071BC"
  })), /* @__PURE__ */ i.createElement("g", {
    stroke: "#000"
  }, /* @__PURE__ */ i.createElement("path", {
    fill: "#8C8A8C",
    strokeWidth: 1.9,
    d: "M444.7 450c.7 11-7.8 20-18.8 20H323.6c-11 0-19.5-9-19-20l16.7-325c.6-11 10-20 21-20h61.4c11 0 20.5 9 21.2 20l19.8 325z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFF",
    strokeWidth: 2,
    strokeLinejoin: "round",
    d: "m373 114 30 93h97l-78 56 29 92-78-56-78 57 30-93-79-57h97l30-92z"
  })));
}, e_ = function(e) {
  var n = e.title, r = v(e, hM);
  return /* @__PURE__ */ i.createElement("svg", h({
    viewBox: "0 0 900 600",
    xmlns: "http://www.w3.org/2000/svg"
  }, r), n && /* @__PURE__ */ i.createElement("title", null, n), /* @__PURE__ */ i.createElement("path", {
    fill: "#231f1e",
    d: "M0 0h900v600H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#00a650",
    d: "M0 0h900v300H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#ef1923",
    d: "m0 0 450 300L0 600z"
  }));
}, t_ = function(e) {
  var n = e.title, r = v(e, vM);
  return /* @__PURE__ */ i.createElement("svg", h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 100 513 342"
  }, r), n && /* @__PURE__ */ i.createElement("title", null, n), /* @__PURE__ */ i.createElement("path", {
    fill: "#006233",
    d: "M0 100h513v342H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#cd2a3e",
    d: "M0 100h513v46H0zm0 296h513v46H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#ffc400",
    d: "M256 298.851c-45.956 0-84.348-32.298-93.767-75.429A96.288 96.288 0 0 0 160 243.994c0 53.02 42.979 96 96 96s96-42.98 96-96c0-7.066-.785-13.942-2.233-20.572-9.419 43.131-47.811 75.429-93.767 75.429z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#ffc400",
    d: "m255.999 171.994 8.935 27.502h28.918l-23.394 16.996 8.936 27.503-23.395-16.998-23.394 16.998 8.937-27.503-23.394-16.996h28.915z"
  }));
}, n_ = function(e) {
  var n = e.title, r = v(e, gM);
  return /* @__PURE__ */ i.createElement("svg", h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ i.createElement("title", null, n), /* @__PURE__ */ i.createElement("path", {
    fill: "#1B4991",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#00A2B8",
    stroke: "#FFF",
    strokeWidth: 3,
    d: "M318.2 106.7v106.5c0 51.9 67.8 67.8 67.8 67.8s67.8-15.9 67.8-67.8V106.7H318.2z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#A35023",
    d: "M319.7 212.7c0 50.8 66.3 66.3 66.3 66.3s66.3-15.6 66.3-66.3H319.7z"
  }), /* @__PURE__ */ i.createElement("path", {
    d: "M415.1 155.1h-19.4v-19.4h-19.4v19.4H357v19.4h19.3v58.1h19.4v-58.1h19.4z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFF",
    d: "M256 0v30.6l-45.2 25.1H256V115h-59.1l59.1 32.8v22.9h-26.7l-73.5-40.9v40.9h-55.6v-48.6l-87.5 48.6H0v-30.6L45.2 115H0V55.7h59.1L0 22.8V0h26.7l73.5 40.8V0h55.6v48.6L243.3 0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#D80027",
    d: "M144 0h-32v69.3H0v32h112v69.4h32v-69.4h112v-32H144z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#0052B4",
    d: "M155.8 115 256 170.7v-15.8L184.2 115z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFF",
    d: "M155.8 115 256 170.7v-15.8L184.2 115z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#D80027",
    d: "M155.8 115 256 170.7v-15.8L184.2 115zm-84 0L0 154.9v15.8L100.2 115z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#0052B4",
    d: "M100.2 55.6 0 0v15.7l71.8 39.9z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFF",
    d: "M100.2 55.6 0 0v15.7l71.8 39.9z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#D80027",
    d: "M100.2 55.6 0 0v15.7l71.8 39.9zm84 0L256 15.7V0L155.8 55.6z"
  }));
}, r_ = function(e) {
  var n = e.title, r = v(e, yM);
  return /* @__PURE__ */ i.createElement("svg", h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ i.createElement("title", null, n), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFF",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#C31B28",
    d: "M256 0h256.5v342H256z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#ACABB1",
    stroke: "#C31B28",
    strokeWidth: 2,
    d: "M101.2 68.2V33H66v35.2H30.8v35.2H66v35.2h35.2v-35.2h35.2V68.2z"
  }));
}, a_ = function(e) {
  var n = e.title, r = v(e, bM);
  return /* @__PURE__ */ i.createElement("svg", h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ i.createElement("title", null, n), /* @__PURE__ */ i.createElement("path", {
    fill: "#f7ce00",
    d: "M0 85.331h512v341.326H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#e32737",
    d: "M0 85.331h512v85.337H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#191f6a",
    d: "M0 170.657h512v85.337H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#00a04e",
    d: "M0 341.331h512v85.337H0z"
  }));
}, i_ = function(e) {
  var n = e.title, r = v(e, EM);
  return /* @__PURE__ */ i.createElement("svg", h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ i.createElement("title", null, n), /* @__PURE__ */ i.createElement("path", {
    fill: "#d01920",
    d: "M0 85.331h512v341.333H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#017c3b",
    d: "M144.696 174.375h222.609v163.25H144.696z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFF",
    d: "M283.484 304.226c-26.637 0-48.232-21.594-48.232-48.232s21.594-48.232 48.232-48.232c8.306 0 16.12 2.1 22.943 5.797-10.703-10.467-25.341-16.927-41.494-16.927-32.784 0-59.362 26.577-59.362 59.362s26.578 59.362 59.362 59.362c16.154 0 30.791-6.461 41.494-16.927-6.822 3.698-14.636 5.797-22.943 5.797z"
  }));
}, o_ = function(e) {
  var n = e.title, r = v(e, wM);
  return /* @__PURE__ */ i.createElement("svg", h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 342"
  }, r), n && /* @__PURE__ */ i.createElement("title", null, n), /* @__PURE__ */ i.createElement("path", {
    fill: "#272727",
    d: "M0 0h512v114H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#e40112",
    d: "M0 114h512v114H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#07893f",
    d: "M0 228h512v114H0z"
  }), /* @__PURE__ */ i.createElement("circle", {
    fill: "#e40112",
    cx: 256,
    cy: 125,
    r: 95
  }));
}, l_ = function(e) {
  var n = e.title, r = v(e, $M);
  return /* @__PURE__ */ i.createElement("svg", h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ i.createElement("title", null, n), /* @__PURE__ */ i.createElement("path", {
    fill: "#dc2339",
    d: "M342 0H0v341.3h513V0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#11865d",
    d: "M0 0h171v342H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFF",
    d: "M171 0h171v342H171z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#8C9157",
    d: "M195.8 171.2c0 21.6 11.5 41.7 30.3 52.5 5.8 3.4 13.2 1.4 16.6-4.4 3.4-5.8 1.4-13.2-4.4-16.6-11.3-6.5-18.2-18.5-18.2-31.5 0-6.7-5.4-12.1-12.1-12.1-6.7 0-12.2 5.4-12.2 12.1zm93.4 51.1c17.5-11.1 28-30.4 28-51.1 0-6.7-5.4-12.1-12.1-12.1s-12.1 5.4-12.1 12.1c0 12.4-6.3 24-16.8 30.7-5.7 3.5-7.5 10.9-4.1 16.7s10.9 7.5 16.7 4.1c0-.2.2-.3.4-.4z"
  }), /* @__PURE__ */ i.createElement("ellipse", {
    fill: "#C59262",
    cx: 256.5,
    cy: 159.1,
    rx: 24.3,
    ry: 36.4
  }));
}, s_ = function(e) {
  var n = e.title, r = v(e, xM);
  return /* @__PURE__ */ i.createElement("svg", h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ i.createElement("title", null, n), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFF",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    d: "M0 0h513v24.4H0zm0 48.9h513v24.4H0zm0 48.8h513v24.4H0zm0 48.9h513V171H0zm0 48.8h513v24.4H0zm0 48.9h513v24.4H0zm0 48.8h513v24.4H0z",
    fill: "#c00"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#006",
    d: "M0 0h256.5v195.4H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    d: "M153.3 42.1C122.6 30.7 88.5 46.3 77.1 77s4.2 64.8 34.9 76.2c13.3 5 28 5 41.4 0-30.7 24.5-75.4 19.6-100-11.1s-19.6-75.4 11.1-100c26-20.7 62.9-20.7 88.8 0zm26.7 75-20.6 23.3 5.4-30.6-31-1.6 27.3-14.9L143 68l28.6 12 8.4-29.9 8.4 29.9L217 68l-18 25.4 27.3 14.9-31 1.6 5.4 30.6-20.7-23.4z",
    fill: "#fc0"
  }));
}, c_ = function(e) {
  var n = e.title, r = v(e, CM);
  return /* @__PURE__ */ i.createElement("svg", h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 513 342"
  }, r), n && /* @__PURE__ */ i.createElement("title", null, n), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFF",
    d: "M0 85.333h513v342H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#f4d900",
    d: "M0 323.333h513v104H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#006d66",
    d: "M0 85.333h513v104H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    d: "M0 204.333h513v104H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#cb0f31",
    d: "M256 256.006 0 426.668V85.331z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#f4d900",
    d: "m83.477 195.132 15.107 46.498h48.894l-39.554 28.739 15.107 46.499-39.554-28.738-39.555 28.738 15.11-46.499-39.554-28.739H68.37z"
  }));
}, d_ = function(e) {
  var n = e.title, r = v(e, MM);
  return /* @__PURE__ */ i.createElement("svg", h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ i.createElement("title", null, n), /* @__PURE__ */ i.createElement("path", {
    fill: "#496E2D",
    d: "M0 85.337h512v341.326H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#0052B4",
    d: "M0 426.663V85.337h512"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFF",
    d: "M512 152.222V85.337H411.67L0 359.778v66.885h100.33z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#A2001D",
    d: "M512 85.337v40.125L60.193 426.663H0v-40.125L451.807 85.337z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFDA44",
    d: "m187.737 189.212-22.741 10.696 12.11 22.024-24.693-4.724-3.129 24.945-17.199-18.347-17.2 18.347-3.129-24.945-24.693 4.723 12.109-22.023-22.739-10.696 22.74-10.697-12.11-22.022 24.693 4.722 3.13-24.944 17.199 18.347 17.2-18.347 3.128 24.944 24.693-4.722-12.108 22.024z"
  }));
}, u_ = function(e) {
  var n = e.title, r = v(e, SM);
  return /* @__PURE__ */ i.createElement("svg", h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 426.7"
  }, r), n && /* @__PURE__ */ i.createElement("title", null, n), /* @__PURE__ */ i.createElement("path", {
    fill: "#009543",
    d: "M0 293h640v133.7H0V293z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#ED4135",
    d: "M0 132h640v161.3H0V132z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#0035AD",
    d: "M0 0h640v133.3H0V0z"
  }), /* @__PURE__ */ i.createElement("circle", {
    fill: "#FAE600",
    stroke: "#000",
    strokeWidth: 5.3,
    cx: 240,
    cy: 213.3,
    r: 157.3
  }), /* @__PURE__ */ i.createElement("path", {
    d: "m307.9 354.5-31.8 12-36.1 4.2-37.8-2.4-35.9-15.5s28.6-29.3 40.7-33.5c8.6-3 22.4-3.7 22.4-3.7V122l-.3-66H246l-.5 67.5v191.7s15.3 1.2 22.1 4.1c11.3 4.9 40.3 35.2 40.3 35.2z"
  }), /* @__PURE__ */ i.createElement("path", {
    d: "m212.727 102.375 42.955-21.418 5.577 11.187-42.955 21.417z"
  }), /* @__PURE__ */ i.createElement("ellipse", {
    cx: 237.8,
    cy: 280.5,
    rx: 16.8,
    ry: 26.5
  }), /* @__PURE__ */ i.createElement("circle", {
    cx: 237.4,
    cy: 143.4,
    r: 20.9
  }), /* @__PURE__ */ i.createElement("ellipse", {
    cx: 238.4,
    cy: 211.1,
    rx: 19.9,
    ry: 12.1
  }), /* @__PURE__ */ i.createElement("path", {
    d: "M213.8 177h47v10h-47zm0 57h47v10h-47z"
  }));
}, f_ = function(e) {
  var n = e.title, r = v(e, FM);
  return /* @__PURE__ */ i.createElement("svg", h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ i.createElement("title", null, n), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFF",
    d: "M0 85.337h512v341.326H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#e05206",
    d: "M0 85.337h512v113.775H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#0db02b",
    d: "M0 312.888h512v113.775H0z"
  }), /* @__PURE__ */ i.createElement("circle", {
    fill: "#e05206",
    cx: 256,
    cy: 256,
    r: 32
  }));
}, p_ = function(e) {
  var n = e.title, r = v(e, PM);
  return /* @__PURE__ */ i.createElement("svg", h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.5 513 342"
  }, r), n && /* @__PURE__ */ i.createElement("title", null, n), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFF",
    d: "M0 85.5h513v342H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    d: "M0 85.5h171v342H0zm342 0h171v342H342zm-38 226.495-48-152.001-48 152.001h36v39.999h24v-39.999z",
    fill: "#007b23"
  }));
}, m_ = function(e) {
  var n = e.title, r = v(e, NM);
  return /* @__PURE__ */ i.createElement("svg", h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.5 513 342"
  }, r), n && /* @__PURE__ */ i.createElement("title", null, n), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFF",
    d: "M0 85.5h513v342H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    d: "M0 85.5h171v342H0zm342 0h171v342H342z",
    fill: "#007b23"
  }));
}, h_ = function(e) {
  var n = e.title, r = v(e, _M);
  return /* @__PURE__ */ i.createElement("svg", h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ i.createElement("title", null, n), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFF",
    d: "M0 85.337h512v341.326H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    d: "M0 85.337h512v113.775H0zm0 227.551h512v113.775H0z",
    fill: "#338AF3"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFDA44",
    d: "M256 214.447c-22.949 0-41.553 18.603-41.553 41.553S233.05 297.553 256 297.553c22.949 0 41.553-18.603 41.553-41.553S278.949 214.447 256 214.447zm0 65.298c-13.114 0-23.745-10.631-23.745-23.745s10.631-23.745 23.745-23.745 23.745 10.631 23.745 23.745-10.631 23.745-23.745 23.745z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#0052B4",
    d: "M276.563 261.936 256 256l-20.563 5.936-6.855 11.873h54.836z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#338AF3",
    d: "m256 226.32-13.709 23.744L256 256l13.709-5.936z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#6DA544",
    d: "M235.437 261.936h41.126l-6.854-11.872h-27.418z"
  }));
}, v_ = function(e) {
  var n = e.title, r = v(e, TM);
  return /* @__PURE__ */ i.createElement("svg", h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ i.createElement("title", null, n), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFF",
    d: "M0 114h513v114H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#cd1f2a",
    d: "M0 0h513v114H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#1d4185",
    d: "M0 228h513v114H0z"
  }));
}, g_ = function(e) {
  var n = e.title, r = v(e, AM);
  return /* @__PURE__ */ i.createElement("svg", h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ i.createElement("title", null, n), /* @__PURE__ */ i.createElement("path", {
    fill: "#D80027",
    d: "M0 85.334h512v341.337H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFF",
    d: "M512 295.883H202.195v130.783h-79.76V295.883H0v-79.772h122.435V85.329h79.76v130.782H512v61.218z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#2E52B2",
    d: "M512 234.666v42.663H183.652v149.337h-42.674V277.329H0v-42.663h140.978V85.329h42.674v149.337z"
  }));
}, y_ = function(e) {
  var n = e.title, r = v(e, zM);
  return /* @__PURE__ */ i.createElement("svg", h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ i.createElement("title", null, n), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFF",
    d: "M0 85.337h512v341.326H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#0052B4",
    d: "M0 426.663V85.337l280.419 174.75H87.61l183.576 166.576z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#D80027",
    d: "M244.769 249.888 10.199 103.71v312.754h234.57L61.193 249.888z"
  }), /* @__PURE__ */ i.createElement("g", {
    fill: "#FFF"
  }, /* @__PURE__ */ i.createElement("path", {
    d: "m98.003 324.433-14.589-6.863 7.77-14.13-15.844 3.03-2.008-16.005-11.035 11.772-11.036-11.772-2.008 16.005-15.843-3.031 7.77 14.131-14.591 6.863 14.591 6.862-7.77 14.13 15.844-3.029 2.007 16.004 11.036-11.772L73.332 358.4l2.008-16.004 15.843 3.03-7.769-14.13zm-9.735-132.771-10.612-4.991 5.651-10.278-11.523 2.205-1.461-11.641-8.026 8.561-8.026-8.561-1.46 11.641-11.525-2.205 5.652 10.278-10.613 4.991 25.972 5.194z"
  }), /* @__PURE__ */ i.createElement("path", {
    d: "M93.462 191.662c0 17.212-13.953 31.165-31.165 31.165s-31.165-13.953-31.165-31.165"
  })));
}, b_ = function(e) {
  var n = e.title, r = v(e, DM);
  return /* @__PURE__ */ i.createElement("svg", h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ i.createElement("title", null, n), /* @__PURE__ */ i.createElement("path", {
    fill: "#0052B4",
    d: "M0 85.337h512v341.326H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFDA44",
    d: "M0 239.994h512v32H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFF",
    d: "m174.802 341.329-19.124 8.996 10.184 18.521-20.767-3.973-2.631 20.978L128 370.422l-14.465 15.429-2.63-20.978-20.767 3.973 10.183-18.521-19.123-8.996 19.124-8.995-10.184-18.52 20.766 3.971 2.632-20.978L128 312.236l14.465-15.429 2.63 20.978 20.767-3.971-10.183 18.521z"
  }));
}, E_ = function(e) {
  var n = e.title, r = v(e, IM);
  return /* @__PURE__ */ i.createElement("svg", h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ i.createElement("title", null, n), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFDA44",
    d: "M0 85.334h512v341.337H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFF",
    d: "M0 85.334h256v170.663H0z"
  }), /* @__PURE__ */ i.createElement("g", {
    fill: "#D80027"
  }, /* @__PURE__ */ i.createElement("path", {
    d: "M144 85.33h-32v69.333H0v32h112v69.334h32v-69.334h112v-32H144z"
  }), /* @__PURE__ */ i.createElement("path", {
    d: "M0 85.329v15.083l57.377 38.251H80z"
  })), /* @__PURE__ */ i.createElement("path", {
    d: "M0 107.951v30.712h46.069zm96-22.62v48.913L22.628 85.331z",
    fill: "#2E52B2"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#D80027",
    d: "M256 85.329v15.083l-57.377 38.251H176z"
  }), /* @__PURE__ */ i.createElement("path", {
    d: "M256 107.951v30.712h-46.069zm-96-22.62v48.913l73.372-48.913z",
    fill: "#2E52B2"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#D80027",
    d: "M0 85.329v15.083l57.377 38.251H80z"
  }), /* @__PURE__ */ i.createElement("path", {
    d: "M0 107.951v30.712h46.069zm96-22.62v48.913L22.628 85.331z",
    fill: "#2E52B2"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#D80027",
    d: "M256 85.329v15.083l-57.377 38.251H176z"
  }), /* @__PURE__ */ i.createElement("path", {
    d: "M256 107.951v30.712h-46.069zm-96-22.62v48.913l73.372-48.913z",
    fill: "#2E52B2"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#D80027",
    d: "M0 255.997v-15.082l57.377-38.252H80z"
  }), /* @__PURE__ */ i.createElement("path", {
    d: "M0 233.376v-30.713h46.069zm96 22.618v-48.912l-73.372 48.912z",
    fill: "#2E52B2"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#D80027",
    d: "M256 255.997v-15.082l-57.377-38.252H176z"
  }), /* @__PURE__ */ i.createElement("g", {
    fill: "#2E52B2"
  }, /* @__PURE__ */ i.createElement("path", {
    d: "M256 233.376v-30.713h-46.069zm-96 22.618v-48.912l73.372 48.912z"
  }), /* @__PURE__ */ i.createElement("circle", {
    cx: 128,
    cy: 170.66,
    r: 22.627
  })), /* @__PURE__ */ i.createElement("path", {
    d: "m128 154.663 3.97 12.222h12.854l-10.398 7.556 3.971 12.222L128 179.109l-10.398 7.554 3.972-12.222-10.398-7.556h12.853zm0 65.14 2.364 7.278h7.653l-6.19 4.498 2.364 7.278-6.191-4.498-6.191 4.498 2.364-7.278-6.19-4.498h7.652zm0-117.334 2.364 7.278h7.653l-6.19 4.498 2.364 7.278-6.191-4.498-6.191 4.498 2.364-7.278-6.19-4.498h7.652zm69.931 58.667 2.365 7.277h7.653l-6.192 4.499 2.365 7.279-6.191-4.498-6.191 4.498 2.365-7.279-6.191-4.499h7.652zm-139.862 0 2.364 7.277h7.653l-6.191 4.499 2.364 7.279-6.19-4.498-6.191 4.498 2.365-7.279-6.192-4.499h7.653z",
    fill: "#FFDA44"
  }));
}, w_ = function(e) {
  var n = e.title, r = v(e, kM);
  return /* @__PURE__ */ i.createElement("svg", h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ i.createElement("title", null, n), /* @__PURE__ */ i.createElement("path", {
    fill: "#0052B4",
    d: "M0 85.334h512v341.337H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    d: "m425.301 233.745 3.388 10.428h10.963l-8.87 6.444 3.388 10.427-8.869-6.444-8.871 6.444 3.388-10.427-8.87-6.444h10.963zm-39.194 75.072 5.083 15.642h16.445l-13.305 9.667 5.082 15.64-13.305-9.667-13.305 9.667 5.083-15.64-13.305-9.667h16.445zm1.481-122.846 4.236 13.036h13.704l-11.088 8.054 4.235 13.034-11.087-8.056-11.088 8.056 4.235-13.034-11.087-8.054h13.704zm-37.712 47.32 5.082 15.641h16.446l-13.306 9.666 5.084 15.641-13.306-9.666-13.305 9.666 5.082-15.641-13.305-9.666h16.445z",
    fill: "#D80027"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFF",
    d: "M256.003 85.329v30.564l-45.178 25.088h45.178v59.359H196.89l59.113 32.846v22.806h-26.69l-73.484-40.826v40.826h-55.652v-48.573l-87.429 48.573H.003v-30.553l45.168-25.099H.003v-59.359h59.103L.003 108.147V85.329h26.68l73.494 40.838V85.329h55.652v48.573l87.43-48.573z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#D80027",
    d: "M144 85.33h-32v69.334H0v32h112v69.334h32v-69.334h112v-32H144z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#0052B4",
    d: "M155.826 200.344 256 255.998v-15.739l-71.847-39.915z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFF",
    d: "M155.826 200.344 256 255.998v-15.739l-71.847-39.915z"
  }), /* @__PURE__ */ i.createElement("path", {
    d: "M155.826 200.344 256 255.998v-15.739l-71.847-39.915zm-83.98 0L0 240.259v15.739l100.174-55.654z",
    fill: "#D80027"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#0052B4",
    d: "M100.174 140.983 0 85.33v15.738l71.847 39.915z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFF",
    d: "M100.174 140.983 0 85.33v15.738l71.847 39.915z"
  }), /* @__PURE__ */ i.createElement("path", {
    d: "M100.174 140.983 0 85.33v15.738l71.847 39.915zm83.98 0L256 101.068V85.33l-100.174 55.653z",
    fill: "#D80027"
  }));
}, $_ = function(e) {
  var n = e.title, r = v(e, OM);
  return /* @__PURE__ */ i.createElement("svg", h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ i.createElement("title", null, n), /* @__PURE__ */ i.createElement("path", {
    fill: "#D80027",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFF",
    d: "M138 0h377v114H138z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#4A7C3A",
    d: "M138 230h377v114H138z"
  }), /* @__PURE__ */ i.createElement("g", {
    fill: "none",
    stroke: "#FFF",
    strokeWidth: 10,
    strokeMiterlimit: 2
  }, /* @__PURE__ */ i.createElement("path", {
    d: "M40.3 35.2s37.1 48 50.8 54.5c13.7 6.5 17.1 5.7 17.1 5.7"
  }), /* @__PURE__ */ i.createElement("path", {
    d: "M100 35.2S62.9 80.6 53.3 87.6c-9.6 7-18.7 7.8-18.7 7.8m17.1-30.1h37.9M70.7 35.2v30.1"
  })));
}, x_ = function(e) {
  var n = e.title, r = v(e, LM);
  return /* @__PURE__ */ i.createElement("svg", h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ i.createElement("title", null, n), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFF",
    d: "M0 85.337h512v341.326H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#0052B4",
    d: "M256 256v170.663H0V256h256z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#D80027",
    d: "M512 85.337V256H256V85.337h256z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#0052B4",
    d: "m128 123.034 11.824 36.389h38.263l-30.955 22.491 11.823 36.389L128 195.813l-30.955 22.49 11.823-36.389-30.955-22.491h38.263z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#D80027",
    d: "m384 293.697 11.824 36.389h38.263l-30.955 22.491 11.823 36.389L384 366.476l-30.955 22.49 11.823-36.389-30.955-22.491h38.263z"
  }));
}, C_ = function(e) {
  var n = e.title, r = v(e, RM);
  return /* @__PURE__ */ i.createElement("svg", h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ i.createElement("title", null, n), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFF",
    d: "M0 85.331h512v341.326H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    d: "M0 85.331h170.663v341.337H0zm341.337 0H512v341.337H341.337z",
    fill: "#D80027"
  }));
}, M_ = function(e) {
  var n = e.title, r = v(e, HM);
  return /* @__PURE__ */ i.createElement("svg", h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ i.createElement("title", null, n), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFF",
    d: "M0 85.337h512v341.326H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    d: "M0 85.337h512v113.775H0zm0 227.551h512v113.775H0z",
    fill: "#D80027"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFDA44",
    d: "M293.991 256c0 20.982-17.01 33.243-37.992 33.243S218.008 276.982 218.008 256s17.01-37.992 37.992-37.992 37.991 17.01 37.991 37.992z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#0052B4",
    d: "M293.991 256c0 20.982-17.01 37.992-37.992 37.992s-37.992-17.01-37.992-37.992"
  }), /* @__PURE__ */ i.createElement("path", {
    d: "M232.259 246.506h9.498v19h-9.498zm37.988 0h9.498v19h-9.498zm-19-14.247h9.498v33.243h-9.498z",
    fill: "#D80027"
  }));
}, S_ = function(e) {
  var n = e.title, r = v(e, BM);
  return /* @__PURE__ */ i.createElement("svg", h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ i.createElement("title", null, n), /* @__PURE__ */ i.createElement("path", {
    d: "M0 85.333h512V426.67H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#A2001D",
    d: "M0 85.33h512v341.332"
  }), /* @__PURE__ */ i.createElement("path", {
    d: "m204.631 326.488 2.762 8.504h8.941l-7.233 5.255 2.763 8.502-7.233-5.254-7.233 5.254 2.762-8.502-7.233-5.255h8.94zm-22.834-81.622 4.605 14.172h14.901l-12.056 8.757 4.605 14.172-12.055-8.759-12.055 8.759 4.606-14.172-12.056-8.757h14.901zm0 103.883 4.604 14.173h14.902l-12.057 8.757 4.606 14.173-12.055-8.759-12.055 8.759 4.604-14.173-12.054-8.757h14.899zm43.566-66.782 4.606 14.172h14.901l-12.056 8.758 4.605 14.172-12.056-8.759-12.054 8.759 4.606-14.172-12.056-8.758h14.901zm-87.133 0 4.606 14.172h14.899l-12.054 8.758 4.603 14.172-12.054-8.759-12.055 8.759 4.605-14.172-12.055-8.758h14.9z",
    fill: "#FFF"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFDA44",
    d: "M376.526 204.163c-7.628-7.628-17.538-12.133-28.189-12.908l31.88-24.795c-12.698-12.698-29.714-18.431-46.319-17.218a44.31 44.31 0 0 0-11.396-19.511l-12.593 25.186a18.47 18.47 0 0 0-3.148-4.197c-7.245-7.245-18.991-7.244-26.234 0s-7.245 18.99 0 26.234a18.536 18.536 0 0 0 4.197 3.148l-25.186 12.593a44.303 44.303 0 0 0 19.519 11.399c-1.217 16.606 4.511 33.619 17.209 46.317L324.12 214.6a11.053 11.053 0 0 1 7.807-3.202c2.973 0 5.768 1.158 7.87 3.26a11.055 11.055 0 0 1 3.26 7.87c0 2.974-1.158 5.768-3.26 7.87l10.494 10.494c4.905-4.905 7.607-11.428 7.607-18.364 0-5.675-1.81-11.071-5.153-15.534a29.492 29.492 0 0 1 13.288 7.662c11.573 11.572 11.573 30.403 0 41.975l10.494 10.494c8.409-8.409 13.039-19.59 13.039-31.481-.001-11.892-4.632-23.072-13.04-31.481z"
  }));
}, F_ = function(e) {
  var n = e.title, r = v(e, jM);
  return /* @__PURE__ */ i.createElement("svg", h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ i.createElement("title", null, n), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFF",
    d: "M0 85.337h512v341.326H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#0052B4",
    d: "M512 85.337V256H256L0 85.337z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#D80027",
    d: "M512 256v170.663H0L256 256z"
  }), /* @__PURE__ */ i.createElement("path", {
    d: "m161.908 256-27.288-12.835 14.532-26.428-29.632 5.668-3.755-29.933-20.64 22.015-20.639-22.015-3.755 29.933-29.631-5.669 14.531 26.428L28.343 256l27.288 12.835L41.1 295.263l29.633-5.668 3.753 29.933 20.639-22.015 20.64 22.015 3.755-29.933 29.631 5.669-14.532-26.427zM21.789 117.607l9.081 12.696 14.879-4.714-9.268 12.56 9.081 12.694-14.809-4.932-9.268 12.559.117-15.608-14.809-4.934 14.88-4.712zm0 235.923 9.081 12.696 14.879-4.714-9.268 12.56 9.081 12.695-14.809-4.933-9.268 12.558.117-15.607-14.809-4.934 14.88-4.712zm188.606-117.961-9.081 12.695-14.879-4.713 9.268 12.559-9.081 12.696 14.809-4.933 9.268 12.558-.117-15.607 14.809-4.934-14.88-4.713z",
    fill: "#FFDA44"
  }));
}, P_ = function(e) {
  var n = e.title, r = v(e, VM);
  return /* @__PURE__ */ i.createElement("svg", h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ i.createElement("title", null, n), /* @__PURE__ */ i.createElement("g", {
    fill: "#FFF"
  }, /* @__PURE__ */ i.createElement("path", {
    d: "m393.508 170.516 17.512 18.875 23.363-10.821-12.541 22.487 17.513 18.876-25.263-4.978-12.539 22.488-3.073-25.564-25.263-4.978 23.363-10.82z"
  }), /* @__PURE__ */ i.createElement("path", {
    d: "M0 85.343h512v341.326H0z"
  })), /* @__PURE__ */ i.createElement("path", {
    fill: "#01411c",
    d: "M128 85.331h384v341.337H128z"
  }), /* @__PURE__ */ i.createElement("path", {
    d: "M361.909 298.793c-31.037 22.426-74.378 15.446-96.804-15.592-22.427-31.038-15.446-74.379 15.593-96.804 9.677-6.992 20.55-11.125 31.613-12.563-21.283-3.183-43.777 1.613-62.598 15.211-38.2 27.602-46.792 80.944-19.191 119.145 27.601 38.199 80.944 46.792 119.145 19.189 18.82-13.598 30.436-33.448 34.096-54.655-4.839 10.05-12.176 19.076-21.854 26.069zm-1.329-125.904 17.484 18.842 23.322-10.802-12.519 22.447 17.483 18.844-25.219-4.968-12.519 22.45-3.067-25.521-25.22-4.969 23.323-10.802z",
    fill: "#FFF"
  }));
}, N_ = function(e) {
  var n = e.title, r = v(e, UM);
  return /* @__PURE__ */ i.createElement("svg", h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ i.createElement("title", null, n), /* @__PURE__ */ i.createElement("g", {
    fill: "#FFF"
  }, /* @__PURE__ */ i.createElement("path", {
    d: "M0 85.337h512v341.326H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    d: "M0 85.337h512V256H0z"
  })), /* @__PURE__ */ i.createElement("path", {
    fill: "#D80027",
    d: "M0 256h512v170.663H0z"
  }));
}, __ = function(e) {
  var n = e.title, r = v(e, WM);
  return /* @__PURE__ */ i.createElement("svg", h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ i.createElement("title", null, n), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFF",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#00318A",
    d: "M0 0h171v342H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#D80027",
    d: "M342 0h171v342H342z"
  }));
}, T_ = function(e) {
  var n = e.title, r = v(e, GM);
  return /* @__PURE__ */ i.createElement("svg", h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ i.createElement("title", null, n), /* @__PURE__ */ i.createElement("path", {
    fill: "#0052B4",
    d: "M0 85.333h512V426.67H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#ACABB1",
    d: "M400.696 219.822 384 225.387l-16.696-5.565-5.565-13.913 5.565-13.913h33.392l-5.566 13.913z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#338AF3",
    d: "M345.043 219.822v61.217c0 29.821 38.957 38.957 38.957 38.957s38.957-9.137 38.957-38.957v-61.217h-77.914z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#6DA544",
    d: "M348.555 295.541C358.131 313.927 384 319.996 384 319.996s25.869-6.069 35.445-24.455L384 236.518l-35.445 59.023z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFDA44",
    d: "M422.957 280.421 384 219.822l-38.957 60.599v.618c0 5.518 1.337 10.328 3.512 14.503L384 240.405l35.445 55.137c2.175-4.175 3.512-8.983 3.512-14.503v-.618z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFF",
    d: "M256 85.333v30.553l-45.167 25.099H256v59.359h-59.103L256 233.179v22.817h-26.68l-73.494-40.826v40.826h-55.652v-48.573l-87.43 48.573H0v-30.554l45.167-25.098H0v-59.359h59.103L0 108.139V85.333h26.68l73.494 40.825V85.333h55.652v48.572l87.43-48.572z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#D80027",
    d: "M144 85.33h-32v69.332H0v32h112v69.334h32v-69.334h112v-32H144z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#0052B4",
    d: "M155.826 200.344 256 255.996v-15.737l-71.847-39.915z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFF",
    d: "M155.826 200.344 256 255.996v-15.737l-71.847-39.915z"
  }), /* @__PURE__ */ i.createElement("path", {
    d: "M155.826 200.344 256 255.996v-15.737l-71.847-39.915zm-83.98 0L0 240.259v15.737l100.174-55.652z",
    fill: "#D80027"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#0052B4",
    d: "M100.174 140.982 0 85.33v15.737l71.847 39.915z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFF",
    d: "M100.174 140.982 0 85.33v15.737l71.847 39.915z"
  }), /* @__PURE__ */ i.createElement("path", {
    d: "M100.174 140.982 0 85.33v15.737l71.847 39.915zm83.98 0L256 101.067V85.33l-100.174 55.652z",
    fill: "#D80027"
  }));
}, A_ = function(e) {
  var n = e.title, r = v(e, KM);
  return /* @__PURE__ */ i.createElement("svg", h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ i.createElement("title", null, n), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFF",
    d: "M0 85.337h512v341.326H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    d: "M0 85.337h512V153.6H0zm0 136.526h512v68.263H0zM0 358.4h512v68.263H0z",
    fill: "#D80027"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#0052B4",
    d: "M256 256.006 0 426.668V85.331z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFF",
    d: "m83.477 195.132 15.107 46.498h48.894l-39.554 28.739 15.107 46.499-39.554-28.738-39.555 28.738 15.11-46.499-39.554-28.739H68.37z"
  }));
}, z_ = function(e) {
  var n = e.title, r = v(e, qM);
  return /* @__PURE__ */ i.createElement("svg", h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ i.createElement("title", null, n), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFF",
    d: "M0 85.337h512v341.326H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    d: "M0 85.337h512v113.775H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#268024",
    d: "M0 312.888h512v113.775H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#e4312b",
    d: "M256 256.006 0 426.668V85.331z"
  }));
}, D_ = function(e) {
  var n = e.title, r = v(e, YM);
  return /* @__PURE__ */ i.createElement("svg", h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ i.createElement("title", null, n), /* @__PURE__ */ i.createElement("path", {
    fill: "#D80027",
    d: "M0 85.337h512v341.326H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#6DA544",
    d: "M196.641 85.337v341.326H0V85.337z"
  }), /* @__PURE__ */ i.createElement("circle", {
    fill: "#FFDA44",
    cx: 196.641,
    cy: 256,
    r: 64
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#D80027",
    d: "M160.638 224v40.001c0 19.882 16.118 36 36 36s36-16.118 36-36V224h-72z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFF",
    d: "M196.638 276c-6.617 0-12-5.383-12-12v-16h24.001v16c-.001 6.616-5.385 12-12.001 12z"
  }));
}, I_ = function(e) {
  var n = e.title, r = v(e, ZM);
  return /* @__PURE__ */ i.createElement("svg", h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ i.createElement("title", null, n), /* @__PURE__ */ i.createElement("path", {
    fill: "#338AF3",
    d: "M0 85.331h512v341.337H0z"
  }), /* @__PURE__ */ i.createElement("circle", {
    fill: "#FFDA44",
    cx: 218.902,
    cy: 255.994,
    r: 74.207
  }));
}, k_ = function(e) {
  var n = e.title, r = v(e, XM);
  return /* @__PURE__ */ i.createElement("svg", h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ i.createElement("title", null, n), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFF",
    d: "M0 85.337h512v341.326H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#D80027",
    d: "M0 85.337h512v113.775H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#0052B4",
    d: "M0 312.888h512v113.775H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#6DA544",
    d: "m289.579 216.738-12.592 12.592c5.37 5.372 8.693 12.792 8.693 20.988 0 16.392-13.289 29.68-29.68 29.68-16.392 0-29.68-13.289-29.68-29.68 0-8.195 3.322-15.616 8.693-20.988l-12.592-12.592c-8.594 8.594-13.91 20.466-13.91 33.579 0 26.228 21.261 47.489 47.489 47.489s47.489-21.261 47.489-47.489c0-13.112-5.316-24.985-13.91-33.579z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFDA44",
    d: "m256 232.51 4.421 13.605h14.304l-11.573 8.408 4.421 13.604L256 259.719l-11.573 8.408 4.421-13.604-11.573-8.408h14.304z"
  }));
}, O_ = function(e) {
  var n = e.title, r = v(e, JM);
  return /* @__PURE__ */ i.createElement("svg", h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ i.createElement("title", null, n), /* @__PURE__ */ i.createElement("path", {
    fill: "#751A46",
    d: "M0 0h512v342H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFF",
    d: "M0 0v342h150.3l37.7-19.6-37.7-18.9 37.7-19-37.7-18.9 37.7-19-37.7-19 37.7-18.9-37.7-19 37.7-19-37.7-18.9 37.7-19-37.7-18.9 37.7-19-37.7-19L188 57l-37.7-19L188 19.1 150.3 0z"
  }));
}, L_ = function(e) {
  var n = e.title, r = v(e, QM);
  return /* @__PURE__ */ i.createElement("svg", h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ i.createElement("title", null, n), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFF",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#00318A",
    d: "M0 0h171v342H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#D80027",
    d: "M342 0h171v342H342z"
  }));
}, R_ = function(e) {
  var n = e.title, r = v(e, eS);
  return /* @__PURE__ */ i.createElement("svg", h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ i.createElement("title", null, n), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFDA44",
    d: "M0 85.331h512v341.326H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#0052B4",
    d: "M0 85.331h170.663v341.337H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#D80027",
    d: "M341.337 85.331H512v341.337H341.337z"
  }));
}, H_ = function(e) {
  var n = e.title, r = v(e, tS);
  return /* @__PURE__ */ i.createElement("svg", h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ i.createElement("title", null, n), /* @__PURE__ */ i.createElement("path", {
    fill: "#0052B4",
    d: "M0 85.331h512v341.337H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#D80027",
    d: "M0 85.331h512v113.775H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFF",
    d: "M0 312.882h512v113.775H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#D80027",
    d: "M129.468 181.793v85.136c0 48.429 63.267 63.267 63.267 63.267S256 315.356 256 266.929v-85.136H129.468z"
  }), /* @__PURE__ */ i.createElement("path", {
    d: "M155.634 196.634h74.201v-29.681l-14.841 7.42-22.261-22.26-22.259 22.26-14.84-7.42zm85.526 82.148-48.231-48.231-48.231 48.231 15.741 15.74 32.49-32.49 32.49 32.49z",
    fill: "#FFDA44"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFF",
    d: "M241.16 233.734h-22.504a14.74 14.74 0 0 0 2.001-7.418c0-8.196-6.645-14.84-14.84-14.84-5.663 0-10.581 3.172-13.083 7.836-2.502-4.663-7.421-7.836-13.083-7.836-8.195 0-14.84 6.644-14.84 14.84 0 2.706.736 5.235 2.001 7.418h-22.114c0 8.196 7.139 14.84 15.334 14.84h-.494c0 8.196 6.644 14.84 14.84 14.84 0 7.257 5.211 13.286 12.094 14.576l-11.694 26.401a48.075 48.075 0 0 0 18.149 3.544 48.079 48.079 0 0 0 18.149-3.544l-11.694-26.401c6.883-1.29 12.094-7.319 12.094-14.576 8.196 0 14.84-6.644 14.84-14.84h-.494c8.199 0 15.338-6.644 15.338-14.84z"
  }));
}, B_ = function(e) {
  var n = e.title, r = v(e, nS);
  return /* @__PURE__ */ i.createElement("svg", h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ i.createElement("title", null, n), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFF",
    d: "M0 85.33v341.332h512V85.33z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#0052B4",
    d: "M0 85.333h512V426.67H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFF",
    d: "M0 85.333h512v113.775H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#D80027",
    d: "M0 312.884h512v113.775H0z"
  }));
}, j_ = function(e) {
  var n = e.title, r = v(e, rS);
  return /* @__PURE__ */ i.createElement("svg", h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ i.createElement("title", null, n), /* @__PURE__ */ i.createElement("path", {
    fill: "#338AF3",
    d: "M0 85.331h512v341.337H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFDA44",
    d: "M0 255.994h512v81.619H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#496E2D",
    d: "M0 337.614h512v89.043H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFDA44",
    d: "m278.261 185.209 20.844 9.804-11.099 20.186 22.632-4.33 2.868 22.865 15.765-16.816 15.766 16.816 2.867-22.865 22.633 4.33-11.099-20.186 20.843-9.804-20.844-9.805 11.1-20.185-22.633 4.329-2.868-22.864-15.765 16.816-15.766-16.816-2.867 22.864-22.634-4.329 11.1 20.187z"
  }));
}, V_ = function(e) {
  var n = e.title, r = v(e, aS);
  return /* @__PURE__ */ i.createElement("svg", h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ i.createElement("title", null, n), /* @__PURE__ */ i.createElement("path", {
    fill: "#055e1c",
    d: "M0 85.333h512v341.333H0z"
  }), /* @__PURE__ */ i.createElement("g", {
    fill: "#FFF"
  }, /* @__PURE__ */ i.createElement("path", {
    d: "M183.548 289.386c0 12.295 9.731 22.261 21.736 22.261h65.208c0 10.244 8.11 18.551 18.114 18.551h21.736c10.004 0 18.114-8.306 18.114-18.551v-22.261H183.548zm146.716-107.595v51.942c0 8.183-6.5 14.84-14.491 14.84v22.261c19.976 0 36.226-16.643 36.226-37.101v-51.942h-21.735zm-155.773 51.943c0 8.183-6.5 14.84-14.491 14.84v22.261c19.976 0 36.226-16.643 36.226-37.101v-51.942H174.49v51.942z"
  }), /* @__PURE__ */ i.createElement("path", {
    d: "M297.661 181.788h21.736v51.942h-21.736zm-32.604 29.685c0 2.046-1.625 3.71-3.623 3.71-1.998 0-3.623-1.664-3.623-3.71v-29.682h-21.736v29.682c0 2.046-1.625 3.71-3.623 3.71s-3.623-1.664-3.623-3.71v-29.682h-21.736v29.682c0 14.32 11.376 25.971 25.358 25.971 5.385 0 10.38-1.733 14.491-4.677 4.11 2.944 9.106 4.677 14.491 4.677 1.084 0 2.15-.078 3.2-.215-1.54 6.499-7.255 11.345-14.068 11.345v22.261c19.976 0 36.226-16.643 36.226-37.101v-51.943h-21.736l.002 29.682z"
  }), /* @__PURE__ */ i.createElement("path", {
    d: "M207.093 248.57h32.601v22.261h-32.601z"
  })));
}, U_ = function(e) {
  var n = e.title, r = v(e, iS);
  return /* @__PURE__ */ i.createElement("svg", h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ i.createElement("title", null, n), /* @__PURE__ */ i.createElement("path", {
    fill: "#496E2D",
    d: "M0 85.334h512v341.337H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#0052B4",
    d: "M0 426.663V85.329h512"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFDA44",
    d: "M0 396.494v30.169h45.255L512 115.499v-30.17h-45.255z"
  }), /* @__PURE__ */ i.createElement("path", {
    d: "m85.688 108.787 5.12 15.756h16.566l-13.403 9.737 5.12 15.757-13.403-9.738-13.405 9.738 5.12-15.757L64 124.543h16.567zm84.624 0 5.121 15.756H192l-13.403 9.737 5.12 15.757-13.405-9.738-13.403 9.738 5.12-15.757-13.403-9.737h16.566zm-84.624 82.502 5.12 15.756h16.566l-13.403 9.738 5.12 15.757-13.403-9.739-13.405 9.739 5.12-15.757L64 207.045h16.567zm84.624 0 5.121 15.756H192l-13.403 9.738 5.12 15.757-13.405-9.739-13.403 9.739 5.12-15.757-13.403-9.738h16.566zM128 150.037l5.12 15.756h16.568l-13.405 9.738 5.12 15.758L128 181.55l-13.403 9.739 5.12-15.758-13.405-9.738h16.568z",
    fill: "#FFF"
  }));
}, W_ = function(e) {
  var n = e.title, r = v(e, oS);
  return /* @__PURE__ */ i.createElement("svg", h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ i.createElement("title", null, n), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFF",
    d: "M0 85.337h512v341.326H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFDA44",
    d: "M235.454 85.337 0 426.663 427.345 85.337z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#6DA544",
    d: "M512 329.393 0 426.663h512z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#D80027",
    d: "M512 85.337h-84.655L0 426.663l512-204.512z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#0052B4",
    d: "M0 85.337v341.326L235.454 85.337z"
  }));
}, G_ = function(e) {
  var n = e.title, r = v(e, lS);
  return /* @__PURE__ */ i.createElement("svg", h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ i.createElement("title", null, n), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFF",
    d: "M0 85.337h512v341.326H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#D80027",
    d: "M0 85.337h512v113.775H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    d: "M0 312.888h512v113.775H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#496E2D",
    d: "M0 426.668V85.331l256 170.675z"
  }));
}, K_ = function(e) {
  var n = e.title, r = v(e, sS);
  return /* @__PURE__ */ i.createElement("svg", h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ i.createElement("title", null, n), /* @__PURE__ */ i.createElement("path", {
    fill: "#0052B4",
    d: "M0 85.333h512V426.67H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFDA44",
    d: "M192 85.33h-64v138.666H0v64h128v138.666h64V287.996h320v-64H192z"
  }));
}, q_ = function(e) {
  var n = e.title, r = v(e, cS);
  return /* @__PURE__ */ i.createElement("svg", h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ i.createElement("title", null, n), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFF",
    d: "M0 85.337h512v341.326H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#D80027",
    d: "M0 85.337h512V256H0z"
  }), /* @__PURE__ */ i.createElement("g", {
    fill: "#FFF"
  }, /* @__PURE__ */ i.createElement("path", {
    d: "M83.478 170.666c0-24.865 17.476-45.637 40.812-50.734a52.059 52.059 0 0 0-11.13-1.208c-28.688 0-51.942 23.254-51.942 51.941s23.255 51.942 51.942 51.942c3.822 0 7.543-.425 11.13-1.208-23.336-5.095-40.812-25.867-40.812-50.733zm66.783-48.231 3.684 11.337h11.921l-9.645 7.007 3.684 11.337-9.644-7.006-9.645 7.006 3.685-11.337-9.645-7.007h11.921z"
  }), /* @__PURE__ */ i.createElement("path", {
    d: "m121.344 144.696 3.683 11.337h11.921l-9.645 7.007 3.684 11.337-9.643-7.006-9.645 7.006 3.685-11.337-9.645-7.007h11.921zm57.834 0 3.684 11.337h11.921l-9.645 7.007 3.684 11.337-9.644-7.006-9.644 7.006 3.685-11.337-9.645-7.007h11.921zm-11.131 33.391 3.684 11.337h11.921l-9.644 7.007 3.684 11.337-9.645-7.006-9.643 7.006 3.684-11.337-9.644-7.007h11.92zm-35.573 0 3.683 11.337h11.921l-9.644 7.007 3.684 11.337-9.644-7.006-9.644 7.006 3.684-11.337-9.644-7.007h11.92z"
  })));
}, Y_ = function(e) {
  var n = e.title, r = v(e, dS);
  return /* @__PURE__ */ i.createElement("svg", h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 341.3"
  }, r), n && /* @__PURE__ */ i.createElement("title", null, n), /* @__PURE__ */ i.createElement("path", {
    fill: "#0052B4",
    d: "M0 0h512v341.3H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFF",
    d: "M256 0v117.4h-46.1l46.1 30.7v22.6h-22.6L160 121.8v48.9H96v-48.9l-73.4 48.9H0v-22.6l46.1-30.7H0v-64h46.1L0 22.7V0h22.6L96 48.9V0h64v48.9L233.4 0z"
  }), /* @__PURE__ */ i.createElement("g", {
    fill: "#D80027"
  }, /* @__PURE__ */ i.createElement("path", {
    d: "M144 0h-32v69.4H0v32h112v69.3h32v-69.3h112v-32H144z"
  }), /* @__PURE__ */ i.createElement("path", {
    d: "M0 0v15.1l57.4 38.3H80zm256 0v15.1l-57.4 38.3H176z"
  })), /* @__PURE__ */ i.createElement("path", {
    fill: "#2E52B2",
    d: "M256 22.7v30.7h-46.1z"
  }), /* @__PURE__ */ i.createElement("path", {
    d: "M0 0v15.1l57.4 38.3H80zm256 0v15.1l-57.4 38.3H176z",
    fill: "#D80027"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#2E52B2",
    d: "M256 22.7v30.7h-46.1z"
  }), /* @__PURE__ */ i.createElement("path", {
    d: "M0 170.7v-15.1l57.4-38.2H80zm256 0v-15.1l-57.4-38.2H176z",
    fill: "#D80027"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#29DBFF",
    d: "M449 139.7c-.1 44.4-7.2 92.1-65 114.9-57.8-22.8-64.9-70.5-65-114.9h130z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#ffda44",
    d: "M449 139.7c0-16.7-.9-32.9-.5-47.1C426.9 83 398.4 81 383.9 81s-42.9 2-64.6 11.6c.4 14.2-.5 30.4-.5 47.1H449z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#BF521B",
    d: "m369.5 204.5.3 10.3-12.8.2 4.9 13.2h-17.3c-18-20.2-23.4-42.4-24.9-68.1l9.1-9.7 8.3 14.3 10.8-12.8 7 7.8.8 15.7 13.8 29.1z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#474747",
    d: "m436.6 192.5-8.6 18.3h-47l-29.2-19.5 25.7 10.5h25.1l3.7-6.5 7.2.2 2-3z"
  }));
}, Z_ = function(e) {
  var n = e.title, r = v(e, uS);
  return /* @__PURE__ */ i.createElement("svg", h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ i.createElement("title", null, n), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFF",
    d: "M0 85.337h512v341.326H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#0052B4",
    d: "M0 199.112h512v113.775H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#D80027",
    d: "M0 312.888h512v113.775H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFF",
    d: "M233.606 196.639v14.837c0 34.081-44.522 44.522-44.522 44.522s-44.522-10.44-44.522-44.522v-14.837l-.145-44.188 89.043-.266.146 44.454z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#0052B4",
    d: "M233.606 196.639v14.837c0 34.081-44.522 44.522-44.522 44.522s-44.522-10.44-44.522-44.522v-14.837l-.145-44.188 89.043-.266.146 44.454z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFF",
    d: "M233.606 196.639v14.837c0 34.081-44.522 44.522-44.522 44.522s-44.522-10.44-44.522-44.522v-14.837l14.848 14.837 29.674-22.261 29.685 22.261 14.837-14.837z"
  }));
}, X_ = function(e) {
  var n = e.title, r = v(e, fS);
  return /* @__PURE__ */ i.createElement("svg", h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ i.createElement("title", null, n), /* @__PURE__ */ i.createElement("path", {
    fill: "#D80027",
    d: "M0 85.334h512v341.337H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFF",
    d: "M512 295.883H202.195v130.783h-79.76V295.883H0v-79.772h122.435V85.329h79.76v130.782H512v61.218z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#2E52B2",
    d: "M512 234.666v42.663H183.652v149.337h-42.674V277.329H0v-42.663h140.978V85.329h42.674v149.337z"
  }));
}, J_ = function(e) {
  var n = e.title, r = v(e, pS);
  return /* @__PURE__ */ i.createElement("svg", h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ i.createElement("title", null, n), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFF",
    d: "M0 85.337h512v341.326H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#0052B4",
    d: "M0 196.641h512v118.717H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#D80027",
    d: "M0 315.359h512v111.304H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFF",
    d: "M129.468 181.799v85.136c0 48.429 63.267 63.267 63.267 63.267S256 315.362 256 266.935v-85.136H129.468z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#D80027",
    d: "M146.126 184.294v81.941c0 5.472 1.215 10.64 3.623 15.485h85.97c2.408-4.844 3.623-10.012 3.623-15.485v-81.941h-93.216z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFF",
    d: "M221.301 241.427h-21.425v-14.283h14.284v-14.283h-14.284v-14.284h-14.283v14.284h-14.282v14.283h14.282v14.283h-21.426v14.284h21.426v14.283h14.283v-14.283h21.425z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#0052B4",
    d: "M169.232 301.658c9.204 5.783 18.66 9.143 23.502 10.636 4.842-1.494 14.298-4.852 23.502-10.636 9.282-5.833 15.79-12.506 19.484-19.939a24.878 24.878 0 0 0-14.418-4.583c-1.956 0-3.856.232-5.682.657-3.871-8.796-12.658-14.94-22.884-14.94-10.227 0-19.013 6.144-22.884 14.94a25.048 25.048 0 0 0-5.682-.657 24.88 24.88 0 0 0-14.418 4.583c3.691 7.433 10.198 14.106 19.48 19.939z"
  }));
}, Q_ = function(e) {
  var n = e.title, r = v(e, mS);
  return /* @__PURE__ */ i.createElement("svg", h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ i.createElement("title", null, n), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFF",
    d: "M0 85.337h512v341.326H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#6DA544",
    d: "M0 85.337h512v113.775H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#338AF3",
    d: "M0 312.888h512v113.775H0z"
  }));
}, eT = function(e) {
  var n = e.title, r = v(e, hS);
  return /* @__PURE__ */ i.createElement("svg", h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ i.createElement("title", null, n), /* @__PURE__ */ i.createElement("path", {
    fill: "#338AF3",
    d: "M0 85.34h512v341.326H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFF",
    d: "M512 85.334v166.69L0 256.175V85.334z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#6DA544",
    d: "M323.744 203.099 256 270.843l-67.744-67.744a81.156 81.156 0 0 0-13.879 45.483v22.261c0 35.744 23.097 66.193 55.148 77.213-4.277 8.385-3.556 18.848 2.712 26.671l24.258-19.439 24.258 19.439c6.342-7.915 7.011-18.534 2.564-26.968 31.614-11.261 54.308-41.485 54.308-76.916v-22.261a81.174 81.174 0 0 0-13.881-45.483z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFDA44",
    d: "M256 330.206c-32.732 0-59.362-26.63-59.362-59.362v-22.261c0-32.733 26.63-59.363 59.362-59.363s59.362 26.63 59.362 59.362v22.261c0 32.733-26.63 59.363-59.362 59.363z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#338AF3",
    d: "M293.101 270.843v-22.261c0-20.458-16.643-37.101-37.101-37.101s-37.101 16.643-37.101 37.101v22.261L256 278.264l37.101-7.421z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#6DA544",
    d: "M218.899 270.843c0 20.458 16.643 37.101 37.101 37.101s37.101-16.643 37.101-37.101h-74.202z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFDA44",
    d: "M300.522 189.22c0-12.295-9.966-22.261-22.261-22.261a22.173 22.173 0 0 0-14.84 5.672v-13.093h7.421v-14.84h-7.421v-7.421h-14.84v7.421h-7.421v14.84h7.421v13.093a22.177 22.177 0 0 0-14.841-5.672c-12.295 0-22.261 9.966-22.261 22.261 0 6.591 2.867 12.512 7.421 16.589v13.093h74.203v-13.093c4.552-4.077 7.419-9.997 7.419-16.589z"
  }));
}, tT = function(e) {
  var n = e.title, r = v(e, vS);
  return /* @__PURE__ */ i.createElement("svg", h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ i.createElement("title", null, n), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFDA44",
    d: "M0 85.331h512v341.326H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#D80027",
    d: "M330.207 85.331H512v341.337H330.207z"
  }), /* @__PURE__ */ i.createElement("path", {
    d: "M0 85.331h181.793v341.337H0zm255.999 111.301 14.733 45.347h47.685l-38.576 28.029 14.734 45.348-38.576-28.026-38.577 28.026 14.737-45.348-38.576-28.029h47.681z",
    fill: "#496E2D"
  }));
}, nT = function(e) {
  var n = e.title, r = v(e, gS);
  return /* @__PURE__ */ i.createElement("svg", h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ i.createElement("title", null, n), /* @__PURE__ */ i.createElement("path", {
    fill: "#338AF3",
    d: "M0 85.331h512v341.337H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFF",
    d: "m256 157.273 22.663 69.748H352l-59.332 43.106 22.664 69.749L256 296.769l-59.332 43.107 22.664-69.749L160 227.021h73.337z"
  }));
}, rT = function(e) {
  var n = e.title, r = v(e, yS);
  return /* @__PURE__ */ i.createElement("svg", h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ i.createElement("title", null, n), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFF",
    d: "M0 85.331h512v341.337H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#A2001D",
    d: "M0 196.636h512v118.728H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    d: "M0 352.462h512v74.207H0zM0 85.331h512v74.207H0z",
    fill: "#6DA544"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFDA44",
    d: "m256.742 218.003 9.43 29.021h30.518L272 264.963l9.431 29.023-24.689-17.937-24.689 17.937 9.431-29.023-24.69-17.939h30.518z"
  }));
}, aT = function(e) {
  var n = e.title, r = v(e, bS);
  return /* @__PURE__ */ i.createElement("svg", h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ i.createElement("title", null, n), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFF",
    d: "M0 85.337h512v341.326H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#496E2D",
    d: "M0 322.783h512v103.88H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    d: "M0 85.337h512v104.515H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#A2001D",
    d: "M0 210.877h512v89.656H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#0052B4",
    d: "M256 256.006 0 426.668V85.331z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFDA44",
    d: "m73.178 209.188 20.831 29.067 34.084-10.83-21.207 28.795 20.83 29.069-33.939-11.271-21.208 28.794.234-35.762-33.94-11.273 34.083-10.83z"
  }));
}, iT = function(e) {
  var n = e.title, r = v(e, ES);
  return /* @__PURE__ */ i.createElement("svg", h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ i.createElement("title", null, n), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFDA44",
    d: "M0 85.337h512v341.326H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    d: "M0 85.337h512v113.775H0zm0 227.551h512v113.775H0z",
    fill: "#6DA544"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#D80027",
    d: "M256 256.006 0 426.668V85.331z"
  }), /* @__PURE__ */ i.createElement("path", {
    d: "m302.049 226.318 7.368 22.674h23.842l-19.288 14.016 7.366 22.674-19.288-14.015-19.287 14.015 7.366-22.674-19.288-14.016h23.842zm74.203 0 7.367 22.674h23.842l-19.288 14.016 7.367 22.674-19.288-14.015-19.288 14.015 7.367-22.674-19.288-14.016h23.842z"
  }));
}, oT = function(e) {
  var n = e.title, r = v(e, wS);
  return /* @__PURE__ */ i.createElement("svg", h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ i.createElement("title", null, n), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFF",
    d: "M0 85.337h512v341.326H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    d: "M0 85.337h512v113.775H0zm0 227.551h512v113.775H0z",
    fill: "#0052B4"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFDA44",
    d: "M228.582 261.936 256 214.447l27.418 47.489z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#6DA544",
    d: "M291.616 277.616 256 295.425l-35.616-17.809v-23.744h71.232z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFDA44",
    d: "m289.579 216.485-12.592 12.592c5.37 5.372 8.693 12.791 8.693 20.988 0 16.392-13.289 29.68-29.68 29.68-16.392 0-29.68-13.289-29.68-29.68 0-8.195 3.322-15.616 8.693-20.988l-12.592-12.592c-8.594 8.594-13.91 20.466-13.91 33.579 0 26.228 21.261 47.489 47.489 47.489s47.489-21.261 47.489-47.489c0-13.114-5.316-24.987-13.91-33.579z"
  }));
}, lT = function(e) {
  var n = e.title, r = v(e, $S);
  return /* @__PURE__ */ i.createElement("svg", h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ i.createElement("title", null, n), /* @__PURE__ */ i.createElement("path", {
    fill: "#0052B4",
    d: "M0 85.337h512v341.326H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#D80027",
    d: "M512 85.331v166.69L0 256.173V85.331z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFF",
    d: "M256 256.006 0 426.668V85.331z"
  }), /* @__PURE__ */ i.createElement("g", {
    fill: "#FFDA44"
  }, /* @__PURE__ */ i.createElement("path", {
    d: "M59.621 256a59.546 59.546 0 0 0-.193 4.57c0 32.821 26.607 59.429 59.429 59.429s59.429-26.607 59.429-59.429c0-1.539-.078-3.061-.193-4.57H59.621z"
  }), /* @__PURE__ */ i.createElement("circle", {
    cx: 118.862,
    cy: 210.287,
    r: 18.286
  })), /* @__PURE__ */ i.createElement("path", {
    fill: "#D80027",
    d: "M77.715 205.714v59.429c0 31.494 41.144 41.143 41.144 41.143s41.144-9.649 41.144-41.143v-59.429H77.715z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#338AF3",
    d: "M118.877 287.148c-7.632-2.746-22.876-9.767-22.876-22.006v-41.144h45.715v41.144c-.001 12.28-15.244 19.283-22.839 22.006z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#F3F3F3",
    d: "M128.001 246.856v-9.142l-9.144-4.571-9.142 4.571v9.142l-4.571 4.573v18.285h27.428v-18.285z"
  }));
}, sT = function(e) {
  var n = e.title, r = v(e, xS);
  return /* @__PURE__ */ i.createElement("svg", h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 900 600"
  }, r), n && /* @__PURE__ */ i.createElement("title", null, n), /* @__PURE__ */ i.createElement("path", {
    d: "M0 0h900v600H0z",
    fill: "#0f0f0f"
  }), /* @__PURE__ */ i.createElement("path", {
    d: "M0 0h900v400H0z",
    fill: "#fff"
  }), /* @__PURE__ */ i.createElement("path", {
    d: "M0 0h900v200H0z",
    fill: "#047a3f"
  }), /* @__PURE__ */ i.createElement("path", {
    d: "m176.26 375 48.738-150 48.738 150-127.6-92.705h157.72M626.256 375l48.738-150 48.738 150-127.6-92.705h157.72M401.252 375l48.738-150 48.738 150-127.6-92.705h157.72",
    fill: "#ce1126"
  }));
}, cT = function(e) {
  var n = e.title, r = v(e, CS);
  return /* @__PURE__ */ i.createElement("svg", h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 900 600"
  }, r), n && /* @__PURE__ */ i.createElement("title", null, n), /* @__PURE__ */ i.createElement("path", {
    fill: "#2B5DEA",
    d: "M0 0h900v600H0V0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFDF29",
    d: "M0 100h900v400H0V100z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#D70000",
    d: "M0 150h900v300H0V150z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFF",
    d: "M450 171.4v257.2c114.3 0 171.4-85.7 214.3-128.6-42.9-42.9-100-128.6-214.3-128.6z"
  }), /* @__PURE__ */ i.createElement("path", {
    d: "M450 171.4c-100 0-171.4 85.7-214.3 128.6C278.6 342.9 350 428.6 450 428.6V171.4z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFF",
    d: "M346.3 254.3h21v91.3h-21zm51.9 0h21v91.3h-21z"
  }), /* @__PURE__ */ i.createElement("path", {
    d: "M477.8 254.3h21v91.3h-21zm51.9 0h21v91.3h-21z"
  }));
}, dT = function(e) {
  var n = e.title, r = v(e, MS);
  return /* @__PURE__ */ i.createElement("svg", h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 341.3"
  }, r), n && /* @__PURE__ */ i.createElement("title", null, n), /* @__PURE__ */ i.createElement("path", {
    fill: "#0052B4",
    d: "M0 0h512v341.3H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFF",
    d: "M256 0v117.4h-46.1l46.1 30.7v22.6h-22.6L160 121.8v48.9H96v-48.9l-73.4 48.9H0v-22.6l46.1-30.7H0v-64h46.1L0 22.7V0h22.6L96 48.9V0h64v48.9L233.4 0z"
  }), /* @__PURE__ */ i.createElement("g", {
    fill: "#D80027"
  }, /* @__PURE__ */ i.createElement("path", {
    d: "M144 0h-32v69.4H0v32h112v69.3h32v-69.3h112v-32H144z"
  }), /* @__PURE__ */ i.createElement("path", {
    d: "M0 0v15.1l57.4 38.3H80zm256 0v15.1l-57.4 38.3H176z"
  })), /* @__PURE__ */ i.createElement("path", {
    fill: "#2E52B2",
    d: "M256 22.7v30.7h-46.1z"
  }), /* @__PURE__ */ i.createElement("path", {
    d: "M0 0v15.1l57.4 38.3H80zm256 0v15.1l-57.4 38.3H176z",
    fill: "#D80027"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#2E52B2",
    d: "M256 22.7v30.7h-46.1z"
  }), /* @__PURE__ */ i.createElement("path", {
    d: "M0 170.7v-15.1l57.4-38.2H80zm256 0v-15.1l-57.4-38.2H176z",
    fill: "#D80027"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#29DBFF",
    d: "M448.9 169.5c0 9.6-.3 29.6-1.4 39.2-4.1 34.9-23.5 68.8-62.1 85.9-45.3-17.9-60.8-51-64.9-85.9-1.1-9.6-1.5-19.4-1.5-29l.3-47.1h129.2l.4 36.9z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFF",
    d: "M447.5 208.7c-.2 1.6-.4 3.3-.6 4.9-4.8 33.1-22.9 65.4-61.5 81-43.2-17-59.4-47.9-64.2-81-.2-1.6-.4-3.2-.6-4.9"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#29DBFF",
    d: "m385.4 251.7-22.9-43h45.8z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFF",
    d: "m385.4 165.8-22.9 42.9h45.8z"
  }), /* @__PURE__ */ i.createElement("ellipse", {
    fill: "#FFBE57",
    cx: 474.8,
    cy: 236.8,
    rx: 16.8,
    ry: 43.3
  }), /* @__PURE__ */ i.createElement("ellipse", {
    fill: "#FFBE57",
    cx: 295.3,
    cy: 236.8,
    rx: 16.8,
    ry: 43.3
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFF",
    d: "m385.4 31.5-33.4 44h68.5zM315.5 280s33.8 29.5 69.9 29.5 67.1-29.5 67.1-29.5l8.5 14.6S439.2 326 385.4 326 307 294.6 307 294.6l8.5-14.6z"
  }), /* @__PURE__ */ i.createElement("ellipse", {
    fill: "#A5A5A5",
    cx: 386.3,
    cy: 104.3,
    rx: 34.3,
    ry: 23.3
  }));
}, uT = function(e) {
  var n = e.title, r = v(e, SS);
  return /* @__PURE__ */ i.createElement("svg", h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ i.createElement("title", null, n), /* @__PURE__ */ i.createElement("path", {
    fill: "#0052B4",
    d: "M0 85.333h512V426.67H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFDA44",
    d: "M332.058 191.996v78.221c0 38.103 51.942 49.779 51.942 49.779s51.942-11.675 51.942-49.779v-78.221H332.058z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#FF9811",
    d: "M376.579 220.44c0 7.855-6.644 28.445-14.84 28.445s-14.84-20.589-14.84-28.445c0-7.856 14.84-14.222 14.84-14.222s14.84 6.367 14.84 14.222z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#A2001D",
    d: "M415.961 235.93c2.394-5.6 4.257-13.785 4.257-17.86 0-6.546-8.904-11.852-8.904-11.852s-8.904 5.306-8.904 11.852c0 4.075 1.862 12.26 4.257 17.86l-5.141 11.123a26.898 26.898 0 0 0 9.788 1.831c3.463 0 6.766-.654 9.788-1.831l-5.141-11.123z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#6DA544",
    d: "M372.87 270.217s-7.421 14.222-7.421 28.445h37.101c0-14.222-7.421-28.445-7.421-28.445l-11.13-7.111-11.129 7.111z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#D80027",
    d: "M395.13 270.217v-3.555c0-5.891-4.983-10.666-11.13-10.666-6.147 0-11.13 4.776-11.13 10.666v3.555h22.26z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFF",
    d: "M256 85.333v30.553l-45.167 25.099H256v59.359h-59.103L256 233.179v22.817h-26.68l-73.494-40.826v40.826h-55.652v-48.573l-87.43 48.573H0v-30.554l45.167-25.098H0v-59.359h59.103L0 108.139V85.333h26.68l73.494 40.825V85.333h55.652v48.572l87.43-48.572z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#D80027",
    d: "M144 85.33h-32v69.332H0v32h112v69.334h32v-69.334h112v-32H144z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#0052B4",
    d: "M155.826 200.344 256 255.996v-15.737l-71.847-39.915z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFF",
    d: "M155.826 200.344 256 255.996v-15.737l-71.847-39.915z"
  }), /* @__PURE__ */ i.createElement("path", {
    d: "M155.826 200.344 256 255.996v-15.737l-71.847-39.915zm-83.98 0L0 240.259v15.737l100.174-55.652z",
    fill: "#D80027"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#0052B4",
    d: "M100.174 140.982 0 85.33v15.737l71.847 39.915z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFF",
    d: "M100.174 140.982 0 85.33v15.737l71.847 39.915z"
  }), /* @__PURE__ */ i.createElement("path", {
    d: "M100.174 140.982 0 85.33v15.737l71.847 39.915zm83.98 0L256 101.067V85.33l-100.174 55.652z",
    fill: "#D80027"
  }));
}, fT = function(e) {
  var n = e.title, r = v(e, FS);
  return /* @__PURE__ */ i.createElement("svg", h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ i.createElement("title", null, n), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFDA44",
    d: "M0 85.331h512v341.337H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#0052B4",
    d: "M0 85.331h170.663v341.337H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#D80027",
    d: "M341.337 85.331H512v341.337H341.337z"
  }));
}, pT = function(e) {
  var n = e.title, r = v(e, PS);
  return /* @__PURE__ */ i.createElement("svg", h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22.5 15"
  }, r), n && /* @__PURE__ */ i.createElement("title", null, n), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFF",
    d: "M0 0h21v15H0V0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#0A388A",
    d: "M0 0h22.5v15H0V0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFF",
    d: "M0 0h11.3v7.5H0V0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#D80027",
    d: "M7.1 0h3.6v7H7.1V0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#0A388A",
    d: "M0 0h3.6v7H0V0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFF",
    d: "M3.6 0h3.6v7H3.6V0zm10.9 6h5L19 7h-1.5v.5h1l-.5 1h-.5V10h-1V7H15l-.5-1zm4 2.5 1 1.5h-2l1-1.5zm-3 0 1 1.5h-2l1-1.5zm1.5 3L16 10h2l-1 1.5zM20 8c-.3 0-.5-.2-.5-.5s.2-.5.5-.5.5.2.5.5-.2.5-.5.5zm-6 0c-.3 0-.5-.2-.5-.5s.2-.5.5-.5.5.2.5.5-.2.5-.5.5zm1 4c-.3 0-.5-.2-.5-.5s.2-.5.5-.5.5.2.5.5-.2.5-.5.5zm4 0c-.3 0-.5-.2-.5-.5s.2-.5.5-.5.5.2.5.5-.2.5-.5.5zm-2 1c-.3 0-.5-.2-.5-.5s.2-.5.5-.5.5.2.5.5-.2.5-.5.5z"
  }));
}, mT = function(e) {
  var n = e.title, r = v(e, NS);
  return /* @__PURE__ */ i.createElement("svg", h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ i.createElement("title", null, n), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFDA44",
    d: "M0 85.337h512v341.326H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    d: "M0 85.337h512V153.6H0zM0 358.4h512v68.263H0zm0-136.537h512v68.263H0z",
    fill: "#496E2D"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#D80027",
    d: "M0 85.337h204.054v204.054H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFF",
    d: "m102.026 133.938 13.26 40.812h42.916l-34.718 25.226 13.26 40.814-34.718-25.224-34.719 25.224 13.263-40.814-34.718-25.226h42.913z"
  }));
}, hT = function(e) {
  var n = e.title, r = v(e, _S);
  return /* @__PURE__ */ i.createElement("svg", h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ i.createElement("title", null, n), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFF",
    d: "M0 85.334h512V426.66H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#0052B4",
    d: "M0 194.056h512v123.882H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    d: "M0 85.334h512v54.522H0zm0 286.809h512v54.522H0z",
    fill: "#D80027"
  }));
}, vT = function(e) {
  var n = e.title, r = v(e, TS);
  return /* @__PURE__ */ i.createElement("svg", h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ i.createElement("title", null, n), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFF",
    d: "M0 85.337h512v341.326H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#D80027",
    d: "M0 85.337h512v113.775H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#6DA544",
    d: "M0 312.888h512v113.775H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    d: "M226.318 300.522h59.364v-25.23l-11.873 5.937L256 263.421l-17.809 17.808-11.873-5.937zm-33.963-29.682 2.763 8.504h8.94l-7.233 5.255 2.763 8.502-7.233-5.255-7.234 5.255 2.763-8.502-7.233-5.255h8.94zm8.566-29.68 2.763 8.502h8.94l-7.233 5.255 2.763 8.504-7.233-5.256-7.234 5.256 2.763-8.504-7.233-5.255h8.94zm24.488-22.261 2.763 8.502h8.94l-7.233 5.255 2.763 8.504-7.233-5.256-7.234 5.256 2.763-8.504-7.233-5.255h8.94zm94.236 51.941-2.763 8.504h-8.94l7.233 5.255-2.763 8.502 7.233-5.255 7.234 5.255-2.763-8.502 7.233-5.255h-8.94zm-8.566-29.68-2.763 8.502h-8.94l7.233 5.255-2.763 8.504 7.233-5.256 7.234 5.256-2.763-8.504 7.233-5.255h-8.94zm-24.488-22.261-2.763 8.502h-8.94l7.233 5.255-2.763 8.504 7.233-5.256 7.234 5.256-2.763-8.504 7.233-5.255h-8.94zM256 207.767l2.763 8.503h8.941l-7.234 5.256 2.763 8.502-7.233-5.254-7.233 5.254 2.763-8.502-7.234-5.256h8.941z",
    fill: "#FFDA44"
  }));
}, gT = function(e) {
  var n = e.title, r = v(e, AS);
  return /* @__PURE__ */ i.createElement("svg", h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ i.createElement("title", null, n), /* @__PURE__ */ i.createElement("path", {
    fill: "#0052B4",
    d: "M0 85.337h512v341.326H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    d: "m210.715 174.377 3.684 11.338h11.919l-9.643 7.006 3.684 11.337-9.644-7.007-9.644 7.007 3.684-11.337-9.645-7.006h11.921zm-93.899 107.594 4.605 14.172h14.9l-12.055 8.757 4.606 14.173-12.056-8.76-12.055 8.76 4.604-14.173-12.054-8.757h14.899zm27.88-162.292 4.604 14.172h14.901l-12.056 8.758 4.606 14.171-12.055-8.759-12.056 8.759 4.606-14.171-12.055-8.758h14.9zm-75.157 55.652 4.604 14.172h14.9l-12.055 8.758 4.606 14.171-12.055-8.758-12.056 8.758 4.606-14.171-12.055-8.758h14.9z",
    fill: "#FFF"
  }), /* @__PURE__ */ i.createElement("path", {
    d: "M483.386 354.503H117.801s109.234-88.562 310.593-220.938c.001 0-88.443 128.935 54.992 220.938zm-365.585 11.586c-11.177 0-11.195 17.37 0 17.37h365.585c11.177 0 11.195-17.37 0-17.37H117.801z",
    fill: "#FFDA44"
  }));
}, yT = function(e) {
  var n = e.title, r = v(e, zS);
  return /* @__PURE__ */ i.createElement("svg", h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ i.createElement("title", null, n), /* @__PURE__ */ i.createElement("path", {
    fill: "#D80027",
    d: "M0 85.337h512v341.326H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFDA44",
    d: "M256 256 0 90.691v44.242L155.826 256 0 377.067v44.242z"
  }), /* @__PURE__ */ i.createElement("path", {
    d: "M0 90.691v330.618L189.217 256z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFF",
    d: "m44.184 213.36 24.912 23.577 30.121-16.41-14.723 30.98 24.911 23.575-34.012-4.43L60.67 301.63l-6.296-33.716-34.012-4.43 30.119-16.408z"
  }));
}, bT = function(e) {
  var n = e.title, r = v(e, DS);
  return /* @__PURE__ */ i.createElement("svg", h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ i.createElement("title", null, n), /* @__PURE__ */ i.createElement("path", {
    fill: "#496E2D",
    d: "M0 85.337h512v341.326H0z"
  }), /* @__PURE__ */ i.createElement("g", {
    fill: "#FFF"
  }, /* @__PURE__ */ i.createElement("path", {
    d: "M357.208 183.679c8.397-23.404-1.036-48.858-21.281-61.536a52.131 52.131 0 0 1 10.884 2.621c27.002 9.688 41.038 39.428 31.35 66.431s-39.428 41.038-66.431 31.35a52.182 52.182 0 0 1-10.069-4.895c23.686 3.084 47.15-10.566 55.547-33.971zm-46.571-67.95-7.297 9.427-11.22-4.026 6.712 9.852-7.296 9.427 11.443-3.338 6.712 9.852.361-11.914 11.444-3.339-11.221-4.025z"
  }), /* @__PURE__ */ i.createElement("path", {
    d: "m330.338 146.448-7.296 9.427-11.221-4.026 6.712 9.852-7.296 9.427 11.443-3.339 6.712 9.853.36-11.915 11.445-3.34-11.221-4.024zM275.9 126.916l-7.296 9.427-11.219-4.024 6.711 9.851-7.296 9.426 11.443-3.338 6.712 9.852.361-11.915 11.444-3.337-11.221-4.027zm-.799 35.189-7.296 9.427-11.221-4.026 6.712 9.852-7.296 9.427 11.444-3.338 6.711 9.852.362-11.915 11.443-3.338-11.22-4.026zm33.484 12.013-7.296 9.427-11.22-4.026 6.712 9.853-7.297 9.426 11.444-3.338 6.712 9.852.36-11.915 11.443-3.338-11.219-4.025z"
  })), /* @__PURE__ */ i.createElement("path", {
    fill: "#D80027",
    d: "M83.478 85.337h89.043v341.326H83.478z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFF",
    d: "m117.458 175.191-14.908-11.105v-15.705l14.908-11.105h21.084l14.908 11.105v15.705l-14.908 11.105z"
  }), /* @__PURE__ */ i.createElement("path", {
    d: "M128 137.276h-10.542l-14.908 11.105v7.678H128zm0 37.915h10.542l14.908-11.105v-8.012H128z",
    fill: "#FF9811"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFF",
    d: "m117.458 374.725-14.908-11.106v-15.704l14.908-11.105h21.084l14.908 11.105v15.704l-14.908 11.106z"
  }), /* @__PURE__ */ i.createElement("path", {
    d: "M128 336.81h-10.542l-14.908 11.105v7.678H128zm0 37.915h10.542l14.908-11.106v-8.011H128z",
    fill: "#FF9811"
  }), /* @__PURE__ */ i.createElement("path", {
    d: "m117.458 274.957-14.908-11.105v-15.703l14.908-11.106h21.084l14.908 11.106v15.703l-14.908 11.105zm36.513 24.434h-6.493v-6.493h-11.411l-8.068-8.068-8.067 8.068h-11.41v6.493h-6.493v12.986h6.493v6.492h11.41l8.068 8.069 8.068-8.069h11.41v-6.492h6.493zm0-99.768h-6.493v-6.492h-11.411l-8.068-8.069-8.067 8.069h-11.41v6.492h-6.493v12.986h6.493v6.492h11.41l8.068 8.07 8.068-8.07h11.41v-6.492h6.493z",
    fill: "#496E2D"
  }), /* @__PURE__ */ i.createElement("g", {
    fill: "#D80027"
  }, /* @__PURE__ */ i.createElement("path", {
    d: "M120.576 248.576h14.84v14.84h-14.84z"
  }), /* @__PURE__ */ i.createElement("circle", {
    cx: 128,
    cy: 206.113,
    r: 7.421
  }), /* @__PURE__ */ i.createElement("circle", {
    cx: 128,
    cy: 305.887,
    r: 7.421
  })));
}, ET = function(e) {
  var n = e.title, r = v(e, IS);
  return /* @__PURE__ */ i.createElement("svg", h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ i.createElement("title", null, n), /* @__PURE__ */ i.createElement("path", {
    fill: "#D80027",
    d: "M0 85.331h512v341.337H0z"
  }), /* @__PURE__ */ i.createElement("circle", {
    fill: "#FFF",
    cx: 256,
    cy: 255.994,
    r: 96
  }), /* @__PURE__ */ i.createElement("g", {
    fill: "#D80027"
  }, /* @__PURE__ */ i.createElement("path", {
    d: "m267.826 219.291 16.47 22.695 26.673-8.649-16.496 22.676 16.468 22.695-26.664-8.681-16.495 22.676.017-28.04-26.664-8.682 26.674-8.648z"
  }), /* @__PURE__ */ i.createElement("path", {
    d: "M277.818 312.724c-31.33 0-56.727-25.397-56.727-56.727s25.397-56.727 56.727-56.727c9.769 0 18.96 2.47 26.985 6.819-12.589-12.31-29.804-19.909-48.803-19.909-38.558 0-69.818 31.259-69.818 69.818s31.26 69.818 69.818 69.818c18.999 0 36.215-7.599 48.803-19.909-8.026 4.347-17.216 6.817-26.985 6.817z"
  })));
}, wT = function(e) {
  var n = e.title, r = v(e, kS);
  return /* @__PURE__ */ i.createElement("svg", h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ i.createElement("title", null, n), /* @__PURE__ */ i.createElement("path", {
    fill: "#D80027",
    d: "M0 85.331h512v341.337H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFF",
    d: "M0 85.331h256v170.663H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#D80027",
    d: "M141.357 157.303V130.59h-26.714v26.713H87.93v26.713h26.713v26.713h26.714v-26.713h26.713v-26.713z"
  }));
}, $T = function(e) {
  var n = e.title, r = v(e, OS);
  return /* @__PURE__ */ i.createElement("svg", h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ i.createElement("title", null, n), /* @__PURE__ */ i.createElement("path", {
    fill: "#E30A17",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFF",
    d: "M259.7 118.6c-13.1-9.5-29-14.6-45.3-14.5-40.8 0-73.8 30.8-73.8 68.9s33.1 68.9 73.8 68.9c17.1 0 32.9-5.4 45.3-14.5-30 38.6-85.7 45.6-124.3 15.5s-45.6-85.7-15.5-124.3 85.7-45.6 124.3-15.5c5.8 4.5 11 9.8 15.5 15.5zm39.9 65.8-18.1 21.9 1.2-28.4-26.4-10.4 27.3-7.6 1.8-28.3 15.6 23.7 27.5-7.1-17.5 22 15.3 23.9-26.7-9.7z"
  }));
}, xT = function(e) {
  var n = e.title, r = v(e, LS);
  return /* @__PURE__ */ i.createElement("svg", h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ i.createElement("title", null, n), /* @__PURE__ */ i.createElement("path", {
    fill: "#D80027",
    d: "M0 85.337h512v341.326H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFF",
    d: "m6.066 85.337 207.961 212.636 131.584 128.69h160.323L297.973 214.027 166.389 85.337z"
  }), /* @__PURE__ */ i.createElement("path", {
    d: "M43.364 85.337 384.69 426.663h83.946L127.31 85.337z"
  }));
}, CT = function(e) {
  var n = e.title, r = v(e, RS);
  return /* @__PURE__ */ i.createElement("svg", h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 900 600"
  }, r), n && /* @__PURE__ */ i.createElement("title", null, n), /* @__PURE__ */ i.createElement("path", {
    fill: "#0052B4",
    d: "M0 0h900v600H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#00B2EE",
    d: "M0 300h450V0h450v600H0V300z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFDA44",
    d: "m345.3 480.9 29.4 90.6-77.1-56H393l-77.1 56 29.4-90.6zM706.4 340l29.4 90.6-77.1-56H754l-77.1 56 29.5-90.6zm106.4-78.5 29.4 90.6-77.1-56h95.3l-77.1 56 29.5-90.6zm0-224.1 29.4 90.6-77.1-56h95.3l-77.1 56 29.5-90.6z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFF",
    d: "M449.9 0v206.3h-81l81 54V300h-39.7l-129-85.9V300H168.7v-85.9L39.7 300H0v-39.7l81-54H0V93.8h81L0 39.9V0h39.7l129 85.9V0h112.5v85.9L410.2 0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#D80027",
    d: "M253.1 0h-56.3v122H0v56.2h196.8V300h56.3V178.2h196.8V122H253.1z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#2E52B2",
    d: "M449.9 39.9v53.9h-81z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#D80027",
    d: "M0 300v-19.3l109.9-74.4h39.7L12.8 300zM12.8.1l136.8 93.7h-39.7L0 19.4V.1zm437.1.1v19.3L340 93.8h-39.7L437.1.2zM437.1 300l-136.8-93.7H340l109.9 74.4V300z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFDA44",
    d: "m719.9 131.6 29.4 90.6-77.1-56h95.3l-77.1 56 29.5-90.6zM584 187.7l29.4 90.6-77.1-56h95.3l-77.1 56 29.5-90.6zm30 242.9 29.4 90.6-77.1-56h95.3l-77.1 56 29.5-90.6zM488 332l29.4 90.6-77.1-56h95.3l-77.1 56L488 332zm0 132 29.4 90.6-77.1-56h95.3l-77.1 56L488 464z"
  }));
}, MT = function(e) {
  var n = e.title, r = v(e, HS);
  return /* @__PURE__ */ i.createElement("svg", h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ i.createElement("title", null, n), /* @__PURE__ */ i.createElement("path", {
    fill: "#D80027",
    d: "M0 85.337h512v341.326H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#0052B4",
    d: "M0 85.337h256V256H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFF",
    d: "M186.435 170.669 162.558 181.9l12.714 23.125-25.927-4.961-3.286 26.192L128 206.993l-18.06 19.263-3.285-26.192-25.927 4.96 12.714-23.125-23.877-11.23 23.877-11.231-12.714-23.125 25.927 4.96 3.286-26.192L128 134.344l18.06-19.263 3.285 26.192 25.928-4.96-12.715 23.125z"
  }), /* @__PURE__ */ i.createElement("circle", {
    fill: "#0052B4",
    cx: 128,
    cy: 170.674,
    r: 29.006
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFF",
    d: "M128 190.06c-10.692 0-19.391-8.7-19.391-19.391 0-10.692 8.7-19.391 19.391-19.391 10.692 0 19.391 8.7 19.391 19.391 0 10.691-8.699 19.391-19.391 19.391z"
  }));
}, ST = function(e) {
  var n = e.title, r = v(e, BS);
  return /* @__PURE__ */ i.createElement("svg", h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ i.createElement("title", null, n), /* @__PURE__ */ i.createElement("path", {
    fill: "#338AF3",
    d: "M0 85.337h512v341.326H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#6DA544",
    d: "M0 426.663V85.337h512"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFDA44",
    d: "M512 152.222V85.337H411.67L0 359.778v66.885h100.33z"
  }), /* @__PURE__ */ i.createElement("path", {
    d: "M512 85.337v40.125L60.193 426.663H0v-40.125L451.807 85.337z"
  }));
}, FT = function(e) {
  var n = e.title, r = v(e, jS);
  return /* @__PURE__ */ i.createElement("svg", h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ i.createElement("title", null, n), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFDA44",
    d: "M0 85.337h512v341.326H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#338AF3",
    d: "M0 85.337h512V256H0z"
  }));
}, PT = function(e) {
  var n = e.title, r = v(e, VS);
  return /* @__PURE__ */ i.createElement("svg", h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 341.3"
  }, r), n && /* @__PURE__ */ i.createElement("title", null, n), /* @__PURE__ */ i.createElement("path", {
    fill: "#232323",
    d: "M0 0h512v341.3H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFDA44",
    d: "M0 56.9h512v56.9H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#D32300",
    d: "M0 113.8h512v56.9H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFDA44",
    d: "M0 227.6h512v56.9H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#D32300",
    d: "M0 284.4h512v56.9H0z"
  }), /* @__PURE__ */ i.createElement("circle", {
    fill: "#FFF",
    cx: 256,
    cy: 170.7,
    r: 80.7
  }), /* @__PURE__ */ i.createElement("path", {
    d: "M234.5 127.5c.9-1.4-19.6-2-19.6-2 1.7-2.5 18.4-10.5 18.4-10.5s-.9-6 2.7-9.8l-4.5-9.8s7-3.4 18.4-3.4 19.9 7 21 13.1l-6.4 3.4c-.1 4.7 1.7 11.6-4.3 17.3-5.9 5.7-8.3 6.9-8.5 18.8 0 3.9 2.3 8.2 8.8 11.7 17.4 9.3 38.6 28.2 44.6 33.9 6.1 5.7 5.1 19.2 2.6 25.2s-12.1 14.3-14.3 13.6c-2.2-.6 1.2-9.2-3.5-11.6 0 0-8.9-7.6-16.8.6s-.2 25.2 3.9 28c4.1 2.8 1.7 5-1.9 5H247c-3.8 0-5.4-2.3-1.9-5 7.6-3.8 12.4-15.3 7.4-20.3-4.9-4.9-18.3 1.5-21.5 6.3-2.8 2.8-8.8 3.6-12.9-1.4s-4.1-10.4-1.1-12.5c7-4.8 0 0 .1-.1 0 0 11.9-8.6 29.9-9 3.9 0 4.8-2.2 2.2-4.8 0 0-30.9-27.4-28.1-44.2 3-18.3 20-26.3 13.4-32.5-1.3-1.8 0 0 0 0z"
  }));
}, NT = function(e) {
  var n = e.title, r = v(e, US);
  return /* @__PURE__ */ i.createElement("svg", h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ i.createElement("title", null, n), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFF",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    d: "M0 0h513v26.3H0zm0 52.6h513v26.3H0zm0 52.6h513v26.3H0zm0 52.6h513v26.3H0zm0 52.7h513v26.3H0zm0 52.6h513v26.3H0zm0 52.6h513V342H0z",
    fill: "#D80027"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#2E52B2",
    d: "M0 0h256.5v184.1H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    d: "m47.8 138.9-4-12.8-4.4 12.8H26.2l10.7 7.7-4 12.8 10.9-7.9 10.6 7.9-4.1-12.8 10.9-7.7zm56.3 0-4.1-12.8-4.2 12.8H82.6l10.7 7.7-4 12.8 10.7-7.9 10.8 7.9-4-12.8 10.7-7.7zm56.5 0-4.3-12.8-4 12.8h-13.5l11 7.7-4.2 12.8 10.7-7.9 11 7.9-4.2-12.8 10.7-7.7zm56.2 0-4-12.8-4.2 12.8h-13.3l10.8 7.7-4 12.8 10.7-7.9 10.8 7.9-4.3-12.8 11-7.7zM100 75.3l-4.2 12.8H82.6L93.3 96l-4 12.6 10.7-7.8 10.8 7.8-4-12.6 10.7-7.9h-13.4zm-56.2 0-4.4 12.8H26.2L36.9 96l-4 12.6 10.9-7.8 10.6 7.8L50.3 96l10.9-7.9H47.8zm112.5 0-4 12.8h-13.5l11 7.9-4.2 12.6 10.7-7.8 11 7.8-4.2-12.6 10.7-7.9h-13.2zm56.5 0-4.2 12.8h-13.3l10.8 7.9-4 12.6 10.7-7.8 10.8 7.8-4.3-12.6 11-7.9h-13.5zm-169-50.6-4.4 12.6H26.2l10.7 7.9-4 12.7L43.8 50l10.6 7.9-4.1-12.7 10.9-7.9H47.8zm56.2 0-4.2 12.6H82.6l10.7 7.9-4 12.7L100 50l10.8 7.9-4-12.7 10.7-7.9h-13.4zm56.3 0-4 12.6h-13.5l11 7.9-4.2 12.7 10.7-7.9 11 7.9-4.2-12.7 10.7-7.9h-13.2zm56.5 0-4.2 12.6h-13.3l10.8 7.9-4 12.7 10.7-7.9 10.8 7.9-4.3-12.7 11-7.9h-13.5z",
    fill: "#FFF"
  }));
}, _T = function(e) {
  var n = e.title, r = v(e, WS);
  return /* @__PURE__ */ i.createElement("svg", h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ i.createElement("title", null, n), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFF",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    d: "M0 0h513v26.3H0zm0 52.6h513v26.3H0zm0 52.6h513v26.3H0zm0 52.6h513v26.3H0zm0 52.7h513v26.3H0zm0 52.6h513v26.3H0zm0 52.6h513V342H0z",
    fill: "#D80027"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#2E52B2",
    d: "M0 0h256.5v184.1H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    d: "m47.8 138.9-4-12.8-4.4 12.8H26.2l10.7 7.7-4 12.8 10.9-7.9 10.6 7.9-4.1-12.8 10.9-7.7zm56.3 0-4.1-12.8-4.2 12.8H82.6l10.7 7.7-4 12.8 10.7-7.9 10.8 7.9-4-12.8 10.7-7.7zm56.5 0-4.3-12.8-4 12.8h-13.5l11 7.7-4.2 12.8 10.7-7.9 11 7.9-4.2-12.8 10.7-7.7zm56.2 0-4-12.8-4.2 12.8h-13.3l10.8 7.7-4 12.8 10.7-7.9 10.8 7.9-4.3-12.8 11-7.7zM100 75.3l-4.2 12.8H82.6L93.3 96l-4 12.6 10.7-7.8 10.8 7.8-4-12.6 10.7-7.9h-13.4zm-56.2 0-4.4 12.8H26.2L36.9 96l-4 12.6 10.9-7.8 10.6 7.8L50.3 96l10.9-7.9H47.8zm112.5 0-4 12.8h-13.5l11 7.9-4.2 12.6 10.7-7.8 11 7.8-4.2-12.6 10.7-7.9h-13.2zm56.5 0-4.2 12.8h-13.3l10.8 7.9-4 12.6 10.7-7.8 10.8 7.8-4.3-12.6 11-7.9h-13.5zm-169-50.6-4.4 12.6H26.2l10.7 7.9-4 12.7L43.8 50l10.6 7.9-4.1-12.7 10.9-7.9H47.8zm56.2 0-4.2 12.6H82.6l10.7 7.9-4 12.7L100 50l10.8 7.9-4-12.7 10.7-7.9h-13.4zm56.3 0-4 12.6h-13.5l11 7.9-4.2 12.7 10.7-7.9 11 7.9-4.2-12.7 10.7-7.9h-13.2zm56.5 0-4.2 12.6h-13.3l10.8 7.9-4 12.7 10.7-7.9 10.8 7.9-4.3-12.7 11-7.9h-13.5z",
    fill: "#FFF"
  }));
}, TT = function(e) {
  var n = e.title, r = v(e, GS);
  return /* @__PURE__ */ i.createElement("svg", h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ i.createElement("title", null, n), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFF",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    d: "M0 38h513v38H0zm0 76h513v38H0zm0 76h513v38H0zm0 76h513v38H0z",
    fill: "#0038a8"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFF",
    d: "M0 0h256.5v190H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#FED443",
    d: "m128.3 138.7-15.1 22.6-3.8-26.9L86 148.2l8.2-25.9-27.2 2.2 18.6-19.8L60.3 95l25.4-9.7L67 65.5l27.1 2.3-8.2-25.9 23.4 13.8 3.9-26.9 15.1 22.6 15.1-22.6 3.8 26.9 23.4-13.8-8.2 25.9 27.1-2.2-18.6 19.8 25.4 9.7-25.4 9.7 18.6 19.8-27.1-2.2 8.2 25.9-23.4-13.8-3.9 26.9-15-22.7zm0-.5c23.9.9 44-17.6 44.9-41.5.9-23.9-17.6-44-41.5-44.9h-3.4c-23.9.8-42.6 20.8-41.8 44.6.6 22.8 19 41.1 41.8 41.8zm0-10.6c-18.8 0-34-15.2-34-34s15.2-34 34-34 34 15.2 34 34-15.3 34-34 34z"
  }));
}, AT = function(e) {
  var n = e.title, r = v(e, KS);
  return /* @__PURE__ */ i.createElement("svg", h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ i.createElement("title", null, n), /* @__PURE__ */ i.createElement("path", {
    fill: "#D80027",
    d: "M0 85.337h512v341.326H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#6DA544",
    d: "M0 322.783h512v103.88H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#338AF3",
    d: "M0 85.337h512v104.515H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFF",
    d: "M0 210.877h512v89.656H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#338AF3",
    d: "M0 85.337h512v104.515H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    d: "M188.688 137.589c0-15.984 11.234-29.339 26.236-32.614a33.531 33.531 0 0 0-7.155-.777c-18.442 0-33.391 14.949-33.391 33.391s14.949 33.391 33.391 33.391c2.458 0 4.85-.273 7.155-.777-15.002-3.275-26.236-16.63-26.236-32.614zm45.97 15.177 2.261 6.957h7.315l-5.918 4.301 2.261 6.956-5.919-4.3-5.918 4.3 2.261-6.956-5.918-4.301h7.315zm23.348 0 2.26 6.957h7.315l-5.918 4.301 2.261 6.956-5.918-4.3-5.918 4.3 2.26-6.956-5.917-4.301h7.314zm23.347 0 2.26 6.957h7.315l-5.917 4.301 2.26 6.956-5.918-4.3-5.918 4.3 2.26-6.956-5.918-4.301h7.315zm23.347 0 2.262 6.957h7.315l-5.919 4.301 2.261 6.956-5.919-4.3-5.918 4.3 2.262-6.956-5.919-4.301h7.314zm23.348 0 2.26 6.957h7.315l-5.918 4.301 2.261 6.956-5.918-4.3-5.918 4.3 2.26-6.956-5.917-4.301h7.314zm-70.042-24.284 2.26 6.956h7.315l-5.918 4.3 2.261 6.957-5.918-4.299-5.918 4.299 2.26-6.957-5.917-4.3h7.314zm23.347 0 2.26 6.956h7.315l-5.917 4.3 2.26 6.957-5.918-4.299-5.918 4.299 2.26-6.957-5.918-4.3h7.315zm23.347 0 2.262 6.956h7.315l-5.919 4.3 2.261 6.957-5.919-4.299-5.918 4.299 2.262-6.957-5.919-4.3h7.314zm23.348 0 2.26 6.956h7.315l-5.918 4.3 2.261 6.957-5.918-4.299-5.918 4.299 2.26-6.957-5.917-4.3h7.314zm-46.695-24.284 2.26 6.956h7.315l-5.917 4.3 2.26 6.957-5.918-4.3-5.918 4.3 2.26-6.957-5.918-4.3h7.315zm23.347 0 2.262 6.956h7.315l-5.919 4.3 2.261 6.957-5.919-4.3-5.918 4.3 2.262-6.957-5.919-4.3h7.314zm23.348 0 2.26 6.956h7.315l-5.918 4.3 2.261 6.957-5.918-4.3-5.918 4.3 2.26-6.957-5.917-4.3h7.314z",
    fill: "#FFF"
  }));
}, zT = function(e) {
  var n = e.title, r = v(e, qS);
  return /* @__PURE__ */ i.createElement("svg", h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ i.createElement("title", null, n), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFDA44",
    d: "M0 85.331h512v341.326H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFF",
    d: "M256 85.331h256v341.337H256z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#ACABB1",
    d: "m321.353 233.837 32.073 42.43c-5.053 7.651-5.026 17.961.817 25.692 7.414 9.807 21.374 11.748 31.182 4.335 9.807-7.414 11.748-21.374 4.334-31.182-5.843-7.731-15.756-10.568-24.495-7.795l-49.988-66.129-11.838 8.949-17.759 13.424 17.899 23.677 17.775-13.401zm46.175 48.78a7.421 7.421 0 1 1 8.95 11.84 7.421 7.421 0 0 1-8.95-11.84z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFDA44",
    d: "m376.367 247.24 17.899-23.677-17.759-13.424-11.838-8.949-49.988 66.129c-8.74-2.775-18.651.063-24.495 7.795-7.414 9.808-5.473 23.768 4.334 31.182 9.808 7.414 23.768 5.473 31.182-4.335 5.845-7.731 5.871-18.041.817-25.692l32.073-42.43 17.775 13.401zm-62.504 45.771a7.42 7.42 0 1 1-11.84-8.95 7.42 7.42 0 0 1 11.84 8.95z"
  }));
}, DT = function(e) {
  var n = e.title, r = v(e, YS);
  return /* @__PURE__ */ i.createElement("svg", h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ i.createElement("title", null, n), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFDA44",
    d: "M0 85.331h512v341.337H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#338AF3",
    d: "M0 85.331h170.663v341.337H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    d: "M341.337 85.331H512v341.337H341.337zM214.261 283.82l-33.393-50.086 33.392-50.087 33.392 50.087zm83.478 0-33.391-50.086 33.391-50.087 33.393 50.087zM256 350.603l-33.391-50.087L256 250.429l33.391 50.087z",
    fill: "#6DA544"
  }));
}, IT = function(e) {
  var n = e.title, r = v(e, ZS);
  return /* @__PURE__ */ i.createElement("svg", h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22.5 15"
  }, r), n && /* @__PURE__ */ i.createElement("title", null, n), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFCE00",
    d: "M0 0h22.5v5H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#203899",
    d: "M0 5h22.5v5H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#D82B2B",
    d: "M0 10h22.5v5H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFF",
    d: "m12.13 5.38.14.46.45.14-.39.27.01.48-.38-.29-.45.15.15-.44-.28-.38h.47zm-1.77 0 .27.39h.47l-.28.38.15.45-.45-.16-.38.28.01-.47-.39-.28.45-.13zm3.44.56-.01.48.39.27-.46.14-.14.45-.27-.38h-.48l.29-.38-.15-.45.45.16zm-5.11.02.4.27.44-.18-.13.46.3.36-.47.02-.26.4-.16-.44-.46-.12.37-.3zm6.55 1.17-.2.44.25.4-.47-.05-.31.36-.1-.46-.43-.18.41-.24.03-.47.35.31zm.19 1.12.21.43.47.07-.34.33.08.46-.42-.22-.42.22.08-.46-.34-.33.47-.07zM7 8.2l.21.43.47.06-.34.33.08.47L7 9.27l-.42.22.08-.47-.34-.33.47-.06zm.31-1.15.45.14.38-.29v.48l.39.26-.45.15-.13.46-.28-.38-.47.01.27-.38z"
  }));
}, kT = function(e) {
  var n = e.title, r = v(e, XS);
  return /* @__PURE__ */ i.createElement("svg", h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ i.createElement("title", null, n), /* @__PURE__ */ i.createElement("path", {
    fill: "#0052B4",
    d: "M0 85.334h512v341.337H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFF",
    d: "M256 85.334V202.66h-46.069L256 233.38v22.617h-22.628L160 207.078v48.919H96v-48.919l-73.372 48.919H0V233.38l46.069-30.72H0v-64h46.069L0 107.951V85.334h22.628L96 134.241V85.334h64v48.907l73.372-48.907z"
  }), /* @__PURE__ */ i.createElement("g", {
    fill: "#D80027"
  }, /* @__PURE__ */ i.createElement("path", {
    d: "M144 85.33h-32v69.333H0v32h112v69.334h32v-69.334h112v-32H144z"
  }), /* @__PURE__ */ i.createElement("path", {
    d: "M0 85.329v15.083l57.377 38.251H80zm256 0v15.083l-57.377 38.251H176z"
  })), /* @__PURE__ */ i.createElement("path", {
    fill: "#2E52B2",
    d: "M256 107.951v30.712h-46.069z"
  }), /* @__PURE__ */ i.createElement("path", {
    d: "M0 85.329v15.083l57.377 38.251H80zm256 0v15.083l-57.377 38.251H176z",
    fill: "#D80027"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#2E52B2",
    d: "M256 107.951v30.712h-46.069z"
  }), /* @__PURE__ */ i.createElement("path", {
    d: "M0 255.997v-15.082l57.377-38.252H80zm256 0v-15.082l-57.377-38.252H176z",
    fill: "#D80027"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFDA44",
    d: "m384 259.706-46.129 46.129c8.645 16.675 26.051 28.074 46.129 28.074s37.484-11.4 46.129-28.074L384 259.706z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#6DA544",
    d: "M332.058 178.084v81.624c.001 39.759 51.942 51.941 51.942 51.941s51.941-12.182 51.942-51.942v-81.623H332.058z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFF",
    d: "M372.87 215.181h22.261v59.359H372.87z"
  }), /* @__PURE__ */ i.createElement("circle", {
    fill: "#A2001D",
    cx: 384,
    cy: 215.181,
    r: 11.13
  }), /* @__PURE__ */ i.createElement("path", {
    d: "M346.902 192.92h14.84v14.84h-14.84zm0 33.392h14.84v14.84h-14.84zm0 33.391h14.84v14.84h-14.84zm59.359-66.783h14.84v14.84h-14.84zm0 33.392h14.84v14.84h-14.84zm0 33.391h14.84v14.84h-14.84z",
    fill: "#FFDA44"
  }));
}, OT = function(e) {
  var n = e.title, r = v(e, JS);
  return /* @__PURE__ */ i.createElement("svg", h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 341.3"
  }, r), n && /* @__PURE__ */ i.createElement("title", null, n), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFF",
    d: "M0 0h512v341.3H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#1583C4",
    d: "m397.7 166.3-51 97.7c-1.1 2-.3 4.5 1.8 5.6 2 1.1 4.5.3 5.6-1.8l51-97.7c1-2.1.1-4.6-2-5.5-2-.9-4.3-.2-5.4 1.7z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#1583C4",
    d: "m404.9 188-57.8 75.4c-1.3 1.9-.8 4.5 1.1 5.8 1.7 1.2 4.1.9 5.5-.7l57.8-75.4c1.4-1.8 1.1-4.4-.8-5.8-1.8-1.5-4.4-1.1-5.8.7z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#1583C4",
    d: "m379 181.3-32.5 83.1c-.8 2.1.2 4.6 2.4 5.4 2.1.8 4.6-.2 5.4-2.4l32.5-83.1c.7-2.2-.4-4.5-2.6-5.3-2.1-.6-4.3.4-5.2 2.3z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#409347",
    d: "M122.1 171.9c.4 1.7 1.2 4.7 2.2 8.5 1.7 6.4 3.6 12.8 5.6 18.7 2.3 6.9 14.7 31.4 20.2 39.1 6.9 9.7 14.1 19.3 21.5 28.6 1.6 1.9 4.5 2.1 6.4.5 1.8-1.6 2.1-4.3.7-6.2-7.3-9.2-14.4-18.6-21.2-28.2-4.2-5.8-17.2-31.1-19-36.7-2.9-8.7-5.4-17.6-7.6-26.5-.5-2.4-2.9-4-5.3-3.5s-4 2.9-3.5 5.3c-.1.2 0 .3 0 .4z"
  }), /* @__PURE__ */ i.createElement("g", {
    fill: "#FFD836",
    stroke: "#231F20",
    strokeMiterlimit: 10
  }, /* @__PURE__ */ i.createElement("path", {
    d: "M297.1 114.9S279.5 42.8 261 42.8c-6.9 0-11.9-.6-15.4 6.4-.9 1.7-20.7-1.6-19.1 20.8.5 6.9 1.1-9.8 14.9-3.4 6.3 3-16.4 48.2-16.4 48.2h72.1z"
  }), /* @__PURE__ */ i.createElement("path", {
    d: "m466.1 48.4-90.9 22c-75.3 18.3-42.1 44.4-42.1 44.4l-72.1 12-72.1-12s33.2-26.1-42.1-44.4l-90.9-22C43.1 45.3 38.1 51.8 45.3 63c0 0 106.6 104 126.8 112 20.2 8.1 40.8 0 40.8 0s-14.9 8.7-24 24c-9.2 15.3-4.6 34.7-38.9 40.2-5.5 6.6-5 14 2.9 19.9 7.9 5.8 72.1-48.1 72.1-48.1s-24 24.4-24 36.1c0 5.1 44.1 53.8 60.1 53.8s60.1-48.7 60.1-53.8c0-11.7-24-36.1-24-36.1s64.2 53.9 72.1 48.1 11.4-19.3 2.8-19.9c-28-1.8-29.7-24.9-38.9-40.2-9.2-15.3-24-24-24-24s20.6 8.1 40.8 0S476.7 63 476.7 63c7.2-11.2 2.3-17.7-10.6-14.6z"
  })), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFF",
    stroke: "#231F20",
    strokeMiterlimit: 10,
    d: "M201.3 111.8v80.3c0 45.7 59.7 59.7 59.7 59.7s59.7-14 59.7-59.7v-80.3H201.3z"
  }), /* @__PURE__ */ i.createElement("path", {
    d: "M225.2 137.7V235c8.2 6 17 10.2 23.9 12.9V137.7h-23.9zm71.6 0V235c-8.2 6-17 10.2-23.9 12.9V137.7h23.9z",
    fill: "#D80027"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#0052B4",
    d: "M201.3 111.8h119.4v37.9H201.3z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#1583C4",
    d: "m60.1 210.5-21.9-58.1H15.7l31.8 80.8h25.2l31.5-80.8H81.7zm391.4-58.6h18.9v81.7h-18.9z"
  }));
}, LT = function(e) {
  var n = e.title, r = v(e, QS);
  return /* @__PURE__ */ i.createElement("svg", h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ i.createElement("title", null, n), /* @__PURE__ */ i.createElement("path", {
    fill: "#D80027",
    d: "M196.641 85.337H0v341.326h512V85.337z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFDA44",
    d: "m256 157.279 22.663 69.747H352l-59.332 43.106 22.664 69.749L256 296.774l-59.332 43.107 22.664-69.749L160 227.026h73.337z"
  }));
}, RT = function(e) {
  var n = e.title, r = v(e, eF);
  return /* @__PURE__ */ i.createElement("svg", h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ i.createElement("title", null, n), /* @__PURE__ */ i.createElement("path", {
    d: "M0 85.337h512v341.326H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#6DA544",
    d: "M512 256v170.663H0L215.185 256z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#D80027",
    d: "M512 85.337V256H215.185L0 85.337z"
  }), /* @__PURE__ */ i.createElement("path", {
    d: "M221.001 239.304 26.868 85.337H8.956l208.168 165.098H512v-11.131zM8.956 426.663h17.912l194.133-153.967H512v-11.131H217.124zM0 92.44v14.206L188.317 256 0 405.354v14.205L206.229 256z"
  }), /* @__PURE__ */ i.createElement("g", {
    fill: "#FFDA44"
  }, /* @__PURE__ */ i.createElement("path", {
    d: "M8.956 85.337H0v7.103L206.229 256 0 419.559v7.104h8.956l208.168-165.098H512v-11.13H217.124z"
  }), /* @__PURE__ */ i.createElement("path", {
    d: "M63.718 292.382v-14.295c14.265 0 25.87-11.606 25.87-25.869 0-10.092-8.211-18.303-18.304-18.303-6.875 0-12.469 5.593-12.469 12.469 0 4.397 3.577 7.974 7.974 7.974a4.514 4.514 0 0 0 4.508-4.508h14.295c0 10.368-8.435 18.804-18.802 18.804-12.279-.002-22.269-9.993-22.269-22.271 0-14.758 12.006-26.764 26.764-26.764 17.975 0 32.599 14.623 32.599 32.599 0 22.145-18.018 40.164-40.166 40.164z"
  })));
}, HT = function(e) {
  var n = e.title, r = v(e, tF);
  return /* @__PURE__ */ i.createElement("svg", h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 150 100"
  }, r), n && /* @__PURE__ */ i.createElement("title", null, n), /* @__PURE__ */ i.createElement("path", {
    fill: "#D80B30",
    d: "M0 0h150v100H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#00318A",
    d: "M0 0h20v44.33H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFF",
    d: "M20 0h20v44.33H20z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "none",
    stroke: "#FFF",
    strokeWidth: 3,
    d: "M0 44.33h62.75V0"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFF",
    d: "M108.08 43.29 87.96 23.17h40.25l-20.13 20.12zm-6.7 6.71L81.25 29.88v40.25L101.38 50zm6.7 6.71L87.96 76.83h40.25l-20.13-20.12zm6.71-6.71 20.13-20.13v40.25L114.79 50z"
  }));
}, BT = function(e) {
  var n = e.title, r = v(e, nF);
  return /* @__PURE__ */ i.createElement("svg", h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ i.createElement("title", null, n), /* @__PURE__ */ i.createElement("path", {
    fill: "#D80027",
    d: "M0 85.331h512v341.337H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#0052B4",
    d: "M0 85.331h256v170.663H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    d: "m165.483 181.79 2.764 8.504h8.939l-7.232 5.254 2.763 8.503-7.234-5.255-7.233 5.255 2.763-8.503-7.233-5.254h8.94zm-44.904-66.783 4.606 14.173h14.9l-12.055 8.757 4.605 14.171-12.056-8.758-12.054 8.758 4.605-14.171-12.056-8.757h14.901zm44.522 14.841 4.606 14.172h14.9l-12.055 8.757 4.604 14.173-12.055-8.76-12.054 8.76 4.604-14.173-12.055-8.757h14.9zm-35.192 59.363 4.606 14.172h14.9l-12.055 8.758 4.604 14.171-12.055-8.759-12.054 8.759 4.604-14.171-12.055-8.758h14.9zm-39.01-37.103 4.605 14.173h14.9l-12.055 8.757 4.604 14.173-12.054-8.76-12.055 8.76 4.604-14.173-12.055-8.757h14.9z",
    fill: "#FFF"
  }));
}, jT = function(e) {
  var n = e.title, r = v(e, rF);
  return /* @__PURE__ */ i.createElement("svg", h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 341.33"
  }, r), n && /* @__PURE__ */ i.createElement("title", null, n), /* @__PURE__ */ i.createElement("path", {
    fill: "#0052B4",
    d: "M0 0h512v341.34H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    d: "m220.72 42.63 7.95 16.11 17.77 2.58-12.86 12.54 3.04 17.7-15.9-8.36-15.9 8.36 3.03-17.7-12.86-12.54 17.78-2.58zm70.56-.06 7.95 16.1 17.78 2.59-12.86 12.53 3.03 17.71-15.9-8.36-15.9 8.36 3.04-17.71-12.86-12.53 17.77-2.59zm62.08 11.36 7.95 16.11 17.77 2.58-12.86 12.54 3.04 17.7-15.9-8.35-15.9 8.35 3.04-17.7-12.87-12.54 17.78-2.58zm63.01 18.3 7.95 16.11 17.77 2.59-12.86 12.53 3.04 17.71-15.9-8.36-15.9 8.36 3.03-17.71-12.86-12.53 17.78-2.59zm-257.73-18.3 7.95 16.11 17.78 2.58-12.87 12.54 3.04 17.7-15.9-8.35-15.9 8.35 3.04-17.7-12.86-12.54 17.77-2.58zm-63.01 18.3 7.95 16.11 17.78 2.59-12.86 12.53 3.03 17.71-15.9-8.36-15.9 8.36 3.04-17.71-12.86-12.53 17.77-2.59z",
    fill: "#FFF"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFDA44",
    d: "m217.53 259.33-27.22-13.61-27.22-54.43h27.22l27.22-27.22 13.61-27.22 27.22-13.61 13.61 13.61 27.22 13.61v13.61l13.61 13.61 40.83 27.22L340 245.73l-40.83 40.83-13.61-27.22-40.83 27.22v27.22l-13.61-13.61-13.59-40.84z"
  }));
}, VT = function(e) {
  var n = e.title, r = v(e, aF);
  return /* @__PURE__ */ i.createElement("svg", h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ i.createElement("title", null, n), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFF",
    d: "M0 85.337h512v341.326H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#D80027",
    d: "M0 85.337h512v113.775H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    d: "M0 312.888h512v113.775H0z"
  }));
}, UT = function(e) {
  var n = e.title, r = v(e, iF);
  return /* @__PURE__ */ i.createElement("svg", h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 90 60"
  }, r), n && /* @__PURE__ */ i.createElement("title", null, n), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFF",
    d: "M0 0h90v60H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    stroke: "#7f7f7f",
    strokeWidth: 0.25,
    fill: "#ABABAB",
    d: "M75.6 39.6c-1.1.7 0 1.8-.6 1.9-.6.1-1.5-1.4-.2-2.5 1.6-1.5 5.8 0 5.9 4.3 0 2.2-.9 6.8-7.2 6.8-7.6 0-11.4-5.7-11.4-11.4 0-4.8 3.7-13.5 6.5-14.6 3.1-1.2 6.7-3.5 6.8-5 0-.5-1.4-.1-3.3.9-3.1 1.7-6.6 2.5-6.6 1.4s2.9-3.1 4-4.6c1.2-1.6.9-5.5 3-5.5 7.6 0 9.9 7.7 7 11.7-1.9 2.6 4.3 1 4.3 1s0 5.3-3.2 7.3c-3 1.8-4.8 3.9-4.8 3.9s.2-4.6-.5-3.9c-.6.7-11.1 4.5-10.3 12 .3 3 4.5 5.4 8.5 5.2s5.7-2.4 5.8-4.9c.1-3.9-3-4.4-3.7-4zm-64.9 4c.1 2.5 1.8 4.7 5.8 4.9s8.2-2.2 8.5-5.2c.8-7.5-9.7-11.3-10.3-12-.7-.7-.5 3.9-.5 3.9s-1.8-2.1-4.8-3.9c-3.2-2-3.2-7.3-3.2-7.3s6.2 1.6 4.3-1c-2.9-4-.6-11.7 7-11.7 2.1 0 1.8 3.9 3 5.5 1.1 1.5 4 3.5 4 4.6s-3.5.3-6.6-1.4c-1.9-1-3.3-1.4-3.3-.9.1 1.5 3.7 3.8 6.8 5 2.8 1.1 6.5 9.8 6.5 14.6 0 5.7-3.8 11.4-11.4 11.4-6.3 0-7.2-4.6-7.2-6.8.1-4.3 4.3-5.8 5.9-4.3 1.2 1.1.4 2.7-.2 2.5-.6-.1.6-1.2-.6-1.9-.6-.4-3.7.1-3.7 4z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#DE393A",
    d: "M31 28.8v14c0 1.9 2.1 1.6 2.1 1.6h9.3c1.2 0 2.6 2.3 2.6 2.3s1.4-2.3 2.5-2.3h9.6s2 .2 2-1.8V28.7H31z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#3951A3",
    d: "M31 13.1h28v15.7H31z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFF",
    d: "M50.1 16.5c-.4 2.4-2.5 4.2-5.1 4.2-2.5 0-4.6-1.8-5.1-4.2-.5.9-.8 1.9-.8 3 0 3.3 2.6 5.9 5.9 5.9 3.3 0 5.9-2.6 5.9-5.9 0-1.1-.3-2.1-.8-3z"
  }), /* @__PURE__ */ i.createElement("circle", {
    fill: "#FEE05F",
    cx: 39.1,
    cy: 36.5,
    r: 3
  }), /* @__PURE__ */ i.createElement("circle", {
    fill: "#FEE05F",
    cx: 50.9,
    cy: 36.5,
    r: 3
  }));
}, WT = function(e) {
  var n = e.title, r = v(e, oF);
  return /* @__PURE__ */ i.createElement("svg", h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ i.createElement("title", null, n), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFF",
    d: "M0 85.337h512v341.326H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    d: "M114.024 256.001 0 141.926v228.17z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#ffb915",
    d: "M161.192 256 0 94.7v47.226l114.024 114.075L0 370.096v47.138z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#007847",
    d: "M509.833 289.391c.058-.44.804-.878 2.167-1.318v-65.464H222.602L85.33 85.337H0V94.7L161.192 256 0 417.234v9.429h85.33l137.272-137.272h287.231z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#000c8a",
    d: "M503.181 322.783H236.433l-103.881 103.88H512v-103.88z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#e1392d",
    d: "M503.181 189.217H512V85.337H132.552l103.881 103.88z"
  }));
}, GT = function(e) {
  var n = e.title, r = v(e, lF);
  return /* @__PURE__ */ i.createElement("svg", h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ i.createElement("title", null, n), /* @__PURE__ */ i.createElement("path", {
    fill: "#496E2D",
    d: "M0 85.331h512v341.337H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#FF9811",
    d: "M490.668 195.476h-48c0-8.836-7.164-16-16-16s-16 7.164-16 16h-48c0 8.836 7.697 16 16.533 16h-.533c0 8.836 7.162 16 16 16 0 8.836 7.162 16 16 16h32c8.836 0 16-7.164 16-16 8.836 0 16-7.164 16-16h-.533c8.837 0 16.533-7.164 16.533-16z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#D80027",
    d: "M341.337 255.994h56.888v170.663h-56.888z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#FF9811",
    d: "M455.112 255.994H512v170.663h-56.888z"
  }), /* @__PURE__ */ i.createElement("path", {
    d: "M398.225 255.994h56.888v170.663h-56.888z"
  }));
}, KT = function(e) {
  var n = e.title, r = v(e, sF);
  return /* @__PURE__ */ i.createElement("svg", h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ i.createElement("title", null, n), /* @__PURE__ */ i.createElement("path", {
    d: "M0 85.333h512V426.67H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    d: "M0 134.196h512v48.868H0zm0 195.472h512v48.868H0z",
    fill: "#FFDA44"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#057f44",
    d: "M0 85.333h512v48.868H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    d: "M0 183.069h512v48.868H0zm0 97.737h512v48.868H0z",
    fill: "#D80027"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#057f44",
    d: "M0 378.542h512v48.128H0z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFF",
    d: "M276.992 255.996 106.329 426.659H0V85.333h106.329z"
  }), /* @__PURE__ */ i.createElement("path", {
    d: "M256 255.996 85.334 426.662h20.987l170.667-170.666L106.321 85.33H85.334z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#D80027",
    d: "m102.465 202.57 13.259 40.812h42.917l-34.718 25.226 13.26 40.814-34.718-25.224-34.72 25.224 13.262-40.814-34.718-25.226h42.915z"
  }), /* @__PURE__ */ i.createElement("path", {
    fill: "#FFDA44",
    d: "m138.94 259.335-34.559-12.243s-2.553-23.955-2.708-24.766c-1.173-6.18-6.603-10.851-13.123-10.851-7.376 0-13.357 5.98-13.357 13.357 0 1.223.178 2.402.486 3.528l-9.689 9.755h17.229c0 17.882-13.344 17.882-13.344 35.691l7.402 17.809h44.522l7.422-17.809h-.004a17.782 17.782 0 0 0 1.381-5.231c6.397-2.589 8.342-9.24 8.342-9.24z"
  }));
};
const qT = {
  AC: dF,
  AD: uF,
  AE: fF,
  AF: pF,
  AG: mF,
  AI: hF,
  AL: vF,
  AM: gF,
  AO: yF,
  AQ: bF,
  AR: EF,
  AS: wF,
  AT: $F,
  AU: xF,
  AW: CF,
  AX: MF,
  AZ: SF,
  BA: FF,
  BB: PF,
  BD: NF,
  BE: _F,
  BF: TF,
  BG: AF,
  BH: zF,
  BI: DF,
  BJ: IF,
  BL: kF,
  BM: OF,
  BN: LF,
  BO: RF,
  BQ: HF,
  BR: BF,
  BS: jF,
  BT: VF,
  BV: UF,
  BW: WF,
  BY: GF,
  BZ: KF,
  CA: qF,
  CC: YF,
  CD: ZF,
  CF: XF,
  CG: JF,
  CH: QF,
  CI: eP,
  CK: tP,
  CL: nP,
  CM: rP,
  CN: aP,
  CO: iP,
  CR: oP,
  CU: lP,
  CV: sP,
  CW: cP,
  CX: dP,
  CY: uP,
  CZ: fP,
  DE: pP,
  DJ: mP,
  DK: hP,
  DM: vP,
  DO: gP,
  DZ: yP,
  EC: bP,
  EE: EP,
  EG: wP,
  EH: $P,
  ER: xP,
  ES: CP,
  ET: MP,
  EU: SP,
  FI: FP,
  FJ: PP,
  FK: NP,
  FM: _P,
  FO: TP,
  FR: AP,
  GA: zP,
  GB: DP,
  GD: IP,
  GE: kP,
  GF: OP,
  GG: LP,
  GH: RP,
  GI: HP,
  GL: BP,
  GM: jP,
  GN: VP,
  GP: UP,
  GQ: WP,
  GR: GP,
  GS: KP,
  GT: qP,
  GU: YP,
  GW: ZP,
  GY: XP,
  HK: JP,
  HM: QP,
  HN: eN,
  HR: tN,
  HT: nN,
  HU: rN,
  IC: aN,
  ID: iN,
  IE: oN,
  IL: lN,
  IM: sN,
  IN: cN,
  IO: dN,
  IQ: uN,
  IR: fN,
  IS: pN,
  IT: mN,
  JE: hN,
  JM: vN,
  JO: gN,
  JP: yN,
  KE: bN,
  KG: EN,
  KH: wN,
  KI: $N,
  KM: xN,
  KN: CN,
  KP: MN,
  KR: SN,
  KW: FN,
  KY: PN,
  KZ: NN,
  LA: _N,
  LB: TN,
  LC: AN,
  LI: zN,
  LK: DN,
  LR: IN,
  LS: kN,
  LT: ON,
  LU: LN,
  LV: RN,
  LY: HN,
  MA: BN,
  MC: jN,
  MD: VN,
  ME: UN,
  MF: WN,
  MG: GN,
  MH: KN,
  MK: qN,
  ML: YN,
  MM: ZN,
  MN: XN,
  MO: JN,
  MP: QN,
  MQ: e_,
  MR: t_,
  MS: n_,
  MT: r_,
  MU: a_,
  MV: i_,
  MW: o_,
  MX: l_,
  MY: s_,
  MZ: c_,
  NA: d_,
  NC: u_,
  NE: f_,
  NF: p_,
  NG: m_,
  NI: h_,
  NL: v_,
  NO: g_,
  NP: y_,
  NR: b_,
  NU: E_,
  NZ: w_,
  OM: $_,
  PA: x_,
  PE: C_,
  PF: M_,
  PG: S_,
  PH: F_,
  PK: P_,
  PL: N_,
  PM: __,
  PN: T_,
  PR: A_,
  PS: z_,
  PT: D_,
  PW: I_,
  PY: k_,
  QA: O_,
  RE: L_,
  RO: R_,
  RS: H_,
  RU: B_,
  RW: j_,
  SA: V_,
  SB: U_,
  SC: W_,
  SD: G_,
  SE: K_,
  SG: q_,
  SH: Y_,
  SI: Z_,
  SJ: X_,
  SK: J_,
  SL: Q_,
  SM: eT,
  SN: tT,
  SO: nT,
  SR: rT,
  SS: aT,
  ST: iT,
  SV: oT,
  SX: lT,
  SY: sT,
  SZ: cT,
  TA: dT,
  TC: uT,
  TD: fT,
  TF: pT,
  TG: mT,
  TH: hT,
  TJ: vT,
  TK: gT,
  TL: yT,
  TM: bT,
  TN: ET,
  TO: wT,
  TR: $T,
  TT: xT,
  TV: CT,
  TW: MT,
  TZ: ST,
  UA: FT,
  UG: PT,
  UM: NT,
  US: _T,
  UY: TT,
  UZ: AT,
  VA: zT,
  VC: DT,
  VE: IT,
  VG: kT,
  VI: OT,
  VN: LT,
  VU: RT,
  WF: HT,
  WS: BT,
  XK: jT,
  YE: VT,
  YT: UT,
  ZA: WT,
  ZM: GT,
  ZW: KT
};
function _O() {
  if (typeof navigator > "u") return;
  const t = navigator.language ?? "en-US";
  return new Intl.Locale(t).region;
}
const YT = $.forwardRef(
  ({ className: t, onChange: e, value: n, ...r }, a) => /* @__PURE__ */ p(
    x$,
    {
      ref: a,
      className: fe("flex", t),
      flagComponent: ks,
      countrySelectComponent: ZT,
      inputComponent: I0,
      smartCaret: !1,
      value: n || void 0,
      onChange: (o) => e?.(o || ""),
      ...r
    }
  )
);
YT.displayName = "PhoneInput";
const I0 = $.forwardRef(({ className: t, ...e }, n) => /* @__PURE__ */ p(
  $a,
  {
    className: fe(
      "rounded-s-none rounded-e-lg focus-visible:ring-[0px]",
      t
    ),
    ...e,
    ref: n
  }
));
I0.displayName = "InputComponent";
const ZT = ({
  disabled: t,
  value: e,
  options: n,
  onChange: r
}) => {
  const { t: a } = Ae(), o = $.useRef(null), [l, s] = $.useState(""), [c, d] = $.useState(!1);
  return /* @__PURE__ */ S(l4, { open: c, onOpenChange: d, modal: !0, children: [
    /* @__PURE__ */ p(s4, { asChild: !0, children: /* @__PURE__ */ S(
      mt,
      {
        type: "button",
        variant: "outline",
        dir: "ltr",
        className: "flex !min-h-12 gap-1 rounded-s-lg rounded-e-none border-r-0 bg-transparent px-3 focus:z-10",
        disabled: t,
        children: [
          /* @__PURE__ */ p(
            ks,
            {
              country: e,
              countryName: e
            }
          ),
          /* @__PURE__ */ p(
            Q4,
            {
              className: fe(
                "-mr-2 size-4 opacity-50",
                t ? "hidden" : "opacity-100"
              )
            }
          )
        ]
      }
    ) }),
    /* @__PURE__ */ p(c4, { className: "w-[300px] p-0", children: /* @__PURE__ */ S(nu, { children: [
      /* @__PURE__ */ p(
        d4,
        {
          value: l,
          onValueChange: (u) => {
            s(u), setTimeout(() => {
              if (o.current) {
                const f = o.current.querySelector(
                  "[data-radix-scroll-area-viewport]"
                );
                f && (f.scrollTop = 0);
              }
            }, 0);
          },
          placeholder: a("shared.common.searchCountry")
        }
      ),
      /* @__PURE__ */ p(ru, { children: /* @__PURE__ */ S(u4, { ref: o, className: "h-72", children: [
        /* @__PURE__ */ p(f4, { children: "No country found." }),
        /* @__PURE__ */ p(au, { children: n.map(
          ({ value: u, label: f }) => u ? /* @__PURE__ */ p(
            XT,
            {
              country: u,
              countryName: f,
              selectedCountry: e,
              onChange: r,
              onSelectComplete: () => d(!1)
            },
            u
          ) : null
        ) })
      ] }) })
    ] }) })
  ] });
}, XT = ({
  country: t,
  countryName: e,
  selectedCountry: n,
  onChange: r,
  onSelectComplete: a
}) => /* @__PURE__ */ S(iu, { className: "gap-2", onSelect: () => {
  r(t), a();
}, children: [
  /* @__PURE__ */ p(ks, { country: t, countryName: e }),
  /* @__PURE__ */ p("span", { className: "flex-1 text-sm", children: e }),
  /* @__PURE__ */ p("span", { className: "text-foreground/50 text-sm", children: `+${C$(t)}` }),
  /* @__PURE__ */ p(
    zr,
    {
      className: `ml-auto size-4 ${t === n ? "opacity-100" : "opacity-0"}`
    }
  )
] }), ks = ({ country: t, countryName: e }) => {
  const n = qT[t];
  return /* @__PURE__ */ p("span", { className: "bg-foreground/20 flex h-4 w-6 overflow-hidden rounded-sm [&_svg:not([class*='size-'])]:size-full", children: n && /* @__PURE__ */ p(n, { title: e }) });
}, cn = typeof document < "u" ? i.useLayoutEffect : () => {
};
var Wo;
const JT = (Wo = i.useInsertionEffect) !== null && Wo !== void 0 ? Wo : cn;
function Ve(t) {
  const e = $e(null);
  return JT(() => {
    e.current = t;
  }, [
    t
  ]), de((...n) => {
    const r = e.current;
    return r?.(...n);
  }, []);
}
function QT(t) {
  let [e, n] = ve(t), r = $e(null), a = Ve(() => {
    if (!r.current) return;
    let l = r.current.next();
    if (l.done) {
      r.current = null;
      return;
    }
    e === l.value ? a() : n(l.value);
  });
  cn(() => {
    r.current && a();
  });
  let o = Ve((l) => {
    r.current = l(e), a();
  });
  return [
    e,
    o
  ];
}
const Si = {
  prefix: String(Math.round(Math.random() * 1e10)),
  current: 0
}, k0 = /* @__PURE__ */ i.createContext(Si), eA = /* @__PURE__ */ i.createContext(!1);
let tA = !!(typeof window < "u" && window.document && window.document.createElement), Go = /* @__PURE__ */ new WeakMap();
function nA(t = !1) {
  let e = St(k0), n = $e(null);
  if (n.current === null && !t) {
    var r, a;
    let o = (a = i.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED) === null || a === void 0 || (r = a.ReactCurrentOwner) === null || r === void 0 ? void 0 : r.current;
    if (o) {
      let l = Go.get(o);
      l == null ? Go.set(o, {
        id: e.current,
        state: o.memoizedState
      }) : o.memoizedState !== l.state && (e.current = l.id, Go.delete(o));
    }
    n.current = ++e.current;
  }
  return n.current;
}
function rA(t) {
  let e = St(k0);
  e === Si && !tA && process.env.NODE_ENV !== "production" && console.warn("When server rendering, you must wrap your application in an <SSRProvider> to ensure consistent ids are generated between the client and server.");
  let n = nA(!!t), r = e === Si && process.env.NODE_ENV === "test" ? "react-aria" : `react-aria${e.prefix}`;
  return t || `${r}-${n}`;
}
function aA(t) {
  let e = i.useId(), [n] = ve(O0()), r = n || process.env.NODE_ENV === "test" ? "react-aria" : `react-aria${Si.prefix}`;
  return t || `${r}-${e}`;
}
const iA = typeof i.useId == "function" ? aA : rA;
function oA() {
  return !1;
}
function lA() {
  return !0;
}
function sA(t) {
  return () => {
  };
}
function O0() {
  return typeof i.useSyncExternalStore == "function" ? i.useSyncExternalStore(sA, oA, lA) : St(eA);
}
let cA = !!(typeof window < "u" && window.document && window.document.createElement), or = /* @__PURE__ */ new Map(), Nr;
typeof FinalizationRegistry < "u" && (Nr = new FinalizationRegistry((t) => {
  or.delete(t);
}));
function Rt(t) {
  let [e, n] = ve(t), r = $e(null), a = iA(e), o = $e(null);
  if (Nr && Nr.register(o, a), cA) {
    const l = or.get(a);
    l && !l.includes(r) ? l.push(r) : or.set(a, [
      r
    ]);
  }
  return cn(() => {
    let l = a;
    return () => {
      Nr && Nr.unregister(o), or.delete(l);
    };
  }, [
    a
  ]), xe(() => {
    let l = r.current;
    return l && n(l), () => {
      l && (r.current = null);
    };
  }), a;
}
function dA(t, e) {
  if (t === e) return t;
  let n = or.get(t);
  if (n)
    return n.forEach((a) => a.current = e), e;
  let r = or.get(e);
  return r ? (r.forEach((a) => a.current = t), t) : e;
}
function J1(t = []) {
  let e = Rt(), [n, r] = QT(e), a = de(() => {
    r(function* () {
      yield e, yield document.getElementById(e) ? e : void 0;
    });
  }, [
    e,
    r
  ]);
  return cn(a, [
    e,
    a,
    ...t
  ]), n;
}
function Os(...t) {
  return (...e) => {
    for (let n of t) typeof n == "function" && n(...e);
  };
}
const qe = (t) => {
  var e;
  return (e = t?.ownerDocument) !== null && e !== void 0 ? e : document;
}, nt = (t) => t && "window" in t && t.window === t ? t : qe(t).defaultView || window;
function uA(t) {
  return t !== null && typeof t == "object" && "nodeType" in t && typeof t.nodeType == "number";
}
function fA(t) {
  return uA(t) && t.nodeType === Node.DOCUMENT_FRAGMENT_NODE && "host" in t;
}
let pA = !1;
function Ls() {
  return pA;
}
function Le(t, e) {
  if (!Ls()) return e && t ? t.contains(e) : !1;
  if (!t || !e) return !1;
  let n = e;
  for (; n !== null; ) {
    if (n === t) return !0;
    n.tagName === "SLOT" && n.assignedSlot ? n = n.assignedSlot.parentNode : fA(n) ? n = n.host : n = n.parentNode;
  }
  return !1;
}
const ga = (t = document) => {
  var e;
  if (!Ls()) return t.activeElement;
  let n = t.activeElement;
  for (; n && "shadowRoot" in n && (!((e = n.shadowRoot) === null || e === void 0) && e.activeElement); ) n = n.shadowRoot.activeElement;
  return n;
};
function Te(t) {
  return Ls() && t.target.shadowRoot && t.composedPath ? t.composedPath()[0] : t.target;
}
function L0(t) {
  var e, n, r = "";
  if (typeof t == "string" || typeof t == "number") r += t;
  else if (typeof t == "object") if (Array.isArray(t)) {
    var a = t.length;
    for (e = 0; e < a; e++) t[e] && (n = L0(t[e])) && (r && (r += " "), r += n);
  } else for (n in t) t[n] && (r && (r += " "), r += n);
  return r;
}
function mA() {
  for (var t, e, n = 0, r = "", a = arguments.length; n < a; n++) (t = arguments[n]) && (e = L0(t)) && (r && (r += " "), r += e);
  return r;
}
function Ye(...t) {
  let e = {
    ...t[0]
  };
  for (let n = 1; n < t.length; n++) {
    let r = t[n];
    for (let a in r) {
      let o = e[a], l = r[a];
      typeof o == "function" && typeof l == "function" && // This is a lot faster than a regex.
      a[0] === "o" && a[1] === "n" && a.charCodeAt(2) >= /* 'A' */
      65 && a.charCodeAt(2) <= /* 'Z' */
      90 ? e[a] = Os(o, l) : (a === "className" || a === "UNSAFE_className") && typeof o == "string" && typeof l == "string" ? e[a] = mA(o, l) : a === "id" && o && l ? e.id = dA(o, l) : e[a] = l !== void 0 ? l : o;
    }
  }
  return e;
}
function hA(...t) {
  return t.length === 1 && t[0] ? t[0] : (e) => {
    let n = !1;
    const r = t.map((a) => {
      const o = Q1(a, e);
      return n || (n = typeof o == "function"), o;
    });
    if (n) return () => {
      r.forEach((a, o) => {
        typeof a == "function" ? a() : Q1(t[o], null);
      });
    };
  };
}
function Q1(t, e) {
  if (typeof t == "function") return t(e);
  t != null && (t.current = e);
}
const vA = /* @__PURE__ */ new Set([
  "id"
]), gA = /* @__PURE__ */ new Set([
  "aria-label",
  "aria-labelledby",
  "aria-describedby",
  "aria-details"
]), yA = /* @__PURE__ */ new Set([
  "href",
  "hrefLang",
  "target",
  "rel",
  "download",
  "ping",
  "referrerPolicy"
]), bA = /* @__PURE__ */ new Set([
  "dir",
  "lang",
  "hidden",
  "inert",
  "translate"
]), ed = /* @__PURE__ */ new Set([
  "onClick",
  "onAuxClick",
  "onContextMenu",
  "onDoubleClick",
  "onMouseDown",
  "onMouseEnter",
  "onMouseLeave",
  "onMouseMove",
  "onMouseOut",
  "onMouseOver",
  "onMouseUp",
  "onTouchCancel",
  "onTouchEnd",
  "onTouchMove",
  "onTouchStart",
  "onPointerDown",
  "onPointerMove",
  "onPointerUp",
  "onPointerCancel",
  "onPointerEnter",
  "onPointerLeave",
  "onPointerOver",
  "onPointerOut",
  "onGotPointerCapture",
  "onLostPointerCapture",
  "onScroll",
  "onWheel",
  "onAnimationStart",
  "onAnimationEnd",
  "onAnimationIteration",
  "onTransitionCancel",
  "onTransitionEnd",
  "onTransitionRun",
  "onTransitionStart"
]), EA = /^(data-.*)$/;
function Pa(t, e = {}) {
  let { labelable: n, isLink: r, global: a, events: o = a, propNames: l } = e, s = {};
  for (const c in t) Object.prototype.hasOwnProperty.call(t, c) && (vA.has(c) || n && gA.has(c) || r && yA.has(c) || a && bA.has(c) || o && ed.has(c) || c.endsWith("Capture") && ed.has(c.slice(0, -7)) || l?.has(c) || EA.test(c)) && (s[c] = t[c]);
  return s;
}
function mr(t) {
  if (wA()) t.focus({
    preventScroll: !0
  });
  else {
    let e = $A(t);
    t.focus(), xA(e);
  }
}
let Ba = null;
function wA() {
  if (Ba == null) {
    Ba = !1;
    try {
      document.createElement("div").focus({
        get preventScroll() {
          return Ba = !0, !0;
        }
      });
    } catch {
    }
  }
  return Ba;
}
function $A(t) {
  let e = t.parentNode, n = [], r = document.scrollingElement || document.documentElement;
  for (; e instanceof HTMLElement && e !== r; )
    (e.offsetHeight < e.scrollHeight || e.offsetWidth < e.scrollWidth) && n.push({
      element: e,
      scrollTop: e.scrollTop,
      scrollLeft: e.scrollLeft
    }), e = e.parentNode;
  return r instanceof HTMLElement && n.push({
    element: r,
    scrollTop: r.scrollTop,
    scrollLeft: r.scrollLeft
  }), n;
}
function xA(t) {
  for (let { element: e, scrollTop: n, scrollLeft: r } of t)
    e.scrollTop = n, e.scrollLeft = r;
}
function Qi(t) {
  var e;
  if (typeof window > "u" || window.navigator == null) return !1;
  let n = (e = window.navigator.userAgentData) === null || e === void 0 ? void 0 : e.brands;
  return Array.isArray(n) && n.some((r) => t.test(r.brand)) || t.test(window.navigator.userAgent);
}
function Rs(t) {
  var e;
  return typeof window < "u" && window.navigator != null ? t.test(((e = window.navigator.userAgentData) === null || e === void 0 ? void 0 : e.platform) || window.navigator.platform) : !1;
}
function Gt(t) {
  if (process.env.NODE_ENV === "test") return t;
  let e = null;
  return () => (e == null && (e = t()), e);
}
const hr = Gt(function() {
  return Rs(/^Mac/i);
}), R0 = Gt(function() {
  return Rs(/^iPhone/i);
}), H0 = Gt(function() {
  return Rs(/^iPad/i) || // iPadOS 13 lies and says it's a Mac, but we can distinguish by detecting touch support.
  hr() && navigator.maxTouchPoints > 1;
}), eo = Gt(function() {
  return R0() || H0();
});
Gt(function() {
  return hr() || eo();
});
const CA = Gt(function() {
  return Qi(/AppleWebKit/i) && !MA();
}), MA = Gt(function() {
  return Qi(/Chrome/i);
}), Hs = Gt(function() {
  return Qi(/Android/i);
}), SA = Gt(function() {
  return Qi(/Firefox/i);
});
function ya(t, e, n = !0) {
  var r, a;
  let { metaKey: o, ctrlKey: l, altKey: s, shiftKey: c } = e;
  SA() && (!((a = window.event) === null || a === void 0 || (r = a.type) === null || r === void 0) && r.startsWith("key")) && t.target === "_blank" && (hr() ? o = !0 : l = !0);
  let d = CA() && hr() && !H0() && process.env.NODE_ENV !== "test" ? new KeyboardEvent("keydown", {
    keyIdentifier: "Enter",
    metaKey: o,
    ctrlKey: l,
    altKey: s,
    shiftKey: c
  }) : new MouseEvent("click", {
    metaKey: o,
    ctrlKey: l,
    altKey: s,
    shiftKey: c,
    bubbles: !0,
    cancelable: !0
  });
  ya.isOpening = n, mr(t), t.dispatchEvent(d), ya.isOpening = !1;
}
ya.isOpening = !1;
let Qt = /* @__PURE__ */ new Map(), Gl = /* @__PURE__ */ new Set();
function td() {
  if (typeof window > "u") return;
  function t(r) {
    return "propertyName" in r;
  }
  let e = (r) => {
    if (!t(r) || !r.target) return;
    let a = Qt.get(r.target);
    a || (a = /* @__PURE__ */ new Set(), Qt.set(r.target, a), r.target.addEventListener("transitioncancel", n, {
      once: !0
    })), a.add(r.propertyName);
  }, n = (r) => {
    if (!t(r) || !r.target) return;
    let a = Qt.get(r.target);
    if (a && (a.delete(r.propertyName), a.size === 0 && (r.target.removeEventListener("transitioncancel", n), Qt.delete(r.target)), Qt.size === 0)) {
      for (let o of Gl) o();
      Gl.clear();
    }
  };
  document.body.addEventListener("transitionrun", e), document.body.addEventListener("transitionend", n);
}
typeof document < "u" && (document.readyState !== "loading" ? td() : document.addEventListener("DOMContentLoaded", td));
function FA() {
  for (const [t] of Qt)
    "isConnected" in t && !t.isConnected && Qt.delete(t);
}
function B0(t) {
  requestAnimationFrame(() => {
    FA(), Qt.size === 0 ? t() : Gl.add(t);
  });
}
function to() {
  let t = $e(/* @__PURE__ */ new Map()), e = de((a, o, l, s) => {
    let c = s?.once ? (...d) => {
      t.current.delete(l), l(...d);
    } : l;
    t.current.set(l, {
      type: o,
      eventTarget: a,
      fn: c,
      options: s
    }), a.addEventListener(o, c, s);
  }, []), n = de((a, o, l, s) => {
    var c;
    let d = ((c = t.current.get(l)) === null || c === void 0 ? void 0 : c.fn) || l;
    a.removeEventListener(o, d, s), t.current.delete(l);
  }, []), r = de(() => {
    t.current.forEach((a, o) => {
      n(a.eventTarget, a.type, o, a.options);
    });
  }, [
    n
  ]);
  return xe(() => r, [
    r
  ]), {
    addGlobalListener: e,
    removeGlobalListener: n,
    removeAllGlobalListeners: r
  };
}
function PA(t, e) {
  let { id: n, "aria-label": r, "aria-labelledby": a } = t;
  return n = Rt(n), a && r ? a = [
    .../* @__PURE__ */ new Set([
      n,
      ...a.trim().split(/\s+/)
    ])
  ].join(" ") : a && (a = a.trim().split(/\s+/).join(" ")), !r && !a && e && (r = e), {
    id: n,
    "aria-label": r,
    "aria-labelledby": a
  };
}
function NA(t) {
  const e = $e(null), n = $e(void 0), r = de((a) => {
    if (typeof t == "function") {
      const o = t, l = o(a);
      return () => {
        typeof l == "function" ? l() : o(null);
      };
    } else if (t)
      return t.current = a, () => {
        t.current = null;
      };
  }, [
    t
  ]);
  return Fe(() => ({
    get current() {
      return e.current;
    },
    set current(a) {
      e.current = a, n.current && (n.current(), n.current = void 0), a != null && (n.current = r(a));
    }
  }), [
    r
  ]);
}
function j0(t, e) {
  cn(() => {
    if (t && t.ref && e)
      return t.ref.current = e.current, () => {
        t.ref && (t.ref.current = null);
      };
  });
}
function _A(t, e, n, r) {
  let a = Ve(n), o = n == null;
  xe(() => {
    if (o || !t.current) return;
    let l = t.current;
    return l.addEventListener(e, a, r), () => {
      l.removeEventListener(e, a, r);
    };
  }, [
    t,
    e,
    r,
    o,
    a
  ]);
}
function Kl(t) {
  return t.pointerType === "" && t.isTrusted ? !0 : Hs() && t.pointerType ? t.type === "click" && t.buttons === 1 : t.detail === 0 && !t.pointerType;
}
function TA(t) {
  return !Hs() && t.width === 0 && t.height === 0 || t.width === 1 && t.height === 1 && t.pressure === 0 && t.detail === 0 && t.pointerType === "mouse";
}
function V0(t, e, n) {
  let r = Ve(() => {
    n && n(e);
  });
  xe(() => {
    var a;
    let o = t == null || (a = t.current) === null || a === void 0 ? void 0 : a.form;
    return o?.addEventListener("reset", r), () => {
      o?.removeEventListener("reset", r);
    };
  }, [
    t,
    r
  ]);
}
const AA = typeof Element < "u" && "checkVisibility" in Element.prototype;
function zA(t) {
  const e = nt(t);
  if (!(t instanceof e.HTMLElement) && !(t instanceof e.SVGElement)) return !1;
  let { display: n, visibility: r } = t.style, a = n !== "none" && r !== "hidden" && r !== "collapse";
  if (a) {
    const { getComputedStyle: o } = t.ownerDocument.defaultView;
    let { display: l, visibility: s } = o(t);
    a = l !== "none" && s !== "hidden" && s !== "collapse";
  }
  return a;
}
function DA(t, e) {
  return !t.hasAttribute("hidden") && // Ignore HiddenSelect when tree walking.
  !t.hasAttribute("data-react-aria-prevent-focus") && (t.nodeName === "DETAILS" && e && e.nodeName !== "SUMMARY" ? t.hasAttribute("open") : !0);
}
function U0(t, e) {
  return AA ? t.checkVisibility({
    visibilityProperty: !0
  }) && !t.closest("[data-react-aria-prevent-focus]") : t.nodeName !== "#comment" && zA(t) && DA(t, e) && (!t.parentElement || U0(t.parentElement, t));
}
const W0 = [
  "input:not([disabled]):not([type=hidden])",
  "select:not([disabled])",
  "textarea:not([disabled])",
  "button:not([disabled])",
  "a[href]",
  "area[href]",
  "summary",
  "iframe",
  "object",
  "embed",
  "audio[controls]",
  "video[controls]",
  '[contenteditable]:not([contenteditable^="false"])',
  "permission"
], IA = W0.join(":not([hidden]),") + ",[tabindex]:not([disabled]):not([hidden])";
W0.push('[tabindex]:not([tabindex="-1"]):not([disabled])');
function kA(t) {
  return t.matches(IA) && U0(t) && !OA(t);
}
function OA(t) {
  let e = t;
  for (; e != null; ) {
    if (e instanceof e.ownerDocument.defaultView.HTMLElement && e.inert) return !0;
    e = e.parentElement;
  }
  return !1;
}
function G0(t, e, n) {
  let [r, a] = ve(t || e), o = $e(t !== void 0), l = t !== void 0;
  xe(() => {
    let d = o.current;
    d !== l && process.env.NODE_ENV !== "production" && console.warn(`WARN: A component changed from ${d ? "controlled" : "uncontrolled"} to ${l ? "controlled" : "uncontrolled"}.`), o.current = l;
  }, [
    l
  ]);
  let s = l ? t : r, c = de((d, ...u) => {
    let f = (m, ...g) => {
      n && (Object.is(s, m) || n(m, ...g)), l || (s = m);
    };
    typeof d == "function" ? (process.env.NODE_ENV !== "production" && console.warn("We can not support a function callback. See Github Issues for details https://github.com/adobe/react-spectrum/issues/2320"), a((g, ...C) => {
      let b = d(l ? s : g, ...C);
      return f(b, ...u), l ? g : b;
    })) : (l || a(d), f(d, ...u));
  }, [
    l,
    s,
    n
  ]);
  return [
    s,
    c
  ];
}
function Ko(t, e = -1 / 0, n = 1 / 0) {
  return Math.min(Math.max(t, e), n);
}
function ja(t, e) {
  let n = t, r = 0, a = e.toString(), o = a.toLowerCase().indexOf("e-");
  if (o > 0) r = Math.abs(Math.floor(Math.log10(Math.abs(e)))) + o;
  else {
    let l = a.indexOf(".");
    l >= 0 && (r = a.length - l);
  }
  if (r > 0) {
    let l = Math.pow(10, r);
    n = Math.round(n * l) / l;
  }
  return n;
}
function _t(t, e, n, r) {
  e = Number(e), n = Number(n);
  let a = (t - (isNaN(e) ? 0 : e)) % r, o = ja(Math.abs(a) * 2 >= r ? t + Math.sign(a) * (r - Math.abs(a)) : t - a, r);
  return isNaN(e) ? !isNaN(n) && o > n && (o = Math.floor(ja(n / r, r)) * r) : o < e ? o = e : !isNaN(n) && o > n && (o = e + Math.floor(ja((n - e) / r, r)) * r), o = ja(o, r), o;
}
const LA = Symbol("default");
function RA({ values: t, children: e }) {
  for (let [n, r] of t)
    e = /* @__PURE__ */ i.createElement(n.Provider, {
      value: r
    }, e);
  return e;
}
function no(t) {
  let { className: e, style: n, children: r, defaultClassName: a, defaultChildren: o, defaultStyle: l, values: s } = t;
  return Fe(() => {
    let c, d, u;
    return typeof e == "function" ? c = e({
      ...s,
      defaultClassName: a
    }) : c = e, typeof n == "function" ? d = n({
      ...s,
      defaultStyle: l || {}
    }) : d = n, typeof r == "function" ? u = r({
      ...s,
      defaultChildren: o
    }) : r == null ? u = o : u = r, {
      className: c ?? a,
      style: d || l ? {
        ...l,
        ...d
      } : void 0,
      children: u ?? o,
      "data-rac": ""
    };
  }, [
    e,
    n,
    r,
    a,
    o,
    l,
    s
  ]);
}
function K0(t, e) {
  let n = St(t);
  if (e === null)
    return null;
  if (n && typeof n == "object" && "slots" in n && n.slots) {
    let r = e || LA;
    if (!n.slots[r]) {
      let a = new Intl.ListFormat().format(Object.keys(n.slots).map((l) => `"${l}"`)), o = e ? `Invalid slot "${e}".` : "A slot prop is required.";
      throw new Error(`${o} Valid slot names are ${a}.`);
    }
    return n.slots[r];
  }
  return n;
}
function Na(t, e, n) {
  let r = K0(n, t.slot) || {}, { ref: a, ...o } = r, l = NA(Fe(() => hA(e, a), [
    e,
    a
  ])), s = Ye(o, t);
  return "style" in o && o.style && "style" in t && t.style && (typeof o.style == "function" || typeof t.style == "function" ? s.style = (c) => {
    let d = typeof o.style == "function" ? o.style(c) : o.style, u = {
      ...c.defaultStyle,
      ...d
    }, f = typeof t.style == "function" ? t.style({
      ...c,
      defaultStyle: u
    }) : t.style;
    return {
      ...u,
      ...f
    };
  } : s.style = {
    ...o.style,
    ...t.style
  }), [
    s,
    l
  ];
}
function HA(t = !0) {
  let [e, n] = ve(t), r = $e(!1), a = de((o) => {
    r.current = !0, n(!!o);
  }, []);
  return cn(() => {
    r.current || n(!1);
  }, []), [
    a,
    e
  ];
}
function BA(t) {
  const e = /^(data-.*)$/;
  let n = {};
  for (const r in t) e.test(r) || (n[r] = t[r]);
  return n;
}
const q0 = 7e3;
let ot = null;
function ql(t, e = "assertive", n = q0) {
  ot ? ot.announce(t, e, n) : (ot = new VA(), (typeof IS_REACT_ACT_ENVIRONMENT == "boolean" ? IS_REACT_ACT_ENVIRONMENT : typeof jest < "u") ? ot.announce(t, e, n) : setTimeout(() => {
    ot?.isAttached() && ot?.announce(t, e, n);
  }, 100));
}
function jA(t) {
  ot && ot.clear(t);
}
class VA {
  isAttached() {
    var e;
    return (e = this.node) === null || e === void 0 ? void 0 : e.isConnected;
  }
  createLog(e) {
    let n = document.createElement("div");
    return n.setAttribute("role", "log"), n.setAttribute("aria-live", e), n.setAttribute("aria-relevant", "additions"), n;
  }
  destroy() {
    this.node && (document.body.removeChild(this.node), this.node = null);
  }
  announce(e, n = "assertive", r = q0) {
    var a, o;
    if (!this.node) return;
    let l = document.createElement("div");
    typeof e == "object" ? (l.setAttribute("role", "img"), l.setAttribute("aria-labelledby", e["aria-labelledby"])) : l.textContent = e, n === "assertive" ? (a = this.assertiveLog) === null || a === void 0 || a.appendChild(l) : (o = this.politeLog) === null || o === void 0 || o.appendChild(l), e !== "" && setTimeout(() => {
      l.remove();
    }, r);
  }
  clear(e) {
    this.node && ((!e || e === "assertive") && this.assertiveLog && (this.assertiveLog.innerHTML = ""), (!e || e === "polite") && this.politeLog && (this.politeLog.innerHTML = ""));
  }
  constructor() {
    this.node = null, this.assertiveLog = null, this.politeLog = null, typeof document < "u" && (this.node = document.createElement("div"), this.node.dataset.liveAnnouncer = "true", Object.assign(this.node.style, {
      border: 0,
      clip: "rect(0 0 0 0)",
      clipPath: "inset(50%)",
      height: "1px",
      margin: "-1px",
      overflow: "hidden",
      padding: 0,
      position: "absolute",
      width: "1px",
      whiteSpace: "nowrap"
    }), this.assertiveLog = this.createLog("assertive"), this.node.appendChild(this.assertiveLog), this.politeLog = this.createLog("polite"), this.node.appendChild(this.politeLog), document.body.prepend(this.node));
  }
}
const UA = /* @__PURE__ */ new Set([
  "Arab",
  "Syrc",
  "Samr",
  "Mand",
  "Thaa",
  "Mend",
  "Nkoo",
  "Adlm",
  "Rohg",
  "Hebr"
]), WA = /* @__PURE__ */ new Set([
  "ae",
  "ar",
  "arc",
  "bcc",
  "bqi",
  "ckb",
  "dv",
  "fa",
  "glk",
  "he",
  "ku",
  "mzn",
  "nqo",
  "pnb",
  "ps",
  "sd",
  "ug",
  "ur",
  "yi"
]);
function GA(t) {
  if (Intl.Locale) {
    let n = new Intl.Locale(t).maximize(), r = typeof n.getTextInfo == "function" ? n.getTextInfo() : n.textInfo;
    if (r) return r.direction === "rtl";
    if (n.script) return UA.has(n.script);
  }
  let e = t.split("-")[0];
  return WA.has(e);
}
const KA = Symbol.for("react-aria.i18n.locale");
function Y0() {
  let t = typeof window < "u" && window[KA] || typeof navigator < "u" && (navigator.language || navigator.userLanguage) || "en-US";
  try {
    Intl.DateTimeFormat.supportedLocalesOf([
      t
    ]);
  } catch {
    t = "en-US";
  }
  return {
    locale: t,
    direction: GA(t) ? "rtl" : "ltr"
  };
}
let Yl = Y0(), _r = /* @__PURE__ */ new Set();
function nd() {
  Yl = Y0();
  for (let t of _r) t(Yl);
}
function qA() {
  let t = O0(), [e, n] = ve(Yl);
  return xe(() => (_r.size === 0 && window.addEventListener("languagechange", nd), _r.add(n), () => {
    _r.delete(n), _r.size === 0 && window.removeEventListener("languagechange", nd);
  }), []), t ? {
    locale: "en-US",
    direction: "ltr"
  } : e;
}
const YA = /* @__PURE__ */ i.createContext(null);
function Bs() {
  let t = qA();
  return St(YA) || t;
}
const ZA = Symbol.for("react-aria.i18n.locale"), XA = Symbol.for("react-aria.i18n.strings");
let Un;
class ro {
  /** Returns a localized string for the given key and locale. */
  getStringForLocale(e, n) {
    let a = this.getStringsForLocale(n)[e];
    if (!a) throw new Error(`Could not find intl message ${e} in ${n} locale`);
    return a;
  }
  /** Returns all localized strings for the given locale. */
  getStringsForLocale(e) {
    let n = this.strings[e];
    return n || (n = JA(e, this.strings, this.defaultLocale), this.strings[e] = n), n;
  }
  static getGlobalDictionaryForPackage(e) {
    if (typeof window > "u") return null;
    let n = window[ZA];
    if (Un === void 0) {
      let a = window[XA];
      if (!a) return null;
      Un = {};
      for (let o in a) Un[o] = new ro({
        [n]: a[o]
      }, n);
    }
    let r = Un?.[e];
    if (!r) throw new Error(`Strings for package "${e}" were not included by LocalizedStringProvider. Please add it to the list passed to createLocalizedStringDictionary.`);
    return r;
  }
  constructor(e, n = "en-US") {
    this.strings = Object.fromEntries(Object.entries(e).filter(([, r]) => r)), this.defaultLocale = n;
  }
}
function JA(t, e, n = "en-US") {
  if (e[t]) return e[t];
  let r = QA(t);
  if (e[r]) return e[r];
  for (let a in e)
    if (a.startsWith(r + "-")) return e[a];
  return e[n];
}
function QA(t) {
  return Intl.Locale ? new Intl.Locale(t).language : t.split("-")[0];
}
const rd = /* @__PURE__ */ new Map(), ad = /* @__PURE__ */ new Map();
class ez {
  /** Formats a localized string for the given key with the provided variables. */
  format(e, n) {
    let r = this.strings.getStringForLocale(e, this.locale);
    return typeof r == "function" ? r(n, this) : r;
  }
  plural(e, n, r = "cardinal") {
    let a = n["=" + e];
    if (a) return typeof a == "function" ? a() : a;
    let o = this.locale + ":" + r, l = rd.get(o);
    l || (l = new Intl.PluralRules(this.locale, {
      type: r
    }), rd.set(o, l));
    let s = l.select(e);
    return a = n[s] || n.other, typeof a == "function" ? a() : a;
  }
  number(e) {
    let n = ad.get(this.locale);
    return n || (n = new Intl.NumberFormat(this.locale), ad.set(this.locale, n)), n.format(e);
  }
  select(e, n) {
    let r = e[n] || e.other;
    return typeof r == "function" ? r() : r;
  }
  constructor(e, n) {
    this.locale = e, this.strings = n;
  }
}
const id = /* @__PURE__ */ new WeakMap();
function tz(t) {
  let e = id.get(t);
  return e || (e = new ro(t), id.set(t, e)), e;
}
function nz(t, e) {
  return e && ro.getGlobalDictionaryForPackage(e) || tz(t);
}
function Z0(t, e) {
  let { locale: n } = Bs(), r = nz(t, e);
  return Fe(() => new ez(n, r), [
    n,
    r
  ]);
}
function rz(t, e) {
  if (e.has(t))
    throw new TypeError("Cannot initialize the same private elements twice on an object");
}
function az(t, e, n) {
  rz(t, e), e.set(t, n);
}
let qo = /* @__PURE__ */ new Map(), Zl = !1;
try {
  Zl = new Intl.NumberFormat("de-DE", {
    signDisplay: "exceptZero"
  }).resolvedOptions().signDisplay === "exceptZero";
} catch {
}
let Fi = !1;
try {
  Fi = new Intl.NumberFormat("de-DE", {
    style: "unit",
    unit: "degree"
  }).resolvedOptions().style === "unit";
} catch {
}
const X0 = {
  degree: {
    narrow: {
      default: "°",
      "ja-JP": " 度",
      "zh-TW": "度",
      "sl-SI": " °"
    }
  }
};
class Pi {
  /** Formats a number value as a string, according to the locale and options provided to the constructor. */
  format(e) {
    let n = "";
    if (!Zl && this.options.signDisplay != null ? n = oz(this.numberFormatter, this.options.signDisplay, e) : n = this.numberFormatter.format(e), this.options.style === "unit" && !Fi) {
      var r;
      let { unit: a, unitDisplay: o = "short", locale: l } = this.resolvedOptions();
      if (!a) return n;
      let s = (r = X0[a]) === null || r === void 0 ? void 0 : r[o];
      n += s[l] || s.default;
    }
    return n;
  }
  /** Formats a number to an array of parts such as separators, digits, punctuation, and more. */
  formatToParts(e) {
    return this.numberFormatter.formatToParts(e);
  }
  /** Formats a number range as a string. */
  formatRange(e, n) {
    if (typeof this.numberFormatter.formatRange == "function") return this.numberFormatter.formatRange(e, n);
    if (n < e) throw new RangeError("End date must be >= start date");
    return `${this.format(e)} – ${this.format(n)}`;
  }
  /** Formats a number range as an array of parts. */
  formatRangeToParts(e, n) {
    if (typeof this.numberFormatter.formatRangeToParts == "function") return this.numberFormatter.formatRangeToParts(e, n);
    if (n < e) throw new RangeError("End date must be >= start date");
    let r = this.numberFormatter.formatToParts(e), a = this.numberFormatter.formatToParts(n);
    return [
      ...r.map((o) => ({
        ...o,
        source: "startRange"
      })),
      {
        type: "literal",
        value: " – ",
        source: "shared"
      },
      ...a.map((o) => ({
        ...o,
        source: "endRange"
      }))
    ];
  }
  /** Returns the resolved formatting options based on the values passed to the constructor. */
  resolvedOptions() {
    let e = this.numberFormatter.resolvedOptions();
    return !Zl && this.options.signDisplay != null && (e = {
      ...e,
      signDisplay: this.options.signDisplay
    }), !Fi && this.options.style === "unit" && (e = {
      ...e,
      style: "unit",
      unit: this.options.unit,
      unitDisplay: this.options.unitDisplay
    }), e;
  }
  constructor(e, n = {}) {
    this.numberFormatter = iz(e, n), this.options = n;
  }
}
function iz(t, e = {}) {
  let { numberingSystem: n } = e;
  if (n && t.includes("-nu-") && (t.includes("-u-") || (t += "-u-"), t += `-nu-${n}`), e.style === "unit" && !Fi) {
    var r;
    let { unit: l, unitDisplay: s = "short" } = e;
    if (!l) throw new Error('unit option must be provided with style: "unit"');
    if (!(!((r = X0[l]) === null || r === void 0) && r[s])) throw new Error(`Unsupported unit ${l} with unitDisplay = ${s}`);
    e = {
      ...e,
      style: "decimal"
    };
  }
  let a = t + (e ? Object.entries(e).sort((l, s) => l[0] < s[0] ? -1 : 1).join() : "");
  if (qo.has(a)) return qo.get(a);
  let o = new Intl.NumberFormat(t, e);
  return qo.set(a, o), o;
}
function oz(t, e, n) {
  if (e === "auto") return t.format(n);
  if (e === "never") return t.format(Math.abs(n));
  {
    let r = !1;
    if (e === "always" ? r = n > 0 || Object.is(n, 0) : e === "exceptZero" && (Object.is(n, -0) || Object.is(n, 0) ? n = Math.abs(n) : r = n > 0), r) {
      let a = t.format(-n), o = t.format(n), l = a.replace(o, "").replace(/\u200e|\u061C/, "");
      return [
        ...l
      ].length !== 1 && console.warn("@react-aria/i18n polyfill for NumberFormat signDisplay: Unsupported case"), a.replace(o, "!!!").replace(l, "+").replace("!!!", o);
    } else return t.format(n);
  }
}
const lz = new RegExp("^.*\\(.*\\).*$"), sz = [
  "latn",
  "arab",
  "hanidec",
  "deva",
  "beng",
  "fullwide"
];
class J0 {
  /**
  * Parses the given string to a number. Returns NaN if a valid number could not be parsed.
  */
  parse(e) {
    return Yo(this.locale, this.options, e).parse(e);
  }
  /**
  * Returns whether the given string could potentially be a valid number. This should be used to
  * validate user input as the user types. If a `minValue` or `maxValue` is provided, the validity
  * of the minus/plus sign characters can be checked.
  */
  isValidPartialNumber(e, n, r) {
    return Yo(this.locale, this.options, e).isValidPartialNumber(e, n, r);
  }
  /**
  * Returns a numbering system for which the given string is valid in the current locale.
  * If no numbering system could be detected, the default numbering system for the current
  * locale is returned.
  */
  getNumberingSystem(e) {
    return Yo(this.locale, this.options, e).options.numberingSystem;
  }
  constructor(e, n = {}) {
    this.locale = e, this.options = n;
  }
}
const od = /* @__PURE__ */ new Map();
function Yo(t, e, n) {
  let r = ld(t, e);
  if (!t.includes("-nu-") && !r.isValidPartialNumber(n)) {
    for (let a of sz) if (a !== r.options.numberingSystem) {
      let o = ld(t + (t.includes("-u-") ? "-nu-" : "-u-nu-") + a, e);
      if (o.isValidPartialNumber(n)) return o;
    }
  }
  return r;
}
function ld(t, e) {
  let n = t + (e ? Object.entries(e).sort((a, o) => a[0] < o[0] ? -1 : 1).join() : ""), r = od.get(n);
  return r || (r = new cz(t, e), od.set(n, r)), r;
}
class cz {
  parse(e) {
    let n = this.sanitize(e);
    if (this.symbols.group && (n = Wn(n, this.symbols.group, "")), this.symbols.decimal && (n = n.replace(this.symbols.decimal, ".")), this.symbols.minusSign && (n = n.replace(this.symbols.minusSign, "-")), n = n.replace(this.symbols.numeral, this.symbols.index), this.options.style === "percent") {
      let l = n.indexOf("-");
      n = n.replace("-", ""), n = n.replace("+", "");
      let s = n.indexOf(".");
      s === -1 && (s = n.length), n = n.replace(".", ""), s - 2 === 0 ? n = `0.${n}` : s - 2 === -1 ? n = `0.0${n}` : s - 2 === -2 ? n = "0.00" : n = `${n.slice(0, s - 2)}.${n.slice(s - 2)}`, l > -1 && (n = `-${n}`);
    }
    let r = n ? +n : NaN;
    if (isNaN(r)) return NaN;
    if (this.options.style === "percent") {
      var a, o;
      let l = {
        ...this.options,
        style: "decimal",
        minimumFractionDigits: Math.min(((a = this.options.minimumFractionDigits) !== null && a !== void 0 ? a : 0) + 2, 20),
        maximumFractionDigits: Math.min(((o = this.options.maximumFractionDigits) !== null && o !== void 0 ? o : 0) + 2, 20)
      };
      return new J0(this.locale, l).parse(new Pi(this.locale, l).format(r));
    }
    return this.options.currencySign === "accounting" && lz.test(e) && (r = -1 * r), r;
  }
  sanitize(e) {
    return e = e.replace(this.symbols.literals, ""), this.symbols.minusSign && (e = e.replace("-", this.symbols.minusSign)), this.options.numberingSystem === "arab" && (this.symbols.decimal && (e = e.replace(",", this.symbols.decimal), e = e.replace("،", this.symbols.decimal)), this.symbols.group && (e = Wn(e, ".", this.symbols.group))), this.symbols.group === "’" && e.includes("'") && (e = Wn(e, "'", this.symbols.group)), this.options.locale === "fr-FR" && this.symbols.group && (e = Wn(e, " ", this.symbols.group), e = Wn(e, /\u00A0/g, this.symbols.group)), e;
  }
  isValidPartialNumber(e, n = -1 / 0, r = 1 / 0) {
    return e = this.sanitize(e), this.symbols.minusSign && e.startsWith(this.symbols.minusSign) && n < 0 ? e = e.slice(this.symbols.minusSign.length) : this.symbols.plusSign && e.startsWith(this.symbols.plusSign) && r > 0 && (e = e.slice(this.symbols.plusSign.length)), this.symbols.group && e.startsWith(this.symbols.group) || this.symbols.decimal && e.indexOf(this.symbols.decimal) > -1 && this.options.maximumFractionDigits === 0 ? !1 : (this.symbols.group && (e = Wn(e, this.symbols.group, "")), e = e.replace(this.symbols.numeral, ""), this.symbols.decimal && (e = e.replace(this.symbols.decimal, "")), e.length === 0);
  }
  constructor(e, n = {}) {
    this.locale = e, n.roundingIncrement !== 1 && n.roundingIncrement != null && (n.maximumFractionDigits == null && n.minimumFractionDigits == null ? (n.maximumFractionDigits = 0, n.minimumFractionDigits = 0) : n.maximumFractionDigits == null ? n.maximumFractionDigits = n.minimumFractionDigits : n.minimumFractionDigits == null && (n.minimumFractionDigits = n.maximumFractionDigits)), this.formatter = new Intl.NumberFormat(e, n), this.options = this.formatter.resolvedOptions(), this.symbols = uz(e, this.formatter, this.options, n);
    var r, a;
    this.options.style === "percent" && (((r = this.options.minimumFractionDigits) !== null && r !== void 0 ? r : 0) > 18 || ((a = this.options.maximumFractionDigits) !== null && a !== void 0 ? a : 0) > 18) && console.warn("NumberParser cannot handle percentages with greater than 18 decimal places, please reduce the number in your options.");
  }
}
const sd = /* @__PURE__ */ new Set([
  "decimal",
  "fraction",
  "integer",
  "minusSign",
  "plusSign",
  "group"
]), dz = [
  0,
  4,
  2,
  1,
  11,
  20,
  3,
  7,
  100,
  21,
  0.1,
  1.1
];
function uz(t, e, n, r) {
  var a, o, l, s;
  let c = new Intl.NumberFormat(t, {
    ...n,
    // Resets so we get the full range of symbols
    minimumSignificantDigits: 1,
    maximumSignificantDigits: 21,
    roundingIncrement: 1,
    roundingPriority: "auto",
    roundingMode: "halfExpand"
  }), d = c.formatToParts(-10000.111), u = c.formatToParts(10000.111), f = dz.map((W) => c.formatToParts(W));
  var m;
  let g = (m = (a = d.find((W) => W.type === "minusSign")) === null || a === void 0 ? void 0 : a.value) !== null && m !== void 0 ? m : "-", C = (o = u.find((W) => W.type === "plusSign")) === null || o === void 0 ? void 0 : o.value;
  !C && (r?.signDisplay === "exceptZero" || r?.signDisplay === "always") && (C = "+");
  let E = (l = new Intl.NumberFormat(t, {
    ...n,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).formatToParts(1e-3).find((W) => W.type === "decimal")) === null || l === void 0 ? void 0 : l.value, x = (s = d.find((W) => W.type === "group")) === null || s === void 0 ? void 0 : s.value, _ = d.filter((W) => !sd.has(W.type)).map((W) => cd(W.value)), N = f.flatMap((W) => W.filter((y) => !sd.has(y.type)).map((y) => cd(y.value))), k = [
    .../* @__PURE__ */ new Set([
      ..._,
      ...N
    ])
  ].sort((W, y) => y.length - W.length), F = k.length === 0 ? new RegExp("[\\p{White_Space}]", "gu") : new RegExp(`${k.join("|")}|[\\p{White_Space}]`, "gu"), A = [
    ...new Intl.NumberFormat(n.locale, {
      useGrouping: !1
    }).format(9876543210)
  ].reverse(), O = new Map(A.map((W, y) => [
    W,
    y
  ])), te = new RegExp(`[${A.join("")}]`, "g");
  return {
    minusSign: g,
    plusSign: C,
    decimal: E,
    group: x,
    literals: F,
    numeral: te,
    index: (W) => String(O.get(W))
  };
}
function Wn(t, e, n) {
  return t.replaceAll ? t.replaceAll(e, n) : t.split(e).join(n);
}
function cd(t) {
  return t.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}
function dd(t = {}) {
  let { locale: e } = Bs();
  return Fe(() => new Pi(e, t), [
    e,
    t
  ]);
}
function js(t) {
  let e = t;
  return e.nativeEvent = t, e.isDefaultPrevented = () => e.defaultPrevented, e.isPropagationStopped = () => e.cancelBubble, e.persist = () => {
  }, e;
}
function Q0(t, e) {
  Object.defineProperty(t, "target", {
    value: e
  }), Object.defineProperty(t, "currentTarget", {
    value: e
  });
}
function e3(t) {
  let e = $e({
    isFocused: !1,
    observer: null
  });
  cn(() => {
    const r = e.current;
    return () => {
      r.observer && (r.observer.disconnect(), r.observer = null);
    };
  }, []);
  let n = Ve((r) => {
    t?.(r);
  });
  return de((r) => {
    if (r.target instanceof HTMLButtonElement || r.target instanceof HTMLInputElement || r.target instanceof HTMLTextAreaElement || r.target instanceof HTMLSelectElement) {
      e.current.isFocused = !0;
      let a = r.target, o = (l) => {
        if (e.current.isFocused = !1, a.disabled) {
          let s = js(l);
          n(s);
        }
        e.current.observer && (e.current.observer.disconnect(), e.current.observer = null);
      };
      a.addEventListener("focusout", o, {
        once: !0
      }), e.current.observer = new MutationObserver(() => {
        if (e.current.isFocused && a.disabled) {
          var l;
          (l = e.current.observer) === null || l === void 0 || l.disconnect();
          let s = a === document.activeElement ? null : document.activeElement;
          a.dispatchEvent(new FocusEvent("blur", {
            relatedTarget: s
          })), a.dispatchEvent(new FocusEvent("focusout", {
            bubbles: !0,
            relatedTarget: s
          }));
        }
      }), e.current.observer.observe(a, {
        attributes: !0,
        attributeFilter: [
          "disabled"
        ]
      });
    }
  }, [
    n
  ]);
}
let Ni = !1;
function ud(t) {
  for (; t && !kA(t); ) t = t.parentElement;
  let e = nt(t), n = e.document.activeElement;
  if (!n || n === t) return;
  Ni = !0;
  let r = !1, a = (u) => {
    (u.target === n || r) && u.stopImmediatePropagation();
  }, o = (u) => {
    (u.target === n || r) && (u.stopImmediatePropagation(), !t && !r && (r = !0, mr(n), c()));
  }, l = (u) => {
    (u.target === t || r) && u.stopImmediatePropagation();
  }, s = (u) => {
    (u.target === t || r) && (u.stopImmediatePropagation(), r || (r = !0, mr(n), c()));
  };
  e.addEventListener("blur", a, !0), e.addEventListener("focusout", o, !0), e.addEventListener("focusin", s, !0), e.addEventListener("focus", l, !0);
  let c = () => {
    cancelAnimationFrame(d), e.removeEventListener("blur", a, !0), e.removeEventListener("focusout", o, !0), e.removeEventListener("focusin", s, !0), e.removeEventListener("focus", l, !0), Ni = !1, r = !1;
  }, d = requestAnimationFrame(c);
  return c;
}
let Xn = "default", Xl = "", ni = /* @__PURE__ */ new WeakMap();
function fd(t) {
  if (eo()) {
    if (Xn === "default") {
      const e = qe(t);
      Xl = e.documentElement.style.webkitUserSelect, e.documentElement.style.webkitUserSelect = "none";
    }
    Xn = "disabled";
  } else if (t instanceof HTMLElement || t instanceof SVGElement) {
    let e = "userSelect" in t.style ? "userSelect" : "webkitUserSelect";
    ni.set(t, t.style[e]), t.style[e] = "none";
  }
}
function Zo(t) {
  if (eo()) {
    if (Xn !== "disabled") return;
    Xn = "restoring", setTimeout(() => {
      B0(() => {
        if (Xn === "restoring") {
          const e = qe(t);
          e.documentElement.style.webkitUserSelect === "none" && (e.documentElement.style.webkitUserSelect = Xl || ""), Xl = "", Xn = "default";
        }
      });
    }, 300);
  } else if ((t instanceof HTMLElement || t instanceof SVGElement) && t && ni.has(t)) {
    let e = ni.get(t), n = "userSelect" in t.style ? "userSelect" : "webkitUserSelect";
    t.style[n] === "none" && (t.style[n] = e), t.getAttribute("style") === "" && t.removeAttribute("style"), ni.delete(t);
  }
}
const t3 = i.createContext({
  register: () => {
  }
});
t3.displayName = "PressResponderContext";
function fz(t, e) {
  return e.get ? e.get.call(t) : e.value;
}
function n3(t, e, n) {
  if (!e.has(t)) throw new TypeError("attempted to " + n + " private field on non-instance");
  return e.get(t);
}
function pz(t, e) {
  var n = n3(t, e, "get");
  return fz(t, n);
}
function mz(t, e, n) {
  if (e.set) e.set.call(t, n);
  else {
    if (!e.writable)
      throw new TypeError("attempted to set read only private field");
    e.value = n;
  }
}
function pd(t, e, n) {
  var r = n3(t, e, "set");
  return mz(t, r, n), n;
}
function hz(t) {
  let e = St(t3);
  if (e) {
    let { register: n, ...r } = e;
    t = Ye(r, t), n();
  }
  return j0(e, t.ref), t;
}
var Va = /* @__PURE__ */ new WeakMap();
class Ua {
  continuePropagation() {
    pd(this, Va, !1);
  }
  get shouldStopPropagation() {
    return pz(this, Va);
  }
  constructor(e, n, r, a) {
    az(this, Va, {
      writable: !0,
      value: void 0
    }), pd(this, Va, !0);
    var o;
    let l = (o = a?.target) !== null && o !== void 0 ? o : r.currentTarget;
    const s = l?.getBoundingClientRect();
    let c, d = 0, u, f = null;
    r.clientX != null && r.clientY != null && (u = r.clientX, f = r.clientY), s && (u != null && f != null ? (c = u - s.left, d = f - s.top) : (c = s.width / 2, d = s.height / 2)), this.type = e, this.pointerType = n, this.target = r.currentTarget, this.shiftKey = r.shiftKey, this.metaKey = r.metaKey, this.ctrlKey = r.ctrlKey, this.altKey = r.altKey, this.x = c, this.y = d;
  }
}
const md = Symbol("linkClicked"), hd = "react-aria-pressable-style", vd = "data-react-aria-pressable";
function vz(t) {
  let { onPress: e, onPressChange: n, onPressStart: r, onPressEnd: a, onPressUp: o, onClick: l, isDisabled: s, isPressed: c, preventFocusOnPress: d, shouldCancelOnPointerExit: u, allowTextSelectionOnPress: f, ref: m, ...g } = hz(t), [C, b] = ve(!1), E = $e({
    isPressed: !1,
    ignoreEmulatedMouseEvents: !1,
    didFirePressStart: !1,
    isTriggeringEvent: !1,
    activePointerId: null,
    target: null,
    isOverTarget: !1,
    pointerType: null,
    disposables: []
  }), { addGlobalListener: x, removeAllGlobalListeners: _ } = to(), N = Ve((y, Y) => {
    let ee = E.current;
    if (s || ee.didFirePressStart) return !1;
    let I = !0;
    if (ee.isTriggeringEvent = !0, r) {
      let Q = new Ua("pressstart", Y, y);
      r(Q), I = Q.shouldStopPropagation;
    }
    return n && n(!0), ee.isTriggeringEvent = !1, ee.didFirePressStart = !0, b(!0), I;
  }), k = Ve((y, Y, ee = !0) => {
    let I = E.current;
    if (!I.didFirePressStart) return !1;
    I.didFirePressStart = !1, I.isTriggeringEvent = !0;
    let Q = !0;
    if (a) {
      let M = new Ua("pressend", Y, y);
      a(M), Q = M.shouldStopPropagation;
    }
    if (n && n(!1), b(!1), e && ee && !s) {
      let M = new Ua("press", Y, y);
      e(M), Q && (Q = M.shouldStopPropagation);
    }
    return I.isTriggeringEvent = !1, Q;
  }), F = Ve((y, Y) => {
    let ee = E.current;
    if (s) return !1;
    if (o) {
      ee.isTriggeringEvent = !0;
      let I = new Ua("pressup", Y, y);
      return o(I), ee.isTriggeringEvent = !1, I.shouldStopPropagation;
    }
    return !0;
  }), A = Ve((y) => {
    let Y = E.current;
    if (Y.isPressed && Y.target) {
      Y.didFirePressStart && Y.pointerType != null && k(pn(Y.target, y), Y.pointerType, !1), Y.isPressed = !1, Y.isOverTarget = !1, Y.activePointerId = null, Y.pointerType = null, _(), f || Zo(Y.target);
      for (let ee of Y.disposables) ee();
      Y.disposables = [];
    }
  }), O = Ve((y) => {
    u && A(y);
  }), te = Ve((y) => {
    s || l?.(y);
  }), le = Ve((y, Y) => {
    if (!s && l) {
      let ee = new MouseEvent("click", y);
      Q0(ee, Y), l(js(ee));
    }
  }), W = Fe(() => {
    let y = E.current, Y = {
      onKeyDown(I) {
        if (Xo(I.nativeEvent, I.currentTarget) && Le(I.currentTarget, Te(I.nativeEvent))) {
          var Q;
          bd(Te(I.nativeEvent), I.key) && I.preventDefault();
          let M = !0;
          if (!y.isPressed && !I.repeat) {
            y.target = I.currentTarget, y.isPressed = !0, y.pointerType = "keyboard", M = N(I, "keyboard");
            let X = I.currentTarget, se = (he) => {
              Xo(he, X) && !he.repeat && Le(X, Te(he)) && y.target && F(pn(y.target, he), "keyboard");
            };
            x(qe(I.currentTarget), "keyup", Os(se, ee), !0);
          }
          M && I.stopPropagation(), I.metaKey && hr() && ((Q = y.metaKeyEvents) === null || Q === void 0 || Q.set(I.key, I.nativeEvent));
        } else I.key === "Meta" && (y.metaKeyEvents = /* @__PURE__ */ new Map());
      },
      onClick(I) {
        if (!(I && !Le(I.currentTarget, Te(I.nativeEvent))) && I && I.button === 0 && !y.isTriggeringEvent && !ya.isOpening) {
          let Q = !0;
          if (s && I.preventDefault(), !y.ignoreEmulatedMouseEvents && !y.isPressed && (y.pointerType === "virtual" || Kl(I.nativeEvent))) {
            let M = N(I, "virtual"), X = F(I, "virtual"), se = k(I, "virtual");
            te(I), Q = M && X && se;
          } else if (y.isPressed && y.pointerType !== "keyboard") {
            let M = y.pointerType || I.nativeEvent.pointerType || "virtual", X = F(pn(I.currentTarget, I), M), se = k(pn(I.currentTarget, I), M, !0);
            Q = X && se, y.isOverTarget = !1, te(I), A(I);
          }
          y.ignoreEmulatedMouseEvents = !1, Q && I.stopPropagation();
        }
      }
    }, ee = (I) => {
      var Q;
      if (y.isPressed && y.target && Xo(I, y.target)) {
        var M;
        bd(Te(I), I.key) && I.preventDefault();
        let se = Te(I), he = Le(y.target, Te(I));
        k(pn(y.target, I), "keyboard", he), he && le(I, y.target), _(), I.key !== "Enter" && Vs(y.target) && Le(y.target, se) && !I[md] && (I[md] = !0, ya(y.target, I, !1)), y.isPressed = !1, (M = y.metaKeyEvents) === null || M === void 0 || M.delete(I.key);
      } else if (I.key === "Meta" && (!((Q = y.metaKeyEvents) === null || Q === void 0) && Q.size)) {
        var X;
        let se = y.metaKeyEvents;
        y.metaKeyEvents = void 0;
        for (let he of se.values()) (X = y.target) === null || X === void 0 || X.dispatchEvent(new KeyboardEvent("keyup", he));
      }
    };
    if (typeof PointerEvent < "u") {
      Y.onPointerDown = (M) => {
        if (M.button !== 0 || !Le(M.currentTarget, Te(M.nativeEvent))) return;
        if (TA(M.nativeEvent)) {
          y.pointerType = "virtual";
          return;
        }
        y.pointerType = M.pointerType;
        let X = !0;
        if (!y.isPressed) {
          y.isPressed = !0, y.isOverTarget = !0, y.activePointerId = M.pointerId, y.target = M.currentTarget, f || fd(y.target), X = N(M, y.pointerType);
          let se = Te(M.nativeEvent);
          "releasePointerCapture" in se && se.releasePointerCapture(M.pointerId), x(qe(M.currentTarget), "pointerup", I, !1), x(qe(M.currentTarget), "pointercancel", Q, !1);
        }
        X && M.stopPropagation();
      }, Y.onMouseDown = (M) => {
        if (Le(M.currentTarget, Te(M.nativeEvent)) && M.button === 0) {
          if (d) {
            let X = ud(M.target);
            X && y.disposables.push(X);
          }
          M.stopPropagation();
        }
      }, Y.onPointerUp = (M) => {
        !Le(M.currentTarget, Te(M.nativeEvent)) || y.pointerType === "virtual" || M.button === 0 && !y.isPressed && F(M, y.pointerType || M.pointerType);
      }, Y.onPointerEnter = (M) => {
        M.pointerId === y.activePointerId && y.target && !y.isOverTarget && y.pointerType != null && (y.isOverTarget = !0, N(pn(y.target, M), y.pointerType));
      }, Y.onPointerLeave = (M) => {
        M.pointerId === y.activePointerId && y.target && y.isOverTarget && y.pointerType != null && (y.isOverTarget = !1, k(pn(y.target, M), y.pointerType, !1), O(M));
      };
      let I = (M) => {
        if (M.pointerId === y.activePointerId && y.isPressed && M.button === 0 && y.target) {
          if (Le(y.target, Te(M)) && y.pointerType != null) {
            let X = !1, se = setTimeout(() => {
              y.isPressed && y.target instanceof HTMLElement && (X ? A(M) : (mr(y.target), y.target.click()));
            }, 80);
            x(M.currentTarget, "click", () => X = !0, !0), y.disposables.push(() => clearTimeout(se));
          } else A(M);
          y.isOverTarget = !1;
        }
      }, Q = (M) => {
        A(M);
      };
      Y.onDragStart = (M) => {
        Le(M.currentTarget, Te(M.nativeEvent)) && A(M);
      };
    } else if (process.env.NODE_ENV === "test") {
      Y.onMouseDown = (M) => {
        if (M.button !== 0 || !Le(M.currentTarget, Te(M.nativeEvent))) return;
        if (y.ignoreEmulatedMouseEvents) {
          M.stopPropagation();
          return;
        }
        if (y.isPressed = !0, y.isOverTarget = !0, y.target = M.currentTarget, y.pointerType = Kl(M.nativeEvent) ? "virtual" : "mouse", A4(() => N(M, y.pointerType)) && M.stopPropagation(), d) {
          let se = ud(M.target);
          se && y.disposables.push(se);
        }
        x(qe(M.currentTarget), "mouseup", I, !1);
      }, Y.onMouseEnter = (M) => {
        if (!Le(M.currentTarget, Te(M.nativeEvent))) return;
        let X = !0;
        y.isPressed && !y.ignoreEmulatedMouseEvents && y.pointerType != null && (y.isOverTarget = !0, X = N(M, y.pointerType)), X && M.stopPropagation();
      }, Y.onMouseLeave = (M) => {
        if (!Le(M.currentTarget, Te(M.nativeEvent))) return;
        let X = !0;
        y.isPressed && !y.ignoreEmulatedMouseEvents && y.pointerType != null && (y.isOverTarget = !1, X = k(M, y.pointerType, !1), O(M)), X && M.stopPropagation();
      }, Y.onMouseUp = (M) => {
        Le(M.currentTarget, Te(M.nativeEvent)) && !y.ignoreEmulatedMouseEvents && M.button === 0 && !y.isPressed && F(M, y.pointerType || "mouse");
      };
      let I = (M) => {
        if (M.button === 0) {
          if (y.ignoreEmulatedMouseEvents) {
            y.ignoreEmulatedMouseEvents = !1;
            return;
          }
          y.target && y.target.contains(M.target) && y.pointerType != null || A(M), y.isOverTarget = !1;
        }
      };
      Y.onTouchStart = (M) => {
        if (!Le(M.currentTarget, Te(M.nativeEvent))) return;
        let X = gz(M.nativeEvent);
        if (!X) return;
        y.activePointerId = X.identifier, y.ignoreEmulatedMouseEvents = !0, y.isOverTarget = !0, y.isPressed = !0, y.target = M.currentTarget, y.pointerType = "touch", f || fd(y.target), N(Xt(y.target, M), y.pointerType) && M.stopPropagation(), x(nt(M.currentTarget), "scroll", Q, !0);
      }, Y.onTouchMove = (M) => {
        if (!Le(M.currentTarget, Te(M.nativeEvent))) return;
        if (!y.isPressed) {
          M.stopPropagation();
          return;
        }
        let X = gd(M.nativeEvent, y.activePointerId), se = !0;
        X && yd(X, M.currentTarget) ? !y.isOverTarget && y.pointerType != null && (y.isOverTarget = !0, se = N(Xt(y.target, M), y.pointerType)) : y.isOverTarget && y.pointerType != null && (y.isOverTarget = !1, se = k(Xt(y.target, M), y.pointerType, !1), O(Xt(y.target, M))), se && M.stopPropagation();
      }, Y.onTouchEnd = (M) => {
        if (!Le(M.currentTarget, Te(M.nativeEvent))) return;
        if (!y.isPressed) {
          M.stopPropagation();
          return;
        }
        let X = gd(M.nativeEvent, y.activePointerId), se = !0;
        X && yd(X, M.currentTarget) && y.pointerType != null ? (F(Xt(y.target, M), y.pointerType), se = k(Xt(y.target, M), y.pointerType), le(M.nativeEvent, y.target)) : y.isOverTarget && y.pointerType != null && (se = k(Xt(y.target, M), y.pointerType, !1)), se && M.stopPropagation(), y.isPressed = !1, y.activePointerId = null, y.isOverTarget = !1, y.ignoreEmulatedMouseEvents = !0, y.target && !f && Zo(y.target), _();
      }, Y.onTouchCancel = (M) => {
        Le(M.currentTarget, Te(M.nativeEvent)) && (M.stopPropagation(), y.isPressed && A(Xt(y.target, M)));
      };
      let Q = (M) => {
        y.isPressed && Le(Te(M), y.target) && A({
          currentTarget: y.target,
          shiftKey: !1,
          ctrlKey: !1,
          metaKey: !1,
          altKey: !1
        });
      };
      Y.onDragStart = (M) => {
        Le(M.currentTarget, Te(M.nativeEvent)) && A(M);
      };
    }
    return Y;
  }, [
    x,
    s,
    d,
    _,
    f,
    A,
    O,
    k,
    N,
    F,
    te,
    le
  ]);
  return xe(() => {
    if (!m || process.env.NODE_ENV === "test") return;
    const y = qe(m.current);
    if (!y || !y.head || y.getElementById(hd)) return;
    const Y = y.createElement("style");
    Y.id = hd, Y.textContent = `
@layer {
  [${vd}] {
    touch-action: pan-x pan-y pinch-zoom;
  }
}
    `.trim(), y.head.prepend(Y);
  }, [
    m
  ]), xe(() => {
    let y = E.current;
    return () => {
      var Y;
      f || Zo((Y = y.target) !== null && Y !== void 0 ? Y : void 0);
      for (let ee of y.disposables) ee();
      y.disposables = [];
    };
  }, [
    f
  ]), {
    isPressed: c || C,
    pressProps: Ye(g, W, {
      [vd]: !0
    })
  };
}
function Vs(t) {
  return t.tagName === "A" && t.hasAttribute("href");
}
function Xo(t, e) {
  const { key: n, code: r } = t, a = e, o = a.getAttribute("role");
  return (n === "Enter" || n === " " || n === "Spacebar" || r === "Space") && !(a instanceof nt(a).HTMLInputElement && !r3(a, n) || a instanceof nt(a).HTMLTextAreaElement || a.isContentEditable) && // Links should only trigger with Enter key
  !((o === "link" || !o && Vs(a)) && n !== "Enter");
}
function gz(t) {
  const { targetTouches: e } = t;
  return e.length > 0 ? e[0] : null;
}
function gd(t, e) {
  const n = t.changedTouches;
  for (let r = 0; r < n.length; r++) {
    const a = n[r];
    if (a.identifier === e) return a;
  }
  return null;
}
function Xt(t, e) {
  let n = 0, r = 0;
  return e.targetTouches && e.targetTouches.length === 1 && (n = e.targetTouches[0].clientX, r = e.targetTouches[0].clientY), {
    currentTarget: t,
    shiftKey: e.shiftKey,
    ctrlKey: e.ctrlKey,
    metaKey: e.metaKey,
    altKey: e.altKey,
    clientX: n,
    clientY: r
  };
}
function pn(t, e) {
  let n = e.clientX, r = e.clientY;
  return {
    currentTarget: t,
    shiftKey: e.shiftKey,
    ctrlKey: e.ctrlKey,
    metaKey: e.metaKey,
    altKey: e.altKey,
    clientX: n,
    clientY: r
  };
}
function yz(t) {
  let e = 0, n = 0;
  return t.width !== void 0 ? e = t.width / 2 : t.radiusX !== void 0 && (e = t.radiusX), t.height !== void 0 ? n = t.height / 2 : t.radiusY !== void 0 && (n = t.radiusY), {
    top: t.clientY - n,
    right: t.clientX + e,
    bottom: t.clientY + n,
    left: t.clientX - e
  };
}
function bz(t, e) {
  return !(t.left > e.right || e.left > t.right || t.top > e.bottom || e.top > t.bottom);
}
function yd(t, e) {
  let n = e.getBoundingClientRect(), r = yz(t);
  return bz(n, r);
}
function Ez(t) {
  return t instanceof HTMLInputElement ? !1 : t instanceof HTMLButtonElement ? t.type !== "submit" && t.type !== "reset" : !Vs(t);
}
function bd(t, e) {
  return t instanceof HTMLInputElement ? !r3(t, e) : Ez(t);
}
const wz = /* @__PURE__ */ new Set([
  "checkbox",
  "radio",
  "range",
  "color",
  "file",
  "image",
  "button",
  "submit",
  "reset"
]);
function r3(t, e) {
  return t.type === "checkbox" || t.type === "radio" ? e === " " : wz.has(t.type);
}
let Dn = null, Jl = /* @__PURE__ */ new Set(), Ar = /* @__PURE__ */ new Map(), Nn = !1, Ql = !1;
const $z = {
  Tab: !0,
  Escape: !0
};
function ao(t, e) {
  for (let n of Jl) n(t, e);
}
function xz(t) {
  return !(t.metaKey || !hr() && t.altKey || t.ctrlKey || t.key === "Control" || t.key === "Shift" || t.key === "Meta");
}
function _i(t) {
  Nn = !0, xz(t) && (Dn = "keyboard", ao("keyboard", t));
}
function lt(t) {
  Dn = "pointer", (t.type === "mousedown" || t.type === "pointerdown") && (Nn = !0, ao("pointer", t));
}
function a3(t) {
  Kl(t) && (Nn = !0, Dn = "virtual");
}
function i3(t) {
  t.target === window || t.target === document || Ni || !t.isTrusted || (!Nn && !Ql && (Dn = "virtual", ao("virtual", t)), Nn = !1, Ql = !1);
}
function o3() {
  Ni || (Nn = !1, Ql = !0);
}
function es(t) {
  if (typeof window > "u" || typeof document > "u" || Ar.get(nt(t))) return;
  const e = nt(t), n = qe(t);
  let r = e.HTMLElement.prototype.focus;
  e.HTMLElement.prototype.focus = function() {
    Nn = !0, r.apply(this, arguments);
  }, n.addEventListener("keydown", _i, !0), n.addEventListener("keyup", _i, !0), n.addEventListener("click", a3, !0), e.addEventListener("focus", i3, !0), e.addEventListener("blur", o3, !1), typeof PointerEvent < "u" ? (n.addEventListener("pointerdown", lt, !0), n.addEventListener("pointermove", lt, !0), n.addEventListener("pointerup", lt, !0)) : process.env.NODE_ENV === "test" && (n.addEventListener("mousedown", lt, !0), n.addEventListener("mousemove", lt, !0), n.addEventListener("mouseup", lt, !0)), e.addEventListener("beforeunload", () => {
    l3(t);
  }, {
    once: !0
  }), Ar.set(e, {
    focus: r
  });
}
const l3 = (t, e) => {
  const n = nt(t), r = qe(t);
  e && r.removeEventListener("DOMContentLoaded", e), Ar.has(n) && (n.HTMLElement.prototype.focus = Ar.get(n).focus, r.removeEventListener("keydown", _i, !0), r.removeEventListener("keyup", _i, !0), r.removeEventListener("click", a3, !0), n.removeEventListener("focus", i3, !0), n.removeEventListener("blur", o3, !1), typeof PointerEvent < "u" ? (r.removeEventListener("pointerdown", lt, !0), r.removeEventListener("pointermove", lt, !0), r.removeEventListener("pointerup", lt, !0)) : process.env.NODE_ENV === "test" && (r.removeEventListener("mousedown", lt, !0), r.removeEventListener("mousemove", lt, !0), r.removeEventListener("mouseup", lt, !0)), Ar.delete(n));
};
function Cz(t) {
  const e = qe(t);
  let n;
  return e.readyState !== "loading" ? es(t) : (n = () => {
    es(t);
  }, e.addEventListener("DOMContentLoaded", n)), () => l3(t, n);
}
typeof document < "u" && Cz();
function s3() {
  return Dn !== "pointer";
}
function Mz() {
  return Dn;
}
function Sz(t) {
  Dn = t, ao(t, null);
}
const Fz = /* @__PURE__ */ new Set([
  "checkbox",
  "radio",
  "range",
  "color",
  "file",
  "image",
  "button",
  "submit",
  "reset"
]);
function Pz(t, e, n) {
  let r = qe(n?.target);
  const a = typeof window < "u" ? nt(n?.target).HTMLInputElement : HTMLInputElement, o = typeof window < "u" ? nt(n?.target).HTMLTextAreaElement : HTMLTextAreaElement, l = typeof window < "u" ? nt(n?.target).HTMLElement : HTMLElement, s = typeof window < "u" ? nt(n?.target).KeyboardEvent : KeyboardEvent;
  return t = t || r.activeElement instanceof a && !Fz.has(r.activeElement.type) || r.activeElement instanceof o || r.activeElement instanceof l && r.activeElement.isContentEditable, !(t && e === "keyboard" && n instanceof s && !$z[n.key]);
}
function Nz(t, e, n) {
  es(), xe(() => {
    let r = (a, o) => {
      Pz(!!n?.isTextInput, a, o) && t(s3());
    };
    return Jl.add(r), () => {
      Jl.delete(r);
    };
  }, e);
}
function _z(t) {
  const e = qe(t), n = ga(e);
  if (Mz() === "virtual") {
    let r = n;
    B0(() => {
      ga(e) === r && t.isConnected && mr(t);
    });
  } else mr(t);
}
function Us(t) {
  let { isDisabled: e, onFocus: n, onBlur: r, onFocusChange: a } = t;
  const o = de((c) => {
    if (c.target === c.currentTarget)
      return r && r(c), a && a(!1), !0;
  }, [
    r,
    a
  ]), l = e3(o), s = de((c) => {
    const d = qe(c.target), u = d ? ga(d) : ga();
    c.target === c.currentTarget && u === Te(c.nativeEvent) && (n && n(c), a && a(!0), l(c));
  }, [
    a,
    n,
    l
  ]);
  return {
    focusProps: {
      onFocus: !e && (n || a || r) ? s : void 0,
      onBlur: !e && (r || a) ? o : void 0
    }
  };
}
function Ed(t) {
  if (!t) return;
  let e = !0;
  return (n) => {
    let r = {
      ...n,
      preventDefault() {
        n.preventDefault();
      },
      isDefaultPrevented() {
        return n.isDefaultPrevented();
      },
      stopPropagation() {
        e && process.env.NODE_ENV !== "production" ? console.error("stopPropagation is now the default behavior for events in React Spectrum. You can use continuePropagation() to revert this behavior.") : e = !0;
      },
      continuePropagation() {
        e = !1;
      },
      isPropagationStopped() {
        return e;
      }
    };
    t(r), e && n.stopPropagation();
  };
}
function Tz(t) {
  return {
    keyboardProps: t.isDisabled ? {} : {
      onKeyDown: Ed(t.onKeyDown),
      onKeyUp: Ed(t.onKeyUp)
    }
  };
}
let Az = /* @__PURE__ */ i.createContext(null);
function zz(t) {
  let e = St(Az) || {};
  j0(e, t);
  let { ref: n, ...r } = e;
  return r;
}
function c3(t, e) {
  let { focusProps: n } = Us(t), { keyboardProps: r } = Tz(t), a = Ye(n, r), o = zz(e), l = t.isDisabled ? {} : o, s = $e(t.autoFocus);
  xe(() => {
    s.current && e.current && _z(e.current), s.current = !1;
  }, [
    e
  ]);
  let c = t.excludeFromTabOrder ? -1 : 0;
  return t.isDisabled && (c = void 0), {
    focusableProps: Ye({
      ...a,
      tabIndex: c
    }, l)
  };
}
function d3(t) {
  let { isDisabled: e, onBlurWithin: n, onFocusWithin: r, onFocusWithinChange: a } = t, o = $e({
    isFocusWithin: !1
  }), { addGlobalListener: l, removeAllGlobalListeners: s } = to(), c = de((f) => {
    f.currentTarget.contains(f.target) && o.current.isFocusWithin && !f.currentTarget.contains(f.relatedTarget) && (o.current.isFocusWithin = !1, s(), n && n(f), a && a(!1));
  }, [
    n,
    a,
    o,
    s
  ]), d = e3(c), u = de((f) => {
    if (!f.currentTarget.contains(f.target)) return;
    const m = qe(f.target), g = ga(m);
    if (!o.current.isFocusWithin && g === Te(f.nativeEvent)) {
      r && r(f), a && a(!0), o.current.isFocusWithin = !0, d(f);
      let C = f.currentTarget;
      l(m, "focus", (b) => {
        if (o.current.isFocusWithin && !Le(C, b.target)) {
          let E = new m.defaultView.FocusEvent("blur", {
            relatedTarget: b.target
          });
          Q0(E, C);
          let x = js(E);
          c(x);
        }
      }, {
        capture: !0
      });
    }
  }, [
    r,
    a,
    d,
    l,
    c
  ]);
  return e ? {
    focusWithinProps: {
      // These cannot be null, that would conflict in mergeProps
      onFocus: void 0,
      onBlur: void 0
    }
  } : {
    focusWithinProps: {
      onFocus: u,
      onBlur: c
    }
  };
}
let Ti = !1, Wa = 0;
function ts() {
  Ti = !0, setTimeout(() => {
    Ti = !1;
  }, 50);
}
function wd(t) {
  t.pointerType === "touch" && ts();
}
function Dz() {
  if (!(typeof document > "u"))
    return Wa === 0 && (typeof PointerEvent < "u" ? document.addEventListener("pointerup", wd) : process.env.NODE_ENV === "test" && document.addEventListener("touchend", ts)), Wa++, () => {
      Wa--, !(Wa > 0) && (typeof PointerEvent < "u" ? document.removeEventListener("pointerup", wd) : process.env.NODE_ENV === "test" && document.removeEventListener("touchend", ts));
    };
}
function Ws(t) {
  let { onHoverStart: e, onHoverChange: n, onHoverEnd: r, isDisabled: a } = t, [o, l] = ve(!1), s = $e({
    isHovered: !1,
    ignoreEmulatedMouseEvents: !1,
    pointerType: "",
    target: null
  }).current;
  xe(Dz, []);
  let { addGlobalListener: c, removeAllGlobalListeners: d } = to(), { hoverProps: u, triggerHoverEnd: f } = Fe(() => {
    let m = (b, E) => {
      if (s.pointerType = E, a || E === "touch" || s.isHovered || !b.currentTarget.contains(b.target)) return;
      s.isHovered = !0;
      let x = b.currentTarget;
      s.target = x, c(qe(b.target), "pointerover", (_) => {
        s.isHovered && s.target && !Le(s.target, _.target) && g(_, _.pointerType);
      }, {
        capture: !0
      }), e && e({
        type: "hoverstart",
        target: x,
        pointerType: E
      }), n && n(!0), l(!0);
    }, g = (b, E) => {
      let x = s.target;
      s.pointerType = "", s.target = null, !(E === "touch" || !s.isHovered || !x) && (s.isHovered = !1, d(), r && r({
        type: "hoverend",
        target: x,
        pointerType: E
      }), n && n(!1), l(!1));
    }, C = {};
    return typeof PointerEvent < "u" ? (C.onPointerEnter = (b) => {
      Ti && b.pointerType === "mouse" || m(b, b.pointerType);
    }, C.onPointerLeave = (b) => {
      !a && b.currentTarget.contains(b.target) && g(b, b.pointerType);
    }) : process.env.NODE_ENV === "test" && (C.onTouchStart = () => {
      s.ignoreEmulatedMouseEvents = !0;
    }, C.onMouseEnter = (b) => {
      !s.ignoreEmulatedMouseEvents && !Ti && m(b, "mouse"), s.ignoreEmulatedMouseEvents = !1;
    }, C.onMouseLeave = (b) => {
      !a && b.currentTarget.contains(b.target) && g(b, "mouse");
    }), {
      hoverProps: C,
      triggerHoverEnd: g
    };
  }, [
    e,
    n,
    r,
    a,
    s,
    c,
    d
  ]);
  return xe(() => {
    a && f({
      currentTarget: s.target
    }, s.pointerType);
  }, [
    a
  ]), {
    hoverProps: u,
    isHovered: o
  };
}
function Iz(t, e) {
  let { onScroll: n, isDisabled: r } = t, a = de((o) => {
    o.ctrlKey || (o.preventDefault(), o.stopPropagation(), n && n({
      deltaX: o.deltaX,
      deltaY: o.deltaY
    }));
  }, [
    n
  ]);
  _A(e, "wheel", r ? void 0 : a);
}
function Gs(t = {}) {
  let { autoFocus: e = !1, isTextInput: n, within: r } = t, a = $e({
    isFocused: !1,
    isFocusVisible: e || s3()
  }), [o, l] = ve(!1), [s, c] = ve(() => a.current.isFocused && a.current.isFocusVisible), d = de(() => c(a.current.isFocused && a.current.isFocusVisible), []), u = de((g) => {
    a.current.isFocused = g, l(g), d();
  }, [
    d
  ]);
  Nz((g) => {
    a.current.isFocusVisible = g, d();
  }, [], {
    isTextInput: n
  });
  let { focusProps: f } = Us({
    isDisabled: r,
    onFocusChange: u
  }), { focusWithinProps: m } = d3({
    isDisabled: !r,
    onFocusWithinChange: u
  });
  return {
    isFocused: o,
    isFocusVisible: s,
    focusProps: r ? m : f
  };
}
function kz(t) {
  let { id: e, label: n, "aria-labelledby": r, "aria-label": a, labelElementType: o = "label" } = t;
  e = Rt(e);
  let l = Rt(), s = {};
  n ? (r = r ? `${l} ${r}` : l, s = {
    id: l,
    htmlFor: o === "label" ? e : void 0
  }) : !r && !a && process.env.NODE_ENV !== "production" && console.warn("If you do not provide a visible label, you must specify an aria-label or aria-labelledby attribute for accessibility");
  let c = PA({
    id: e,
    "aria-label": a,
    "aria-labelledby": r
  });
  return {
    labelProps: s,
    fieldProps: c
  };
}
function Oz(t) {
  let { description: e, errorMessage: n, isInvalid: r, validationState: a } = t, { labelProps: o, fieldProps: l } = kz(t), s = J1([
    !!e,
    !!n,
    r,
    a
  ]), c = J1([
    !!e,
    !!n,
    r,
    a
  ]);
  return l = Ye(l, {
    "aria-describedby": [
      s,
      // Use aria-describedby for error message because aria-errormessage is unsupported using VoiceOver or NVDA. See https://github.com/adobe/react-spectrum/issues/1346#issuecomment-740136268
      c,
      t["aria-describedby"]
    ].filter(Boolean).join(" ") || void 0
  }), {
    labelProps: o,
    fieldProps: l,
    descriptionProps: {
      id: s
    },
    errorMessageProps: {
      id: c
    }
  };
}
const u3 = {
  badInput: !1,
  customError: !1,
  patternMismatch: !1,
  rangeOverflow: !1,
  rangeUnderflow: !1,
  stepMismatch: !1,
  tooLong: !1,
  tooShort: !1,
  typeMismatch: !1,
  valueMissing: !1,
  valid: !0
}, f3 = {
  ...u3,
  customError: !0,
  valid: !1
}, Mr = {
  isInvalid: !1,
  validationDetails: u3,
  validationErrors: []
}, Lz = it({}), ns = "__formValidationState" + Date.now();
function p3(t) {
  if (t[ns]) {
    let { realtimeValidation: e, displayValidation: n, updateValidation: r, resetValidation: a, commitValidation: o } = t[ns];
    return {
      realtimeValidation: e,
      displayValidation: n,
      updateValidation: r,
      resetValidation: a,
      commitValidation: o
    };
  }
  return Rz(t);
}
function Rz(t) {
  let { isInvalid: e, validationState: n, name: r, value: a, builtinValidation: o, validate: l, validationBehavior: s = "aria" } = t;
  n && (e || (e = n === "invalid"));
  let c = e !== void 0 ? {
    isInvalid: e,
    validationErrors: [],
    validationDetails: f3
  } : null, d = Fe(() => {
    if (!l || a == null) return null;
    let W = Hz(l, a);
    return $d(W);
  }, [
    l,
    a
  ]);
  o?.validationDetails.valid && (o = void 0);
  let u = St(Lz), f = Fe(() => r ? Array.isArray(r) ? r.flatMap((W) => rs(u[W])) : rs(u[r]) : [], [
    u,
    r
  ]), [m, g] = ve(u), [C, b] = ve(!1);
  u !== m && (g(u), b(!1));
  let E = Fe(() => $d(C ? [] : f), [
    C,
    f
  ]), x = $e(Mr), [_, N] = ve(Mr), k = $e(Mr), F = () => {
    if (!A) return;
    O(!1);
    let W = d || o || x.current;
    Jo(W, k.current) || (k.current = W, N(W));
  }, [A, O] = ve(!1);
  return xe(F), {
    realtimeValidation: c || E || d || o || Mr,
    displayValidation: s === "native" ? c || E || _ : c || E || d || o || _,
    updateValidation(W) {
      s === "aria" && !Jo(_, W) ? N(W) : x.current = W;
    },
    resetValidation() {
      let W = Mr;
      Jo(W, k.current) || (k.current = W, N(W)), s === "native" && O(!1), b(!0);
    },
    commitValidation() {
      s === "native" && O(!0), b(!0);
    }
  };
}
function rs(t) {
  return t ? Array.isArray(t) ? t : [
    t
  ] : [];
}
function Hz(t, e) {
  if (typeof t == "function") {
    let n = t(e);
    if (n && typeof n != "boolean") return rs(n);
  }
  return [];
}
function $d(t) {
  return t.length ? {
    isInvalid: !0,
    validationErrors: t,
    validationDetails: f3
  } : null;
}
function Jo(t, e) {
  return t === e ? !0 : !!t && !!e && t.isInvalid === e.isInvalid && t.validationErrors.length === e.validationErrors.length && t.validationErrors.every((n, r) => n === e.validationErrors[r]) && Object.entries(t.validationDetails).every(([n, r]) => e.validationDetails[n] === r);
}
function Bz(t, e, n) {
  let { validationBehavior: r, focus: a } = t;
  cn(() => {
    if (r === "native" && n?.current && !n.current.disabled) {
      let d = e.realtimeValidation.isInvalid ? e.realtimeValidation.validationErrors.join(" ") || "Invalid value." : "";
      n.current.setCustomValidity(d), n.current.hasAttribute("title") || (n.current.title = ""), e.realtimeValidation.isInvalid || e.updateValidation(Vz(n.current));
    }
  });
  let o = $e(!1), l = Ve(() => {
    o.current || e.resetValidation();
  }), s = Ve((d) => {
    var u;
    e.displayValidation.isInvalid || e.commitValidation();
    let f = n == null || (u = n.current) === null || u === void 0 ? void 0 : u.form;
    if (!d.defaultPrevented && n && f && Uz(f) === n.current) {
      var m;
      a ? a() : (m = n.current) === null || m === void 0 || m.focus(), Sz("keyboard");
    }
    d.preventDefault();
  }), c = Ve(() => {
    e.commitValidation();
  });
  xe(() => {
    let d = n?.current;
    if (!d) return;
    let u = d.form, f = u?.reset;
    return u && (u.reset = () => {
      o.current = !window.event || window.event.type === "message" && window.event.target instanceof MessagePort, f?.call(u), o.current = !1;
    }), d.addEventListener("invalid", s), d.addEventListener("change", c), u?.addEventListener("reset", l), () => {
      d.removeEventListener("invalid", s), d.removeEventListener("change", c), u?.removeEventListener("reset", l), u && (u.reset = f);
    };
  }, [
    n,
    s,
    c,
    l,
    r
  ]);
}
function jz(t) {
  let e = t.validity;
  return {
    badInput: e.badInput,
    customError: e.customError,
    patternMismatch: e.patternMismatch,
    rangeOverflow: e.rangeOverflow,
    rangeUnderflow: e.rangeUnderflow,
    stepMismatch: e.stepMismatch,
    tooLong: e.tooLong,
    tooShort: e.tooShort,
    typeMismatch: e.typeMismatch,
    valueMissing: e.valueMissing,
    valid: e.valid
  };
}
function Vz(t) {
  return {
    isInvalid: !t.validity.valid,
    validationDetails: jz(t),
    validationErrors: t.validationMessage ? [
      t.validationMessage
    ] : []
  };
}
function Uz(t) {
  for (let e = 0; e < t.elements.length; e++) {
    let n = t.elements[e];
    if (!n.validity.valid) return n;
  }
  return null;
}
function Wz(t, e) {
  let { inputElementType: n = "input", isDisabled: r = !1, isRequired: a = !1, isReadOnly: o = !1, type: l = "text", validationBehavior: s = "aria" } = t, [c, d] = G0(t.value, t.defaultValue || "", t.onChange), { focusableProps: u } = c3(t, e), f = p3({
    ...t,
    value: c
  }), { isInvalid: m, validationErrors: g, validationDetails: C } = f.displayValidation, { labelProps: b, fieldProps: E, descriptionProps: x, errorMessageProps: _ } = Oz({
    ...t,
    isInvalid: m,
    errorMessage: t.errorMessage || g
  }), N = Pa(t, {
    labelable: !0
  });
  const k = {
    type: l,
    pattern: t.pattern
  };
  let [F] = ve(c);
  var A;
  return V0(e, (A = t.defaultValue) !== null && A !== void 0 ? A : F, d), Bz(t, f, e), xe(() => {
    if (e.current instanceof nt(e.current).HTMLTextAreaElement) {
      let O = e.current;
      Object.defineProperty(O, "defaultValue", {
        get: () => O.value,
        set: () => {
        },
        configurable: !0
      });
    }
  }, [
    e
  ]), {
    labelProps: b,
    inputProps: Ye(N, n === "input" ? k : void 0, {
      disabled: r,
      readOnly: o,
      required: a && s === "native",
      "aria-required": a && s === "aria" || void 0,
      "aria-invalid": m || void 0,
      "aria-errormessage": t["aria-errormessage"],
      "aria-activedescendant": t["aria-activedescendant"],
      "aria-autocomplete": t["aria-autocomplete"],
      "aria-haspopup": t["aria-haspopup"],
      "aria-controls": t["aria-controls"],
      value: c,
      onChange: (O) => d(O.target.value),
      autoComplete: t.autoComplete,
      autoCapitalize: t.autoCapitalize,
      maxLength: t.maxLength,
      minLength: t.minLength,
      name: t.name,
      form: t.form,
      placeholder: t.placeholder,
      inputMode: t.inputMode,
      autoCorrect: t.autoCorrect,
      spellCheck: t.spellCheck,
      [parseInt(i.version, 10) >= 17 ? "enterKeyHint" : "enterkeyhint"]: t.enterKeyHint,
      // Clipboard events
      onCopy: t.onCopy,
      onCut: t.onCut,
      onPaste: t.onPaste,
      // Composition events
      onCompositionEnd: t.onCompositionEnd,
      onCompositionStart: t.onCompositionStart,
      onCompositionUpdate: t.onCompositionUpdate,
      // Selection events
      onSelect: t.onSelect,
      // Input events
      onBeforeInput: t.onBeforeInput,
      onInput: t.onInput,
      ...u,
      ...E
    }),
    descriptionProps: x,
    errorMessageProps: _,
    isInvalid: m,
    validationErrors: g,
    validationDetails: C
  };
}
function xd() {
  return typeof window < "u" && window.InputEvent && typeof InputEvent.prototype.getTargetRanges == "function";
}
function Gz(t, e, n) {
  let r = Ve((f) => {
    let m = n.current;
    if (!m) return;
    let g = null;
    switch (f.inputType) {
      case "historyUndo":
      case "historyRedo":
        return;
      case "insertLineBreak":
        return;
      case "deleteContent":
      case "deleteByCut":
      case "deleteByDrag":
        g = m.value.slice(0, m.selectionStart) + m.value.slice(m.selectionEnd);
        break;
      case "deleteContentForward":
        g = m.selectionEnd === m.selectionStart ? m.value.slice(0, m.selectionStart) + m.value.slice(m.selectionEnd + 1) : m.value.slice(0, m.selectionStart) + m.value.slice(m.selectionEnd);
        break;
      case "deleteContentBackward":
        g = m.selectionEnd === m.selectionStart ? m.value.slice(0, m.selectionStart - 1) + m.value.slice(m.selectionStart) : m.value.slice(0, m.selectionStart) + m.value.slice(m.selectionEnd);
        break;
      case "deleteSoftLineBackward":
      case "deleteHardLineBackward":
        g = m.value.slice(m.selectionStart);
        break;
      default:
        f.data != null && (g = m.value.slice(0, m.selectionStart) + f.data + m.value.slice(m.selectionEnd));
        break;
    }
    (g == null || !e.validate(g)) && f.preventDefault();
  });
  xe(() => {
    if (!xd() || !n.current) return;
    let f = n.current;
    return f.addEventListener("beforeinput", r, !1), () => {
      f.removeEventListener("beforeinput", r, !1);
    };
  }, [
    n,
    r
  ]);
  let a = xd() ? null : (f) => {
    let m = f.target.value.slice(0, f.target.selectionStart) + f.data + f.target.value.slice(f.target.selectionEnd);
    e.validate(m) || f.preventDefault();
  }, { labelProps: o, inputProps: l, descriptionProps: s, errorMessageProps: c, ...d } = Wz(t, n), u = $e(null);
  return {
    inputProps: Ye(l, {
      onBeforeInput: a,
      onCompositionStart() {
        let { value: f, selectionStart: m, selectionEnd: g } = n.current;
        u.current = {
          value: f,
          selectionStart: m,
          selectionEnd: g
        };
      },
      onCompositionEnd() {
        if (n.current && !e.validate(n.current.value)) {
          let { value: f, selectionStart: m, selectionEnd: g } = u.current;
          n.current.value = f, n.current.setSelectionRange(m, g), e.setInputValue(f);
        }
      }
    }),
    labelProps: o,
    descriptionProps: s,
    errorMessageProps: c,
    ...d
  };
}
if (typeof HTMLTemplateElement < "u") {
  const t = Object.getOwnPropertyDescriptor(Node.prototype, "firstChild").get;
  Object.defineProperty(HTMLTemplateElement.prototype, "firstChild", {
    configurable: !0,
    enumerable: !0,
    get: function() {
      return this.dataset.reactAriaHidden ? this.content.firstChild : t.call(this);
    }
  });
}
const Kz = /* @__PURE__ */ it(!1);
function Ks(t) {
  let e = (n, r) => St(Kz) ? null : t(n, r);
  return e.displayName = t.displayName || t.name, _n(e);
}
var Ga = { exports: {} }, Qo = {};
var Cd;
function qz() {
  if (Cd) return Qo;
  Cd = 1;
  var t = i;
  function e(f, m) {
    return f === m && (f !== 0 || 1 / f === 1 / m) || f !== f && m !== m;
  }
  var n = typeof Object.is == "function" ? Object.is : e, r = t.useState, a = t.useEffect, o = t.useLayoutEffect, l = t.useDebugValue;
  function s(f, m) {
    var g = m(), C = r({ inst: { value: g, getSnapshot: m } }), b = C[0].inst, E = C[1];
    return o(
      function() {
        b.value = g, b.getSnapshot = m, c(b) && E({ inst: b });
      },
      [f, g, m]
    ), a(
      function() {
        return c(b) && E({ inst: b }), f(function() {
          c(b) && E({ inst: b });
        });
      },
      [f]
    ), l(g), g;
  }
  function c(f) {
    var m = f.getSnapshot;
    f = f.value;
    try {
      var g = m();
      return !n(f, g);
    } catch {
      return !0;
    }
  }
  function d(f, m) {
    return m();
  }
  var u = typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u" ? d : s;
  return Qo.useSyncExternalStore = t.useSyncExternalStore !== void 0 ? t.useSyncExternalStore : u, Qo;
}
var el = {};
var Md;
function Yz() {
  return Md || (Md = 1, process.env.NODE_ENV !== "production" && (function() {
    function t(g, C) {
      return g === C && (g !== 0 || 1 / g === 1 / C) || g !== g && C !== C;
    }
    function e(g, C) {
      u || a.startTransition === void 0 || (u = !0, console.error(
        "You are using an outdated, pre-release alpha of React 18 that does not support useSyncExternalStore. The use-sync-external-store shim will not work correctly. Upgrade to a newer pre-release."
      ));
      var b = C();
      if (!f) {
        var E = C();
        o(b, E) || (console.error(
          "The result of getSnapshot should be cached to avoid an infinite loop"
        ), f = !0);
      }
      E = l({
        inst: { value: b, getSnapshot: C }
      });
      var x = E[0].inst, _ = E[1];
      return c(
        function() {
          x.value = b, x.getSnapshot = C, n(x) && _({ inst: x });
        },
        [g, b, C]
      ), s(
        function() {
          return n(x) && _({ inst: x }), g(function() {
            n(x) && _({ inst: x });
          });
        },
        [g]
      ), d(b), b;
    }
    function n(g) {
      var C = g.getSnapshot;
      g = g.value;
      try {
        var b = C();
        return !o(g, b);
      } catch {
        return !0;
      }
    }
    function r(g, C) {
      return C();
    }
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(Error());
    var a = i, o = typeof Object.is == "function" ? Object.is : t, l = a.useState, s = a.useEffect, c = a.useLayoutEffect, d = a.useDebugValue, u = !1, f = !1, m = typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u" ? r : e;
    el.useSyncExternalStore = a.useSyncExternalStore !== void 0 ? a.useSyncExternalStore : m, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(Error());
  })()), el;
}
var Sd;
function Zz() {
  return Sd || (Sd = 1, process.env.NODE_ENV === "production" ? Ga.exports = qz() : Ga.exports = Yz()), Ga.exports;
}
Zz();
function Xz(t, e) {
  let { elementType: n = "button", isDisabled: r, onPress: a, onPressStart: o, onPressEnd: l, onPressUp: s, onPressChange: c, preventFocusOnPress: d, allowFocusWhenDisabled: u, onClick: f, href: m, target: g, rel: C, type: b = "button" } = t, E;
  n === "button" ? E = {
    type: b,
    disabled: r,
    form: t.form,
    formAction: t.formAction,
    formEncType: t.formEncType,
    formMethod: t.formMethod,
    formNoValidate: t.formNoValidate,
    formTarget: t.formTarget,
    name: t.name,
    value: t.value
  } : E = {
    role: "button",
    href: n === "a" && !r ? m : void 0,
    target: n === "a" ? g : void 0,
    type: n === "input" ? b : void 0,
    disabled: n === "input" ? r : void 0,
    "aria-disabled": !r || n === "input" ? void 0 : r,
    rel: n === "a" ? C : void 0
  };
  let { pressProps: x, isPressed: _ } = vz({
    onPressStart: o,
    onPressEnd: l,
    onPressChange: c,
    onPress: a,
    onPressUp: s,
    onClick: f,
    isDisabled: r,
    preventFocusOnPress: d,
    ref: e
  }), { focusableProps: N } = c3(t, e);
  u && (N.tabIndex = r ? -1 : N.tabIndex);
  let k = Ye(N, x, Pa(t, {
    labelable: !0
  }));
  return {
    isPressed: _,
    buttonProps: Ye(E, k, {
      "aria-haspopup": t["aria-haspopup"],
      "aria-expanded": t["aria-expanded"],
      "aria-controls": t["aria-controls"],
      "aria-pressed": t["aria-pressed"],
      "aria-current": t["aria-current"],
      "aria-disabled": t["aria-disabled"]
    })
  };
}
function Jz(t) {
  let { minValue: e, maxValue: n, step: r, formatOptions: a, value: o, defaultValue: l = NaN, onChange: s, locale: c, isDisabled: d, isReadOnly: u } = t;
  o === null && (o = NaN), o !== void 0 && !isNaN(o) && (r !== void 0 && !isNaN(r) ? o = _t(o, e, n, r) : o = Ko(o, e, n)), isNaN(l) || (r !== void 0 && !isNaN(r) ? l = _t(l, e, n, r) : l = Ko(l, e, n));
  let [f, m] = G0(o, isNaN(l) ? NaN : l, s), [g] = ve(f), [C, b] = ve(() => isNaN(f) ? "" : new Pi(c, a).format(f)), E = Fe(() => new J0(c, a), [
    c,
    a
  ]), x = Fe(() => E.getNumberingSystem(C), [
    E,
    C
  ]), _ = Fe(() => new Pi(c, {
    ...a,
    numberingSystem: x
  }), [
    c,
    a,
    x
  ]), N = Fe(() => _.resolvedOptions(), [
    _
  ]), k = de((D) => isNaN(D) || D === null ? "" : _.format(D), [
    _
  ]), F = p3({
    ...t,
    value: f
  }), A = r !== void 0 && !isNaN(r) ? r : 1;
  N.style === "percent" && (r === void 0 || isNaN(r)) && (A = 0.01);
  let [O, te] = ve(f), [le, W] = ve(c), [y, Y] = ve(a);
  (!Object.is(f, O) || c !== le || a !== y) && (b(k(f)), te(f), W(c), Y(a));
  let ee = Fe(() => E.parse(C), [
    E,
    C
  ]), I = () => {
    if (!C.length) {
      m(NaN), b(o === void 0 ? "" : k(f));
      return;
    }
    if (isNaN(ee)) {
      b(k(f));
      return;
    }
    let D;
    r === void 0 || isNaN(r) ? D = Ko(ee, e, n) : D = _t(ee, e, n, r), D = E.parse(k(D)), m(D), b(k(o === void 0 ? D : f)), F.commitValidation();
  }, Q = (D, B = 0) => {
    let H = ee;
    if (isNaN(H)) {
      let j = isNaN(B) ? 0 : B;
      return _t(j, e, n, A);
    } else {
      let j = _t(H, e, n, A);
      return D === "+" && j > H || D === "-" && j < H ? j : _t(tl(D, H, A), e, n, A);
    }
  }, M = () => {
    let D = Q("+", e);
    D === f && b(k(D)), m(D), F.commitValidation();
  }, X = () => {
    let D = Q("-", n);
    D === f && b(k(D)), m(D), F.commitValidation();
  }, se = () => {
    n != null && (m(_t(n, e, n, A)), F.commitValidation());
  }, he = () => {
    e != null && (m(e), F.commitValidation());
  }, L = Fe(() => !d && !u && (isNaN(ee) || n === void 0 || isNaN(n) || _t(ee, e, n, A) > ee || tl("+", ee, A) <= n), [
    d,
    u,
    e,
    n,
    A,
    ee
  ]), K = Fe(() => !d && !u && (isNaN(ee) || e === void 0 || isNaN(e) || _t(ee, e, n, A) < ee || tl("-", ee, A) >= e), [
    d,
    u,
    e,
    n,
    A,
    ee
  ]);
  return {
    ...F,
    validate: (D) => E.isValidPartialNumber(D, e, n),
    increment: M,
    incrementToMax: se,
    decrement: X,
    decrementToMin: he,
    canIncrement: L,
    canDecrement: K,
    minValue: e,
    maxValue: n,
    numberValue: ee,
    defaultNumberValue: isNaN(l) ? g : l,
    setNumberValue: m,
    setInputValue: b,
    inputValue: C,
    commit: I
  };
}
function tl(t, e, n) {
  let r = t === "+" ? e + n : e - n;
  if (e % 1 !== 0 || n % 1 !== 0) {
    const a = e.toString().split("."), o = n.toString().split("."), l = a[1] && a[1].length || 0, s = o[1] && o[1].length || 0, c = Math.pow(10, Math.max(l, s));
    e = Math.round(e * c), n = Math.round(n * c), r = t === "+" ? e + n : e - n, r /= c;
  }
  return r;
}
var m3 = {};
m3 = {
  Empty: "فارغ"
};
var h3 = {};
h3 = {
  Empty: "Изпразни"
};
var v3 = {};
v3 = {
  Empty: "Prázdné"
};
var g3 = {};
g3 = {
  Empty: "Tom"
};
var y3 = {};
y3 = {
  Empty: "Leer"
};
var b3 = {};
b3 = {
  Empty: "Άδειο"
};
var E3 = {};
E3 = {
  Empty: "Empty"
};
var w3 = {};
w3 = {
  Empty: "Vacío"
};
var $3 = {};
$3 = {
  Empty: "Tühjenda"
};
var x3 = {};
x3 = {
  Empty: "Tyhjä"
};
var C3 = {};
C3 = {
  Empty: "Vide"
};
var M3 = {};
M3 = {
  Empty: "ריק"
};
var S3 = {};
S3 = {
  Empty: "Prazno"
};
var F3 = {};
F3 = {
  Empty: "Üres"
};
var P3 = {};
P3 = {
  Empty: "Vuoto"
};
var N3 = {};
N3 = {
  Empty: "空"
};
var _3 = {};
_3 = {
  Empty: "비어 있음"
};
var T3 = {};
T3 = {
  Empty: "Tuščias"
};
var A3 = {};
A3 = {
  Empty: "Tukšs"
};
var z3 = {};
z3 = {
  Empty: "Tom"
};
var D3 = {};
D3 = {
  Empty: "Leeg"
};
var I3 = {};
I3 = {
  Empty: "Pusty"
};
var k3 = {};
k3 = {
  Empty: "Vazio"
};
var O3 = {};
O3 = {
  Empty: "Vazio"
};
var L3 = {};
L3 = {
  Empty: "Gol"
};
var R3 = {};
R3 = {
  Empty: "Не заполнено"
};
var H3 = {};
H3 = {
  Empty: "Prázdne"
};
var B3 = {};
B3 = {
  Empty: "Prazen"
};
var j3 = {};
j3 = {
  Empty: "Prazno"
};
var V3 = {};
V3 = {
  Empty: "Tomt"
};
var U3 = {};
U3 = {
  Empty: "Boş"
};
var W3 = {};
W3 = {
  Empty: "Пусто"
};
var G3 = {};
G3 = {
  Empty: "空"
};
var K3 = {};
K3 = {
  Empty: "空白"
};
var q3 = {};
q3 = {
  "ar-AE": m3,
  "bg-BG": h3,
  "cs-CZ": v3,
  "da-DK": g3,
  "de-DE": y3,
  "el-GR": b3,
  "en-US": E3,
  "es-ES": w3,
  "et-EE": $3,
  "fi-FI": x3,
  "fr-FR": C3,
  "he-IL": M3,
  "hr-HR": S3,
  "hu-HU": F3,
  "it-IT": P3,
  "ja-JP": N3,
  "ko-KR": _3,
  "lt-LT": T3,
  "lv-LV": A3,
  "nb-NO": z3,
  "nl-NL": D3,
  "pl-PL": I3,
  "pt-BR": k3,
  "pt-PT": O3,
  "ro-RO": L3,
  "ru-RU": R3,
  "sk-SK": H3,
  "sl-SI": B3,
  "sr-SP": j3,
  "sv-SE": V3,
  "tr-TR": U3,
  "uk-UA": W3,
  "zh-CN": G3,
  "zh-TW": K3
};
function Qz(t) {
  return t && t.__esModule ? t.default : t;
}
function eD(t) {
  const e = $e(void 0);
  let { value: n, textValue: r, minValue: a, maxValue: o, isDisabled: l, isReadOnly: s, isRequired: c, onIncrement: d, onIncrementPage: u, onDecrement: f, onDecrementPage: m, onDecrementToMin: g, onIncrementToMax: C } = t;
  const b = Z0(Qz(q3), "@react-aria/spinbutton"), E = () => clearTimeout(e.current);
  xe(() => () => E(), []);
  let x = (y) => {
    if (!(y.ctrlKey || y.metaKey || y.shiftKey || y.altKey || s || y.nativeEvent.isComposing))
      switch (y.key) {
        case "PageUp":
          if (u) {
            y.preventDefault(), u?.();
            break;
          }
        // fallthrough!
        case "ArrowUp":
        case "Up":
          d && (y.preventDefault(), d?.());
          break;
        case "PageDown":
          if (m) {
            y.preventDefault(), m?.();
            break;
          }
        // fallthrough
        case "ArrowDown":
        case "Down":
          f && (y.preventDefault(), f?.());
          break;
        case "Home":
          g && (y.preventDefault(), g?.());
          break;
        case "End":
          C && (y.preventDefault(), C?.());
          break;
      }
  }, _ = $e(!1), N = () => {
    _.current = !0;
  }, k = () => {
    _.current = !1;
  }, F = r === "" ? b.format("Empty") : (r || `${n}`).replace("-", "−");
  xe(() => {
    _.current && (jA("assertive"), ql(F, "assertive"));
  }, [
    F
  ]);
  const A = Ve((y) => {
    E(), d?.(), e.current = window.setTimeout(() => {
      (o === void 0 || isNaN(o) || n === void 0 || isNaN(n) || n < o) && A(60);
    }, y);
  }), O = Ve((y) => {
    E(), f?.(), e.current = window.setTimeout(() => {
      (a === void 0 || isNaN(a) || n === void 0 || isNaN(n) || n > a) && O(60);
    }, y);
  });
  let te = (y) => {
    y.preventDefault();
  }, { addGlobalListener: le, removeAllGlobalListeners: W } = to();
  return {
    spinButtonProps: {
      role: "spinbutton",
      "aria-valuenow": n !== void 0 && !isNaN(n) ? n : void 0,
      "aria-valuetext": F,
      "aria-valuemin": a,
      "aria-valuemax": o,
      "aria-disabled": l || void 0,
      "aria-readonly": s || void 0,
      "aria-required": c || void 0,
      onKeyDown: x,
      onFocus: N,
      onBlur: k
    },
    incrementButtonProps: {
      onPressStart: () => {
        A(400), le(window, "contextmenu", te);
      },
      onPressEnd: () => {
        E(), W();
      },
      onFocus: N,
      onBlur: k
    },
    decrementButtonProps: {
      onPressStart: () => {
        O(400), le(window, "contextmenu", te);
      },
      onPressEnd: () => {
        E(), W();
      },
      onFocus: N,
      onBlur: k
    }
  };
}
var Y3 = {};
Y3 = {
  decrease: (t) => `خفض ${t.fieldLabel}`,
  increase: (t) => `زيادة ${t.fieldLabel}`,
  numberField: "حقل رقمي"
};
var Z3 = {};
Z3 = {
  decrease: (t) => `Намаляване ${t.fieldLabel}`,
  increase: (t) => `Усилване ${t.fieldLabel}`,
  numberField: "Номер на полето"
};
var X3 = {};
X3 = {
  decrease: (t) => `Snížit ${t.fieldLabel}`,
  increase: (t) => `Zvýšit ${t.fieldLabel}`,
  numberField: "Číselné pole"
};
var J3 = {};
J3 = {
  decrease: (t) => `Reducer ${t.fieldLabel}`,
  increase: (t) => `Øg ${t.fieldLabel}`,
  numberField: "Talfelt"
};
var Q3 = {};
Q3 = {
  decrease: (t) => `${t.fieldLabel} verringern`,
  increase: (t) => `${t.fieldLabel} erhöhen`,
  numberField: "Nummernfeld"
};
var ef = {};
ef = {
  decrease: (t) => `Μείωση ${t.fieldLabel}`,
  increase: (t) => `Αύξηση ${t.fieldLabel}`,
  numberField: "Πεδίο αριθμού"
};
var tf = {};
tf = {
  decrease: (t) => `Decrease ${t.fieldLabel}`,
  increase: (t) => `Increase ${t.fieldLabel}`,
  numberField: "Number field"
};
var nf = {};
nf = {
  decrease: (t) => `Reducir ${t.fieldLabel}`,
  increase: (t) => `Aumentar ${t.fieldLabel}`,
  numberField: "Campo de número"
};
var rf = {};
rf = {
  decrease: (t) => `Vähenda ${t.fieldLabel}`,
  increase: (t) => `Suurenda ${t.fieldLabel}`,
  numberField: "Numbri väli"
};
var af = {};
af = {
  decrease: (t) => `Vähennä ${t.fieldLabel}`,
  increase: (t) => `Lisää ${t.fieldLabel}`,
  numberField: "Numerokenttä"
};
var of = {};
of = {
  decrease: (t) => `Diminuer ${t.fieldLabel}`,
  increase: (t) => `Augmenter ${t.fieldLabel}`,
  numberField: "Champ de nombre"
};
var lf = {};
lf = {
  decrease: (t) => `הקטן ${t.fieldLabel}`,
  increase: (t) => `הגדל ${t.fieldLabel}`,
  numberField: "שדה מספר"
};
var sf = {};
sf = {
  decrease: (t) => `Smanji ${t.fieldLabel}`,
  increase: (t) => `Povećaj ${t.fieldLabel}`,
  numberField: "Polje broja"
};
var cf = {};
cf = {
  decrease: (t) => `${t.fieldLabel} csökkentése`,
  increase: (t) => `${t.fieldLabel} növelése`,
  numberField: "Számmező"
};
var df = {};
df = {
  decrease: (t) => `Riduci ${t.fieldLabel}`,
  increase: (t) => `Aumenta ${t.fieldLabel}`,
  numberField: "Campo numero"
};
var uf = {};
uf = {
  decrease: (t) => `${t.fieldLabel}を縮小`,
  increase: (t) => `${t.fieldLabel}を拡大`,
  numberField: "数値フィールド"
};
var ff = {};
ff = {
  decrease: (t) => `${t.fieldLabel} 감소`,
  increase: (t) => `${t.fieldLabel} 증가`,
  numberField: "번호 필드"
};
var pf = {};
pf = {
  decrease: (t) => `Sumažinti ${t.fieldLabel}`,
  increase: (t) => `Padidinti ${t.fieldLabel}`,
  numberField: "Numerio laukas"
};
var mf = {};
mf = {
  decrease: (t) => `Samazināšana ${t.fieldLabel}`,
  increase: (t) => `Palielināšana ${t.fieldLabel}`,
  numberField: "Skaitļu lauks"
};
var hf = {};
hf = {
  decrease: (t) => `Reduser ${t.fieldLabel}`,
  increase: (t) => `Øk ${t.fieldLabel}`,
  numberField: "Tallfelt"
};
var vf = {};
vf = {
  decrease: (t) => `${t.fieldLabel} verlagen`,
  increase: (t) => `${t.fieldLabel} verhogen`,
  numberField: "Getalveld"
};
var gf = {};
gf = {
  decrease: (t) => `Zmniejsz ${t.fieldLabel}`,
  increase: (t) => `Zwiększ ${t.fieldLabel}`,
  numberField: "Pole numeru"
};
var yf = {};
yf = {
  decrease: (t) => `Diminuir ${t.fieldLabel}`,
  increase: (t) => `Aumentar ${t.fieldLabel}`,
  numberField: "Campo de número"
};
var bf = {};
bf = {
  decrease: (t) => `Diminuir ${t.fieldLabel}`,
  increase: (t) => `Aumentar ${t.fieldLabel}`,
  numberField: "Campo numérico"
};
var Ef = {};
Ef = {
  decrease: (t) => `Scădere ${t.fieldLabel}`,
  increase: (t) => `Creștere ${t.fieldLabel}`,
  numberField: "Câmp numeric"
};
var wf = {};
wf = {
  decrease: (t) => `Уменьшение ${t.fieldLabel}`,
  increase: (t) => `Увеличение ${t.fieldLabel}`,
  numberField: "Числовое поле"
};
var $f = {};
$f = {
  decrease: (t) => `Znížiť ${t.fieldLabel}`,
  increase: (t) => `Zvýšiť ${t.fieldLabel}`,
  numberField: "Číselné pole"
};
var xf = {};
xf = {
  decrease: (t) => `Upadati ${t.fieldLabel}`,
  increase: (t) => `Povečajte ${t.fieldLabel}`,
  numberField: "Številčno polje"
};
var Cf = {};
Cf = {
  decrease: (t) => `Smanji ${t.fieldLabel}`,
  increase: (t) => `Povećaj ${t.fieldLabel}`,
  numberField: "Polje broja"
};
var Mf = {};
Mf = {
  decrease: (t) => `Minska ${t.fieldLabel}`,
  increase: (t) => `Öka ${t.fieldLabel}`,
  numberField: "Nummerfält"
};
var Sf = {};
Sf = {
  decrease: (t) => `${t.fieldLabel} azalt`,
  increase: (t) => `${t.fieldLabel} arttır`,
  numberField: "Sayı alanı"
};
var Ff = {};
Ff = {
  decrease: (t) => `Зменшити ${t.fieldLabel}`,
  increase: (t) => `Збільшити ${t.fieldLabel}`,
  numberField: "Поле номера"
};
var Pf = {};
Pf = {
  decrease: (t) => `降低 ${t.fieldLabel}`,
  increase: (t) => `提高 ${t.fieldLabel}`,
  numberField: "数字字段"
};
var Nf = {};
Nf = {
  decrease: (t) => `縮小 ${t.fieldLabel}`,
  increase: (t) => `放大 ${t.fieldLabel}`,
  numberField: "數字欄位"
};
var _f = {};
_f = {
  "ar-AE": Y3,
  "bg-BG": Z3,
  "cs-CZ": X3,
  "da-DK": J3,
  "de-DE": Q3,
  "el-GR": ef,
  "en-US": tf,
  "es-ES": nf,
  "et-EE": rf,
  "fi-FI": af,
  "fr-FR": of,
  "he-IL": lf,
  "hr-HR": sf,
  "hu-HU": cf,
  "it-IT": df,
  "ja-JP": uf,
  "ko-KR": ff,
  "lt-LT": pf,
  "lv-LV": mf,
  "nb-NO": hf,
  "nl-NL": vf,
  "pl-PL": gf,
  "pt-BR": yf,
  "pt-PT": bf,
  "ro-RO": Ef,
  "ru-RU": wf,
  "sk-SK": $f,
  "sl-SI": xf,
  "sr-SP": Cf,
  "sv-SE": Mf,
  "tr-TR": Sf,
  "uk-UA": Ff,
  "zh-CN": Pf,
  "zh-TW": Nf
};
function tD(t) {
  return t && t.__esModule ? t.default : t;
}
function nD(t, e, n) {
  let { id: r, decrementAriaLabel: a, incrementAriaLabel: o, isDisabled: l, isReadOnly: s, isRequired: c, minValue: d, maxValue: u, autoFocus: f, label: m, formatOptions: g, onBlur: C = () => {
  }, onFocus: b, onFocusChange: E, onKeyDown: x, onKeyUp: _, description: N, errorMessage: k, isWheelDisabled: F, ...A } = t, { increment: O, incrementToMax: te, decrement: le, decrementToMin: W, numberValue: y, inputValue: Y, commit: ee, commitValidation: I } = e;
  const Q = Z0(tD(_f), "@react-aria/numberfield");
  let M = Rt(r), { focusProps: X } = Us({
    onBlur() {
      ee();
    }
  }), se = dd(g), he = Fe(() => se.resolvedOptions(), [
    se
  ]), L = dd({
    ...g,
    currencySign: void 0
  }), K = Fe(() => isNaN(y) ? "" : L.format(y), [
    L,
    y
  ]), { spinButtonProps: P, incrementButtonProps: D, decrementButtonProps: B } = eD({
    isDisabled: l,
    isReadOnly: s,
    isRequired: c,
    maxValue: u,
    minValue: d,
    onIncrement: O,
    onIncrementToMax: te,
    onDecrement: le,
    onDecrementToMin: W,
    value: y,
    textValue: K
  }), [H, j] = ve(!1), { focusWithinProps: Z } = d3({
    isDisabled: l,
    onFocusWithinChange: j
  }), ne = de((je) => {
    Math.abs(je.deltaY) <= Math.abs(je.deltaX) || (je.deltaY > 0 ? O() : je.deltaY < 0 && le());
  }, [
    le,
    O
  ]);
  Iz({
    onScroll: ne,
    isDisabled: F || l || s || !H
  }, n);
  var ce;
  let Oe = ((ce = he.maximumFractionDigits) !== null && ce !== void 0 ? ce : 0) > 0, V = e.minValue === void 0 || isNaN(e.minValue) || e.minValue < 0, Be = "numeric";
  R0() ? V ? Be = "text" : Oe && (Be = "decimal") : Hs() && (V ? Be = "numeric" : Oe && (Be = "decimal"));
  let Pt = (je) => {
    e.validate(je) && e.setInputValue(je);
  }, dn = Pa(t), br = de((je) => {
    je.nativeEvent.isComposing || (je.key === "Enter" ? (ee(), I()) : je.continuePropagation());
  }, [
    ee,
    I
  ]), { isInvalid: Nt, validationErrors: Er, validationDetails: In } = e.displayValidation, { labelProps: un, inputProps: io, descriptionProps: oo, errorMessageProps: lo } = Gz({
    ...A,
    ...dn,
    // These props are added to a hidden input rather than the formatted textfield.
    name: void 0,
    form: void 0,
    label: m,
    autoFocus: f,
    isDisabled: l,
    isReadOnly: s,
    isRequired: c,
    validate: void 0,
    [ns]: e,
    value: Y,
    defaultValue: "!",
    autoComplete: "off",
    "aria-label": t["aria-label"] || void 0,
    "aria-labelledby": t["aria-labelledby"] || void 0,
    id: M,
    type: "text",
    inputMode: Be,
    onChange: Pt,
    onBlur: C,
    onFocus: b,
    onFocusChange: E,
    onKeyDown: Fe(() => Os(br, x), [
      br,
      x
    ]),
    onKeyUp: _,
    description: N,
    errorMessage: k
  }, e, n);
  V0(n, e.defaultNumberValue, e.setNumberValue);
  let G = Ye(P, X, io, {
    // override the spinbutton role, we can't focus a spin button with VO
    role: null,
    // ignore aria-roledescription on iOS so that required state will announce when it is present
    "aria-roledescription": eo() ? null : Q.format("numberField"),
    "aria-valuemax": null,
    "aria-valuemin": null,
    "aria-valuenow": null,
    "aria-valuetext": null,
    autoCorrect: "off",
    spellCheck: "false"
  });
  t.validationBehavior === "native" && (G["aria-required"] = void 0);
  let re = (je) => {
    var fn;
    document.activeElement !== n.current && (je.pointerType === "mouse" ? (fn = n.current) === null || fn === void 0 || fn.focus() : je.target.focus());
  }, ze = t["aria-label"] || (typeof t.label == "string" ? t.label : ""), _e;
  ze || (_e = t.label != null ? un.id : t["aria-labelledby"]);
  let Ge = Rt(), Kt = Rt(), qt = Ye(D, {
    "aria-label": o || Q.format("increase", {
      fieldLabel: ze
    }).trim(),
    id: _e && !o ? Ge : null,
    "aria-labelledby": _e && !o ? `${Ge} ${_e}` : null,
    "aria-controls": M,
    excludeFromTabOrder: !0,
    preventFocusOnPress: !0,
    allowFocusWhenDisabled: !0,
    isDisabled: !e.canIncrement,
    onPressStart: re
  }), wr = Ye(B, {
    "aria-label": a || Q.format("decrease", {
      fieldLabel: ze
    }).trim(),
    id: _e && !a ? Kt : null,
    "aria-labelledby": _e && !a ? `${Kt} ${_e}` : null,
    "aria-controls": M,
    excludeFromTabOrder: !0,
    preventFocusOnPress: !0,
    allowFocusWhenDisabled: !0,
    isDisabled: !e.canDecrement,
    onPressStart: re
  });
  return {
    groupProps: {
      ...Z,
      role: "group",
      "aria-disabled": l,
      "aria-invalid": Nt ? "true" : void 0
    },
    labelProps: un,
    inputProps: G,
    incrementButtonProps: qt,
    decrementButtonProps: wr,
    errorMessageProps: lo,
    descriptionProps: oo,
    isInvalid: Nt,
    validationErrors: Er,
    validationDetails: In
  };
}
const Tf = /* @__PURE__ */ it({}), rD = /* @__PURE__ */ Ks(function(e, n) {
  [e, n] = Na(e, n, Tf);
  let { elementType: r = "label", ...a } = e;
  return /* @__PURE__ */ i.createElement(r, {
    className: "react-aria-Label",
    ...a,
    ref: n
  });
}), aD = /* @__PURE__ */ it(null), Af = /* @__PURE__ */ it({}), Fd = /* @__PURE__ */ Ks(function(e, n) {
  [e, n] = Na(e, n, Af);
  let r = e, { isPending: a } = r, { buttonProps: o, isPressed: l } = Xz(e, n);
  o = iD(o, a);
  let { focusProps: s, isFocused: c, isFocusVisible: d } = Gs(e), { hoverProps: u, isHovered: f } = Ws({
    ...e,
    isDisabled: e.isDisabled || a
  }), m = {
    isHovered: f,
    isPressed: (r.isPressed || l) && !a,
    isFocused: c,
    isFocusVisible: d,
    isDisabled: e.isDisabled || !1,
    isPending: a ?? !1
  }, g = no({
    ...e,
    values: m,
    defaultClassName: "react-aria-Button"
  }), C = Rt(o.id), b = Rt(), E = o["aria-labelledby"];
  a && (E ? E = `${E} ${b}` : o["aria-label"] && (E = `${C} ${b}`));
  let x = $e(a);
  xe(() => {
    let N = {
      "aria-labelledby": E || C
    };
    (!x.current && c && a || x.current && c && !a) && ql(N, "assertive"), x.current = a;
  }, [
    a,
    c,
    E,
    C
  ]);
  let _ = Pa(e, {
    global: !0
  });
  return delete _.onClick, /* @__PURE__ */ i.createElement("button", {
    ...Ye(_, g, o, s, u),
    // When the button is in a pending state, we want to stop implicit form submission (ie. when the user presses enter on a text input).
    // We do this by changing the button's type to button.
    type: o.type === "submit" && a ? "button" : o.type,
    id: C,
    ref: n,
    "aria-labelledby": E,
    slot: e.slot || void 0,
    "aria-disabled": a ? "true" : o["aria-disabled"],
    "data-disabled": e.isDisabled || void 0,
    "data-pressed": m.isPressed || void 0,
    "data-hovered": f || void 0,
    "data-focused": c || void 0,
    "data-pending": a || void 0,
    "data-focus-visible": d || void 0
  }, /* @__PURE__ */ i.createElement(aD.Provider, {
    value: {
      id: b
    }
  }, g.children));
});
function iD(t, e) {
  if (e) {
    for (const n in t) n.startsWith("on") && !(n.includes("Focus") || n.includes("Blur")) && (t[n] = void 0);
    t.href = void 0, t.target = void 0;
  }
  return t;
}
const oD = /* @__PURE__ */ it({}), lD = /* @__PURE__ */ it(null), sD = /* @__PURE__ */ it(null), zf = /* @__PURE__ */ it({}), cD = /* @__PURE__ */ _n(function(e, n) {
  [e, n] = Na(e, n, zf);
  let { isDisabled: r, isInvalid: a, isReadOnly: o, onHoverStart: l, onHoverChange: s, onHoverEnd: c, ...d } = e, { hoverProps: u, isHovered: f } = Ws({
    onHoverStart: l,
    onHoverChange: s,
    onHoverEnd: c,
    isDisabled: r
  }), { isFocused: m, isFocusVisible: g, focusProps: C } = Gs({
    within: !0
  });
  r ?? (r = !!e["aria-disabled"] && e["aria-disabled"] !== "false"), a ?? (a = !!e["aria-invalid"] && e["aria-invalid"] !== "false");
  let b = no({
    ...e,
    values: {
      isHovered: f,
      isFocusWithin: m,
      isFocusVisible: g,
      isDisabled: r,
      isInvalid: a
    },
    defaultClassName: "react-aria-Group"
  });
  var E, x;
  return /* @__PURE__ */ i.createElement("div", {
    ...Ye(d, C, u),
    ...b,
    ref: n,
    role: (E = e.role) !== null && E !== void 0 ? E : "group",
    slot: (x = e.slot) !== null && x !== void 0 ? x : void 0,
    "data-focus-within": m || void 0,
    "data-hovered": f || void 0,
    "data-focus-visible": g || void 0,
    "data-disabled": r || void 0,
    "data-invalid": a || void 0,
    "data-readonly": o || void 0
  }, b.children);
}), Df = /* @__PURE__ */ it({});
let dD = (t) => {
  let { onHoverStart: e, onHoverChange: n, onHoverEnd: r, ...a } = t;
  return a;
};
const uD = /* @__PURE__ */ Ks(function(e, n) {
  [e, n] = Na(e, n, Df);
  let { hoverProps: r, isHovered: a } = Ws(e), { isFocused: o, isFocusVisible: l, focusProps: s } = Gs({
    isTextInput: !0,
    autoFocus: e.autoFocus
  }), c = !!e["aria-invalid"] && e["aria-invalid"] !== "false", d = no({
    ...e,
    values: {
      isHovered: a,
      isFocused: o,
      isFocusVisible: l,
      isDisabled: e.disabled || !1,
      isInvalid: c
    },
    defaultClassName: "react-aria-Input"
  });
  return /* @__PURE__ */ i.createElement("input", {
    ...Ye(dD(e), s, r),
    ...d,
    ref: n,
    "data-focused": o || void 0,
    "data-disabled": e.disabled || void 0,
    "data-hovered": a || void 0,
    "data-focus-visible": l || void 0,
    "data-invalid": c || void 0
  });
}), fD = /* @__PURE__ */ it(null), pD = /* @__PURE__ */ it(null), mD = /* @__PURE__ */ _n(function(e, n) {
  [e, n] = Na(e, n, fD);
  let { validationBehavior: r } = K0(sD) || {};
  var a, o;
  let l = (o = (a = e.validationBehavior) !== null && a !== void 0 ? a : r) !== null && o !== void 0 ? o : "native", { locale: s } = Bs(), c = Jz({
    ...e,
    locale: s,
    validationBehavior: l
  }), d = $e(null), [u, f] = HA(!e["aria-label"] && !e["aria-labelledby"]), { labelProps: m, groupProps: g, inputProps: C, incrementButtonProps: b, decrementButtonProps: E, descriptionProps: x, errorMessageProps: _, ...N } = nD({
    ...BA(e),
    label: f,
    validationBehavior: l
  }, c, d), k = no({
    ...e,
    values: {
      state: c,
      isDisabled: e.isDisabled || !1,
      isInvalid: N.isInvalid || !1,
      isRequired: e.isRequired || !1
    },
    defaultClassName: "react-aria-NumberField"
  }), F = Pa(e, {
    global: !0
  });
  return delete F.id, /* @__PURE__ */ i.createElement(RA, {
    values: [
      [
        pD,
        c
      ],
      [
        zf,
        g
      ],
      [
        Df,
        {
          ...C,
          ref: d
        }
      ],
      [
        Tf,
        {
          ...m,
          ref: u
        }
      ],
      [
        Af,
        {
          slots: {
            increment: b,
            decrement: E
          }
        }
      ],
      [
        oD,
        {
          slots: {
            description: x,
            errorMessage: _
          }
        }
      ],
      [
        lD,
        N
      ]
    ]
  }, /* @__PURE__ */ i.createElement("div", {
    ...F,
    ...k,
    ref: n,
    slot: e.slot || void 0,
    "data-disabled": e.isDisabled || void 0,
    "data-required": e.isRequired || void 0,
    "data-invalid": N.isInvalid || void 0
  }), e.name && /* @__PURE__ */ i.createElement("input", {
    type: "hidden",
    name: e.name,
    form: e.form,
    value: isNaN(c.numberValue) ? "" : c.numberValue,
    disabled: e.isDisabled || void 0
  }));
});
function TO({
  label: t,
  value: e,
  onChange: n,
  onBlur: r,
  showCounter: a = !1
}) {
  return /* @__PURE__ */ S(
    mD,
    {
      formatOptions: {
        style: "currency",
        currency: "SAR",
        currencySign: "accounting"
      },
      onBlur: r,
      onChange: n,
      value: e,
      children: [
        /* @__PURE__ */ p(rD, { className: "text-foreground mb-4 text-sm font-medium", children: t }),
        /* @__PURE__ */ S(cD, { className: "border-input data-[focus-within]:border-ring data-[focus-within]:ring-ring/20 relative mt-2 inline-flex h-11 w-full items-center overflow-hidden rounded-lg border text-sm whitespace-nowrap shadow-sm shadow-black/5 transition-shadow data-[disabled]:opacity-50 data-[focus-within]:ring-[3px] data-[focus-within]:outline-none", children: [
          /* @__PURE__ */ p(uD, { className: "bg-background text-foreground flex-1 px-3 py-2 tabular-nums focus:outline-none" }),
          a && /* @__PURE__ */ S("div", { className: "flex h-[calc(100%+2px)] flex-col", children: [
            /* @__PURE__ */ p(
              Fd,
              {
                slot: "increment",
                className: "border-input bg-background text-muted-foreground/80 hover:bg-accent hover:text-foreground -me-px flex h-1/2 w-6 flex-1 items-center justify-center border text-sm transition-shadow disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50",
                children: /* @__PURE__ */ p(X4, { size: 12, strokeWidth: 2, "aria-hidden": "true" })
              }
            ),
            /* @__PURE__ */ p(
              Fd,
              {
                slot: "decrement",
                className: "border-input bg-background text-muted-foreground/80 hover:bg-accent hover:text-foreground -me-px -mt-px flex h-1/2 w-6 flex-1 items-center justify-center border text-sm transition-shadow disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50",
                children: /* @__PURE__ */ p(Y4, { size: 12, strokeWidth: 2, "aria-hidden": "true" })
              }
            )
          ] })
        ] })
      ]
    }
  );
}
function hD(t) {
  return t.startsWith("ar") ? "ar-u-nu-latn" : t;
}
function vD(t, e) {
  const { hours: n, minutes: r } = sE(t), a = new Date(2e3, 0, 1, n, r);
  return new Intl.DateTimeFormat(e, {
    hour: "numeric",
    minute: "2-digit",
    hour12: !0
  }).format(a);
}
function Ka({ locale: t, value: e }) {
  return /* @__PURE__ */ p("bdi", { dir: "ltr", children: vD(e, t) });
}
function gD({
  from: t,
  to: e
}) {
  const { i18n: n } = Ae(), r = hD(n.language);
  return n.dir() === "rtl" ? /* @__PURE__ */ S("span", { className: "inline-flex items-center gap-1", children: [
    /* @__PURE__ */ p(Ka, { locale: r, value: t }),
    /* @__PURE__ */ p("span", { children: "-" }),
    /* @__PURE__ */ p(Ka, { locale: r, value: e })
  ] }) : /* @__PURE__ */ S("span", { children: [
    /* @__PURE__ */ p(Ka, { locale: r, value: t }),
    " -",
    " ",
    /* @__PURE__ */ p(Ka, { locale: r, value: e })
  ] });
}
function yD({
  children: t,
  className: e
}) {
  return /* @__PURE__ */ p(
    "span",
    {
      className: fe(
        "flex items-center gap-0.5 rounded-md border bg-white px-1.5 py-px",
        e
      ),
      children: t
    }
  );
}
function AO({ children: t }) {
}
const bD = {
  lessThanXSeconds: {
    one: "أقل من ثانية",
    two: "أقل من ثانيتين",
    threeToTen: "أقل من {{count}} ثواني",
    other: "أقل من {{count}} ثانية"
  },
  xSeconds: {
    one: "ثانية واحدة",
    two: "ثانيتان",
    threeToTen: "{{count}} ثواني",
    other: "{{count}} ثانية"
  },
  halfAMinute: "نصف دقيقة",
  lessThanXMinutes: {
    one: "أقل من دقيقة",
    two: "أقل من دقيقتين",
    threeToTen: "أقل من {{count}} دقائق",
    other: "أقل من {{count}} دقيقة"
  },
  xMinutes: {
    one: "دقيقة واحدة",
    two: "دقيقتان",
    threeToTen: "{{count}} دقائق",
    other: "{{count}} دقيقة"
  },
  aboutXHours: {
    one: "ساعة واحدة تقريباً",
    two: "ساعتين تقريبا",
    threeToTen: "{{count}} ساعات تقريباً",
    other: "{{count}} ساعة تقريباً"
  },
  xHours: {
    one: "ساعة واحدة",
    two: "ساعتان",
    threeToTen: "{{count}} ساعات",
    other: "{{count}} ساعة"
  },
  xDays: {
    one: "يوم واحد",
    two: "يومان",
    threeToTen: "{{count}} أيام",
    other: "{{count}} يوم"
  },
  aboutXWeeks: {
    one: "أسبوع واحد تقريبا",
    two: "أسبوعين تقريبا",
    threeToTen: "{{count}} أسابيع تقريبا",
    other: "{{count}} أسبوعا تقريبا"
  },
  xWeeks: {
    one: "أسبوع واحد",
    two: "أسبوعان",
    threeToTen: "{{count}} أسابيع",
    other: "{{count}} أسبوعا"
  },
  aboutXMonths: {
    one: "شهر واحد تقريباً",
    two: "شهرين تقريبا",
    threeToTen: "{{count}} أشهر تقريبا",
    other: "{{count}} شهرا تقريباً"
  },
  xMonths: {
    one: "شهر واحد",
    two: "شهران",
    threeToTen: "{{count}} أشهر",
    other: "{{count}} شهرا"
  },
  aboutXYears: {
    one: "سنة واحدة تقريباً",
    two: "سنتين تقريبا",
    threeToTen: "{{count}} سنوات تقريباً",
    other: "{{count}} سنة تقريباً"
  },
  xYears: {
    one: "سنة واحد",
    two: "سنتان",
    threeToTen: "{{count}} سنوات",
    other: "{{count}} سنة"
  },
  overXYears: {
    one: "أكثر من سنة",
    two: "أكثر من سنتين",
    threeToTen: "أكثر من {{count}} سنوات",
    other: "أكثر من {{count}} سنة"
  },
  almostXYears: {
    one: "ما يقارب سنة واحدة",
    two: "ما يقارب سنتين",
    threeToTen: "ما يقارب {{count}} سنوات",
    other: "ما يقارب {{count}} سنة"
  }
}, ED = (t, e, n) => {
  const r = bD[t];
  let a;
  return typeof r == "string" ? a = r : e === 1 ? a = r.one : e === 2 ? a = r.two : e <= 10 ? a = r.threeToTen.replace("{{count}}", String(e)) : a = r.other.replace("{{count}}", String(e)), n?.addSuffix ? n.comparison && n.comparison > 0 ? "خلال " + a : "منذ " + a : a;
}, wD = {
  full: "EEEE، do MMMM y",
  long: "do MMMM y",
  medium: "d MMM y",
  short: "dd/MM/yyyy"
}, $D = {
  full: "HH:mm:ss",
  long: "HH:mm:ss",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, xD = {
  full: "{{date}} 'عند الساعة' {{time}}",
  long: "{{date}} 'عند الساعة' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, CD = {
  date: nr({
    formats: wD,
    defaultWidth: "full"
  }),
  time: nr({
    formats: $D,
    defaultWidth: "full"
  }),
  dateTime: nr({
    formats: xD,
    defaultWidth: "full"
  })
}, MD = {
  lastWeek: "eeee 'الماضي عند الساعة' p",
  yesterday: "'الأمس عند الساعة' p",
  today: "'اليوم عند الساعة' p",
  tomorrow: "'غدا عند الساعة' p",
  nextWeek: "eeee 'القادم عند الساعة' p",
  other: "P"
}, SD = (t) => MD[t], FD = {
  narrow: ["ق", "ب"],
  abbreviated: ["ق.م.", "ب.م."],
  wide: ["قبل الميلاد", "بعد الميلاد"]
}, PD = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["ر1", "ر2", "ر3", "ر4"],
  wide: ["الربع الأول", "الربع الثاني", "الربع الثالث", "الربع الرابع"]
}, ND = {
  narrow: ["ي", "ف", "م", "أ", "م", "ي", "ي", "أ", "س", "أ", "ن", "د"],
  abbreviated: [
    "يناير",
    "فبراير",
    "مارس",
    "أبريل",
    "مايو",
    "يونيو",
    "يوليو",
    "أغسطس",
    "سبتمبر",
    "أكتوبر",
    "نوفمبر",
    "ديسمبر"
  ],
  wide: [
    "يناير",
    "فبراير",
    "مارس",
    "أبريل",
    "مايو",
    "يونيو",
    "يوليو",
    "أغسطس",
    "سبتمبر",
    "أكتوبر",
    "نوفمبر",
    "ديسمبر"
  ]
}, _D = {
  narrow: ["ح", "ن", "ث", "ر", "خ", "ج", "س"],
  short: ["أحد", "اثنين", "ثلاثاء", "أربعاء", "خميس", "جمعة", "سبت"],
  abbreviated: ["أحد", "اثنين", "ثلاثاء", "أربعاء", "خميس", "جمعة", "سبت"],
  wide: [
    "الأحد",
    "الاثنين",
    "الثلاثاء",
    "الأربعاء",
    "الخميس",
    "الجمعة",
    "السبت"
  ]
}, TD = {
  narrow: {
    am: "ص",
    pm: "م",
    morning: "الصباح",
    noon: "الظهر",
    afternoon: "بعد الظهر",
    evening: "المساء",
    night: "الليل",
    midnight: "منتصف الليل"
  },
  abbreviated: {
    am: "ص",
    pm: "م",
    morning: "الصباح",
    noon: "الظهر",
    afternoon: "بعد الظهر",
    evening: "المساء",
    night: "الليل",
    midnight: "منتصف الليل"
  },
  wide: {
    am: "ص",
    pm: "م",
    morning: "الصباح",
    noon: "الظهر",
    afternoon: "بعد الظهر",
    evening: "المساء",
    night: "الليل",
    midnight: "منتصف الليل"
  }
}, AD = {
  narrow: {
    am: "ص",
    pm: "م",
    morning: "في الصباح",
    noon: "الظهر",
    afternoon: "بعد الظهر",
    evening: "في المساء",
    night: "في الليل",
    midnight: "منتصف الليل"
  },
  abbreviated: {
    am: "ص",
    pm: "م",
    morning: "في الصباح",
    noon: "الظهر",
    afternoon: "بعد الظهر",
    evening: "في المساء",
    night: "في الليل",
    midnight: "منتصف الليل"
  },
  wide: {
    am: "ص",
    pm: "م",
    morning: "في الصباح",
    noon: "الظهر",
    afternoon: "بعد الظهر",
    evening: "في المساء",
    night: "في الليل",
    midnight: "منتصف الليل"
  }
}, zD = (t) => String(t), DD = {
  ordinalNumber: zD,
  era: bt({
    values: FD,
    defaultWidth: "wide"
  }),
  quarter: bt({
    values: PD,
    defaultWidth: "wide",
    argumentCallback: (t) => t - 1
  }),
  month: bt({
    values: ND,
    defaultWidth: "wide"
  }),
  day: bt({
    values: _D,
    defaultWidth: "wide"
  }),
  dayPeriod: bt({
    values: TD,
    defaultWidth: "wide",
    formattingValues: AD,
    defaultFormattingWidth: "wide"
  })
}, ID = /^(\d+)(th|st|nd|rd)?/i, kD = /\d+/i, OD = {
  narrow: /[قب]/,
  abbreviated: /[قب]\.م\./,
  wide: /(قبل|بعد) الميلاد/
}, LD = {
  any: [/قبل/, /بعد/]
}, RD = {
  narrow: /^[1234]/i,
  abbreviated: /ر[1234]/,
  wide: /الربع (الأول|الثاني|الثالث|الرابع)/
}, HD = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, BD = {
  narrow: /^[أيفمسند]/,
  abbreviated: /^(يناير|فبراير|مارس|أبريل|مايو|يونيو|يوليو|أغسطس|سبتمبر|أكتوبر|نوفمبر|ديسمبر)/,
  wide: /^(يناير|فبراير|مارس|أبريل|مايو|يونيو|يوليو|أغسطس|سبتمبر|أكتوبر|نوفمبر|ديسمبر)/
}, jD = {
  narrow: [
    /^ي/i,
    /^ف/i,
    /^م/i,
    /^أ/i,
    /^م/i,
    /^ي/i,
    /^ي/i,
    /^أ/i,
    /^س/i,
    /^أ/i,
    /^ن/i,
    /^د/i
  ],
  any: [
    /^يناير/i,
    /^فبراير/i,
    /^مارس/i,
    /^أبريل/i,
    /^مايو/i,
    /^يونيو/i,
    /^يوليو/i,
    /^أغسطس/i,
    /^سبتمبر/i,
    /^أكتوبر/i,
    /^نوفمبر/i,
    /^ديسمبر/i
  ]
}, VD = {
  narrow: /^[حنثرخجس]/i,
  short: /^(أحد|اثنين|ثلاثاء|أربعاء|خميس|جمعة|سبت)/i,
  abbreviated: /^(أحد|اثنين|ثلاثاء|أربعاء|خميس|جمعة|سبت)/i,
  wide: /^(الأحد|الاثنين|الثلاثاء|الأربعاء|الخميس|الجمعة|السبت)/i
}, UD = {
  narrow: [/^ح/i, /^ن/i, /^ث/i, /^ر/i, /^خ/i, /^ج/i, /^س/i],
  wide: [
    /^الأحد/i,
    /^الاثنين/i,
    /^الثلاثاء/i,
    /^الأربعاء/i,
    /^الخميس/i,
    /^الجمعة/i,
    /^السبت/i
  ],
  any: [/^أح/i, /^اث/i, /^ث/i, /^أر/i, /^خ/i, /^ج/i, /^س/i]
}, WD = {
  narrow: /^(ص|م|منتصف الليل|الظهر|بعد الظهر|في الصباح|في المساء|في الليل)/,
  any: /^(ص|م|منتصف الليل|الظهر|بعد الظهر|في الصباح|في المساء|في الليل)/
}, GD = {
  any: {
    am: /^ص/,
    pm: /^م/,
    midnight: /منتصف الليل/,
    noon: /الظهر/,
    afternoon: /بعد الظهر/,
    morning: /في الصباح/,
    evening: /في المساء/,
    night: /في الليل/
  }
}, KD = {
  ordinalNumber: z2({
    matchPattern: ID,
    parsePattern: kD,
    valueCallback: (t) => parseInt(t, 10)
  }),
  era: Et({
    matchPatterns: OD,
    defaultMatchWidth: "wide",
    parsePatterns: LD,
    defaultParseWidth: "any"
  }),
  quarter: Et({
    matchPatterns: RD,
    defaultMatchWidth: "wide",
    parsePatterns: HD,
    defaultParseWidth: "any",
    valueCallback: (t) => t + 1
  }),
  month: Et({
    matchPatterns: BD,
    defaultMatchWidth: "wide",
    parsePatterns: jD,
    defaultParseWidth: "any"
  }),
  day: Et({
    matchPatterns: VD,
    defaultMatchWidth: "wide",
    parsePatterns: UD,
    defaultParseWidth: "any"
  }),
  dayPeriod: Et({
    matchPatterns: WD,
    defaultMatchWidth: "any",
    parsePatterns: GD,
    defaultParseWidth: "any"
  })
}, If = {
  code: "ar",
  formatDistance: ED,
  formatLong: CD,
  formatRelative: SD,
  localize: DD,
  match: KD,
  options: {
    weekStartsOn: 6,
    firstWeekContainsDate: 1
  }
}, qD = { ar: If, en: D2 };
function qs() {
  return qD[z4.language] ?? If;
}
function nl(t) {
  return Ms(t, "EEEE - dd/MM/yyyy", { locale: qs() });
}
function zO(t) {
  return Ms(t, "h:mm a", { locale: qs() });
}
function DO(t) {
  return Ms(t, "EEEE - dd/MM/yyyy - h:mm a", { locale: qs() });
}
function IO(t) {
  return t?.birthDate ? o7(/* @__PURE__ */ new Date(), t.birthDate) : void 0;
}
function kO({ request: t }) {
  const { t: e } = Ae(), n = t.projectType === "GOVERNMENT" ? e("shared.reviewRequest.governmentSector") : e("shared.reviewRequest.privateSector"), r = t.offers.find((l) => l.id === t.offerId), { phase: a, rejectionReason: o } = gE({
    offerId: t.offerId,
    acceptedOffer: r,
    requiredDocuments: t.requiredDocuments
  });
  return /* @__PURE__ */ p($t, { children: /* @__PURE__ */ p(ki, { className: "border-primary bg-white py-5", children: /* @__PURE__ */ S(Oi, { className: "space-y-6", children: [
    /* @__PURE__ */ p(
      vE,
      {
        phase: a,
        rejectionReason: o
      }
    ),
    /* @__PURE__ */ S("div", { className: "grid grid-cols-2 gap-6", children: [
      /* @__PURE__ */ S("div", { className: "space-y-1", children: [
        /* @__PURE__ */ p("p", { className: "text-muted-foreground text-sm", children: e("shared.reviewRequest.projectType") }),
        /* @__PURE__ */ p("p", { className: "font-bold", children: n })
      ] }),
      /* @__PURE__ */ S("div", { className: "space-y-1", children: [
        /* @__PURE__ */ p("p", { className: "text-muted-foreground text-sm", children: e("shared.reviewRequest.projectLocation") }),
        /* @__PURE__ */ p(
          B5,
          {
            name: t.location.name,
            latitude: t.location.latitude,
            longitude: t.location.longitude,
            showMapIcon: !1,
            className: "text-sm font-medium"
          }
        )
      ] })
    ] }),
    /* @__PURE__ */ S("div", { className: "grid grid-cols-2 gap-6", children: [
      /* @__PURE__ */ S("div", { className: "space-y-1", children: [
        /* @__PURE__ */ p("p", { className: "text-muted-foreground text-sm", children: e("shared.reviewRequest.requestDate") }),
        /* @__PURE__ */ S("div", { className: "flex items-center gap-2", children: [
          /* @__PURE__ */ p(G4, { size: 18 }),
          /* @__PURE__ */ S("span", { children: [
            nl(t.scheduleStartDate),
            " -",
            " ",
            nl(t.scheduleEndDate)
          ] })
        ] })
      ] }),
      /* @__PURE__ */ S("div", { className: "space-y-1", children: [
        /* @__PURE__ */ p("p", { className: "text-muted-foreground text-sm", children: e("shared.reviewRequest.dailyWorkHours") }),
        /* @__PURE__ */ S("div", { className: "flex items-center gap-2", children: [
          /* @__PURE__ */ p(Ir, { size: 18 }),
          /* @__PURE__ */ p(
            gD,
            {
              from: t.scheduleHoursFrom,
              to: t.scheduleHoursTo
            }
          )
        ] })
      ] })
    ] }),
    /* @__PURE__ */ S("div", { className: "space-y-3", children: [
      /* @__PURE__ */ p("p", { className: "text-muted-foreground text-sm", children: e("shared.reviewRequest.requiredServices") }),
      /* @__PURE__ */ p("div", { className: "flex flex-wrap gap-2", children: YD(t, e).map((l, s) => /* @__PURE__ */ p(yD, { className: "text-sm", children: l }, s)) })
    ] }),
    /* @__PURE__ */ S("div", { className: "space-y-3", children: [
      /* @__PURE__ */ p("p", { className: "text-muted-foreground text-sm", children: e("shared.reviewRequest.siteConditions") }),
      /* @__PURE__ */ S("div", { className: "flex flex-col gap-2", children: [
        /* @__PURE__ */ p(
          po,
          {
            value: t.isolatedWorkArea,
            label: e("shared.reviewRequest.isolatedArea")
          }
        ),
        /* @__PURE__ */ p(
          po,
          {
            value: t.housingTransportProvided,
            label: e("shared.reviewRequest.housingTransport")
          }
        ),
        /* @__PURE__ */ p(
          po,
          {
            value: t.mealsProvided,
            label: e("shared.reviewRequest.mealsForStaff")
          }
        )
      ] })
    ] }),
    t.notes && /* @__PURE__ */ S("div", { className: "space-y-3", children: [
      /* @__PURE__ */ p("p", { className: "text-muted-foreground text-sm", children: e("shared.reviewRequest.notes") }),
      /* @__PURE__ */ p("p", { className: "text-sm whitespace-pre-wrap", children: t.notes })
    ] }),
    (t.proposalDeadline || t.bankGuaranteePercent || t.paymentSchedule || t.kpis) && /* @__PURE__ */ S($t, { children: [
      /* @__PURE__ */ p(ou, {}),
      /* @__PURE__ */ S("div", { className: "space-y-4", children: [
        /* @__PURE__ */ p("p", { className: "text-muted-foreground text-sm font-medium", children: e("shared.reviewRequest.offerAndPayment") }),
        /* @__PURE__ */ S("div", { className: "grid grid-cols-2 gap-6", children: [
          t.proposalDeadline && /* @__PURE__ */ S("div", { className: "space-y-1", children: [
            /* @__PURE__ */ p("p", { className: "text-muted-foreground text-sm", children: e("shared.reviewRequest.proposalDeadline") }),
            /* @__PURE__ */ S("div", { className: "flex items-center gap-2", children: [
              /* @__PURE__ */ p(Ir, { size: 18 }),
              /* @__PURE__ */ p("span", { className: "font-medium", children: nl(t.proposalDeadline) })
            ] })
          ] }),
          t.bankGuaranteePercent && /* @__PURE__ */ S("div", { className: "space-y-1", children: [
            /* @__PURE__ */ p("p", { className: "text-muted-foreground text-sm", children: e("shared.reviewRequest.bankGuarantee") }),
            /* @__PURE__ */ S("div", { className: "flex items-center gap-2", children: [
              /* @__PURE__ */ p(Ep, { size: 18 }),
              /* @__PURE__ */ S("span", { className: "font-medium", children: [
                t.bankGuaranteePercent,
                "%"
              ] })
            ] })
          ] })
        ] }),
        t.paymentSchedule && t.paymentSchedule.milestones.length > 0 && /* @__PURE__ */ S("div", { className: "space-y-2", children: [
          /* @__PURE__ */ p("p", { className: "text-muted-foreground text-sm", children: e("shared.reviewRequest.paymentSystem") }),
          /* @__PURE__ */ S("div", { className: "flex items-start gap-2", children: [
            /* @__PURE__ */ p(U4, { size: 18, className: "mt-0.5" }),
            /* @__PURE__ */ S("div", { children: [
              /* @__PURE__ */ p("p", { className: "font-medium", children: e(O5(t.paymentSchedule)) }),
              /* @__PURE__ */ p("ul", { className: "text-muted-foreground mt-2 space-y-1 text-sm", children: t.paymentSchedule.milestones.map(
                (l, s) => /* @__PURE__ */ S("li", { className: "flex gap-1", children: [
                  /* @__PURE__ */ p("span", { children: "•" }),
                  /* @__PURE__ */ S("span", { children: [
                    e("shared.reviewRequest.installment"),
                    " ",
                    hE(s + 1, "feminine"),
                    ": ",
                    l.percentage,
                    "%"
                  ] })
                ] }, s)
              ) })
            ] })
          ] })
        ] }),
        t.kpis.length > 0 && /* @__PURE__ */ S("div", { className: "space-y-2", children: [
          /* @__PURE__ */ p("p", { className: "text-muted-foreground text-sm", children: e("shared.reviewRequest.kpis") }),
          /* @__PURE__ */ p("ul", { className: "text-sm", children: t.kpis.map((l, s) => /* @__PURE__ */ S("li", { className: "flex gap-1", children: [
            /* @__PURE__ */ p("span", { children: "•" }),
            /* @__PURE__ */ p("span", { children: l })
          ] }, s)) })
        ] })
      ] })
    ] })
  ] }) }) });
}
function OO() {
  return /* @__PURE__ */ p(ki, { className: "border-primary py-5", children: /* @__PURE__ */ S(Oi, { className: "space-y-6", children: [
    /* @__PURE__ */ S("div", { className: "flex items-center justify-end gap-2", children: [
      /* @__PURE__ */ p(me, { className: "h-6 w-24" }),
      /* @__PURE__ */ p(me, { className: "h-5 w-5" })
    ] }),
    /* @__PURE__ */ S("div", { className: "grid grid-cols-2 gap-6", children: [
      /* @__PURE__ */ S("div", { className: "space-y-2", children: [
        /* @__PURE__ */ p(me, { className: "h-4 w-20" }),
        /* @__PURE__ */ p(me, { className: "h-5 w-28" })
      ] }),
      /* @__PURE__ */ S("div", { className: "space-y-2", children: [
        /* @__PURE__ */ p(me, { className: "h-4 w-24" }),
        /* @__PURE__ */ p(me, { className: "h-5 w-48" })
      ] })
    ] }),
    /* @__PURE__ */ S("div", { className: "grid grid-cols-2 gap-6", children: [
      /* @__PURE__ */ S("div", { className: "space-y-2", children: [
        /* @__PURE__ */ p(me, { className: "h-4 w-20" }),
        /* @__PURE__ */ S("div", { className: "flex items-center gap-2", children: [
          /* @__PURE__ */ p(me, { className: "h-5 w-5" }),
          /* @__PURE__ */ p(me, { className: "h-5 w-40" })
        ] })
      ] }),
      /* @__PURE__ */ S("div", { className: "space-y-2", children: [
        /* @__PURE__ */ p(me, { className: "h-4 w-28" }),
        /* @__PURE__ */ S("div", { className: "flex items-center gap-2", children: [
          /* @__PURE__ */ p(me, { className: "h-5 w-5" }),
          /* @__PURE__ */ p(me, { className: "h-5 w-32" })
        ] })
      ] })
    ] }),
    /* @__PURE__ */ S("div", { className: "space-y-3", children: [
      /* @__PURE__ */ p(me, { className: "h-4 w-24" }),
      /* @__PURE__ */ S("div", { className: "flex flex-wrap gap-2", children: [
        /* @__PURE__ */ p(me, { className: "h-8 w-24 rounded-md" }),
        /* @__PURE__ */ p(me, { className: "h-8 w-36 rounded-md" }),
        /* @__PURE__ */ p(me, { className: "h-8 w-32 rounded-md" })
      ] })
    ] }),
    /* @__PURE__ */ p(me, { className: "h-px w-full" }),
    /* @__PURE__ */ S("div", { className: "space-y-3", children: [
      /* @__PURE__ */ p(me, { className: "mx-auto h-4 w-20" }),
      /* @__PURE__ */ S("div", { className: "flex flex-col items-center gap-2", children: [
        /* @__PURE__ */ S("div", { className: "flex items-center gap-2", children: [
          /* @__PURE__ */ p(me, { className: "h-5 w-5" }),
          /* @__PURE__ */ p(me, { className: "h-5 w-36" })
        ] }),
        /* @__PURE__ */ S("div", { className: "flex items-center gap-2", children: [
          /* @__PURE__ */ p(me, { className: "h-5 w-5" }),
          /* @__PURE__ */ p(me, { className: "h-5 w-28" })
        ] }),
        /* @__PURE__ */ S("div", { className: "flex items-center gap-2", children: [
          /* @__PURE__ */ p(me, { className: "h-5 w-5" }),
          /* @__PURE__ */ p(me, { className: "h-5 w-32" })
        ] })
      ] })
    ] })
  ] }) });
}
function Tt(t) {
  return !t || t.length === 0 ? "" : ` (${t.map((e) => `${e.name} × ${e.quantity}`).join("، ")})`;
}
function YD(t, e) {
  const n = [];
  for (const f of t.ambulanceServiceWithDriver) {
    if (f.type1Amount > 0) {
      const m = Tt(f.type1Equipment);
      n.push(
        `${f.type1Amount} ${e("shared.services.ambulanceWithDriver")} - ${jn.type1.name}${m}`
      );
    }
    if (f.type2Amount > 0) {
      const m = Tt(f.type2Equipment);
      n.push(
        `${f.type2Amount} ${e("shared.services.ambulanceWithDriver")} - ${jn.type2.name}${m}`
      );
    }
    if (f.type3Amount > 0) {
      const m = Tt(f.type3Equipment);
      n.push(
        `${f.type3Amount} ${e("shared.services.ambulanceWithDriver")} - ${jn.type3.name}${m}`
      );
    }
  }
  for (const f of t.ambulanceServiceWithoutDriver) {
    if (f.type1Amount > 0) {
      const m = Tt(f.type1Equipment);
      n.push(
        `${f.type1Amount} ${e("shared.services.ambulanceWithoutDriver")} - ${jn.type1.name}${m}`
      );
    }
    if (f.type2Amount > 0) {
      const m = Tt(f.type2Equipment);
      n.push(
        `${f.type2Amount} ${e("shared.services.ambulanceWithoutDriver")} - ${jn.type2.name}${m}`
      );
    }
    if (f.type3Amount > 0) {
      const m = Tt(f.type3Equipment);
      n.push(
        `${f.type3Amount} ${e("shared.services.ambulanceWithoutDriver")} - ${jn.type3.name}${m}`
      );
    }
  }
  for (const f of t.ambulance4x4WithDriver)
    if (f.amount > 0) {
      const m = Tt(f.equipment || []);
      n.push(`${f.amount} ${e("shared.services.ambulance4x4WithDriver")}${m}`);
    }
  for (const f of t.ambulance4x4WithoutDriver)
    if (f.amount > 0) {
      const m = Tt(f.equipment || []);
      n.push(`${f.amount} ${e("shared.services.ambulance4x4WithoutDriver")}${m}`);
    }
  for (const f of t.mobileClinicService)
    if (f.amount > 0) {
      const m = Tt(f.equipment || []), g = f.type === "ADVANCED" ? "shared.services.mobileClinicAdvanced" : "shared.services.mobileClinicBasic";
      n.push(`${f.amount} ${e(g)}${m}`);
    }
  const r = t.requestParamedicService.find(
    (f) => f.type === "SPECIALIST"
  ), a = t.requestParamedicService.find(
    (f) => f.type === "TECHNICIAN"
  ), o = [];
  r && r.amount > 0 && o.push(`${e("shared.services.specialist")}: ${r.amount}`), a && a.amount > 0 && o.push(`${e("shared.services.technician")}: ${a.amount}`), o.length > 0 && n.push(`${e("shared.services.paramedics")} (${o.join("، ")})`);
  const l = t.requestNurseService.find(
    (f) => f.type === "SPECIALIST"
  ), s = t.requestNurseService.find(
    (f) => f.type === "TECHNICIAN"
  ), c = [];
  l && l.amount > 0 && c.push(`${e("shared.services.specialist")}: ${l.amount}`), s && s.amount > 0 && c.push(`${e("shared.services.technician")}: ${s.amount}`), c.length > 0 && n.push(`${e("shared.services.nurses")} (${c.join("، ")})`);
  const d = [];
  for (const f of t.doctorService)
    f.amount > 0 && d.push(`${f.specialization}: ${f.amount}`);
  d.length > 0 && n.push(`${e("shared.services.doctors")} (${d.join("، ")})`);
  const u = t.medicalEquipment;
  if (u && u.length > 0) {
    const f = u.map((m) => `${m.name}: ${m.quantity}`).join("، ");
    n.push(`${e("shared.services.medicalEquipment")} (${f})`);
  }
  return n;
}
var ZD = typeof global == "object" && global && global.Object === Object && global, XD = typeof self == "object" && self && self.Object === Object && self, kf = ZD || XD || Function("return this")(), Ai = kf.Symbol, Of = Object.prototype, JD = Of.hasOwnProperty, QD = Of.toString, Sr = Ai ? Ai.toStringTag : void 0;
function eI(t) {
  var e = JD.call(t, Sr), n = t[Sr];
  try {
    t[Sr] = void 0;
    var r = !0;
  } catch {
  }
  var a = QD.call(t);
  return r && (e ? t[Sr] = n : delete t[Sr]), a;
}
var tI = Object.prototype, nI = tI.toString;
function rI(t) {
  return nI.call(t);
}
var aI = "[object Null]", iI = "[object Undefined]", Pd = Ai ? Ai.toStringTag : void 0;
function oI(t) {
  return t == null ? t === void 0 ? iI : aI : Pd && Pd in Object(t) ? eI(t) : rI(t);
}
function lI(t) {
  return t != null && typeof t == "object";
}
var sI = "[object Symbol]";
function cI(t) {
  return typeof t == "symbol" || lI(t) && oI(t) == sI;
}
var dI = /\s/;
function uI(t) {
  for (var e = t.length; e-- && dI.test(t.charAt(e)); )
    ;
  return e;
}
var fI = /^\s+/;
function pI(t) {
  return t && t.slice(0, uI(t) + 1).replace(fI, "");
}
function as(t) {
  var e = typeof t;
  return t != null && (e == "object" || e == "function");
}
var Nd = NaN, mI = /^[-+]0x[0-9a-f]+$/i, hI = /^0b[01]+$/i, vI = /^0o[0-7]+$/i, gI = parseInt;
function _d(t) {
  if (typeof t == "number")
    return t;
  if (cI(t))
    return Nd;
  if (as(t)) {
    var e = typeof t.valueOf == "function" ? t.valueOf() : t;
    t = as(e) ? e + "" : e;
  }
  if (typeof t != "string")
    return t === 0 ? t : +t;
  t = pI(t);
  var n = hI.test(t);
  return n || vI.test(t) ? gI(t.slice(2), n ? 2 : 8) : mI.test(t) ? Nd : +t;
}
var rl = function() {
  return kf.Date.now();
}, yI = "Expected a function", bI = Math.max, EI = Math.min;
function wI(t, e, n) {
  var r, a, o, l, s, c, d = 0, u = !1, f = !1, m = !0;
  if (typeof t != "function")
    throw new TypeError(yI);
  e = _d(e) || 0, as(n) && (u = !!n.leading, f = "maxWait" in n, o = f ? bI(_d(n.maxWait) || 0, e) : o, m = "trailing" in n ? !!n.trailing : m);
  function g(A) {
    var O = r, te = a;
    return r = a = void 0, d = A, l = t.apply(te, O), l;
  }
  function C(A) {
    return d = A, s = setTimeout(x, e), u ? g(A) : l;
  }
  function b(A) {
    var O = A - c, te = A - d, le = e - O;
    return f ? EI(le, o - te) : le;
  }
  function E(A) {
    var O = A - c, te = A - d;
    return c === void 0 || O >= e || O < 0 || f && te >= o;
  }
  function x() {
    var A = rl();
    if (E(A))
      return _(A);
    s = setTimeout(x, b(A));
  }
  function _(A) {
    return s = void 0, m && r ? g(A) : (r = a = void 0, l);
  }
  function N() {
    s !== void 0 && clearTimeout(s), d = 0, r = c = a = s = void 0;
  }
  function k() {
    return s === void 0 ? l : _(rl());
  }
  function F() {
    var A = rl(), O = E(A);
    if (r = arguments, a = this, c = A, O) {
      if (s === void 0)
        return C(c);
      if (f)
        return clearTimeout(s), s = setTimeout(x, e), g(c);
    }
    return s === void 0 && (s = setTimeout(x, e)), l;
  }
  return F.cancel = N, F.flush = k, F;
}
function qa(t) {
  for (var e = 1; e < arguments.length; e++) {
    var n = arguments[e];
    for (var r in n)
      t[r] = n[r];
  }
  return t;
}
var $I = {
  read: function(t) {
    return t[0] === '"' && (t = t.slice(1, -1)), t.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent);
  },
  write: function(t) {
    return encodeURIComponent(t).replace(
      /%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g,
      decodeURIComponent
    );
  }
};
function is(t, e) {
  function n(a, o, l) {
    if (!(typeof document > "u")) {
      l = qa({}, e, l), typeof l.expires == "number" && (l.expires = new Date(Date.now() + l.expires * 864e5)), l.expires && (l.expires = l.expires.toUTCString()), a = encodeURIComponent(a).replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent).replace(/[()]/g, escape);
      var s = "";
      for (var c in l)
        l[c] && (s += "; " + c, l[c] !== !0 && (s += "=" + l[c].split(";")[0]));
      return document.cookie = a + "=" + t.write(o, a) + s;
    }
  }
  function r(a) {
    if (!(typeof document > "u" || arguments.length && !a)) {
      for (var o = document.cookie ? document.cookie.split("; ") : [], l = {}, s = 0; s < o.length; s++) {
        var c = o[s].split("="), d = c.slice(1).join("=");
        try {
          var u = decodeURIComponent(c[0]);
          if (l[u] = t.read(d, u), a === u)
            break;
        } catch {
        }
      }
      return a ? l[a] : l;
    }
  }
  return Object.create(
    {
      set: n,
      get: r,
      remove: function(a, o) {
        n(
          a,
          "",
          qa({}, o, {
            expires: -1
          })
        );
      },
      withAttributes: function(a) {
        return is(this.converter, qa({}, this.attributes, a));
      },
      withConverter: function(a) {
        return is(qa({}, this.converter, a), this.attributes);
      }
    },
    {
      attributes: { value: Object.freeze(e) },
      converter: { value: Object.freeze(t) }
    }
  );
}
is($I, { path: "/" });
var al = { exports: {} };
var Td;
function xI() {
  return Td || (Td = 1, (function(t) {
    (function() {
      var e = typeof window < "u" && typeof window.document < "u" ? window.document : {}, n = t.exports, r = (function() {
        for (var l, s = [
          [
            "requestFullscreen",
            "exitFullscreen",
            "fullscreenElement",
            "fullscreenEnabled",
            "fullscreenchange",
            "fullscreenerror"
          ],
          // New WebKit
          [
            "webkitRequestFullscreen",
            "webkitExitFullscreen",
            "webkitFullscreenElement",
            "webkitFullscreenEnabled",
            "webkitfullscreenchange",
            "webkitfullscreenerror"
          ],
          // Old WebKit
          [
            "webkitRequestFullScreen",
            "webkitCancelFullScreen",
            "webkitCurrentFullScreenElement",
            "webkitCancelFullScreen",
            "webkitfullscreenchange",
            "webkitfullscreenerror"
          ],
          [
            "mozRequestFullScreen",
            "mozCancelFullScreen",
            "mozFullScreenElement",
            "mozFullScreenEnabled",
            "mozfullscreenchange",
            "mozfullscreenerror"
          ],
          [
            "msRequestFullscreen",
            "msExitFullscreen",
            "msFullscreenElement",
            "msFullscreenEnabled",
            "MSFullscreenChange",
            "MSFullscreenError"
          ]
        ], c = 0, d = s.length, u = {}; c < d; c++)
          if (l = s[c], l && l[1] in e) {
            for (c = 0; c < l.length; c++)
              u[s[0][c]] = l[c];
            return u;
          }
        return !1;
      })(), a = {
        change: r.fullscreenchange,
        error: r.fullscreenerror
      }, o = {
        request: function(l, s) {
          return new Promise((function(c, d) {
            var u = (function() {
              this.off("change", u), c();
            }).bind(this);
            this.on("change", u), l = l || e.documentElement;
            var f = l[r.requestFullscreen](s);
            f instanceof Promise && f.then(u).catch(d);
          }).bind(this));
        },
        exit: function() {
          return new Promise((function(l, s) {
            if (!this.isFullscreen) {
              l();
              return;
            }
            var c = (function() {
              this.off("change", c), l();
            }).bind(this);
            this.on("change", c);
            var d = e[r.exitFullscreen]();
            d instanceof Promise && d.then(c).catch(s);
          }).bind(this));
        },
        toggle: function(l, s) {
          return this.isFullscreen ? this.exit() : this.request(l, s);
        },
        onchange: function(l) {
          this.on("change", l);
        },
        onerror: function(l) {
          this.on("error", l);
        },
        on: function(l, s) {
          var c = a[l];
          c && e.addEventListener(c, s, !1);
        },
        off: function(l, s) {
          var c = a[l];
          c && e.removeEventListener(c, s, !1);
        },
        raw: r
      };
      if (!r) {
        n ? t.exports = { isEnabled: !1 } : window.screenfull = { isEnabled: !1 };
        return;
      }
      Object.defineProperties(o, {
        isFullscreen: {
          get: function() {
            return !!e[r.fullscreenElement];
          }
        },
        element: {
          enumerable: !0,
          get: function() {
            return e[r.fullscreenElement];
          }
        },
        isEnabled: {
          enumerable: !0,
          get: function() {
            return !!e[r.fullscreenEnabled];
          }
        }
      }), n ? t.exports = o : window.screenfull = o;
    })();
  })(al)), al.exports;
}
xI();
var Ad, zd;
function Lf(t) {
  return typeof t == "function";
}
const Rf = process.env.NODE_ENV === "development" || process.env.NODE_ENV === "test", Hf = typeof window < "u", CI = typeof navigator < "u";
Hf && (!((zd = window) == null || (Ad = zd.navigator) == null) && Ad.userAgent) && /iP(?:ad|hone|od)/.test(window.navigator.userAgent);
const MI = Hf ? b4 : xe, Bf = (t) => {
  const e = $e(t);
  return MI(() => {
    e.current = t;
  }, [
    t
  ]), e;
};
function SI(t) {
  Rf && (Lf(t) || console.error(`useUnmount expected parameter is a function, got ${typeof t}`));
  const e = Bf(t);
  xe(() => () => {
    e.current();
  }, [
    e
  ]);
}
const FI = (t, e, n) => {
  Rf && (Lf(t) || console.error(`useDebounceFn expected parameter is a function, got ${typeof t}`));
  const r = Bf(t), a = Fe(
    () => wI((...o) => r.current(...o), e, n),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      JSON.stringify(n),
      e
    ]
  );
  return SI(() => {
    a.cancel();
  }), {
    run: a,
    cancel: a.cancel,
    flush: a.flush
  };
}, PI = (t, e, n) => {
  const [r, a] = ve(t), { run: o } = FI(() => {
    a(t);
  }, e, n);
  return xe(() => {
    o();
  }, [
    o,
    t
  ]), r;
}, Ya = CI ? navigator : void 0;
Ya && (Ya.connection || Ya.mozConnection || Ya.webkitConnection);
i.use;
function LO({
  onChange: t,
  minCharacters: e,
  ...n
}) {
  const r = Li(), [a, o] = ve(n.value || ""), l = PI(a, 300);
  xe(() => {
    o(n.value || "");
  }, [n.value]);
  const s = a.trim(), d = /^\d/.test(s) ? 0 : typeof e == "function" ? e(a) : e ?? 3;
  return xe(() => {
    if (t) {
      const u = l.trim();
      u.length ? u.length >= d && t(u) : t(void 0);
    }
  }, [l, t, d]), /* @__PURE__ */ S("div", { className: fe("min-w-[300px]", n.className), children: [
    /* @__PURE__ */ p(wa, { htmlFor: r, children: n.label }),
    /* @__PURE__ */ S("div", { className: "relative", children: [
      /* @__PURE__ */ p(
        $a,
        {
          id: r,
          className: "peer h-11 ps-9 pe-9 shadow-none",
          placeholder: n.placeholder ?? "Search...",
          value: a,
          type: "text",
          onChange: (u) => {
            o(u.target.value);
          }
        }
      ),
      /* @__PURE__ */ p("div", { className: "text-muted-foreground/80 pointer-events-none absolute inset-y-0 start-0 flex items-center justify-center ps-3 peer-disabled:opacity-50", children: n.isLoading ? /* @__PURE__ */ p(
        fu,
        {
          className: "animate-spin",
          size: 16,
          strokeWidth: 2,
          role: "status",
          "aria-label": "Loading..."
        }
      ) : /* @__PURE__ */ p(_p, { size: 16, strokeWidth: 2, "aria-hidden": "true" }) })
    ] })
  ] });
}
function RO({
  open: t,
  isPending: e,
  onAccept: n,
  onLogout: r,
  documents: a
}) {
  const { t: o } = Ae(), [l, s] = ve(!1), c = a.map(({ label: d }) => d).join(o("shared.terms.documentSeparator"));
  return /* @__PURE__ */ p(Zd, { open: t, children: /* @__PURE__ */ S(Xd, { className: "gap-7 rounded-3xl p-6 sm:max-w-3xl sm:p-10", children: [
    /* @__PURE__ */ S(Jd, { children: [
      /* @__PURE__ */ p(Qd, { className: "text-2xl leading-tight sm:text-3xl", children: o("shared.terms.title") }),
      /* @__PURE__ */ p(eu, { className: "text-base leading-7 sm:text-lg", children: o("shared.terms.description") })
    ] }),
    /* @__PURE__ */ p("ul", { className: "divide-border divide-y overflow-hidden rounded-xl border", children: a.map((d) => {
      const u = d.kind === "agreement" ? uu : Ap;
      return /* @__PURE__ */ p("li", { children: /* @__PURE__ */ S(
        "a",
        {
          href: d.href,
          target: "_blank",
          rel: "noopener noreferrer",
          className: "hover:bg-accent focus-visible:ring-ring flex min-h-16 items-center gap-3 px-5 py-4 text-base font-medium text-blue-600 transition-colors focus-visible:ring-2 focus-visible:outline-none sm:text-lg dark:text-blue-400",
          children: [
            /* @__PURE__ */ p(u, { "aria-hidden": "true", className: "size-6" }),
            /* @__PURE__ */ p("span", { children: d.label }),
            /* @__PURE__ */ p(
              du,
              {
                "aria-hidden": "true",
                className: "ms-auto size-5"
              }
            )
          ]
        }
      ) }, d.href);
    }) }),
    /* @__PURE__ */ S(
      "label",
      {
        htmlFor: "terms-acceptance",
        className: "flex cursor-pointer items-start gap-3 text-base leading-8 sm:text-lg",
        children: [
          /* @__PURE__ */ p(
            p4,
            {
              id: "terms-acceptance",
              checked: l,
              onCheckedChange: (d) => s(d === !0),
              disabled: e,
              className: "mt-1.5 size-5"
            }
          ),
          /* @__PURE__ */ p("span", { children: o("shared.terms.acknowledgement", {
            documents: c
          }) })
        ]
      }
    ),
    /* @__PURE__ */ S(tu, { className: "gap-3 sm:rtl:flex-row-reverse", children: [
      /* @__PURE__ */ p(
        mt,
        {
          variant: "outline",
          onClick: r,
          disabled: e,
          className: "min-w-40",
          children: o("shared.terms.logout")
        }
      ),
      /* @__PURE__ */ p(
        mt,
        {
          onClick: n,
          disabled: !l || e,
          className: "min-w-40",
          children: o(e ? "shared.terms.accepting" : "shared.terms.accept")
        }
      )
    ] })
  ] }) });
}
function HO({
  firstSigned: t,
  secondSigned: e,
  firstLabel: n,
  secondLabel: r,
  className: a
}) {
  const { t: o } = Ae();
  return /* @__PURE__ */ S(ki, { className: fe("mb-6", a), children: [
    /* @__PURE__ */ p(m4, { children: /* @__PURE__ */ p(h4, { className: "text-lg", children: o("shared.contract.signatureStatus") }) }),
    /* @__PURE__ */ S(Oi, { className: "space-y-4", children: [
      /* @__PURE__ */ p(Dd, { label: n, signed: t }),
      /* @__PURE__ */ p(ou, {}),
      /* @__PURE__ */ p(Dd, { label: r, signed: e })
    ] })
  ] });
}
function Dd({ label: t, signed: e }) {
  const { t: n } = Ae();
  return /* @__PURE__ */ S("div", { className: "flex items-center justify-between", children: [
    /* @__PURE__ */ S("div", { className: "flex items-center gap-3", children: [
      /* @__PURE__ */ p(
        "div",
        {
          className: fe(
            "flex h-10 w-10 items-center justify-center rounded-full",
            e ? "bg-green-100" : "bg-gray-100"
          ),
          children: e ? /* @__PURE__ */ p(su, { className: "h-5 w-5 text-green-600" }) : /* @__PURE__ */ p(Ir, { className: "h-5 w-5 text-gray-500" })
        }
      ),
      /* @__PURE__ */ S("div", { children: [
        /* @__PURE__ */ p("p", { className: "font-medium", children: t }),
        /* @__PURE__ */ p("p", { className: "text-muted-foreground text-sm", children: n(e ? "shared.contract.signed" : "shared.contract.awaitingSignature") })
      ] })
    ] }),
    e && /* @__PURE__ */ p(Ip, { className: "h-5 w-5 text-green-600" })
  ] });
}
function BO({
  title: t,
  description: e
} = {}) {
  const { t: n } = Ae();
  return /* @__PURE__ */ p(ki, { className: "border-blue-200 bg-blue-50", children: /* @__PURE__ */ p(Oi, { className: "p-4", children: /* @__PURE__ */ S("div", { className: "flex items-start gap-3", children: [
    /* @__PURE__ */ p(xp, { className: "mt-0.5 h-5 w-5 shrink-0 text-blue-600" }),
    /* @__PURE__ */ S("div", { children: [
      /* @__PURE__ */ p("p", { className: "font-medium text-blue-800", children: t ?? n("shared.contract.signingEmailSent") }),
      /* @__PURE__ */ p("p", { className: "mt-1 text-sm text-blue-700", children: e ?? n("shared.contract.signingEmailInstruction") })
    ] })
  ] }) }) });
}
function jO(t) {
  return /* @__PURE__ */ S(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "62",
      height: "63",
      fill: "none",
      viewBox: "0 0 62 63",
      ...t,
      children: [
        /* @__PURE__ */ S("g", { clipPath: "url(#a)", children: [
          /* @__PURE__ */ p("circle", { cx: "31", cy: "31.5", r: "31", fill: "#E9F6ED" }),
          /* @__PURE__ */ p("g", { filter: "url(#b)", children: /* @__PURE__ */ p(
            "path",
            {
              fill: "#E9F6ED",
              fillRule: "evenodd",
              d: "M31.516 57.334c11.985 0 21.7-9.716 21.7-21.7s-9.715-21.7-21.7-21.7c-5.376 0-7.42 6.449-11.211 9.688-4.659 3.98-10.489 5.404-10.489 12.012 0 11.984 9.716 21.7 21.7 21.7",
              clipRule: "evenodd"
            }
          ) }),
          /* @__PURE__ */ p(
            "path",
            {
              fill: "#fff",
              d: "M30.742 50.1c9.987 0 18.083-8.096 18.083-18.083S40.729 13.934 30.74 13.934 12.659 22.03 12.659 32.017 20.754 50.1 30.742 50.1"
            }
          ),
          /* @__PURE__ */ p(
            "path",
            {
              stroke: "#239D46",
              strokeLinecap: "round",
              strokeLinejoin: "round",
              strokeWidth: "4",
              d: "m24 32.357 4.8 5.143 11.2-12"
            }
          )
        ] }),
        /* @__PURE__ */ S("defs", { children: [
          /* @__PURE__ */ p("clipPath", { id: "a", children: /* @__PURE__ */ p("path", { fill: "#fff", d: "M0 .5h62v62H0z" }) }),
          /* @__PURE__ */ S(
            "filter",
            {
              id: "b",
              width: "65.4",
              height: "65.4",
              x: "-1.184",
              y: "2.934",
              colorInterpolationFilters: "sRGB",
              filterUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ p("feFlood", { floodOpacity: "0", result: "BackgroundImageFix" }),
                /* @__PURE__ */ p(
                  "feBlend",
                  {
                    in: "SourceGraphic",
                    in2: "BackgroundImageFix",
                    result: "shape"
                  }
                ),
                /* @__PURE__ */ p(
                  "feGaussianBlur",
                  {
                    result: "effect1_foregroundBlur_401_19025",
                    stdDeviation: "5.5"
                  }
                )
              ]
            }
          )
        ] })
      ]
    }
  );
}
function NI(t, e) {
  return t ? _I(t) ? /* @__PURE__ */ $.createElement(t, e) : t : null;
}
function _I(t) {
  return TI(t) || typeof t == "function" || AI(t);
}
function TI(t) {
  return typeof t == "function" && (() => {
    const e = Object.getPrototypeOf(t);
    return e.prototype && e.prototype.isReactComponent;
  })();
}
function AI(t) {
  return typeof t == "object" && typeof t.$$typeof == "symbol" && ["react.memo", "react.forward_ref"].includes(t.$$typeof.description);
}
function VO({
  headerGroup: t
}) {
  return /* @__PURE__ */ p(v4, { children: t.headers.map((e) => /* @__PURE__ */ p(g4, { colSpan: e.colSpan, children: e.isPlaceholder ? null : /* @__PURE__ */ S(
    "div",
    {
      className: fe(
        "flex",
        e.column.getCanSort() ? "cursor-pointer items-center select-none" : ""
      ),
      onClick: e.column.getToggleSortingHandler(),
      title: e.column.getCanSort() ? e.column.getNextSortingOrder() === "asc" ? "Sort ascending" : e.column.getNextSortingOrder() === "desc" ? "Sort descending" : "Clear sort" : void 0,
      children: [
        NI(
          e.column.columnDef.header,
          e.getContext()
        ),
        /* @__PURE__ */ S("div", { className: "mx-2", children: [
          e.column.getCanSort() && !e.column.getIsSorted() && /* @__PURE__ */ p(j4, { className: "size-4" }),
          e.column.getIsSorted() && /* @__PURE__ */ S("span", { className: "text-xs", children: [
            "(",
            e.column.getIsSorted() === "asc" ? "↑" : "↓",
            ")"
          ] })
        ] })
      ]
    }
  ) }, e.id)) });
}
const zI = {
  theme: "system",
  setTheme: () => null
}, jf = it(zI);
function UO({
  children: t,
  defaultTheme: e = "system",
  storageKey: n = "vite-ui-theme",
  ...r
}) {
  const [a, o] = ve(
    () => localStorage.getItem(n) || e
  );
  xe(() => {
    const s = window.document.documentElement;
    if (s.classList.remove("light", "dark"), a === "system") {
      const c = window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light";
      s.classList.add(c);
      return;
    }
    s.classList.add(a);
  }, [a]);
  const l = {
    theme: a,
    setTheme: (s) => {
      localStorage.setItem(n, s), o(s);
    }
  };
  return /* @__PURE__ */ p(jf.Provider, { ...r, value: l, children: t });
}
const WO = () => {
  const t = St(jf);
  if (t === void 0)
    throw new Error("useTheme must be used within a ThemeProvider");
  return t;
}, DI = /* @__PURE__ */ new Map([
  // https://github.com/guzzle/psr7/blob/2d9260799e713f1c475d3c5fdc3d6561ff7441b2/src/MimeType.php
  ["1km", "application/vnd.1000minds.decision-model+xml"],
  ["3dml", "text/vnd.in3d.3dml"],
  ["3ds", "image/x-3ds"],
  ["3g2", "video/3gpp2"],
  ["3gp", "video/3gp"],
  ["3gpp", "video/3gpp"],
  ["3mf", "model/3mf"],
  ["7z", "application/x-7z-compressed"],
  ["7zip", "application/x-7z-compressed"],
  ["123", "application/vnd.lotus-1-2-3"],
  ["aab", "application/x-authorware-bin"],
  ["aac", "audio/x-acc"],
  ["aam", "application/x-authorware-map"],
  ["aas", "application/x-authorware-seg"],
  ["abw", "application/x-abiword"],
  ["ac", "application/vnd.nokia.n-gage.ac+xml"],
  ["ac3", "audio/ac3"],
  ["acc", "application/vnd.americandynamics.acc"],
  ["ace", "application/x-ace-compressed"],
  ["acu", "application/vnd.acucobol"],
  ["acutc", "application/vnd.acucorp"],
  ["adp", "audio/adpcm"],
  ["aep", "application/vnd.audiograph"],
  ["afm", "application/x-font-type1"],
  ["afp", "application/vnd.ibm.modcap"],
  ["ahead", "application/vnd.ahead.space"],
  ["ai", "application/pdf"],
  ["aif", "audio/x-aiff"],
  ["aifc", "audio/x-aiff"],
  ["aiff", "audio/x-aiff"],
  ["air", "application/vnd.adobe.air-application-installer-package+zip"],
  ["ait", "application/vnd.dvb.ait"],
  ["ami", "application/vnd.amiga.ami"],
  ["amr", "audio/amr"],
  ["apk", "application/vnd.android.package-archive"],
  ["apng", "image/apng"],
  ["appcache", "text/cache-manifest"],
  ["application", "application/x-ms-application"],
  ["apr", "application/vnd.lotus-approach"],
  ["arc", "application/x-freearc"],
  ["arj", "application/x-arj"],
  ["asc", "application/pgp-signature"],
  ["asf", "video/x-ms-asf"],
  ["asm", "text/x-asm"],
  ["aso", "application/vnd.accpac.simply.aso"],
  ["asx", "video/x-ms-asf"],
  ["atc", "application/vnd.acucorp"],
  ["atom", "application/atom+xml"],
  ["atomcat", "application/atomcat+xml"],
  ["atomdeleted", "application/atomdeleted+xml"],
  ["atomsvc", "application/atomsvc+xml"],
  ["atx", "application/vnd.antix.game-component"],
  ["au", "audio/x-au"],
  ["avi", "video/x-msvideo"],
  ["avif", "image/avif"],
  ["aw", "application/applixware"],
  ["azf", "application/vnd.airzip.filesecure.azf"],
  ["azs", "application/vnd.airzip.filesecure.azs"],
  ["azv", "image/vnd.airzip.accelerator.azv"],
  ["azw", "application/vnd.amazon.ebook"],
  ["b16", "image/vnd.pco.b16"],
  ["bat", "application/x-msdownload"],
  ["bcpio", "application/x-bcpio"],
  ["bdf", "application/x-font-bdf"],
  ["bdm", "application/vnd.syncml.dm+wbxml"],
  ["bdoc", "application/x-bdoc"],
  ["bed", "application/vnd.realvnc.bed"],
  ["bh2", "application/vnd.fujitsu.oasysprs"],
  ["bin", "application/octet-stream"],
  ["blb", "application/x-blorb"],
  ["blorb", "application/x-blorb"],
  ["bmi", "application/vnd.bmi"],
  ["bmml", "application/vnd.balsamiq.bmml+xml"],
  ["bmp", "image/bmp"],
  ["book", "application/vnd.framemaker"],
  ["box", "application/vnd.previewsystems.box"],
  ["boz", "application/x-bzip2"],
  ["bpk", "application/octet-stream"],
  ["bpmn", "application/octet-stream"],
  ["bsp", "model/vnd.valve.source.compiled-map"],
  ["btif", "image/prs.btif"],
  ["buffer", "application/octet-stream"],
  ["bz", "application/x-bzip"],
  ["bz2", "application/x-bzip2"],
  ["c", "text/x-c"],
  ["c4d", "application/vnd.clonk.c4group"],
  ["c4f", "application/vnd.clonk.c4group"],
  ["c4g", "application/vnd.clonk.c4group"],
  ["c4p", "application/vnd.clonk.c4group"],
  ["c4u", "application/vnd.clonk.c4group"],
  ["c11amc", "application/vnd.cluetrust.cartomobile-config"],
  ["c11amz", "application/vnd.cluetrust.cartomobile-config-pkg"],
  ["cab", "application/vnd.ms-cab-compressed"],
  ["caf", "audio/x-caf"],
  ["cap", "application/vnd.tcpdump.pcap"],
  ["car", "application/vnd.curl.car"],
  ["cat", "application/vnd.ms-pki.seccat"],
  ["cb7", "application/x-cbr"],
  ["cba", "application/x-cbr"],
  ["cbr", "application/x-cbr"],
  ["cbt", "application/x-cbr"],
  ["cbz", "application/x-cbr"],
  ["cc", "text/x-c"],
  ["cco", "application/x-cocoa"],
  ["cct", "application/x-director"],
  ["ccxml", "application/ccxml+xml"],
  ["cdbcmsg", "application/vnd.contact.cmsg"],
  ["cda", "application/x-cdf"],
  ["cdf", "application/x-netcdf"],
  ["cdfx", "application/cdfx+xml"],
  ["cdkey", "application/vnd.mediastation.cdkey"],
  ["cdmia", "application/cdmi-capability"],
  ["cdmic", "application/cdmi-container"],
  ["cdmid", "application/cdmi-domain"],
  ["cdmio", "application/cdmi-object"],
  ["cdmiq", "application/cdmi-queue"],
  ["cdr", "application/cdr"],
  ["cdx", "chemical/x-cdx"],
  ["cdxml", "application/vnd.chemdraw+xml"],
  ["cdy", "application/vnd.cinderella"],
  ["cer", "application/pkix-cert"],
  ["cfs", "application/x-cfs-compressed"],
  ["cgm", "image/cgm"],
  ["chat", "application/x-chat"],
  ["chm", "application/vnd.ms-htmlhelp"],
  ["chrt", "application/vnd.kde.kchart"],
  ["cif", "chemical/x-cif"],
  ["cii", "application/vnd.anser-web-certificate-issue-initiation"],
  ["cil", "application/vnd.ms-artgalry"],
  ["cjs", "application/node"],
  ["cla", "application/vnd.claymore"],
  ["class", "application/octet-stream"],
  ["clkk", "application/vnd.crick.clicker.keyboard"],
  ["clkp", "application/vnd.crick.clicker.palette"],
  ["clkt", "application/vnd.crick.clicker.template"],
  ["clkw", "application/vnd.crick.clicker.wordbank"],
  ["clkx", "application/vnd.crick.clicker"],
  ["clp", "application/x-msclip"],
  ["cmc", "application/vnd.cosmocaller"],
  ["cmdf", "chemical/x-cmdf"],
  ["cml", "chemical/x-cml"],
  ["cmp", "application/vnd.yellowriver-custom-menu"],
  ["cmx", "image/x-cmx"],
  ["cod", "application/vnd.rim.cod"],
  ["coffee", "text/coffeescript"],
  ["com", "application/x-msdownload"],
  ["conf", "text/plain"],
  ["cpio", "application/x-cpio"],
  ["cpp", "text/x-c"],
  ["cpt", "application/mac-compactpro"],
  ["crd", "application/x-mscardfile"],
  ["crl", "application/pkix-crl"],
  ["crt", "application/x-x509-ca-cert"],
  ["crx", "application/x-chrome-extension"],
  ["cryptonote", "application/vnd.rig.cryptonote"],
  ["csh", "application/x-csh"],
  ["csl", "application/vnd.citationstyles.style+xml"],
  ["csml", "chemical/x-csml"],
  ["csp", "application/vnd.commonspace"],
  ["csr", "application/octet-stream"],
  ["css", "text/css"],
  ["cst", "application/x-director"],
  ["csv", "text/csv"],
  ["cu", "application/cu-seeme"],
  ["curl", "text/vnd.curl"],
  ["cww", "application/prs.cww"],
  ["cxt", "application/x-director"],
  ["cxx", "text/x-c"],
  ["dae", "model/vnd.collada+xml"],
  ["daf", "application/vnd.mobius.daf"],
  ["dart", "application/vnd.dart"],
  ["dataless", "application/vnd.fdsn.seed"],
  ["davmount", "application/davmount+xml"],
  ["dbf", "application/vnd.dbf"],
  ["dbk", "application/docbook+xml"],
  ["dcr", "application/x-director"],
  ["dcurl", "text/vnd.curl.dcurl"],
  ["dd2", "application/vnd.oma.dd2+xml"],
  ["ddd", "application/vnd.fujixerox.ddd"],
  ["ddf", "application/vnd.syncml.dmddf+xml"],
  ["dds", "image/vnd.ms-dds"],
  ["deb", "application/x-debian-package"],
  ["def", "text/plain"],
  ["deploy", "application/octet-stream"],
  ["der", "application/x-x509-ca-cert"],
  ["dfac", "application/vnd.dreamfactory"],
  ["dgc", "application/x-dgc-compressed"],
  ["dic", "text/x-c"],
  ["dir", "application/x-director"],
  ["dis", "application/vnd.mobius.dis"],
  ["disposition-notification", "message/disposition-notification"],
  ["dist", "application/octet-stream"],
  ["distz", "application/octet-stream"],
  ["djv", "image/vnd.djvu"],
  ["djvu", "image/vnd.djvu"],
  ["dll", "application/octet-stream"],
  ["dmg", "application/x-apple-diskimage"],
  ["dmn", "application/octet-stream"],
  ["dmp", "application/vnd.tcpdump.pcap"],
  ["dms", "application/octet-stream"],
  ["dna", "application/vnd.dna"],
  ["doc", "application/msword"],
  ["docm", "application/vnd.ms-word.template.macroEnabled.12"],
  ["docx", "application/vnd.openxmlformats-officedocument.wordprocessingml.document"],
  ["dot", "application/msword"],
  ["dotm", "application/vnd.ms-word.template.macroEnabled.12"],
  ["dotx", "application/vnd.openxmlformats-officedocument.wordprocessingml.template"],
  ["dp", "application/vnd.osgi.dp"],
  ["dpg", "application/vnd.dpgraph"],
  ["dra", "audio/vnd.dra"],
  ["drle", "image/dicom-rle"],
  ["dsc", "text/prs.lines.tag"],
  ["dssc", "application/dssc+der"],
  ["dtb", "application/x-dtbook+xml"],
  ["dtd", "application/xml-dtd"],
  ["dts", "audio/vnd.dts"],
  ["dtshd", "audio/vnd.dts.hd"],
  ["dump", "application/octet-stream"],
  ["dvb", "video/vnd.dvb.file"],
  ["dvi", "application/x-dvi"],
  ["dwd", "application/atsc-dwd+xml"],
  ["dwf", "model/vnd.dwf"],
  ["dwg", "image/vnd.dwg"],
  ["dxf", "image/vnd.dxf"],
  ["dxp", "application/vnd.spotfire.dxp"],
  ["dxr", "application/x-director"],
  ["ear", "application/java-archive"],
  ["ecelp4800", "audio/vnd.nuera.ecelp4800"],
  ["ecelp7470", "audio/vnd.nuera.ecelp7470"],
  ["ecelp9600", "audio/vnd.nuera.ecelp9600"],
  ["ecma", "application/ecmascript"],
  ["edm", "application/vnd.novadigm.edm"],
  ["edx", "application/vnd.novadigm.edx"],
  ["efif", "application/vnd.picsel"],
  ["ei6", "application/vnd.pg.osasli"],
  ["elc", "application/octet-stream"],
  ["emf", "image/emf"],
  ["eml", "message/rfc822"],
  ["emma", "application/emma+xml"],
  ["emotionml", "application/emotionml+xml"],
  ["emz", "application/x-msmetafile"],
  ["eol", "audio/vnd.digital-winds"],
  ["eot", "application/vnd.ms-fontobject"],
  ["eps", "application/postscript"],
  ["epub", "application/epub+zip"],
  ["es", "application/ecmascript"],
  ["es3", "application/vnd.eszigno3+xml"],
  ["esa", "application/vnd.osgi.subsystem"],
  ["esf", "application/vnd.epson.esf"],
  ["et3", "application/vnd.eszigno3+xml"],
  ["etx", "text/x-setext"],
  ["eva", "application/x-eva"],
  ["evy", "application/x-envoy"],
  ["exe", "application/octet-stream"],
  ["exi", "application/exi"],
  ["exp", "application/express"],
  ["exr", "image/aces"],
  ["ext", "application/vnd.novadigm.ext"],
  ["ez", "application/andrew-inset"],
  ["ez2", "application/vnd.ezpix-album"],
  ["ez3", "application/vnd.ezpix-package"],
  ["f", "text/x-fortran"],
  ["f4v", "video/mp4"],
  ["f77", "text/x-fortran"],
  ["f90", "text/x-fortran"],
  ["fbs", "image/vnd.fastbidsheet"],
  ["fcdt", "application/vnd.adobe.formscentral.fcdt"],
  ["fcs", "application/vnd.isac.fcs"],
  ["fdf", "application/vnd.fdf"],
  ["fdt", "application/fdt+xml"],
  ["fe_launch", "application/vnd.denovo.fcselayout-link"],
  ["fg5", "application/vnd.fujitsu.oasysgp"],
  ["fgd", "application/x-director"],
  ["fh", "image/x-freehand"],
  ["fh4", "image/x-freehand"],
  ["fh5", "image/x-freehand"],
  ["fh7", "image/x-freehand"],
  ["fhc", "image/x-freehand"],
  ["fig", "application/x-xfig"],
  ["fits", "image/fits"],
  ["flac", "audio/x-flac"],
  ["fli", "video/x-fli"],
  ["flo", "application/vnd.micrografx.flo"],
  ["flv", "video/x-flv"],
  ["flw", "application/vnd.kde.kivio"],
  ["flx", "text/vnd.fmi.flexstor"],
  ["fly", "text/vnd.fly"],
  ["fm", "application/vnd.framemaker"],
  ["fnc", "application/vnd.frogans.fnc"],
  ["fo", "application/vnd.software602.filler.form+xml"],
  ["for", "text/x-fortran"],
  ["fpx", "image/vnd.fpx"],
  ["frame", "application/vnd.framemaker"],
  ["fsc", "application/vnd.fsc.weblaunch"],
  ["fst", "image/vnd.fst"],
  ["ftc", "application/vnd.fluxtime.clip"],
  ["fti", "application/vnd.anser-web-funds-transfer-initiation"],
  ["fvt", "video/vnd.fvt"],
  ["fxp", "application/vnd.adobe.fxp"],
  ["fxpl", "application/vnd.adobe.fxp"],
  ["fzs", "application/vnd.fuzzysheet"],
  ["g2w", "application/vnd.geoplan"],
  ["g3", "image/g3fax"],
  ["g3w", "application/vnd.geospace"],
  ["gac", "application/vnd.groove-account"],
  ["gam", "application/x-tads"],
  ["gbr", "application/rpki-ghostbusters"],
  ["gca", "application/x-gca-compressed"],
  ["gdl", "model/vnd.gdl"],
  ["gdoc", "application/vnd.google-apps.document"],
  ["geo", "application/vnd.dynageo"],
  ["geojson", "application/geo+json"],
  ["gex", "application/vnd.geometry-explorer"],
  ["ggb", "application/vnd.geogebra.file"],
  ["ggt", "application/vnd.geogebra.tool"],
  ["ghf", "application/vnd.groove-help"],
  ["gif", "image/gif"],
  ["gim", "application/vnd.groove-identity-message"],
  ["glb", "model/gltf-binary"],
  ["gltf", "model/gltf+json"],
  ["gml", "application/gml+xml"],
  ["gmx", "application/vnd.gmx"],
  ["gnumeric", "application/x-gnumeric"],
  ["gpg", "application/gpg-keys"],
  ["gph", "application/vnd.flographit"],
  ["gpx", "application/gpx+xml"],
  ["gqf", "application/vnd.grafeq"],
  ["gqs", "application/vnd.grafeq"],
  ["gram", "application/srgs"],
  ["gramps", "application/x-gramps-xml"],
  ["gre", "application/vnd.geometry-explorer"],
  ["grv", "application/vnd.groove-injector"],
  ["grxml", "application/srgs+xml"],
  ["gsf", "application/x-font-ghostscript"],
  ["gsheet", "application/vnd.google-apps.spreadsheet"],
  ["gslides", "application/vnd.google-apps.presentation"],
  ["gtar", "application/x-gtar"],
  ["gtm", "application/vnd.groove-tool-message"],
  ["gtw", "model/vnd.gtw"],
  ["gv", "text/vnd.graphviz"],
  ["gxf", "application/gxf"],
  ["gxt", "application/vnd.geonext"],
  ["gz", "application/gzip"],
  ["gzip", "application/gzip"],
  ["h", "text/x-c"],
  ["h261", "video/h261"],
  ["h263", "video/h263"],
  ["h264", "video/h264"],
  ["hal", "application/vnd.hal+xml"],
  ["hbci", "application/vnd.hbci"],
  ["hbs", "text/x-handlebars-template"],
  ["hdd", "application/x-virtualbox-hdd"],
  ["hdf", "application/x-hdf"],
  ["heic", "image/heic"],
  ["heics", "image/heic-sequence"],
  ["heif", "image/heif"],
  ["heifs", "image/heif-sequence"],
  ["hej2", "image/hej2k"],
  ["held", "application/atsc-held+xml"],
  ["hh", "text/x-c"],
  ["hjson", "application/hjson"],
  ["hlp", "application/winhlp"],
  ["hpgl", "application/vnd.hp-hpgl"],
  ["hpid", "application/vnd.hp-hpid"],
  ["hps", "application/vnd.hp-hps"],
  ["hqx", "application/mac-binhex40"],
  ["hsj2", "image/hsj2"],
  ["htc", "text/x-component"],
  ["htke", "application/vnd.kenameaapp"],
  ["htm", "text/html"],
  ["html", "text/html"],
  ["hvd", "application/vnd.yamaha.hv-dic"],
  ["hvp", "application/vnd.yamaha.hv-voice"],
  ["hvs", "application/vnd.yamaha.hv-script"],
  ["i2g", "application/vnd.intergeo"],
  ["icc", "application/vnd.iccprofile"],
  ["ice", "x-conference/x-cooltalk"],
  ["icm", "application/vnd.iccprofile"],
  ["ico", "image/x-icon"],
  ["ics", "text/calendar"],
  ["ief", "image/ief"],
  ["ifb", "text/calendar"],
  ["ifm", "application/vnd.shana.informed.formdata"],
  ["iges", "model/iges"],
  ["igl", "application/vnd.igloader"],
  ["igm", "application/vnd.insors.igm"],
  ["igs", "model/iges"],
  ["igx", "application/vnd.micrografx.igx"],
  ["iif", "application/vnd.shana.informed.interchange"],
  ["img", "application/octet-stream"],
  ["imp", "application/vnd.accpac.simply.imp"],
  ["ims", "application/vnd.ms-ims"],
  ["in", "text/plain"],
  ["ini", "text/plain"],
  ["ink", "application/inkml+xml"],
  ["inkml", "application/inkml+xml"],
  ["install", "application/x-install-instructions"],
  ["iota", "application/vnd.astraea-software.iota"],
  ["ipfix", "application/ipfix"],
  ["ipk", "application/vnd.shana.informed.package"],
  ["irm", "application/vnd.ibm.rights-management"],
  ["irp", "application/vnd.irepository.package+xml"],
  ["iso", "application/x-iso9660-image"],
  ["itp", "application/vnd.shana.informed.formtemplate"],
  ["its", "application/its+xml"],
  ["ivp", "application/vnd.immervision-ivp"],
  ["ivu", "application/vnd.immervision-ivu"],
  ["jad", "text/vnd.sun.j2me.app-descriptor"],
  ["jade", "text/jade"],
  ["jam", "application/vnd.jam"],
  ["jar", "application/java-archive"],
  ["jardiff", "application/x-java-archive-diff"],
  ["java", "text/x-java-source"],
  ["jhc", "image/jphc"],
  ["jisp", "application/vnd.jisp"],
  ["jls", "image/jls"],
  ["jlt", "application/vnd.hp-jlyt"],
  ["jng", "image/x-jng"],
  ["jnlp", "application/x-java-jnlp-file"],
  ["joda", "application/vnd.joost.joda-archive"],
  ["jp2", "image/jp2"],
  ["jpe", "image/jpeg"],
  ["jpeg", "image/jpeg"],
  ["jpf", "image/jpx"],
  ["jpg", "image/jpeg"],
  ["jpg2", "image/jp2"],
  ["jpgm", "video/jpm"],
  ["jpgv", "video/jpeg"],
  ["jph", "image/jph"],
  ["jpm", "video/jpm"],
  ["jpx", "image/jpx"],
  ["js", "application/javascript"],
  ["json", "application/json"],
  ["json5", "application/json5"],
  ["jsonld", "application/ld+json"],
  // https://jsonlines.org/
  ["jsonl", "application/jsonl"],
  ["jsonml", "application/jsonml+json"],
  ["jsx", "text/jsx"],
  ["jxr", "image/jxr"],
  ["jxra", "image/jxra"],
  ["jxrs", "image/jxrs"],
  ["jxs", "image/jxs"],
  ["jxsc", "image/jxsc"],
  ["jxsi", "image/jxsi"],
  ["jxss", "image/jxss"],
  ["kar", "audio/midi"],
  ["karbon", "application/vnd.kde.karbon"],
  ["kdb", "application/octet-stream"],
  ["kdbx", "application/x-keepass2"],
  ["key", "application/x-iwork-keynote-sffkey"],
  ["kfo", "application/vnd.kde.kformula"],
  ["kia", "application/vnd.kidspiration"],
  ["kml", "application/vnd.google-earth.kml+xml"],
  ["kmz", "application/vnd.google-earth.kmz"],
  ["kne", "application/vnd.kinar"],
  ["knp", "application/vnd.kinar"],
  ["kon", "application/vnd.kde.kontour"],
  ["kpr", "application/vnd.kde.kpresenter"],
  ["kpt", "application/vnd.kde.kpresenter"],
  ["kpxx", "application/vnd.ds-keypoint"],
  ["ksp", "application/vnd.kde.kspread"],
  ["ktr", "application/vnd.kahootz"],
  ["ktx", "image/ktx"],
  ["ktx2", "image/ktx2"],
  ["ktz", "application/vnd.kahootz"],
  ["kwd", "application/vnd.kde.kword"],
  ["kwt", "application/vnd.kde.kword"],
  ["lasxml", "application/vnd.las.las+xml"],
  ["latex", "application/x-latex"],
  ["lbd", "application/vnd.llamagraphics.life-balance.desktop"],
  ["lbe", "application/vnd.llamagraphics.life-balance.exchange+xml"],
  ["les", "application/vnd.hhe.lesson-player"],
  ["less", "text/less"],
  ["lgr", "application/lgr+xml"],
  ["lha", "application/octet-stream"],
  ["link66", "application/vnd.route66.link66+xml"],
  ["list", "text/plain"],
  ["list3820", "application/vnd.ibm.modcap"],
  ["listafp", "application/vnd.ibm.modcap"],
  ["litcoffee", "text/coffeescript"],
  ["lnk", "application/x-ms-shortcut"],
  ["log", "text/plain"],
  ["lostxml", "application/lost+xml"],
  ["lrf", "application/octet-stream"],
  ["lrm", "application/vnd.ms-lrm"],
  ["ltf", "application/vnd.frogans.ltf"],
  ["lua", "text/x-lua"],
  ["luac", "application/x-lua-bytecode"],
  ["lvp", "audio/vnd.lucent.voice"],
  ["lwp", "application/vnd.lotus-wordpro"],
  ["lzh", "application/octet-stream"],
  ["m1v", "video/mpeg"],
  ["m2a", "audio/mpeg"],
  ["m2v", "video/mpeg"],
  ["m3a", "audio/mpeg"],
  ["m3u", "text/plain"],
  ["m3u8", "application/vnd.apple.mpegurl"],
  ["m4a", "audio/x-m4a"],
  ["m4p", "application/mp4"],
  ["m4s", "video/iso.segment"],
  ["m4u", "application/vnd.mpegurl"],
  ["m4v", "video/x-m4v"],
  ["m13", "application/x-msmediaview"],
  ["m14", "application/x-msmediaview"],
  ["m21", "application/mp21"],
  ["ma", "application/mathematica"],
  ["mads", "application/mads+xml"],
  ["maei", "application/mmt-aei+xml"],
  ["mag", "application/vnd.ecowin.chart"],
  ["maker", "application/vnd.framemaker"],
  ["man", "text/troff"],
  ["manifest", "text/cache-manifest"],
  ["map", "application/json"],
  ["mar", "application/octet-stream"],
  ["markdown", "text/markdown"],
  ["mathml", "application/mathml+xml"],
  ["mb", "application/mathematica"],
  ["mbk", "application/vnd.mobius.mbk"],
  ["mbox", "application/mbox"],
  ["mc1", "application/vnd.medcalcdata"],
  ["mcd", "application/vnd.mcd"],
  ["mcurl", "text/vnd.curl.mcurl"],
  ["md", "text/markdown"],
  ["mdb", "application/x-msaccess"],
  ["mdi", "image/vnd.ms-modi"],
  ["mdx", "text/mdx"],
  ["me", "text/troff"],
  ["mesh", "model/mesh"],
  ["meta4", "application/metalink4+xml"],
  ["metalink", "application/metalink+xml"],
  ["mets", "application/mets+xml"],
  ["mfm", "application/vnd.mfmp"],
  ["mft", "application/rpki-manifest"],
  ["mgp", "application/vnd.osgeo.mapguide.package"],
  ["mgz", "application/vnd.proteus.magazine"],
  ["mid", "audio/midi"],
  ["midi", "audio/midi"],
  ["mie", "application/x-mie"],
  ["mif", "application/vnd.mif"],
  ["mime", "message/rfc822"],
  ["mj2", "video/mj2"],
  ["mjp2", "video/mj2"],
  ["mjs", "application/javascript"],
  ["mk3d", "video/x-matroska"],
  ["mka", "audio/x-matroska"],
  ["mkd", "text/x-markdown"],
  ["mks", "video/x-matroska"],
  ["mkv", "video/x-matroska"],
  ["mlp", "application/vnd.dolby.mlp"],
  ["mmd", "application/vnd.chipnuts.karaoke-mmd"],
  ["mmf", "application/vnd.smaf"],
  ["mml", "text/mathml"],
  ["mmr", "image/vnd.fujixerox.edmics-mmr"],
  ["mng", "video/x-mng"],
  ["mny", "application/x-msmoney"],
  ["mobi", "application/x-mobipocket-ebook"],
  ["mods", "application/mods+xml"],
  ["mov", "video/quicktime"],
  ["movie", "video/x-sgi-movie"],
  ["mp2", "audio/mpeg"],
  ["mp2a", "audio/mpeg"],
  ["mp3", "audio/mpeg"],
  ["mp4", "video/mp4"],
  ["mp4a", "audio/mp4"],
  ["mp4s", "application/mp4"],
  ["mp4v", "video/mp4"],
  ["mp21", "application/mp21"],
  ["mpc", "application/vnd.mophun.certificate"],
  ["mpd", "application/dash+xml"],
  ["mpe", "video/mpeg"],
  ["mpeg", "video/mpeg"],
  ["mpg", "video/mpeg"],
  ["mpg4", "video/mp4"],
  ["mpga", "audio/mpeg"],
  ["mpkg", "application/vnd.apple.installer+xml"],
  ["mpm", "application/vnd.blueice.multipass"],
  ["mpn", "application/vnd.mophun.application"],
  ["mpp", "application/vnd.ms-project"],
  ["mpt", "application/vnd.ms-project"],
  ["mpy", "application/vnd.ibm.minipay"],
  ["mqy", "application/vnd.mobius.mqy"],
  ["mrc", "application/marc"],
  ["mrcx", "application/marcxml+xml"],
  ["ms", "text/troff"],
  ["mscml", "application/mediaservercontrol+xml"],
  ["mseed", "application/vnd.fdsn.mseed"],
  ["mseq", "application/vnd.mseq"],
  ["msf", "application/vnd.epson.msf"],
  ["msg", "application/vnd.ms-outlook"],
  ["msh", "model/mesh"],
  ["msi", "application/x-msdownload"],
  ["msl", "application/vnd.mobius.msl"],
  ["msm", "application/octet-stream"],
  ["msp", "application/octet-stream"],
  ["msty", "application/vnd.muvee.style"],
  ["mtl", "model/mtl"],
  ["mts", "model/vnd.mts"],
  ["mus", "application/vnd.musician"],
  ["musd", "application/mmt-usd+xml"],
  ["musicxml", "application/vnd.recordare.musicxml+xml"],
  ["mvb", "application/x-msmediaview"],
  ["mvt", "application/vnd.mapbox-vector-tile"],
  ["mwf", "application/vnd.mfer"],
  ["mxf", "application/mxf"],
  ["mxl", "application/vnd.recordare.musicxml"],
  ["mxmf", "audio/mobile-xmf"],
  ["mxml", "application/xv+xml"],
  ["mxs", "application/vnd.triscape.mxs"],
  ["mxu", "video/vnd.mpegurl"],
  ["n-gage", "application/vnd.nokia.n-gage.symbian.install"],
  ["n3", "text/n3"],
  ["nb", "application/mathematica"],
  ["nbp", "application/vnd.wolfram.player"],
  ["nc", "application/x-netcdf"],
  ["ncx", "application/x-dtbncx+xml"],
  ["nfo", "text/x-nfo"],
  ["ngdat", "application/vnd.nokia.n-gage.data"],
  ["nitf", "application/vnd.nitf"],
  ["nlu", "application/vnd.neurolanguage.nlu"],
  ["nml", "application/vnd.enliven"],
  ["nnd", "application/vnd.noblenet-directory"],
  ["nns", "application/vnd.noblenet-sealer"],
  ["nnw", "application/vnd.noblenet-web"],
  ["npx", "image/vnd.net-fpx"],
  ["nq", "application/n-quads"],
  ["nsc", "application/x-conference"],
  ["nsf", "application/vnd.lotus-notes"],
  ["nt", "application/n-triples"],
  ["ntf", "application/vnd.nitf"],
  ["numbers", "application/x-iwork-numbers-sffnumbers"],
  ["nzb", "application/x-nzb"],
  ["oa2", "application/vnd.fujitsu.oasys2"],
  ["oa3", "application/vnd.fujitsu.oasys3"],
  ["oas", "application/vnd.fujitsu.oasys"],
  ["obd", "application/x-msbinder"],
  ["obgx", "application/vnd.openblox.game+xml"],
  ["obj", "model/obj"],
  ["oda", "application/oda"],
  ["odb", "application/vnd.oasis.opendocument.database"],
  ["odc", "application/vnd.oasis.opendocument.chart"],
  ["odf", "application/vnd.oasis.opendocument.formula"],
  ["odft", "application/vnd.oasis.opendocument.formula-template"],
  ["odg", "application/vnd.oasis.opendocument.graphics"],
  ["odi", "application/vnd.oasis.opendocument.image"],
  ["odm", "application/vnd.oasis.opendocument.text-master"],
  ["odp", "application/vnd.oasis.opendocument.presentation"],
  ["ods", "application/vnd.oasis.opendocument.spreadsheet"],
  ["odt", "application/vnd.oasis.opendocument.text"],
  ["oga", "audio/ogg"],
  ["ogex", "model/vnd.opengex"],
  ["ogg", "audio/ogg"],
  ["ogv", "video/ogg"],
  ["ogx", "application/ogg"],
  ["omdoc", "application/omdoc+xml"],
  ["onepkg", "application/onenote"],
  ["onetmp", "application/onenote"],
  ["onetoc", "application/onenote"],
  ["onetoc2", "application/onenote"],
  ["opf", "application/oebps-package+xml"],
  ["opml", "text/x-opml"],
  ["oprc", "application/vnd.palm"],
  ["opus", "audio/ogg"],
  ["org", "text/x-org"],
  ["osf", "application/vnd.yamaha.openscoreformat"],
  ["osfpvg", "application/vnd.yamaha.openscoreformat.osfpvg+xml"],
  ["osm", "application/vnd.openstreetmap.data+xml"],
  ["otc", "application/vnd.oasis.opendocument.chart-template"],
  ["otf", "font/otf"],
  ["otg", "application/vnd.oasis.opendocument.graphics-template"],
  ["oth", "application/vnd.oasis.opendocument.text-web"],
  ["oti", "application/vnd.oasis.opendocument.image-template"],
  ["otp", "application/vnd.oasis.opendocument.presentation-template"],
  ["ots", "application/vnd.oasis.opendocument.spreadsheet-template"],
  ["ott", "application/vnd.oasis.opendocument.text-template"],
  ["ova", "application/x-virtualbox-ova"],
  ["ovf", "application/x-virtualbox-ovf"],
  ["owl", "application/rdf+xml"],
  ["oxps", "application/oxps"],
  ["oxt", "application/vnd.openofficeorg.extension"],
  ["p", "text/x-pascal"],
  ["p7a", "application/x-pkcs7-signature"],
  ["p7b", "application/x-pkcs7-certificates"],
  ["p7c", "application/pkcs7-mime"],
  ["p7m", "application/pkcs7-mime"],
  ["p7r", "application/x-pkcs7-certreqresp"],
  ["p7s", "application/pkcs7-signature"],
  ["p8", "application/pkcs8"],
  ["p10", "application/x-pkcs10"],
  ["p12", "application/x-pkcs12"],
  ["pac", "application/x-ns-proxy-autoconfig"],
  ["pages", "application/x-iwork-pages-sffpages"],
  ["pas", "text/x-pascal"],
  ["paw", "application/vnd.pawaafile"],
  ["pbd", "application/vnd.powerbuilder6"],
  ["pbm", "image/x-portable-bitmap"],
  ["pcap", "application/vnd.tcpdump.pcap"],
  ["pcf", "application/x-font-pcf"],
  ["pcl", "application/vnd.hp-pcl"],
  ["pclxl", "application/vnd.hp-pclxl"],
  ["pct", "image/x-pict"],
  ["pcurl", "application/vnd.curl.pcurl"],
  ["pcx", "image/x-pcx"],
  ["pdb", "application/x-pilot"],
  ["pde", "text/x-processing"],
  ["pdf", "application/pdf"],
  ["pem", "application/x-x509-user-cert"],
  ["pfa", "application/x-font-type1"],
  ["pfb", "application/x-font-type1"],
  ["pfm", "application/x-font-type1"],
  ["pfr", "application/font-tdpfr"],
  ["pfx", "application/x-pkcs12"],
  ["pgm", "image/x-portable-graymap"],
  ["pgn", "application/x-chess-pgn"],
  ["pgp", "application/pgp"],
  ["php", "application/x-httpd-php"],
  ["php3", "application/x-httpd-php"],
  ["php4", "application/x-httpd-php"],
  ["phps", "application/x-httpd-php-source"],
  ["phtml", "application/x-httpd-php"],
  ["pic", "image/x-pict"],
  ["pkg", "application/octet-stream"],
  ["pki", "application/pkixcmp"],
  ["pkipath", "application/pkix-pkipath"],
  ["pkpass", "application/vnd.apple.pkpass"],
  ["pl", "application/x-perl"],
  ["plb", "application/vnd.3gpp.pic-bw-large"],
  ["plc", "application/vnd.mobius.plc"],
  ["plf", "application/vnd.pocketlearn"],
  ["pls", "application/pls+xml"],
  ["pm", "application/x-perl"],
  ["pml", "application/vnd.ctc-posml"],
  ["png", "image/png"],
  ["pnm", "image/x-portable-anymap"],
  ["portpkg", "application/vnd.macports.portpkg"],
  ["pot", "application/vnd.ms-powerpoint"],
  ["potm", "application/vnd.ms-powerpoint.presentation.macroEnabled.12"],
  ["potx", "application/vnd.openxmlformats-officedocument.presentationml.template"],
  ["ppa", "application/vnd.ms-powerpoint"],
  ["ppam", "application/vnd.ms-powerpoint.addin.macroEnabled.12"],
  ["ppd", "application/vnd.cups-ppd"],
  ["ppm", "image/x-portable-pixmap"],
  ["pps", "application/vnd.ms-powerpoint"],
  ["ppsm", "application/vnd.ms-powerpoint.slideshow.macroEnabled.12"],
  ["ppsx", "application/vnd.openxmlformats-officedocument.presentationml.slideshow"],
  ["ppt", "application/powerpoint"],
  ["pptm", "application/vnd.ms-powerpoint.presentation.macroEnabled.12"],
  ["pptx", "application/vnd.openxmlformats-officedocument.presentationml.presentation"],
  ["pqa", "application/vnd.palm"],
  ["prc", "application/x-pilot"],
  ["pre", "application/vnd.lotus-freelance"],
  ["prf", "application/pics-rules"],
  ["provx", "application/provenance+xml"],
  ["ps", "application/postscript"],
  ["psb", "application/vnd.3gpp.pic-bw-small"],
  ["psd", "application/x-photoshop"],
  ["psf", "application/x-font-linux-psf"],
  ["pskcxml", "application/pskc+xml"],
  ["pti", "image/prs.pti"],
  ["ptid", "application/vnd.pvi.ptid1"],
  ["pub", "application/x-mspublisher"],
  ["pvb", "application/vnd.3gpp.pic-bw-var"],
  ["pwn", "application/vnd.3m.post-it-notes"],
  ["pya", "audio/vnd.ms-playready.media.pya"],
  ["pyv", "video/vnd.ms-playready.media.pyv"],
  ["qam", "application/vnd.epson.quickanime"],
  ["qbo", "application/vnd.intu.qbo"],
  ["qfx", "application/vnd.intu.qfx"],
  ["qps", "application/vnd.publishare-delta-tree"],
  ["qt", "video/quicktime"],
  ["qwd", "application/vnd.quark.quarkxpress"],
  ["qwt", "application/vnd.quark.quarkxpress"],
  ["qxb", "application/vnd.quark.quarkxpress"],
  ["qxd", "application/vnd.quark.quarkxpress"],
  ["qxl", "application/vnd.quark.quarkxpress"],
  ["qxt", "application/vnd.quark.quarkxpress"],
  ["ra", "audio/x-realaudio"],
  ["ram", "audio/x-pn-realaudio"],
  ["raml", "application/raml+yaml"],
  ["rapd", "application/route-apd+xml"],
  ["rar", "application/x-rar"],
  ["ras", "image/x-cmu-raster"],
  ["rcprofile", "application/vnd.ipunplugged.rcprofile"],
  ["rdf", "application/rdf+xml"],
  ["rdz", "application/vnd.data-vision.rdz"],
  ["relo", "application/p2p-overlay+xml"],
  ["rep", "application/vnd.businessobjects"],
  ["res", "application/x-dtbresource+xml"],
  ["rgb", "image/x-rgb"],
  ["rif", "application/reginfo+xml"],
  ["rip", "audio/vnd.rip"],
  ["ris", "application/x-research-info-systems"],
  ["rl", "application/resource-lists+xml"],
  ["rlc", "image/vnd.fujixerox.edmics-rlc"],
  ["rld", "application/resource-lists-diff+xml"],
  ["rm", "audio/x-pn-realaudio"],
  ["rmi", "audio/midi"],
  ["rmp", "audio/x-pn-realaudio-plugin"],
  ["rms", "application/vnd.jcp.javame.midlet-rms"],
  ["rmvb", "application/vnd.rn-realmedia-vbr"],
  ["rnc", "application/relax-ng-compact-syntax"],
  ["rng", "application/xml"],
  ["roa", "application/rpki-roa"],
  ["roff", "text/troff"],
  ["rp9", "application/vnd.cloanto.rp9"],
  ["rpm", "audio/x-pn-realaudio-plugin"],
  ["rpss", "application/vnd.nokia.radio-presets"],
  ["rpst", "application/vnd.nokia.radio-preset"],
  ["rq", "application/sparql-query"],
  ["rs", "application/rls-services+xml"],
  ["rsa", "application/x-pkcs7"],
  ["rsat", "application/atsc-rsat+xml"],
  ["rsd", "application/rsd+xml"],
  ["rsheet", "application/urc-ressheet+xml"],
  ["rss", "application/rss+xml"],
  ["rtf", "text/rtf"],
  ["rtx", "text/richtext"],
  ["run", "application/x-makeself"],
  ["rusd", "application/route-usd+xml"],
  ["rv", "video/vnd.rn-realvideo"],
  ["s", "text/x-asm"],
  ["s3m", "audio/s3m"],
  ["saf", "application/vnd.yamaha.smaf-audio"],
  ["sass", "text/x-sass"],
  ["sbml", "application/sbml+xml"],
  ["sc", "application/vnd.ibm.secure-container"],
  ["scd", "application/x-msschedule"],
  ["scm", "application/vnd.lotus-screencam"],
  ["scq", "application/scvp-cv-request"],
  ["scs", "application/scvp-cv-response"],
  ["scss", "text/x-scss"],
  ["scurl", "text/vnd.curl.scurl"],
  ["sda", "application/vnd.stardivision.draw"],
  ["sdc", "application/vnd.stardivision.calc"],
  ["sdd", "application/vnd.stardivision.impress"],
  ["sdkd", "application/vnd.solent.sdkm+xml"],
  ["sdkm", "application/vnd.solent.sdkm+xml"],
  ["sdp", "application/sdp"],
  ["sdw", "application/vnd.stardivision.writer"],
  ["sea", "application/octet-stream"],
  ["see", "application/vnd.seemail"],
  ["seed", "application/vnd.fdsn.seed"],
  ["sema", "application/vnd.sema"],
  ["semd", "application/vnd.semd"],
  ["semf", "application/vnd.semf"],
  ["senmlx", "application/senml+xml"],
  ["sensmlx", "application/sensml+xml"],
  ["ser", "application/java-serialized-object"],
  ["setpay", "application/set-payment-initiation"],
  ["setreg", "application/set-registration-initiation"],
  ["sfd-hdstx", "application/vnd.hydrostatix.sof-data"],
  ["sfs", "application/vnd.spotfire.sfs"],
  ["sfv", "text/x-sfv"],
  ["sgi", "image/sgi"],
  ["sgl", "application/vnd.stardivision.writer-global"],
  ["sgm", "text/sgml"],
  ["sgml", "text/sgml"],
  ["sh", "application/x-sh"],
  ["shar", "application/x-shar"],
  ["shex", "text/shex"],
  ["shf", "application/shf+xml"],
  ["shtml", "text/html"],
  ["sid", "image/x-mrsid-image"],
  ["sieve", "application/sieve"],
  ["sig", "application/pgp-signature"],
  ["sil", "audio/silk"],
  ["silo", "model/mesh"],
  ["sis", "application/vnd.symbian.install"],
  ["sisx", "application/vnd.symbian.install"],
  ["sit", "application/x-stuffit"],
  ["sitx", "application/x-stuffitx"],
  ["siv", "application/sieve"],
  ["skd", "application/vnd.koan"],
  ["skm", "application/vnd.koan"],
  ["skp", "application/vnd.koan"],
  ["skt", "application/vnd.koan"],
  ["sldm", "application/vnd.ms-powerpoint.slide.macroenabled.12"],
  ["sldx", "application/vnd.openxmlformats-officedocument.presentationml.slide"],
  ["slim", "text/slim"],
  ["slm", "text/slim"],
  ["sls", "application/route-s-tsid+xml"],
  ["slt", "application/vnd.epson.salt"],
  ["sm", "application/vnd.stepmania.stepchart"],
  ["smf", "application/vnd.stardivision.math"],
  ["smi", "application/smil"],
  ["smil", "application/smil"],
  ["smv", "video/x-smv"],
  ["smzip", "application/vnd.stepmania.package"],
  ["snd", "audio/basic"],
  ["snf", "application/x-font-snf"],
  ["so", "application/octet-stream"],
  ["spc", "application/x-pkcs7-certificates"],
  ["spdx", "text/spdx"],
  ["spf", "application/vnd.yamaha.smaf-phrase"],
  ["spl", "application/x-futuresplash"],
  ["spot", "text/vnd.in3d.spot"],
  ["spp", "application/scvp-vp-response"],
  ["spq", "application/scvp-vp-request"],
  ["spx", "audio/ogg"],
  ["sql", "application/x-sql"],
  ["src", "application/x-wais-source"],
  ["srt", "application/x-subrip"],
  ["sru", "application/sru+xml"],
  ["srx", "application/sparql-results+xml"],
  ["ssdl", "application/ssdl+xml"],
  ["sse", "application/vnd.kodak-descriptor"],
  ["ssf", "application/vnd.epson.ssf"],
  ["ssml", "application/ssml+xml"],
  ["sst", "application/octet-stream"],
  ["st", "application/vnd.sailingtracker.track"],
  ["stc", "application/vnd.sun.xml.calc.template"],
  ["std", "application/vnd.sun.xml.draw.template"],
  ["stf", "application/vnd.wt.stf"],
  ["sti", "application/vnd.sun.xml.impress.template"],
  ["stk", "application/hyperstudio"],
  ["stl", "model/stl"],
  ["stpx", "model/step+xml"],
  ["stpxz", "model/step-xml+zip"],
  ["stpz", "model/step+zip"],
  ["str", "application/vnd.pg.format"],
  ["stw", "application/vnd.sun.xml.writer.template"],
  ["styl", "text/stylus"],
  ["stylus", "text/stylus"],
  ["sub", "text/vnd.dvb.subtitle"],
  ["sus", "application/vnd.sus-calendar"],
  ["susp", "application/vnd.sus-calendar"],
  ["sv4cpio", "application/x-sv4cpio"],
  ["sv4crc", "application/x-sv4crc"],
  ["svc", "application/vnd.dvb.service"],
  ["svd", "application/vnd.svd"],
  ["svg", "image/svg+xml"],
  ["svgz", "image/svg+xml"],
  ["swa", "application/x-director"],
  ["swf", "application/x-shockwave-flash"],
  ["swi", "application/vnd.aristanetworks.swi"],
  ["swidtag", "application/swid+xml"],
  ["sxc", "application/vnd.sun.xml.calc"],
  ["sxd", "application/vnd.sun.xml.draw"],
  ["sxg", "application/vnd.sun.xml.writer.global"],
  ["sxi", "application/vnd.sun.xml.impress"],
  ["sxm", "application/vnd.sun.xml.math"],
  ["sxw", "application/vnd.sun.xml.writer"],
  ["t", "text/troff"],
  ["t3", "application/x-t3vm-image"],
  ["t38", "image/t38"],
  ["taglet", "application/vnd.mynfc"],
  ["tao", "application/vnd.tao.intent-module-archive"],
  ["tap", "image/vnd.tencent.tap"],
  ["tar", "application/x-tar"],
  ["tcap", "application/vnd.3gpp2.tcap"],
  ["tcl", "application/x-tcl"],
  ["td", "application/urc-targetdesc+xml"],
  ["teacher", "application/vnd.smart.teacher"],
  ["tei", "application/tei+xml"],
  ["teicorpus", "application/tei+xml"],
  ["tex", "application/x-tex"],
  ["texi", "application/x-texinfo"],
  ["texinfo", "application/x-texinfo"],
  ["text", "text/plain"],
  ["tfi", "application/thraud+xml"],
  ["tfm", "application/x-tex-tfm"],
  ["tfx", "image/tiff-fx"],
  ["tga", "image/x-tga"],
  ["tgz", "application/x-tar"],
  ["thmx", "application/vnd.ms-officetheme"],
  ["tif", "image/tiff"],
  ["tiff", "image/tiff"],
  ["tk", "application/x-tcl"],
  ["tmo", "application/vnd.tmobile-livetv"],
  ["toml", "application/toml"],
  ["torrent", "application/x-bittorrent"],
  ["tpl", "application/vnd.groove-tool-template"],
  ["tpt", "application/vnd.trid.tpt"],
  ["tr", "text/troff"],
  ["tra", "application/vnd.trueapp"],
  ["trig", "application/trig"],
  ["trm", "application/x-msterminal"],
  ["ts", "video/mp2t"],
  ["tsd", "application/timestamped-data"],
  ["tsv", "text/tab-separated-values"],
  ["ttc", "font/collection"],
  ["ttf", "font/ttf"],
  ["ttl", "text/turtle"],
  ["ttml", "application/ttml+xml"],
  ["twd", "application/vnd.simtech-mindmapper"],
  ["twds", "application/vnd.simtech-mindmapper"],
  ["txd", "application/vnd.genomatix.tuxedo"],
  ["txf", "application/vnd.mobius.txf"],
  ["txt", "text/plain"],
  ["u8dsn", "message/global-delivery-status"],
  ["u8hdr", "message/global-headers"],
  ["u8mdn", "message/global-disposition-notification"],
  ["u8msg", "message/global"],
  ["u32", "application/x-authorware-bin"],
  ["ubj", "application/ubjson"],
  ["udeb", "application/x-debian-package"],
  ["ufd", "application/vnd.ufdl"],
  ["ufdl", "application/vnd.ufdl"],
  ["ulx", "application/x-glulx"],
  ["umj", "application/vnd.umajin"],
  ["unityweb", "application/vnd.unity"],
  ["uoml", "application/vnd.uoml+xml"],
  ["uri", "text/uri-list"],
  ["uris", "text/uri-list"],
  ["urls", "text/uri-list"],
  ["usdz", "model/vnd.usdz+zip"],
  ["ustar", "application/x-ustar"],
  ["utz", "application/vnd.uiq.theme"],
  ["uu", "text/x-uuencode"],
  ["uva", "audio/vnd.dece.audio"],
  ["uvd", "application/vnd.dece.data"],
  ["uvf", "application/vnd.dece.data"],
  ["uvg", "image/vnd.dece.graphic"],
  ["uvh", "video/vnd.dece.hd"],
  ["uvi", "image/vnd.dece.graphic"],
  ["uvm", "video/vnd.dece.mobile"],
  ["uvp", "video/vnd.dece.pd"],
  ["uvs", "video/vnd.dece.sd"],
  ["uvt", "application/vnd.dece.ttml+xml"],
  ["uvu", "video/vnd.uvvu.mp4"],
  ["uvv", "video/vnd.dece.video"],
  ["uvva", "audio/vnd.dece.audio"],
  ["uvvd", "application/vnd.dece.data"],
  ["uvvf", "application/vnd.dece.data"],
  ["uvvg", "image/vnd.dece.graphic"],
  ["uvvh", "video/vnd.dece.hd"],
  ["uvvi", "image/vnd.dece.graphic"],
  ["uvvm", "video/vnd.dece.mobile"],
  ["uvvp", "video/vnd.dece.pd"],
  ["uvvs", "video/vnd.dece.sd"],
  ["uvvt", "application/vnd.dece.ttml+xml"],
  ["uvvu", "video/vnd.uvvu.mp4"],
  ["uvvv", "video/vnd.dece.video"],
  ["uvvx", "application/vnd.dece.unspecified"],
  ["uvvz", "application/vnd.dece.zip"],
  ["uvx", "application/vnd.dece.unspecified"],
  ["uvz", "application/vnd.dece.zip"],
  ["vbox", "application/x-virtualbox-vbox"],
  ["vbox-extpack", "application/x-virtualbox-vbox-extpack"],
  ["vcard", "text/vcard"],
  ["vcd", "application/x-cdlink"],
  ["vcf", "text/x-vcard"],
  ["vcg", "application/vnd.groove-vcard"],
  ["vcs", "text/x-vcalendar"],
  ["vcx", "application/vnd.vcx"],
  ["vdi", "application/x-virtualbox-vdi"],
  ["vds", "model/vnd.sap.vds"],
  ["vhd", "application/x-virtualbox-vhd"],
  ["vis", "application/vnd.visionary"],
  ["viv", "video/vnd.vivo"],
  ["vlc", "application/videolan"],
  ["vmdk", "application/x-virtualbox-vmdk"],
  ["vob", "video/x-ms-vob"],
  ["vor", "application/vnd.stardivision.writer"],
  ["vox", "application/x-authorware-bin"],
  ["vrml", "model/vrml"],
  ["vsd", "application/vnd.visio"],
  ["vsf", "application/vnd.vsf"],
  ["vss", "application/vnd.visio"],
  ["vst", "application/vnd.visio"],
  ["vsw", "application/vnd.visio"],
  ["vtf", "image/vnd.valve.source.texture"],
  ["vtt", "text/vtt"],
  ["vtu", "model/vnd.vtu"],
  ["vxml", "application/voicexml+xml"],
  ["w3d", "application/x-director"],
  ["wad", "application/x-doom"],
  ["wadl", "application/vnd.sun.wadl+xml"],
  ["war", "application/java-archive"],
  ["wasm", "application/wasm"],
  ["wav", "audio/x-wav"],
  ["wax", "audio/x-ms-wax"],
  ["wbmp", "image/vnd.wap.wbmp"],
  ["wbs", "application/vnd.criticaltools.wbs+xml"],
  ["wbxml", "application/wbxml"],
  ["wcm", "application/vnd.ms-works"],
  ["wdb", "application/vnd.ms-works"],
  ["wdp", "image/vnd.ms-photo"],
  ["weba", "audio/webm"],
  ["webapp", "application/x-web-app-manifest+json"],
  ["webm", "video/webm"],
  ["webmanifest", "application/manifest+json"],
  ["webp", "image/webp"],
  ["wg", "application/vnd.pmi.widget"],
  ["wgt", "application/widget"],
  ["wks", "application/vnd.ms-works"],
  ["wm", "video/x-ms-wm"],
  ["wma", "audio/x-ms-wma"],
  ["wmd", "application/x-ms-wmd"],
  ["wmf", "image/wmf"],
  ["wml", "text/vnd.wap.wml"],
  ["wmlc", "application/wmlc"],
  ["wmls", "text/vnd.wap.wmlscript"],
  ["wmlsc", "application/vnd.wap.wmlscriptc"],
  ["wmv", "video/x-ms-wmv"],
  ["wmx", "video/x-ms-wmx"],
  ["wmz", "application/x-msmetafile"],
  ["woff", "font/woff"],
  ["woff2", "font/woff2"],
  ["word", "application/msword"],
  ["wpd", "application/vnd.wordperfect"],
  ["wpl", "application/vnd.ms-wpl"],
  ["wps", "application/vnd.ms-works"],
  ["wqd", "application/vnd.wqd"],
  ["wri", "application/x-mswrite"],
  ["wrl", "model/vrml"],
  ["wsc", "message/vnd.wfa.wsc"],
  ["wsdl", "application/wsdl+xml"],
  ["wspolicy", "application/wspolicy+xml"],
  ["wtb", "application/vnd.webturbo"],
  ["wvx", "video/x-ms-wvx"],
  ["x3d", "model/x3d+xml"],
  ["x3db", "model/x3d+fastinfoset"],
  ["x3dbz", "model/x3d+binary"],
  ["x3dv", "model/x3d-vrml"],
  ["x3dvz", "model/x3d+vrml"],
  ["x3dz", "model/x3d+xml"],
  ["x32", "application/x-authorware-bin"],
  ["x_b", "model/vnd.parasolid.transmit.binary"],
  ["x_t", "model/vnd.parasolid.transmit.text"],
  ["xaml", "application/xaml+xml"],
  ["xap", "application/x-silverlight-app"],
  ["xar", "application/vnd.xara"],
  ["xav", "application/xcap-att+xml"],
  ["xbap", "application/x-ms-xbap"],
  ["xbd", "application/vnd.fujixerox.docuworks.binder"],
  ["xbm", "image/x-xbitmap"],
  ["xca", "application/xcap-caps+xml"],
  ["xcs", "application/calendar+xml"],
  ["xdf", "application/xcap-diff+xml"],
  ["xdm", "application/vnd.syncml.dm+xml"],
  ["xdp", "application/vnd.adobe.xdp+xml"],
  ["xdssc", "application/dssc+xml"],
  ["xdw", "application/vnd.fujixerox.docuworks"],
  ["xel", "application/xcap-el+xml"],
  ["xenc", "application/xenc+xml"],
  ["xer", "application/patch-ops-error+xml"],
  ["xfdf", "application/vnd.adobe.xfdf"],
  ["xfdl", "application/vnd.xfdl"],
  ["xht", "application/xhtml+xml"],
  ["xhtml", "application/xhtml+xml"],
  ["xhvml", "application/xv+xml"],
  ["xif", "image/vnd.xiff"],
  ["xl", "application/excel"],
  ["xla", "application/vnd.ms-excel"],
  ["xlam", "application/vnd.ms-excel.addin.macroEnabled.12"],
  ["xlc", "application/vnd.ms-excel"],
  ["xlf", "application/xliff+xml"],
  ["xlm", "application/vnd.ms-excel"],
  ["xls", "application/vnd.ms-excel"],
  ["xlsb", "application/vnd.ms-excel.sheet.binary.macroEnabled.12"],
  ["xlsm", "application/vnd.ms-excel.sheet.macroEnabled.12"],
  ["xlsx", "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"],
  ["xlt", "application/vnd.ms-excel"],
  ["xltm", "application/vnd.ms-excel.template.macroEnabled.12"],
  ["xltx", "application/vnd.openxmlformats-officedocument.spreadsheetml.template"],
  ["xlw", "application/vnd.ms-excel"],
  ["xm", "audio/xm"],
  ["xml", "application/xml"],
  ["xns", "application/xcap-ns+xml"],
  ["xo", "application/vnd.olpc-sugar"],
  ["xop", "application/xop+xml"],
  ["xpi", "application/x-xpinstall"],
  ["xpl", "application/xproc+xml"],
  ["xpm", "image/x-xpixmap"],
  ["xpr", "application/vnd.is-xpr"],
  ["xps", "application/vnd.ms-xpsdocument"],
  ["xpw", "application/vnd.intercon.formnet"],
  ["xpx", "application/vnd.intercon.formnet"],
  ["xsd", "application/xml"],
  ["xsl", "application/xml"],
  ["xslt", "application/xslt+xml"],
  ["xsm", "application/vnd.syncml+xml"],
  ["xspf", "application/xspf+xml"],
  ["xul", "application/vnd.mozilla.xul+xml"],
  ["xvm", "application/xv+xml"],
  ["xvml", "application/xv+xml"],
  ["xwd", "image/x-xwindowdump"],
  ["xyz", "chemical/x-xyz"],
  ["xz", "application/x-xz"],
  ["yaml", "text/yaml"],
  ["yang", "application/yang"],
  ["yin", "application/yin+xml"],
  ["yml", "text/yaml"],
  ["ymp", "text/x-suse-ymp"],
  ["z", "application/x-compress"],
  ["z1", "application/x-zmachine"],
  ["z2", "application/x-zmachine"],
  ["z3", "application/x-zmachine"],
  ["z4", "application/x-zmachine"],
  ["z5", "application/x-zmachine"],
  ["z6", "application/x-zmachine"],
  ["z7", "application/x-zmachine"],
  ["z8", "application/x-zmachine"],
  ["zaz", "application/vnd.zzazz.deck+xml"],
  ["zip", "application/zip"],
  ["zir", "application/vnd.zul"],
  ["zirz", "application/vnd.zul"],
  ["zmm", "application/vnd.handheld-entertainment+xml"],
  ["zsh", "text/x-scriptzsh"]
]);
function vr(t, e, n) {
  const r = II(t), { webkitRelativePath: a } = t, o = typeof e == "string" ? e : typeof a == "string" && a.length > 0 ? a : `./${t.name}`;
  return typeof r.path != "string" && Id(r, "path", o), Id(r, "relativePath", o), r;
}
function II(t) {
  const { name: e } = t;
  if (e && e.lastIndexOf(".") !== -1 && !t.type) {
    const r = e.split(".").pop().toLowerCase(), a = DI.get(r);
    a && Object.defineProperty(t, "type", {
      value: a,
      writable: !1,
      configurable: !1,
      enumerable: !0
    });
  }
  return t;
}
function Id(t, e, n) {
  Object.defineProperty(t, e, {
    value: n,
    writable: !1,
    configurable: !1,
    enumerable: !0
  });
}
const kI = [
  // Thumbnail cache files for macOS and Windows
  ".DS_Store",
  // macOs
  "Thumbs.db"
  // Windows
];
function OI(t) {
  return zn(this, void 0, void 0, function* () {
    return zi(t) && LI(t.dataTransfer) ? jI(t.dataTransfer, t.type) : RI(t) ? HI(t) : Array.isArray(t) && t.every((e) => "getFile" in e && typeof e.getFile == "function") ? BI(t) : [];
  });
}
function LI(t) {
  return zi(t);
}
function RI(t) {
  return zi(t) && zi(t.target);
}
function zi(t) {
  return typeof t == "object" && t !== null;
}
function HI(t) {
  return os(t.target.files).map((e) => vr(e));
}
function BI(t) {
  return zn(this, void 0, void 0, function* () {
    return (yield Promise.all(t.map((n) => n.getFile()))).map((n) => vr(n));
  });
}
function jI(t, e) {
  return zn(this, void 0, void 0, function* () {
    if (t.items) {
      const n = os(t.items).filter((a) => a.kind === "file");
      if (e !== "drop")
        return n;
      const r = yield Promise.all(n.map(VI));
      return kd(Vf(r));
    }
    return kd(os(t.files).map((n) => vr(n)));
  });
}
function kd(t) {
  return t.filter((e) => kI.indexOf(e.name) === -1);
}
function os(t) {
  if (t === null)
    return [];
  const e = [];
  for (let n = 0; n < t.length; n++) {
    const r = t[n];
    e.push(r);
  }
  return e;
}
function VI(t) {
  if (typeof t.webkitGetAsEntry != "function")
    return Od(t);
  const e = t.webkitGetAsEntry();
  return e && e.isDirectory ? Uf(e) : Od(t, e);
}
function Vf(t) {
  return t.reduce((e, n) => [
    ...e,
    ...Array.isArray(n) ? Vf(n) : [n]
  ], []);
}
function Od(t, e) {
  return zn(this, void 0, void 0, function* () {
    var n;
    if (globalThis.isSecureContext && typeof t.getAsFileSystemHandle == "function") {
      const o = yield t.getAsFileSystemHandle();
      if (o === null)
        throw new Error(`${t} is not a File`);
      if (o !== void 0) {
        const l = yield o.getFile();
        return l.handle = o, vr(l);
      }
    }
    const r = t.getAsFile();
    if (!r)
      throw new Error(`${t} is not a File`);
    return vr(r, (n = e?.fullPath) !== null && n !== void 0 ? n : void 0);
  });
}
function UI(t) {
  return zn(this, void 0, void 0, function* () {
    return t.isDirectory ? Uf(t) : WI(t);
  });
}
function Uf(t) {
  const e = t.createReader();
  return new Promise((n, r) => {
    const a = [];
    function o() {
      e.readEntries((l) => zn(this, void 0, void 0, function* () {
        if (l.length) {
          const s = Promise.all(l.map(UI));
          a.push(s), o();
        } else
          try {
            const s = yield Promise.all(a);
            n(s);
          } catch (s) {
            r(s);
          }
      }), (l) => {
        r(l);
      });
    }
    o();
  });
}
function WI(t) {
  return zn(this, void 0, void 0, function* () {
    return new Promise((e, n) => {
      t.file((r) => {
        const a = vr(r, t.fullPath);
        e(a);
      }, (r) => {
        n(r);
      });
    });
  });
}
var Za = {}, Ld;
function GI() {
  return Ld || (Ld = 1, Za.__esModule = !0, Za.default = function(t, e) {
    if (t && e) {
      var n = Array.isArray(e) ? e : e.split(",");
      if (n.length === 0)
        return !0;
      var r = t.name || "", a = (t.type || "").toLowerCase(), o = a.replace(/\/.*$/, "");
      return n.some(function(l) {
        var s = l.trim().toLowerCase();
        return s.charAt(0) === "." ? r.toLowerCase().endsWith(s) : s.endsWith("/*") ? o === s.replace(/\/.*$/, "") : a === s;
      });
    }
    return !0;
  }), Za;
}
var KI = GI();
const il = /* @__PURE__ */ Fs(KI);
function Rd(t) {
  return ZI(t) || YI(t) || Gf(t) || qI();
}
function qI() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function YI(t) {
  if (typeof Symbol < "u" && t[Symbol.iterator] != null || t["@@iterator"] != null) return Array.from(t);
}
function ZI(t) {
  if (Array.isArray(t)) return ls(t);
}
function Hd(t, e) {
  var n = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(t);
    e && (r = r.filter(function(a) {
      return Object.getOwnPropertyDescriptor(t, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function Bd(t) {
  for (var e = 1; e < arguments.length; e++) {
    var n = arguments[e] != null ? arguments[e] : {};
    e % 2 ? Hd(Object(n), !0).forEach(function(r) {
      Wf(t, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : Hd(Object(n)).forEach(function(r) {
      Object.defineProperty(t, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return t;
}
function Wf(t, e, n) {
  return e in t ? Object.defineProperty(t, e, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = n, t;
}
function ba(t, e) {
  return QI(t) || JI(t, e) || Gf(t, e) || XI();
}
function XI() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Gf(t, e) {
  if (t) {
    if (typeof t == "string") return ls(t, e);
    var n = Object.prototype.toString.call(t).slice(8, -1);
    if (n === "Object" && t.constructor && (n = t.constructor.name), n === "Map" || n === "Set") return Array.from(t);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return ls(t, e);
  }
}
function ls(t, e) {
  (e == null || e > t.length) && (e = t.length);
  for (var n = 0, r = new Array(e); n < e; n++)
    r[n] = t[n];
  return r;
}
function JI(t, e) {
  var n = t == null ? null : typeof Symbol < "u" && t[Symbol.iterator] || t["@@iterator"];
  if (n != null) {
    var r = [], a = !0, o = !1, l, s;
    try {
      for (n = n.call(t); !(a = (l = n.next()).done) && (r.push(l.value), !(e && r.length === e)); a = !0)
        ;
    } catch (c) {
      o = !0, s = c;
    } finally {
      try {
        !a && n.return != null && n.return();
      } finally {
        if (o) throw s;
      }
    }
    return r;
  }
}
function QI(t) {
  if (Array.isArray(t)) return t;
}
var ek = typeof il == "function" ? il : il.default, tk = "file-invalid-type", nk = "file-too-large", rk = "file-too-small", ak = "too-many-files", ik = function() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", n = e.split(","), r = n.length > 1 ? "one of ".concat(n.join(", ")) : n[0];
  return {
    code: tk,
    message: "File type must be ".concat(r)
  };
}, jd = function(e) {
  return {
    code: nk,
    message: "File is larger than ".concat(e, " ").concat(e === 1 ? "byte" : "bytes")
  };
}, Vd = function(e) {
  return {
    code: rk,
    message: "File is smaller than ".concat(e, " ").concat(e === 1 ? "byte" : "bytes")
  };
}, ok = {
  code: ak,
  message: "Too many files"
};
function Kf(t, e) {
  var n = t.type === "application/x-moz-file" || ek(t, e);
  return [n, n ? null : ik(e)];
}
function qf(t, e, n) {
  if (vn(t.size))
    if (vn(e) && vn(n)) {
      if (t.size > n) return [!1, jd(n)];
      if (t.size < e) return [!1, Vd(e)];
    } else {
      if (vn(e) && t.size < e) return [!1, Vd(e)];
      if (vn(n) && t.size > n) return [!1, jd(n)];
    }
  return [!0, null];
}
function vn(t) {
  return t != null;
}
function lk(t) {
  var e = t.files, n = t.accept, r = t.minSize, a = t.maxSize, o = t.multiple, l = t.maxFiles, s = t.validator;
  return !o && e.length > 1 || o && l >= 1 && e.length > l ? !1 : e.every(function(c) {
    var d = Kf(c, n), u = ba(d, 1), f = u[0], m = qf(c, r, a), g = ba(m, 1), C = g[0], b = s ? s(c) : null;
    return f && C && !b;
  });
}
function Di(t) {
  return typeof t.isPropagationStopped == "function" ? t.isPropagationStopped() : typeof t.cancelBubble < "u" ? t.cancelBubble : !1;
}
function Xa(t) {
  return t.dataTransfer ? Array.prototype.some.call(t.dataTransfer.types, function(e) {
    return e === "Files" || e === "application/x-moz-file";
  }) : !!t.target && !!t.target.files;
}
function Ud(t) {
  t.preventDefault();
}
function sk(t) {
  return t.indexOf("MSIE") !== -1 || t.indexOf("Trident/") !== -1;
}
function ck(t) {
  return t.indexOf("Edge/") !== -1;
}
function dk() {
  var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : window.navigator.userAgent;
  return sk(t) || ck(t);
}
function gt() {
  for (var t = arguments.length, e = new Array(t), n = 0; n < t; n++)
    e[n] = arguments[n];
  return function(r) {
    for (var a = arguments.length, o = new Array(a > 1 ? a - 1 : 0), l = 1; l < a; l++)
      o[l - 1] = arguments[l];
    return e.some(function(s) {
      return !Di(r) && s && s.apply(void 0, [r].concat(o)), Di(r);
    });
  };
}
function uk() {
  return "showOpenFilePicker" in window;
}
function fk(t) {
  if (vn(t)) {
    var e = Object.entries(t).filter(function(n) {
      var r = ba(n, 2), a = r[0], o = r[1], l = !0;
      return Yf(a) || (console.warn('Skipped "'.concat(a, '" because it is not a valid MIME type. Check https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/MIME_types/Common_types for a list of valid MIME types.')), l = !1), (!Array.isArray(o) || !o.every(Zf)) && (console.warn('Skipped "'.concat(a, '" because an invalid file extension was provided.')), l = !1), l;
    }).reduce(function(n, r) {
      var a = ba(r, 2), o = a[0], l = a[1];
      return Bd(Bd({}, n), {}, Wf({}, o, l));
    }, {});
    return [{
      // description is required due to https://crbug.com/1264708
      description: "Files",
      accept: e
    }];
  }
  return t;
}
function pk(t) {
  if (vn(t))
    return Object.entries(t).reduce(function(e, n) {
      var r = ba(n, 2), a = r[0], o = r[1];
      return [].concat(Rd(e), [a], Rd(o));
    }, []).filter(function(e) {
      return Yf(e) || Zf(e);
    }).join(",");
}
function mk(t) {
  return t instanceof DOMException && (t.name === "AbortError" || t.code === t.ABORT_ERR);
}
function hk(t) {
  return t instanceof DOMException && (t.name === "SecurityError" || t.code === t.SECURITY_ERR);
}
function Yf(t) {
  return t === "audio/*" || t === "video/*" || t === "image/*" || t === "text/*" || t === "application/*" || /\w+\/[-+.\w]+/g.test(t);
}
function Zf(t) {
  return /^.*\.[\w]+$/.test(t);
}
var vk = ["children"], gk = ["open"], yk = ["refKey", "role", "onKeyDown", "onFocus", "onBlur", "onClick", "onDragEnter", "onDragOver", "onDragLeave", "onDrop"], bk = ["refKey", "onChange", "onClick"];
function Ek(t) {
  return xk(t) || $k(t) || Xf(t) || wk();
}
function wk() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function $k(t) {
  if (typeof Symbol < "u" && t[Symbol.iterator] != null || t["@@iterator"] != null) return Array.from(t);
}
function xk(t) {
  if (Array.isArray(t)) return ss(t);
}
function ol(t, e) {
  return Sk(t) || Mk(t, e) || Xf(t, e) || Ck();
}
function Ck() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Xf(t, e) {
  if (t) {
    if (typeof t == "string") return ss(t, e);
    var n = Object.prototype.toString.call(t).slice(8, -1);
    if (n === "Object" && t.constructor && (n = t.constructor.name), n === "Map" || n === "Set") return Array.from(t);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return ss(t, e);
  }
}
function ss(t, e) {
  (e == null || e > t.length) && (e = t.length);
  for (var n = 0, r = new Array(e); n < e; n++)
    r[n] = t[n];
  return r;
}
function Mk(t, e) {
  var n = t == null ? null : typeof Symbol < "u" && t[Symbol.iterator] || t["@@iterator"];
  if (n != null) {
    var r = [], a = !0, o = !1, l, s;
    try {
      for (n = n.call(t); !(a = (l = n.next()).done) && (r.push(l.value), !(e && r.length === e)); a = !0)
        ;
    } catch (c) {
      o = !0, s = c;
    } finally {
      try {
        !a && n.return != null && n.return();
      } finally {
        if (o) throw s;
      }
    }
    return r;
  }
}
function Sk(t) {
  if (Array.isArray(t)) return t;
}
function Wd(t, e) {
  var n = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(t);
    e && (r = r.filter(function(a) {
      return Object.getOwnPropertyDescriptor(t, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function Ie(t) {
  for (var e = 1; e < arguments.length; e++) {
    var n = arguments[e] != null ? arguments[e] : {};
    e % 2 ? Wd(Object(n), !0).forEach(function(r) {
      cs(t, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : Wd(Object(n)).forEach(function(r) {
      Object.defineProperty(t, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return t;
}
function cs(t, e, n) {
  return e in t ? Object.defineProperty(t, e, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = n, t;
}
function Ii(t, e) {
  if (t == null) return {};
  var n = Fk(t, e), r, a;
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(t);
    for (a = 0; a < o.length; a++)
      r = o[a], !(e.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(t, r) && (n[r] = t[r]);
  }
  return n;
}
function Fk(t, e) {
  if (t == null) return {};
  var n = {}, r = Object.keys(t), a, o;
  for (o = 0; o < r.length; o++)
    a = r[o], !(e.indexOf(a) >= 0) && (n[a] = t[a]);
  return n;
}
var Ys = /* @__PURE__ */ _n(function(t, e) {
  var n = t.children, r = Ii(t, vk), a = Qf(r), o = a.open, l = Ii(a, gk);
  return w4(e, function() {
    return {
      open: o
    };
  }, [o]), /* @__PURE__ */ i.createElement($4, null, n(Ie(Ie({}, l), {}, {
    open: o
  })));
});
Ys.displayName = "Dropzone";
var Jf = {
  disabled: !1,
  getFilesFromEvent: OI,
  maxSize: 1 / 0,
  minSize: 0,
  multiple: !0,
  maxFiles: 0,
  preventDropOnDocument: !0,
  noClick: !1,
  noKeyboard: !1,
  noDrag: !1,
  noDragEventsBubbling: !1,
  validator: null,
  useFsAccessApi: !1,
  autoFocus: !1
};
Ys.defaultProps = Jf;
Ys.propTypes = {
  /**
   * Render function that exposes the dropzone state and prop getter fns
   *
   * @param {object} params
   * @param {Function} params.getRootProps Returns the props you should apply to the root drop container you render
   * @param {Function} params.getInputProps Returns the props you should apply to hidden file input you render
   * @param {Function} params.open Open the native file selection dialog
   * @param {boolean} params.isFocused Dropzone area is in focus
   * @param {boolean} params.isFileDialogActive File dialog is opened
   * @param {boolean} params.isDragActive Active drag is in progress
   * @param {boolean} params.isDragAccept Dragged files are accepted
   * @param {boolean} params.isDragReject Some dragged files are rejected
   * @param {File[]} params.acceptedFiles Accepted files
   * @param {FileRejection[]} params.fileRejections Rejected files and why they were rejected
   */
  children: T.func,
  /**
   * Set accepted file types.
   * Checkout https://developer.mozilla.org/en-US/docs/Web/API/window/showOpenFilePicker types option for more information.
   * Keep in mind that mime type determination is not reliable across platforms. CSV files,
   * for example, are reported as text/plain under macOS but as application/vnd.ms-excel under
   * Windows. In some cases there might not be a mime type set at all (https://github.com/react-dropzone/react-dropzone/issues/276).
   */
  accept: T.objectOf(T.arrayOf(T.string)),
  /**
   * Allow drag 'n' drop (or selection from the file dialog) of multiple files
   */
  multiple: T.bool,
  /**
   * If false, allow dropped items to take over the current browser window
   */
  preventDropOnDocument: T.bool,
  /**
   * If true, disables click to open the native file selection dialog
   */
  noClick: T.bool,
  /**
   * If true, disables SPACE/ENTER to open the native file selection dialog.
   * Note that it also stops tracking the focus state.
   */
  noKeyboard: T.bool,
  /**
   * If true, disables drag 'n' drop
   */
  noDrag: T.bool,
  /**
   * If true, stops drag event propagation to parents
   */
  noDragEventsBubbling: T.bool,
  /**
   * Minimum file size (in bytes)
   */
  minSize: T.number,
  /**
   * Maximum file size (in bytes)
   */
  maxSize: T.number,
  /**
   * Maximum accepted number of files
   * The default value is 0 which means there is no limitation to how many files are accepted.
   */
  maxFiles: T.number,
  /**
   * Enable/disable the dropzone
   */
  disabled: T.bool,
  /**
   * Use this to provide a custom file aggregator
   *
   * @param {(DragEvent|Event|Array<FileSystemFileHandle>)} event A drag event or input change event (if files were selected via the file dialog)
   */
  getFilesFromEvent: T.func,
  /**
   * Cb for when closing the file dialog with no selection
   */
  onFileDialogCancel: T.func,
  /**
   * Cb for when opening the file dialog
   */
  onFileDialogOpen: T.func,
  /**
   * Set to true to use the https://developer.mozilla.org/en-US/docs/Web/API/File_System_Access_API
   * to open the file picker instead of using an `<input type="file">` click event.
   */
  useFsAccessApi: T.bool,
  /**
   * Set to true to focus the root element on render
   */
  autoFocus: T.bool,
  /**
   * Cb for when the `dragenter` event occurs.
   *
   * @param {DragEvent} event
   */
  onDragEnter: T.func,
  /**
   * Cb for when the `dragleave` event occurs
   *
   * @param {DragEvent} event
   */
  onDragLeave: T.func,
  /**
   * Cb for when the `dragover` event occurs
   *
   * @param {DragEvent} event
   */
  onDragOver: T.func,
  /**
   * Cb for when the `drop` event occurs.
   * Note that this callback is invoked after the `getFilesFromEvent` callback is done.
   *
   * Files are accepted or rejected based on the `accept`, `multiple`, `minSize` and `maxSize` props.
   * `accept` must be a valid [MIME type](http://www.iana.org/assignments/media-types/media-types.xhtml) according to [input element specification](https://www.w3.org/wiki/HTML/Elements/input/file) or a valid file extension.
   * If `multiple` is set to false and additional files are dropped,
   * all files besides the first will be rejected.
   * Any file which does not have a size in the [`minSize`, `maxSize`] range, will be rejected as well.
   *
   * Note that the `onDrop` callback will always be invoked regardless if the dropped files were accepted or rejected.
   * If you'd like to react to a specific scenario, use the `onDropAccepted`/`onDropRejected` props.
   *
   * `onDrop` will provide you with an array of [File](https://developer.mozilla.org/en-US/docs/Web/API/File) objects which you can then process and send to a server.
   * For example, with [SuperAgent](https://github.com/visionmedia/superagent) as a http/ajax library:
   *
   * ```js
   * function onDrop(acceptedFiles) {
   *   const req = request.post('/upload')
   *   acceptedFiles.forEach(file => {
   *     req.attach(file.name, file)
   *   })
   *   req.end(callback)
   * }
   * ```
   *
   * @param {File[]} acceptedFiles
   * @param {FileRejection[]} fileRejections
   * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
   */
  onDrop: T.func,
  /**
   * Cb for when the `drop` event occurs.
   * Note that if no files are accepted, this callback is not invoked.
   *
   * @param {File[]} files
   * @param {(DragEvent|Event)} event
   */
  onDropAccepted: T.func,
  /**
   * Cb for when the `drop` event occurs.
   * Note that if no files are rejected, this callback is not invoked.
   *
   * @param {FileRejection[]} fileRejections
   * @param {(DragEvent|Event)} event
   */
  onDropRejected: T.func,
  /**
   * Cb for when there's some error from any of the promises.
   *
   * @param {Error} error
   */
  onError: T.func,
  /**
   * Custom validation function. It must return null if there's no errors.
   * @param {File} file
   * @returns {FileError|FileError[]|null}
   */
  validator: T.func
};
var ds = {
  isFocused: !1,
  isFileDialogActive: !1,
  isDragActive: !1,
  isDragAccept: !1,
  isDragReject: !1,
  acceptedFiles: [],
  fileRejections: []
};
function Qf() {
  var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, e = Ie(Ie({}, Jf), t), n = e.accept, r = e.disabled, a = e.getFilesFromEvent, o = e.maxSize, l = e.minSize, s = e.multiple, c = e.maxFiles, d = e.onDragEnter, u = e.onDragLeave, f = e.onDragOver, m = e.onDrop, g = e.onDropAccepted, C = e.onDropRejected, b = e.onFileDialogCancel, E = e.onFileDialogOpen, x = e.useFsAccessApi, _ = e.autoFocus, N = e.preventDropOnDocument, k = e.noClick, F = e.noKeyboard, A = e.noDrag, O = e.noDragEventsBubbling, te = e.onError, le = e.validator, W = Fe(function() {
    return pk(n);
  }, [n]), y = Fe(function() {
    return fk(n);
  }, [n]), Y = Fe(function() {
    return typeof E == "function" ? E : Gd;
  }, [E]), ee = Fe(function() {
    return typeof b == "function" ? b : Gd;
  }, [b]), I = $e(null), Q = $e(null), M = E4(Pk, ds), X = ol(M, 2), se = X[0], he = X[1], L = se.isFocused, K = se.isFileDialogActive, P = $e(typeof window < "u" && window.isSecureContext && x && uk()), D = function() {
    !P.current && K && setTimeout(function() {
      if (Q.current) {
        var re = Q.current.files;
        re.length || (he({
          type: "closeDialog"
        }), ee());
      }
    }, 300);
  };
  xe(function() {
    return window.addEventListener("focus", D, !1), function() {
      window.removeEventListener("focus", D, !1);
    };
  }, [Q, K, ee, P]);
  var B = $e([]), H = function(re) {
    I.current && I.current.contains(re.target) || (re.preventDefault(), B.current = []);
  };
  xe(function() {
    return N && (document.addEventListener("dragover", Ud, !1), document.addEventListener("drop", H, !1)), function() {
      N && (document.removeEventListener("dragover", Ud), document.removeEventListener("drop", H));
    };
  }, [I, N]), xe(function() {
    return !r && _ && I.current && I.current.focus(), function() {
    };
  }, [I, _, r]);
  var j = de(function(G) {
    te ? te(G) : console.error(G);
  }, [te]), Z = de(function(G) {
    G.preventDefault(), G.persist(), un(G), B.current = [].concat(Ek(B.current), [G.target]), Xa(G) && Promise.resolve(a(G)).then(function(re) {
      if (!(Di(G) && !O)) {
        var ze = re.length, _e = ze > 0 && lk({
          files: re,
          accept: W,
          minSize: l,
          maxSize: o,
          multiple: s,
          maxFiles: c,
          validator: le
        }), Ge = ze > 0 && !_e;
        he({
          isDragAccept: _e,
          isDragReject: Ge,
          isDragActive: !0,
          type: "setDraggedFiles"
        }), d && d(G);
      }
    }).catch(function(re) {
      return j(re);
    });
  }, [a, d, j, O, W, l, o, s, c, le]), ne = de(function(G) {
    G.preventDefault(), G.persist(), un(G);
    var re = Xa(G);
    if (re && G.dataTransfer)
      try {
        G.dataTransfer.dropEffect = "copy";
      } catch {
      }
    return re && f && f(G), !1;
  }, [f, O]), ie = de(function(G) {
    G.preventDefault(), G.persist(), un(G);
    var re = B.current.filter(function(_e) {
      return I.current && I.current.contains(_e);
    }), ze = re.indexOf(G.target);
    ze !== -1 && re.splice(ze, 1), B.current = re, !(re.length > 0) && (he({
      type: "setDraggedFiles",
      isDragActive: !1,
      isDragAccept: !1,
      isDragReject: !1
    }), Xa(G) && u && u(G));
  }, [I, u, O]), ce = de(function(G, re) {
    var ze = [], _e = [];
    G.forEach(function(Ge) {
      var Kt = Kf(Ge, W), qt = ol(Kt, 2), wr = qt[0], je = qt[1], fn = qf(Ge, l, o), _a = ol(fn, 2), so = _a[0], co = _a[1], uo = le ? le(Ge) : null;
      if (wr && so && !uo)
        ze.push(Ge);
      else {
        var fo = [je, co];
        uo && (fo = fo.concat(uo)), _e.push({
          file: Ge,
          errors: fo.filter(function(e4) {
            return e4;
          })
        });
      }
    }), (!s && ze.length > 1 || s && c >= 1 && ze.length > c) && (ze.forEach(function(Ge) {
      _e.push({
        file: Ge,
        errors: [ok]
      });
    }), ze.splice(0)), he({
      acceptedFiles: ze,
      fileRejections: _e,
      isDragReject: _e.length > 0,
      type: "setFiles"
    }), m && m(ze, _e, re), _e.length > 0 && C && C(_e, re), ze.length > 0 && g && g(ze, re);
  }, [he, s, W, l, o, c, m, g, C, le]), Oe = de(function(G) {
    G.preventDefault(), G.persist(), un(G), B.current = [], Xa(G) && Promise.resolve(a(G)).then(function(re) {
      Di(G) && !O || ce(re, G);
    }).catch(function(re) {
      return j(re);
    }), he({
      type: "reset"
    });
  }, [a, ce, j, O]), V = de(function() {
    if (P.current) {
      he({
        type: "openDialog"
      }), Y();
      var G = {
        multiple: s,
        types: y
      };
      window.showOpenFilePicker(G).then(function(re) {
        return a(re);
      }).then(function(re) {
        ce(re, null), he({
          type: "closeDialog"
        });
      }).catch(function(re) {
        mk(re) ? (ee(re), he({
          type: "closeDialog"
        })) : hk(re) ? (P.current = !1, Q.current ? (Q.current.value = null, Q.current.click()) : j(new Error("Cannot open the file picker because the https://developer.mozilla.org/en-US/docs/Web/API/File_System_Access_API is not supported and no <input> was provided."))) : j(re);
      });
      return;
    }
    Q.current && (he({
      type: "openDialog"
    }), Y(), Q.current.value = null, Q.current.click());
  }, [he, Y, ee, x, ce, j, y, s]), Be = de(function(G) {
    !I.current || !I.current.isEqualNode(G.target) || (G.key === " " || G.key === "Enter" || G.keyCode === 32 || G.keyCode === 13) && (G.preventDefault(), V());
  }, [I, V]), Pt = de(function() {
    he({
      type: "focus"
    });
  }, []), dn = de(function() {
    he({
      type: "blur"
    });
  }, []), br = de(function() {
    k || (dk() ? setTimeout(V, 0) : V());
  }, [k, V]), Nt = function(re) {
    return r ? null : re;
  }, Er = function(re) {
    return F ? null : Nt(re);
  }, In = function(re) {
    return A ? null : Nt(re);
  }, un = function(re) {
    O && re.stopPropagation();
  }, io = Fe(function() {
    return function() {
      var G = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, re = G.refKey, ze = re === void 0 ? "ref" : re, _e = G.role, Ge = G.onKeyDown, Kt = G.onFocus, qt = G.onBlur, wr = G.onClick, je = G.onDragEnter, fn = G.onDragOver, _a = G.onDragLeave, so = G.onDrop, co = Ii(G, yk);
      return Ie(Ie(cs({
        onKeyDown: Er(gt(Ge, Be)),
        onFocus: Er(gt(Kt, Pt)),
        onBlur: Er(gt(qt, dn)),
        onClick: Nt(gt(wr, br)),
        onDragEnter: In(gt(je, Z)),
        onDragOver: In(gt(fn, ne)),
        onDragLeave: In(gt(_a, ie)),
        onDrop: In(gt(so, Oe)),
        role: typeof _e == "string" && _e !== "" ? _e : "presentation"
      }, ze, I), !r && !F ? {
        tabIndex: 0
      } : {}), co);
    };
  }, [I, Be, Pt, dn, br, Z, ne, ie, Oe, F, A, r]), oo = de(function(G) {
    G.stopPropagation();
  }, []), lo = Fe(function() {
    return function() {
      var G = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, re = G.refKey, ze = re === void 0 ? "ref" : re, _e = G.onChange, Ge = G.onClick, Kt = Ii(G, bk), qt = cs({
        accept: W,
        multiple: s,
        type: "file",
        style: {
          border: 0,
          clip: "rect(0, 0, 0, 0)",
          clipPath: "inset(50%)",
          height: "1px",
          margin: "0 -1px -1px 0",
          overflow: "hidden",
          padding: 0,
          position: "absolute",
          width: "1px",
          whiteSpace: "nowrap"
        },
        onChange: Nt(gt(_e, Oe)),
        onClick: Nt(gt(Ge, oo)),
        tabIndex: -1
      }, ze, Q);
      return Ie(Ie({}, qt), Kt);
    };
  }, [Q, n, s, Oe, r]);
  return Ie(Ie({}, se), {}, {
    isFocused: L && !r,
    getRootProps: io,
    getInputProps: lo,
    rootRef: I,
    inputRef: Q,
    open: Nt(V)
  });
}
function Pk(t, e) {
  switch (e.type) {
    case "focus":
      return Ie(Ie({}, t), {}, {
        isFocused: !0
      });
    case "blur":
      return Ie(Ie({}, t), {}, {
        isFocused: !1
      });
    case "openDialog":
      return Ie(Ie({}, ds), {}, {
        isFileDialogActive: !0
      });
    case "closeDialog":
      return Ie(Ie({}, t), {}, {
        isFileDialogActive: !1
      });
    case "setDraggedFiles":
      return Ie(Ie({}, t), {}, {
        isDragActive: e.isDragActive,
        isDragAccept: e.isDragAccept,
        isDragReject: e.isDragReject
      });
    case "setFiles":
      return Ie(Ie({}, t), {}, {
        acceptedFiles: e.acceptedFiles,
        fileRejections: e.fileRejections,
        isDragReject: e.isDragReject
      });
    case "reset":
      return Ie({}, ds);
    default:
      return t;
  }
}
function Gd() {
}
function Nk(t, e, n) {
  return {
    "file-invalid-type": n("shared.fileErrors.invalidType"),
    "file-too-large": n("shared.fileErrors.tooLarge"),
    "file-too-small": n("shared.fileErrors.tooSmall"),
    "too-many-files": n("shared.fileErrors.tooMany")
  }[t] || e;
}
function GO({
  label: t,
  name: e,
  value: n,
  onChange: r,
  accept: a = {
    "application/pdf": [".pdf"],
    "image/jpeg": [".jpg", ".jpeg"],
    "image/png": [".png"]
  },
  maxSizeBytes: o = 10 * 1024 * 1024,
  helperText: l = "PDF, JPG / JPEG, PNG",
  suffix: s,
  canDelete: c = !0,
  required: d = !1
}) {
  const { t: u } = Ae(), [f, m] = ve([]), g = n ?? null, C = de(
    (N, k) => {
      if (m(k), N && N.length > 0) {
        const F = N[0];
        r?.(F);
      }
    },
    [r]
  ), { getRootProps: b, getInputProps: E, isDragActive: x } = Qf({
    onDrop: C,
    accept: a,
    multiple: !1,
    maxSize: o
  }), _ = () => {
    m([]), r?.(null);
  };
  return /* @__PURE__ */ p("div", { className: "space-y-3", children: /* @__PURE__ */ S("div", { className: "space-y-2", children: [
    t && /* @__PURE__ */ S(wa, { className: "text-sm font-medium", children: [
      t,
      d ? /* @__PURE__ */ p(y4, { delayDuration: 0, children: /* @__PURE__ */ S(Kd, { children: [
        /* @__PURE__ */ p(qd, { asChild: !0, children: /* @__PURE__ */ p(
          "span",
          {
            tabIndex: 0,
            className: "inline-flex cursor-help",
            "aria-label": u("shared.common.mandatory"),
            children: /* @__PURE__ */ p(kr, { size: 16 })
          }
        ) }),
        /* @__PURE__ */ p(Yd, { children: u("shared.common.mandatory") })
      ] }) }) : /* @__PURE__ */ p(kr, { size: 16 })
    ] }),
    /* @__PURE__ */ p("div", { className: "relative", children: /* @__PURE__ */ S(
      "div",
      {
        ...b(),
        className: fe(
          "border-input flex h-12 w-full cursor-pointer items-center justify-between rounded-md border border-dashed px-3 py-2 text-sm transition-colors",
          "hover:bg-accent hover:text-accent-foreground",
          x && "border-primary bg-primary/5",
          f.length > 0 && "border-destructive",
          g && "border-none bg-gray-50"
        ),
        children: [
          /* @__PURE__ */ p("input", { ...E(), name: e }),
          g ? /* @__PURE__ */ S("div", { className: "flex w-full items-center gap-2", children: [
            /* @__PURE__ */ p(uu, { size: 16 }),
            /* @__PURE__ */ p("span", { className: "truncate text-right", children: g.name }),
            c && /* @__PURE__ */ p(
              mt,
              {
                type: "button",
                variant: "ghost",
                size: "sm",
                onClick: (N) => {
                  N.stopPropagation(), _();
                },
                className: "text-destructive hover:text-destructive/90 mr-auto h-6 shrink-0 cursor-pointer px-2",
                children: /* @__PURE__ */ p(mu, { size: 14 })
              }
            ),
            s
          ] }) : /* @__PURE__ */ S("div", { className: "flex items-center gap-2", children: [
            /* @__PURE__ */ p(ap, { className: "size-4 shrink-0" }),
            /* @__PURE__ */ S("span", { className: "text-right", children: [
              l,
              " - ",
              u("shared.common.dragFile")
            ] })
          ] })
        ]
      }
    ) }),
    f.length > 0 && /* @__PURE__ */ p("div", { className: "text-destructive text-xs", children: f.map((N, k) => /* @__PURE__ */ p("div", { children: N.errors.map((F) => Nk(F.code, F.message, u)).join(", ") }, `${N.file.name}-${k}`)) })
  ] }) });
}
const _k = 10 * 1024 * 1024, KO = U2(File).nullable().refine((t) => t instanceof File, {
  message: "هذا الحقل مطلوب. يرجى إرفاق المستند المطلوب"
}).refine((t) => !t || t.size <= _k, {
  message: "يجب أن يكون حجم كل ملف 10 ميغابايت أو أقل."
});
async function Tk(t, e) {
  const n = await fetch(t.signedUrl, {
    method: "PUT",
    headers: t.requiredHeaders,
    body: e
  });
  if (!n.ok) throw new Error("Failed to upload file");
  return n;
}
async function qO(t) {
  const e = await $n.request("POST /signed-url", {
    name: t.name,
    type: t.type,
    size: t.size
  });
  return await Tk(e, t), e.fileId;
}
export {
  RO as AcceptTermsDialog,
  Uk as AwaitingSignatureBanner,
  ps as BACKEND_BASE_URL,
  po as BooleanLabel,
  vO as CalendarIcon,
  gO as ClockHistoryIcon,
  Wk as ConfirmDialog,
  Gk as ContractPageSkeleton,
  jp as CounterField,
  Xk as DownloadGeneratedFile,
  Qk as DownloadStoredFile,
  eO as EmailInput,
  tO as EmptySection,
  rO as EquipmentListField,
  aO as ExpandableCheckbox,
  iO as FieldMessage,
  oO as FormMessage,
  hO as HomeCard,
  yO as IncompleteProfileBanner,
  L5 as InlineStep,
  bO as InlineSteps,
  EO as Loading,
  B5 as LocationLink,
  xO as MultiSelect,
  MO as OfferActionBanner,
  vE as OfferStatusIndicator,
  SO as PageContainer,
  yE as PasswordInput,
  FO as PendingDocumentsBanner,
  PO as PendingVerificationBanner,
  YT as PhoneInput,
  TO as PriceField,
  NO as RejectedAccountBanner,
  AO as RequestBadge,
  kO as ReviewRequestDetails,
  OO as ReviewRequestDetailsSkeleton,
  gD as ScheduleHourRange,
  LO as SearchInput,
  yD as ServiceBadge,
  HO as SignatureStatusCard,
  BO as SigningEmailNotice,
  jO as SuccessIcon,
  VO as TableRowSort,
  Ri as TheButton,
  UO as ThemeProvider,
  GO as UploadField,
  Zk as ViewGeneratedFile,
  Jk as ViewStoredFile,
  lO as apiErrorToMessage,
  $n as client,
  CO as createMutationErrorHandler,
  Vp as downloadGeneratedFile,
  Wp as errorToFormIssue,
  KO as fileField,
  sO as firebaseApp,
  nl as formatDate,
  DO as formatDateTime,
  O5 as formatPaymentSchedule,
  zO as formatTime,
  _O as getCurrentCountry,
  gE as getDocumentPhase,
  cO as getSubject,
  I5 as logout,
  pO as notifyPasswordChanged,
  fO as resetPasswordViaEmail,
  jk as sharedAr,
  Vk as sharedEn,
  uO as signInEmail,
  mO as signUpEmail,
  nO as sumEquipmentQuantities,
  IO as toAge,
  qO as uploadFile,
  qk as useAction,
  Yk as useActionState,
  Kk as useData,
  dO as useSubject,
  WO as useTheme,
  Up as viewGeneratedFile
};
//# sourceMappingURL=index.js.map
